module.exports = function loadVueComponents() {
            window["VueComponents"] = window["VueComponents"] || {};
window["VueComponents"]["PackageHelper"] = Vue.component(
                    "PackageHelper",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bazaar = _interopRequireDefault(require("../bazaar"));
var _ui = _interopRequireDefault(require("../ui"));
var _utils = _interopRequireDefault(require("../utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = {
  data() {
    return {
      processingManifest: false,
      installWorld: null,
      installWorldVisible: false,
      installWorldResolve: null,
      showManifestInstall: false,
      manifestImportStatus: "",
      customPackages: []
    };
  },
  computed: {
    allPackages() {
      const allPackages = [...this.packages];
      for (const customPackage of this.customPackages) {
        const duplicateIndex = allPackages.findIndex(bazaarPackage => bazaarPackage.name === customPackage.name && bazaarPackage.type === customPackage.type);
        if (duplicateIndex !== -1) {
          const bazaarDuplicate = allPackages[duplicateIndex];
          if (bazaarDuplicate.premium) {
            allPackages[duplicateIndex] = {
              ...bazaarDuplicate,
              // Use the custom manifest URL to upgrade
              manifest: _bazaar.default.getPackageManifestUrl(customPackage.manifest, false),
              versions: [...new Set(...bazaarDuplicate.versions, customPackage.installed)],
              installed: customPackage.installed,
              secret: customPackage.secret,
              locked: customPackage.locked,
              custom: false
            };
          } else {
            // Replace the Bazaar package with the installed custom package
            allPackages[duplicateIndex] = customPackage;
          }
        } else {
          allPackages.push(customPackage);
        }
      }
      return allPackages;
    }
  },
  methods: {
    /* =======================================================================
     *  PACKAGE INSTALLATION
     * ======================================================================= */

    /**
     * Installs a package from the Bazaar or a custom manifest
     * @param {object} pkg - The package object to install
     * @param {boolean} [autoIdle] - Whether to automatically idle games after
     * installation. Note that this is generally used when installing standard,
     * non-asset packages (modules, systems, etc).
     * @returns {Promise<boolean>} - Whether the installation was successful
     */
    async installPackage(pkg, autoIdle = true) {
      pkg.processing = true;
      try {
        if (pkg.custom) {
          return await this.installCustomPackage(pkg);
        }
        if (["module", "system", "asset"].includes(pkg.type)) {
          return await this.installStandardPackage(pkg, autoIdle);
        }
        if (pkg.type === "world") {
          return await this.installWorldPackage(pkg);
        }
      } catch (error) {
        console.error(error);
      } finally {
        pkg.processing = false;
      }
    },
    /**
     * Installs a custom package using the provided package information.
     * Displays a toast notification during the installation process.
     * @param {object} pkg - The package information.
     * @param {string} pkg.name - The name of the package.
     * @param {string} pkg.title - The title of the package.
     * @param {string} pkg.type - The type of the package.
     * @param {string} pkg.manifest - The manifest URL of the package.
     * @returns {Promise<boolean>} - Returns true if the manifest is successfully installed, otherwise false.
     */
    async installCustomPackage(pkg) {
      const manifest = await this.executeWithToast(pkg.name, pkg.title, `${t("Installing custom package")}...`, () => this.installPackageFromManifest(pkg.type, pkg.name, pkg.manifest), {
        isCustom: true
      });
      return !!manifest;
    },
    /**
     * Installs a standard package and handles its dependencies.
     * @param {object} pkg - The package to be installed.
     * @param {string} pkg.name - The name of the package.
     * @param {string} pkg.title - The title of the package.
     * @param {string} pkg.type - The type of the package (e.g., module, system, asset).
     * @param {string} [pkg.versionToInstall] - The specific version of the package to install.
     * @param {boolean} [pkg.installed] - Indicates if the package is already installed.
     * @param {boolean} autoIdle - Whether to idle the games automatically after installation.
     * @returns {Promise<boolean>} - Returns true if the installation was successful, otherwise false.
     * @throws {Error} - Throws an error if the installation or update fails.
     */
    async installStandardPackage(pkg, autoIdle) {
      const result = await this.executeWithToast(pkg.name, pkg.title, `${t("Installing")}...`, async () => {
        const data = {
          name: pkg.name
        };
        if (pkg.versionToInstall) {
          data.version = pkg.versionToInstall;
        }
        const response = await _utils.default.apiTask(`data/${pkg.type}s/install`, data);
        if (response.error) {
          const verb = pkg.installed ? t("update") : t("install");
          const errorMessage = t("Failed to {{verb}} {{- type}} {{- name}}: {{- error}}", {
            verb,
            type: pkg.type,
            name: `<strong>${pkg.name}</strong>`,
            error: response.error
          });
          throw new Error(errorMessage);
        }
        pkg.installed = String(response.version);
        pkg.versionToInstall = pkg.installed;
        pkg.secret = response.secret;
        const deps = this.readDependencies(response);
        if (deps.length > 0) {
          await this.installPackageDependencies(deps);
        }

        // Installing an asset pack does not require idling the game
        if (autoIdle && pkg.type !== "asset") {
          await this.idleGames();
        }
        return response;
      }, {
        successMessage: t("Installation successful!")
      });
      return !!result;
    },
    /**
     * Installs a world package and its dependencies.
     * The function performs the following steps:
     * 1. Sets up a promise to handle the installation process.
     * 2. If the response contains a system, it checks if the system is installed.
     * 3. If the system is not installed, it installs the system and shows an alert.
     * 4. Reads and installs any dependencies of the package.
     * @param {object} pkg - The package to be installed.
     * @returns {Promise<boolean>} - A promise that resolves to true if the package was installed successfully, otherwise false.
     */
    async installWorldPackage(pkg) {
      const response = await new Promise(resolve => {
        this.installWorld = pkg;
        this.installWorldResolve = resolve;
        this.installWorldVisible = true;
      });
      this.installWorldResolve = null;
      if (response && response.system) {
        const system = this.allPackages.find(p => p.type === "system" && p.name === response.system);
        if (system && !system.installed) {
          await this.installPackage(system);
          _ui.default.alert("info", t(`Installed required Game System: {{title}}`, {
            title: system.title
          }));
        }
        const deps = this.readDependencies(response);
        if (deps.length > 0) {
          await this.installPackageDependencies(deps);
        }
      }
      return !!response;
    },
    /**
     * Installs a package from a custom manifest URL
     * @param {object} options - Installation options
     * @param {string} [options.type] - The type of package to install (module, system, asset, world)
     * @param {string} options.manifest - The URL to the package manifest
     * @returns {Promise<void>}
     */
    async installCustomManifest({
      type = "module",
      manifest
    } = {}) {
      this.manifestImportStatus = "";
      this.processingManifest = true;
      const installed = await this.installPackageFromManifest(type, null, manifest);
      if (installed && type === "module") {
        await this.idleGames();
      }
      this.processingManifest = false;
      if (!installed) {
        this.showManifestInstall = false;
      }
    },
    /**
     * Core method to install a package from a manifest URL
     * @param {string} type - The package type (module, system, asset, world)
     * @param {string|null} name - The package name, or null if unknown
     * @param {string} manifest - The URL to the package manifest
     * @returns {Promise<object | null>} - The installed manifest data or null if installation failed
     */
    async installPackageFromManifest(type, name, manifest) {
      this.manifestImportStatus = t("Verifying manifest");
      const response = await _utils.default.apiTask("package/install", {
        type: type || "module",
        name,
        manifest
      }, null, {
        status: (status, _response) => {
          this.manifestImportStatus = this.getManifestImportStatus(status);
        }
      });
      if (response.error) {
        const errorMessage = response.error.replace("Terms of Service", `<a href='/tos'>${t("Terms of Service")}</a>`);
        _ui.default.alert("danger", `${t("Failed to install {{type}}:", {
          type
        })} ${errorMessage}`);
        return null;
      }

      // Success
      await this.handleManifestSuccess(type, name, response.manifest);
      return response.manifest || null;
    },
    /**
     * Returns a user-friendly message based on the provided status of the package import process.
     * @param {string} status - The current status of the package import process. Possible values are:
     *   - "download": When the package is being downloaded.
     *   - "start-foundry": When the Foundry instance is starting.
     *   - "install": When the protected package is being installed.
     *   - "unpack": When the archive is being unpacked.
     *   - "optimize": When the package is being optimized.
     *   - "restore-foundry": When the Foundry instance is stopping.
     *   - Any other value will default to "Installing package".
     * @returns {string} A user-friendly message corresponding to the provided status.
     */
    getManifestImportStatus(status) {
      switch (status) {
        case "download":
          return t("Downloading the package");
        case "start-foundry":
          return t("Starting Foundry instance");
        case "install":
          return t("Installing the protected package");
        case "unpack":
          return t("Unpacking the archive");
        case "optimize":
          return t("Optimizing the package");
        case "restore-foundry":
          return t("Stopping Foundry instance");
        default:
          return t("Installing package");
      }
    },
    /**
     * Handles the successful processing of a package manifest.
     * @param {string} type - The type of the package (e.g., "module", "system", "world").
     * @param {string} name - The expected name of the package.
     * @param {object} manifest - The manifest object containing package details.
     * @param {string} manifest.id - The unique identifier of the package for newer versions of Foundry.
     * @param {string} manifest.name - The unique identifier of the package for older versions of Foundry.
     * @param {string} manifest.version - The version of the package.
     * @param {string} manifest.secret - The secret key of the package.
     * @param {boolean} manifest.custom - Whether or not this package was installed as a custom package.
     * @param {string} manifest.system - The system associated with the package (for "world" type).
     * @param {string} manifest.title - The title of the package.
     * @returns {Promise<void>} - A promise that resolves when the manifest processing is complete.
     */
    async handleManifestSuccess(type, name, manifest) {
      const packageId = manifest.id || manifest.name;
      if (name && packageId !== name) {
        _ui.default.alert("danger", `${t("Failed to install {{type}}:", {
          type
        })} ${t("Wrong package archive installed")}`);
        return;
      }
      const pkg = _bazaar.default.findPackage({
        type,
        name: packageId,
        custom: manifest.custom
      }, this.allPackages);
      if (pkg) {
        pkg.installed = manifest.version;
        pkg.secret = manifest.secret;
      } else {
        this.customPackages.push(_bazaar.default.customPackageToBazaar(type, manifest));
      }
      const deps = this.readDependencies(manifest);
      if (type === "world" && manifest.system && !deps.find(d => d.name === manifest.system)) {
        deps.push({
          type: "system",
          name: manifest.system
        });
      }
      if (deps.length > 0) {
        this.manifestImportStatus = t("Installing the package dependencies");
        await this.installPackageDependencies(deps);
      }
      // Mark installation done and reset fields for next manifest
      this.manifestImportStatus = `Installed “${manifest.title}”`;
    },
    /**
     * Handles post-installation tasks for D&D Beyond packages
     * @param {object} manifest - The manifest of the installed package
     * @returns {Promise<void>}
     */
    async DDBPackageInstalled(manifest) {
      if (!manifest) {
        return;
      }
      const deps = this.readDependencies(manifest);
      if (deps.length > 0) {
        await this.installPackageDependencies(deps);
      }
      if (manifest.system) {
        const system = this.allPackages.find(p => p.type === "system" && p.name === manifest.system);
        if (system && !system.installed) {
          await this.installPackage(system);
          _ui.default.alert("info", t(`Installed required Game System: {{title}}`, {
            title: system.title
          }));
        }
      }
      if (manifest.dependencies) {
        await this.installPackageDependencies(manifest.dependencies);
      }
      await this.idleGames();
    },
    /**
     * Installs dependencies for a package
     * @param {Array<object>} dependencies - Array of dependency objects
     * @returns {Promise<number>} - Number of dependencies successfully installed
     */
    async installPackageDependencies(dependencies) {
      // Find all missing dependencies
      const missingDependencies = dependencies.filter(dep => !this.allPackages.find(p => p.installed && p.type === (dep.type || "module") && p.name === dep.name));
      if (missingDependencies.length === 0) {
        return 0;
      }
      for (const dep of missingDependencies) {
        const pkg = this.allPackages.find(p => p.type === (dep.type || "module") && p.name === dep.name);
        dep.userFriendlyTitle = pkg ? pkg.title : dep.name;

        // Try to install the missing dependencies
        dep.installed = false;
        if (dep.manifest) {
          const manifest = await this.installPackageFromManifest(dep.type || "module", dep.name, dep.manifest);
          if (manifest) {
            dep.installed = true;
          }
        } else if (pkg && (await this.installPackage(pkg))) {
          dep.installed = true;
        }
      }

      // Notify to the user which dependencies were installed, and which failed or were not found
      const installed = missingDependencies.filter(d => d.installed).map(d => d.userFriendlyTitle);
      // Only required dependencies can be considered failed. Optional/recommended dependencies should fail silently.
      const failed = missingDependencies.filter(d => !d.installed && !d.optional).map(d => d.userFriendlyTitle);
      if (installed.length) {
        _ui.default.alert("info", `${t("Installed {{length}} package dependencies:", {
          length: installed.length
        })} <b>${installed.join("</b>, <b>")}</b>`);
      }
      if (failed.length) {
        _ui.default.alert("danger", `${t("Failed to satisfy {{length}} package dependencies:", {
          length: failed.length
        })} <b>${failed.join("</b>, <b>")}</b>`);
      }
      return installed.length;
    },
    /* =======================================================================
     *  PACKAGE UNINSTALLATION
     * ======================================================================= */

    /**
     * Uninstalls a package
     * @param {object} pkg - The package object to uninstall
     * @param {boolean} [autoIdle] - Whether to automatically idle games after uninstallation
     * @returns {Promise<boolean>} - Whether the uninstallation was successful
     */
    async uninstallPackage(pkg, autoIdle = true) {
      pkg.processing = true;
      try {
        if (!["module", "system", "asset"].includes(pkg.type)) {
          return false;
        }
        if (pkg.custom) {
          const confirmDelete = await this.confirmCustomPackageDelete(pkg);
          if (!confirmDelete) {
            return false;
          }
        }
        if (pkg.locked) {
          const confirmUninstall = await this.confirmLockedPackageUninstall(pkg);
          if (!confirmUninstall) {
            return false;
          }
        }
        const result = await this.executeWithToast(pkg.name, pkg.title, `${t("Uninstalling")}...`, async () => {
          const response = await _utils.default.api(`data/${pkg.type}s/delete`, {
            name: pkg.name,
            secret: pkg.secret
          });
          if (response.error) {
            throw new Error(t(`Failed to uninstall {{type}}: {{- error}}`, {
              type: pkg.type,
              error: response.error
            }));
          }
          pkg.installed = null;
          if (pkg.custom) {
            const customPackageIndex = this.customPackages.findIndex(p => p.name === pkg.name && p.type === pkg.type);
            if (customPackageIndex !== -1) {
              this.customPackages.splice(customPackageIndex, 1);
            }
          }

          // Uninstalling an asset pack does not require idling the game
          if (autoIdle && pkg.type !== "asset") {
            await this.idleGames();
          }
          return response;
        }, {
          isCustom: pkg.custom,
          successMessage: t("Uninstallation successful!")
        });
        return !!result;
      } catch (error) {
        console.error(error);
      } finally {
        pkg.processing = false;
      }
    },
    /* =======================================================================
     *  CONFIRMATION DIALOGS
     * ======================================================================= */

    /**
     * Retrieves the confirmation buttons.
     * @returns {Array} An array of button objects.
     */
    getConfirmationButtons() {
      return [{
        id: "delete-no",
        type: "success",
        label: t("No"),
        response: "no"
      }, {
        id: "delete-yes",
        type: "danger",
        label: t(`Delete`),
        response: "yes"
      }];
    },
    /**
     * Prompts the user with a confirmation dialog to delete a custom package.
     * @param {object} pkg - The package object to be deleted.
     * @param {string} pkg.type - The type of the package.
     * @param {string} pkg.title - The title of the package.
     * @returns {Promise<boolean>} - Returns a promise that resolves to `true` if the user confirms the deletion, otherwise `false`.
     */
    async confirmCustomPackageDelete(pkg) {
      const result = await _ui.default.query(t(`Delete custom {{type}}`, {
        type: pkg.type
      }), `${t(`Are you sure you want to delete the custom {{type}} {{- title}}?`, {
        type: pkg.type,
        title: `“<strong>${_utils.default.escapeHTML(pkg.title)}</strong>”`
      })} <br/>${t("You will not be able to re-install it unless you import it from a local backup.")}`, {
        buttons: this.getConfirmationButtons()
      });
      return result === "yes";
    },
    /**
     * Prompts the user to confirm the uninstallation of a locked package.
     * @param {object} pkg - The package to be uninstalled.
     * @param {string} pkg.type - The type of the package.
     * @param {string} pkg.title - The title of the package.
     * @returns {Promise<boolean>} - A promise that resolves to `true` if the user confirms the uninstallation, otherwise `false`.
     */
    async confirmLockedPackageUninstall(pkg) {
      const result = await _ui.default.query(t(`Uninstalled locked {{type}}`, {
        type: pkg.type
      }), t(`Are you sure you want to uninstall the version locked {{type}} {{- title}}?`, {
        type: pkg.type,
        title: `“<strong>${_utils.default.escapeHTML(pkg.title)}</strong>”`
      }), {
        buttons: this.getConfirmationButtons()
      });
      return result === "yes";
    },
    /* =======================================================================
     *  PACKAGE MANAGEMENT
     * ======================================================================= */

    /**
     * Checks if a package has an update available
     * @param {object} pkg - The package object to check
     * @returns {Promise<void>}
     */
    async checkUpdate(pkg) {
      if (!pkg.manifest) {
        return;
      }
      pkg.processing = true;
      const customPackage = this.customPackages.find(p => p.name === pkg.name && p.type === pkg.type);
      if (customPackage) {
        // If this is a custom package, work with the source data instead.
        // This is necessary because custom packages replace the matching `name` in this.packages.
        pkg = customPackage;
      }
      const manifestUrl = _bazaar.default.getPackageManifestUrl(pkg.manifest, !customPackage);
      const response = await _utils.default.api(`package/check`, {
        type: pkg.type,
        url: manifestUrl
      });
      if (response.error) {
        pkg.processing = false;
        let errorMsg = response.error;
        if (pkg.title) {
          errorMsg += `: ${pkg.title}`;
        }
        if (pkg.name) {
          errorMsg += pkg.title ? ` (${pkg.name})` : `: ${pkg.name}`;
        }
        _ui.default.alert("danger", errorMsg.replace("Terms of Service", `<a href='/tos'>${t("Terms of Service")}</a>`));
        return;
      }
      // checking package compatibility
      const minimumVersion = response.manifest.compatibility && response.manifest.compatibility.minimum || response.manifest.minimumCoreVersion;
      let minimumVersionCompatible = true;
      let maximumVersionCompatible = true;
      const maximumVersion = response.manifest.compatibility && response.manifest.compatibility.maximum || response.manifest.maximumCoreVersion;
      if (minimumVersion) {
        minimumVersionCompatible = _utils.default.compareFoundryVersions(this.numericVersion, minimumVersion) >= 0;
      }
      if (maximumVersion) {
        maximumVersionCompatible = _utils.default.compareFoundryVersions(this.numericVersion, maximumVersion, true) <= 0;
      }
      if (minimumVersionCompatible && maximumVersionCompatible) {
        pkg.latest = response.manifest.version;
        pkg.latest_download = response.manifest.download;
      } else {
        pkg.latest = pkg.installed;
        this.$set(pkg, "latest_incompatible", true);
      }
      pkg.processing = false;
    },
    /**
     * Toggles the locked state of a package
     * @param {object} pkg - The package to toggle the lock state for
     * @returns {Promise<void>}
     */
    async togglePackageLock(pkg) {
      await this.lockPackages([{
        name: pkg.name,
        type: pkg.type,
        locked: !pkg.locked
      }]);
    },
    /**
     * Locks or unlocks multiple packages
     * @param {Array<object>} packages - Array of package objects with name, type, and locked properties
     * @returns {Promise<void>}
     */
    async lockPackages(packages) {
      // @todo #372 also check package type in case a module & system have the same name
      const packageNames = new Set(...packages.map(p => p.name));
      const filteredPackages = this.packages.filter(p => packageNames.has(p.name));
      filteredPackages.forEach(p => p.processing = true);
      const response = await _utils.default.api(`data/lock`, {
        packages
      });
      if (response.error) {
        filteredPackages.forEach(p => p.processing = false);
        _ui.default.alert("danger", response.error);
        console.warn(response.error);
        return;
      }
      for (const result of response.results) {
        const pkg = this.allPackages.find(p => p.name === result.name);
        if (result.error) {
          _ui.default.alert("danger", result.error);
          console.warn(result.error);
          pkg.processing = false;
          continue;
        }
        pkg.locked = result.locked;
        pkg.processing = false;
      }
    },
    /**
     * Idles all active game servers to apply package changes
     * Shows a warning if active games require restart
     * @returns {Promise<void>}
     */
    async idleGames() {
      const idle = await _utils.default.api(`game/idle`, {});
      if (!idle.success) {
        _ui.default.alert("warning", t(`You have currently in use games. You will need to {{- restartLink}} the servers for the updated packages to become available.`, {
          restartLink: `<a href="/setup#${_utils.default.buildHash({
            restart: true
          })}">${t("restart")}</a>`
        }), true);
      }
    },
    /**
     * Extracts dependency information from a package manifest
     * Handles both legacy and modern (v10+) manifest formats
     * @param {object|null} manifest - The package manifest
     * @returns {Array<object>} - Array of dependency objects
     */
    readDependencies(manifest) {
      if (!manifest) {
        return [];
      }
      const deps = manifest.dependencies || [];
      // From v10 manifests can carry package dependencies in relationships.requires
      // New manifests carry package id instead of name. We use name internally
      if (manifest.relationships) {
        // From v11, relationships.recommends is another relationship type for optional dependencies.
        const relationships = ["requires", "recommends"];
        for (const r of relationships) {
          if (manifest.relationships[r] && manifest.relationships[r].length > 0) {
            for (const newDep of manifest.relationships[r]) {
              if (!deps.find(d => d.name === newDep.id)) {
                deps.push({
                  ...newDep,
                  name: newDep.id,
                  optional: r === "recommends"
                });
              }
            }
          }
        }
      }
      return deps;
    },
    /* =======================================================================
     *  USER FEEDBACK
     *  ---
     *  We use Bootstrap's toast concept to alert users to changes to their
     *  packages.
     * ======================================================================= */

    /**
     * Execute an operation with a toast notification that stays visible for a
     * minimum duration. Depending on the operation's outcome, potentially
     * display a success/error toast.
     * @param {string} name - The package name that we're operating on.
     * @param {string} title - The package title, which we'll display in the toast's header.
     * @param {string} initialMessage -Initial toast message
     * @param {Function} operation - Async function to execute
     * @param {object} options - Configuration options
     * @param {number} options.minDuration - Minimum toast display time in ms (default: 1500)
     * @param {boolean} options.isCustom - Whether this is a custom package (default: false)
     * @param {string} options.variant - Toast variant (default: "primary")
     * @param {boolean} options.showSuccess - Whether to show success toast (default: true)
     * @param {string} options.successMessage - Success message override (default: "Operation completed successfully!")
     * @returns {Promise<*>} - The result from the operation
     */
    async executeWithToast(name, title, initialMessage, operation, options = {}) {
      const {
        minDuration = 1.5 * globalThis.SECOND_MS,
        isCustom = false,
        variant = "primary",
        showSuccess = true,
        successMessage = t("Operation completed successfully!")
      } = options;
      const toastId = isCustom ? `custom-${name}` : name;

      /**
       * Given a toast ID, manage hiding the toast.
       * - If the user is on this tab, immediately hide the toast.
       * - If the user isn't on this tab, wait for the user to return, then
       *   hide it.
       * @param {string} id - The toast ID to close
       * @returns {Promise<void> | void} Did the toast close yet?
       */
      const waitForDismissal = async id => {
        // If document already has focus, dismiss immediately
        if (document.hasFocus()) {
          this.$bvToast.hide(id);
          return;
        }

        // Otherwise wait for focus to return
        return new Promise(resolve => {
          const onVisibilityChange = () => {
            if (document.visibilityState === "visible" && document.hasFocus()) {
              document.removeEventListener("visibilitychange", onVisibilityChange);
              window.removeEventListener("focus", onVisibilityChange);
              this.$bvToast.hide(id);
              resolve();
            }
          };
          document.addEventListener("visibilitychange", onVisibilityChange);
          window.addEventListener("focus", onVisibilityChange);
        });
      };
      await waitForDismissal(toastId);

      // Create initial toast
      const h = this.$createElement;
      const message = h("span", {
        domProps: {
          innerHTML: initialMessage
        }
      });
      const spinner = h("b-spinner", {
        props: {
          small: true
        },
        class: ["mr-2"]
      }, "");
      this.$bvToast.toast([spinner, message], {
        noAutoHide: true,
        noCloseButton: true,
        id: toastId,
        toaster: "b-toaster-bottom-right",
        variant,
        title
      });

      // Start timing and execute operation
      const startTime = performance.now();
      try {
        const result = await operation();
        // Ensure minimum display time
        const elapsed = performance.now() - startTime;
        if (elapsed < minDuration) {
          await new Promise(resolve => setTimeout(resolve, minDuration - elapsed));
        }
        // Remove the operation toast
        waitForDismissal(toastId).then(() => {
          // Show result toast if appropriate
          if (result && showSuccess) {
            this.createSuccessToast(toastId, title, successMessage);
          }
        });
        return result;
      } catch (error) {
        // If the operation fails within a couple milliseconds, the in-progress
        // toast won't have time to show up. Let's give it a chance to show up
        // before hiding it.
        await new Promise(resolve => setTimeout(resolve, 1.5 * globalThis.SECOND_MS));
        waitForDismissal(toastId).then(() => {
          this.createErrorToast(toastId, title, error.message || String(error));
        });
        // Re-throw error
        throw error;
      }
    },
    /**
     * Create a toast that indicates that an operation completed successfully.
     * @param {string} name - The package name that we're operating on.
     * @param {string} title - The package title, which we'll display in the toast's header.
     * @param {string} content - Text displayed in the toast's body.
     */
    createSuccessToast(name, title, content) {
      const h = this.$createElement;
      const icon = h("i", {
        class: ["fa", "fa-check-square", "mr-2"]
      });
      const message = h("span", {
        domProps: {
          innerHTML: content
        }
      });
      this.$bvToast.toast([icon, message], {
        id: name,
        variant: "success",
        toaster: "b-toaster-bottom-right",
        title
      });
    },
    /**
     * Create a toast that indicates that an error occurred during an operation.
     * @param {string} name - The package name that we're operating on.
     * @param {string} title - The package title, which we'll display in the toast's header.
     * @param {string} error - Text displayed in the toast's body.
     */
    createErrorToast(name, title, error) {
      const icon = this.$createElement("i", {
        class: ["fa", "fa-exclamation-circle", "mr-2"]
      });
      const message = this.$createElement("span", {
        domProps: {
          innerHTML: error
        }
      });
      this.$bvToast.toast([icon, message], {
        noAutoHide: true,
        id: name,
        variant: "danger",
        toaster: "b-toaster-bottom-right",
        title
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CharacterSheetForge"] = Vue.component(
                    "CharacterSheetForge",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"character-sheet-container\"> <div class=\"d-flex flex-column\" style=\"height: 100%\"> <a :href=\"`/about/${member.nickname}`\"> <div class=\"d-flex flex-row\" style=\"height: 65px\"> <img v-if=\"member.avatar && !avatarError\" :src=\"member.avatar\" :alt=\"member.name\" style=\"flex: 0 65px; object-fit: cover\" width=\"65\" height=\"65\" @error=\"handleAvatarError()\" /> <img v-else src=\"/images/sheets/forge/fake-border.png\" style=\"flex: 0 2px; border: none !important\" width=\"2\" height=\"65\" /> <div class=\"d-flex flex-column column-name\"> <span class=\"nick\">{{ member.nickname }}</span> <span class=\"name\">{{ member.fullName }}</span> </div> <div class=\"d-flex flex-row column-level\"> <div class=\"d-flex flex-column p-1\"> <span class=\"level\">{{ member.level }}</span> <span class=\"subtitle\">Level</span> </div> <div class=\"d-flex flex-column p-1\" style=\"flex: 1\"> <span class=\"title\">{{ member.title }}</span> <span class=\"subtitle\">Class</span> </div> </div> </div> </a> <div class=\"biography mt-1\"> <div class=\"d-flex flex-column p-1\" style=\"flex: 1\"> <span class=\"subtitle-upper\">Biography</span> <div v-html=\"biography\"></div> </div> </div> <div v-if=\"hasLinks\" class=\"social-box mt-1\"> <div class=\"d-flex flex-column p-1\" style=\"flex: 1\"> <character-sheet-social-links :member=\"member\" xmlns=\"http://www.w3.org/1999/xhtml\" class=\"justify-content-center\" /> <span class=\"subtitle\">Alliances</span> </div> </div> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: "@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700&display=swap\"); .character-sheet-container { width: 100%; height: 100%; position: relative; padding: 0.35rem; } .character-sheet-container span, .character-sheet-container p { color: black; font-family: \"Playfair Display\", serif; font-weight: 500; margin: 0; line-height: 24px; } .character-sheet-container p a { color: #007bff; } .character-sheet-container span:hover { text-decoration: none !important; } .character-sheet-container img { border: 2px solid black; border-radius: 2px; } .character-sheet-container span.nick { background: url(\"/images/sheets/forge/banner_rot.svg\") no-repeat left center; background-size: cover; color: black; font-size: 1.1rem; font-weight: 700; text-transform: uppercase; } .character-sheet-container div.column-name { flex: 1; } .character-sheet-container div.column-name span { height: 2.03rem; padding-left: 0.7rem; white-space: nowrap; padding-right: 1rem; } .character-sheet-container div.column-name span.name { padding-left: 0.1rem; } .character-sheet-container div.column-level { flex: 1; background-color: rgba(255, 255, 255, 0.7); backdrop-filter: blur(5px); border: 2px solid black; border-radius: 2px; } .character-sheet-container div.biography { flex: 1; background-color: rgba(255, 255, 255, 0.7); backdrop-filter: blur(5px); border: 2px solid black; border-radius: 2px; } .character-sheet-container div.biography p { font-weight: 600; padding: 1rem; min-height: 15rem; background-image: linear-gradient(to bottom, transparent 1px, transparent 1.4rem, rgb(0 0 0 / 20%) 1px); background-size: 100% 1.5rem; background-origin: content-box; background-clip: content-box; } .character-sheet-container div.social-box { flex: 0 3rem; background-color: rgba(255, 255, 255, 0.7); backdrop-filter: blur(5px); border: 2px solid black; border-radius: 2px; } .character-sheet-container span.name { background: url(\"/images/sheets/forge/banner.svg\") no-repeat right center; background-size: cover; color: black; font-size: 1.1rem; font-weight: 600; display: flex; align-items: end; } .character-sheet-container span.level { color: black; font-size: 2.4rem; font-family: \"El Messiri\", serif; text-anchor: middle; line-height: 2rem; flex: 1; text-align: center; } .character-sheet-container span.title { color: black; font-size: 1rem; line-height: 0.9rem; font-weight: 600; text-align: center; display: inline-flex; align-items: center; justify-content: center; flex: 1; font-variant: small-caps; } .character-sheet-container span.subtitle { font-variant: small-caps; text-align: center; font-size: 1rem; font-weight: 800; border-top: 1px solid #333333; flex: 0; } .character-sheet-container span.subtitle-upper { font-variant: small-caps; text-align: center; font-size: 1rem; font-weight: 800; border-bottom: 1px solid #333333; flex: 0; }"
    });
  },
  props: {
    member: Object
  },
  data() {
    return {
      avatarError: false
    };
  },
  computed: {
    biography() {
      return DOMPurify.sanitize(marked(this.member.bio));
    },
    hasLinks() {
      return this.member.github || this.member.linkedin || this.member.twitter || this.member.twitch || this.member.websites && this.member.websites.length;
    }
  },
  methods: {
    handleAvatarError() {
      this.avatarError = true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CharacterSheetSocialLinks"] = Vue.component(
                    "CharacterSheetSocialLinks",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"social-icons\"> <a v-if=\"member.github\" :href=\"`https://github.com/${member.github}`\" target=\"_blank\" rel=\"noopener noreferrer\"> <i class=\"fab fa-github\"></i> </a> <a v-if=\"member.linkedin\" :href=\"`https://www.linkedin.com/in/${member.linkedin}`\" target=\"_blank\" rel=\"noopener noreferrer\" > <i class=\"fab fa-linkedin\"></i> </a> <a v-if=\"member.twitter\" :href=\"`https://twitter.com/${member.twitter}`\" target=\"_blank\" rel=\"noopener noreferrer\"> <i class=\"fab fa-twitter\"></i> </a> <a v-if=\"member.twitch\" :href=\"`https://twitch.tv/${member.twitch}`\" target=\"_blank\" rel=\"noopener noreferrer\"> <i class=\"fab fa-twitch\"></i> </a> <a v-for=\"web of member.websites || []\" :key=\"web.url\" v-b-tooltip :href=\"web.url\" target=\"_blank\" rel=\"noopener noreferrer\" :title=\"web.name\" > <i class=\"fas fa-globe\"></i> </a> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".social-icons { display: block; text-align: center; color: black; font-size: 1.8rem; height: 1.6rem; flex: 0; } .social-icons a { color: var(--secondary); } .social-icons a:hover { color: black; }"
    });
  },
  props: {
    member: Object
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ApiKeyTable"] = Vue.component(
                    "ApiKeyTable",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <h5><i v-if=\"icon\" :class=\"`${icon} pr-2`\"></i>{{ title }}</h5> <loading-indicator v-if=\"loading\" :label=\"t('Loading API keys, please wait…')\"></loading-indicator> <transition v-if=\"!loading && !apiKeys.length\" tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > </transition> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > <b-table v-if=\"!loading\" bordered hover small sort-icon-left striped show-empty sticky-header stacked=\"md\" class=\"api-key-table\" head-variant=\"light\" :primary-key=\"primaryKey\" :fields=\"filteredTableFields\" :items=\"apiKeys\" :empty-text=\"noKeysMessage\" :sort-compare=\"sortKeys\" :sort-by.sync=\"sortByField\" :sort-desc.sync=\"sortDesc\" :tbody-transition-props=\"transitionProps\" > <!-- Headers --> <template #head()=\"data\"> <div :id=\"headerId(data.field)\"> {{ data.label }} <span v-if=\"data.field.sortable\" class=\"sr-only\">({{ sortTooltip(data.field) }})</span> </div> </template> <!-- Data --> <template #cell(name)=\"data\"> <b>{{ data.value }}</b> </template> <template #cell(permissions)=\"data\"> <b-badge v-if=\"readPermission(data.value)\" variant=\"success\" pill> {{ t(\"Read Assets\") }} </b-badge> <b-badge v-if=\"writePermission(data.value)\" variant=\"warning\" pill> {{ t(\"Write Assets\") }} </b-badge> </template> <template #cell(created)=\"data\"> {{ data.item.createdString }} </template> <template #cell(expiration)=\"data\"> <div v-if=\"expired(data.item)\"> <b-badge v-b-tooltip.hover.top variant=\"danger\" :title=\"t('Expired API keys can be Revoked without risk.')\"> {{ t(\"Expired\") }} <i class=\"fas fa-question-circle\"></i> </b-badge> </div> <span v-else>{{ data.item.expiresString }}</span> </template> <template #cell(actions)=\"data\"> <div class=\"action-buttons\"> <b-button v-for=\"action in totalActions\" :key=\"action.key\" v-b-tooltip.hover.top.noninteractive class=\"mx-1\" size=\"sm\" :variant=\"action.variant || 'danger'\" :disabled=\"allProcessing\" :title=\"action.label\" :aria-label=\"action.label\" @click=\"doAction(action.key, data.item)\" > <i v-if=\"!allProcessing\" :class=\"action.icon\"></i> <b-spinner v-else small></b-spinner> <span class=\"d-none d-lg-inline-block\">{{ action.label }}</span> </b-button> </div> </template> </b-table> </transition> <!-- Confirmation dialog for removing/revoking a key --> <b-modal v-model=\"showRemoveKeyModal\" custom-class=\"confirm-remove-key\" centered :title=\"sharedKeys ? t('Remove API Key') : t('Revoke API Key')\" @ok=\"removeKey(keyToRemove)\" > <div v-if=\"sharedKeys\"> <i18n tag=\"p\" :path=\"t('Are you sure you want to remove the key {0} from your account?')\"> <strong>{{ keyToRemove ? keyToRemove.name : \"\" }}</strong> </i18n> <i18n tag=\"p\" :path=\"t('This will not affect any other users access.')\"></i18n> </div> <div v-else> <i18n tag=\"p\" :path=\"t('Are you sure you want to revoke the key {0}?')\"> <strong>{{ keyToRemove ? keyToRemove.name : \"\" }}</strong> </i18n> <b-alert :show=\"!keyToRemoveIsExpired\" variant=\"warning\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"This will immediately prevent all other users from using the key.\") }} </b-alert> </div> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".api-key-table .actions-header { width: 9em; white-space: nowrap; } @media (min-width: 992px) { .api-key-table .action-buttons { white-space: nowrap; } } .api-key-table .badge { font-size: 0.9rem; } .api-key-table .row-move { transition: transform 1s; }"
    });
  },
  props: {
    id: String,
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ""
    },
    sharedKeys: {
      type: Boolean,
      default: false
    },
    processing: Boolean,
    reload: Boolean,
    hideCols: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      apiKeys: [],
      loading: true,
      selfProcessing: false,
      keyToRemove: null,
      showRemoveKeyModal: false,
      sortByField: "name",
      sortDesc: false,
      transitionProps: {
        enterActiveClass: "animate__animated animate__faster animate__fadeIn",
        leaveActiveClass: "animate__animated animate__faster animate__fadeOut",
        moveClass: "animate__animated animate__fast row-move"
      },
      tableFields: [{
        key: "name",
        label: t("Name"),
        thClass: "pl-3 align-middle",
        tdClass: "align-middle",
        sortable: true
      }, {
        key: "permissions",
        label: t("Permissions"),
        thClass: "pl-3 align-middle",
        tdClass: "align-middle",
        sortable: true
      }, {
        key: "created",
        label: t("Created"),
        thClass: "pl-3 align-middle",
        tdClass: "align-middle",
        sortable: true
      }, {
        key: "expiration",
        label: t("Expires"),
        thClass: "pl-3 align-middle",
        tdClass: "align-middle",
        sortable: true
      }, {
        key: "actions",
        label: t("Actions"),
        thClass: "align-middle text-md-center actions-header",
        tdClass: "align-middle text-md-center",
        sortable: false
      }]
    };
  },
  watch: {
    sortByField(newValue) {
      if (!newValue) {
        // Reset to default sort after a short delay so that the b-table picks up the change
        setTimeout(() => {
          this.sortByField = this.filteredTableFields[0].key;
        }, 100);
      }
    },
    reload(newValue) {
      // Only request keys from server on a rising edge
      if (!this.loading && newValue) {
        this.getKeys();
      }
    }
  },
  computed: {
    filteredTableFields() {
      return this.tableFields.filter(field => !this.hideCols.includes(field.key));
    },
    primaryKey() {
      for (const key of this.apiKeys) {
        if (!key.id) {
          return "name";
        }
      }
      // Only use the id field if all keys have an id
      return "id";
    },
    allProcessing() {
      return this.processing || this.selfProcessing;
    },
    totalActions() {
      const defaults = [];
      defaults.push({
        key: "remove",
        label: this.sharedKeys ? t("Remove") : t("Revoke"),
        icon: "fas fa-trash-alt",
        variant: "danger"
      });
      return [...defaults, ...this.actions];
    },
    noKeysMessage() {
      return this.sharedKeys ? t("You have not accepted any shared API keys yet.") : t("You have not generated any API keys yet.");
    },
    keyToRemoveIsExpired() {
      return this.keyToRemove && this.keyToRemove.expiration !== null && this.keyToRemove.expiration - Date.now() < 0;
    }
  },
  methods: {
    async getKeys() {
      this.loading = true;
      const response = await Utils.api(this.sharedKeys ? "shared-keys" : "keys", {}, {
        method: "GET"
      });
      // Handle the response for this user's keys
      if (response.error) {
        // Error message differs depending on which type of keys this table is for
        if (this.sharedKeys) {
          UI.error(t("Error getting added API Keys: {{error}}", {
            error: response.error
          }));
        } else {
          UI.error(t("Error getting your API Keys: {{error}}", {
            error: response.error
          }));
        }
      } else {
        this.apiKeys = this.processKeysResponse(response);
      }
      this.$emit("keys", {
        keys: this.apiKeys
      });
      this.loading = false;
    },
    processKeysResponse(response) {
      const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric"
      };
      /* The results returned by /api/keys and /api/shared-keys differ, so the processing below needs to account for this.
      In both cases, response.keys is an array of objects. They have the following properties:
      keys: {
        name: string;
        created: string;
        expiration: string;
        permissions: string[];
      }
      shared-keys: {
        id: string;
        name: string;
        key: string; // This is the jwt
      }
      */
      return response.keys
      // Convert dates to timestamps
      .map(key => {
        // If this is a shared key, it will have a `key` property.
        if (key.key) {
          // Parse the jwt
          const keyData = key.key ? JSON.parse(atob(key.key.split(".")[1])) : {};
          return {
            name: keyData.keyName,
            id: key.id,
            created: keyData.iat * 1000,
            expiration: keyData.exp ? keyData.exp * 1000 : null,
            permissions: keyData.permissions || []
          };
        }
        // This is not a shared key, so it is a key owned by this account
        return {
          name: key.name,
          created: Date.parse(key.created),
          expiration: key.expiration ? Date.parse(key.expiration) : null,
          permissions: key.permissions || []
        };
      })
      // Create strings for display of dates
      .map(key => {
        return {
          ...key,
          createdString: key.created ? new Date(key.created).toLocaleDateString(undefined, dateOptions) : t("Unknown"),
          expiresString: key.expiration ? Utils.timeSince(key.expiration) : t("Never")
        };
      })
      // Default sort by the first column
      .sort((a, b) => this.sortKeys(a, b, this.filteredTableFields[0]));
    },
    sortKeys(a, b, field) {
      switch (field) {
        case "created":
          return a.created - b.created;
        case "expiration":
          if (a.expiration === null) {
            return 1;
          }
          if (b.expiration === null) {
            return -1;
          }
          return a.expiration - b.expiration;
        case "permissions":
          return a.permissions.length - b.permissions.length;
        case "name":
        default:
          return a.name.localeCompare(b.name);
      }
    },
    headerId(field) {
      return `${this.id}--header-${field.key}`;
    },
    sortTooltip(field) {
      if (!field.sortable) {
        return "";
      }
      if (field.key !== this.sortByField || this.sortDesc) {
        return t("Click to sort ascending");
      }
      return t("Click to sort descending");
    },
    readPermission(value) {
      return value && Array.isArray(value) && value.includes("read-assets");
    },
    writePermission(value) {
      return value && Array.isArray(value) && value.includes("write-assets");
    },
    expired(item) {
      return item && item.expiration && item.expiration < Date.now();
    },
    doAction(action, item) {
      if (action === "remove") {
        this.promptRemoveKey(item);
      } else {
        this.$emit(action, item);
      }
    },
    promptRemoveKey(key) {
      this.keyToRemove = key;
      this.showRemoveKeyModal = true;
    },
    async removeKey(key) {
      if (!key || !key.name && !key.id) {
        return false;
      }
      this.selfProcessing = true;
      let response;
      if (!this.sharedKeys) {
        response = await Utils.api(`revoke-key`, {
          name: key.name
        });
      } else {
        response = await Utils.api(`remove-shared-key`, {
          id: key.id
        });
      }
      this.selfProcessing = false;
      if (response.error) {
        UI.error(!this.sharedKeys ? t("Error revoking API Key: {{response.error}}", {
          response
        }) : t("Error removing API Key: {{response.error}}", {
          response
        }));
        return false;
      }
      if (response.success) {
        this.apiKeys = this.apiKeys.filter(k => this.sharedKeys ? k.id !== key.id : k.name !== key.name);
        this.$emit("removed", key);
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.getKeys();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileAccountInformation"] = Vue.component(
                    "ProfileAccountInformation",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header>{{ t(\"Account Information\") }}</b-card-header> <b-card-body> <b-row> <b-col> <b-form-group label-cols=\"3\" :label=\"t('Username')\" :invalid-feedback=\"usernameError\" :state=\"!usernameError && null\" > <b-form-input v-model=\"userData.username\" required :state=\"!usernameError && null\" /> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Email Address')\" :invalid-feedback=\"emailError\" :state=\"!emailError && null\" > <b-input-group> <template #append> <b-input-group-text> {{ verifiedText }} </b-input-group-text> <b-button v-if=\"!user.emailVerified\" v-b-tooltip.hover variant=\"primary\" :title=\"t('Resend email verification')\" @click=\"resendEmail\" > <i class=\"fas fa-paper-plane\" /> </b-button> <information-toggle v-model=\"emailInputType\" :noun=\"t('Email Address')\" /> </template> <b-form-input v-model=\"userData.email\" :type=\"emailInputType\" :state=\"!emailError && null\" @input=\"emailInputModified\" /> </b-input-group> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Current Password')\" :disabled=\"!user.hasPassword\" :invalid-feedback=\"currentPasswordError\" :state=\"!currentPasswordError && null\" > <b-form-input v-model=\"userData.password\" type=\"password\" :placeholder=\"passwordPlaceholder\" :state=\"!currentPasswordError && null\" /> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('New Password')\" :invalid-feedback=\"newPasswordError\" :state=\"!newPasswordError && null\" > <b-form-input v-model=\"userData.newPassword\" type=\"password\" :placeholder=\"newPasswordPlaceholder\" :state=\"!newPasswordError && null\" /> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Confirm New Password')\" :disabled=\"!userData.newPassword\" :invalid-feedback=\"userData.confirmPassword ? confirmPasswordError : null\" :state=\"!confirmPasswordError && (!!userData.confirmPassword || null)\" > <b-form-input v-model=\"userData.confirmPassword\" type=\"password\" :placeholder=\"t('Confirm your new password')\" :state=\"userData.confirmPassword ? !confirmPasswordError : null\" /> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Two Factor Authentication (2FA)')\" class=\"tfa-group\"> <p v-if=\"!user.hasPassword\" class=\"text-danger mb-0\"> {{ t(\"Unavailable until you set your password\") }} </p> <span v-else-if=\"canConfigure2FA\" class=\"d-flex align-items-center\"> {{ status2FA }} <b-button variant=\"primary\" class=\"ml-2\" @click.prevent=\"popup2FA = true\"> <i class=\"fas fa-user-cog\" /> {{ label2FA }} </b-button> </span> <p v-else class=\"text-danger mb-0\"> {{ t(\"Unavailable until you verify your email address\") }} </p> </b-form-group> <security2fa v-model=\"popup2FA\" class=\"vue-render-app\" @auth-change=\"authenticatorChanged\" /> </b-col> </b-row> <hr /> <b-row> <b-col cols=\"3\"> <b-button variant=\"primary\" class=\"profile-button\" :disabled=\"!hasChanges || !canSave || saving\" @click.prevent=\"saveAccountInformation\" > <i class=\"fas fa-save\" /> <span v-if=\"!saving\">{{ t(\"Update account\") }}</span> <span v-else>{{ t(\"Saving…\") }}</span> </b-button> </b-col> <b-col> <b-alert v-if=\"!userData.password\" show variant=\"warning\" class=\"mb-0\"> <i18n v-if=\"user.hasPassword\" :path=\"t('You must enter your current password to change your username, email, or password.')\" /> <i18n v-else :path=\" t( 'Your account was created by linking with your Google, Discord, or Patreon account, and so does not have a username and password set. You must set a password before being able to make other changes to your account.' ) \" /> </b-alert> </b-col> </b-row> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".linked-accounts .input-group-prepend .fa-fw { margin-right: 6px; } .linked-accounts .input-group-prepend .input-group-text { min-width: 8em; } .linked-accounts .input-group-append button { min-width: 6em; } .tfa-group > .form-row { align-items: center; }"
    });
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      saving: false,
      userData: {
        username: this.user.username || "",
        email: this.user.email || "",
        password: "",
        newPassword: "",
        confirmPassword: "",
        emailVerified: this.user.emailVerified || false
      },
      emailInputType: "password",
      popup2FA: false,
      active2FA: this.user.active2FA
    };
  },
  computed: {
    verifiedText() {
      return this.userData.emailVerified ? t("Verified") : t("Not Verified");
    },
    passwordPlaceholder() {
      return this.user.hasPassword ? t("Enter current password to make any changes") : t("Account was created without a password via third-party signin.");
    },
    newPasswordPlaceholder() {
      return this.user.hasPassword ? t("Leave empty to keep your current password") : t("You must create a new password for this site to save any changes");
    },
    hasUsernameChanges() {
      return this.user.username !== this.userData.username;
    },
    hasEmailChanges() {
      return this.user.email !== this.userData.email;
    },
    hasPasswordChanges() {
      return this.userData.newPassword !== "";
    },
    /**
     * Checks if there are any changes in the account information.
     *
     * @returns {boolean} - Returns true if there are changes in the username, email, or password; otherwise, false.
     */
    hasChanges() {
      return this.hasUsernameChanges || this.hasEmailChanges || this.hasPasswordChanges;
    },
    /**
     * Validates the username field in the user data.
     *
     * @returns {string|null} - Returns an error message if the username is empty, otherwise returns null.
     */
    usernameError() {
      if (this.userData.username.trim() === "") {
        return t("Username cannot be empty");
      }
      return null;
    },
    /**
     * Checks for errors related to the current password when making changes to the profile.
     *
     * @returns {string|null} An error message if the current password is required but not provided, otherwise null.
     */
    currentPasswordError() {
      if (this.user.hasPassword && !this.userData.password && this.hasChanges) {
        return t("You must enter your current password to make any changes to your profile");
      }
      return null;
    },
    /**
     * Validates the new password input and returns an appropriate error message if any validation fails.
     *
     * @returns {string|null} - Returns an error message string if validation fails, otherwise returns null.
     *
     * Validation rules:
     * 1. If the user does not have a password set and no new password is provided, an error message is returned.
     * 2. If there are password changes and the new password is less than 8 characters long, an error message is returned.
     */
    newPasswordError() {
      if (!this.user.hasPassword && !this.userData.newPassword) {
        return t("You must set a new password to make any changes to your profile");
      }
      if (this.hasPasswordChanges && this.userData.newPassword.length < 8) {
        return t("Password must be at least 8 characters long");
      }
      return null;
    },
    /**
     * Validates the email address format if there are changes to the email.
     * @returns {string|null} - Returns an error message if the email format is invalid, otherwise returns null.
     */
    emailError() {
      if (this.hasEmailChanges && !this.userData.email.match(globalThis.PERMISSIVE_EMAIL_REGEX)) {
        return t("Please enter a valid email address");
      }
      return null;
    },
    /**
     * Validates if the new password and confirm password fields match.
     *
     * @returns {string|null} - Returns an error message if the passwords do not match, otherwise returns null.
     */
    confirmPasswordError() {
      if (this.hasPasswordChanges && this.userData.newPassword !== this.userData.confirmPassword) {
        return t("Passwords do not match");
      }
      return null;
    },
    /**
     * Determines if the form can be saved by checking for any existing errors.
     *
     * @returns {boolean} - Returns true if there are no errors in the form fields (username, email, current password, new password, confirm password), otherwise returns false.
     */
    canSave() {
      return !(this.usernameError || this.emailError || this.currentPasswordError || this.newPasswordError || this.confirmPasswordError);
    },
    canConfigure2FA() {
      return this.active2FA || this.user.emailVerified;
    },
    status2FA() {
      return this.active2FA ? t("Enabled") : t("Disabled");
    },
    label2FA() {
      return this.active2FA ? t("Configure") : t("Setup");
    }
  },
  methods: {
    async authenticatorChanged(active) {
      this.active2FA = active;
    },
    async saveAccountInformation() {
      if (!this.canSave) {
        this.saving = false;
        return;
      }
      this.saving = true;
      const result = await Utils.api("profile/account", this.userData);
      if (!result.success) {
        UI.error(result.msg || result.error || t("Error communicating with server"));
        this.saving = false;
        return;
      }
      if (result.emailVerification) {
        UI.success(t("Email verification has been sent."));
      }
      this.$emit("update", {
        username: this.userData.username,
        email: this.userData.email,
        emailVerified: !result.emailVerification,
        hasPassword: result.hasPassword
      });
      this.userData.emailVerified = !result.emailVerification;
      this.userData.password = "";
      this.userData.newPassword = "";
      this.userData.confirmPassword = "";
      this.saving = false;
      UI.success(t("Your account information has been updated."));
    },
    async resendEmail() {
      const result = await Utils.api("profile/account/send-email-verification", {});
      if (!result.success) {
        UI.error(result.msg || t("Error communicating with server"));
        return;
      }
      UI.success(t("Email verification has been sent."));
    },
    emailInputModified() {
      // Modifying the email input field should reveal the hidden content
      if (this.emailInputType === "password" && this.hasEmailChanges) {
        this.emailInputType = "text";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileAccountLinkedAccounts"] = Vue.component(
                    "ProfileAccountLinkedAccounts",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header>{{ t(\"Linked Accounts\") }}</b-card-header> <b-card-body> <b-row> <b-col> <p> {{ t( \"You can link your Forge account with external services in order to login to your Forge account using the third party service directly.\" ) }} </p> <i18n :path=\" t( `Linking your account with Patreon can unlock additional features or give access to specific Patreon-exclusive content in the {0}.` ) \" tag=\"p\" > <a href=\"/bazaar\">{{ t(\"Bazaar\") }}</a> </i18n> </b-col> </b-row> <b-row> <b-col> <b-form-group v-for=\"provider in ['patreon', 'google', 'discord']\" :key=\"provider\" class=\"linked-accounts\"> <b-input-group> <template #prepend> <b-input-group-text class=\"bg-dark text-light\"> <i :class=\"`fab fa-fw fa-${provider}`\"></i> {{ Utils.capitalize(provider) }} </b-input-group-text> </template> <b-form-input v-model=\"external[provider].username\" :name=\"provider\" disabled></b-form-input> <template #append> <b-button v-if=\"!external[provider].linked\" variant=\"primary\" @click=\"linkExternalAccount(provider)\"> {{ t(\"Link\") }} </b-button> <b-button v-else variant=\"danger\" @click=\"unlinkExternalAccount(provider)\"> {{ t(\"Unlink\") }} </b-button> </template> </b-input-group> </b-form-group> </b-col> </b-row> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".linked-accounts .input-group-prepend .fa-fw { margin-right: 6px; } .linked-accounts .input-group-prepend .input-group-text { min-width: 8em; } .linked-accounts .input-group-append button { min-width: 6em; }"
    });
  },
  props: {
    external: Object
  },
  methods: {
    async linkExternalAccount(provider) {
      window.location = `/account/auth/${provider}?returnToHash=${window.location.hash.slice(1)}`;
    },
    async unlinkExternalAccount(provider) {
      const result = await Utils.api(`profile/account/unlink-${provider}`, {});
      if (!result.success) {
        UI.alert("danger", result.error || t("Error communicating with server"), true);
        throw new Error(result.error || t("Error communicating with server"));
      } else {
        UI.alert("success", t(`{{provider}} account has been unlinked`, {
          provider: Utils.capitalize(provider)
        }), false, 10000);
        setTimeout(() => window.location.reload(), 2000);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileApiKeyManagerSection"] = Vue.component(
                    "ProfileApiKeyManagerSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card class=\"api-key-manager\" no-body> <b-card-header> {{ t(\"API Manager\") }} </b-card-header> <b-card-body> <b-row> <b-col> <p> {{ t(\"You can generate new API Keys which allow anyone with the key to access portions of your account.\") }} </p> <p> {{ t( \"From within The Forge, you can access your assets library without setting an API key as long as you are logged in.\" ) }} </p> <i18n :path=\" t( `You can also set a different API Key in the Forge module settings within Foundry to access someone else's assets library, or access your own assets library from someone else's game, if they are not hosted on The Forge (Requires {0}).` ) \" tag=\"p\" > <a target=\"_blank\" href=\"https://foundryvtt.com/packages/forge-vtt/\">{{ t(\"The Forge module\") }}</a> </i18n> <!-- API keys shared with this account --> <api-key-table id=\"shared-api-keys\" shared-keys emit-keys icon=\"fas fa-share-alt\" :title=\"t('API Keys Shared With You')\" :processing=\"processing\" :hide-cols=\"['created']\" @keys=\"populateSharedKeys\" ></api-key-table> <!-- API keys owned by this account --> <api-key-table id=\"own-api-keys\" emit-keys icon=\"fas fa-key\" :title=\"t('Your API Keys')\" :processing=\"processing\" :reload=\"reload\" :actions=\"[ { key: 'share-url', label: t('Share URL'), icon: 'fas fa-share-alt', variant: 'info', }, ]\" @share-url=\"getShareUrl\" @keys=\"populateOwnKeys\" @removed=\"keyRemoved\" ></api-key-table> <b-card> <template #header> {{ t(\"Generate a new API Key\") }} </template> <p> {{ t( \"The API keys you generate can have one or more permissions assigned to them, and an expiration date.\" ) }} </p> <p> {{ t(\"For now, only access to your assets is provided through the API.\") }} </p> <i18n :path=\" t( 'If you want to limit sharing to a specific folder of your assets, you can create a share key from your {0}.' ) \" > <a target=\"_blank\" href=\"/assets/browse\">{{ t(\"assets library\") }}</a> </i18n> <assets-key-generator class=\"mt-3\" folder-name=\"/\" :reset=\"resetKeyGen\" @new-key=\"newKey\" ></assets-key-generator> </b-card> <b-card v-if=\"apiKeys.length\" header-text-variant=\"dark\" header-bg-variant=\"warning\" border-variant=\"warning\" header-class=\"rounded-0\" class=\"mt-4 mb-2 thick-border border-top-0\" > <template #header> <b>{{ t(\"Revoke all API Keys\") }}</b> </template> <p class=\"mb-1\"> {{ t( \"If your API Key has leaked or you want to revoke access to someone whose key has not yet expired, you can reset all keys at once.\" ) }} </p> <p class=\"mb-1\"> {{ t( 'If you created a legacy API key before the \"Share Folder\" feature, this is the only way to revoke that key.' ) }} </p> <p> {{ t( \"After resetting your keys, you may need to reload your games running on The Forge as their own keys would have become revoked.\" ) }} </p> <b-row class=\"text-left\"> <b-col> <b-button variant=\"danger\" :disabled=\"processing\" @click=\"promptReset\"> <i class=\"fas fa-trash-alt\"></i> {{ t(\"Revoke All Keys\") }} </b-button> </b-col> </b-row> </b-card> </b-col> </b-row> </b-card-body> <!-- New API key popup dialog --> <b-modal v-model=\"showAddedKey\" custom-class=\"added-key-info\" centered :title=\"t('New API Key')\"> <div v-if=\"showAddedKey\"> <i18n tag=\"p\" :path=\" t('You have added an API key named {0}, which expires {1} and allows {2} access to the associated assets.') \" > <strong>{{ addedKey.name }}</strong> <strong>{{ addedKey.expiresString }}</strong> <strong>{{ addedKeyPermissions }}</strong> </i18n> <p> {{ t(\"You can remove this key from your account at any time without affecting anyone else's access.\") }} </p> </div> <template #modal-footer=\"{ ok }\"> <b-button @click=\"ok()\"> {{ t(\"OK\") }} </b-button> </template> </b-modal> <!-- Confirmation dialog before revoking all keys --> <b-modal v-model=\"showRevokeKeysModal\" custom-class=\"confirm-remove-key\" centered :title=\"t('Revoke all API Keys')\" @ok=\"reset\" > <i18n tag=\"p\" :path=\"t('Are you sure you want to revoke {0}?')\"> <strong>{{ t(\"all of your API keys\") }}</strong> </i18n> <b-alert show variant=\"danger\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"This will immediately prevent everyone from using any of your existing API keys.\") }} {{ t(\"This action cannot be undone!\") }} </b-alert> </b-modal> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".api-key-manager .thick-border { border-width: 0.3rem; } .api-key-manager .copy-to-clipboard { position: absolute; right: 0px; top: 0px; }"
    });
  },
  data() {
    return {
      processing: false,
      reload: false,
      resetKeyGen: false,
      expirationList: [{
        value: "",
        text: t("Never")
      }, {
        value: "30d",
        text: t("TIME.days", {
          count: 30
        })
      }, {
        value: "7d",
        text: t("TIME.days", {
          count: 7
        })
      }, {
        value: "24h",
        text: t("TIME.hours", {
          count: 24
        })
      }, {
        value: "6h",
        text: t("TIME.hours", {
          count: 6
        })
      }, {
        value: "1h",
        text: t("TIME.hours", {
          count: 1
        })
      }, {
        value: "15m",
        text: t("TIME.minutes", {
          count: 15
        })
      }],
      addedKeyId: null,
      apiKeys: [],
      sharedApiKeys: [],
      generatedKey: null,
      showRevokeKeysModal: false
    };
  },
  computed: {
    addedKey() {
      return this.sharedApiKeys.find(k => k.id === this.addedKeyId);
    },
    showAddedKey: {
      get() {
        return !!(!this.processing && this.addedKey && this.addedKey.name);
      },
      set(value) {
        if (!value) {
          this.addedKeyId = null;
        }
      }
    },
    addedKeyPermissions() {
      if (!this.addedKey) {
        return "";
      }
      if (this.addedKey.permissions.includes("write-assets")) {
        return t("Read and Write");
      }
      return t("Read Only");
    }
  },
  methods: {
    promptReset() {
      this.showRevokeKeysModal = true;
    },
    async reset() {
      this.processing = true;
      const response = await Utils.api("reset-keys", {});
      if (response.error) {
        this.processing = false;
        return UI.error(t("Error resetting API Keys: {{response.error}}", {
          response
        }));
      }
      this.processing = false;
      this.reloadKeys();
      this.resetKeyGenerator();
      UI.success(t("API Keys revoked"));
      this.apiKey = "";
      return true;
    },
    newKey(key) {
      this.generatedKey = key;
      this.reloadKeys();
    },
    async reloadKeys() {
      this.reload = true;
      // wait 1 sec
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.reload = false;
    },
    keyRemoved(key) {
      if (this.generatedKey && key && key.name === this.generatedKey) {
        this.generatedKey = null;
        this.resetKeyGenerator();
      }
    },
    async resetKeyGenerator() {
      this.resetKeyGen = true;
      // wait 1 sec
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.resetKeyGen = false;
    },
    populateSharedKeys(event) {
      this.sharedApiKeys.push(...(event.keys || []));
    },
    populateOwnKeys(event) {
      this.apiKeys.push(...(event.keys || []));
    },
    async getShareUrl(key) {
      const response = await Utils.api("share-url", {
        name: key.name
      });
      if (response.error) {
        UI.error(t("Error getting share URL: {{response.error}}", {
          response
        }));
        return false;
      }
      navigator.clipboard.writeText(response.url);
      UI.info(t("Copied Share URL to clipboard"));
      return true;
    }
  },
  mounted() {
    // If the hash has `&added={uuid}`, show message with info about the new key.
    const hash = Utils.hashProps(window.location.hash);
    if (hash.added) {
      this.addedKeyId = hash.added;
      window.location.hash = "#api";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileBillingSection"] = Vue.component(
                    "ProfileBillingSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"Billing and Payment Details\") }} <div class=\"header-buttons\"> <b-button v-b-tooltip.hover variant=\"primary\" :disabled=\"loading\" class=\"float-right ml-2\" :title=\"loaded ? t('Refresh') : t('View balance')\" @click=\"loadContent\" > <i class=\"fas fa-sync-alt\"></i> </b-button> <payment-stripe-portal class=\"float-right\"></payment-stripe-portal> </div> </b-card-header> <b-card-body> <div class=\"w-100 text-right mb-2\"> <b-button variant=\"primary\" @click=\"showBilling = true\"> {{ t(\"Billing Details\") }} <i class=\"fas fa-edit\"></i> </b-button> <billing-manager v-model=\"showBilling\"></billing-manager> <b-button variant=\"primary\" @click=\"showPayment = true\"> {{ t(\"Payment Details\") }} <i class=\"fas fa-edit\"></i> </b-button> <payment-manager v-model=\"showPayment\"></payment-manager> </div> <b-alert v-if=\"balance !== 0\" show> <b-row> <b-col> <span v-if=\"balance > 0\"> <i18n :path=\" t( `You have a balance of {0} due on your account. It will be charged automatically on your next invoice.` ) \" tag=\"p\" > <strong>{{ balanceValue }}</strong> </i18n> </span> <span v-else-if=\"balance < 0\"> <i18n :path=\" t( `Your account has an available credit of {0} which will be used automatically on your next invoice.` ) \" tag=\"p\" > <strong>{{ balanceValue }}</strong> </i18n> </span> </b-col> </b-row> <b-row v-if=\"unpaidTotal > 0\" class=\"mt-2\"> <b-col> <div class=\"mt-1\"> <i18n :path=\"t('You have {0} unpaid invoices, totalling {1}.')\"> {{ unpaidInvoices.length }} <b>{{ unpaidTotalValue }}</b> </i18n> </div> </b-col> <b-col class=\"text-right\" md=\"auto\"> <payment-stripe-portal class=\"float-right btn-small\" :label=\"t('View invoices')\"> </payment-stripe-portal> </b-col> </b-row> </b-alert> <h5>{{ t(\"Upcoming invoice:\") }}</h5> <div v-if=\"!loaded\" v-b-tooltip.hover :title=\"invoiceTitle\" @click.prevent=\"fetchUpcomingInvoice\"> <b-skeleton-table :animation=\"(loading && 'wave') || null\" :rows=\"3\" :columns=\"1\"></b-skeleton-table> </div> <div v-else> <div v-if=\"!invoice\"> <p>{{ t(\"You do not have any upcoming invoice.\") }}</p> </div> <div v-else> <i18n :path=\" t( 'This is a preview of the invoice that will be billed on {0}. It may change if the subscription is updated.' ) \" tag=\"p\" > <strong>{{ invoiceDate }}</strong> </i18n> <payment-invoice :invoice=\"invoice\" :country=\"country\" :exchange-currency=\"currency\" :exchange-rates=\"exchangeRates\" ></payment-invoice> </div> </div> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ""
    });
  },
  data() {
    return {
      invoice: null,
      currency: "USD",
      country: null,
      exchangeRates: {},
      showBilling: false,
      showPayment: false,
      balance: null,
      unpaidInvoices: [],
      loaded: false,
      loading: false
    };
  },
  computed: {
    invoiceTitle() {
      return this.loading ? t("Retrieving upcoming invoice…") : t("View upcoming invoice");
    },
    invoiceDate() {
      return new Date(this.invoice.created * 1000).toDateString();
    },
    balanceValue() {
      return Utils.isNumeric(this.balance) ? `US$ ${Math.abs(this.balance.toFixed(2))}` : "";
    },
    unpaidTotal() {
      return this.unpaidInvoices.reduce((t, i) => t + i.total / 100, 0);
    },
    unpaidTotalValue() {
      return `US$ ${this.unpaidTotal.toFixed(2)}`;
    }
  },
  methods: {
    async loadContent() {
      this.fetchUpcomingInvoice();
      this.getBalance();
    },
    async fetchUpcomingInvoice() {
      if (this.loading) {
        return;
      }
      this.loaded = false;
      this.loading = true;
      const response = await Utils.api("profile/upcoming-invoice");
      if (response.success) {
        this.invoice = response.invoice;
        this.country = response.country;
        this.currency = response.currency || "USD";
        this.exchangeRates = response.exchangeRates || {
          USD: 1
        };
        this.loaded = true;
      } else {
        UI.alert("danger", t(`Error retrieving upcoming user invoice: {{- error}}`, {
          error: response.error || t("Unknown Error")
        }));
      }
      this.loading = false;
    },
    async getBalance() {
      this.balance = 0;
      const response = await Utils.api("profile/user-balance");
      if (response.success) {
        if (!Utils.isNumeric(response.balance)) {
          this.balance = 0;
          UI.alert("danger", t(`Error retrieving account balance: Invalid balance value`));
        } else {
          this.balance = response.balance;
        }
        this.unpaidInvoices = response.unpaid_invoices || [];
      } else {
        UI.alert("danger", t(`Error retrieving account balance: {{- error}}`, {
          error: response.error || t("Unknown Error")
        }));
      }
    },
    tabLoad() {
      if (this.loaded) {
        return;
      }
      this.loadContent();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCachedInformation"] = Vue.component(
                    "ProfileCachedInformation",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"Cached Browser Information\") }} <b-button size=\"sm\" variant=\"danger\" @click=\"clearAllCache(cachedInfo)\"> <i class=\"fas fa-trash\"></i> <span class=\"d-none d-lg-inline-block\">{{ t(\"Clear All\") }}</span> </b-button> </b-card-header> <b-card-body> <b-table :fields=\"fields\" :items=\"cachedInfo\" small bordered striped hover show-empty head-variant=\"light\"> <template #cell(actions)=\"row\"> <b-button size=\"sm\" variant=\"danger\" class=\"mx-2\" @click=\"clearCache(row.item)\"> <i class=\"fas fa-trash\"></i> <span class=\"d-none d-lg-inline-block\">{{ t(\"Clear\") }}</span> </b-button> </template> </b-table> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".size-column { width: 150px; } .actions-column { width: 8em; } .actions-column button { white-space: nowrap; }"
    });
  },
  props: {
    username: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fields: [{
        key: "name",
        label: t("Name"),
        class: "align-middle"
      }, {
        key: "size",
        label: t("Size"),
        class: "align-middle text-right size-column"
      }, {
        key: "actions",
        label: t("Actions"),
        class: "text-center actions-column"
      }],
      cacheKeys: [{
        id: "bazaarTags",
        displayName: t("Bazaar Tags")
      }, {
        id: "forge-bazaar-dndbeyond",
        displayName: t("DnD Beyond Data")
      }, {
        id: "forge-bazaar-packages",
        displayName: t("Forge Bazaar Packages")
      }, {
        id: `forge-bazaar-installs`,
        displayName: t("User Installs Information")
      }, {
        id: "patreon-pledges",
        displayName: t("Patreon cached pledges")
      }, {
        id: "assets-browser",
        displayName: t("Assets Browser Data")
      }],
      refreshCacheKeys: 0
    };
  },
  computed: {
    cachedInfo() {
      this.refreshCacheKeys; // This is here to force a refresh when the cache is cleared
      return this.cacheKeys.map(cacheKey => {
        const data = localStorage.getItem(cacheKey.id);
        switch (cacheKey.id) {
          case "patreon-pledges":
            {
              return {
                id: cacheKey.id,
                name: cacheKey.displayName,
                size: ""
              };
            }
          case "forge-bazaar-installs":
            {
              const installsKeys = Object.keys(localStorage).filter(key => key.startsWith("forge-bazaar-installs-"));
              let size = 0;
              for (const key of installsKeys) {
                size += JSON.stringify(localStorage.getItem(key)).length;
              }
              if (size === 0) {
                return null;
              }
              return {
                id: cacheKey.id,
                name: cacheKey.displayName,
                size: Utils.bytesToHuman(size)
              };
            }
          case "forge-bazaar-packages":
            {
              /**
               * @todo We can determine the size of the cached data from the
               *       size of the blob stored in the DB, but getting anything
               *       from the DB requires an async call.
               */
              return {
                id: cacheKey.id,
                name: cacheKey.displayName,
                size: ""
              };
            }
          case "assets-browser":
            {
              const assetsKeys = Object.keys(localStorage).filter(key => key.startsWith("asset"));
              let size = 0;
              for (const key of assetsKeys) {
                size += JSON.stringify(localStorage.getItem(key)).length;
              }
              if (size === 0) {
                return null;
              }
              return {
                id: cacheKey.id,
                name: cacheKey.displayName,
                size: Utils.bytesToHuman(size)
              };
            }
          default:
            {
              if (!data) {
                return null;
              }
              const size = Utils.bytesToHuman(JSON.stringify(data).length);
              return {
                id: cacheKey.id,
                name: cacheKey.displayName,
                size
              };
            }
        }
      }).filter(item => !!item);
    }
  },
  methods: {
    async clearCache(item) {
      switch (item.id) {
        case "patreon-pledges":
          {
            const clearPatreonPledgesResponse = await Utils.api("profile/clear/data", {
              dataType: "patreon"
            });
            if (clearPatreonPledgesResponse.message) {
              UI.info(clearPatreonPledgesResponse.message);
            } else {
              UI.error(clearPatreonPledgesResponse.error);
            }
            break;
          }
        case "forge-bazaar-packages":
          {
            window.indexedDB.deleteDatabase(globalThis.bazaarCachingKeys.db);
            localStorage.removeItem("forge-bazaar-last-update");
            localStorage.removeItem("forge-bazaar-schema");
            UI.info(t(`${item.name} has been successfully cleared.`));
            break;
          }
        case "forge-bazaar-installs":
          {
            const installsKeys = Object.keys(localStorage).filter(key => key.startsWith("forge-bazaar-installs-"));
            for (const key of installsKeys) {
              localStorage.removeItem(key);
            }
            UI.info(t(`${item.name} has been successfully cleared.`));
            break;
          }
        case "assets-browser":
          {
            const assetsKeys = Object.keys(localStorage).filter(key => key.startsWith("asset"));
            for (const key of assetsKeys) {
              localStorage.removeItem(key);
            }
            UI.info(t(`${item.name} has been successfully cleared.`));
            break;
          }
        default:
          {
            // Clear cache based on item
            localStorage.removeItem(item.id);
            UI.info(t(`${item.name} has been successfully cleared.`));
            this.refreshCacheKeys++;
          }
      }
    },
    clearAllCache(cachedInfo) {
      // Clear all cached items
      cachedInfo.forEach(item => {
        this.clearCache(item);
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileLicenseAdd"] = Vue.component(
                    "ProfileLicenseAdd",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"t('Add new Foundry VTT License')\" @ok.prevent=\"queryOk\" @hidden=\"visible = false\" @show=\"license = ''\" > <b-alert :show=\"!hasLicense\"> <i18n :path=\"t('In order to use The Forge hosting services, you will first need to have a valid {0} game license.')\" tag=\"p\" > <a href=\"http://foundryvtt.com\">{{ t(\"Foundry VTT\") }}</a> </i18n> <em>{{ t(\"At the moment, you can only purchase new license keys directly from the Foundry VTT website.\") }}</em> </b-alert> <b-form-group label-cols=\"6\" content-cols=\"6\" :label=\"t('Enter your License Key:')\" :invalid-feedback=\"errorLicense\" :state=\"errorLicense === ''\" > <b-form-input v-model=\"license\" autofocus @keydown=\"errorLicense = ''\"></b-form-input> </b-form-group> <hr /> <p> <i18n :path=\" t( 'Having more than one license would allow you to run more than one game simultaneously if you have the Game Manager {0} enabled (requires Story Teller subscription or higher)' ) \" tag=\"i\" > <a href=\"https://forums.forge-vtt.com/t/the-game-manager/11004\" target=\"_blank\"> <small><i class=\"fas fa-question-circle\"></i></small> </a> </i18n> </p> <template #modal-footer=\"{ ok, cancel }\"> <b-row class=\"w-100\"> <b-col class=\"text-left pl-0\"> <a class=\"btn btn-info float-left\" href=\"https://foundryvtt.com/purchase/\" target=\"_blank\"> {{ t(\"Open Foundry VTT Purchasing\") }} </a> </b-col> <b-col class=\"text-right pr-0\"> <b-button variant=\"primary\" :disabled=\"!validKey || processing\" @click=\"ok\"> <loading-indicator v-if=\"processing\" tag=\"span\" small :label=\"t('Processing…')\"></loading-indicator> <template v-else> {{ t(\"Add License\") }} </template> </b-button> <b-button variant=\"secondary\" @click=\"cancel\"> {{ t(\"Cancel\") }} </b-button> </b-col> </b-row> </template> </b-modal>",
  props: {
    value: Boolean,
    hasLicense: Boolean
  },
  data() {
    return {
      license: "",
      errorLicense: "",
      processing: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    validKey() {
      const key = this.license.toUpperCase().trim().replace(/-/g, "");
      return /^([A-Z0-9]{24})$/.test(key);
    }
  },
  methods: {
    queryKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.queryOk();
        this.visible = false;
      }
    },
    async queryOk() {
      if (this.license !== "") {
        const response = await this.addLicense(this.license);
        if (response === true) {
          this.visible = false;
        }
      }
    },
    async addLicense(license) {
      const key = license.toUpperCase().trim().replace(/-/g, "");
      if (!/^([A-Z0-9]{24})$/.test(key)) {
        this.errorLicense = t("Invalid license key");
        return false;
      }
      this.processing = true;
      const response = await Utils.api("license/add", {
        license: key
      });
      this.processing = false;
      if (response.error) {
        this.errorLicense = Utils.t_vue("Error adding license: {{error}}", {
          error: `${response.error}`
        });
        return false;
      }
      UI.alert("success", t("New license key added to user account."), true, 10000);
      this.$emit("addLicense", response.license);
      return true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileManager"] = Vue.component(
                    "ProfileManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-tabs v-model=\"tabIndex\" pills card vertical class=\"profile-manager-tabs\" nav-wrapper-class=\"col-sm-auto container-sm\" @input=\"changeTab\" > <b-tab :title=\"t('User Profile')\"> <b-card-text> <profile-user-profile ref=\"profile-user-profile\" :user=\"userData\" :region=\"region\" :themes=\"themes\" :avatar=\"avatar\" @update=\"updateUserInfo\" ></profile-user-profile> </b-card-text> </b-tab> <!-- Notification Tab --> <b-tab :title=\"t('Notifications')\"> <b-card-text> <profile-notification-list></profile-notification-list> </b-card-text> </b-tab> <b-tab :title=\"t('License & Subscriptions')\"> <b-card-text> <profile-membership-information-section :membership=\"membership\" :tier=\"tier\" :subscriptions=\"subscriptions\" :trial-days=\"trialDays\" :tiers=\"tiers\" :extras=\"extras\" :licenses=\"licenses\" :quotas=\"quotas\" ></profile-membership-information-section> </b-card-text> </b-tab> <b-tab :title=\"t('Account Information')\" lazy> <b-card-text> <profile-account-information :user=\"userData\" @update=\"updateUserInfo\"></profile-account-information> </b-card-text> </b-tab> <b-tab :title=\"t('Linked Accounts')\" lazy> <b-card-text> <profile-account-linked-accounts :external=\"external\"></profile-account-linked-accounts> </b-card-text> </b-tab> <b-tab :title=\"t('Server Region')\"> <b-card-text> <profile-server-region ref=\"profileServerRegion\" :user=\"userData\" :region=\"region\"></profile-server-region> </b-card-text> </b-tab> <b-tab v-if=\"user.isCreator\" :title=\"t('Content Creator Profile')\"> <b-card-text> <profile-creator-section ref=\"profileCreatorSection\" :creator=\"user.isCreator\" :creator-integration=\"creatorIntegration\" :loading-integrations=\"loadingIntegrations\" @remove=\"removeIntegration\" @reload=\"loadIntegrations\" ></profile-creator-section> </b-card-text> </b-tab> <b-tab :title=\"t('API Key Manager')\" lazy> <b-card-text> <profile-api-key-manager-section></profile-api-key-manager-section> </b-card-text> </b-tab> <b-tab :title=\"t('Patreon')\" lazy> <b-card-text> <profile-patreon-section :patreon=\"external.patreon\"></profile-patreon-section> </b-card-text> </b-tab> <b-tab :title=\"t('Purchases')\"> <b-card-text> <profile-purchases-section id=\"purchases\" ref=\"profilePurchasesSection\"></profile-purchases-section> </b-card-text> </b-tab> <b-tab :title=\"t('Billing and Payment')\"> <b-card-text> <profile-billing-section id=\"billing\" ref=\"profileBillingSection\"></profile-billing-section> </b-card-text> </b-tab> <b-tab :title=\"t('Cached Information')\"> <b-card-text> <profile-cached-information id=\"cachedinfo\" :username=\"user.username\"></profile-cached-information> </b-card-text> </b-tab> </b-tabs> </b-card>",
  props: {
    user: Object,
    region: String,
    themes: Object,
    avatar: String,
    external: Object,
    membership: Object,
    tier: Number,
    subscriptions: Array,
    trialDays: Number,
    tiers: Object,
    extras: Object,
    licenses: Array,
    quotas: Object
  },
  data() {
    return {
      userData: null,
      loadingIntegrations: false,
      userIntegrations: null,
      creatorIntegration: null,
      tabIndex: 0,
      tabs: ["profile", "notifications", "membership", "account", "links", "region", "creator", "api", "patreon", "purchases", "billing", "cachedinfo"]
    };
  },
  computed: {
    showTabs() {
      return this.user.isCreator ? this.tabs : this.tabs.filter(t => t != "creator");
    }
  },
  methods: {
    checkTabIndex() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        for (let idx = 0; idx < this.showTabs.length; idx++) {
          if (this.showTabs[idx] in hash) {
            this.tabIndex = idx;
            break;
          }
        }
      }
    },
    changeTab(tab) {
      window.location.hash = `${this.showTabs[tab]}`;
      this.tabLoad();
    },
    tabLoad() {
      switch (this.showTabs[this.tabIndex]) {
        case "creator":
          console.log("Preload creator");
          const creator = this.$refs.profileCreatorSection;
          creator.tabLoad();
          break;
        case "purchases":
          console.log("Preload purchases");
          const purchases = this.$refs.profilePurchasesSection;
          purchases.tabLoad();
          break;
        case "billing":
          console.log("Preload billing");
          const billing = this.$refs.profileBillingSection;
          billing.tabLoad();
          break;
        case "region":
          console.log("Preload region");
          const region = this.$refs.profileServerRegion;
          region.tabLoad();
          break;
      }
    },
    updateUserInfo(data) {
      Object.assign(this.userData, data);
    },
    async loadIntegrations() {
      this.loadingIntegrations = true;
      const response = await Utils.api("profile/integrations");
      if (response.success) {
        this.userIntegrations = response;
      } else {
        UI.alert("danger", t("Error retrieving integration information: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      }
      if (this.user.isCreator) {
        const response2 = await Utils.api("profile/creator/integrations");
        if (response2.success) {
          this.creatorIntegration = response2;
        } else {
          UI.alert("danger", t("Error retrieving integration information: {{- error}}", {
            error: response2.error || t("Unknown Error")
          }));
        }
      }
      this.loadingIntegrations = false;
    },
    async removeIntegration(item) {
      const response = await Utils.api(`bazaar/creator`, {
        action: "remove-integration",
        type: item.type,
        name: item.name
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t("Error setting package configuration: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      } else {
        this.loadIntegrations();
      }
    }
  },
  created() {
    this.userData = this.user;
    this.checkTabIndex();
  },
  mounted() {
    this.tabLoad();
    this.loadIntegrations();
    // This is here so that on mobile displays the menu fills the width of the screen
    $(".profile-manager-tabs > .col-auto").removeClass("col-auto");
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileMembershipInformationSection"] = Vue.component(
                    "ProfileMembershipInformationSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header> {{ t(\"Subscription Information\") }} <help-icon url=\"https://forums.forge-vtt.com/t/how-to-add-change-a-subscription-on-the-forge/13204\" :tooltip=\"t('How to add/change/cancel your subscription on the Forge')\" ></help-icon> </b-card-header> <b-card-body> <b-row> <b-col class=\"membership-column\"> <profile-subscription-section ref=\"ProfileSubscriptionSection\" :membership=\"membership\" :user-tier=\"tier\" :subscriptions=\"subscriptions\" :trial-days=\"trialDays\" :tiers=\"tiers\" :extras=\"extras\" @open-license=\"showAddLicense = true\" > </profile-subscription-section> </b-col> <b-col class=\"membership-column\"> <b-row> <b-card-text class=\"mb-2\">{{ t(\"Foundry VTT Licenses:\") }}</b-card-text> </b-row> <b-row> <b-container v-if=\"licensesShown.length > 0\" fluid> <b-list-group flush> <b-list-group-item v-for=\"license in licensesShown\" :key=\"license.key\" class=\"border-bottom-0 p-0 pb-1\"> <b-input-group size=\"sm\"> <template #prepend> <b-input-group-text class=\"license-type\"> {{ license.type }} <i v-if=\"license.isDemo\" :class=\"stopwatchIcon(license)\"></i> </b-input-group-text> <b-badge v-if=\"!license.valid\" variant=\"danger\" class=\"license-badge\"> {{ invalidTitle(license) }} </b-badge> </template> <template> <b-form-input v-model=\"license.key\" :class=\"inputClass(license)\" :type=\"license.inputType\" disabled /> </template> <template v-if=\"!license.isDemo\" #append> <information-toggle v-model=\"license.inputType\" :noun=\"t('Foundry license')\"></information-toggle> <b-button variant=\"outline-danger\" class=\"license-button\" :title=\"t('Click to remove license')\" @click.prevent=\"confirmDelete(license)\" > <i class=\"fa fa-trash\" aria-hidden=\"true\"></i> </b-button> </template> </b-input-group> </b-list-group-item> </b-list-group> </b-container> <b-alert v-else-if=\"tier > 0\" variant=\"danger\" show class=\"mt-3\"> <i18n :path=\" t( 'In order to use The Forge hosting services, you will first need to have a valid Foundry VTT game license. {0}Select the {1} button above to add your license to your account.' ) \" tag=\"p\" > <br /> <code>{{ t(\"Add Licenses\") }}</code> </i18n> </b-alert> </b-row> <b-row class=\"text-center\"> <b-col class=\"mt-3\"> <b-button class=\"profile-button\" variant=\"primary\" @click=\"showAddLicense = true\"> {{ t(\"Add Licenses\") }} </b-button> </b-col> </b-row> </b-col> </b-row> <hr /> <b-card-text>{{ t(\"Quotas:\") }}</b-card-text> <quota-list :quotas=\"quotas\"></quota-list> </b-card-body> <profile-license-add v-model=\"showAddLicense\" :has-license=\"hasLicense\" @addLicense=\"addLicense\" ></profile-license-add> <confirm-delete-with-code v-model=\"showDeleteDialog\" :name=\"t('License Key')\" :code=\"licenseToDelete\" :verb=\"t('Remove')\" :what=\"t('the license key')\" :placeholder=\"t('Confirm License Key')\" :follow-up=\" t( 'Please note that once deleted, you will no longer be able to run games with this license unless it has been added back.' ) \" @delete=\"deleteLicense\" ></confirm-delete-with-code> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".membership-column { min-width: 360px; } .license-badge { line-height: 24px; border-radius: 0px; } .license-button { width: 46px; }"
    });
  },
  props: {
    membership: Object,
    tier: Number,
    subscriptions: Array,
    trialDays: Number,
    tiers: Object,
    extras: Object,
    licenses: Array,
    quotas: Object
  },
  data() {
    return {
      licensesShown: [],
      licenseToDelete: null,
      showAddLicense: false,
      showDeleteDialog: false
    };
  },
  computed: {
    licenseBadge() {
      return this.licenses.length > 0 ? "success" : "warning";
    },
    hasLicense() {
      return this.licenses.filter(l => {
        return l.valid && !l.isDemo;
      }).length > 0;
    }
  },
  methods: {
    stopwatchIcon(license) {
      return `fas fa-stopwatch text-${license.valid ? "success" : "danger"} ml-1`;
    },
    invalidTitle(license) {
      return license.isDemo ? t("EXPIRED") : t("INVALID");
    },
    inputClass(license) {
      return "form-control" + (!license.valid ? " text-danger" : "");
    },
    confirmDelete(license) {
      this.licenseToDelete = license.key;
      this.showDeleteDialog = true;
    },
    addLicense(license) {
      //refresh licenses
      this.licensesShown.push({
        ...license,
        inputType: license.isDemo ? "text" : "password"
      });
      // If the subscription dialog is open, then reset it
      this.$refs["ProfileSubscriptionSection"].resetSubscriptionDialog();
    },
    async deleteLicense(key) {
      if (key !== this.licenseToDelete) {
        return;
      }
      const response = await Utils.api("license/rm", {
        license: key
      });
      if (!response || response.error) {
        UI.alert("danger", t(`Error deleting license: {{- error}}`, {
          error: response ? response.error : t("Unknown Error")
        }), true, 10000);
      } else {
        UI.alert("success", t(`License removed successfully.`), true, 10000);
        const idx = this.licensesShown.findIndex(p => p.key === key);
        if (idx !== -1) {
          this.licensesShown.splice(idx, 1);
        }
      }
    }
  },
  created() {
    this.licensesShown = this.licenses.map(l => ({
      ...l,
      inputType: l.isDemo ? "text" : "password"
    }));
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileNotificationList"] = Vue.component(
                    "ProfileNotificationList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @typedef {import("../../common/types.d").Notification} Notification
 * @typedef {import("../../common/types.d").PaginatedResponse} PaginatedResponse
 */
var _default = exports.default = {
  template: "<section> <b-card no-body> <b-card-header> {{ t(\"Notifications\") }} <!-- Right aligned \"Mark all as Read button\" --> <b-button class=\"float-right\" :disabled=\"markingAsRead\" variant=\"outline-primary\" size=\"sm\" @click=\"markAsRead()\" > <b-spinner v-if=\"markingAsRead\" small :label=\"t('Loading…')\" class=\"mr-1\" variant=\"primary\"></b-spinner> {{ t(\"Mark all as read\") }} </b-button> </b-card-header> <b-card-body class=\"p-0 profile-notification-list\"> <div v-if=\"hasNewNotifications\" class=\"card-header text-center p-2 profile-notification-list__new-notifications\" > {{ t(\"There are new notifications available.\") }} <b-button variant=\"link\" @click=\"refreshNotifications\"> {{ t(\"Refresh notifications\") }} </b-button> </div> <lazy-loading-list ref=\"lazyLoadingNotificationList\" :load-function=\"loadNotificationPage\"> <template #entry=\"{ item }\"> <notification-card :img=\"item.display.picture\" :from=\"item.display.from\" :title=\"item.title\" :snippet=\"item.snippet\" :content=\"item.content\" :url=\"item.url\" :date=\"new Date(item.timestamp)\" :is-unread=\"item.isUnread\" :is-sender-verified=\"item.isSenderVerified\" ></notification-card> </template> <template #spinner> <b-spinner :label=\"t('Loading…')\" class=\"my-3\" variant=\"primary\"></b-spinner> </template> </lazy-loading-list> </b-card-body> </b-card> </section>",
  beforeCreate() {
    Utils.loadCss({
      content: ".profile-notification-list { height: calc(100vh - 200px); position: relative; overflow-y: auto; .notification-container { border-bottom: 1px solid rgba(0, 0, 0, 0.25) !important; padding: 0rem; } } .profile-notification-list__new-notifications { border-bottom: 1px solid rgba(0, 0, 0, 0.25); position: sticky; width: 100%; top: 0; z-index: 1; transition: background-color 0.3s ease; } .theme--default .profile-notification-list__new-notifications.card-header { background-color: #f7f7f7; }"
    });
  },
  data: () => ({
    markingAsRead: false,
    hasNewNotifications: false,
    newestNotificationTimestamp: Date.now()
  }),
  methods: {
    /**
     * Load a page of notifications
     * @param {object} pageOptions - The page and limit to load
     * @param {number} pageOptions.page - The page number to load
     * @param {number} pageOptions.limit - The number of items to load per page
     * @returns {Promise<PaginatedResponse<Notification>>} - The paginated response of notifications
     */
    async loadNotificationPage({
      page,
      limit
    }) {
      return Utils.api(`notifications?page=${page}&limit=${limit}`);
    },
    /**
     * Mark all notifications as read
     * @returns {Promise<void>} - A promise that resolves when the notifications are marked as read
     * @throws {Error} - Throws an error if the API call fails
     */
    async markAsRead() {
      this.markingAsRead = true;
      const response = await Utils.api("notifications/mark-read", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.markingAsRead = false;
      if (response.success === true) {
        this.refreshNotifications();
      } else {
        this.$bvToast.toast(this.t("Error marking notifications as read"), {
          toaster: "b-toaster-bottom-right",
          title: this.t("Error"),
          variant: "danger"
        });
      }
    },
    /**
     * Handle notification updates
     * @param {CustomEvent} event - The event containing the notification update
     * @returns {void}
     */
    handleNotificationUpdate(event) {
      const {
        newestNotificationTimestamp,
        source
      } = event.detail;
      if (source === "profile-notification-list") {
        return;
      }
      if (Date.parse(newestNotificationTimestamp) > this.newestNotificationTimestamp) {
        this.hasNewNotifications = true;
        this.newestNotificationTimestamp = newestNotificationTimestamp;
      }
    },
    /**
     * Refresh the notification list component
     * @returns {void}
     */
    refreshNotifications() {
      this.hasNewNotifications = false;
      window.dispatchEvent(new CustomEvent("notification-drawer:refreshed", {
        detail: {
          source: "profile-notification-list"
        }
      }));
      this.$refs.lazyLoadingNotificationList.refresh();
    }
  },
  unmounted() {
    window.removeEventListener("notification-drawer:refreshed", this.handleNotificationUpdate);
  },
  mounted() {
    window.addEventListener("notification-drawer:refreshed", this.handleNotificationUpdate);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfilePatreonSection"] = Vue.component(
                    "ProfilePatreonSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"Patreon Information\") }} <div class=\"header-buttons\"> <b-button v-if=\"patreon.linked\" v-b-tooltip.hover variant=\"primary\" :title=\"t('Refresh Pledges')\" @click=\"linkPatreon\" > <i class=\"fas fa-sync-alt\"></i> </b-button> </div> </b-card-header> <b-card-body> <b-row> <b-col> <b-form-group label-cols=\"3\" :label=\"t('Patreon')\" label-for=\"patreon\"> <b-input-group> <b-form-input :value=\"patreon.username\" name=\"patreon\" disabled></b-form-input> <template #append> <b-button v-if=\"!patreon.linked\" variant=\"secondary\" @click=\"linkPatreon\"> <i18n :path=\"t('Link with {0}')\"> <strong>{{ t(\"Patreon\") }}</strong> </i18n> </b-button> <b-button v-else variant=\"secondary\" @click=\"unlinkPatreon\"> <i18n :path=\"t('Unlink {0}')\"> <strong>{{ t(\"Patreon\") }}</strong> </i18n> </b-button> </template> </b-input-group> </b-form-group> <div v-if=\"patreon.linked && patreon.pledges.length\" class=\"accordion\"> <b-card no-body> <b-card-header> {{ t(\"Patreon Pledges\") }} </b-card-header> <b-card-body> <b-table striped hover :items=\"patreon.pledges\" :fields=\"fields\" :tbody-tr-class=\"rowClass\" @row-clicked=\"openPatreon\" > <template #cell(lifetime_contribution)=\"data\"> <span v-if=\"data.item.creator || data.value === 0\" class=\"text-muted\">-</span> <span v-else> <small class=\"text-muted\">{{ data.item.currency || \"$\" }}</small> {{ data.value }} </span> </template> <template #cell(tiers)=\"data\"> <b-badge v-for=\"tier in data.value\" :key=\"tier.title\" class=\"mr-2\"> {{ tier.title }} </b-badge> </template> </b-table> </b-card-body> </b-card> </div> </b-col> </b-row> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".patreon-button { width: 200px; }"
    });
  },
  props: {
    patreon: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      fields: [{
        key: "vanity",
        label: t("Creator")
      }, {
        key: "lifetime_contribution",
        label: t("Contribution")
      }, {
        key: "tiers",
        label: t("Tiers")
      }]
    };
  },
  computed: {
    hasChanges() {
      return false;
    }
  },
  methods: {
    async linkPatreon() {
      window.location = `/account/auth/patreon?returnToHash=${window.location.hash.slice(1)}`;
    },
    async unlinkPatreon() {
      const result = await Utils.api("profile/account/unlink-patreon", {});
      if (!result.success) {
        const error = result.error || t("Error communicating with server");
        UI.alert("danger", error, true);
        throw new Error(error);
      } else {
        UI.alert("success", t("Patreon has been unlinked"), false, 10000);
        setTimeout(() => window.location.reload(), 2000);
      }
    },
    openPatreon(row) {
      window.open(row.url, "_blank");
    },
    rowClass(item, type) {
      if (type === "row" && item && item.creator) {
        return "table-primary";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfilePurchasesSection"] = Vue.component(
                    "ProfilePurchasesSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"My Content Purchases\") }} <div class=\"header-buttons\"> <b-button v-b-tooltip.hover variant=\"primary\" :disabled=\"loading\" class=\"float-right ml-2\" :title=\"loaded ? t('Refresh') : t('View purchases')\" @click.prevent=\"loadContent\" > <i v-if=\"loaded\" class=\"fas fa-sync-alt\"></i> <i v-else class=\"fas fa-eye\"></i> </b-button> <payment-stripe-portal class=\"float-right\"></payment-stripe-portal> </div> </b-card-header> <b-card-body> <div v-if=\"!loaded\" v-b-tooltip.hover :title=\"loading ? t('Loading…') : t('Click to view')\"> <b-skeleton-table :animation=\"(loading && 'wave') || null\" :rows=\"3\" :columns=\"1\"></b-skeleton-table> </div> <div v-else> <b-alert v-if=\"balance !== 0\" show> <i18n v-if=\"balance > 0\" :path=\" t('You have a balance of {0} due on your account. It will be charged automatically on your next invoice.') \" > <strong>{{ balanceValue }}</strong> </i18n> <i18n v-else :path=\" t('Your account has an available credit of {0} which will be used automatically on your next invoice.') \" > <strong>{{ balanceValue }}</strong> </i18n> </b-alert> <div v-if=\"purchases.length === 0\"> <i18n :path=\"t('You did not purchase any content. Visit the {0} and check out our Premium content.')\" tag=\"p\"> <a href=\"/bazaar#price=marketplace\">{{ t(\"Bazaar\") }}</a> </i18n> <i18n :path=\"t('You can also purchase a Gift Card 🎁 from {0}.')\" tag=\"p\"> <a href=\"/bazaar#forge=forge-gift-card\">{{ t(\"here\") }}</a> </i18n> </div> <div v-else> <profile-purchases-table v-if=\"myPurchases.length > 0\" :label=\"t('My Purchases')\" :purchases=\"myPurchases\" ></profile-purchases-table> <profile-purchases-table v-if=\"myReceivedGifts.length > 0\" :label=\"t('My received Gifts')\" :purchases=\"myReceivedGifts\" ></profile-purchases-table> <profile-purchases-table v-if=\"mySentGifts.length > 0\" :label=\"t('My sent Gifts')\" :purchases=\"mySentGifts\" ></profile-purchases-table> </div> </div> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ""
    });
  },
  data() {
    return {
      purchases: [],
      balance: 0,
      loaded: false,
      loading: false
    };
  },
  computed: {
    myPurchases() {
      return this.purchases.filter(p => !p.gift);
    },
    myReceivedGifts() {
      return this.purchases.filter(p => p.gift && p.owner);
    },
    mySentGifts() {
      return this.purchases.filter(p => p.gift && !p.owner);
    },
    balanceValue() {
      return Utils.isNumeric(this.balance) ? `US$ ${Math.abs(this.balance.toFixed(2))}` : "";
    }
  },
  methods: {
    async loadContent() {
      if (this.loading) {
        return;
      }
      this.loaded = false;
      this.loading = true;
      const response = await Utils.api("profile/purchases");
      if (response.success) {
        this.purchases = response.purchases || [];
        this.balance = response.balance || 0;
        this.loaded = true;
      } else {
        UI.alert("danger", t(`Error retrieving profile information: {{- error}}`, {
          error: response.error || t("Unknown Error")
        }));
      }
      this.loading = false;
    },
    tabLoad() {
      if (this.loaded) {
        return;
      }
      this.loadContent();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfilePurchasesTable"] = Vue.component(
                    "ProfilePurchasesTable",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <h5 v-if=\"label\">{{ label }}</h5> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" class=\"purchases-table\" :items=\"purchases\" :fields=\"purchasesFields\" > <template #cell(content)=\"{ item }\"> <a :href=\"`/bazaar#package=${item.name}`\" target=\"_blank\"> {{ item.title }} </a> </template> <template #cell(gift)=\"{ item }\"> <span v-if=\"item.owner\"> {{ item.message }} </span> <span v-else-if=\"item.claimed\" v-b-tooltip.hover class=\"text-success\" :title=\"t('Gift claimed!')\" ><i class=\"fas fa-check-square\"></i ></span> <a v-else-if=\"item.gift\" v-b-tooltip.hover :href=\"`/bazaar/claim/${item.gift}`\" target=\"_blank\" class=\"text-success\" :title=\"t('Share your Gift now')\" ><i class=\"fas fa-hand-holding-heart\"></i ></a> </template> <template #cell(invoice)=\"{ value }\"> <a v-if=\"value\" v-b-tooltip.hover href=\"#\" title=\"View Invoice\" @click.prevent=\"openInvoice(value)\"> <i class=\"fas fa-external-link-alt\"></i> </a> </template> <template #cell(download)=\"{ item, value }\"> <template v-if=\"value && item.hasManifest\"> <a v-b-tooltip.hover :href=\"`/bazaar/manifest/${item.name}.json?key=${item.download}`\" :title=\"t('Copy Manifest URL')\" target=\"_blank\" @click.prevent=\"copyLinkToClipboard\" > <i class=\"fas fa-link\"></i> </a> <span> | </span> </template> <a v-if=\"value\" v-b-tooltip.hover :href=\"`/bazaar/download/${item.name}.zip?key=${item.download}`\" :title=\"t('Download ZIP Content')\" target=\"_blank\" > <i class=\"fas fa-download\"></i> </a> </template> </b-table> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".purchases-table .date-field { width: 250px; } .purchases-table .price-field { width: 200px; } .purchases-table .button-field { width: 100px; }"
    });
  },
  props: {
    label: {
      type: String
    },
    purchases: {
      type: Array,
      default: []
    }
  },
  data() {
    return {};
  },
  computed: {
    purchasesFields() {
      const fields = [{
        key: "date",
        label: t("Purchase date"),
        formatter: (value, key, item) => {
          return new Date(value).toDateString();
        },
        thClass: ["date-field"]
      }, {
        key: "content",
        label: t("Content")
      }, {
        key: "price",
        label: t("Price"),
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        },
        thClass: ["price-field"]
      }];
      if (this.purchases.some(p => p.gift)) {
        fields.push({
          key: "gift",
          label: "🎁",
          thClass: ["text-center", "button-field"],
          tdClass: ["text-center"]
        });
      }
      if (this.purchases.some(p => p.download)) {
        fields.push({
          key: "download",
          label: t("Download"),
          thClass: ["text-center", "button-field"],
          tdClass: ["text-center"]
        });
      }
      if (this.purchases.some(p => p.invoice)) {
        fields.push({
          key: "invoice",
          label: t("Invoice"),
          thClass: ["text-center", "button-field"],
          tdClass: ["text-center"]
        });
      }
      return fields;
    }
  },
  methods: {
    async openInvoice(invoice) {
      const response = await Utils.api("subscription/payment", {
        stripe: {
          invoice
        }
      });
      if (!response.url) {
        return UI.alert("danger", response.error || t("Error communicating with server"));
      }
      window.open(response.url, "_blank");
    },
    async shareGift(purchase) {
      window.open(`/bazaar/claim/${purchase.gift}`, "_blank");
    },
    copyLinkToClipboard(event) {
      Utils.copyToClipboard(event.target.closest("a").href);
      UI.alert("info", t("Manifest URL copied to clipboard"), true, 5000);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileServerRegion"] = Vue.component(
                    "ProfileServerRegion",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header>{{ t(\"Server Region\") }}</b-card-header> <b-card-body> <p class=\"mx-2\"> {{ t( \"The Forge is offered in multiple regions. Choosing a server closer to you will help lower the latency and responsiveness of the VTT itself.\" ) }} </p> <p class=\"mx-2\"> {{ t( \"Regardless of your choice, however, the Assets Library will always be geo-distributed and available from over 200 different locations around the world at all times.\" ) }} </p> <div class=\"form-group w-100\"> <b-list-group> <b-list-group-item> <b-row> <b-col class=\"p-2\">{{ t(\"Assets Library (200+ locations)\") }}</b-col> <b-col md=\"auto\" class=\"p-2\"> <b-badge v-if=\"assets.latency || assets.pinging\" variant=\"light\" class=\"ping-result\"> <div v-if=\"assets.pinging\" class=\"spinner-grow spinner-grow-sm\" role=\"status\"></div> <span v-else>{{ assets.latency }} ms</span> </b-badge> </b-col> <b-col md=\"auto\"> <b-button variant=\"info\" size=\"sm\" class=\"float-right mt-1 ping-btn\" :disabled=\"assets.pinging\" @click.prevent=\"pingServer(null, $event)\" > <span v-if=\"!assets.pinging\">{{ t(\"Test Latency\") }}</span> <span v-else>{{ t(\"Pinging\") }}</span> </b-button> </b-col> </b-row> </b-list-group-item> </b-list-group> </div> <div class=\"region-selector-body w-100\"> <div v-if=\"loading\" class=\"text-center\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Looking for servers, please wait…\") }} </div> <div v-else> <div class=\"form-group\"> <label for=\"region\" class=\"col-sm-3 col-form-label\"> {{ t(\"Select a region\") }} </label> <b-list-group> <b-list-group-item v-for=\"region in availableRegions\" :key=\"region.id\"> <b-row> <b-col md=\"auto\" class=\"p-2\"> <b-form-radio v-model=\"userRegion\" name=\"region\" :value=\"region.id\" :disabled=\"!region.available\" ></b-form-radio> </b-col> <b-col class=\"p-2\"> {{ region.name }} <b-badge v-if=\"region.id === user.region\" variant=\"primary\">{{ t(\"current\") }}</b-badge> </b-col> <b-col md=\"auto\" class=\"p-2\"> <b-badge v-if=\"region.latency || region.pinging\" variant=\"light\" class=\"ping-result\"> <div v-if=\"region.pinging\" class=\"spinner-grow spinner-grow-sm\" role=\"status\"></div> <span v-else>{{ region.latency }} ms</span> </b-badge> </b-col> <b-col md=\"auto\"> <b-button v-if=\"region.available\" variant=\"info\" size=\"sm\" class=\"float-right mt-1 ping-btn\" :disabled=\"region.pinging\" @click.prevent=\"pingServer(region, $event)\" > <span v-if=\"!region.pinging\">{{ t(\"Test Latency\") }}</span> <span v-else>{{ t(\"Pinging\") }}</span> </b-button> <b-button v-else variant=\"warning\" size=\"sm\" class=\"float-right mb-1 ping-btn no-click\" disabled> {{ t(\"Not available\") }} </b-button> </b-col> </b-row> </b-list-group-item> </b-list-group> </div> <b-alert :show=\"!!migrationMessage\" variant=\"info\"> <b-spinner small class=\"align-middle\"></b-spinner> {{ migrationMessage }} </b-alert> <b-alert :show=\"!migrationMessage && hasChanges\" variant=\"warning\"> {{ t( \"Please note that changing your server selection will take a few minutes, during which you will not be able to access your data or launch games.\" ) }} </b-alert> </div> </div> <hr /> <b-row> <b-col> <b-button variant=\"primary\" class=\"profile-button\" :disabled=\"!hasChanges || saving\" @click.prevent=\"saveUserRegion\" > <i class=\"fas fa-save\"></i> <span v-if=\"!saving\">{{ t(\"Update region\") }}</span> <span v-else>{{ t(\"Saving…\") }}</span> </b-button> </b-col> </b-row> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".ping-btn { width: 100px; font-size: 12px; } .no-click { cursor: default; }"
    });
  },
  props: {
    user: Object,
    region: String
  },
  data() {
    return {
      saving: false,
      loaded: false,
      loading: false,
      userRegion: null,
      regions: [],
      assets: {
        pinging: false,
        pings: [],
        latency: null
      },
      migrationMessage: null
    };
  },
  computed: {
    hasChanges() {
      return this.user.region.localeCompare(this.userRegion) !== 0;
    },
    availableRegions() {
      return this.regions.sort((a, b) => {
        if (a.available && !b.available) {
          return -1;
        }
        if (b.available && !a.available) {
          return 1;
        }
        return a.name - b.name;
      });
    },
    regionName() {
      const region = this.regions.find(r => r.id === this.userRegion);
      return region ? region.name : this.region;
    }
  },
  methods: {
    tabLoad() {
      if (this.loaded) {
        return;
      }
      this.loadContent();
    },
    async loadContent() {
      if (this.loading) {
        return;
      }
      this.loaded = false;
      this.loading = true;
      this.regions = await Utils.api("regions");
      if (this.regions.error) {
        return UI.alert("danger", t(`Error retreiving list of available regions: {{error}}`, {
          error: this.regions.error
        }), false, 10000);
      }
      this.regions = this.regions.map(r => ({
        ...r,
        pinging: false,
        pings: [],
        latency: null
      }));
      this.loaded = true;
      this.loading = false;
    },
    async saveUserRegion() {
      this.saving = true;
      if (this.userRegion !== this.user.region) {
        this.migrationMessage = t("Preparing to migrate the data to the new region");
        const response = await Utils.apiTask("profile/set-region", {
          region: this.userRegion
        }, null, {
          status: (status, response) => {
            this.migrationMessage = {
              files: t("Migrating your data to the new region"),
              cleanup: t("Finishing the region migration")
            }[status] || t("Preparing to migrate the data to the new region");
          }
        });
        this.migrationMessage = null;
        if (!response || response.error) {
          UI.alert("danger", t(`Error setting region: {{error}}`, {
            error: response ? response.error : t("Unknown Error")
          }), false, 10000);
          this.saving = false;
        } else {
          UI.alert("success", response.message || t(`Region transfer complete, you will be automatically redirected…`), false, 3000);
          setTimeout(() => window.location.reload(), 1000);
        }
      }
    },
    changeRegion(region) {
      this.userRegion = region;
    },
    async pingServer(region, ev) {
      const url = region ? `https://ping.${region.domain}/api/ping` //ping a region
      : "https://assets.forge-vtt.com/favicon.ico"; //ping the asset server
      region = region || this.assets;
      region.pinging = true;
      console.log("Pinging: ", url);
      region.pings = [];
      for (let i = 0; i < 10; i++) {
        region.pings.push(await this.ping(url));
      }
      region.latency = Math.min(...region.pings);
      console.log(t(`Ping results ({{region.latency}} ms): {{region.pings}}`, {
        region
      }));
      region.pinging = false;
    },
    async ping(url) {
      const start = Date.now();
      await fetch(url, {
        cache: "no-cache",
        method: "HEAD"
      }).catch(console.error);
      const end = Date.now();
      return end - start;
    }
  },
  async mounted() {
    this.userRegion = this.user.region;
    this.loadContent();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileSubscriptionSection"] = Vue.component(
                    "ProfileSubscriptionSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-row> <b-col class=\"subscription-column\"> <b-row> <b-col class=\"membership-image\"> <img class=\"align-self-center\" :src=\"`/images/${tier.code}-512x512.png`\" width=\"100px\" height=\"100px\" /> </b-col> <b-col class=\"ml-2 membership-info\"> <b-row> <b-card-title class=\"membership-tier mr-1\"> {{ membership.tier }} <tier-badge-icon :tier=\"userTier\"></tier-badge-icon> </b-card-title> </b-row> <b-row> <b-badge v-if=\"activeSubscription\" ref=\"expirationBadge\" :variant=\"expirationType\">{{ expirationLabel }}</b-badge> <b-tooltip v-if=\"activeSubscription\" :target=\"() => $refs.expirationBadge\" custom-class=\"subscription-tooltip\" > <div v-if=\"activeSubscription\"> <div class=\"border-bottom mb-1\"> <b>{{ t(\"Current Subscription:\") }}</b> </div> <div class=\"text-left\">{{ activeSubscriptionDescription }}</div> <div v-if=\"activeSubscription.status === 'trialing'\" class=\"text-left\">{{ trialEndingString }}</div> <div v-else class=\"text-left\"> {{ activeSubscription.renew ? t(\"Renews\") : t(\"Expires\") }} {{ expiresDateString }} </div> <div v-if=\"isOverdue\" class=\"text-left text-danger\"> <b>{{ t(\"Payment is overdue\") }}</b> </div> </div> <div v-if=\"hasDowngrades && futureSubscriptions.length > 0\"> <div class=\"border-bottom mb-1\"> <b>{{ t(\"Pending Subscription:\") }}</b> </div> <div class=\"text-left\">{{ pendingSubscriptionDescription }}</div> </div> </b-tooltip> </b-row> </b-col> </b-row> <b-row class=\"text-center\"> <b-col class=\"mt-3 mb-2\"> <b-button variant=\"primary\" class=\"profile-button\" @click=\"showDialog = true\"> {{ t(\"Manage Subscriptions\") }} </b-button> </b-col> </b-row> </b-col> <subscription-manager ref=\"SubscriptionManager\" v-model=\"showDialog\" :tiers=\"tiers\" :extras=\"extras\" :initial-subscription=\"initialSubscription\" @remove-inital=\"initialSubscription = null\" v-on=\"$listeners\" ></subscription-manager> </b-row>",
  beforeCreate() {
    Utils.loadCss({
      content: ".subscription-column { display: flex; flex-direction: column; } .subscription-column > div { justify-content: center; } .membership-image, .membership-info { flex-grow: 0; } .membership-tier { display: inline-block; white-space: nowrap; } .subscription-tooltip > .tooltip-inner { max-width: none; }"
    });
  },
  props: {
    membership: Object,
    userTier: Number,
    subscriptions: Array,
    trialDays: Number,
    tiers: Object,
    extras: Object
  },
  data() {
    return {
      showDialog: false,
      initialSubscription: null
    };
  },
  computed: {
    expirationLabel() {
      const sub = this.activeSubscription;
      if (!sub) {
        return "";
      }
      if (!this.hasDowngrades) {
        if (sub.status == "trialing") {
          return this.trialEndingString;
        }
        return t(`Renews on {{date}}`, {
          date: this.expiresDateString
        });
      }
      if (this.pendingSubscription) {
        return t(`Downgrade scheduled for {{date}}`, {
          date: this.expiresDateString
        });
      }
      return t(`Expires on {{date}}`, {
        date: this.expiresDateString
      });
    },
    expirationType() {
      if (!this.activeSubscription) {
        return "";
      }
      if (this.activeSubscription.status === "trialing") {
        return "info";
      }
      if (this.isOverdue) {
        return "danger";
      }
      if (!this.hasDowngrades) {
        return "success";
      }
      return this.pendingSubscription ? "info" : "warning";
    },
    expiresDateString() {
      return this.activeSubscription ? new Date(this.activeSubscription.expires).toDateString() : "";
    },
    trialEndingString() {
      if (this.trialDays >= 2) {
        // t("TIME.days", {count})
        return t('Trial ends in $t(TIME.days, {"count": {{days}} })', {
          days: Math.round(this.trialDays)
        });
      } else if (this.trialEnds > 1) {
        return t("Trial ends tomorrow");
      }
      // t("TIME.hours", {count})
      return t('Trial ends in $t(TIME.hours, {"count": {{hours}} })', {
        hours: Math.round(this.trialDays * 24)
      });
    },
    hostingSubscriptions() {
      return this.subscriptions.filter(sub => !!this.tierCodeToName(sub.code));
    },
    extraSubscriptions() {
      return this.subscriptions.filter(sub => !this.tierCodeToName(sub.code));
    },
    futureSubscriptions() {
      return this.subscriptions.filter(sub => sub.renew || !sub.active);
    },
    activeSubscription() {
      return this.hostingSubscriptions.find(sub => sub.active) || null;
    },
    pendingSubscription() {
      return this.hostingSubscriptions.find(sub => sub.renew || !sub.active) || null;
    },
    activeSubscriptionName() {
      return this.activeSubscription ? this.tierCodeToName(this.activeSubscription.code) : "";
    },
    pendingSubscriptionName() {
      return this.pendingSubscription ? this.tierCodeToName(this.pendingSubscription.code) : "";
    },
    activeSubscriptionDescription() {
      const hosting = `${this.activeSubscription.cycle === 12 ? t("Yearly") : t("Monthly")} ${this.activeSubscriptionName}`;
      const extras = this.activeTotalExtras > 0 ? ` + ${this.activeTotalExtras} ${t("Extras")}` : "";
      return hosting + extras;
    },
    pendingSubscriptionDescription() {
      const hosting = `${this.pendingSubscription.cycle === 12 ? t("Yearly") : t("Monthly")} ${this.pendingSubscriptionName}`;
      const extras = this.pendingTotalExtras > 0 ? ` + ${this.pendingTotalExtras} ${t("Extras")}` : "";
      return hosting + extras;
    },
    activeExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.active);
    },
    pendingExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.renew || !sub.active);
    },
    activeTotalExtras() {
      return this.activeExtraSubscriptions.reduce((total, sub) => total + sub.quantity, 0);
    },
    pendingTotalExtras() {
      return this.pendingExtraSubscriptions.reduce((total, sub) => total + sub.quantity, 0);
    },
    isOverdue() {
      if (!this.activeSubscription) {
        return false;
      }
      return ["past_due", "unpaid"].includes(this.activeSubscription.status);
    },
    hasDowngrades() {
      return this.subscriptions.some(sub => !sub.renew);
    },
    tier() {
      return Object.values(this.tiers).find(t => t.tier == this.userTier) || {};
    }
  },
  methods: {
    tierCodeToName(code) {
      const names = {
        "game-master": t("Game Master"),
        "story-teller": t("Story Teller"),
        "world-builder": t("World Builder")
      };
      return names[code] || "";
    },
    resetSubscriptionDialog() {
      if (this.showDialog) {
        this.$refs["SubscriptionManager"].reset();
      }
    }
  },
  mounted() {
    const hash = Utils.hashProps(window.location.hash);
    if (hash.subscribe) {
      this.initialSubscription = hash.subscribe;
      this.showDialog = true;
      window.location.hash = "";
    } else {
      this.initialSubscription = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileUserProfile"] = Vue.component(
                    "ProfileUserProfile",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header>{{ t(\"User Profile\") }}</b-card-header> <b-card-body class=\"drag-container\" @drop.prevent=\"dropFile\" @dragover.prevent=\"dragging = true\" @dragenter=\"dragging = true\" @dragend=\"dragging = false\" > <div v-if=\"dragging\" class=\"drag-overlay\" :class=\"dragging ? 'dragging' : ''\" @dragover.prevent=\"dragging = true\" @dragenter=\"dragging = true\" @dragend=\"dragging = false\" @dragleave=\"dragging = false\" > {{ t(\"Drag Avatar Image Here\") }} </div> <b-row> <b-col> <b-form-group label-cols=\"3\" :label=\"t('Name')\" label-for=\"name\"> <b-form-input v-model=\"userData.name\" type=\"text\" name=\"name\" :placeholder=\"t('Your Name')\"></b-form-input> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Display Name')\" label-for=\"nickname\"> <b-form-input v-model=\"userData.nickname\" type=\"text\" name=\"nickname\" :placeholder=\"t('Display Name')\" ></b-form-input> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Theme')\" label-for=\"theme\"> <b-form-select v-model=\"userData.theme\" :options=\"displayThemes\"></b-form-select> </b-form-group> <b-form-group label-cols=\"3\" :label=\"t('Language')\" label-for=\"lang\"> <b-dropdown id=\"language-dropdown\" right> <template #button-content> <span v-html=\"languageWithFlagHtml(userData.lang)\"></span> </template> <b-dropdown-item v-for=\"lang in supportedLanguages\" :key=\"lang\" @click=\"selectLanguage(lang)\"> <span v-html=\"languageWithFlagHtml(lang)\"></span> </b-dropdown-item> </b-dropdown> </b-form-group> </b-col> <b-col md=\"auto\"> <b-img id=\"profile-avatar-image\" rounded :title=\"t('Click to change')\" :src=\"avatarImage\" @click=\"selectAvatar\" @error=\"errorLoadingImage\" @mouseover=\"mouseOverAvatar\" ></b-img> <div v-if=\"hoverAvatar\" class=\"rounded avatar-click-indicator position-absolute\" @click=\"selectAvatar\" @mouseover=\"mouseOverAvatar\" @mouseleave=\"mouseLeaveAvatar\" > {{ t(\"Click to change\") }} </div> <b-form-file ref=\"fileInput\" v-model=\"fileAvatar\" class=\"d-none\" accept=\"image/*\"> </b-form-file> <b-col class=\"text-center p-0\"> <b-button id=\"profile-avatar-button\" variant=\"outline-secondary\" class=\"mt-1\" @click=\"selectAvatar\"> {{ t(\"Change Avatar\") }} </b-button> </b-col> </b-col> </b-row> <hr /> <b-row> <b-col> <b-button variant=\"primary\" class=\"profile-button\" :disabled=\"!hasChanges || saving\" @click.prevent=\"saveUserProfile\" > <i class=\"fas fa-save\"></i> <span v-if=\"!saving\">{{ t(\"Update profile\") }}</span> <span v-else>{{ t(\"Saving…\") }}</span> </b-button> </b-col> </b-row> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".drag-container { position: relative; } .drag-overlay { position: absolute; background: rgba(255, 255, 255, 0.9); text-align: center; border: 4px dashed #c0c0c0; border-radius: 10px; width: 100%; height: 100%; margin-top: -1.25rem; margin-left: -1.25rem; z-index: 100; color: #808080; font-size: 32px; font-weight: bold; padding-top: 120px; } #profile-avatar-image { width: 190px; height: 190px; object-fit: contain; cursor: pointer; background-color: rgba(248, 248, 248, 0.9); } #profile-avatar-button { width: 190px; } .avatar-click-indicator { position: absolute; width: 190px; height: 190px; background: rgba(255, 255, 255, 0.8); border: 2px dashed #c0c0c0; color: #808080; top: 0px; text-align: center; line-height: 190px; font-weight: bold; cursor: pointer; }"
    });
  },
  props: {
    user: Object,
    themes: Object,
    avatar: String //this could be the gravatar image and not just the user.profile.picture
  },

  data() {
    return {
      saving: false,
      fileAvatar: null,
      avatarPreview: null,
      avatarShowing: null,
      userData: {},
      dragging: false,
      hoverAvatar: false
    };
  },
  watch: {
    fileAvatar(newValue, oldValue) {
      if (newValue) {
        // as soon as the user uploads an image to fileAvatar, we generate a base64 version of the image
        // so that the user can preview the changes
        // than we upload the image to the server and save it as the user's avatar
        Utils.getDataURL(newValue).then(async value => {
          this.avatarPreview = value;
          await this.saveUserProfileImage();
        }).catch(() => {
          this.avatarPreview = null;
        });
      } else {
        this.avatarPreview = null;
      }
    }
  },
  computed: {
    displayThemes() {
      return [{
        label: t("Light Themes"),
        options: this.themes.light.map(t => ({
          value: t,
          text: Utils.capitalize(t)
        }))
      }, {
        label: t("Dark Themes"),
        options: this.themes.dark.map(t => ({
          value: t,
          text: Utils.capitalize(t)
        }))
      }];
    },
    supportedLanguages() {
      return UI.i18n.SUPPORTED_LANGUAGES;
    },
    avatarImage() {
      return this.avatarPreview || this.avatarShowing;
    },
    hasChanges() {
      return this.user.name !== this.userData.name || this.user.nickname !== this.userData.nickname || this.user.theme !== this.userData.theme || this.user.lang !== this.userData.lang || this.user.picture !== this.userData.avatar;
    }
  },
  methods: {
    async saveUserProfileImage() {
      const avatar = await Assets.uploadFiles("avatars", [this.fileAvatar]);
      if (!avatar.success) {
        UI.alert("danger", t(`Error uploading avatar picture: {{error}}`, {
          error: avatar.results && avatar.results.length && avatar.results[0].error || t("Unknown Error")
        }), true);
        this.fileAvatar = null;
        this.avatarPreview = null;
      } else {
        this.fileAvatar = null;
        const urls = avatar.results.map(r => r.url).filter(u => !!u);
        this.userData.avatar = this.avatarShowing = urls[0];
        this.userData.picture = this.userData.avatar; // this is to mark hasChanges as false after updating profile image
        $(".main-navigation .user-profile-menu .menu-label img.user-avatar").attr("src", this.userData.avatar);
      }
    },
    async saveUserProfile() {
      this.saving = true;
      const result = await Utils.api("profile", this.userData);
      if (!result.success) {
        UI.alert("danger", result.error || t(`Error communicating with server`), true);
        this.saving = false;
        return;
      }
      // if the user's theme or lang changes then the page needs to be reloaded.
      if (this.user.nickname !== this.userData.nickname) {
        $(".user-profile-name").html(this.userData.nickname);
      }
      if (this.user.theme !== this.userData.theme || this.user.lang !== this.userData.lang) {
        location.reload();
      }
      this.$emit("update", this.userData);
      this.saving = false;
      UI.alert("success", t(`Your profile information has been updated.`), false, 10000);
    },
    selectAvatar() {
      this.$refs.fileInput.$el.childNodes[0].click();
    },
    dropFile(e) {
      this.dragging = false;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) {
        return;
      }
      this.fileAvatar = droppedFiles[0];
    },
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, "/images/avatars/Goblin2.png");
    },
    mouseOverAvatar() {
      this.hoverAvatar = true;
    },
    mouseLeaveAvatar() {
      this.hoverAvatar = false;
    },
    languageWithFlagHtml(lang) {
      // DEFAULT_LANGUAGE is efined in common constants
      lang = lang || DEFAULT_LANGUAGE;
      return `<i class="${UI.i18n.langToCountryCode(lang)} flag shadowed"></i>${t(`LANGUAGE.${lang}`)}`;
    },
    selectLanguage(lang) {
      this.userData.lang = lang;
    }
  },
  mounted() {
    this.avatarShowing = this.avatar;
    this.userData = {
      name: this.user.name,
      nickname: this.user.nickname,
      theme: this.user.theme,
      lang: this.user.lang,
      avatar: this.user.picture
    };
    this.hoverAvatar = false;
    this.dragging = false;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["RegionSelector"] = Vue.component(
                    "RegionSelector",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"t('Change Region')\" @ok=\"queryOk\" @hidden=\"visible = false\" @show=\"userRegion = region\" > <p> {{ t( \"The Forge is offered in multiple regions. Choosing a server closer to you will help lower the latency and responsiveness of the VTT itself.\" ) }} </p> <p> {{ t( \"Regardless of your choice, however, the Assets Library will always be geo-distributed and available from over 200 different locations around the world at all times.\" ) }} </p> <div class=\"form-group\"> <b-list-group> <b-list-group-item> <b-row> <b-col class=\"p-2\"> {{ t(\"Assets Library (200+ locations)\") }} </b-col> <b-col md=\"auto\" class=\"p-2\"> <b-badge v-if=\"assets.latency || assets.pinging\" variant=\"light\" class=\"ping-result\"> <div v-if=\"assets.pinging\" class=\"spinner-grow spinner-grow-sm\" role=\"status\"></div> <span v-else>{{ assets.latency }} ms</span> </b-badge> </b-col> <b-col md=\"auto\"> <b-button variant=\"info\" size=\"sm\" class=\"float-right mt-1 ping-btn\" :disabled=\"assets.pinging\" @click.prevent=\"pingServer(null, $event)\" > <span v-if=\"!assets.pinging\">{{ t(\"Test Latency\") }}</span> <span v-else>{{ t(\"Pinging\") }}</span> </b-button> </b-col> </b-row> </b-list-group-item> </b-list-group> </div> <div class=\"region-selector-body\"> <div v-if=\"loading\" class=\"text-center\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Looking for servers, please wait…\") }} </div> <div v-else> <div class=\"form-group row\"> <label for=\"region\" class=\"col-sm-4 col-form-label col-form-label-sm\"> {{ t(\"Your currently assigned region is:\") }} </label> <div class=\"col-sm-6\"> <b-form-input v-model=\"regionName\" size=\"sm\" readonly></b-form-input> </div> </div> <div class=\"form-group\"> <label for=\"region\" class=\"col-sm-3 col-form-label\"> {{ t(\"Select a region\") }} </label> <b-list-group> <b-list-group-item v-for=\"region in availableRegions\" :key=\"region.id\"> <b-row> <b-col md=\"auto\" class=\"p-2\"> <b-form-radio v-if=\"region.available\" v-model=\"userRegion\" name=\"region\" :value=\"region.id\" :disabled=\"!region.available\" ></b-form-radio> </b-col> <b-col class=\"p-2\"> <!-- {{ t('North America (East)') }} --> <!-- {{ t('Europe') }} --> <!-- {{ t('Asia') }} --> <!-- {{ t('Oceania') }} --> {{ t(region.name) }} </b-col> <b-col md=\"auto\" class=\"p-2\"> <b-badge v-if=\"region.latency || region.pinging\" variant=\"light\" class=\"ping-result\"> <div v-if=\"region.pinging\" class=\"spinner-grow spinner-grow-sm\" role=\"status\"></div> <span v-else>{{ t(\"LATENCY_MS\", { count: region.latency }) }}</span> </b-badge> </b-col> <b-col md=\"auto\"> <b-button v-if=\"region.available\" variant=\"info\" size=\"sm\" class=\"float-right mt-1 ping-btn\" :disabled=\"region.pinging\" @click.prevent=\"pingServer(region, $event)\" > <span v-if=\"!region.pinging\">{{ t(\"Test Latency\") }}</span> <span v-else>{{ t(\"Pinging\") }}</span> </b-button> <b-button v-else variant=\"warning\" size=\"sm\" class=\"float-right mb-1 ping-btn no-click\" disabled> {{ t(\"Not available\") }} </b-button> </b-col> </b-row> </b-list-group-item> </b-list-group> </div> <b-alert :show=\"userRegion != region\" variant=\"warning\"> {{ t( \"Please note that changing your server selection will take a few minutes, during which you will not be able to access your data or launch games.\" ) }} </b-alert> </div> </div> <template #modal-footer=\"{ ok, cancel }\"> <b-button variant=\"primary\" @click=\"ok\">{{ t(\"Set server selection\") }}</b-button> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".ping-btn { width: 100px; } .no-click { cursor: default; }"
    });
  },
  props: {
    value: Boolean,
    region: String
  },
  data() {
    return {
      userRegion: null,
      loading: true,
      regions: [],
      assets: {
        pinging: false,
        pings: [],
        latency: null
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    availableRegions() {
      return this.regions.sort((a, b) => {
        if (a.available && !b.available) {
          return -1;
        }
        if (b.available && !a.available) {
          return 1;
        }
        return a.name - b.name;
      });
    },
    regionName() {
      const region = this.regions.find(r => r.id === this.userRegion);
      return region ? region.name : this.region;
    }
  },
  methods: {
    queryKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.queryOk();
        this.visible = false;
      }
    },
    queryOk() {
      if (this.userRegion.id !== this.region) {
        let result = this.regions.find(r => r.id === this.userRegion);
        if (result == undefined) {
          result = {
            id: this.userRegion,
            name: this.userRegion
          };
        }
        this.$emit("change", result);
      }
    },
    async pingServer(region, ev) {
      const url = region ? `https://ping.${region.domain}/api/ping` //ping a region
      : "https://assets.forge-vtt.com/favicon.ico"; //ping the asset server
      region = region || this.assets;
      region.pinging = true;
      console.log("Pinging : ", url);
      region.pings = [];
      for (let i = 0; i < 10; i++) {
        region.pings.push(await this.ping(url));
      }
      region.latency = Math.min(...region.pings);
      console.log(`Ping results (${region.latency} ms): ${region.pings}`);
      region.pinging = false;
    },
    async ping(url) {
      const start = Date.now();
      await fetch(url, {
        cache: "no-cache",
        method: "HEAD"
      }).catch(console.error);
      const end = Date.now();
      return end - start;
    }
  },
  async mounted() {
    this.loading = true;
    this.regions = await Utils.api("regions");
    if (this.regions.error) {
      return UI.alert("danger", t("Error retrieving list of available regions: {{- error}}", {
        error: this.regions.error
      }), false, 10000);
    }
    this.regions = this.regions.map(r => ({
      ...r,
      pinging: false,
      pings: [],
      latency: null
    }));
    this.loading = false;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Security2fa"] = Vue.component(
                    "Security2fa",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :hide-footer=\"!initialized\" no-close-on-backdrop footer-class=\"unallow-disabled\" :title=\"t('Two Factor Authentication')\" size=\"lg\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <b-alert :show=\"showAlert\" dismissible variant=\"danger\">{{ t(error) }}</b-alert> <p v-if=\"!initialized\" class=\"text-center\"> <span class=\"spinner-border spinner-border-sm mr-2 align-middle\"></span> {{ t(\"Loading…\") }} </p> <div v-else-if=\"!otp.bound\"> <p> {{ t(\"You can enable two-factor authentication (2FA) to secure your Forge account.\") }} </p> <p v-html=\"authenticatorsURLs\"></p> <p> {{ t(\"You can stop the procedure and opt out at any given moment.\") }} </p> </div> <div v-else> <figure v-if=\"otp.secret\" class=\"qrcode mb-4 text-center\"> <img :alt=\"otp.secret\" :src=\"otp.qrcode\" /> <figcaption class=\"text-monospace text-break\"> {{ otp.secret }} </figcaption> </figure> <div v-else> <p class=\"mb-0\"> {{ t(\"The QRCode and secret key have been hidden as a safety measure.\") }} </p> <p class=\"mb-5\"> {{ t(\"If you lost the previous secret or your device, you can remove the current one and generate a new one.\") }} </p> </div> <div v-if=\"!validOrActive\"> <b-alert :show=\"validationFailed\" dismissible variant=\"danger\">{{ t(\"Some of the information provided is incorrect, correct them and try again.\") }}</b-alert> <form id=\"validatation2FA\" class=\"p-3 pb-0\" @submit.prevent=\"validate\"> <p> <i18n :path=\"t('A verification code has been sent to your email address ({0}).')\"> <b>{{ emailAddress }}</b> </i18n ><br /> {{ t(\"Fill all the required information down below to activate your authenticator and complete the process.\") }} </p> <b-form-group :label=\"t('Auth code')\"> <b-form-input id=\"authCode\" class=\"text-uppercase\" :class=\"validationErrors.authCode\" minlength=\"6\" :placeholder=\"t('6-digit authentication code')\" required ></b-form-input> </b-form-group> <b-form-group :label=\"t('Email code')\"> <b-form-input id=\"mailCode\" class=\"text-uppercase\" :class=\"validationErrors.mailCode\" minlength=\"6\" maxlength=\"20\" :placeholder=\"t('8-characters validation code')\" required ></b-form-input> </b-form-group> <b-form-group :label=\"t('Password')\"> <b-form-input id=\"password\" type=\"password\" :class=\"validationErrors.password\" minlength=\"6\" :placeholder=\"t('Password')\" required ></b-form-input> </b-form-group> </form> </div> <div v-else class=\"text-center\"> <div> <h4 class=\"text-center\"> {{ t(\"Recovery codes\") }} <button v-if=\"active\" class=\"btn btn-primary\" @click.prevent=\"openRecoveryCodeRequest\"> <i class=\"fa fa-sync align-middle\"></i> </button> </h4> <ul v-if=\"recoveryVisible\" class=\"recovery-codes list-inline row justify-content-center\"> <li v-for=\"code in otp.recovery\" :key=\"code\" class=\"text-monospace col-12 col-sm-6 col-md-4 col-lg-3\"> {{ code }} </li> </ul> <div v-else> <p class=\"mb-0\">{{ t(\"You can generate new recovery codes.\") }}</p> </div> <p v-if=\"showRecoveryRegenDate\" class=\"text-success font-weight-bold\"> {{ t(\"New set of codes generated on:\") }} {{ recoveryRegenDate }} </p> </div> </div> </div> <p v-if=\"showRecoveryMessage\" class=\"mt-4 mb-0\"> <span class=\"text-danger text-uppercase\" ><b>{{ t(\"Warning:\") }}</b> </span >{{ t(\"The recovery codes above are the only way to login if you lose your authenticator.\") }}<br /> <b>{{ t(\"If you lose your recovery codes there is no way to recover your account\") }}</b >.<br /> {{ t(\"Print them out with the button available down below.\") }} </p> <template #modal-footer=\"{ cancel }\"> <b-button v-if=\"active\" variant=\"danger\" class=\"mr-auto\" @click=\"openRemovalCodeRequest\">{{ t(\"Disable 2FA\") }}</b-button> <b-button :variant=\"closeVariant\" @click=\"cancel\">{{ closeLabel }}</b-button> <b-button v-if=\"potentiallyBroken\" variant=\"danger\" :disabled=\"action.request\" @click=\"request\"> <span v-if=\"action.request\" class=\"spinner-border spinner-border-sm mr-2 align-middle\"></span> {{ regenerateLabel }} </b-button> <b-button v-if=\"validButInactive\" variant=\"primary\" @click=\"activate\">{{ t(\"I saved my recovery codes\") }}</b-button> <b-button v-if=\"validOrActive\" variant=\"info\" :disabled=\"!recoveryVisible\" @click=\"showPrintPage = true\" ><i class=\"fa fa-print align-middle\"></i> {{ t(\"Print\") }}</b-button > <b-button v-if=\"!otp.bound\" variant=\"primary\" :disabled=\"action.request\" @click=\"request\"> <span v-if=\"action.request\" class=\"spinner-border spinner-border-sm mr-2 align-middle\"></span> {{ requestLabel }} </b-button> <b-button v-if=\"otp.bound && !validOrActive\" type=\"submit\" form=\"validatation2FA\" variant=\"primary\" :disabled=\"action.validate\" > <span v-if=\"action.validate\" class=\"spinner-border spinner-border-sm mr-2 align-middle\"></span> {{ verifyLabel }} </b-button> </template> <security2fa-code-request v-model=\"showCodeRequest\" :error=\"codeRequestError\" :type=\"codeRequestType\" @submit=\"requestedCode\" ></security2fa-code-request> <security2fa-printable v-model=\"showPrintPage\" :otp=\"otp\"></security2fa-printable> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".unallow-disabled button:disabled { cursor: not-allowed; }"
    });
  },
  props: {
    isBound: Boolean,
    value: Boolean
  },
  data() {
    return {
      otp: null,
      // OTP data
      showPrintPage: false,
      // Show printable secrets page
      showCodeRequest: false,
      // Show auth code dialog
      recoveryRegenDate: null,
      // Confirmation of recovery codes regeneration
      codeRequestType: null,
      // Code request type (Regen/Unbind)
      codeRequestError: null,
      // Show code request error
      error: null,
      // Error feedback
      action: {
        // Currently performing
        request: false,
        validate: false
      },
      validationErrors: {
        // Validation errors
        authCode: null,
        mailCode: null,
        password: null
      },
      emailAddress: null // Email address of the user where the 2FA email code was sent
    };
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.otp = null;
        }
        this.$emit("input", value);
      }
    },
    showAlert() {
      return this.error ? 3 : false;
    },
    initialized() {
      return this.otp !== null;
    },
    validButInactive() {
      return this.otp && this.otp.valid && !this.otp.active;
    },
    validOrActive() {
      return this.otp && (this.otp.valid || this.otp.active);
    },
    active() {
      return this.otp && this.otp.active;
    },
    potentiallyBroken() {
      return this.otp.bound && !this.otp.secret && !(this.otp.valid || this.otp.active);
    },
    closeVariant() {
      return this.validButInactive ? "danger" : "secondary";
    },
    closeLabel() {
      return this.validButInactive ? t("Close without activating") : t("Close");
    },
    requestLabel() {
      return this.action.request ? t("Waiting…") : t("Request 2FA");
    },
    verifyLabel() {
      return this.action.validate ? t("Waiting…") : t("Validate 2FA");
    },
    regenerateLabel() {
      return this.action.validate ? t("Waiting…") : t("Regenerate 2FA");
    },
    validationFailed() {
      return Object.values(this.validationErrors).some(Boolean) ? true : false;
    },
    recoveryVisible() {
      return !!(this.otp && this.otp.recovery && this.otp.recovery.length > 0);
    },
    showRecoveryRegenDate() {
      return this.recoveryVisible && this.recoveryRegenDate;
    },
    showRecoveryMessage() {
      return this.validButInactive || this.showRecoveryRegenDate;
    },
    authenticatorsURLs() {
      return t("Through this process you will connect an authenticator of your choice (such as {{GoogleAuthURL}}, {{AuthyURL}} or {{MicrosoftAuthURL}}), and you will test its correct functionality before making it definitive.", {
        GoogleAuthURL: `<a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">${t("Google Authenticator")}</a>`,
        AuthyURL: `<a target="_blank" href="https://authy.com/download/">${t("Authy")}</a>`,
        MicrosoftAuthURL: `<a target="_blank" href="https://www.microsoft.com/en-us/p/microsoft-authenticator/9nblgggzmcj6">${t("Microsoft Authenticator")}</a>`,
        interpolation: {
          escapeValue: false
        }
      });
    }
  },
  methods: {
    getFormData(event) {
      const form = {};
      for (const target of event.target) {
        form[target.id] = target.value;
      }
      return form;
    },
    async dialogShown() {
      this.otp = await Utils.api("2fa/status");
      // If not activated fully, then reset the state
      if (!this.otp.active) {
        this.otp.bound = false;
        this.otp.valid = false;
      }
    },
    async request() {
      this.action.request = true;
      console.log("Generating 2FA data…");
      const response = await Utils.api("2fa/new", {});
      if (response.error) {
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.action.request = false;
        }, 10000);
        if (response.status) {
          this.otp = response.status;
        }
        return;
      } else if (response.success) {
        this.error = null;
        this.otp = response.status;
        this.$set(this.otp, "secret", response.secret);
        this.$set(this.otp, "qrcode", response.qrcode);
        this.emailAddress = response.email;
      }
      this.action.request = false;
    },
    async validate(event) {
      this.action.validate = true;
      const response = await Utils.api("2fa/validate", this.getFormData(event));
      if (response.error) {
        this.error = response.error;
        setTimeout(() => {
          this.error = null;
          this.action.validate = false;
        }, 10000);
        return;
      }
      for (const [id, value] of Object.entries(response.validation)) {
        this.validationErrors[id] = value ? null : "border-danger";
      }
      if (response.status.valid) {
        Object.assign(this.otp, response.status);
        this.$set(this.otp, "recovery", response.recovery);
        // Clear the secret/QR once the user has validated/confirmed they saved it
        this.otp.secret = null;
        this.otp.qrcode = null;
      }
      this.action.validate = false;
    },
    async activate() {
      const response = await Utils.api("2fa/activate", {});
      if (response.error) {
        this.error = t("There was a problem activating the authenticator, please try again shortly.");
      } else if (response.success) {
        this.error = null;
        Object.assign(this.otp, response.status);
        this.$emit("auth-change", true);
        UI.alert("success", t("Successfully activated Two Factor Authentication for your account."), true, 3000);
      }
    },
    openRecoveryCodeDialog(type) {
      this.codeRequestType = type;
      this.codeRequestError = null;
      this.showCodeRequest = true;
    },
    openRecoveryCodeRequest() {
      this.openRecoveryCodeDialog(Enums.CodeRequestTypes.REGENERATE_RECOVERY_CODES);
    },
    async openRemovalCodeRequest() {
      this.openRecoveryCodeDialog(Enums.CodeRequestTypes.UNBIND_AUTHENTICATOR);
    },
    async requestedCode(code) {
      const cleanup = success => {
        if (success) {
          this.codeRequestError = null;
          this.showCodeRequest = false;
        }
      };
      if (this.codeRequestType === Enums.CodeRequestTypes.REGENERATE_RECOVERY_CODES) {
        return this.regenerateRecovery(code).then(cleanup);
      }
      if (this.codeRequestType === Enums.CodeRequestTypes.UNBIND_AUTHENTICATOR) {
        return this.removeAuthenticator(code).then(cleanup);
      }
    },
    async regenerateRecovery(authCode) {
      const response = await Utils.api("2fa/regenerate-recovery-codes", {
        authCode
      });
      if (response.error) {
        this.codeRequestError = response.error;
      } else {
        const now = new Date();
        this.recoveryRegenDate = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        Object.assign(this.otp, response.status);
        this.$set(this.otp, "recovery", response.recovery);
      }
      return !!response.success;
    },
    async removeAuthenticator(authCode) {
      const response = await Utils.api("2fa/remove", {
        authCode
      });
      if (response.error) {
        this.codeRequestError = response.error;
      } else {
        this.codeRequestError = null;
        this.error = null;
        this.showCodeRequest = false;
        this.visible = false;
        this.otp = {};
        this.$emit("auth-change", false);
        UI.alert("success", t("Successfully removed Two Factor Authentication from your account."), true, 3000);
      }
      return !!response.success;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Security2faCodeRequest"] = Vue.component(
                    "Security2faCodeRequest",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"dialogTitle\" @hidden=\"visible = false\"> <b-alert :show=\"showAlert\" variant=\"danger\" dismissible>{{ t(error) }}</b-alert> <p v-if=\"login\"> {{ t( \"To login, please enter the Two-Factor Authentication code from your authenticator app (Google Authenticator, Authy, Microsoft Authenticator, etc…).\" ) }} </p> <div v-else-if=\"regenerate\"> <p> <b>{{ t(\"Warning:\") }}</b> {{ t( \"This procedure will invalidate all current recovery codes and generate new ones. They're the only way to login if you lose your authenticator.\" ) }} </p> <p> <b>{{ t(\"If you lose your recovery codes there is no way to recover your account.\") }}</b> </p> <p> {{ t(\"Print them out immediately after the process is complete, or close the dialog to abort the procedure.\") }} </p> </div> <div v-else-if=\"unbind\"> <p> <b>{{ t(\"Warning:\") }}</b> {{ t(\"This procedure will remove the authenticator from your account.\") }} </p> <p> <b>{{ t(\"Are you sure you want to give up the added security?\") }}</b> </p> </div> <b-form-group :label=\"t('Auth code')\" label-cols=\"3\"> <b-input id=\"authCode\" ref=\"authInput\" v-model=\"code\" class=\"text-uppercase\" autofocus :class=\"inputClass\" minlength=\"6\" required @keyup=\"inputKeyUp\" ></b-input> </b-form-group> <template #modal-footer=\"{ cancel }\"> <b-button :variant=\"closeColor\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> <b-button :variant=\"okColor\" :disabled=\"!validLength\" @click=\"submit\">{{ buttonLabel }}</b-button> </template> </b-modal>",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    type: Symbol
  },
  data() {
    return {
      code: ""
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.code = "";
        }
        this.$emit("input", value);
      }
    },
    showAlert() {
      return !!this.error;
    },
    login() {
      return this.type === Enums.CodeRequestTypes.LOGIN;
    },
    regenerate() {
      return this.type === Enums.CodeRequestTypes.REGENERATE_RECOVERY_CODES;
    },
    unbind() {
      return this.type === Enums.CodeRequestTypes.UNBIND_AUTHENTICATOR;
    },
    admin() {
      return this.type === Enums.CodeRequestTypes.ADMIN_ACCESS;
    },
    dialogTitle() {
      return {
        [Enums.CodeRequestTypes.LOGIN]: t("2FA code request"),
        [Enums.CodeRequestTypes.REGENERATE_RECOVERY_CODES]: t("2FA recovery codes regeneration"),
        [Enums.CodeRequestTypes.UNBIND_AUTHENTICATOR]: t("2FA authenticator removal"),
        [Enums.CodeRequestTypes.ADMIN_ACCESS]: t("2FA admin access request")
      }[this.type];
    },
    groupClass() {
      return this.error ? "has-error" : "";
    },
    inputClass() {
      return this.error ? "border-danger" : "";
    },
    buttonLabel() {
      return {
        [Enums.CodeRequestTypes.LOGIN]: t("Login"),
        [Enums.CodeRequestTypes.REGENERATE_RECOVERY_CODES]: t("Regenerate"),
        [Enums.CodeRequestTypes.UNBIND_AUTHENTICATOR]: t("Disable 2FA"),
        [Enums.CodeRequestTypes.ADMIN_ACCESS]: t("Admin Access")
      }[this.type];
    },
    closeColor() {
      return this.login || this.admin ? "" : "primary";
    },
    okColor() {
      return this.login || this.admin ? "primary" : "danger";
    },
    validLength() {
      const verifyier = this.regenerate ? /^[0-9]{6,20}$/ : /^[0-9A-Z]{6,20}$/i;
      return this.code.length >= 6 && verifyier.test(this.code);
    }
  },
  methods: {
    submit() {
      this.$emit("submit", this.code);
    },
    inputKeyUp(ev) {
      if (ev.keyCode === 13 && this.validLength) {
        this.submit();
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Security2faPrintable"] = Vue.component(
                    "Security2faPrintable",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"value\" class=\"security-2fa print\"> <div class=\"header\"> <div class=\"image\"><img alt=\"\" src=\"/images/the-forge-logo-200x200.png\" @load=\"logoLoaded\" /></div> <div class=\"now\"> <h1>{{ t(\"The Forge\") }}</h1> <h2>{{ t(\"Two Factor Authentication\") }}</h2> <p class=\"timestamp\">{{ now }}</p> </div> </div> <div v-if=\"otp\" class=\"security-2fa text-center\"> <h3>{{ t(\"Recovery codes\") }}</h3> <ul class=\"security-2fa recovery-codes\"> <li v-for=\"code in otp.recovery\" :key=\"code\" class=\"text-monospace\">{{ code }}</li> </ul> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".security-2fa.print { display: none; font-size: 1.6rem; text-align: center; color: #444; font-size: 2.4em; padding-top: 1.2em; } @media print { .security-2fa.print { display: block !important; } body.hide-on-print { display: none; } } .security-2fa.print .text-monospace { font-family: monospace; } .security-2fa.print .header { display: flex; align-items: center; justify-content: center; } .security-2fa.print .header > * { margin: 0 0.6em; } .security-2fa.print h1, .security-2fa.print h2, .security-2fa.print h3 { font-family: \"El Messiri\", serif; font-weight: normal; margin: 0; } .security-2fa.print h1 { line-height: 1; font-size: 2.8em; } .security-2fa.print .image img { height: 7em; } .security-2fa.print h2 { font-size: 1.5em; line-height: 1.75; } .security-2fa.print h3 { font-size: 1.2em; } .security-2fa.print .timestamp { margin: 0; font-family: serif; } .security-2fa.print .qrcode, .security-2fa.print h3 { margin: 2em 0 0; } .security-2fa.print .recovery-codes { list-style-type: none; margin: 0.6em 0 0 0; padding: 0; display: grid; grid-template-columns: 1fr 1fr; grid-gap: 0.6em; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    otp: {
      type: Object
    }
  },
  data() {
    return {
      now: null
    };
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.print();
      }
    }
  },
  methods: {
    print() {
      const pad0 = n => n.toString().padStart(2, "0");
      const now = new Date();
      this.now = `${now.getFullYear()}-${pad0(now.getMonth() + 1)}-${pad0(now.getDate())} ${pad0(now.getHours())}:${pad0(now.getMinutes())}:${pad0(now.getSeconds())}`;
      // Hide the body for printing, and add our element after the body so it can be displayed
      document.body.classList.add("hide-on-print");
      document.body.after(this.$el);
    },
    logoLoaded() {
      window.print();
      document.body.classList.remove("hide-on-print");
      this.$emit("input", false);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SubscriptionManager"] = Vue.component(
                    "SubscriptionManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"xl\" :title=\"t('Manage your subscriptions')\" content-class=\"forge-subscription-manager\" no-close-on-backdrop @hidden=\"hideModal\" @show=\"reset\" > <template> <div v-if=\"dataLoading\"> <div class=\"text-center\"> {{ t(\"Retrieving your account information, please wait.\") }} <div class=\"spinner-border\" role=\"status\"></div> </div> </div> <b-alert v-else-if=\"error\" variant=\"danger\" show> {{ errorMsg }} </b-alert> <div v-else> <wizard-step-indicators :steps=\"currentSteps\" @click=\"clickStep\"> </wizard-step-indicators> <hr /> <div v-if=\"success\"> <div class=\"alert alert-success\" role=\"alert\"> {{ t(\"Your subscription has been updated successfully!\") }} </div> <div v-if=\"invoiceURL\"> {{ t(\"You can access your latest invoice\") }} <a :href=\"invoiceURL\" target=\"_blank\">{{ t(\"here\") }}</a >. </div> </div> <div v-else-if=\"activeStep('plans')\"> <i18n :path=\" t( 'In order to create games of your own, you will need both a {0} game license and a ForgeVTT subscription.' ) \" tag=\"p\" > <a href=\"https://foundryvtt.com\" target=\"_blank\">{{ t(\"Foundry VTT\") }}</a> </i18n> <i18n :path=\"t('For details on the available plans, see our {0} page, and read our {1}.')\" tag=\"p\"> <a href=\"/plans\" target=\"_blank\">{{ t(\"Plans & Pricing\") }}</a> <a href=\"/sales\" target=\"_blank\">{{ t(\"Sales Policy\") }}</a> </i18n> <b-alert v-if=\"trialDaysRemaining\" show variant=\"info\"> <i18n :path=\" t( 'You have {0} of free trial available. During the trial, you can explore any subscription tier and try all of its features. You will only be charged at the end of the trial.' ) \" > <strong>{{ t(\"TIME.days\", { count: trialDaysRemaining }) }}</strong> </i18n ><br /> <i18n :path=\"t('Click {0} for more information about our free trial.')\"> <a href=\"https://forums.forge-vtt.com/docs?topic=15301\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> </b-alert> <b-alert v-if=\"hasDowngrades && futureSubscriptions.length > 0\" show variant=\"warning\"> <b-row> <b-col> <i18n :path=\"t('Current plan {0} will be downgraded to {1} on {2}')\"> <b v-html=\"activeSubscriptionDescription\"></b> <b v-html=\"pendingSubscriptionDescription\"></b> {{ activeSubscription.expirationDate }} </i18n ><br /> {{ t(\"Any changes made will overwrite that.\") }} </b-col> <b-col cols=\"2\" class=\"text-right\"> <b-button variant=\"warning\" @click=\"renewPlan\">{{ t(\"Cancel Change\") }}</b-button> </b-col> </b-row> </b-alert> <b-alert v-else-if=\"activeSubscription\" show variant=\"info\"> <b-row> <b-col> {{ t(\"Current plan\") }} <b v-html=\"activeSubscriptionDescription\"></b> <span v-if=\"activeSubscription.status == 'trialing'\"> {{ trialEndingString }} </span> <span v-else> <i18n path=\"{0}\"> <i18n v-if=\"activeSubscription.renew\" :path=\"t('will renew on {0}')\"> <b>{{ activeSubscription.expirationDate }}</b> </i18n> <i18n v-else :path=\"t('will expire on {0}')\"> <b>{{ activeSubscription.expirationDate }}</b> </i18n> </i18n> </span> </b-col> <b-col v-if=\"activeSubscription.status !== 'trialing' && !activeSubscription.renew\" cols=\"2\" class=\"text-right\" > <b-button variant=\"info\" @click=\"renewPlan\">{{ t(\"Renew\") }}</b-button> </b-col> </b-row> </b-alert> <b-alert v-if=\"!hasFullLicense\" show variant=\"danger\"> <i18n :path=\"t('You cannot subscribe to a hosting tier until you have added a {0} to your account.')\"> <b-link @click=\"openLicenseManager\">{{ t(\"Foundry VTT license\") }}</b-link> </i18n> </b-alert> <template v-else> <subscription-plans v-model=\"selectedPlans\" :tiers=\"tiers\" :extras=\"extras\" :subscriptions=\"subscriptions\" :initial-subscription=\"initialSubscription\" @complete=\"completeStep('plans', $event)\" @remove-inital=\"$emit('remove-inital')\" ></subscription-plans> <hr /> <b-row> <b-col v-if=\"validCoupon\" class=\"text-left border border-success rounded ml-3 py-1\"> <i18n :path=\"t('Applied Coupon: {0}')\"> <b>{{ couponName }}</b> </i18n> </b-col> <b-col v-if=\"couponError\" class=\"text-left border border-danger rounded ml-3 py-1\"> {{ couponError }} </b-col> <b-col class=\"text-right\"> <span class=\"mr-2\" >{{ t(\"Coupon Code:\") }} <help-icon :tooltip=\" t('Coupon can only be applied on new subscriptions or on upgrades to existing subscriptions') \" url=\"https://forums.forge-vtt.com/t/how-to-use-a-coupon-on-the-forge/16224\" ></help-icon> </span> <b-form-input v-model=\"coupon\" :state=\"validCoupon\" class=\"coupon-input\" :title=\"couponError\" @keyup=\"couponInputKeyUp\" @blur=\"checkCoupon\" ></b-form-input> </b-col> </b-row> </template> <div v-if=\"processing\" class=\"text-center\"> <b-spinner :label=\"t('Processing order')\"></b-spinner> {{ t(\"Processing, please wait…\") }} </div> </div> <div v-else-if=\"activeStep('billing')\"> <b-alert variant=\"danger\" :show=\"!email_verified\"> {{ t( \"Your email address is not verified. Make sure you have entered the correct email address so you can receive your invoice, payment receipts and other related communications.\" ) }} </b-alert> <p> {{ t(\"Please enter your billing information.\") }} <b>{{ t(\"This must match the information on your payment method.\") }}</b> </p> <div class=\"billing-error-messages\"></div> <billing-information v-model=\"billing\" @complete=\"completeStep('billing', $event)\"></billing-information> <div v-if=\"processing\" class=\"text-center\"> <b-spinner :label=\"t('Processing')\"></b-spinner> {{ t(\"Saving billing information, please wait…\") }} </div> </div> <div v-else-if=\"activeStep('payment')\"> <div v-if=\"stepLoading\" class=\"text-center\"> <b-spinner :label=\"t('Processing')\"></b-spinner> {{ t(\"Loading payment information, please wait…\") }} </div> <payment-details v-else ref=\"payment\" v-model=\"complete\" :billing=\"billing\" :providers=\"providers\" :trial=\"trial\" :current=\"currentPaymentDetails\" @input=\"completeStep('payment', $event)\" ></payment-details> </div> <div v-else-if=\"activeStep('preview')\"> <p> {{ t( \"Any downgrades or cancellations will happen at the end of your current subscription period. Any upgrades or additions to your subscription will require immediate payment and will reset your subscription end date. Any unused portion of the current subscription will be credited back to you automatically.\" ) }} </p> <i18n :path=\" t( 'Your subscription will {0} and your payment method will be automatically billed at the end of each billing cycle. You must cancel your subscription before then if you do not wish it to renew automatically.' ) \" tag=\"p\" > <strong>{{ t(\"auto-renew\") }}</strong> </i18n> <i18n v-if=\"trialDaysRemaining\" :path=\" t( 'You are given {0} free trial and the payment for your subscription will only be taken at the end of the trial period. If you cancel your subscription at any time before the first payment is collected, then you will not be charged. {1}You can make any changes to your subscription until the end of your trial, so feel free to try all our options before you lock it in.' ) \" tag=\"p\" > <strong>{{ t(\"TIME.days\", { count: trialDaysRemaining }) }}</strong> <br /> </i18n> <i18n :path=\"t('By proceeding, you agree that you understand and will comply with our {0}.')\" tag=\"p\"> <a href=\"/sales\" target=\"_blank\">{{ t(\"Sales Policy\") }}</a> </i18n> <b-alert variant=\"warning\" :show=\"cancelling\"> {{ t(\"You are cancelling your current subscription for\") }} <b v-html=\"activeSubscriptionDescription\"></b>. <div v-if=\"trialDaysRemaining\"> <i18n :path=\"t('TRIAL.DaysLeftChargeInfo', { daysCount: trialDaysRemaining })\"></i18n> </div> <span v-else> {{ t(\"Access to tier benefits will expire on\") }} <b>{{ expiresDateString }}</b> </span> </b-alert> <div class=\"subscription-manager-body\"> <div v-if=\"preview_invoice\" class=\"m-3\"> <b-alert v-if=\"futureInvoiceDate\" variant=\"warning\" show> <i18n :path=\"t('This is a preview of your {0} that will be billed on {1}.')\"> <strong>{{ t(\"future invoice\") }}</strong> <strong>{{ futureInvoiceDateString }}</strong> </i18n> </b-alert> <payment-invoice :invoice=\"preview_invoice\" :country=\"country\" :exchange-currency=\"currency\" :exchange-rates=\"exchangeRates\" > </payment-invoice> </div> </div> <div v-if=\"stepLoading\" class=\"text-center\"> <b-spinner :label=\"t('Generating order')\"></b-spinner> {{ t(\"Generating Order, please wait…\") }} </div> <div v-if=\"processing\" class=\"text-center\"> <b-spinner :label=\"t('Processing order')\"></b-spinner> {{ t(\"Processing, please wait…\") }} </div> </div> </div> </template> <template #modal-footer=\"{ ok, cancel }\"> <b-row class=\"w-100\"> <b-col class=\"text-left\"> <b-button variant=\"info\" class=\"float-left\" href=\"https://forums.forge-vtt.com/t/how-to-add-change-a-subscription-on-the-forge/13204\" target=\"_blank\" > {{ t(\"Help\") }} <i class=\"fas fa-question-circle\"></i> </b-button> <div v-if=\"showRenewButton\"> <b-button v-b-tooltip.hover variant=\"primary\" class=\"ml-1 float-left\" :title=\"t('Renew current subscription immediately')\" @click=\"renewSubscriptionDialog = true\" > <i class=\"fas fa-redo\"></i> </b-button> <!-- Confirm changing Foundry version --> <confirm-message v-model=\"renewSubscriptionDialog\" :title=\"t('Renew current subscription')\" @ok=\"renewSubscription\" > <p>{{ t(\"Are you sure you want to renew the current subscription?\") }}</p> <p> {{ t( \"Your billing cycle will reset to today, and your subscription will be extended. Any planned downgrades will be cancelled.\" ) }} </p> </confirm-message> </div> </b-col> <b-col class=\"text-right\"> <b-button v-if=\"showCancel\" variant=\"danger\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button v-if=\"showMovePrev\" variant=\"secondary\" :disabled=\"stepLoading || processing\" @click=\"prev\" ><i class=\"fas fa-chevron-left\"></i> {{ prevLabel }}</b-button > <b-button v-if=\"showMoveNext\" variant=\"primary\" :disabled=\"!canMoveNext || stepLoading || processing\" @click=\"next\" >{{ nextLabel }} <i class=\"fas fa-chevron-right\"></i> </b-button> <b-button v-if=\"showFinish\" variant=\"primary\" :disabled=\"stepLoading || processing\" @click=\"finish\" ><i class=\"fas fa-money-bill-wave mr-1\"></i>{{ finishText }}</b-button > <b-button v-if=\"success\" variant=\"success\" @click=\"ok\">{{ t(\"OK\") }}</b-button> <b-button v-if=\"error\" variant=\"danger\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </b-col> </b-row> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".forge-subscription-manager .coupon-input { width: 180px; display: inline-block; } .forge-subscription-manager .billing-cycle { vertical-align: top; font-size: small; }"
    });
  },
  props: {
    value: Boolean,
    tiers: Object,
    extras: Object,
    initialSubscription: String
  },
  data() {
    return {
      dataLoading: true,
      error: "",
      warning: "",
      success: false,
      stepLoading: false,
      processing: false,
      email_verified: true,
      step: 0,
      steps: [{
        code: "plans",
        name: t("Plans"),
        done: false
      }, {
        code: "billing",
        name: t("Billing"),
        done: false
      }, {
        code: "payment",
        name: t("Payment Details"),
        done: false
      }, {
        code: "preview",
        name: t("Confirm"),
        done: false
      }],
      licenses: [],
      coupon: "",
      couponChanged: false,
      // Keeps track to changes in the coupon string to avoid querying validity needlessly
      couponInfo: null,
      couponError: null,
      // need these for plans
      activeExtras: {},
      selectedPlans: {
        hosting: null,
        extras: []
      },
      subscriptions: null,
      trialDays: 0,
      trialDaysRemaining: 0,
      // Math.round(trialDays)

      // need these for payment
      originalBilling: {},
      billing: {},
      providers: {},
      trial: 0,
      complete: true,
      currentPaymentDetails: "",
      paymentInfo: {},
      // need these for preview
      preview_invoice: null,
      country: null,
      currency: "",
      exchangeRates: null,
      futureInvoiceDate: "",
      // need this for the success page
      invoiceURL: "",
      resetBillingCycle: false,
      renewSubscriptionDialog: false
    };
  },
  watch: {
    step(value) {
      this.loadStep(this.steps[value].code);
    },
    coupon() {
      this.couponChanged = true;
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    prevLabel() {
      return t("Previous");
    },
    nextLabel() {
      return t("Next");
    },
    showMovePrev() {
      return this.step != 0 && !this.error && !this.success;
    },
    showMoveNext() {
      return this.step < this.steps.length - 1 && !this.error && !this.success;
    },
    showFinish() {
      return this.step == this.steps.length - 1 && !this.error && !this.success;
    },
    showCancel() {
      // Don't show the cancel button, it's not necessary and causes confusion to users
      return false; // !(this.error || this.success || this.processing || this.dataLoading || this.stepLoading);
    },

    showRenewButton() {
      return !this.dataLoading && this.step === 0 && this.activeSubscription;
    },
    canMoveNext() {
      return this.currentStep.done !== false && this.hasFullLicense && !(this.activeStep("billing") && !this.email_verified);
    },
    currentStep() {
      return this.steps[this.step];
    },
    hasFullLicense() {
      return this.licenses.some(l => l.type === "Full License");
    },
    cancelling() {
      return !this.selectedPlans.hosting || this.selectedPlans.hosting.tier === 0;
    },
    errorMsg() {
      return this.error;
    },
    currentSteps() {
      return this.steps.map(step => {
        return {
          id: step.code,
          name: step.name,
          class: this.indicatorClass(step),
          icon: this.indicatorIcon(step)
        };
      });
    },
    expiresDateString() {
      return this.activeSubscription ? new Date(this.activeSubscription.expires).toDateString() : "";
    },
    trialEndingString() {
      if (this.trialDays >= 2) {
        // t('TIME.days', {count})
        return t('Trial ends in $t(TIME.days, {"count": {{days}} })', {
          days: Math.round(this.trialDays)
        });
      } else if (this.trialEnds > 1) {
        return t("Trial ends tomorrow");
      }
      // t('TIME.hours', {count})
      return t('Trial ends in $t(TIME.hours, {"count": {{hours}} })', {
        hours: Math.round(this.trialDays * 24)
      });
    },
    futureInvoiceDateString() {
      return this.futureInvoiceDate ? new Date(this.futureInvoiceDate).toDateString() : "";
    },
    hostingSubscriptions() {
      return this.subscriptions ? this.subscriptions.filter(sub => sub.type === "hosting") : [];
    },
    extraSubscriptions() {
      return this.subscriptions ? this.subscriptions.filter(sub => sub.type === "extra") : [];
    },
    futureSubscriptions() {
      return this.subscriptions ? this.subscriptions.filter(sub => sub.renew || !sub.active) : [];
    },
    activeSubscription() {
      return this.hostingSubscriptions.find(sub => sub.active) || null;
    },
    pendingSubscription() {
      return this.hostingSubscriptions.find(sub => sub.renew || !sub.active) || null;
    },
    activeSubscriptionName() {
      return this.activeSubscription ? this.tiers[this.activeSubscription.code].name : "";
    },
    pendingSubscriptionName() {
      return this.pendingSubscription ? this.tiers[this.pendingSubscription.code].name : "";
    },
    activeSubscriptionDescription() {
      if (!this.activeSubscription) {
        return "";
      }
      const cycle = ` <span class="billing-cycle">(${this.activeSubscription.cycle === 12 ? t("Yearly") : t("Monthly")})</span>`;
      const extras = this.activeTotalExtras > 0 ? ` + ${t("{{count}} Extra", {
        count: this.activeTotalExtras
      })}` : "";
      return this.activeSubscriptionName + extras + cycle;
    },
    pendingSubscriptionDescription() {
      if (!this.pendingSubscription) {
        return "";
      }
      const cycle = ` <span class="billing-cycle">(${this.pendingSubscription.cycle === 12 ? t("Yearly") : t("Monthly")})</span>`;
      const extras = this.pendingTotalExtras > 0 ? ` + ${t("{{count}} Extra", {
        count: this.pendingTotalExtras
      })}` : "";
      return this.pendingSubscriptionName + extras + cycle;
    },
    activeExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.active);
    },
    pendingExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.renew || !sub.active);
    },
    activeTotalExtras() {
      return this.activeExtraSubscriptions.reduce((total, sub) => total + sub.quantity, 0);
    },
    pendingTotalExtras() {
      return this.pendingExtraSubscriptions.reduce((total, sub) => total + sub.quantity, 0);
    },
    hasDowngrades() {
      return this.subscriptions.some(sub => !sub.renew);
    },
    validCoupon() {
      if (this.couponError) {
        return false;
      }
      if (this.couponInfo) {
        return true;
      }
      return null;
    },
    couponCode() {
      return this.validCoupon ? this.couponInfo.code : undefined;
    },
    couponName() {
      return this.validCoupon ? this.couponInfo.name : "";
    },
    finishText() {
      return this.futureInvoiceDate || this.cancelling ? t("Confirm changes") : t("Confirm Subscription");
    }
  },
  methods: {
    hideModal() {
      this.visible = false;
      if (this.success) {
        window.location.reload();
      }
    },
    async reset() {
      this.step = 0;
      this.success = false;
      this.error = false;
      this.processing = false;
      this.stepLoading = false;
      this.dataLoading = true;
      this.resetBillingCycle = false;
      for (let step of this.steps) {
        step.done = false;
      }
      const info = await Utils.api("subscription");
      if (!info || info.error) {
        this.error = t("Error retrieving your subscription's information: {{- error}}", {
          error: info ? info.error : t("Unknown error")
        });
      } else {
        try {
          this.subscriptions = info.subscriptions.filter(s => s.renewable).map(sub => {
            sub.expirationDate = new Date(sub.expires).toDateString();
            if (sub.code === "data-quota") {
              sub.name = t("Extra Game Data");
              sub.size = 536870912;
            } else if (sub.code === "assets-quota") {
              sub.name = t("Extra Assets");
              sub.size = 5368709120;
            } else if (sub.code === "upload-limit") {
              sub.name = t("Extra Upload Limit");
              sub.size = 52428800;
            } else {
              sub.name = {
                player: t("Player"),
                "game-master": t("Game Master"),
                "story-teller": t("Story Teller"),
                "world-builder": t("World Builder")
              }[sub.code];
            }
            if (sub.status === "trialing") {
              sub.name += ` ${t("Trial")}`;
            }
            sub.cycleText = sub.cycle === 1 ? t("monthly") : t("yearly");
            sub.update = {};
            return sub;
          });
          // this.hosting = subscriptions.filter((sub) => sub.type === "hosting");
          // this.extras = subscriptions.filter((sub) => sub.type === "extra");

          /*
          this.activeExtras = Object.assign(
            { "data-quota": 0, "assets-quota": 0, "upload-limit": 0 },
            this.activeExtraSubscriptions.reduce((a, v) => ({ ...a, [v.code]: v.quantity }), {})
          );*/

          this.selectedPlans = {
            hosting: Utils.duplicate(this.pendingSubscription),
            extras: Utils.duplicate(this.pendingExtraSubscriptions)
          };
          this.licenses = info.licenses;
          this.billing = info.billing;
          this.originalBilling = Utils.duplicate(this.billing || {});
          this.email_verified = info.email_verified;
          this.trialDays = info.trial_days;
          this.trialDaysRemaining = Math.round(info.trial_days);
        } catch (err) {
          console.log("Error", err);
          this.error = err.message;
        }
      }
      this.dataLoading = false;
    },
    async next() {
      try {
        const newStep = this.step + (await this.processStep());
        this.step = newStep;
      } catch (err) {
        this.error = err.message;
      }
    },
    prev() {
      while (this.step > 0) {
        if (this.steps[this.step].done !== "bypass") {
          this.steps[this.step].done = false;
        }
        this.step--;
        if (this.steps[this.step].done !== "bypass") {
          break;
        }
      }
    },
    async finish() {
      this.processing = true;
      const changes = this.getPlanChanges(this.selectedPlans);
      const options = {
        commit: true,
        coupon: this.couponCode,
        resetBillingCycle: this.resetBillingCycle
      };
      const update = await Utils.api("subscription", {
        changes,
        options
      });
      this.processing = false;
      if (!update || update.error) {
        this.error = t("Error updating your subscriptions: {{- error}}", {
          error: update ? update.error : t("Unknown error")
        });
      } else {
        this.invoiceURL = update.url;
        this.success = true;
        this.steps[this.steps.length - 1].done = true;
      }
    },
    async loadStep(step) {
      this.stepLoading = true;
      this.warning = "";
      switch (step || this.currentStep.code) {
        case "payment":
          {
            this.paymentInfo = await Utils.api("subscription/payment");
            if (!this.paymentInfo || this.paymentInfo.error) {
              this.error = t("Error retrieving payment information: {{- error}}", {
                error: this.paymentInfo ? this.paymentInfo.error : t("Unknown error")
              });
            } else {
              this.providers = this.paymentInfo.providers;
              this.trial = this.paymentInfo.trialDays;
              this.complete = false;
              this.currentPaymentDetails = this.paymentInfo.current;
              this.currency = this.paymentInfo.currency || null;
              this.exchangeRates = this.paymentInfo.exchangeRates || null;
            }
          }
          break;
        case "preview":
          {
            this.preview_invoice = null;
            const changes = this.getPlanChanges(this.selectedPlans);
            if (this.selectedPlans.hosting && this.selectedPlans.hosting.tier != 0) {
              const options = {
                preview: true,
                coupon: this.couponCode,
                resetBillingCycle: this.resetBillingCycle
              };
              const update = await Utils.api("subscription", {
                changes,
                options
              });
              if (!update || update.error) {
                this.error = t("Error updating your subscriptions: {{- error}}", {
                  error: update ? update.error : t("Unknown error")
                });
              } else {
                if (update.ip_country !== this.billing.country) {
                  this.warning = t(`The country you selected in your billing address does not match your IP Address origin. You may be required to provide additional evidence on your location for VAT purposes`);
                }

                // Consider the invoice as a preview for a future change if it's date more than 1 hour from now (to compensate for user's possible mismatched clock)
                const futureInvoice = update.preview && update.preview.created * 1000 - Date.now() > 3600 * 100;
                this.futureInvoiceDate = futureInvoice && new Date(update.preview.created * 1000).toString();
                this.preview_invoice = update.preview || null;
                this.country = update.country || null;
              }
            }
          }
          break;
      }
      this.stepLoading = false;
    },
    async processStep(step) {
      let result = 1;
      this.processing = true;
      this.warning = "";
      switch (step || this.currentStep.code) {
        case "plans":
          {
            // If we're cancelling then jump to the last step
            if (this.selectedPlans.hosting && this.selectedPlans.hosting.tier === 0) {
              this.steps[1].done = this.steps[2].done = "bypass";
              result = 3; // move ahead 3 steps
            }
          }

          break;
        case "billing":
          {
            if (!Utils.objectsAreEqual(this.originalBilling, this.billing)) {
              const updated = await Utils.api("profile", {
                billing: this.billing
              });
              if (!updated || updated.error) {
                throw new Error(t(`Error updating your billing information: {{- error}}`, {
                  error: updated ? updated.error : t("Unknown Error")
                }));
              }
            }
          }
          break;
        case "payment":
          {
            result = await this.$refs.payment.submitPayment();
            if (!result) {
              this.error = t("Error Processing Payment");
            }
          }
          break;
      }
      this.processing = false;
      return result;
    },
    activeStep(step) {
      return this.currentStep.code === step;
    },
    completeStep(code, done = false) {
      const step = this.steps.find(s => s.code == code);
      if (step) {
        step.done = done;
      }
    },
    clickStep(code) {
      // Can't switch steps after completion
      if (this.error || this.success) {
        return;
      }
      const idx = this.steps.findIndex(s => s.code == code);
      // Can only move to a step if the step can be found and it's a previous one
      if (idx == -1 || idx >= this.step) {
        return;
      }
      // can't move to a bypassed step isn't being bypassed
      if (this.steps[idx].done === "bypass") {
        return;
      }
      this.step = idx;
      // Clear out 'done' flag on steps that come after the one we're changing to
      for (let i = idx; i < this.steps.length; i++) {
        this.steps[i].done = false;
      }
    },
    indicatorClass(step) {
      if (this.activeStep(step.code) && !this.success && !this.error) {
        return "indicator active";
      }
      if (step.done === "bypass") {
        return "indicator inactive";
      } else if (step.done !== false) {
        return "indicator success";
      }
      return "indicator";
    },
    indicatorIcon(step) {
      if (step.done === "bypass") {
        return "fas fa-minus";
      }
      if (step.done !== false) {
        return "fas fa-check";
      }
      if (this.activeStep(step.code)) {
        return "fas fa-pen";
      }
      return "fas fa-dot-circle";
    },
    openLicenseManager() {
      this.$emit("open-license");
    },
    renewPlan() {
      this.selectedPlans.hosting = Utils.duplicate(this.activeSubscription);
      this.selectedPlans.hosting.renew = true;
      this.selectedPlans.extras = Utils.duplicate(this.activeExtraSubscriptions).map(extra => Object.assign(extra, {
        renew: true
      }));
      // this.next();
    },

    getPlanChanges(plans) {
      // Needs a list of objects with either : `add` or `update`
      // They need to represent the full status of the subscription to change to
      // `add` expects fields : type, code, cycle, quantity (for extras)
      // `update` expects fields : type, code, cycle, renew, quantity (for extras)
      const updates = [];
      if (this.activeSubscription && this.cancelling) {
        // We're cancelling our sub
        updates.push({
          update: {
            type: this.activeSubscription.type,
            code: this.activeSubscription.code,
            cycle: this.activeSubscription.cycle,
            renew: false
          }
        });
      } else if (!this.activeSubscription && !this.cancelling) {
        // We're creating a new sub
        updates.push({
          add: {
            code: plans.hosting.code,
            type: plans.hosting.type,
            cycle: plans.hosting.cycle,
            renew: true
          }
        });
      } else {
        // We're updating our sub
        updates.push({
          update: {
            code: plans.hosting.code,
            type: plans.hosting.type,
            cycle: plans.hosting.cycle,
            renew: true
          }
        });
      }
      for (let code of ["data-quota", "assets-quota", "upload-limit"]) {
        let currentExtra = this.activeExtraSubscriptions.find(extra => extra.code === code);
        let selectedExtra = plans.extras.find(extra => extra.code === code);
        if (currentExtra) {
          updates.push({
            update: {
              code: code,
              type: this.extras[code].type,
              quantity: selectedExtra ? selectedExtra.quantity : currentExtra.quantity,
              cycle: selectedExtra ? selectedExtra.cycle : currentExtra.cycle,
              renew: !!(selectedExtra && selectedExtra.quantity > 0)
            }
          });
        } else if (selectedExtra && selectedExtra.quantity > 0) {
          updates.push({
            add: {
              code: code,
              type: this.extras[code].type,
              quantity: selectedExtra.quantity,
              cycle: selectedExtra.cycle,
              renew: true
            }
          });
        }
      }
      return updates;
    },
    async checkCoupon() {
      if (!this.couponChanged) {
        return;
      }
      if (this.coupon != "") {
        const response = await Utils.api("subscription/coupon", {
          code: this.coupon
        });
        if (!response || response.error || response.coupon == undefined) {
          this.couponError = response && response.error || t("Unknown error");
        } else {
          this.couponError = null;
          this.couponInfo = response.coupon;
          this.coupon = this.couponInfo.code;
        }
      } else {
        this.couponError = null;
        this.couponInfo = null;
      }
      this.$nextTick(() => this.couponChanged = false);
    },
    couponInputKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.checkCoupon();
      } else {
        this.couponInfo = null;
        this.couponError = null;
      }
    },
    renewSubscription() {
      this.renewSubscriptionDialog = false;
      this.renewPlan();
      this.resetBillingCycle = true;
      this.currentStep.done = true;
      this.next();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SubscriptionPlans"] = Vue.component(
                    "SubscriptionPlans",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"forge-subscription-plans\"> <b-card-group deck> <b-card v-for=\"tier in showTiers\" :key=\"tier.code\" :header-bg-variant=\"subscriptionBG(tier.code)\" :header-text-variant=\"subscriptionText(tier.code)\" :border-variant=\"subscriptionBorder(tier.code)\" :header-border-variant=\"subscriptionBorder(tier.code)\" class=\"text-center subscription-plan mb-1\" @click.prevent=\"addHosting(tier.code)\" > <template #header> {{ tier.name }} <span v-if=\"tier.ribbon\" v-b-tooltip.hover.right=\"tier.ribbon\" class=\"attract-star\"> <i class=\"fas fa-star\"></i> </span> </template> <template> <img class=\"align-self-center\" :src=\"`/images/${tier.code}-512x512.png`\" width=\"100px\" height=\"100px\" /> <div> <b>{{ tier.tagline }}</b> </div> </template> <template #footer> <b-button-group vertical class=\"w-100\"> <b-button v-for=\"(plan, planCode) in tier.plans\" :key=\"planCode\" v-b-tooltip.hover.right=\"subscriptionTooltip(tier.code, planCode)\" class=\"plan-button\" :variant=\"subscriptionPlanVariant(tier.code, plan.cycle)\" :disabled=\"!subscriptionAllowed(tier.code, plan.cycle)\" @click.prevent.stop=\"addHosting(tier.code, planCode)\" > <span v-html=\"cycleText(plan)\"></span> <!-- We need to use a div to show our tooltip in a disabled button otherwise they don't show and we can't wrap it in a div because the button-group needs the buttons to be immediate children We use CSS to make sure the div is covering our disabled button --> <div v-if=\"!subscriptionAllowed(tier.code, plan.cycle)\" v-b-tooltip.hover.right=\"subscriptionTooltip(tier.code, planCode)\" ></div> </b-button> </b-button-group> </template> </b-card> </b-card-group> <div class=\"text-center m-3\"> <a href=\"/plans\" target=\"_blank\">{{ t(\"Compare plans\") }} <i class=\"fas fa-external-link-alt\"></i></a> </div> <div class=\"extras-details\"> <div class=\"my-2\">{{ t(\"Account Quotas:\") }}</div> <b-row class=\"extra-row\"> <b-col class=\"extra-label\"> <div class=\"quota-name\"> <strong> Game Storage <help-icon url=\"https://forums.forge-vtt.com/docs?category=21&amp;topic=15307\" :tooltip=\"tipData\" :html=\"true\" ></help-icon> </strong> </div> <div class=\"quota-cost\"> <small><i>$</i>12.99/{{ t(\"year per 500MB\") }}</small> </div> </b-col> <b-col class=\"extra-controls\"> <b-row> <b-col> <b-input-group :prepend=\"tierQuota('data-quota')\" :append=\"tierQuotaMax('data-quota')\"> <b-form-input v-model=\"quota_data\" type=\"range\" min=\"0\" :max=\"maxExtraQty\" step=\"1\" :formatter=\"extraQuantityFormatter('data-quota')\" :disabled=\"!canAddData\" ></b-form-input> <div class=\"extra-current\"> <div v-if=\"pendingExtraSubscriptionQuantity('data-quota') > 0 && canAddData\" :style=\"{ left: pendingExtraLeft('data-quota') }\" ></div> </div> </b-input-group> </b-col> <b-col cols=\"2\" class=\"extra-results pt-2\"> <b-row> <b-col cols=\"6\" class=\"p-0\"> <b-badge :variant=\"extraBG('data-quota')\">{{ extraQuota(\"data-quota\") }}</b-badge> </b-col> <b-col cols=\"6\" class=\"text-right\"> ${{ quotaCost(\"data-quota\").toFixed(2) }} </b-col> </b-row> </b-col> </b-row> </b-col> </b-row> <b-row class=\"extra-row\"> <b-col class=\"extra-label\"> <div class=\"quota-name\"> <strong> Assets <help-icon url=\"https://forums.forge-vtt.com/docs?category=21&amp;topic=15307\" :tooltip=\"tipAssets\" :html=\"true\" ></help-icon> </strong> </div> <div class=\"quota-cost\"> <small><i>$</i>12.99/{{ t(\"year per 5GB\") }}</small> </div> </b-col> <b-col class=\"extra-controls\"> <b-row> <b-col> <b-input-group :prepend=\"tierQuota('assets-quota')\" :append=\"tierQuotaMax('assets-quota')\"> <b-form-input v-model=\"quota_assets\" type=\"range\" min=\"0\" :max=\"maxExtraQty\" step=\"1\" :formatter=\"extraQuantityFormatter('assets-quota')\" :disabled=\"!canAddData\" ></b-form-input> <div class=\"extra-current\"> <div v-if=\"pendingExtraSubscriptionQuantity('assets-quota') > 0 && canAddData\" :style=\"{ left: pendingExtraLeft('assets-quota') }\" ></div> </div> </b-input-group> </b-col> <b-col cols=\"2\" class=\"extra-results pt-2\"> <b-row> <b-col cols=\"6\" class=\"p-0\"> <b-badge :variant=\"extraBG('assets-quota')\">{{ extraQuota(\"assets-quota\") }}</b-badge> </b-col> <b-col cols=\"6\" class=\"text-right\"> ${{ quotaCost(\"assets-quota\").toFixed(2) }} </b-col> </b-row> </b-col> </b-row> </b-col> </b-row> <b-row class=\"extra-row\"> <b-col class=\"extra-label\"> <div class=\"quota-name\"> <strong>Upload Limit</strong> <help-icon :tooltip=\"t('Limit per file applies to Asset uploads only')\"></help-icon> </div> <div class=\"quota-cost\"> <small>$5.99/{{ t(\"year per 50MB\") }}</small> </div> </b-col> <b-col class=\"extra-controls\"> <b-row> <b-col> <b-input-group :prepend=\"tierQuota('upload-limit')\" :append=\"tierQuotaMax('upload-limit')\"> <b-form-input v-model=\"quota_upload\" type=\"range\" min=\"0\" :max=\"maxExtraQty\" step=\"1\" :formatter=\"extraQuantityFormatter('upload-limit')\" :disabled=\"!canAddData\" ></b-form-input> <div class=\"extra-current\"> <div v-if=\"pendingExtraSubscriptionQuantity('upload-limit') > 0 && canAddData\" :style=\"{ left: pendingExtraLeft('upload-limit') }\" ></div> </div> </b-input-group> </b-col> <b-col cols=\"2\" class=\"extra-results pt-2\"> <b-row> <b-col cols=\"6\" class=\"p-0\"> <b-badge :variant=\"extraBG('upload-limit')\">{{ extraQuota(\"upload-limit\") }}</b-badge> </b-col> <b-col cols=\"6\" class=\"text-right\"> ${{ quotaCost(\"upload-limit\").toFixed(2) }} </b-col> </b-row> </b-col> </b-row> </b-col> </b-row> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".forge-subscription-plans .subscription-plan .plan-button:disabled { cursor: no-drop; } .forge-subscription-plans .subscription-plan .plan-button:disabled > div { position: absolute; top: 0; left: 0; z-index: 10; width: 100%; height: 100%; } .forge-subscription-plans .extras-details .input-group-prepend, .forge-subscription-plans .extras-details .input-group-append { flex: 0 0 120px; } .forge-subscription-plans .extras-details .input-group-prepend .input-group-text, .forge-subscription-plans .extras-details .input-group-append .input-group-text { flex: 1; justify-content: flex-end; } .forge-subscription-plans .extras-details .quota-name { line-height: 20px; } .forge-subscription-plans .extras-details .quota-cost { line-height: 5px; } .forge-subscription-plans .extras-details .badge { font-size: 1rem; width: 100%; text-align: right; } .forge-subscription-plans .card.subscription-plan { min-width: 254px; } .forge-subscription-plans .extra-row { flex-wrap: wrap; } .forge-subscription-plans .extra-label { flex: 0 0 190px; height: 38px; } .forge-subscription-plans .extra-controls { min-width: 650px; } .forge-subscription-plans .extra-controls .input-group-prepend, .forge-subscription-plans .extra-controls .input-group-append { max-height: 38px; } .forge-subscription-plans .extra-controls input[type=\"range\"] { height: 38px; } .forge-subscription-plans .extra-results { flex: 0 0 200px; max-width: 200px; } .forge-subscription-plans .attract-star { color: #ffc107; } .forge-subscription-plans .extra-current { position: absolute; left: 140px; width: calc(100% - 280px); height: 38px; pointer-events: none; z-index: 900; } .forge-subscription-plans .extra-current > div { position: absolute; width: 16px; height: 16px; border-radius: 100%; top: 11px; margin-left: -8px; border: 1px solid #007bff; }"
    });
  },
  props: {
    value: Object,
    tiers: Object,
    extras: Object,
    subscriptions: Array,
    initialSubscription: String
  },
  data() {
    return {
      maxExtraQty: 5
    };
  },
  watch: {
    complete() {
      this.$emit("complete", this.complete);
    }
  },
  computed: {
    selectPlan: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    complete() {
      return this.selectedSubscription.code != this.pendingSubscription.code || this.selectedSubscription.cycle != this.pendingSubscription.cycle || this.selectedExtraSubscriptionQuantity("data-quota") != this.pendingExtraSubscriptionQuantity("data-quota") || this.selectedExtraSubscriptionQuantity("assets-quota") != this.pendingExtraSubscriptionQuantity("assets-quota") || this.selectedExtraSubscriptionQuantity("upload-limit") != this.pendingExtraSubscriptionQuantity("upload-limit");
    },
    showTiers() {
      const sortedTiers = [];
      for (const [k, v] of Object.entries(this.tiers)) {
        if (v.available) {
          sortedTiers.push(v);
        }
      }
      sortedTiers.sort((a, b) => a.cost - b.cost);
      return sortedTiers;
    },
    hasHosting() {
      return this.selectedSubscription;
    },
    tipAssets() {
      return t("The Assets Library contains all the images, videos and music used by your games.<br/><em>Click for more information</em>");
    },
    tipData() {
      return t("Only the world's databases and compendiums reside in the Game Storage area.<br/><em>Click for more information</em>");
    },
    quota_data: {
      get() {
        if (!this.canAddData) {
          if (this.selectedExtraSubscription("data-quota")) {
            this.selectedExtraSubscription("data-quota").quantity = 0;
          }
          return 0;
        }
        return this.selectedExtraSubscriptionQuantity("data-quota");
      },
      set(value) {
        if (!this.selectedExtraSubscription("data-quota")) {
          this.selectPlan.extras.push({
            code: "data-quota",
            quantity: value
          });
        } else {
          this.selectedExtraSubscription("data-quota").quantity = value;
        }
      }
    },
    quota_assets: {
      get() {
        if (!this.canAddData) {
          if (this.selectedExtraSubscription("assets-quota")) {
            this.selectedExtraSubscription("assets-quota").quantity = 0;
          }
          return 0;
        }
        return this.selectedExtraSubscriptionQuantity("assets-quota");
      },
      set(value) {
        if (!this.selectedExtraSubscription("assets-quota")) {
          this.selectPlan.extras.push({
            code: "assets-quota",
            quantity: 0
          });
        }
        this.selectedExtraSubscription("assets-quota").quantity = value;
      }
    },
    quota_upload: {
      get() {
        if (!this.canAddData) {
          if (this.selectedExtraSubscription("upload-limit")) {
            this.selectedExtraSubscription("upload-limit").quantity = 0;
          }
          return 0;
        }
        return this.selectedExtraSubscriptionQuantity("upload-limit");
      },
      set(value) {
        if (!this.selectedExtraSubscription("upload-limit")) {
          this.selectPlan.extras.push({
            code: "upload-limit",
            quantity: 0
          });
        }
        this.selectedExtraSubscription("upload-limit").quantity = value;
      }
    },
    canAddData() {
      return this.selectedSubscription.tier > 1 && this.selectedSubscription.cycle == 12;
    },
    hostingSubscriptions() {
      return this.subscriptions.filter(sub => sub.type === "hosting");
    },
    extraSubscriptions() {
      return this.subscriptions.filter(sub => sub.type === "extra");
    },
    activeSubscription() {
      return this.hostingSubscriptions.find(sub => sub.active) || this.defaultSubscription;
    },
    pendingSubscription() {
      // Returning the pending subscription or the default 'player' subscription if none is pending
      return this.hostingSubscriptions.find(sub => sub.renew || !sub.active) || (!this.activeSubscription.renew ? this.defaultSubscription : null);
    },
    selectedSubscription() {
      return this.selectPlan.hosting && this.selectPlan.hosting.renew ? this.selectPlan.hosting : this.defaultSubscription;
    },
    defaultSubscription() {
      return Object.assign({
        renew: false
      }, this.tiers["player"], this.tiers["player"].plans.free);
    },
    activeExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.active);
    },
    pendingExtraSubscriptions() {
      return this.extraSubscriptions.filter(sub => sub.renew || !sub.active);
    },
    hasUpgrades() {
      return this.selectedSubscription.tier > this.activeSubscription.tier;
    }
  },
  methods: {
    cycleText(plan) {
      if (plan.cost == 0) {
        return this.pendingSubscription.tier > 1 ? t("Cancel Subscription") : plan.cycleText;
      }
      if (plan.cycle == 1) {
        return `$${plan.cost.toFixed(2)}&nbsp;${plan.cycleText}`;
      }
      return `~$${plan.costText || plan.cost}/<small>month</small>&nbsp;${plan.cycleText}`;
    },
    subscriptionBG(tier) {
      if (this.pendingSubscription.code !== tier) {
        if (this.selectedSubscription.code == tier) {
          return tier === "player" ? "danger" : "success";
        }
      }
    },
    subscriptionBorder(tier) {
      if (this.pendingSubscription.code == tier) {
        return "primary"; // this.selectedSubscription.code != this.pendingSubscription.code ? "primary" : "";
      }

      if (this.selectedSubscription.code == tier) {
        return tier === "player" ? "danger" : "success";
      }
    },
    subscriptionText(tier) {
      if (this.pendingSubscription.code == tier) {
        return ""; //primary"; // this.selectedSubscription.code != this.pendingSubscription.code ? "primary" : "white";
      }

      return this.selectedSubscription.code == tier ? "white" : "";
    },
    subscriptionPlanVariant(tier, cycle) {
      // if it's changing then success and outline-primary
      if (this.pendingSubscription.code == tier) {
        if (this.selectedSubscription.code == this.pendingSubscription.code) {
          // tier hasn't changed
          if (this.selectedSubscription.cycle == this.pendingSubscription.cycle) {
            return this.pendingSubscription.cycle == cycle ? "primary" : "outline-primary";
          }
          return this.selectedSubscription.cycle == cycle ? "success" : "outline-primary";
        }
        // tier has changed
        return this.pendingSubscription.cycle == cycle ? "outline-primary" : "outline-info";
      } else if (this.selectedSubscription.code == tier) {
        if (cycle == this.selectedSubscription.cycle && tier === "player") {
          return "danger";
        }
        return cycle != this.selectedSubscription.cycle ? "outline-success" : "success";
      } else if (this.activeSubscription.code == tier && this.activeSubscription.cycle == cycle && !this.activeSubscription.renew) {
        return "outline-info";
      }
      if (tier === "player") {
        return "outline-danger";
      }
      return "outline-info";
    },
    subscriptionTooltip(tier, cycleCode) {
      const plans = this.tiers[tier].plans;
      const plan = plans[cycleCode];
      if (!this.subscriptionAllowed(tier, plan.cycle)) {
        return "Cannot upgrade plan while downgrading cycle";
      }
      // if (this.activeSubscription.code == tier && this.activeSubscription.cycle == plan.cycle && !this.activeSubscription.renew)
      //  return "Renew";
      if (plan.cycle > 1) {
        return `Total cost \$${plan.cost}`;
      }
      return "";
    },
    subscriptionAllowed(tier, cycle) {
      return this.tiers[tier].tier <= this.activeSubscription.tier || cycle >= this.activeSubscription.cycle || this.activeSubscription.status == "trialing";
    },
    extraQtyToQuota(type, planCode, qty) {
      return this.tiers[planCode].quotas[type] + qty * this.extras[type].step * this.extras[type].factor;
    },
    tierQuota(type) {
      return Utils.bytesToHuman(this.extraQtyToQuota(type, this.selectedSubscription.code, 0));
    },
    tierQuotaMax(type) {
      return Utils.bytesToHuman(this.extraQtyToQuota(type, this.selectedSubscription.code, this.maxExtraQty));
    },
    extraQuota(type) {
      return Utils.bytesToHuman(this.extraQtyToQuota(type, this.selectedSubscription.code, this.selectedExtraSubscriptionQuantity(type)));
    },
    extraBG(type) {
      if (!this.canAddData) {
        return "";
      }
      if (this.selectedExtraSubscriptionQuantity(type) != this.pendingExtraSubscriptionQuantity(type)) {
        return "success";
      }
      return this.selectedExtraSubscriptionQuantity(type) != 0 ? "primary" : "";
    },
    quotaCost(extra) {
      if (!this.canAddData) {
        return 0;
      }
      return this.selectedExtraSubscriptionQuantity(extra) * this.extras[extra].cost;
    },
    extraQuantityFormatter(type) {
      // make sure that you can set this value, can't downgrade if the tier is upgrading
      return value => {
        value = parseInt(value);
        if (this.hasUpgrades && value < this.activeExtraSubscriptionQuantity(type)) {
          // When upgrading, the user is allowed to downgrade the extras as long as the overall quota amount
          // does not decrease.
          const currentQuota = this.extraQtyToQuota(type, this.activeSubscription.code, this.activeExtraSubscriptionQuantity(type));
          const maxValue = parseInt((currentQuota - this.tiers[this.selectedSubscription.code].quotas[type]) / (this.extras[type].step * this.extras[type].factor));
          return Math.max(value, maxValue);
        }
        return value;
      };
    },
    pendingExtraLeft(extra) {
      return `${this.pendingExtraSubscriptionQuantity(extra) * (100 / this.maxExtraQty)}%`;
    },
    activeExtraSubscription(type) {
      return this.activeExtraSubscriptions.find(extra => extra.code == type);
    },
    pendingExtraSubscription(type) {
      return this.pendingExtraSubscriptions.find(extra => extra.code == type);
    },
    selectedExtraSubscription(type) {
      return this.selectPlan.extras.find(extra => extra.code == type);
    },
    activeExtraSubscriptionQuantity(type) {
      const extra = this.activeExtraSubscription(type);
      return extra && extra.quantity || 0;
    },
    pendingExtraSubscriptionQuantity(type) {
      const extra = this.pendingExtraSubscription(type);
      return extra && extra.quantity || 0;
    },
    selectedExtraSubscriptionQuantity(type) {
      const extra = this.selectedExtraSubscription(type);
      return extra && extra.quantity || 0;
    },
    addHosting(tierCode, cycleCode) {
      if (this.tiers[tierCode] == undefined) {
        return;
      }
      const plans = this.tiers[tierCode].plans;
      if (!cycleCode) {
        // User has clicked on the tier rather than the plan,
        // check to see if there's a current cycle selected
        cycleCode = Object.keys(plans).find(key => plans[key].cycle === this.selectedSubscription.cycle);
      }
      // Default to yearly if the plan is not selected or is not allowed
      if (!cycleCode || !this.subscriptionAllowed(tierCode, plans[cycleCode].cycle)) {
        cycleCode = Object.keys(plans)[Object.keys(plans).length - 1] || "yearly";
      }
      if (tierCode == this.selectedSubscription.code && plans[cycleCode].cycle == this.selectedSubscription.cycle) {
        if (!this.selectedSubscription.renew) {
          this.selectedSubscription.renew = true;
        }
      } else {
        const host = Utils.duplicate(this.tiers[tierCode]);
        const plan = plans[cycleCode];
        delete host.plans;
        const expires = plan.cycle === 0 ? null : Date.now() + plan.cycle * MONTH_MS;
        const newPlan = Object.assign({}, host, plan, {
          quantity: 1,
          active: true,
          renew: true,
          expires: expires,
          expirationDate: new Date(expires).toDateString()
        });
        this.selectPlan.hosting = newPlan;

        // Fix value of extras, preventing abusive downgrade
        if (this.tiers[tierCode].tier > this.activeSubscription.tier) {
          for (let type in this.extras) {
            const extra = this.selectedExtraSubscription(type);
            if (extra) {
              const formatter = this.extraQuantityFormatter(type);
              extra.quantity = formatter(extra.quantity);
            }
          }
        }
      }
    }
  },
  mounted() {
    this.$emit("complete", this.complete);
    if (this.initialSubscription) {
      this.addHosting(this.initialSubscription, t("yearly"));
      this.$emit("remove-inital");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["UserQuotas"] = Vue.component(
                    "UserQuotas",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"quotas\" class=\"user-quotas list-group\"> <!-- Game data quota --> <div :class=\"compact ? 'd-flex align-items-center' : null\"> <label class=\"mt-0\">{{ t(\"Game Data\") }}</label> <b-badge v-if=\"compact\" pill :variant=\"dataColor\">{{ quotas.data.percent }}%</b-badge> <b-progress v-else class=\"position-relative\" :max=\"quotas.data.total\"> <b ><outlined-text center :text=\"`${Utils.bytesToHuman(quotas.data.used)} / ${Utils.bytesToHuman(quotas.data.total)}`\" /></b> <b-progress-bar :value=\"quotas.data.used\" :variant=\"dataColor\"></b-progress-bar> </b-progress> </div> <!-- Assets library quota --> <div :class=\"compact ? 'd-flex align-items-center' : null\"> <label>{{ t(\"Assets Library\") }}</label> <b-badge v-if=\"compact\" pill :variant=\"assetsColor\">{{ quotas.assets.percent }}%</b-badge> <b-progress v-else class=\"position-relative\" :max=\"quotas.assets.total\"> <b ><outlined-text center :text=\"`${Utils.bytesToHuman(quotas.assets.used)} / ${Utils.bytesToHuman(quotas.assets.total)}`\" /></b> <b-progress-bar :value=\"quotas.assets.used\" :variant=\"assetsColor\"></b-progress-bar> </b-progress> </div> <!-- Maximum asset file upload size --> <div v-if=\"showMaxSize && !compact\"> <label>{{ t(\"ASSETS.MaxUploadLabel\") }}</label> <i18n :path=\"t('ASSETS.MaxUploadSize')\" class=\"mb-0\" tag=\"p\"> <b>{{ Utils.bytesToHuman(quotas.upload) }}</b> </i18n> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".user-quotas .badge-pill { margin-left: 0.5em; height: 1.5em; } .user-quotas label { font-weight: bold; font-size: 0.9em; margin: 1em 0 0.25em 0; } .user-quotas > .d-flex > label { margin: 0; }"
    });
  },
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    showMaxSize: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    quotas: null
  }),
  computed: {
    dataColor() {
      return this.getPercentageColor(this.quotas.data.percent);
    },
    assetsColor() {
      return this.getPercentageColor(this.quotas.assets.percent);
    }
  },
  methods: {
    getPercentageColor(percent) {
      if (percent <= 60) {
        return "success";
      }
      return percent <= 85 ? "warning" : "danger";
    }
  },
  async mounted() {
    const quotas = await Utils.api("quotas");
    quotas.data.percent = quotas.data.total === 0 ? 100 : Math.round(100 * quotas.data.used / quotas.data.total);
    quotas.assets.percent = quotas.assets.total === 0 ? 100 : Math.round(100 * quotas.assets.used / quotas.assets.total);
    this.quotas = quotas;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Admin2faPrompt"] = Vue.component(
                    "Admin2faPrompt",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<security2fa-code-request v-model=\"visible\" :type=\"codeRequestType\" @submit=\"submitAdminOtp\"> </security2fa-code-request>",
  data() {
    return {
      visible: true,
      codeRequestType: Enums.CodeRequestTypes.ADMIN_ACCESS
    };
  },
  watch: {
    visible() {
      this.$emit("done", null);
    }
  },
  methods: {
    async submitAdminOtp(code) {
      const response = await Utils.api("administration/otp", {
        authCode: code
      });
      this.$emit("done", response);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminBazaarPromotion"] = Vue.component(
                    "AdminBazaarPromotion",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article :class=\"{ 'admin__bazaar-promotion': true, 'admin__bazaar-promotion--hidden': !visible, 'admin__bazaar-promotion--expired': expired, 'admin__bazaar-promotion--editor-active': isSelectedForEdit, }\" :aria-hidden=\"isFiltered\" > <span class=\"grip\"><i class=\"fas fa-grip-horizontal\"></i></span> <div class=\"admin__bazaar-promotion__content\"> <img :src=\"art\" :alt=\"altText\" /> <div class=\"admin__bazaar-promotion__alt-text\">{{ altText }}</div> <menu class=\"admin__bazaar-promotion__controls\"> <li v-if=\"expired\" v-b-tooltip=\"t('Expired')\" :aria-label=\"t('Expired')\"> <i class=\"fas fa-calendar-times text-danger admin__bazaar-promotion__expired-icon\" aria-role=\"presentational\" ></i> </li> <li> <button-with-tooltip :tooltip=\"t('Toggle visibility')\" size=\"sm\" variant=\"primary\" :icon=\"`fas fa-eye${visible ? '' : '-slash'}`\" @click=\"$emit('toggle', id)\" ></button-with-tooltip> </li> <li> <button-with-tooltip :tooltip=\"t('Edit')\" size=\"sm\" variant=\"primary\" icon=\"fas fa-pencil-alt\" @click=\"$emit('edit', id)\" ></button-with-tooltip> </li> <li> <button-with-tooltip size=\"sm\" variant=\"danger\" :tooltip=\"t('Delete')\" icon=\"fas fa-trash\" @click=\"$emit('delete', id)\" ></button-with-tooltip> </li> </menu> </div> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin__bazaar-promotion{display:grid;grid-template-columns:32px 1fr;gap:.5em}:is(.admin__bazaar-promotion--expired,.admin__bazaar-promotion--hidden) img{opacity:.5}.admin__bazaar-promotion--editor-active .admin__bazaar-promotion__content{outline:3px solid var(--success)}.admin__bazaar-promotion[aria-hidden]{display:none}.admin__bazaar-promotion__expired-icon{font-size:.825rem;width:20px;filter:drop-shadow(1px 1px #000);text-align:center}.admin__bazaar-promotion__content{position:relative}.admin__bazaar-promotion__content img{display:block;width:100%;height:auto;object-fit:cover;min-height:100px}.admin__bazaar-promotion__alt-text,.admin__bazaar-promotion__controls{--edge-offset: 0.5em;background-color:rgba(0,0,0,.5333333333);position:absolute;margin:0;padding:.25em .5em}.admin__bazaar-promotion__alt-text{left:var(--edge-offset);bottom:var(--edge-offset);color:var(--light);text-shadow:1px 1px rgba(0,0,0,.2666666667);font-size:1.2rem}.admin__bazaar-promotion__controls{top:var(--edge-offset);right:var(--edge-offset);list-style-type:none;display:flex;gap:.5em;align-items:baseline}.admin__bazaar-promotion .grip{display:flex;align-items:center;justify-content:center;cursor:grab;width:1.5em}.admin__bazaar-promotion .fa-grip-horizontal{opacity:.75}"
    });
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    startDate: {
      type: [Date, undefined],
      default: undefined
    },
    endDate: {
      type: [Date, undefined],
      default: undefined
    },
    art: {
      type: String,
      default: ""
    },
    altText: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: true
    },
    isFiltered: {
      type: Boolean,
      default: true
    },
    isSelectedForEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    expired() {
      const now = new Date();
      const isTooEarly = this.startDate >= now;
      const isTooLate = this.endDate <= now;
      return isTooEarly || isTooLate;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminBazaarPromotions"] = Vue.component(
                    "AdminBazaarPromotions",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"admin-bazaar-promotions\"> <!-- Create/edit promotions --> <!-- TODO: Extract this to a new file? --> <b-card no-body class=\"admin-bazaar-promotions__editor\"> <b-card-header>{{ t(\"Editor\") }}</b-card-header> <b-card-body> <b-form-group label-cols=\"2\" :label=\"t('Alt text')\"> <b-form-textarea v-model=\"editor.altText\" max-rows=\"10\" required></b-form-textarea> </b-form-group> <b-form-group label-cols=\"2\" :label=\"t('Link')\" class=\"mt-2\"> <b-form-input v-model=\"editor.url\" required></b-form-input> </b-form-group> <b-form-group label-cols=\"2\" :label=\"t('Banner art')\" class=\"mt-2\"> <b-form-input v-model=\"editor.art\" required></b-form-input> </b-form-group> <!-- Start date selector --> <b-form-group label-cols=\"2\" :label=\"t('Start date')\" class=\"mt-2\"> <date-picker v-model=\"editor.startDate\" type=\"datetime\" class=\"w-100\" input-class=\"form-control\" :popup-style=\"{ top: '100%', left: 0 }\" :append-to-body=\"false\" required ></date-picker> </b-form-group> <!-- End date selector --> <b-form-group label-cols=\"2\" :label=\"t('End date')\" class=\"mt-2\"> <date-picker v-model=\"editor.endDate\" type=\"datetime\" class=\"w-100\" input-class=\"form-control\" :popup-style=\"{ top: '100%', left: 0 }\" :append-to-body=\"false\" required ></date-picker> </b-form-group> <b-form-group label-cols=\"2\" :label=\"t('Visible')\"> <b-form-checkbox v-model=\"editor.visible\" :checked=\"editor.visible\" switch></b-form-checkbox> </b-form-group> <!-- Action buttons --> <div class=\"editor-buttons\"> <b-button v-if=\"!isNewPromotion\" variant=\"secondary\" @click=\"cancelEdit\">{{ t(\"Cancel editing\") }}</b-button> <b-button variant=\"secondary\" @click=\"resetEditor\">{{ t(\"Reset\") }}</b-button> <b-button :disabled=\"!canSubmit\" :variant=\"isNewPromotion ? 'success' : 'primary'\" @click=\"submitEdit\">{{ isNewPromotion ? t(\"Create\") : t(\"Update\") }}</b-button> </div> </b-card-body> </b-card> <!-- The list of promotions --> <b-card no-body class=\"admin-bazaar-promotions__existing-promotions mt-4\"> <b-card-header>{{ t(\"Bazaar Promotions\") }}</b-card-header> <b-card-body> <b-form-checkbox id=\"showExpiredPromotions\" v-model=\"showExpiredPromotions\" switch> {{ t(\"Show expired promotions\") }} </b-form-checkbox> <b-form-checkbox id=\"showHiddenPromotions\" v-model=\"showHiddenPromotions\" switch> {{ t(\"Show hidden promotions\") }} </b-form-checkbox> <section class=\"admin-bazaar-promotions__list mt-2\"> <draggable v-model=\"promotions\" v-bind=\"dragOptions\" draggable=\".admin__bazaar-promotion\" handle=\".grip\" class=\"admin-bazaar-promotions__drag-container\" @end=\"reorder\" > <admin-bazaar-promotion v-for=\"promotion in promotions\" :key=\"promotion.id\" v-bind=\"promotion\" :is-filtered=\"!shouldShowPromotion(promotion)\" :is-selected-for-edit=\"promotion.id === editor.id\" @delete=\"deletePromotion\" @edit=\"editPromotion\" @toggle=\"togglePromotionVisibility\" ></admin-bazaar-promotion> </draggable> </section> </b-card-body> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-bazaar-promotions__editor .form-row{align-items:center}.admin-bazaar-promotions__editor .editor-buttons{text-align:right}.admin-bazaar-promotions__list{max-width:90ch;margin-left:auto;margin-right:auto}.admin-bazaar-promotions__drag-container{display:grid;gap:.5em}"
    });
  },
  data() {
    return {
      /** The unfiltered list of promotions. */
      promotions: [],
      /** Should we display promos that are too old have yet to start? */
      showExpiredPromotions: true,
      /** Should we display promos that are marked as not visible? */
      showHiddenPromotions: true,
      /** State for the editor UI. */
      editor: {
        id: null,
        // Editor only field
        art: "",
        url: "",
        altText: "",
        startDate: null,
        endDate: null,
        visible: true
      },
      /** The initial state of the editor. */
      editorDefaultConfiguration: null,
      /** If we're editing a promo, this is the initial state of that promo. */
      editorResetConfiguration: null
    };
  },
  computed: {
    /**
     * Can the editor form submit, or does additional data need to be filled in?
     * @returns {boolean}
     */
    canSubmit() {
      const isReady = str => str ? str.trim().length > 0 : false;
      const altTextReady = isReady(this.editor.altText);
      const artReady = isReady(this.editor.art);
      const startDateReady = !!this.editor.startDate && this.editor.startDate < this.editor.endDate;
      const endDateReady = !!this.editor.endDate && this.editor.endDate > this.editor.startDate;
      return altTextReady && artReady && startDateReady && endDateReady;
    },
    /**
     * @returns {boolean} Is this a new promotion, or are we editing an existing
     * promotion?
     */
    isNewPromotion() {
      return !this.editor.id;
    },
    /**
     * Options to use with the draggable component.
     */
    dragOptions() {
      return {
        animation: 200,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    /**
     * Set the default editor config, if one doesn't exist, then load promos,
     * if we don't have any.
     */
    async lazyLoad() {
      if (!this.editorDefaultConfiguration) {
        this.editorDefaultConfiguration = Object.assign({}, this.editor); // Shallow copy
        this.editorResetConfiguration = Object.assign({}, this.editor); // Shallow copy
      }

      if (this.promotions.length === 0) {
        await this.refresh();
      }
    },
    /**
     * Given a promotion, use the currently applied filters to determine if the
     * promotion should be displayed.
     * @param {BazaarPromotionAdminObject} promotion  the promotion slides to display.
     */
    shouldShowPromotion(promotion) {
      if (!this.showExpiredPromotions && !this.isPromotionInDateRange(promotion.startDate, promotion.endDate)) {
        return false;
      }
      if (!this.showHiddenPromotions && !promotion.visible) {
        return false;
      }
      return true;
    },
    /**
     * Determine if the promo is current -- that today is within its start and
     * end dates.
     * @returns {boolean} Is today in the provided date range?
     */
    isPromotionInDateRange(startDate, endDate) {
      const afterStart = startDate ? Date.now() > Date.parse(startDate) : true;
      const beforeEnd = endDate ? Date.now() < Date.parse(endDate) : true;
      return afterStart && beforeEnd;
    },
    /**
     * Refresh the list of promos by fetching them from the server.
     */
    async refresh() {
      const response = await Utils.apiAdmin(`administration/bazaar-promotions`);
      if (response.error) {
        return UI.alert("danger", t(`Unable to load promotions: {{error}}`, {
          error: response.error
        }), true, 10000);
      }
      this.promotions = response.promotions.sort((a, b) => {
        const orderDifference = a.order - b.order;
        if (orderDifference) {
          return orderDifference;
        }
        // If same order, non expiring first
        return b.startDate.localeCompare(a.startDate);
      }).map(p => ({
        ...p,
        startDate: new Date(p.startDate),
        endDate: new Date(p.endDate)
      }));
    },
    /**
     * Populate the editor UI with the content of a promo.
     * @param {string} id - The ID of the promo to edit.
     */
    editPromotion(id) {
      const promotion = this.promotions.find(p => p.id === id);
      Object.assign(this.editor, promotion);
      Object.assign(this.editorResetConfiguration, promotion);
      document.querySelector(".admin-bazaar-promotions__editor").scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    /**
     * Toggle a promo's visibility.
     * @param {string} id - The ID of the promo to toggle.
     */
    async togglePromotionVisibility(id) {
      await Utils.apiAdmin(`administration/bazaar-promotions/${id}/toggle-visibility`, {}, {
        method: "PATCH"
      });
      this.refresh();
    },
    /**
     * Delete the promo.
     * @todo A confirmation box would be nice here.
     * @param {string} id - The ID of the promo to delete.
     */
    async deletePromotion(id) {
      const verify = confirm(t("Are you sure you wish to delete this promotion? This action cannot be undone."));
      if (!verify) {
        return;
      }
      const response = await Utils.apiAdmin(`administration/bazaar-promotions/${id}`, {}, {
        method: "DELETE"
      });
      if (response.success) {
        this.promotions = this.promotions.filter(p => p.id !== id);
      }
    },
    /**
     * Reset the editor to its default state. For a new promo, this is all empty
     * fields; when editing a promo, it's the initial state of the existing
     * promo.
     */
    resetEditor() {
      Object.assign(this.editor, this.editorResetConfiguration);
    },
    /**
     * Clear out the editor; remove whatever data it was set to edit.
     */
    cancelEdit() {
      Object.assign(this.editor, this.editorDefaultConfiguration);
      Object.assign(this.editorResetConfiguration, this.editorDefaultConfiguration);
    },
    /**
     * Attempt to submit the form -- either as a create or update.
     */
    async submitEdit() {
      const promotion = {
        ...this.editor
      };
      if (this.isNewPromotion) {
        const response = await Utils.apiAdmin("administration/bazaar-promotions", {
          promotion
        });
        if (response.error) {
          return UI.alert("danger", t(`Unable to create promotion: {{error}}`, {
            error: response.error
          }), true, 10000);
        }
        UI.alert("success", t(`Successfully created the promotion`), true, 3000);
      } else {
        const response = await Utils.apiAdmin(`administration/bazaar-promotions`, {
          promotion
        }, {
          method: "PATCH"
        });
        if (response.error) {
          return UI.alert("danger", t(`Unable to edit the promotion: {{error}}`, {
            error: response.error
          }), true, 10000);
        }
        UI.alert("success", t(`Successfully edited the promotion`), true, 3000);
        this.cancelEdit(); // Reset editor
      }

      await this.refresh();
    },
    /**
     * Ask the server to sort existing promos.
     */
    async reorder() {
      // Update the order after sorting
      const order = this.promotions.reduce((p, v, i) => {
        p[v.id] = i;
        return p;
      }, {});
      const response = await Utils.apiAdmin("administration/bazaar-promotions/sort", {
        order
      }, {
        method: "PATCH"
      });
      if (response.error) {
        return UI.alert("danger", t(`Unable to reorder promotions: {{error}}`, {
          error: response.error
        }), true, 10000);
      }
      await this.refresh();
      UI.alert("success", t(`Successfully reordered promotions`), true, 3000);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminDashboard"] = Vue.component(
                    "AdminDashboard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"admin-dashboard\"> <div class=\"stats\"> <div class=\"servers\"> <b-card v-for=\"([id, region, provider, stats], index) in regions\" :key=\"index\" no-body> <b-card-header class=\"d-flex align-items-center\"> <div> {{ region }} <span v-b-tooltip class=\"provider\" :title=\"getProviderName(provider)\">{{ provider }}</span> </div> <b-button v-b-tooltip.hover=\"t('Upscale servers')\" class=\"ml-auto\" size=\"sm\" variant=\"outline-success\" :disabled=\"!!targetRegion\" @click=\"scale(id, true)\" ><i class=\"fa-fw\" :class=\"scaleIcon(id, true)\"></i ></b-button> </b-card-header> <b-card-body> <p class=\"usage\"> <span v-b-tooltip :title=\"t('Foundry instances')\">{{ stats.uses }}</span> / <span v-b-tooltip :title=\"t('Maximum Foundry instances')\">{{ stats.capacity }}</span> </p> <div v-b-tooltip class=\"usage-bar\" :title=\"t('{{percent}}% of total capacity', { percent: usage(stats) })\"> <div class=\"progress\" :style=\"`width: ${usage(stats)}%`\"></div> </div> <p class=\"count\"> <span v-b-tooltip :title=\"t('Static servers')\">{{ stats.static }}</span> + <span v-b-tooltip :title=\"t('Autoscaled servers')\">{{ stats.dynamic }}</span> </p> </b-card-body> </b-card> </div> </div> <!-- Confirm scaling --> <confirm-message v-model=\"confirmScaling\" :title=\"t('Confirm region scaling')\" :cancel-on-esc=\"true\" @ok=\"performScaling\" @cancel=\"abortScaling\" > <i18n :path=\"t('Are you sure you want to upscale the {1} region?')\" tag=\"p\"> <b>{{ targetRegion }}</b> </i18n> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-dashboard .stats { user-select: none; } .admin-dashboard .stats .servers { display: flex; gap: 1rem; } .admin-dashboard .stats .servers > .card { width: 100%; } .admin-dashboard .stats .servers .provider { font-variant: small-caps; } .admin-dashboard .stats .servers .usage { margin: 0; text-align: center; font-size: 240%; } .admin-dashboard .stats .servers .count { margin: 0; text-align: center; font-size: 180%; } .admin-dashboard .stats .usage-bar { background: var(--secondary); border-radius: 5px; height: 10px; } .admin-dashboard .stats .usage-bar .progress { background: #32cd32; height: 100%; }"
    });
  },
  data() {
    return {
      regions: [],
      upscaling: false,
      targetRegion: null,
      confirmScaling: false
    };
  },
  methods: {
    usage(stats) {
      return Math.min(100, Math.round(stats.uses / stats.capacity * 100));
    },
    getProviderName(provider) {
      switch (provider) {
        case "do":
          return "Digital Ocean";
        case "ovh":
          return "OVH";
      }
      return provider;
    },
    async refresh() {
      const response = await Utils.apiAdmin(`administration/stats`);
      if (response.error) {
        UI.alert("danger", `Unable to load statistics: ${response.error}`, true, 10000);
      } else {
        // Parse regional data for easier computing
        this.regions = Object.entries(response.statistics.regions).map(([region, stats]) => {
          const pr = region.split("-");
          return [region,
          // Region code
          pr[1],
          // Region
          pr[0].toLowerCase(),
          // Provider
          stats.servers // Stats
          ];
        }).sort((a, b) => a[0].localeCompare(b[0]));
      }
    },
    async lazyLoad() {
      return this.refresh();
    },
    scaleIcon(region) {
      return this.targetRegion === region ? "fa fa-spinner fa-spin" : "fas fa-arrow-up";
    },
    async scale(region, up) {
      this.upscaling = up;
      this.targetRegion = region;
      this.$root.$emit("bv::hide::tooltip"); // Hide the tooltips hanging above the confirmation dialog forever
      this.confirmScaling = true;
    },
    async performScaling() {
      const region = this.targetRegion;
      const response = await Utils.apiAdmin("administration/autoscaler/scale-up", {
        region,
        direction: this.upscaling ? "up" : "down",
        async: true // use apiTask to wait for the background task to complete
      });

      if (response.error) {
        UI.alert("danger", t(`Failed to scale up “{{region}}”: {{error}}`, {
          region,
          error: response.error
        }));
      } else {
        UI.alert("success", t(`Successfully scaled up “{{region}}”`, {
          region
        }));
      }
      this.targetRegion = null;
    },
    async abortScaling() {
      this.targetRegion = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminEventViewer"] = Vue.component(
                    "AdminEventViewer",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header >{{ t(\"Event Viewer\") }}<b-button class=\"ml-3\" variant=\"outline-primary\" @click=\"lazyLoad(true)\"><i class=\"fa fa-sync\"></i></b-button ></b-card-header> <b-card-body> <b-table class=\"event-viewer\" :busy=\"!loaded\" :items=\"events\" :fields=\"fields\"> <template v-if=\"events.length === 0\" #table-busy> <div class=\"text-center my-2\"><b-spinner small class=\"align-middle\"></b-spinner> Loading…</div> </template> <template #cell(createdAt)=\"{ value }\"> {{ Utils.localizeDate(value, true) }} </template> <template #cell(user)=\"{ value }\"> {{ value._id }} </template> <template #cell(type)=\"{ item, value }\"> <i v-if=\"!item.success\" class=\"fa fa-fw fa-times text-danger\"></i>{{ value }} </template> <template #cell(details)=\"{ item }\"> <div v-html=\"formatDetails(item)\"></div> </template> </b-table> <infinite-loading v-if=\"loaded && events.length > 0 && !eod\" spinner=\"bubbles\" @infinite=\"loadMore\"> <div slot=\"no-results\"></div> </infinite-loading> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".event-viewer .details p, .event-viewer .details pre { margin-bottom: 0; } .event-viewer thead th { border-top: none; }"
    });
  },
  data: () => ({
    loaded: false,
    events: [],
    eventIDs: [],
    fields: [{
      key: "createdAt",
      label: "Date"
    }, {
      key: "user"
    }, {
      key: "type"
    }, {
      key: "details",
      tdClass: "details"
    }],
    page: -1,
    eod: false // End of data, ran out of records
  }),

  methods: {
    async addNewEvents(events) {
      const filteredEvents = [];
      events.forEach(e => {
        if (!this.eventIDs.includes(e._id)) {
          this.eventIDs.push(e._id);
          filteredEvents.push(e);
        }
      });
      if (filteredEvents.length === 0) {
        return 0;
      }
      // Depending on the the batch being added, insert on top if it's a refresh,
      // and append to the bottom if it's an infiniscroll.
      if (this.events.length > 0 && events[0].createdAt > this.events[0].createdAt) {
        // Insert
        this.events = filteredEvents.concat(this.events);
      } else {
        // Append
        this.events = this.events.concat(filteredEvents);
      }
      return filteredEvents.length;
    },
    async loadNextPage() {
      this.loaded = false;
      let success = false;
      const page = this.page + 1;
      const response = await Utils.apiAdmin(`administration/events${page ? `/${page}` : ""}`);
      if (response.error) {
        UI.alert("danger", `Unable to load events: ${response.error}`, true, 10000);
      } else {
        await this.addNewEvents(response.events);
        this.page += 1;
        success = true;
      }
      this.loaded = true;
      return success;
    },
    async getNewEvents() {
      if (this.page === -1 || this.events.length === 0) {
        return this.loadNextPage;
      }
      this.loaded = false;
      const since = Date.parse(this.events[0].createdAt);
      // Get all events that are as old as `since` or newer
      const response = await Utils.apiAdmin(`administration/events/since/${since}`);
      if (response.error) {
        UI.alert("danger", `Unable to load events: ${response.error}`, true, 10000);
      } else if (!(await this.addNewEvents(response.events))) {
        UI.alert("success", "No new events", true, 3000);
      }
      this.loaded = true;
    },
    async lazyLoad(update = false) {
      if (this.loaded && !update) {
        return;
      }
      if (update) {
        this.getNewEvents();
      } else {
        this.loadNextPage();
      }
    },
    formatDetails(event) {
      // If event.details doesn't exist, use a default that has all possible keys set to null.
      const details = event.details || {
        query: null,
        userid: null,
        logType: null,
        roles: null,
        previousRoles: null,
        role: null,
        game: null,
        count: null,
        amount: null,
        message: null,
        note: null,
        type: null,
        regions: null,
        expires: null,
        region: null,
        direction: null,
        purchaseId: null,
        email: null,
        previousEmail: null
      };
      let message = null;
      switch (event.type) {
        case "admin.users.search":
          message = `Search users matching <b>${Utils.escapeHTML(details.query)}</b>`;
          break;
        case "admin.user.delete":
          message = `Delete user <b>${details.userid}</b>`;
          break;
        case "admin.user.games":
          message = `View <b>${details.userid}</b>’s games and invitation links`;
          break;
        case "admin.user.logs":
          message = `Open <b>${details.userid}</b>’s ${details.logType} logs`;
          break;
        case "admin.user.roles.update":
          {
            const roles = details.roles || [];
            const previousRoles = details.previousRoles || [];
            message = previousRoles.length ? `Change <b>${details.userid}</b>’s roles from <b>[${previousRoles.join(", ")}]</b> to <b>[${roles.join(", ")}]</b>` : `Set <b>${details.userid}</b>’s roles to <b>[${roles.join(", ")}]</b>`;
            break;
          }
        case "admin.user.role.delete":
          message = `Remove <b>${details.userid}</b>’s <b>${details.role}</b> role`;
          break;
        case "admin.user.2FA.delete":
          message = `Remove <b>${details.userid}</b>’s 2FA`;
          break;
        case "admin.user.email.update":
          message = `Update <b>${details.userid}</b>’s email from <b>${details.previousEmail}</b> to <b>${details.email}</b>`;
          break;
        case "admin.user.impersonate":
          message = `Impersonate <b>${details.userid}</b>`;
          break;
        case "admin.user.game.start":
        case "admin.user.game.idle":
        case "admin.user.game.stop":
          const verb = Utils.capitalize(event.type.substr(16)); // Start/Idle/Stop
          message = `${verb} <b>${details.userid}</b>’s game <b>${details.game}</b>`;
          break;
        case "admin.giftcard.new":
          {
            message = `Generate <b>${details.count}</b> gift card${details.count > 1 ? "s" : ""} worth <b>$${details.amount}</b>${details.count > 1 ? " each" : ""}`;
            if (details.message) {
              message += `<br>Message: <b>${Utils.escapeHTML(details.message)}</b>`;
            }
            if (details.note) {
              message += `<br>Note: <b>${Utils.escapeHTML(details.note)}</b>`;
            }
            break;
          }
        case "admin.announcement.new":
          {
            message = `Created service announcement <b>${details.message}</b> of type <b>${details.type}</b>`;
            if (details.regions && details.regions.length) {
              message += `, for regions <b>${details.regions.join("</b>, <b>")}</b>`;
            }
            if (details.expires) {
              message += `, expiring on <b>${Utils.localizeDate(details.expires, false)}</b>`;
            }
            break;
          }
        case "admin.announcement.edit":
          {
            message = `Edited service announcement <b>${details._id}</b>, now <b>${details.message}</b> of type <b>${details.type}</b>`;
            if (details.regions && details.regions.length) {
              message += `, for regions <b>${details.regions.join("</b>, <b>")}</b>`;
            }
            if (details.expires) {
              message += `, expiring on <b>${Utils.localizeDate(details.expires, false)}</b>`;
            }
            break;
          }
        case "admin.announcements.update":
          {
            message = "";
            if (details.expiration) {
              message += "Updated expirations: ";
              let expirations = [];
              for (const [id, expiration] of Object.entries(details.expiration)) {
                expirations.push(`<b>${id}</b> (<b>${Utils.localizeDate(expiration, true)}</b>)`);
              }
              if (expirations.length) {
                message += expirations.join(", ");
              }
            }
            if (details.order) {
              if (message) {
                message += "</p><p>";
              }
              message += `Reordered the active service announcements: <b>${Object.keys(details.order).join("</b>, <b>")}</b>`;
            }
            break;
          }
        case "admin.region.scale":
          {
            message = `Scale the <b>${details.region}</b> region <b>${details.direction}</b>`;
            break;
          }
        case "admin.purchase.refund":
          {
            const amount = typeof details.amount === "number" ? details.amount.toFixed(2) : details.amount;
            message = `Refund <b>${details.userid}</b>'s purchase <b>${details.purchaseId}</b> for amount <b>$${amount}</b>`;
            break;
          }
        case "admin.foundry.management.post":
          {
            const versionData = {
              channels: details.channels,
              available: details.available,
              name: details.name,
              numeric: details.numeric,
              tag: details.tag
            };
            const verb = details._id ? "Update" : "Create";
            message = `<b>${verb}</b> Foundry version <b>${details.numeric}</b>: ${JSON.stringify(versionData)}`;
          }
      }
      message = message ? `<p>${message}</p>` : `<pre>${JSON.stringify(event.details, null, 2)}</pre>`;
      if (event.error) {
        message += `<p class="mt-2 text-danger">Failed: ${event.error}</p>`;
      }
      return message;
    },
    async loadMore($state) {
      const cc = this.events.length;
      const success = await this.loadNextPage();
      $state.loaded();
      if (success && cc == this.events.length) {
        this.eod = true;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminFoundryVersions"] = Vue.component(
                    "AdminFoundryVersions",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body class=\"admin-foundry-versions\"> <b-card-header> <div class=\"card-header-container\"> <p class=\"section-title\">{{ t(\"Manage Foundry versions\") }}</p> <b-button-group v-if=\"!loading\" id=\"add-version-wrapper\"> <b-button :disabled=\"foundryVersionsUpdated.length > foundryVersions.length\" variant=\"primary\" @click=\"handleAddVersionClick\" >{{ t(\"Add new Foundry version\") }}</b-button > <b-tooltip v-if=\"foundryVersionsUpdated.length > foundryVersions.length\" target=\"add-version-wrapper\" triggers=\"hover\" > <span class=\"text-danger invalid-input-feedback\">{{ t(\"You must complete the new version before adding another.\") }}</span> </b-tooltip> </b-button-group> </div> </b-card-header> <b-card-body> <div v-if=\"loading\" class=\"text-center\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Looking for Foundry versions, please wait…\") }} </div> <b-table v-else bordered stacked=\"md\" show-empty medium sticky-header head-variant=\"light\" :sort-by=\"sortBy\" :sort-desc=\"sortDesc\" :fields=\"fields\" :items=\"foundryVersionsUpdated\" > <template #cell(name)=\"rowData\"> <b-form-group> <b-form-input :id=\"`foundry-version-update-${rowData.item._id}-name`\" v-model=\"rowData.item.name\" lazy :state=\" validateNameInput( foundryVersions.find((item) => item._id === rowData.item._id) && foundryVersions.find((item) => item._id === rowData.item._id).name, rowData.item.name ) \" ></b-form-input> <b-tooltip v-if=\"rowData.item.name.trim().length === 0\" :target=\"`foundry-version-update-${rowData.item._id}-name`\" triggers=\"hover\" > <span class=\"text-danger invalid-input-feedback\">{{ t(\"Version name cannot be empty\") }}</span> </b-tooltip> </b-form-group> </template> <template #cell(numeric)=\"rowData\"> <b-form-group> <b-form-input :id=\"`foundry-version-update-${rowData.item._id}-numeric`\" v-model=\"rowData.item.numeric\" lazy :state=\" validateVersionInput( foundryVersions.find((item) => item._id === rowData.item._id) && foundryVersions.find((item) => item._id === rowData.item._id).numeric, rowData.item.numeric ) \" ></b-form-input> <b-tooltip v-if=\"!validateNumeric(rowData.item.numeric)\" :target=\"`foundry-version-update-${rowData.item._id}-numeric`\" triggers=\"hover\" > <span class=\"text-danger invalid-input-feedback\">{{ numericFormatErrorMessage }}</span> </b-tooltip> </b-form-group> </template> <template #cell(tag)=\"rowData\"> <b-form-group> <b-form-input :id=\"`foundry-version-update-${rowData.item._id}-tag`\" v-model=\"rowData.item.tag\" lazy :state=\" validateTagInput( foundryVersions.find((item) => item._id === rowData.item._id) && foundryVersions.find((item) => item._id === rowData.item._id).tag, rowData.item.tag ) \" ></b-form-input> <b-tooltip v-if=\"!validateTag(rowData.item.tag)\" :target=\"`foundry-version-update-${rowData.item._id}-tag`\" triggers=\"hover\" > <span class=\"text-danger invalid-input-feedback\">{{ numericFormatErrorMessage }}</span> </b-tooltip> </b-form-group> </template> <template #cell(available)=\"rowData\"> <b-form-checkbox v-model=\"rowData.item.available\" switch> {{ t(\"Available\") }} </b-form-checkbox> </template> <template #cell(channels)=\"rowData\"> <b-form-checkbox-group v-model=\"rowData.item.channels\" :options=\" defaultChannels.concat(rowData.item.channels.filter((channel) => !defaultChannels.includes(channel))) \" stacked :disabled=\"!rowData.item.available\" ></b-form-checkbox-group> </template> <template #cell(edit)=\"rowData\"> <div class=\"buttons-container\"> <b-button-group :id=\"`save-changes-${rowData.item._id}`\"> <b-button style=\"min-width: 70px\" size=\"sm\" :disabled=\" !foundryVersionsChangeStatus[rowData.item._id] || loading || !foundryVersionsValidationStatus[rowData.item._id] \" variant=\"outline-success\" @click=\"saveVersionChanges(rowData.item._id)\" ><i class=\"fas fa-save\"></i> {{ t(\"Save\") }}</b-button > <b-tooltip :target=\"`save-changes-${rowData.item._id}`\" triggers=\"hover\"> <span>{{ t(\"Save changes to this version\") }}</span> </b-tooltip> </b-button-group> <b-button-group :id=\"`discard-changes-${rowData.item._id}`\"> <b-button style=\"min-height: 30px\" size=\"sm\" :disabled=\"!foundryVersionsChangeStatus[rowData.item._id] || loading\" variant=\"outline-danger\" @click=\"handleDiscardChanges(rowData.item._id)\" ><i class=\"fas fa-undo\"></i> </b-button> <b-tooltip :target=\"`discard-changes-${rowData.item._id}`\" triggers=\"hover\"> <span>{{ t(\"Discard changes to this version\") }}</span> </b-tooltip> </b-button-group> </div> </template> </b-table> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-foundry-versions .card-header-container { display: flex; justify-content: space-between; align-items: baseline; } .admin-foundry-versions .buttons-container { display: flex; gap: 5px; align-items: center; min-height: 70px; } .admin-foundry-versions .buttons-container .btn { display: flex; justify-content: space-between; align-items: center; max-height: 30px; } .admin-foundry-versions .section-title { font-size: 16px; } .admin-foundry-versions .invalid-input-feedback { font-size: 0.8em; }"
    });
  },
  data() {
    return {
      loading: false,
      foundryVersions: [],
      foundryVersionsUpdated: [],
      sortBy: "numeric",
      sortDesc: true,
      fields: [{
        key: "name",
        label: t("Version name"),
        sortable: true
      }, {
        key: "numeric",
        label: t("Numeric"),
        sortable: true
      }, {
        key: "tag",
        label: t("Tag"),
        sortable: true
      }, {
        key: "available",
        label: t("Availability")
      }, {
        key: "channels",
        label: t("Available Channels")
      }, {
        key: "edit",
        label: t("Edit")
      }],
      defaultChannels: ["latest", "recommended", "previous"],
      numericFormatErrorMessage: t("Invalid version value. Please enter a valid version format (e.g., 2.2, 0.0.6, 1.0.0-latest).")
    };
  },
  computed: {
    // Computes status of changes for each Foundry VTT version update
    foundryVersionsChangeStatus() {
      const changesDict = {};
      this.foundryVersionsUpdated.forEach(updatedVersion => {
        const originalVersion = this.foundryVersions.find(version => version._id == updatedVersion._id);
        changesDict[updatedVersion._id] = this.versionHasChanges(originalVersion, updatedVersion);
      });
      return changesDict;
    },
    // Computes validation status for each Foundry VTT version update
    foundryVersionsValidationStatus() {
      const validChangesDict = {};
      this.foundryVersionsUpdated.forEach((updatedVersion, index) => {
        if (updatedVersion._id === "new-version") {
          validChangesDict[updatedVersion._id] = updatedVersion.name.trim().length !== 0 && this.validateNumeric(updatedVersion.numeric) && this.validateTag(updatedVersion.tag);
        } else {
          // Validation is only applied to modified fields
          const originalVersion = this.foundryVersions[index];
          const isNameValid = originalVersion.name === updatedVersion.name || updatedVersion.name.trim().length !== 0;
          const isNumericValid = originalVersion.numeric === updatedVersion.numeric || this.validateNumeric(updatedVersion.numeric);
          const isTagValid = originalVersion.tag === updatedVersion.tag || this.validateTag(updatedVersion.tag);
          validChangesDict[updatedVersion._id] = isNameValid && isNumericValid && isTagValid;
        }
      });
      return validChangesDict;
    }
  },
  methods: {
    async lazyLoad() {
      this.refresh();
    },
    async refresh() {
      this.loading = true;
      const response = await Utils.apiAdmin(`administration/foundry-versions`);
      this.loading = false;
      if (response.error) {
        UI.error(t("Unable to load settings: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
        return;
      }
      this.foundryVersions = response.foundryVersions;

      // Name, numeric and channels fields don't provide a default value
      this.foundryVersions.map(foundryVersion => {
        foundryVersion.name = foundryVersion.name ? foundryVersion.name : null;
        foundryVersion.numeric = foundryVersion.numeric ? foundryVersion.numeric : null;
        foundryVersion.channels = foundryVersion.channels ? foundryVersion.channels : [];
      });
      this.foundryVersionsUpdated = Utils.duplicate(response.foundryVersions);
    },
    versionHasChanges(originalVersion, updateVersion) {
      if (!originalVersion) {
        return true;
      }
      return originalVersion.name !== updateVersion.name || originalVersion.numeric !== updateVersion.numeric || originalVersion.tag !== updateVersion.tag || originalVersion.available !== updateVersion.available || originalVersion.channels.length !== updateVersion.channels.length || !originalVersion.channels.every(channel => updateVersion.channels.includes(channel));
    },
    async saveVersionChanges(versionId) {
      this.loading = true;
      const versionIndex = this.foundryVersionsUpdated.findIndex(foundryVersionUpdated => foundryVersionUpdated._id === versionId);
      const updatedVersion = this.foundryVersionsUpdated[versionIndex];

      // Remove temp id
      if (versionId === "new-version") {
        delete updatedVersion._id;
      }
      const response = await Utils.apiAdmin(`administration/foundry-version`, updatedVersion);
      if (response.error) {
        this.loading = false;
        return UI.error(t("Unable to save all the changes : {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      if (versionId === "new-version") {
        this.$set(this.foundryVersionsUpdated, this.foundryVersionsUpdated.length - 1, Utils.duplicate(response.foundryVersion));
        this.$set(this.foundryVersions, this.foundryVersions.length, Utils.duplicate(response.foundryVersion));
      } else {
        this.$set(this.foundryVersions, versionIndex, Utils.duplicate(this.foundryVersionsUpdated[versionIndex]));
      }
      this.loading = false;
      return UI.success(t("Foundry version {{numeric}} updated successfully", {
        numeric: updatedVersion.numeric
      }));
    },
    validateNumeric(numeric) {
      const numericPattern = /^[0-9]\d*(\.[0-9]\d*)*((\.[0-9]\d*)*)?(-[a-zA-Z0-9]*)?$/;
      return numericPattern.test(numeric);
    },
    validateTag(tag) {
      const tagPattern = /^[0-9]\d*(\.[0-9]\d*)*((\.[0-9]\d*)*)?(-[a-zA-Z0-9-]*)?$/;
      return tagPattern.test(tag);
    },
    validateNameInput(prevValue, value) {
      if (prevValue !== value) {
        return !!value.trim().length;
      }
      return null;
    },
    validateVersionInput(prevValue, value) {
      if (prevValue !== value) {
        return this.validateNumeric(value);
      }
      return null;
    },
    validateTagInput(prevValue, value) {
      if (prevValue !== value) {
        return this.validateTag(value);
      }
      return null;
    },
    handleAddVersionClick() {
      this.foundryVersionsUpdated.push({
        name: "",
        numeric: "",
        tag: "",
        available: true,
        channels: [],
        _id: "new-version"
      });
    },
    handleDiscardChanges(versionId) {
      const versionIndex = this.foundryVersions.findIndex(version => version._id === versionId);
      // The new version is always the last one in the array
      if (versionIndex === -1) {
        this.foundryVersionsUpdated.pop();
        return;
      }
      this.$set(this.foundryVersionsUpdated, versionIndex, Utils.duplicate(this.foundryVersions[versionIndex]));
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminGiftCards"] = Vue.component(
                    "AdminGiftCards",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <!-- Gift card generation --> <b-card no-body> <b-card-header>{{ \"Gift cards\" | t }}</b-card-header> <b-card-body> <b-form @submit.prevent=\"confirm.giftCardGeneration = true\"> <b-form-group label-cols=\"2\" :label=\"'Count' | t\"> <b-form-input v-model=\"giftCard.count\" :placeholder=\"'Gift cards to issue' | t\" @input.native=\"Utils.validatePositiveIntegerInput\" ></b-form-input> </b-form-group> <b-form-group label-cols=\"2\" :label=\"'Amount (in $)' | t\"> <b-input-group prepend=\"$\" append=\".00\"> <b-form-input v-model=\"giftCard.amount\" :placeholder=\"'Amount' | t\" @input.native=\"Utils.validatePositiveIntegerInput\" ></b-form-input> </b-input-group> </b-form-group> <b-form-group label-cols=\"2\" :label=\"'Package' | t\"> <b-form-input v-model=\"giftCard.packageName\" :placeholder=\"'Package name' | t\" class=\"text-lowercase\" ></b-form-input> </b-form-group> <b-form-group label-cols=\"2\" :label=\"'Message' | t\"> <b-form-textarea v-model=\"giftCard.message\" :placeholder=\"'Gift card message (optional)' | t\" ></b-form-textarea> </b-form-group> <b-form-group label-cols=\"2\" :label=\"'Internal notes' | t\"> <b-form-input v-model=\"giftCard.note\" :placeholder=\"'Hidden note for internal use (optional)' | t\" ></b-form-input> </b-form-group> <b-form-group label-cols=\"2\"> <b-button type=\"reset\" variant=\"secondary\">{{ \"Reset\" | t }}</b-button> <b-button type=\"submit\" variant=\"primary\" :disabled=\"!giftCard.count || (!giftCard.amount && !giftCard.packageName)\" class=\"ml-2\" >{{ \"Generate\" | t }}</b-button > </b-form-group> </b-form> <confirm-message v-model=\"confirm.giftCardGeneration\" :title=\"'Gift card generation' | t\" @ok=\"generateGiftCards\" > <p> Create <b>{{ giftCard.count }}</b> &times; <b>{{ formatCurrency(giftCard.amount) }}</b> gift cards, for a total of <b>{{ formatCurrency(giftCard.count * giftCard.amount) }}</b ><span v-if=\"giftCard.packageName\"> and the <b>{{ giftCard.packageName }}</b> package</span >? </p> <table> <tr> <th class=\"pr-2\">{{ \"Message\" | t }}:</th> <td>{{ Utils.escapeHTML(giftCard.message || \"\") }}</td> </tr> <tr> <th class=\"pr-2\">{{ \"Notes\" | t }}:</th> <td>{{ Utils.escapeHTML(giftCard.note || \"\") }}</td> </tr> </table> </confirm-message> <b-table :items=\"giftCards\"> <template #cell(code)=\"{ value }\"> <b-link v-b-tooltip title=\"Click to copy the URL into the clipboard\" :href=\"`https://forge-vtt.com/bazaar/claim/${value}`\" @click.prevent=\"copyGiftLink(value)\" >{{ value }}</b-link > </template> <template #cell(amount)=\"{ value }\"> {{ formatCurrency(value) }} </template> </b-table> </b-card-body> </b-card> </div>",
  props: {
    params: String
  },
  data() {
    return {
      confirm: {
        giftCardGeneration: false
      },
      giftCards: [],
      giftCard: {
        count: null,
        amount: null,
        packageName: this.params || null,
        message: null,
        note: null
      }
    };
  },
  methods: {
    formatCurrency(amount) {
      if (!this.formatCurrency.formatter) {
        this.formatCurrency.formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        });
      }
      return this.formatCurrency.formatter.format(amount);
    },
    async generateGiftCards() {
      const gc = Object.assign({}, this.giftCard); // Avoid timing issues
      const request = {
        count: this.giftCard.count || 1,
        amount: this.giftCard.amount || 0
      };
      if (this.giftCard.packageName) {
        request.packageName = this.giftCard.packageName.trim().toLowerCase();
      }
      if (this.giftCard.message) {
        request.message = this.giftCard.message.trim();
      }
      if (this.giftCard.note) {
        request.note = this.giftCard.note.trim();
      }
      const response = await Utils.apiAdmin(`administration/giftcards`, request);
      if (response.error) {
        return UI.alert("danger", `Error generating gift cards: ${response.error}`, true, 10000);
      }
      response.cards.forEach(code => {
        this.giftCards.push({
          code,
          amount: request.amount || "",
          packageName: request.packageName || "",
          message: request.message || "",
          note: request.note || ""
        });
      });
    },
    async copyGiftLink(code) {
      navigator.clipboard.writeText(`https://forge-vtt.com/bazaar/claim/${code}`);
      return UI.alert("success", "Gift card claim link copied to the clipboard", true, 3000);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminPackageList"] = Vue.component(
                    "AdminPackageList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"created\"> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" > <profile-creator-package v-if=\"currentPackage\" :back-button=\"true\" :package=\"currentPackage\" :admin=\"true\" :bazaar-tags-list=\"bazaarTagsList\" @update=\"updatePackage\" @back=\"showPackages\" ></profile-creator-package> <profile-creator-new-package v-else-if=\"newPackage\" :back-button=\"true\" @created=\"newPackageCreated\" @back=\"showPackages\" ></profile-creator-new-package> <creator-package-list v-else :initial-data=\"packages\" :admin=\"true\" :approvals=\"pendingApproval\" @create=\"createPackage\" @change=\"changeSale\" @select=\"selectPackage\" @approve=\"approvePackage\" > <b-btn :variant=\"pendingApproval ? 'primary' : 'outline-primary'\" @click=\"togglePendingApproval\"> <i class=\"fas fa-stamp\"></i> </b-btn> </creator-package-list> </transition> </div>",
  data: () => ({
    created: false,
    loaded: false,
    packages: [],
    hash: null,
    currentPackage: null,
    newPackage: null,
    bazaarTags: [],
    pendingApproval: false
  }),
  watch: {
    hash() {
      this.updateFromHash();
    }
  },
  computed: {
    bazaarTagsList() {
      // Client side translation of BazaarTags, to set label and untranslated _label
      return this.bazaarTags.map(tag => {
        tag._label = tag.label;
        tag.label = t(`BAZAAR_TAG.${tag.tag}`, tag.label || tag.tag);
        return tag;
      });
    }
  },
  methods: {
    async lazyLoad(update = false) {
      if (this.loaded && !update) {
        return;
      }
      const response = await Utils.api("administration/packages");
      if (response.error) {
        return UI.error(t(`Error fetching the list of packages pending approval: {{- error}}`, {
          error: response.error
        }));
      } else if (response.success) {
        this.packages = response.packages;
        this.bazaarTags = response.bazaarTags;
        this.loaded = true;
      }
    },
    updateFromHash() {
      if (window.location.hash) {
        let hash = Utils.hashProps(window.location.hash);
        // Find navigate to the correct tab and package
        if (hash.package === "new") {
          this.newPackage = true;
          this.currentPackage = null;
        } else {
          this.newPackage = false;
          this.currentPackage = this.packages && this.packages.find(p => p.data.id === hash.package);
        }
        this.pendingApproval = !!hash.approvals;
      }
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    createPackage() {
      this.currentPackage = null;
      this.newPackage = true;
    },
    selectPackage(id) {
      this.buildHash({
        package: id
      });
    },
    async changeSale(field, id, value) {
      const pkg = this.packages.find(p => p.data.id === id);
      if (!pkg) {
        return;
      }
      const data = {
        action: "configure-package",
        type: pkg.data.type,
        name: pkg.data.name,
        marketplace: {}
      };
      data.marketplace[field] = Number(value);

      // Don't change the sale price if the price hasn't changed
      if (data.marketplace[field] === pkg.marketplace[field]) {
        return;
      }
      this.savingConfig = true;
      const response = await Utils.api("bazaar/creator", data);
      if (response.error) {
        UI.error(t("Error setting package {{- field}}: {{- error}}", {
          field: field,
          error: response.error || t("Unknown error")
        }));
      } else {
        UI.success(t("The package {{- field}} changed.", {
          field: field
        }));
        pkg.marketplace = Object.assign(pkg.marketplace, data.marketplace);
      }
      this.savingConfig = false;
    },
    async approvePackage(item) {
      const pkg = this.packages.find(p => p.data.id === item.id);
      if (!pkg) {
        return;
      }
      this.savingConfig = true;
      const response = await Utils.api("administration/packages/approve", {
        type: pkg.data.type,
        name: pkg.data.name
      });
      if (response.error) {
        UI.error(t("Error setting package configuration: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      } else {
        UI.success(t("The package, {{- name}}, has been approved.", {
          name: pkg.data.title
        }));
        pkg.available = true;
        const packagesPendingApproval = this.packages.filter(p => !p.available && p.marketplace && p.marketplace.ready).length;
        this.$emit("update", packagesPendingApproval);
      }
      this.savingConfig = false;
    },
    newPackageCreated(pkg) {
      this.packages.push(pkg);
      this.selectPackage(pkg.data.id);
    },
    updatePackage(pkg) {
      const idx = this.packages.findIndex(p => p.data.id === pkg.data.id);
      this.packages.splice(idx, 1, pkg);
      this.currentPackage = pkg;
      // Merge update into integrations
      if (this.creatorIntegration && this.creatorIntegration.integrations) {
        const integrationIdx = this.creatorIntegration.integrations.findIndex(integ => integ.data.id === pkg.data.id);
        if (pkg.patreon && pkg.patreon.tiers) {
          // The updated package has Patreon integration, so ensure it is in the integrations list.
          if (integrationIdx >= 0) {
            this.creatorIntegration.integrations.splice(integrationIdx, 1, pkg);
          } else {
            this.creatorIntegration.integrations.push(pkg);
          }
        } else {
          // The updated package has no Patreon integration, so ensure it is removed from the integrations list.
          if (integrationIdx >= 0) {
            this.creatorIntegration.integrations.splice(integrationIdx, 1);
          }
        }
      }
    },
    showPackages() {
      // Show the package list instead of the current package or new package
      this.buildHash({
        package: null
      });
      this.newPackage = false;
    },
    togglePendingApproval() {
      this.buildHash({
        approvals: this.pendingApproval ? null : "true"
      });
    }
  },
  async created() {
    await Utils.loadDependencies(["dompurify", "v-video-embed", "simple-markdown", "tinymce-vue"]);
    this.updateFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
    this.created = true;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminPayoutsAndPurchases"] = Vue.component(
                    "AdminPayoutsAndPurchases",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body class=\"admin-purchases-payouts\"> <template #header> {{ t(\"Purchases and Payouts\") }} </template> <b-row> <b-form-group class=\"mt-3 ml-3\" style=\"width: 100%\" :disabled=\"purchasesData.pageData && !purchasesData.pageData.isLoaded\" > <b-form @submit.prevent=\"findPurchases\"> <b-input-group> <b-col md=\"3\"> <b-form-group :label=\"t('Search by users')\"> <b-form-input v-model=\"purchasesSearchInputs.users\" :placeholder=\"t('Enter usernames and/or emails')\" ></b-form-input> </b-form-group> </b-col> <b-col md=\"3\"> <b-form-group :label=\"t('Search by packages')\"> <b-form-input v-model=\"purchasesSearchInputs.packages\" :placeholder=\"t('Enter package names and/or titles')\" ></b-form-input> </b-form-group> </b-col> <b-col md=\"2\"> <b-form-group :label=\"t('Page size (purchases)')\"> <b-form-select v-model=\"purchasesData.pageSize\" :options=\"pageSizeOptions\"></b-form-select> </b-form-group> </b-col> <b-col> <b-form-group :label=\"t('Find purchases')\"> <b-button type=\"submit\" variant=\"primary\" :disabled=\"purchasesData.pageData && !purchasesData.pageData.isLoaded\" ><i class=\"fa fa-search fa-fw\"></i> {{ t(\"Search\") }}</b-button > <help-icon :tooltip=\" t( 'Enter usernames or emails separated by comas (you can also enter just one), or enter package names or titles separated by comas. You can fill only one field at a time. If both fields are filled, the search will match purchases that satisfy both criteria.' ) \" ></help-icon> </b-form-group> </b-col> </b-input-group> </b-form> </b-form-group> </b-row> <b-card-body> <div v-if=\"purchasesData.pageData\"> <b-row class=\"mb-1\"> <b-col ><h5>{{ t(\"Purchases\") }}</h5></b-col > <b-col ><b-pagination v-if=\"purchasesData.pageData.isLoaded\" v-model=\"purchasesData.currentPage\" :total-rows=\"purchasesData.totalNumberOfElements\" :per-page=\"purchasesData.pageSize\" @input=\"pageChange\" /></b-col> <b-col class=\"d-flex justify-content-end\" ><b-button v-if=\" purchasesData.pageData && purchasesData.pageData.isLoaded && purchasesData.pageData.purchases.length \" v-b-tooltip.hover variant=\"success\" small :title=\"t('Export all purchases as CSV')\" @click.prevent=\"exportPurchases\" > <i class=\"fas fa-download\"></i> </b-button ></b-col> </b-row> <div v-if=\"purchasesData.pageData.isLoaded\"> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"purchasesData.pageData.purchases\" :fields=\"purchasesFields\" sort-desc sort-by=\"date\" > <template #cell(content)=\"{ item }\"> <a v-b-tooltip.hover :href=\"`/bazaar#package=${item.name}`\" target=\"_blank\" :title=\"item.name\">{{ item.title }}</a> </template> <template #cell(status)=\"{ item }\"> <p class=\"capitalize\">{{ item.status }}</p> </template> <template #cell(refund)=\"{ item }\"> <div v-if=\"item.status === 'paid'\"> <b-button variant=\"danger\" size=\"sm\" @click.prevent=\"showRefundDialog(item)\"> {{ t(\"Refund\") }} </b-button> </div> </template> </b-table> </div> <div v-else class=\"text-center\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Looking for purchases, please wait…\") }} </div> <b-row> <b-col offset-md=\"4\" md=\"4\"> <b-pagination v-if=\"purchasesData.pageData && purchasesData.pageData.isLoaded\" v-model=\"purchasesData.currentPage\" :total-rows=\"purchasesData.totalNumberOfElements\" :per-page=\"purchasesData.pageSize\" @input=\"pageChange\" /> </b-col> </b-row> </div> </b-card-body> <b-card-body> <div v-if=\"!loadingPayoutsAndBalances\"> <b-col class=\"pr-2\"> <b-row class=\"mb-1\"> <h5>{{ t(\"Creator Balances\") }}</h5> <b-button v-if=\"balances.length\" v-b-tooltip.hover variant=\"success\" class=\"ml-auto mr-2\" :title=\"t('Export as CSV')\" @click.prevent=\"exportBalances\" > <i class=\"fas fa-download\"></i> </b-button> </b-row> </b-col> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"balances\" :fields=\"balancesFields\" > </b-table> <b-col> <b-row> <h5>{{ t(\"Payouts\") }}</h5> <b-button v-if=\"payouts.length\" v-b-tooltip.hover variant=\"success\" class=\"ml-auto mr-2\" :title=\"t('Export as CSV')\" @click.prevent=\"exportPayouts\" > <i class=\"fas fa-download\"></i> </b-button> </b-row> </b-col> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"payouts\" :fields=\"payoutsFields\" > </b-table> </div> <div v-else class=\"text-center\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Looking for payouts and balances data, please wait…\") }} </div> </b-card-body> <b-modal id=\"refund-confirmation-modal\" v-model=\"isRefundModalVisible\" centered @ok=\"confirmRefund\"> <template #modal-title><i class=\"fas fa-question-circle\"></i> {{ t(\"Confirm Refund\") }} </template> <div class=\"confirmation-modal\"> {{ t(\"Are you sure you want to mark this purchase has having been refunded?\") }} {{ t(\"Make sure you process the refund on Stripe/Braintree before confirming here.\") }} <div v-if=\"selectedPurchase\"> <ul class=\"purchase-list\"> <li>{{ t(\"Date\") }}: {{ new Date(selectedPurchase.date).toUTCString() }}</li> <li>{{ t(\"User\") }}: {{ selectedPurchase.user.name }} - {{ selectedPurchase.user.email }}</li> <li>{{ t(\"Creator\") }}: {{ selectedPurchase.creator.name }} - {{ selectedPurchase.creator.email }}</li> <li>{{ t(\"Gifted?\") }}: {{ selectedPurchase.gift ? t(\"Yes\") : t(\"No\") }}</li> <li>{{ t(\"Amount\") }}: ${{ selectedPurchase.price?.toFixed(2) }}</li> </ul> </div> </div> </b-modal> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-purchases-payouts .refunded { text-decoration: line-through; } .admin-purchases-payouts .capitalize { text-transform: capitalize; } .confirmation-modal .purchase-list { margin: 10px auto; }"
    });
  },
  data() {
    return {
      purchasesData: {
        pageSize: 50,
        currentPage: 1,
        totalNumberOfElements: null,
        pageData: null,
        totalNumberOfPages: null
      },
      payoutsFields: [{
        key: "date",
        label: t("Payout date"),
        formatter: (value, key, item) => {
          return new Date(value).toUTCString();
        }
      }, {
        key: "user",
        label: t("Creator"),
        formatter: (value, key, item) => {
          return value ? value.name : "<unknown>";
        }
      }, {
        key: "amount",
        label: t("Amount"),
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "status",
        label: t("Status")
      }, {
        key: "refund",
        label: t("Refund")
      }],
      balancesFields: [{
        key: "creator",
        label: t("Creator"),
        formatter: (value, key, item) => {
          return value ? value.name : "<unknown>";
        }
      }, {
        key: "balance",
        label: t("Balance"),
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "nextPayout",
        label: t("Next Payout"),
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }],
      payouts: [],
      balances: [],
      selectedPurchase: null,
      isRefundModalVisible: false,
      pageSizeOptions: [50, 25, 10, 5],
      purchasesSearchInputs: {
        users: "",
        packages: ""
      },
      loadingPayoutsAndBalances: false
    };
  },
  watch: {
    async pageSize() {
      if (this.purchasesData.pageData) {
        await this.findPurchases();
      }
    }
  },
  computed: {
    purchasesFields() {
      const purchasesFields = [{
        key: "date",
        label: t("Purchase date"),
        sortable: true,
        formatter: (value, key, item) => {
          return new Date(value).toUTCString();
        }
      }, {
        key: "user",
        label: t("User"),
        sortable: true,
        formatter: (value, key, item) => {
          return value ? `${value.email} (${value.id})` : "<unknown>";
        }
      }, {
        key: "creator",
        label: t("Creator"),
        sortable: true,
        formatter: (value, key, item) => {
          return value ? `${value.name} (${value.id})` : "";
        }
      }, {
        key: "content",
        sortable: true,
        label: t("Content"),
        sortByFormatted: true,
        formatter: (value, key, item) => {
          return item ? `${item.title}` : "";
        }
      }, {
        key: "price",
        label: t("Price"),
        sortable: true,
        tdClass: (value, key, item) => item.status === "refunded" ? "refunded text-right" : "text-right",
        formatter: (value, key, item) => {
          return `$${value.toFixed(2)}`;
        }
      }, {
        key: "fee",
        label: t("Platform Fee"),
        sortable: true,
        tdClass: (value, key, item) => item.status === "refunded" ? "refunded text-right" : "text-right",
        formatter: (value, key, item) => {
          return `$${value.toFixed(2)}`;
        }
      }, {
        key: "gift",
        label: t("Gifted?"),
        sortable: true,
        tdClass: "text-center",
        formatter: (value, key, item) => {
          return value ? `🎁` : "";
        }
      }, {
        key: "status",
        label: t("Status"),
        tdClass: "text-center",
        sortable: true
      }, {
        key: "refund",
        label: t("Refund"),
        tdClass: "text-center"
      }];
      return purchasesFields;
    },
    purchasesSearchTerms() {
      const usersSearchInputs = this.purchasesSearchInputs.users.split(",").map(input => input.trim()).filter(input => input !== "");
      const packagesSearchInputs = this.purchasesSearchInputs.packages.split(",").map(input => input.trim()).filter(input => input !== "");
      return {
        users: usersSearchInputs,
        packages: packagesSearchInputs
      };
    },
    pageSize() {
      return this.purchasesData.pageSize;
    }
  },
  methods: {
    async lazyLoad() {
      this.refresh();
    },
    async refresh() {
      this.selectedPurchase = null;
      this.isRefundModalVisible = false;
      this.purchasesData = {
        pageSize: 50,
        currentPage: 1,
        totalNumberOfElements: null,
        pageData: null,
        totalNumberOfPages: null
      };
      this.purchasesSearchInputs = {
        users: "",
        packages: ""
      };
      this.loadingPayoutsAndBalances = true;
      const response = await Utils.apiAdmin("administration/creator-payouts-balances");
      if (response.error) {
        this.payouts = [];
        this.balances = [];
        this.loadingPurchaseData = false;
        return UI.error(t("Unable to load payouts and balances data: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      this.payouts = response.payouts || [];
      this.balances = response.balances || [];
      this.loadingPayoutsAndBalances = false;
    },
    async fetchPageData(pageNumber) {
      const response = await Utils.apiAdmin("administration/creator-purchases/search", {
        params: {
          searchInputs: this.purchasesSearchTerms,
          pageSize: this.purchasesData.pageSize,
          pageNumber
        }
      });
      if (response.error) {
        this.refresh();
        return UI.error(t("Unable to load purchase data: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      return response;
    },
    async findPurchases() {
      this.purchasesData.currentPage = 1;
      this.purchasesData.pageData = {
        purchases: [],
        isLoaded: false
      };
      const response = await this.fetchPageData(this.purchasesData.currentPage);
      this.purchasesData.totalNumberOfElements = response.totalNumberOfElements || null;
      this.purchasesData.totalNumberOfPages = response.totalNumberOfPages || null;
      this.purchasesData.pageData = {
        purchases: response.purchases || [],
        isLoaded: true
      };
    },
    async pageChange() {
      this.purchasesData.pageData = {
        purchases: [],
        isLoaded: false
      };
      const response = await this.fetchPageData(this.purchasesData.currentPage);
      this.purchasesData.pageData = {
        purchases: response.purchases || [],
        isLoaded: true
      };
    },
    async exportPurchases() {
      // Load all purchases
      let allPurchases = [];
      for (let pageIndex = 0; pageIndex < this.purchasesData.totalNumberOfPages; pageIndex++) {
        const response = await this.fetchPageData(pageIndex + 1);
        allPurchases.push(...response.purchases);
      }
      Utils.downloadAsCSV(allPurchases, {
        filename: "purchases.csv",
        transform: {
          date: d => new Date(d).toLocaleString(),
          user: u => u ? `${u.id}:${u.email}:${u.name}` : "",
          creator: u => u ? `${u.id}:${u.email}:${u.name}` : ""
        }
      });
    },
    exportPayouts() {
      Utils.downloadAsCSV(this.payouts, {
        filename: "payouts.csv",
        transform: {
          date: d => new Date(d).toLocaleString(),
          user: u => u ? `${u.id}:${u.email}:${u.name}` : ""
        }
      });
    },
    exportBalances() {
      Utils.downloadAsCSV(this.balances, {
        filename: "balances.csv",
        transform: {
          date: d => new Date(d).toLocaleString(),
          creator: u => u ? `${u.id}:${u.email}:${u.name}` : ""
        }
      });
    },
    showRefundDialog(item) {
      this.selectedPurchase = item; // Set the selected purchase
      this.isRefundModalVisible = true;
    },
    async confirmRefund() {
      if (!this.selectedPurchase) {
        return;
      }

      // Call the refund API
      const refundPurchaseResponse = await Utils.apiAdmin("administration/refund-purchase", {
        purchase: this.selectedPurchase
      });
      if (refundPurchaseResponse.success) {
        UI.info(t("The Purchase has been marked as refunded"));
        const purchaseIndex = this.purchasesData.pageData.purchases.findIndex(p => p.id === this.selectedPurchase.id);
        if (purchaseIndex !== -1) {
          this.$set(this.purchasesData.pageData.purchases, purchaseIndex, {
            ...this.purchasesData.pageData.purchases[purchaseIndex],
            status: "refunded"
          });
        }
      } else {
        UI.error(refundPurchaseResponse.message);
      }
      this.selectedPurchase = null; // Clear the selected purchase
      this.isRefundModalVisible = false;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminServiceAnnouncementPreview"] = Vue.component(
                    "AdminServiceAnnouncementPreview",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-alert class=\"service-announcement-preview mb-0\" show :variant=\"announcement.type || 'info'\"> <p class=\"message mb-0\" v-html=\"announcement.message\"></p> <div class=\"details\"> <div v-if=\"announcement.region\" class=\"region mt-1\"> <i class=\"fas fa-globe-americas fa-fw\"></i> {{ announcement.region }} </div> <div v-if=\"announcement.expires\" class=\"expiration mt-1\"> <i class=\"fas fa-clock fa-fw\" :class=\"expired(announcement.expires)\"></i> {{ Utils.localizeDate(announcement.expires) }} </div> </div> </b-alert>",
  beforeCreate() {
    Utils.loadCss({
      content: ".service-announcement-preview .details { display: flex; gap: 1rem; font-variant: small-caps; font-size: 0.9em; font-weight: bold; }"
    });
  },
  props: {
    announcement: Object
  },
  methods: {
    expired(when) {
      return Date.now() < Date.parse(when) ? "" : "text-danger";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminServiceAnnouncements"] = Vue.component(
                    "AdminServiceAnnouncements",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"admin-service-announcements\"> <!-- Create or edit service announcements --> <b-card no-body class=\"service-announcement-editor\"> <b-card-header>{{ t(\"Editor\") }}</b-card-header> <b-card-body> <b-form-group label-cols=\"2\" :label=\"t('Message')\"> <b-form-textarea v-model=\"editor.message\" max-rows=\"10\"></b-form-textarea> </b-form-group> <!-- Expiration selector --> <b-form-group label-cols=\"2\" :label=\"t('Expiration')\" class=\"mt-2\"> <date-picker v-model=\"editor.expires\" type=\"datetime\" class=\"w-100\" input-class=\"form-control\" :popup-style=\"{ top: '100%', left: 0 }\" :append-to-body=\"false\" ></date-picker> </b-form-group> <!-- Type selector --> <b-form-group label-cols=\"2\" :label=\"t('Type')\"> <b-form-radio v-for=\"atype of ALERT_TYPES\" :key=\"atype.value\" v-model=\"editor.type\" :value=\"atype.value\" inline class=\"alert-type\" > <span :class=\"`text-${atype.value}`\"> {{ atype.text }} </span> </b-form-radio> </b-form-group> <!-- Region selector --> <b-form-group label-cols=\"2\" :label=\"t('Regions')\"> <div v-if=\"newAnnouncement\"> <b-form-checkbox :checked=\"editor.regions.length === 0\" :disabled=\"editor.regions.length === 0\" switch @change=\"selectAllRegions\" >{{ t(\"All\") }}</b-form-checkbox > <b-form-checkbox-group v-model=\"editor.regions\" :options=\"regions.map((region) => ({ value: region.id, text: `${region.id} - ${region.name}` }))\" switches ></b-form-checkbox-group> </div> <div v-else> <b-form-radio v-model=\"editor.region\" :value=\"null\">{{ t(\"All\") }}</b-form-radio> <b-form-radio v-for=\"region of regions\" :key=\"region.id\" v-model=\"editor.region\" :value=\"region\">{{ region.id }}</b-form-radio> </div> </b-form-group> <!-- Service announcement preview --> <admin-service-announcement-preview v-for=\"announcement of editedAnnouncement\" :key=\"announcement.region\" :announcement=\"announcement\" ></admin-service-announcement-preview> <!-- Action buttons --> <div class=\"editor-buttons\"> <b-button v-if=\"!newAnnouncement\" variant=\"secondary\" @click=\"cancelEdit\">{{ t(\"Cancel editing\") }}</b-button> <b-button variant=\"secondary\" @click=\"resetEditor\">{{ t(\"Reset\") }}</b-button> <b-button :disabled=\"!messageSet\" :variant=\"newAnnouncement ? 'success' : 'primary'\" @click=\"submitEdit\">{{ newAnnouncement ? t(\"Create\") : t(\"Update\") }}</b-button> </div> </b-card-body> </b-card> <!-- Active (and expired) service announcements --> <b-card no-body class=\"service-announcements-list mt-4\"> <b-card-header>{{ t(\"Service Announcements\") }}</b-card-header> <b-card-body> <b-form-checkbox id=\"showExpiredAnnouncements\" v-model=\"showExpiredAnnouncements\" switch> {{ t(\"Show expired service announcements\") }} </b-form-checkbox> <draggable v-model=\"announcements\" v-bind=\"dragOptions\" draggable=\".preview\" handle=\".grip\" @end=\"reorder\"> <div v-for=\"announcement in activeAnnouncements\" :key=\"announcement._id\" class=\"preview\"> <span class=\"grip\"><i v-if=\"!expired(announcement.expires)\" class=\"fas fa-grip-horizontal\"></i></span> <admin-service-announcement-preview :announcement=\"announcement\"></admin-service-announcement-preview> <b-button v-b-tooltip variant=\"outline-danger\" :title=\"t('Expire immediately')\" @click=\"expire(announcement._id)\" ><i class=\"fas fa-stopwatch\"></i ></b-button> <b-button variant=\"outline-primary\" @click=\"edit(announcement)\" ><i class=\"fas fa-pencil-alt fa-fw\"></i ></b-button> </div> </draggable> <div v-for=\"announcement in expiredAnnouncements\" :key=\"announcement._id\" class=\"preview expired\"> <admin-service-announcement-preview :announcement=\"announcement\"></admin-service-announcement-preview> </div> </b-card-body> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-service-announcements label[for=\"showExpiredAnnouncements\"] + div { display: flex; align-items: center; } .admin-service-announcements label.custom-control-label[for=\"showExpiredAnnouncements\"] { margin-top: -3px; /* Vue bootstrap large checkbox misalignment */ } .admin-service-announcements .custom-switch + .alert { margin-top: 1rem; } .admin-service-announcements .alert-type { font-weight: bold; } .admin-service-announcements .form-group { margin-bottom: 0; } .admin-service-announcements .form-row > .col { align-self: center; } .admin-service-announcements .service-announcement-editor .alert, .admin-service-announcements .service-announcements-list .preview { margin-top: 0.5rem; } .admin-service-announcements .service-announcement-editor .editor-buttons { float: right; display: flex; gap: 1rem; margin-top: 1rem; } .admin-service-announcements .service-announcement-editor .editor-buttons button { min-width: 7em; } .admin-service-announcements .preview { display: flex; gap: 0.5rem; align-items: stretch; } .admin-service-announcements .preview .alert { flex-grow: 1; } .admin-service-announcements .grip { display: flex; align-items: center; justify-content: center; cursor: grab; width: 1.5em; } .admin-service-announcements .fa-grip-horizontal { opacity: 0.75; } .admin-service-announcements .preview.expired { padding-left: calc(1.5em + 0.5rem); /* .grip + flex gap */ } .admin-service-announcements .ghost { opacity: 0.75; } .admin-service-announcements .ghost > .alert { border-style: dashed; border-color: var(--primary); } .admin-service-announcements .custom-switch { display: block; /* Force each radio to be on its own line */ }"
    });
  },
  data() {
    return {
      regions: [],
      ALERT_TYPES: [{
        text: "Info",
        value: "info"
      }, {
        text: "Success",
        value: "success"
      }, {
        text: "Warning",
        value: "warning"
      }, {
        text: "Danger",
        value: "danger"
      }, {
        text: "Primary",
        value: "primary"
      }, {
        text: "Secondary",
        value: "secondary"
      }],
      announcements: [],
      showExpiredAnnouncements: false,
      editor: {
        _id: null,
        // Editor only field
        message: "",
        expires: null,
        type: "info",
        region: null,
        // Editor only field
        regions: [] // New announcements only field
      },

      editorDefaultConfiguration: null,
      // Holds the initial state of editor
      editorResetConfiguration: null // Holds the initial state of the currently edited announcement
    };
  },

  computed: {
    activeAnnouncements() {
      return this.announcements.filter(a => !this.expired(a.expires));
    },
    expiredAnnouncements() {
      return this.showExpiredAnnouncements ? this.announcements.filter(a => this.expired(a.expires)) : [];
    },
    messageSet() {
      return this.editor.message.trim().length > 0;
    },
    editedAnnouncement() {
      // Don't display announcements without message body
      if (!this.messageSet) {
        return [];
      }
      // Show global announcement
      if (this.editor.regions.length === 0) {
        return [this.editor];
      }
      // Show multiple announcements preview (one per region)
      return this.editor.regions.map(region => Object.assign({
        region
      }, this.editor));
    },
    newAnnouncement() {
      return !this.editor._id;
    },
    dragOptions() {
      return {
        animation: 200,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    async lazyLoad() {
      // Initialize the general reset
      if (!this.editorDefaultConfiguration) {
        this.editorDefaultConfiguration = Object.assign({}, this.editor); // Shallow copy
        this.editorResetConfiguration = Object.assign({}, this.editor); // Shallow copy
      }

      // Load regions
      if (this.regions.length === 0) {
        const regions = await Utils.api("regions");
        if (regions.error) {
          return UI.alert("danger", t(`Error retrieving list of available regions: {{error}}`, {
            error: regions.error
          }), false, 10000);
        }
        // List of case-insensitively sorted region IDs
        this.regions = regions.sort((a, b) => a.id.localeCompare(b.id, undefined, {
          sensitivity: "accent"
        }));
      }

      // Load service announcements
      if (this.announcements.length === 0) {
        await this.refresh();
      }
    },
    async refresh() {
      const response = await Utils.apiAdmin(`administration/announcements`);
      if (response.error) {
        return UI.alert("danger", `Unable to load service announcements: ${response.error}`, true, 10000);
      }
      const announcements = response.announcements.sort((a, b) => {
        // Expired are alwayst last, sorted by date, ignoring order
        const ea = this.expired(a.expires);
        const eb = this.expired(b.expires);
        if (!ea && eb) {
          return -1;
        }
        if (ea && !eb) {
          return 1;
        }
        if (ea && eb) {
          return b.expires.localeCompare(a.expires);
        }
        // If not expired, order by provided order
        const orderDifference = a.order - b.order;
        if (orderDifference) {
          return orderDifference;
        }
        // If same order, non expiring first
        if (!a.expires && !b.expires) {
          return 0;
        }
        if (!a.expires && b.expires) {
          return -1;
        }
        if (a.expires && !b.expires) {
          return 1;
        }
        return b.expires.localeCompare(a.expires);
      });
      // Convert from `yyyy-mm-ddThh:mm:ssZ` string to Date, to work with DatePicker
      this.announcements = announcements.map(a => {
        if (a.expires) {
          a.expires = new Date(a.expires);
        }
        return a;
      });
    },
    expired(when) {
      return !!when && Date.now() > Date.parse(when);
    },
    selectAllRegions() {
      this.editor.regions = [];
    },
    edit(announcement) {
      Object.assign(this.editor, announcement);
      Object.assign(this.editorResetConfiguration, announcement);
    },
    resetEditor() {
      Object.assign(this.editor, this.editorResetConfiguration);
    },
    cancelEdit() {
      Object.assign(this.editor, this.editorDefaultConfiguration);
      Object.assign(this.editorResetConfiguration, this.editorDefaultConfiguration);
    },
    async submitEdit() {
      if (this.newAnnouncement) {
        // Create new service announcement
        const response = await Utils.apiAdmin("administration/announcements", this.editor);
        if (response.error) {
          return UI.alert("danger", `Unable to load service announcements: ${response.error}`, true, 10000);
        }
        // If no major errors, the `response.responses` will contain separate
        // results for each region, so we parse them (almost) individually
        const global = this.editor.regions.length === 0;
        const succeeded = [];
        let noErrors = true;
        for (const [region, result] of Object.entries(response.responses)) {
          if (result.error) {
            noErrors = false;
            // Don't autoclose errors, in case they need to be reposted for specific regions only
            UI.alert("danger", `Unable to post the service announcements${global ? "" : ` for the <b>${region}</b> region`}: ${result.error}`);
          } else {
            succeeded.push(region);
          }
        }
        if (succeeded.length) {
          UI.alert("success", `Successfully posted the service announcements${global ? "" : ` for the following regions: <b>${succeeded.join("</b>, <b>")}</b>`}`, true, 5000);
          await this.refresh();
        }
        if (noErrors) {
          this.resetEditor();
        }
      } else {
        // Edit existing service announcement
        const response = await Utils.apiAdmin("administration/announcements", this.editor, {
          method: "PUT"
        });
        if (response.error) {
          return UI.alert("danger", `Unable to edit the service announcements: ${response.error}`, true, 10000);
        }
        UI.alert("success", `Successfully edited the service announcement`, true, 3000);
        this.cancelEdit(); // Reset editor
        await this.refresh();
      }
    },
    async reorder() {
      // Update the order after sorting
      const order = this.activeAnnouncements.reduce((p, v, i) => {
        p[v._id] = i;
        return p;
      }, {});
      const response = await Utils.apiAdmin("administration/announcements", {
        order
      }, {
        method: "PATCH"
      });
      if (response.error) {
        return UI.alert("danger", `Unable to reorder service announcements: ${response.error}`, true, 10000);
      }
      UI.alert("success", `Successfully reordered service announcements`, true, 3000);
    },
    async expire(id) {
      const expiration = {};
      expiration[id] = Date.now() - DAY_MS; // Yesterday
      const response = await Utils.apiAdmin("administration/announcements", {
        expiration
      }, {
        method: "PATCH"
      });
      if (response.error) {
        return UI.alert("danger", `Unable to change service announcement expiration: ${response.error}`, true, 10000);
      }
      UI.alert("success", `Successfully expired service announcement`, true, 3000);
      await this.refresh();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminSiteSettings"] = Vue.component(
                    "AdminSiteSettings",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"admin-site-settings\"> <!-- Edit site settings --> <b-card no-body> <b-card-header>{{ t(\"Settings\") }}</b-card-header> <b-card-body> <b-tabs content-class=\"border-bottom p-3 border-right border-left\"> <b-tab :title=\"t('Bazaar Tags')\" active> <b-table hover striped stacked=\"md\" show-empty small head-variant=\"light\" class=\"bazaar-tag-table mb-0\" :busy=\"loadingBazaarTags\" :items=\"tagList\" :fields=\"tagFields\" @row-clicked=\"selectBazaarTag\" > <template #cell(label)=\"{ item }\"> <span class=\"bazaar-tag-item\" :style=\"`--bazaar-tag-depth:${item.depth}`\"> {{ item.label }} </span> </template> <template #cell(displayOrder)=\"{ item }\"> <b-form-input v-model=\"item.displayOrder\" type=\"number\" size=\"sm\" @change=\"updateBazaarTagPosition(item)\" ></b-form-input> </template> <template #cell(selectable)=\"{ value }\"> <i v-if=\"value\" class=\"fas fa-check\"></i> </template> <template #cell(visible)=\"{ value }\"> <i v-if=\"value\" class=\"fas fa-check\"></i> </template> <template #head(action)> <b-button v-b-tooltip.hover size=\"sm\" variant=\"primary\" :title=\"t('Add a new tag')\" @click=\"addBazaarTag()\" > <i class=\"fas fa-plus\"></i> </b-button> </template> <template #cell(action)=\"{ item }\"> <b-button v-b-tooltip.hover size=\"sm\" variant=\"outline-primary\" :title=\"t('Add child tag')\" @click=\"addBazaarTag(item.tag)\" > <i class=\"fas fa-plus\"></i> </b-button> <b-button v-b-tooltip.hover size=\"sm\" variant=\"outline-secondary\" :title=\"t('Remove this tag')\" @click=\"showConfirmRemove(item)\" > <i class=\"fas fa-trash\"></i> </b-button> </template> <template #table-busy> <div class=\"text-center my-2\"> <b-spinner class=\"align-middle\"></b-spinner> <strong>{{ t(\"Loading…\") }}</strong> </div> </template> </b-table> <b-table hover striped stacked=\"md\" show-empty small table-variant=\"info\" class=\"custom-tag-table mb-0 mt-2\" :items=\"customTagList\" :fields=\"customTagFields\" > <template #cell(action)=\"{ item }\"> <b-button v-b-tooltip.hover size=\"sm\" :variant=\"item.customTagConflict ? 'outline-warning' : 'outline-primary'\" :title=\"item.customTagConflict ? t('Add despite overlap') : t('Add custom tag')\" @click=\"selectBazaarTag(item)\" > <i class=\"fas fa-plus\"></i> </b-button> </template> </b-table> </b-tab> </b-tabs> </b-card-body> </b-card> <b-modal :visible=\"showBazaarTagModal\" centered :title=\"t('Edit Bazaar Tag')\" @hidden=\"showBazaarTagModal = false\" @ok.prevent=\"updateBazaarTag\" > <b-form-group :label=\"t('Parent')\" label-cols=\"3\"> <b-form-input v-model=\"selectedBazaarTag.parent\" list=\"parent-list\" autocomlete=\"off\" @focus=\"showTagsDropdown = true\" @blur=\"showTagsDropdown = false\" ></b-form-input> <bazaar-tags-dropdown v-model=\"showTagsDropdown\" :tags=\"bazaarTagsSelectable\" :selection=\"tagDropdownSelection\" @selected=\"selectedParentTag\" @focus=\"showTagsDropdown = true\" @blur=\"showTagsDropdown = false\" > </bazaar-tags-dropdown> </b-form-group> <!-- This is the display name of the tag --> <b-form-group :label=\"t('Label')\" label-cols=\"3\"> <b-input v-model=\"selectedBazaarTag.label\" autofocus required @blur=\"createTagFromLabel\"></b-input> </b-form-group> <!-- This is the key name of the tag in db --> <b-form-group :label=\"t('Tag')\" label-cols=\"3\"> <b-input v-model=\"selectedBazaarTag.tag\" required :disabled=\"!selectedBazaarTag.newTag\"></b-input> </b-form-group> <b-form-group :label=\"t('Order')\" label-cols=\"3\"> <b-input v-model=\"selectedBazaarTag.displayOrder\" type=\"number\"></b-input> </b-form-group> <b-form-group :label=\"t('Selectable')\" label-cols=\"3\"> <b-checkbox v-model=\"selectedBazaarTag.selectable\"></b-checkbox> </b-form-group> <b-form-group :label=\"t('Visible')\" label-cols=\"3\"> <b-checkbox v-model=\"selectedBazaarTag.visible\"></b-checkbox> </b-form-group> <template #modal-footer=\"{ cancel, ok }\"> <span v-show=\"bazaarTagHasMultipleLabels\" v-b-tooltip.hover.top=\"t('Multiple labels on the same tag may cause incorrect labels to display on packages')\" > <i class=\"fas fa-exclamation-triangle text-warning\"></i> </span> <b-button @click=\"cancel\"> {{ t(\"Close\") }} </b-button> <b-button variant=\"primary\" :disabled=\"!canSaveBazaarTag\" @click=\"ok\"> {{ t(\"Save\") }} </b-button> </template> </b-modal> <confirm-message v-model=\"confirmRemove\" :title=\"t('Confirm Delete Bazaar Tag')\" @ok=\"removeBazaarTag\"> <i18n :path=\"t('Are you sure you wish to remove the Bazaar Tag {0}?')\" tag=\"p\"> <strong>{{ removingBazaarTag.label }}</strong> </i18n> <b-form-group v-if=\"removingTagHasChildren\" :label=\"t('Remove all children')\" label-cols=\"6\"> <b-checkbox v-model=\"removeChildren\" class=\"mt-2\"></b-checkbox> </b-form-group> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".action-col { white-space: nowrap; } @media (min-width: 768px) { .action-col { width: 80px; } } .checkbox-col { width: 120px; } .display-order-col { width: 60px; } :root { --bazaar-tag-depth: 1; --bazaar-tag-padding-width: 0px; } @media (min-width: 768px) { :root { --bazaar-tag-padding-width: 20px; } } @media (min-width: 1200px) { :root { --bazaar-tag-padding-width: 50px; } } .admin-site-settings .bazaar-tag-item { margin-left: calc(var(--bazaar-tag-padding-width) * var(--bazaar-tag-depth)); } .bazaar-tag-table tbody tr td button.btn:not(:hover) { background-color: rgba(0, 0, 0, 0.05); } .custom-tag-table tbody tr td button.btn:not(:hover) { background-color: rgba(255, 255, 255, 0.6); }"
    });
  },
  data() {
    return {
      loadingBazaarTags: true,
      showBazaarTagModal: false,
      selectedBazaarTag: {},
      bazaarTags: [],
      tagUsageList: [],
      confirmRemove: false,
      removingBazaarTag: {},
      removeChildren: true,
      showTagsDropdown: false,
      tagFields: [{
        key: "label",
        label: t("Label"),
        thClass: "align-middle pl-2",
        tdClass: "align-middle pl-md-2"
      }, {
        key: "tag",
        label: t("Tag"),
        thClass: "align-middle",
        tdClass: "align-middle"
      }, {
        key: "count",
        label: t("Usage"),
        thClass: "align-middle text-center",
        tdClass: "align-middle text-center"
      }, {
        key: "displayOrder",
        label: t("Order"),
        thClass: "display-order-col text-center align-middle",
        tdClass: "text-center align-middle"
      }, {
        key: "selectable",
        label: t("Selectable"),
        thClass: "checkbox-col text-center align-middle",
        tdClass: "text-center align-middle"
      }, {
        key: "visible",
        label: t("Visible"),
        thClass: "checkbox-col text-center align-middle",
        tdClass: "text-center align-middle"
      }, {
        key: "action",
        thClass: "action-col",
        tdClass: "action-col"
      }],
      customTagFields: [{
        key: "tag",
        label: t("Custom Bazaar Tags"),
        thClass: "align-middle pl-2",
        tdClass: "align-middle pl-md-2"
      }, {
        key: "customTagConflict",
        label: t("Overlaps with Bazaar Tag"),
        thClass: "align-middle text-center",
        tdClass: "align-middle text-center"
      }, {
        key: "count",
        label: t("Usage"),
        thClass: "align-middle text-center",
        tdClass: "align-middle text-center"
      }, {
        key: "action",
        label: t("Add to Bazaar Tags"),
        thClass: "action-col",
        tdClass: "text-center"
      }],
      maxTagDepth: 8,
      refreshKey: 0
    };
  },
  computed: {
    tagList() {
      const list = [];
      const buildTags = (tags, depth = 0, variant = "") => {
        if (depth > this.maxTagDepth) {
          return;
        }
        if (!tags || !tags.length) {
          return;
        }
        tags = tags.sort((a, b) => {
          const order = a.displayOrder - b.displayOrder;
          if (order !== 0) {
            return order;
          }
          return a.label.localeCompare(b.label);
        });
        for (let tag of tags) {
          const tagUsage = this.tagUsageList.find(tu => tu.tag === tag.tag);
          // Check for cases where tags match but their labels are different
          // These cases are important to be aware of, because we translate from BAZAAR_TAG.${tag}
          // Having different labels can result in an unintended label displaying on packages when tagged
          const hasMultipleLabels = this.bazaarTags.some(bt => bt.tag === tag.tag && (bt.parent || "") !== (tag.parent || "") && bt.label !== tag.label);
          list.push(Object.assign({
            count: tagUsage && tagUsage.count || 0
          }, tag, {
            depth,
            _rowVariant: variant || (hasMultipleLabels ? "warning" : "")
          }));
          buildTags(this.bazaarTags.filter(bt => bt.parent === tag.tag), depth + 1, variant);
        }
      };

      // Add the normal tags
      buildTags(this.bazaarTags.filter(bt => !bt.parent));
      // Add tags that are attached to a parent that doesn't exist
      buildTags(this.bazaarTags.filter(bt => !!bt.parent && !this.bazaarTags.find(t => t.tag === bt.parent)), 0, "danger");
      return list;
    },
    customTagList() {
      // Add custom tags that are not in any hierarchy
      // A custom tag identifier will never match a bazaarTag's tag
      // However, a custom tag identifier may match a bazaarTag's label
      return this.tagUsageList
      // tagUsageList is [{ tag: 'Bazaar tag slug or custom tag string', count: 0 }]
      .filter(tu => !this.bazaarTags.some(bt => bt.tag === tu.tag)) // Filter out BazaarTags
      .map(tu => Object.assign({
        isCustom: true,
        customTagConflict: (this.bazaarTags.find(bt => [bt.label, bt.tag].includes(tu.tag)) || {}).tag,
        displayOrder: 0
      }, tu));
    },
    tagDropdownSelection() {
      this.refreshKey; // Using a refresh key to make sure that the selected tags are updated
      return this.selectedBazaarTag.parent ? [this.selectedBazaarTag.parent] : [];
    },
    // tags list but all marked as selectable so they can be used in the parent selection dropdown
    bazaarTagsSelectable() {
      // check to see if this tag is the selected tag or is the child of any of the selected tags children
      const selectedTagList = [{
        tag: this.selectedBazaarTag.tag,
        parent: this.selectedBazaarTag.originalParent
      }];
      const findSelectedTags = (parent, depth = 0) => {
        const children = this.bazaarTags.filter(bt => bt.parent === parent.tag).map(bt => ({
          tag: bt.tag,
          parent: bt.parent
        }));
        selectedTagList.push(...children);
        if (depth < this.maxTagDepth) {
          for (let child of children) {
            findSelectedTags(child, depth++);
          }
        }
      };
      findSelectedTags(this.selectedBazaarTag);
      return this.bazaarTags.map(tag => {
        const isSelectedTag = selectedTagList.some(t => t.tag === tag.tag && tag.parent === t.parent);
        return {
          ...tag,
          visible: true,
          // Force all tags to become visible
          selectable: true,
          // Force all tags to become selectable
          disabled: isSelectedTag // Disable the selected tag and all of its children
        };
      }).sort((a, b) => {
        const order = a.displayOrder - b.displayOrder;
        if (order !== 0) {
          return order;
        }
        return a.label.localeCompare(b.label);
      });
    },
    canSaveBazaarTag() {
      if (!this.selectedBazaarTag) {
        return false;
      }
      const valid = this.selectedBazaarTag.tag && this.selectedBazaarTag.tag.length >= 3 && this.selectedBazaarTag.label && this.selectedBazaarTag.label.length >= 3;
      // If this is a new tag, or if the parent has changed, then make sure that the tag and parent combo is unique
      if (this.selectedBazaarTag.newTag || (this.selectedBazaarTag.originalParent || "") !== (this.selectedBazaarTag.parent || "")) {
        return valid && !this.bazaarTags.some(bt => bt.tag === this.selectedBazaarTag.tag && (bt.parent || "") === (this.selectedBazaarTag.parent || ""));
      }
      return valid;
    },
    bazaarTagHasMultipleLabels() {
      if (!this.selectedBazaarTag) {
        return false;
      }
      // Check for cases where tags match but labels differ
      return this.bazaarTags.some(bt => {
        return bt.tag === this.selectedBazaarTag.tag && (bt.parent || "") !== (this.selectedBazaarTag.parent || "") && bt.label !== this.selectedBazaarTag.label;
      });
    },
    newBazaarTag() {
      return {
        selectable: true,
        visible: true,
        tag: "",
        label: "",
        parent: "",
        newTag: true
      };
    },
    removingTagHasChildren() {
      return this.bazaarTags.some(t => t.parent === this.removingBazaarTag.tag);
    }
  },
  methods: {
    async lazyLoad() {
      this.refresh();
    },
    async refresh() {
      this.loadingBazaarTags = true;
      const response = await Utils.apiAdmin(`administration/bazaar-tags`);
      if (response.error) {
        this.bazaarTags = [];
        this.tagUsageList = [];
        this.loadingBazaarTags = false;
        return UI.error(t("Unable to load settings: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      this.bazaarTags = response.bazaarTagsList || [];
      this.tagUsageList = response.tagUsageList || [];
      this.loadingBazaarTags = false;
    },
    createTagFromLabel() {
      // Only create the tag if the bazaar tag exists, the tag field is not filled in, and label has been filled in
      if (!this.selectedBazaarTag || !!this.selectedBazaarTag.tag || !this.selectedBazaarTag.label) {
        return;
      }
      this.selectedBazaarTag.tag = Utils.slugify(this.selectedBazaarTag.label);
    },
    selectBazaarTag(item) {
      this.selectedBazaarTag = Utils.duplicate(item); // duplicate the tag so that the table isn't updated while changing data
      this.selectedBazaarTag.originalParent = item.parent;
      if (item.isCustom) {
        // Use the custom label as a template for a new BazaarTag
        // Note: This does not automatically change Packages.bazaarTags to use the new BazaarTag
        this.selectedBazaarTag.label = item.tag;
        this.selectedBazaarTag.tag = Utils.slugify(item.tag);
        this.selectedBazaarTag.selectable = true;
        this.selectedBazaarTag.visible = true;
        this.selectedBazaarTag.newTag = true;
        if (item.customTagConflict) {
          this.selectedBazaarTag.parent = (this.bazaarTags.find(bt => bt.tag === item.customTagConflict) || {}).parent;
        }
      }
      this.showBazaarTagModal = true;
    },
    addBazaarTag(parent) {
      const data = this.newBazaarTag;
      data.parent = parent;
      this.selectBazaarTag(data);
    },
    selectedParentTag(tag) {
      if (!this.selectedBazaarTag) {
        return false;
      }
      if (this.selectedBazaarTag.parent === tag.tag) {
        this.selectedBazaarTag.parent = null;
      } else {
        this.selectedBazaarTag.parent = tag.tag;
      }
      this.refreshKey++;
    },
    async updateBazaarTagPosition(item) {
      const response = await Utils.apiAdmin(`administration/bazaar-tags`, {
        action: "update",
        tag: item.tag,
        parent: item.parent,
        data: {
          displayOrder: item.displayOrder
        }
      });
      if (response.error) {
        return UI.error(t("Unable to update bazaar tag: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      UI.alert("success", t("Bazaar tag updated"), true, 1000);
      this.bazaarTags = this.bazaarTags.filter(tag => !(tag.tag === item.tag && tag.parent === item.parent));
      this.bazaarTags.push(response.tag);
    },
    async updateBazaarTag() {
      this.showBazaarTagModal = false;
      const response = await Utils.apiAdmin(`administration/bazaar-tags`, {
        action: "update",
        tag: this.selectedBazaarTag.tag,
        parent: this.selectedBazaarTag.originalParent,
        data: {
          tag: this.selectedBazaarTag.tag,
          parent: this.selectedBazaarTag.parent || null,
          label: this.selectedBazaarTag.label,
          selectable: this.selectedBazaarTag.selectable,
          visible: this.selectedBazaarTag.visible,
          disabled: this.selectedBazaarTag.disabled,
          displayOrder: this.selectedBazaarTag.displayOrder || 0
        }
      });
      if (response.error) {
        return UI.error(t("Unable to update bazaar tag: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      UI.success(t(this.selectedBazaarTag.newTag ? "Bazaar tag created" : "Bazaar tag updated"));
      this.bazaarTags = this.bazaarTags.filter(tag => !(tag.tag === this.selectedBazaarTag.tag && tag.parent === this.selectedBazaarTag.originalParent));
      delete this.selectedBazaarTag.newTag;
      delete this.selectedBazaarTag.originalParent;
      this.bazaarTags.push(response.tag);
      this.selectedBazaarTag = {};
    },
    showConfirmRemove(item) {
      this.removingBazaarTag = item;
      this.confirmRemove = true;
      this.removeChildren = false;
    },
    async removeBazaarTag() {
      this.confirmRemove = false;
      this.loadingBazaarTags = true;
      const tags = [{
        tag: this.removingBazaarTag.tag,
        parent: this.removingBazaarTag.parent
      }];

      // Check and see if the children should be removed as well
      if (this.removeChildren) {
        const findChildren = parent => {
          const children = this.bazaarTags.filter(bt => bt.parent === parent);
          for (let child of children) {
            tags.push({
              tag: child.tag,
              parent: child.parent
            });
            findChildren(child.tag);
          }
        };
        findChildren(this.removingBazaarTag.tag);
      }
      const response = await Utils.apiAdmin(`administration/bazaar-tags`, {
        action: "remove",
        tags
      });
      this.removingBazaarTag = {};
      this.loadingBazaarTags = false;
      if (response.error) {
        return UI.error(t("Unable to remove bazaar tag: {{- error}}", {
          error: response.error || t("Unknown error")
        }));
      }
      UI.success(t("Bazaar tag removed"));
      this.bazaarTags = this.bazaarTags.filter(tag => !tags.find(t => t.tag === tag.tag && t.parent === tag.parent));
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminUserEmail"] = Vue.component(
                    "AdminUserEmail",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"edit-email-container\"> <span style=\"min-width: 70px\"> {{ t(\"e-Mail\") }}</span> <b-link v-b-tooltip.hover :style=\"{ cursor: disabled ? 'not-allowed' : 'pointer', marginLeft: '-15px' }\" :disabled=\"disabled\" :title=\" editing ? t('Cancel') : disabled ? t( 'You may only edit one user email at a time. Cancel editing the other user email if you want to edit this one.' ) : t('Edit') \" @click=\"toggleEdit()\" > <i v-if=\"!editing\" class=\"fa fa-pencil-alt\"></i> <div v-else class=\"cancel-edit-icon\"> <i class=\"fa fa-pencil-alt cancel-edit-icon\"></i> <i class=\"fa fa-slash cancel-edit-icon\"></i> </div> </b-link> <div style=\"display: flex; margin-left: 20px\"> <span v-if=\"!editing\">{{ userEmail }}</span> <b-form-input v-else v-model=\"userEmail\" :disabled=\"!editing\" :style=\"{ minWidth: '400px', marginLeft: '-5px' }\" ></b-form-input> <b-button v-if=\"editing\" variant=\"primary\" class=\"profile-button\" :disabled=\"!isEmailChanged\" style=\"margin-left: 20px\" @click=\"handleSaveEmailClick()\" > <i class=\"fas fa-save\"></i> <span> {{ t(\"Save new e-Mail\") }}</span> </b-button> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".edit-email-container { display: flex; } .cancel-edit-icon { position: relative; &.fa-pencil-alt { position: absolute; top: 3px; left: 2px; } }"
    });
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data() {
    return {
      userEmail: this.user.email,
      editing: false
    };
  },
  watch: {
    editing(newValue) {
      // Discard changes
      if (!newValue && this.user.email !== this.userEmail) {
        this.userEmail = this.user.email;
      }
      this.$emit(newValue ? "userSet" : "userUnset");
    }
  },
  computed: {
    isEmailChanged() {
      return this.user.email !== this.userEmail;
    }
  },
  methods: {
    async handleSaveEmailClick() {
      const response = await Utils.apiAdmin(`administration/user/email/${this.user.id}`, {
        email: this.userEmail,
        emailVerified: false
      }, {
        method: "PUT"
      });
      this.editing = false;
      if (response.error) {
        UI.alert("danger", response.error, true, 10000);
        return;
      }
      this.$emit("userEmailUpdate", this.userEmail);
      UI.alert("success", t("Email updated successfully"), 100);
    },
    toggleEdit() {
      this.editing = !this.editing;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminUserGames"] = Vue.component(
                    "AdminUserGames",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"admin-user-games\"> <b-link v-if=\"!games\" :disabled=\"busy\" @click=\"refreshGames\">{{ t(\"Load games\") }}</b-link> <b-button v-else :disabled=\"busy\" variant=\"outline-primary\" @click=\"refreshGames\"> <i class=\"fa fa-sync\"></i> </b-button> <b-table v-if=\"games\" class=\"mt-2\" :fields=\"fields\" :items=\"games\"> <!-- Custom headers --> <template #head(invite)=\"{}\"> <i v-b-tooltip class=\"fas fa-paper-plane\" :title=\"t('Invitation link')\"></i> </template> <template #head(playtime)=\"{}\"> <i v-b-tooltip class=\"fas fa-user-clock\" :title=\"t('Play time')\"></i> </template> <template #head(privacy)=\"{}\"> <i v-b-tooltip class=\"fas fa-unlock-alt\" :title=\"t('Privacy')\"></i> </template> <template #head(status)=\"{}\"> <i v-b-tooltip class=\"fas fa-play\" :title=\"t('Server status and controls')\"></i> </template> <template #head(table)=\"{}\"> <i v-b-tooltip class=\"fas fa-gamepad\" :title=\"t('Managed users')\"></i> </template> <template #head(url)=\"{}\"> <i v-b-tooltip class=\"fas fa-dice-d20\" :title=\"t('Game URL')\"></i> </template> <template #head(visible)=\"{}\"> <i v-b-tooltip class=\"fas fa-eye\" :title=\"t('Visibility')\"></i> </template> <!-- Custom cell content --> <template #cell(invite)=\"{ value, item }\"> <b-link :href=\"`/invite/${item.slug}/${value}`\" target=\"_blank\" ><i v-b-tooltip class=\"fas fa-paper-plane\" :title=\"t('Auto invite yourself')\"></i ></b-link> </template> <template #cell(lastAccess)=\"{ value }\"> {{ Utils.localizeDate(value, true) }} </template> <template #cell(players)=\"{ value }\"> <span v-b-tooltip :title=\"value.map((p) => p.name).join(', ')\">{{ value.length }}</span> </template> <template #cell(playtime)=\"{ item }\"> {{ userPlaytime(item) }} </template> <template #cell(privacy)=\"{ value }\"> <i v-if=\"value === 'private'\" v-b-tooltip class=\"fas fa-lock\" :title=\"t('Private')\"></i> </template> <template #cell(status)=\"{ value, item }\"> <b-button variant=\"link\" class=\"p-0\" :disabled=\"!item.visible || gameActionInProgress[item.slug]\" @click=\"displayGameControls(item.slug, true)\" @blur=\"displayGameControls(item.slug, false)\" > <game-status-indicator :status=\"value\"></game-status-indicator> </b-button> <b-toast :id=\"`game-controls-${item.slug}`\" class=\"d-flex\" body-class=\"d-flex\" static no-auto-hide no-close-button > <b-button v-for=\"status of ['online', 'idle', 'offline']\" :key=\"status\" v-b-tooltip :class=\"status === item.status ? 'd-none' : null\" variant=\"outline-dark\" :title=\"gameActionDescription(status)\" @click=\"gameAction(item, status)\" > <game-status-indicator :show-tooltip=\"false\" :status=\"status\"></game-status-indicator> </b-button> </b-toast> </template> <template #cell(table)=\"{ value }\"> <i v-if=\"!value\" v-b-tooltip class=\"fas fa-gamepad\" :title=\"t('Managed users')\"></i> </template> <template #cell(url)=\"{ value }\"> <b-link :href=\"value\" target=\"_blank\" ><i v-b-tooltip class=\"fas fa-dice-d20\" :title=\"t('Join game')\"></i ></b-link> </template> <template #cell(visible)=\"{ value }\"> <i v-if=\"!value\" v-b-tooltip class=\"fas fa-eye-slash\" :title=\"t('Invisible to the user')\"></i> </template> </b-table> <confirm-message v-model=\"forceIdle.showConfirm\" :title=\"t('Force game idling?')\" variant=\"warning\" @ok=\"gameAction(forceIdle.game, 'idle', true)\" > <i18n :path=\"t('The game “{0}” is still active. Do you want to forcefully idle it?')\" tag=\"p\"> <b>{{ forceIdle.game.slug }}</b> </i18n> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-user-games i.fa-sync { display: flex; } .toast[id^=\"game-controls-\"] > .toast-body { gap: 0.5rem; }"
    });
  },
  props: {
    userId: String
  },
  data: () => ({
    busy: false,
    games: null,
    gameActionInProgress: {},
    fields: [{
      key: "visible"
    }, {
      key: "privacy"
    }, {
      key: "table"
    }, {
      key: "status"
    }, {
      key: "slug"
    }, {
      key: "title"
    }, {
      key: "players"
    }, {
      key: "lastAccess"
    }, {
      key: "playtime"
    }, {
      key: "invite"
    }, {
      key: "url"
    }],
    forceIdle: {
      game: {
        slug: null
      },
      showConfirm: false
    }
  }),
  methods: {
    async refreshGames() {
      this.busy = true;
      const response = await Utils.apiAdmin(`administration/user/games/${this.userId}`);
      if (response.error) {
        UI.alert("danger", `Error finding games for user with ID “${this.userId}”: ${response.error}`, true, 10000);
      } else {
        this.games = response.games;
      }
      this.busy = false;
    },
    userPlaytime(game) {
      if (!game.playerId) {
        return;
      }
      const user = game.players.find(p => p.id === game.playerId);
      if (!user || !user.usage) {
        return;
      }
      return Utils.duration(user.usage * 3600); // `usage` is in hours, `duration` expects seconds
    },

    displayGameControls(slug, visible) {
      const toast = `game-controls-${slug}`;
      if (visible) {
        this.$bvToast.show(toast);
      } else {
        // Delay the blur long enough for Vue to trigger the control click
        // inside the toast, should there be one
        setTimeout(() => this.$bvToast.hide(toast), 200);
      }
    },
    gameActionDescription(desiredState) {
      return {
        online: t("Start the server"),
        idle: t("Idle the server"),
        offline: t("Stop the server")
      }[desiredState];
    },
    async gameAction(game, desiredState, force = false) {
      const action = {
        online: "start",
        idle: "idle",
        offline: "stop"
      }[desiredState];
      if (!action) {
        return UI.alert("danger", t("Error: invalid action"), true, 10000);
      }
      this.$set(this.gameActionInProgress, game.slug, true);
      const payload = {
        game: game.slug
      };
      if (force && desiredState === "idle") {
        payload.force = true;
      }
      const response = await Utils.apiAdmin(`administration/user/${this.userId}/game/${action}`, payload);
      this.$delete(this.gameActionInProgress, game.slug);
      if (!response.success) {
        if (!force && desiredState === "idle") {
          // Show prompt to allow an admin to forcefully idle an active server
          this.forceIdle.game = game;
          this.forceIdle.showConfirm = true;
          return;
        }
        return UI.alert("danger", t("Failed to {{action}} server: {{- error}}", {
          action,
          error: response.error || t("Unknown error")
        }), true, 10000);
      }
      UI.alert("success", t("Server {{state}}", {
        state: desiredState
      }), true, 3000);
      game.status = desiredState;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminUserRoleEditor"] = Vue.component(
                    "AdminUserRoleEditor",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal centered :visible=\"visible\" :title=\"title\" @cancel=\"$emit('cancel', $event)\" @shown=\"dialogShown\" @hidden=\"visible = false\" > <b-alert :show=\"errorDismissal\" variant=\"danger\" dismissible @dismissed=\"errorDismissal = 0\" @dismiss-count-down=\"errorDismissal = $event\" >{{ error }}</b-alert > <b-form-checkbox-group v-model=\"selectedRoles\" :options=\"availableRoles\" stacked buttons button-variant=\"outline-primary\" class=\"w-100 mb-0\" :disabled=\"busy\" ></b-form-checkbox-group> <template #modal-footer=\"{ cancel }\"> <b-button :disabled=\"busy\" @click=\"cancel()\">Cancel</b-button> <b-button :disabled=\"busy\" @click=\"selectedRoles = roles\">Reset</b-button> <b-button :disabled=\"busy || !changes\" variant=\"primary\" @click=\"returnRoles\"> <span v-if=\"!busy\">OK</span> <span v-else><b-spinner small class=\"align-middle\"></b-spinner> Updating…</span> </b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    title: String,
    roles: Array
  },
  data: () => ({
    availableRoles: null,
    selectedRoles: [],
    busy: false,
    error: null,
    errorDismissal: 0
  }),
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    changes() {
      return this.roles.length !== this.selectedRoles.length || !this.selectedRoles.every(r => this.roles.includes(r));
    }
  },
  methods: {
    async fetchRoles() {
      if (!this.availableRoles) {
        this.busy = true;
        const response = await Utils.apiAdmin("administration/user/roles");
        if (response.error) {
          this.visible = false;
          return UI.alert("danger", `Error retrieving user roles: ${response.error}`, true, 10000);
        }
        // t("USER_ROLES.administrator")
        // t("USER_ROLES.staff")
        // t("USER_ROLES.moderator")
        // t("USER_ROLES.developer")
        // t("USER_ROLES.developer-wb")
        // t("USER_ROLES.creator")
        // t("USER_ROLES.translator")
        // t("USER_ROLES.sponsored-game-master")
        // t("USER_ROLES.sponsored-story-teller")
        // t("USER_ROLES.sponsored-world-builder")
        // t("USER_ROLES.sponsored-dndbeyond")
        // t("USER_ROLES.sponsored-data-1")
        // t("USER_ROLES.sponsored-data-2")
        // t("USER_ROLES.sponsored-assets-5")
        // t("USER_ROLES.sponsored-assets-10")
        // t("USER_ROLES.sponsored-assets-15")
        // t("USER_ROLES.sponsored-assets-20")
        // t("USER_ROLES.sponsored-assets-25")
        // t("USER_ROLES.sponsored-upload-1")
        // t("USER_ROLES.sponsored-upload-2")
        this.availableRoles = response.roles.map(r => ({
          text: t(`USER_ROLES.${r}`),
          value: r
        }));
        this.busy = false;
      }
    },
    returnRoles() {
      this.error = null;
      this.busy = true;
      this.$emit("update", this.selectedRoles);
    },
    emitCancel(ev) {
      this.$emit("cancel", ev);
    },
    displayError(message) {
      this.error = message;
      this.errorDismissal = 10;
      this.busy = false;
    },
    dialogShown() {
      this.busy = false;
      this.selectedRoles = this.roles;
      this.fetchRoles();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminUsers"] = Vue.component(
                    "AdminUsers",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header>{{ t(\"Users\") }}</b-card-header> <b-card-body class=\"admin-users\"> <!-- User logs viewer --> <log-viewer-foundry v-model=\"showLogs.visible\" :user=\"showLogs.user\" :type=\"showLogs.type\" :title=\"showLogs.title\" ></log-viewer-foundry> <!-- User search --> <b-form-group label-cols=\"2\" :label=\"t('Find users')\"> <b-form @submit.prevent=\"findUsers\"> <b-input-group> <b-form-input v-model=\"userSearchString\" :placeholder=\"t('Username, email, license, game link or invitation link')\" ></b-form-input> <template #append> <b-button type=\"submit\" variant=\"primary\"><i class=\"fa fa-search fa-fw\"></i> {{ t(\"Search\") }}</b-button> </template> </b-input-group> </b-form> </b-form-group> <!-- User list --> <div v-for=\"(user, userIndex) of users\" :key=\"user.id\" class=\"user\"> <div class=\"avatar\"> <img v-if=\"!!user.profile.picture\" :src=\"user.profile.picture\" /> </div> <div class=\"details\"> <h3> {{ user.username }} ({{ user.profile.nickname }}) <b-button v-b-tooltip.hover.noninteractive variant=\"outline-danger\" :disabled=\"user.roles.length > 0\" :title=\"user.roles.length > 0 ? t('User has active roles, deletion forbidden') : ''\" @click=\"confirmUserRemoval(user)\" ><i class=\"fa fa-fw fa-trash-alt\"></i ></b-button> <b-button v-b-tooltip=\"t('Impersonate {{username}}', { username: user.username || user.email })\" variant=\"link\" class=\"p-0 user-impersonate\" @click=\"impersonateUser(user)\" ><i class=\"fas fa-user-secret\"></i ></b-button> <b-button v-b-tooltip :title=\"user.otp ? t('2FA active') : t('2FA not active')\" :disabled=\"!user.otp\" variant=\"button\" @click=\"confirmOTPRemoval(user)\" ><i :class=\"user.otp ? 'fa fa-lock text-success' : 'fa fa-lock text-danger'\"></i ></b-button> <b-button v-b-tooltip :title=\"t('Send Notificaion To User')\" variant=\"outline-primary\" @click=\"sendNotificationToUser(user)\" ><i class=\"fa fa-paper-plane\"></i ></b-button> </h3> <p class=\"glance\"> {{ user.id }} <i v-for=\"feature in MINI_ICONS\" :key=\"feature.icon\" v-b-tooltip :class=\"`fa fa-${feature.icon} ${feature.check(user) ? 'text-success' : 'text-danger'}`\" :title=\"feature.check(user) ? feature.enabled : feature.disabled\" ></i> <a v-if=\"user.profile.website\" :href=\"user.profile.website\" target=\"_blank\" ><i class=\"fas fa-fw fa-external-link-alt\"></i ></a> </p> <table> <tr> <td colspan=\"2\"> <admin-user-email :user=\"users[userIndex]\" :disabled=\"editingEmailUserIdx != null && userIndex != editingEmailUserIdx\" @userEmailUpdate=\"updateUserEmailProp(userIndex, $event)\" @userSet=\"updateUserSet(userIndex)\" @userUnset=\"updateUserUnset\" ></admin-user-email> </td> </tr> <tr v-if=\"user.linkedAccounts.length\"> <th>{{ t(\"Accounts\") }}</th> <td> <table class=\"linkedAccounts\"> <tr v-for=\"account of user.linkedAccounts\" :key=\"account.provider\"> <td> <i :class=\"`fab fa-fw fa-${account.provider}`\"></i> {{ Utils.capitalize(account.provider) }} </td> <td>{{ account.username }}</td> </tr> </table> </td> </tr> <tr> <th>{{ \"Region\" | t }}</th> <td>{{ user.region }}</td> </tr> <tr class=\"roles\"> <th> {{ t(\"Roles\") }}&nbsp;<b-link @click=\"showUserRoleEditor(user)\" ><i class=\"fa fa-pencil-alt\"></i ></b-link> </th> <td> <span v-for=\"role in user.roles\" :key=\"role\" class=\"role\"> {{ t(`USER_ROLES.${role}`) }} <b-link @click=\"confirmUserRoleRemoval(user, role)\"> <i class=\"fa fa-trash-alt text-danger\"></i> </b-link> </span> </td> </tr> <tr v-if=\"user.licenses.length\"> <th>{{ t(\"Licenses\") }}</th> <td> <ul class=\"licenses\"> <li v-for=\"l of user.licenses\" :key=\"l.license\"> {{ beautifyLicense(l.license) }} <span class=\"details\"> <i v-if=\"l.demo\" v-b-tooltip class=\"fa fa-fw fa-clock text-info\" :title=\"t('Demo license')\"></i> <i v-if=\"!l.valid\" v-b-tooltip class=\"fa fa-fw fa-times-circle text-danger\" :title=\"t('Invalid license')\" ></i> </span> <b-button v-if=\"!isLicenseCensored(l.license)\" variant=\"outline-danger\" size=\"sm\" class=\"license-removal\" @click=\"confirmLicenseRemoval(user, l.license)\" ><i class=\"fa fa-fw fa-trash-alt\"></i ></b-button> </li> </ul> </td> </tr> <tr v-if=\"user.billing\"> <th>{{ t(\"Billing\") }}</th> <td> <span v-if=\"user.billing === 'stripe'\" ><i v-b-tooltip class=\"fab fa-stripe-s\" title=\"Stripe\"></i> Stripe</span > <span v-else-if=\"user.billing === 'braintree'\" ><i v-b-tooltip class=\"fab fa-paypal\" title=\"Paypal\"></i> Braintree</span > <span v-else>{{ user.billing }}</span> </td> </tr> <tr v-if=\"user.subscriptions.length > 0\"> <th>{{ t(\"Subscriptions\") }}</th> <td class=\"w-100\"> <b-table :items=\"user.subscriptions\"> <template #cell(active)=\"{ value }\"> <i :class=\"`fa ${value ? 'fa-check text-success' : 'fa-times text-danger'}`\"></i> </template> <template #cell(expiration)=\"{ value }\"> {{ Utils.localizeDate(value, true) }} </template> </b-table> </td> </tr> <tr> <th>{{ t(\"Logs\") }}</th> <td> <b-link @click=\"displayLogs(user, 'debug')\">{{ t(\"Debug\") }}</b-link >, <b-link @click=\"displayLogs(user, 'error')\">{{ t(\"Error\") }}</b-link> </td> </tr> <tr> <th>{{ t(\"Games\") }}</th> <td class=\"w-100\"><admin-user-games :user-id=\"user.id\"></admin-user-games></td> </tr> <!-- <tr v-if=\"user.subscriptions.length\" class=\"subscriptions\"> <th>{{ t('Subscriptions') }}</th> <td>{{ user.subscriptions }}</td> </tr> --> </table> </div> </div> <admin-user-role-editor ref=\"roleEditor\" v-model=\"userRoleEdit.showEditor\" :title=\"`Editing roles for “${userRoleEdit.user.email}”`\" :roles=\"userRoleEdit.user.roles || []\" @update=\"updateUserRoles\" ></admin-user-role-editor> <confirm-message v-model=\"userRoleRemoval.showConfirm\" :title=\"t('User role removal')\" variant=\"danger\" @ok=\"quickUserRoleRemoval\" > <i18n :path=\"t('Remove role “{0}” from user “{1}”?')\" tag=\"p\"> <b>{{ userRoleRemoval.role }}</b> <b>{{ userRoleRemoval.user.email }}</b> </i18n> </confirm-message> <confirm-message v-model=\"userRemoval.showConfirm\" :title=\"t('User removal')\" variant=\"danger\" @ok=\"deleteUser\"> <i18n :path=\"t('Remove user “{0}”?')\" tag=\"p\"> <b>{{ userRemoval.user.email }}</b> </i18n> <p>{{ t(\"This action is not reversible!\") }}</p> </confirm-message> <confirm-message v-model=\"licenseRemoval.showConfirm\" :title=\"t('License removal')\" variant=\"danger\" @ok=\"deleteLicense\" > <i18n :path=\"t('Remove license {0} for user “{1}”?')\" tag=\"p\"> <code>{{ licenseRemoval.license }}</code> <b>{{ licenseRemoval.user.email }}</b> </i18n> <p>{{ t(\"This action is not reversible!\") }}</p> </confirm-message> <confirm-message v-model=\"userOTPRemoval.showConfirm\" :title=\"t('2FA removal')\" variant=\"danger\" @ok=\"deleteOTP\"> <i18n :path=\"t('Remove 2FA for “{0}”?')\" tag=\"p\"> <b>{{ userOTPRemoval.user.email }}</b> </i18n> <b-spinner v-if=\"userOTPRemoval.loading\"> </b-spinner> <p>{{ t(\"This action is not reversible!\") }}</p> </confirm-message> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".admin-users .user { display: grid; grid-template-columns: 1fr 5fr; margin-top: 3rem; } .admin-users .user + .user { margin-top: 2rem; padding-top: 2rem; border-top: dashed 3px rgba(0, 0, 0, 0.25); } .admin-users .user p { margin-bottom: 0; } .admin-users .user .avatar img { width: 100%; padding-right: 2rem; } .admin-users .user h3 { margin-bottom: 0; } .admin-users .user .glance { font-weight: bold; font-size: 0.9em; opacity: 0.66; margin-bottom: 0.6em; } .admin-users .user .glance i { margin-left: 0.25rem; } .admin-users .user .linkedAccounts { margin: 0; padding: 0; } .admin-users .user .linkedAccounts td + td { padding-left: 1rem; font-family: \"PT Mono\"; } .admin-users .user .role { padding: 0.2em 0.4em; background: rgba(0, 0, 0, 0.1); border: solid 1px rgba(0, 0, 0, 0.25); border-radius: 5px; } .admin-users .user .role + .role { margin: 0.4em 0 0 0.4em; } .admin-users .user .roles .fa { padding-left: 0.2em; } .admin-users .licenses { margin: 0; padding: 0; list-style-type: none; letter-spacing: 0.2em; } .admin-users .licenses .license-removal { display: inline-flex; margin-top: -0.25rem; } .admin-users .licenses li > .details { letter-spacing: -0.2em; } .admin-users .user > .details h3 > button.user-impersonate { font-size: 0.7em; } .admin-users .user > .details h3 > button.user-delete { margin-left: 0.5rem; } .admin-users .user > .details h3 > button > i { display: flex; align-items: center; justify-content: center; } .admin-users .user > .details th, .admin-users .user > .details td { vertical-align: top; padding: 0.25em 0; } .admin-users .user > .details th { padding-right: 1rem; min-width: 5.5em; }"
    });
  },
  props: {
    params: String
  },
  data() {
    return {
      MINI_ICONS: [{
        icon: "envelope",
        check: user => user.emailVerified,
        enabled: t("Verified e-Mail"),
        disabled: t("Unverified e-Mail")
      }, {
        icon: "key",
        check: user => user.password,
        enabled: t("Can login with e-Mail & password"),
        disabled: t("Login with SSO only")
      }, {
        icon: "gamepad",
        check: user => user.gamesManager,
        enabled: t("Game Manager enabled"),
        disabled: t("Game Manager disabled")
      }],
      users: null,
      showLogs: {
        user: null,
        type: null,
        title: null,
        visible: false
      },
      userSearchString: this.params || null,
      userRoleRemoval: {
        showConfirm: false,
        user: {
          profile: {}
        },
        role: null
      },
      userRoleEdit: {
        showEditor: false,
        user: {
          profile: {},
          roles: []
        }
      },
      userRemoval: {
        showConfirm: false,
        user: {
          profile: {}
        }
      },
      licenseRemoval: {
        showConfirm: false,
        license: null,
        user: {
          profile: {}
        }
      },
      userOTPRemoval: {
        showConfirm: false,
        user: {},
        loading: false
      },
      editingEmailUserIdx: null
    };
  },
  methods: {
    isLicenseCensored(license) {
      return license.includes("*");
    },
    beautifyLicense(license) {
      return license.replaceAll("*", "⬤").replaceAll("-", "–");
    },
    updateUserEmailProp(userIndex, newEmail) {
      this.users[userIndex].email = newEmail;
      this.users[userIndex].emailVerified = false;
    },
    updateUserSet(userIndex) {
      this.editingEmailUserIdx = userIndex;
    },
    updateUserUnset() {
      this.editingEmailUserIdx = null;
    },
    async findUsers(ev) {
      const value = ev.target[0].value.trim();
      if (!value) {
        return;
      }
      const response = await Utils.apiAdmin("administration/users/search", {
        query: value
      });
      if (response.error) {
        UI.alert("danger", t("Error finding users: {{- error}}", {
          error: response.error
        }), true, 10000);
        return;
      }
      if (response.success) {
        // Convert `linkedAccounts` into a filtered array sorted by provider name for easier logic
        const users = response.users.map(user => {
          const linkedAccounts = Object.entries(user.linkedAccounts).reduce((accounts, [provider, data]) => {
            if (data.linked) {
              accounts.push({
                provider,
                ...data
              });
            }
            return accounts;
          }, []).sort((a, b) => a.provider.localeCompare(b.provider));
          return {
            ...user,
            linkedAccounts
          };
        });
        this.users = users;
      }
    },
    async displayLogs(user, type) {
      this.showLogs = {
        user,
        type,
        title: `${user.id}’s ${type} logs`,
        visible: true
      };
    },
    async confirmUserRoleRemoval(user, role) {
      this.userRoleRemoval.user = user;
      this.userRoleRemoval.role = role;
      this.userRoleRemoval.showConfirm = true;
    },
    async quickUserRoleRemoval() {
      const user = this.userRoleRemoval.user;
      const userId = user.id;
      const role = this.userRoleRemoval.role;
      const response = await Utils.apiAdmin(`administration/user/role/${userId}`, {
        role
      }, {
        method: "DELETE"
      });
      if (response.error) {
        UI.alert("danger", t("Error removing role “{{role}}” for user “{{email}}”: {{error}}", {
          role,
          email: user.email,
          error: response.error
        }), true, 10000);
        return;
      }
      user.roles = user.roles.filter(r => r !== role);
      UI.alert("success", t("Removed the role “{{role}}” for user “{{email}}”", {
        role,
        email: user.email
      }), true, 3000);
    },
    async showUserRoleEditor(user) {
      this.userRoleEdit.user = user;
      this.userRoleEdit.showEditor = true;
    },
    async updateUserRoles(roles) {
      const response = await Utils.apiAdmin(`administration/user/roles/${this.userRoleEdit.user.id}`, {
        roles
      }, {
        method: "PUT"
      });
      if (response.error) {
        this.$refs.roleEditor.displayError(response.error);
        return;
      }
      this.userRoleEdit.user.roles = roles;
      this.userRoleEdit.showEditor = false;
    },
    async confirmUserRemoval(user) {
      this.userRemoval.user = user;
      this.userRemoval.showConfirm = true;
    },
    async confirmLicenseRemoval(user, license) {
      this.licenseRemoval.user = user;
      this.licenseRemoval.license = license;
      this.licenseRemoval.showConfirm = true;
    },
    confirmOTPRemoval(user) {
      this.userOTPRemoval.user = user;
      this.userOTPRemoval.showConfirm = true;
    },
    async sendNotificationToUser(user) {
      window.location.hash = `#${Utils.buildHash({
        tab: "users",
        action: "new-notification",
        userId: user.id
      })}`;
    },
    async deleteUser() {
      const userId = this.userRemoval.user.id;
      const email = this.userRemoval.user.email;
      const response = await Utils.apiAdmin(`administration/user/${userId}`, {}, {
        method: "DELETE"
      });
      if (response.error) {
        UI.alert("danger", t("Error removing user “{{email}}”: {{error}}", {
          email,
          error: response.error
        }), true, 10000);
        return;
      }
      this.users = this.users.reduce((p, c) => c.id === userId ? p : [...p, c], []);
      UI.alert("success", t("Removed the user “{{email}}”", {
        email
      }), true, 3000);
    },
    async impersonateUser(user) {
      const response = await Utils.api(`administration/user/impersonate/${user.id}`, {});
      if (response.error) {
        UI.alert("danger", `Error impersonating “${user.username}”: ${response.error}`, true, 10000);
        return;
      }
      window.location = "/"; // Redirect out of the admin area
    },

    async deleteLicense() {
      const userId = this.licenseRemoval.user.id;
      const email = this.licenseRemoval.user.email;
      const license = this.licenseRemoval.license;
      const response = await Utils.apiAdmin(`administration/user/license/${userId}`, {
        license
      }, {
        method: "DELETE"
      });
      if (response.error) {
        UI.alert("danger", t("Error removing {{- license}} for user “{{email}}”: {{error}}", {
          license: `<code>${license}</code>`,
          email,
          error: response.error
        }), true, 10000);
        return null;
      }
      this.licenseRemoval.user.licenses = this.licenseRemoval.user.licenses.filter(l => l.license !== license);
      UI.alert("success", t("Removed the license {{- license}} for user “{{email}}”", {
        license: `<code>${license}</code>`,
        email
      }), true, 3000);
      return null;
    },
    async deleteOTP() {
      this.userOTPRemoval.loading = true;
      const response = await Utils.apiAdmin(`administration/user/otp/${this.userOTPRemoval.user.id}`, {}, {
        method: "DELETE"
      });
      this.userOTPRemoval.loading = false;
      if (response.error) {
        this.userOTPRemoval.showConfirm = false;
        UI.alert("danger", response.error, true, 10000);
        return;
      }
      this.users.find(user => user.id === this.userOTPRemoval.user.id).otp = false;
      this.userOTPRemoval.showConfirm = false;
      UI.alert("success", t("2FA disabled successfully"));
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ExplorerModeButton"] = Vue.component(
                    "ExplorerModeButton",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"text-center mt-2\"> <a href=\"#\" class=\"btn btn-success\" @click.prevent=\"showDialog = true\">{{ t(\"Try Foundry now!\") }}</a> <b-modal :visible=\"showDialog\" centered size=\"lg\" :title=\"t('Enable Explorer Mode')\" @hidden=\"showDialog = false\" @shown=\"dialogShown\" > <p> {{ t( \"Foundry VTT is a software application that requires the purchase of a license key in order to download and try it. With the Forge however, you can try Foundry online using a demo license key that is valid for one hour only.\" ) }} </p> <i18n :path=\" t( `By enabling the Forge's {0} you will receive a {1}, which will let you explore Foundry VTT and all of its features.` ) \" tag=\"p\" > <em>{{ t(\"Explorer Mode\") }} <tier-badge-icon tier=\"1\"></tier-badge-icon></em> <strong>{{ t(\"time limited Foundry license key valid for 1 hour\") }}</strong> </i18n> <i18n :path=\" t( `{0} {1} features will also be enabled for you to try them out, and World Import and Data Export capabilities will be disabled during that time.` ) \" tag=\"p\" > <strong>{{ t(\"The Forge's Game Management\") }}</strong> <help-icon url=\"https://forums.forge-vtt.com/t/the-game-manager/11004\" :tooltip=\"t('Learn more about the Game Manager')\" ></help-icon> </i18n> <p> {{ t( \"After the license has expired, your games will be forcibly shut down, and all their data permanently deleted. Your Assets Library will remain untouched.\" ) }} </p> <p>{{ t(\"You will be able to re-enable Explorer Mode an hour after the license has expired.\") }}</p> <i18n :path=\" t( 'Note: After you purchase your own Foundry License and add it to your account, you will be able to try The Forge services with a {0}.' ) \" tag=\"p\" > <strong>{{ t(\"14-day free trial\") }}</strong> </i18n> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" :disabled=\"processing\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button v-if=\"processing\" variant=\"secondary\" :disabled=\"true\"> <loading-indicator tag=\"span\" small> </loading-indicator> </b-button> <b-button v-else variant=\"success\" @click=\"enableExplorer\">{{ t(\"Enable Explorer Mode\") }}</b-button> </template> </b-modal> </div>",
  data() {
    return {
      showDialog: false,
      processing: false
    };
  },
  methods: {
    dialogShown() {},
    async enableExplorer() {
      this.processing = true;
      const response = await Utils.api("profile/demo", {
        enable: true
      });
      if (response.error) {
        UI.alert("danger", t("Error enabling Explorer Mode: {{- error}}", {
          error: response.error
        }), true, 10000);
      } else {
        const modal = UI.createModal(t("Welcome to the fun!"), `<p>${t("You are now an Explorer, so go forth and explore!")}</p>
          <p>${t(`If you need help, check out our {{- forumLink}} guide!`, {
          forumLink: `<a href="https://forums.forge-vtt.com/t/getting-started-in-the-forge-not-done/11295" target="_blank">${t("Getting Started")}</a>`
        })}</p>
          `, "", [{
          type: "success",
          label: "Yay!"
        }], {
          static: true,
          modal_classes: "fade",
          dialog_classes: "modal-dialog-centered"
        });
        modal.find(".modal-footer button").click(() => window.location = "/setup");
        modal.modal("show");
      }
      this.processing = false;
      this.showDialog = false;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarCart"] = Vue.component(
                    "BazaarCart",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"t('Purchase Premium Bazaar Content')\" size=\"xl\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <!-- Error --> <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <!-- Busy --> <div v-else-if=\"busy\" class=\"text-center\"> <b-spinner class=\"mx-2\" :label=\"busy\"></b-spinner>{{ busy }}{{ t(\", please wait…\") }} </div> <!-- Cart view --> <div v-else-if=\"step === 'cart'\"> <b-row> <div v-if=\"currentItem\"> <bazaar-package :package=\"currentItem.package\" :user-integrations=\"userIntegrations\" :can-install=\"false\" :can-select=\"false\" :no-footer=\"true\" > </bazaar-package> </div> <b-col> <div v-if=\"currentItem\" class=\"mb-3 p-2 border border-primary\"> Adding <strong ><em>{{ currentItem.package.title }}</em></strong > to the Cart. <div v-if=\"payWhatYouWant\" class=\"my-2\"> {{ t(\"You can pay what you can for this item\") }} <i18n v-if=\"minimumPrice\" :path=\"t('(minimum: $ {{minimum}})', { minimum: minimumPrice.toFixed(2) })\" ></i18n ><i class=\"fas fa-piggy-bank text-success\"></i>! </div> <b-form-group :label=\"payWhatYouWant ? t('Name your price:') : t('Price:')\" label-cols=\"6\"> <b-input-group prepend=\"$\"> <b-form-input v-model=\"currentItem.price\" type=\"number\" placeholder=\"currentItem.package.price\" :disabled=\"!payWhatYouWant\" :formatter=\"priceFormatter\" lazy-formatter ></b-form-input> </b-input-group> <div v-if=\"payWhatYouWant\"> {{ t(\"Suggested price:\") }} <a href=\"#\" @click.prevent=\"currentItem.price = suggestedPrice\" ><strong>$ {{ suggestedPrice.toFixed(2) }}</strong></a > </div> <b-alert variant=\"danger\" :show=\"currentItem.price < minimumPrice\" >{{ t(\"The minimum allowed price is\") }} $ {{ minimumPrice.toFixed(2) }}</b-alert > </b-form-group> <b-form-checkbox v-model=\"currentItem.gift\" v-b-tooltip.hover :title=\"giftTooltip\" :disabled=\"isGiftCard || isInCart || isPurchased\" > <i class=\"fas fa-gift\"></i> {{ t(\"Offer as a gift\") }} </b-form-checkbox> <div class=\"overflow-hidden\"> <transition enter-active-class=\"animate__animated animate__faster animate__slideInDown\" leave-active-class=\"animate__animated animate__faster animate__slideOutUp\" > <div v-show=\"currentItem.gift\"> <b-form-group :label=\"t('Attach a message to your gift:')\" label-cols=\"6\"> <b-form-textarea v-model=\"currentItem.message\" size=\"sm\" rows=\"6\" :placeholder=\"t('Short message (max 250 character)')\" :formatter=\"messageFormatter\" ></b-form-textarea> </b-form-group> <small> {{ t(\"Count:\") }} <span :class=\"messageCountClass\">{{ messageCount }}</span >/250 </small> </div> </transition> </div> </div> <div class=\"m-1\"> <span>{{ t(\"BAZAAR.CartContents\", { count: newCart.length }) }}</span> <b-row v-for=\"(item, index) of newCart\" :key=\"index\"> <b-col cols=\"6\" class=\"text-truncate border rounded\"> {{ item.package.title }} </b-col> <b-col cols=\"4\" class=\"border text-center\"> $ {{ item.price }} </b-col> <b-col cols=\"1\" class=\"border text-center p-0\"> <span v-show=\"item.gift\" v-b-tooltip.hover class=\"text-success\" :title=\"t(`It's a gift!`)\" ><i class=\"fas fa-gift\"></i ></span> </b-col> <b-col cols=\"1\" class=\"border rounded text-center p-0\"> <a v-b-tooltip.hover href=\"#\" class=\"text-danger\" :title=\"t('Remove from cart')\" @click.prevent=\"removeItem(index)\" ><i class=\"fas fa-times\"></i ></a> </b-col> </b-row> </div> </b-col> </b-row> </div> <!-- Billing page --> <div v-else-if=\"step === 'billing'\"> <h5>{{ t(\"Please enter your billing information.\") }}</h5> <billing-information ref=\"billing\" v-model=\"billing\" @complete=\"billingComplete = $event\"></billing-information> </div> <!-- Payment page --> <payment-details v-else-if=\"step === 'payment'\" ref=\"payment\" v-model=\"paymentComplete\" pay-verb=\"Purchase\" :billing=\"billing\" :providers=\"providers\" :current=\"currentProvider\" @current=\"current = $event\" ></payment-details> <!-- Preview page --> <div v-else-if=\"step === 'preview'\"> <payment-invoice :invoice=\"preview.preview\" :exchange-currency=\"currency\" :exchange-rates=\"exchangeRates\"> </payment-invoice> <div> <i18n :path=\"t('All sales are final. Please refer to the {0} for details.')\"> <a href=\"https://forums.forge-vtt.com/t/purchasing-bazaar-content/12464\" target=\"_blank\">{{ t(\"Bazaar EULA\") }}</a> </i18n> </div> <div v-if=\"processing\"> <b-spinner class=\"mx-2\" :label=\"t('Processing order')\"></b-spinner>{{ t(\"Processing order, please wait…\") }} <b-progress :value=\"progressValue\" :max=\"100\" animated></b-progress> <div class=\"text-center\">{{ progressLabel }}</div> </div> </div> <!-- Final result page --> <div v-else> <div class=\"alert alert-success\" role=\"alert\"> <p>{{ t(\"Your purchase is now completed!\") }}</p> <i18n :path=\"t('You can see your purchases and gift cards from your {0} page.')\" tag=\"p\"> <a href=\"/account\" target=\"_blank\">{{ t(\"Account\") }}</a> </i18n> </div> <profile-purchases-table v-if=\"purchases.length > 0\" :label=\"t('Purchased Content')\" :purchases=\"purchases\" ></profile-purchases-table> <div v-if=\"invoiceUrl\"> <i18n :path=\"t('You can access your invoice {0}.')\"> <a :href=\"invoiceUrl\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> </div> </div> <!-- Footer Buttons --> <template #modal-footer=\"{ cancel }\"> <b-button v-if=\"step !== 'final'\" variant=\"secondary\" class=\"float-left\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <!-- Add to cart button --> <template v-if=\"step === 'cart' && currentItem\"> <b-button v-show=\"newCart.length > 0\" variant=\"primary\" class=\"float-right\" :disabled=\"currentItem.price < minimumPrice\" @click=\"addAndClose\" >{{ t(\"Add to cart and continue shopping\") }}</b-button > <b-button v-show=\"newCart.length > 0\" variant=\"success\" class=\"float-right\" :disabled=\"currentItem.price < minimumPrice\" @click=\"checkout\" >{{ t(\"Add to cart and Checkout\") }}</b-button > </template> <!-- Checkout buttons --> <template v-else-if=\"step === 'cart'\"> <b-button v-show=\"newCart.length > 0\" variant=\"danger\" class=\"float-right\" @click=\"emptyCartAndClose\">{{ t(\"Empty cart\") }}</b-button> <b-button v-show=\"newCart.length > 0\" variant=\"primary\" class=\"float-right\" @click=\"addAndClose\">{{ t(\"Save cart\") }}</b-button> <b-button v-show=\"newCart.length > 0\" variant=\"success\" class=\"float-right\" @click=\"checkout\">{{ t(\"Checkout\") }}</b-button> </template> <!-- Payment -> Preview --> <b-button v-else-if=\"step === 'billing' && cartTotal !== 0\" variant=\"success\" class=\"float-right\" :disabled=\"!billingComplete || processing || error !== ''\" @click=\"enterPayment\" >{{ t(\"Enter Payment Details\") }}</b-button > <b-button v-else-if=\"step === 'billing' && cartTotal === 0\" variant=\"success\" class=\"float-right\" :disabled=\"!billingComplete || processing\" @click=\"previewInvoice\" >{{ t(\"Preview Invoice\") }}</b-button > <!-- Payment -> Preview --> <b-button v-else-if=\"step === 'payment'\" variant=\"success\" class=\"float-right\" :disabled=\"!paymentComplete || processing\" @click=\"previewInvoice\" >{{ t(\"Preview Invoice\") }}</b-button > <!-- Preview -> Confirm --> <b-button v-else-if=\"step === 'preview'\" variant=\"success\" class=\"float-right\" :disabled=\"processing\" @click=\"confirmPurchase\" ><i class=\"fas fa-money-bill-wave mr-1\"></i>{{ t(\"Confirm Purchase\") }}</b-button > <!-- Final page (Close) --> <b-button v-else-if=\"step === 'final'\" variant=\"success\" class=\"float-right\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    packages: Array,
    cart: Array,
    addPackage: Object,
    addGift: Boolean,
    userIntegrations: Object
  },
  data() {
    return {
      step: "cart",
      newCart: [],
      currentItem: null,
      preview: null,
      processing: false,
      progressLabel: "",
      progressValue: 0,
      invoiceUrl: null,
      purchases: [],
      providers: {},
      remote_billing: null,
      billing: {},
      error: "",
      busy: null,
      currentProvider: "",
      current: "",
      currency: "USD",
      taxes: [],
      exchangeRates: {},
      paymentComplete: false,
      billingComplete: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    payWhatYouWant() {
      return this.currentItem && this.currentItem.package.pwywMinimum !== undefined;
    },
    minimumPrice() {
      return this.payWhatYouWant ? this.currentItem.package.pwywMinimum : this.currentItem.package.price;
    },
    suggestedPrice() {
      return this.currentItem && this.currentItem.package.price;
    },
    isGiftCard() {
      return this.currentItem && this.currentItem.package.type === "forge-gift-card";
    },
    isInCart() {
      return this.currentItem && !!this.newCart.find(i => i !== this.currentItem && !i.gift && i.name === this.currentItem.name);
    },
    isPurchased() {
      return this.currentItem && this.currentItem.package.purchased;
    },
    giftTooltip() {
      if (this.isGiftCard) {
        return t("Gift cards can only be gifted!");
      }
      if (this.isInCart) {
        return t("Item already in your cart");
      }
      if (this.isPurchased) {
        return t("This content has already been purchased");
      }
      return t("Gifts are a great way to say Thank You!");
    },
    cartTotal() {
      return this.cleanCart.reduce((total, item) => total + item.price, 0);
    },
    cleanCart() {
      return this.newCart.map(i => ({
        name: i.name,
        price: Number(i.price),
        gift: Boolean(i.gift),
        message: (i.message || "").slice(0, 250)
      }));
    },
    messageCount() {
      if (!this.currentItem) {
        return 0;
      }
      return (this.currentItem.message || "").length;
    },
    messageCountClass() {
      if (this.messageCount > 200) {
        return "text-danger";
      }
      if (this.messageCount > 150) {
        return "text-warning";
      }
      return "";
    }
  },
  methods: {
    dialogShown() {
      this.step = "cart";
      this.currentItem = null;
      this.preview = null;
      this.processing = false;
      this.invoiceUrl = null;
      this.progressLabel = "";
      this.progressValue = 0;
      this.error = "";
      this.busy = null;
      this.purchases = [];
      this.newCart = (this.cart || []).map(i => ({
        name: i.name,
        price: this.priceFormatter(i.price),
        gift: i.gift,
        message: (i.message || "").slice(0, 250),
        package: this.packages.find(p => p.name === i.name)
      })).filter(i => !!i.package);
      if (this.addPackage) {
        this.currentItem = {
          name: this.addPackage.name,
          price: this.priceFormatter(this.addPackage.pwywMinimum || this.addPackage.price),
          gift: this.addGift || this.addPackage.type === "forge-gift-card",
          message: "",
          package: this.addPackage
        };
        if (this.isInCart) {
          this.currentItem.gift = true;
        }
        this.newCart.push(this.currentItem);
      }
    },
    priceFormatter(value) {
      return Number(value).toFixed(2);
    },
    removeItem(idx) {
      if (this.newCart[idx] === this.currentItem) {
        this.currentItem = null;
      }
      this.newCart.splice(idx, 1);
    },
    emptyCartAndClose() {
      this.$emit("cart-emptied");
      this.close();
    },
    addAndClose() {
      this.$emit("cart-updated", this.cleanCart);
      this.close();
    },
    close() {
      this.visible = false;
    },
    messageFormatter(value) {
      return value.slice(0, 250);
    },
    async checkout() {
      this.$emit("cart-updated", this.cleanCart);
      this.busy = t("Retrieving your billing information");
      const subscriptionInfo = await Utils.api("subscription");
      if (subscriptionInfo.error) {
        this.error = t(`Error retrieving payment information: {{- error}}`, {
          error: subscriptionInfo.error
        });
        this.busy = null;
        return;
      }
      this.remote_billing = Utils.duplicate(subscriptionInfo.billing);
      this.billing = subscriptionInfo.billing;
      this.step = "billing";
      this.busy = null;
    },
    async enterPayment() {
      try {
        this.processing = true;
        if (!Utils.objectsAreEqual(this.remote_billing, this.billing)) {
          this.busy = t("Saving your billing information");
          const updated = await Utils.api("profile", {
            billing: this.billing
          });
          if (updated.error) {
            throw new Error(t(`Error updating your billing information: {{- error}}`, {
              error: updated.error
            }));
          }
        }
        this.busy = t("Retrieving your payment details");
        const paymentInfo = await Utils.api("subscription/payment");
        if (paymentInfo.error) {
          this.error = t(`Error retrieving payment information: {{- error}}`, {
            error: paymentInfo.error
          });
          this.busy = null;
          return;
        }
        this.providers = paymentInfo.providers;
        this.currentProvider = paymentInfo.current;
        this.currency = paymentInfo.currency;
        this.taxes = paymentInfo.taxes;
        this.exchangeRates = paymentInfo.exchangeRates;
        this.busy = null;
        this.processing = false;
        this.step = "payment";
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
        this.busy = null;
      }
    },
    async previewInvoice() {
      try {
        this.processing = true;
        if (this.$refs.payment) {
          this.processing = await this.$refs.payment.submitPayment();
        }
        if (this.processing) {
          this.preview = await Utils.api("bazaar/purchase", {
            cart: this.cleanCart,
            options: {
              preview: true
            }
          });
          this.error = this.preview.error;
          if (this.preview.success) {
            this.step = "preview";
          }
          this.processing = false;
        }
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
      }
    },
    async confirmPurchase() {
      let interval = 0;
      try {
        this.processing = true;
        this.progressLabel = t("Generating keys…");
        this.progressValue = 1;
        interval = setInterval(() => {
          this.progressValue += 10;
          if (this.progressValue > 10) {
            this.progressLabel = t("Creating invoice…");
          }
          if (this.progressValue > 40) {
            this.progressLabel = t("Processing payment…");
          }
          if (this.progressValue > 90) {
            this.progressLabel = t("Waiting for confirmation…");
          }
        }, 1000);
        const result = await Utils.api("bazaar/purchase", {
          cart: this.cleanCart,
          options: {
            commit: true
          }
        });
        clearInterval(interval);
        this.progressValue = 100;
        if (result.error) {
          this.error = result.error;
        } else {
          this.invoiceUrl = result.url;
          this.purchases = result.purchases || [];
          this.$emit("cart-purchased", this.purchases);
          this.$emit("cart-updated", []);
        }
        this.processing = false;
        this.step = "final";
      } catch (err) {
        clearInterval(interval);
        this.processing = false;
        this.error = err.message || err;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarClaimPurchase"] = Vue.component(
                    "BazaarClaimPurchase",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"claim-gift\"> <div class=\"text-center mb-5\"> <img src=\"/images/bazaar.png\" width=\"128\" /> <h2> {{ t(\"Take your games to the next level!\") }} <help-icon url=\"https://forums.forge-vtt.com/docs?topic=4877\" :tooltip=\"t('What is the Bazaar?')\"></help-icon> </h2> <hr /> </div> <div v-if=\"purchase.claimed\"> <div v-if=\"purchase.owner\"> <h3 class=\"text-center\"> {{ t(\"You have successfully claimed this content.\") }} </h3> <profile-purchases-table :purchases=\"[purchase]\"></profile-purchases-table> </div> <h3 v-else-if=\"purchaser\" class=\"text-center\"> {{ t(\"Your gift has been successfully claimed.\") }} </h3> <h3 v-else class=\"text-center\"> {{ t(\"Sorry, this content has already been claimed!\") }} </h3> </div> <div v-else> <div v-if=\"purchaser\"> <h3 class=\"text-center\">{{ t(\"Your gifted content has not been claimed yet.\") }}</h3> <b-row> <bazaar-package :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"false\" :can-select=\"false\" :no-footer=\"true\" > </bazaar-package> <b-col> <div> <b-form-group :label=\"t('Message attached to your gift:')\" label-cols=\"6\"> <b-form-textarea v-model=\"customMessage\" size=\"sm\" rows=\"6\" :placeholder=\"t('Short message (max 250 character)')\" :formatter=\"messageFormatter\" ></b-form-textarea> <small> Count: <span :class=\"messageCountClass\">{{ messageCount }}</span >/250 </small> <b-button v-show=\"customMessageModified\" size=\"sm\" class=\"float-right m-1\" @click=\"saveMessage\">{{ t(\"Save Changes\") }}</b-button> </b-form-group> </div> <profile-purchases-table :purchases=\"purchaseArray\"></profile-purchases-table> <p>{{ t(\"Share the link below with your friends and have them claim your gift:\") }}</p> <b-form-group class=\"mt-2\"> <b-input-group v-b-tooltip.hover.top title=\"Gift Link\"> <b-form-input id=\"claim-link\" v-b-popover.manual.d200.top=\"t('Gift Link copied to clipboard')\" type=\"text\" :value=\"giftURL\" readonly @click=\"copyClaimLink\" > </b-form-input> <b-input-group-append> <b-input-group-text v-b-tooltip.hover.top :title=\"t('Copy Link to clipboard')\" @click=\"copyClaimLink\" ><i class=\"far fa-copy\"></i ></b-input-group-text> </b-input-group-append> </b-input-group> </b-form-group> <i18n :path=\" t( 'If you have changed your mind and would like to cancel the gift and claim it for yourself instead, {0}.' ) \" tag=\"p\" > <a href=\"#\" @click.prevent=\"claimForSelf\">{{ t(\"click here\") }}</a> </i18n> </b-col> </b-row> </div> <div v-else> <b-row> <bazaar-package :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"false\" :can-select=\"false\" :no-footer=\"true\" > </bazaar-package> <b-col class=\"text-center\"> <h3>{{ t(\"Someone has sent you a gift!\") }}</h3> <div> <blockquote v-show=\"purchase.message\" class=\"text-left m-3 p-3 bg-light text-dark border-left border-secondary\" > <p v-for=\"(line, index) of messageLines\" :key=\"index\">{{ line }}</p> </blockquote> </div> <profile-purchases-table :purchases=\"purchaseArray\"></profile-purchases-table> <div> <b-button size=\"lg\" variant=\"success\" :disabled=\"!!alreadyClaimed || !!claiming\" @click=\"claim\"> <i class=\"fas fa-gift\"></i> {{ t(\"Claim your Gift!\") }} </b-button> </div> </b-col> </b-row> </div> </div> </div>",
  props: {
    purchaser: Boolean,
    purchase: Object,
    package: Object
  },
  data() {
    return {
      customMessage: "",
      hackDetectChange: true,
      popover_show_timeout: 0,
      popover_hide_timeout: 0,
      userIntegrations: null,
      alreadyClaimed: false,
      claiming: false
    };
  },
  computed: {
    pkg() {
      return this.package;
    },
    giftURL() {
      return window.location.href;
    },
    messageCount() {
      return (this.customMessage || "").length;
    },
    messageCountClass() {
      if (this.messageCount > 200) {
        return "text-danger";
      }
      if (this.messageCount > 150) {
        return "text-warning";
      }
      return "";
    },
    messageLines() {
      return this.purchase.message.split("\n");
    },
    purchaseArray() {
      const array = [{
        ...this.purchase
      }];
      // Remove the gift column if we're not the purchaser
      if (!this.purchaser) {
        array[0].gift = undefined;
      }
      return array;
    },
    customMessageModified() {
      // Basically a NOOP but Vue will recompute this value if hackDetectChange is modified
      if (this.hackDetectChange && !this.hackDetectChange) {
        return;
      }
      return this.customMessage !== this.purchase.message;
    }
  },
  methods: {
    async claim() {
      this.claiming = true;
      const response = await Utils.api("bazaar/gift", {
        code: this.purchase.gift,
        claim: true
      });
      this.claiming = false;
      if (response.success) {
        this.alreadyClaimed = true;
        UI.alert("success", t(`Content successfully claimed`));
      } else {
        UI.alert("danger", t(`Error claiming gifted content: {{- error}}`, {
          error: response.error || t("Unknown Error")
        }));
      }
    },
    async claimForSelf() {
      const result = await UI.query(t(`Claim this content for yourself`), `${t(`Are you sure you want to <strong>cancel the gift</strong> and claim this content for your own account.`)}<br/> ${t(`This operation cannot be reverted.`)}`, {
        buttons: [{
          id: "claim-no",
          type: "success",
          label: t("No"),
          response: "no"
        }, {
          id: "claim-yes",
          type: "danger",
          label: t(`Yes, Claim it`),
          response: "yes"
        }]
      });
      if (result === "yes") {
        this.claim();
      }
    },
    dismissPopovers() {
      this.$root.$emit("bv::hide::popover");
    },
    copyClaimLink() {
      Utils.copyToClipboard(this.giftURL);
      this.dismissPopovers();
      clearTimeout(this.popover_show_timeout);
      clearTimeout(this.popover_hide_timeout);
      this.popover_show_timeout = setTimeout(() => this.$root.$emit("bv::show::popover", `claim-link`), 300);
      this.popover_hide_timeout = setTimeout(() => this.$root.$emit("bv::hide::popover", `claim-link`), 3000);
    },
    messageFormatter(value) {
      return value.slice(0, 250);
    },
    async saveMessage() {
      const result = await Utils.api("bazaar/gift", {
        code: this.purchase.gift,
        message: this.customMessage
      });
      if (result.success) {
        this.purchase.message = this.customMessage;
        // Hack to force the detection of modified purchase.message property content to recompute variables
        this.hackDetectChange = !this.hackDetectChange;
      }
    },
    async loadIntegrations() {
      const response = await Utils.api("profile/integrations");
      if (response.success) {
        this.userIntegrations = response;
      } else if (response.error && response.code !== 401) {
        UI.alert("danger", t("Error retrieving account information: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      }
    }
  },
  async created() {
    this.alreadyClaimed = this.purchase.claimed;
    this.customMessage = this.purchase.message;
    await this.loadIntegrations();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarCompatibility"] = Vue.component(
                    "BazaarCompatibility",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-alert v-if=\"canRender\" show :variant=\"alertClass\" class=\"bazaar-compatibility\"> <i v-if=\"icon\" :class=\"icon\"></i> <i18n :path=\"t(text, { coreVersion: coreVersion, packageVersion: packageVersion })\"></i18n> </b-alert>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-compatibility{display:flex;justify-content:center;align-items:baseline;gap:.5em;text-align:left}"
    });
  },
  props: {
    status: {
      type: Number || undefined,
      default: undefined
    },
    packageVersion: {
      type: String,
      default: ""
    },
    coreVersion: {
      type: String,
      default: ""
    }
  },
  computed: {
    canRender() {
      return Object.values(Enums.PackageVersionCompatibilityStatus).includes(this.status);
    },
    isUnverified() {
      return this.status === Enums.PackageVersionCompatibilityStatus.RISKY;
    },
    isIncompatible() {
      return this.status === Enums.PackageVersionCompatibilityStatus.INCOMPATIBLE;
    },
    isVerified() {
      return this.status === Enums.PackageVersionCompatibilityStatus.COMPATIBLE;
    },
    /**
     * Depending on the compat status of the package in question, change the alert's styling.
     * @returns {string} A value for `<b-alert />`'s `variant` prop,representing the package's compatibility with the user's installed core version.
     */
    alertClass() {
      if (this.isUnverified) {
        return "warning";
      }
      if (this.isIncompatible) {
        return "danger";
      }
      if (this.isVerified) {
        return "success";
      }
      return null;
    },
    /**
     * Depending on provided compatibility information, report package compatibility to the user.
     * @returns {string} Translation-friendly messaging around this package's compatibility with the indicated version of Foundry
     */
    text() {
      if (this.isIncompatible) {
        return t("Version {{packageVersion}} of this package is incompatible with Foundry {{coreVersion}}.");
      }
      if (this.isUnverified) {
        return t("Version {{packageVersion}} of this package is not verified with Foundry {{coreVersion}}.");
      }
      if (this.isVerified) {
        return t("Version {{packageVersion}} of this package is verified as compatible with your Foundry version.");
      }
      return null;
    },
    /**
     * Depending on the compat status of the package in question, change the badge's icon.
     * @returns {string} A FontAwesome icon class related to the package's compatibility with the user's installed core version.
     */
    icon() {
      if (this.isUnverified) {
        return "fas fa-exclamation-triangle";
      }
      if (this.isIncompatible) {
        return "fas fa-window-close";
      }
      if (this.isVerified) {
        return "fas fa-check-square";
      }
      return null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarCompatibilityBadge"] = Vue.component(
                    "BazaarCompatibilityBadge",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Displays a compatibility badge for FoundryVTT modules, indicating
 * whether they're verified, unverified, or incompatible with the user's environment.
 */
var _default = exports.default = {
  template: "<div v-if=\"canRender\" ref=\"badge\" class=\"badge bazaar-compatibility-badge\" :class=\"badgeClass\"> <i v-if=\"icon\" class=\"bazaar-compatibility-badge__icon fas\" :class=\"icon\"></i> <span class=\"bazaar-compatibility-badge__label\">{{ t(text) }}</span> <b-tooltip v-if=\"canDisplayCompatibleVersions\" :target=\"() => $refs.badge\" noninteractive> <bazaar-package-compatible-versions :minimum=\"minimum\" :maximum=\"maximum\" :verified=\"verified\" ></bazaar-package-compatible-versions> </b-tooltip> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-compatibility-badge{interpolate-size:allow-keywords}"
    });
  },
  props: {
    /** Minimum compatible version */
    minimum: {
      type: String || undefined,
      default: undefined
    },
    /** Maximum compatible version */
    maximum: {
      type: String || undefined,
      default: undefined
    },
    /**Verified compatible version */
    verified: {
      type: String || undefined,
      default: undefined
    },
    /** Compatibility status code (-1: Risky, 0: Incompatible, 1: Compatible, undefined: Unknown) */
    status: {
      type: Number || undefined,
      default: undefined
    },
    /** Current core version of FoundryVTT */
    coreVersion: {
      type: String,
      default: ""
    }
  },
  computed: {
    /**
     * Whether version compatibility details can be shown
     * @returns {boolean} - Can we display compatibility details?
     */
    canDisplayCompatibleVersions() {
      return this.minimum || this.maximum || this.verified;
    },
    /**
     * Whether the badge should be displayed
     * @returns {boolean} - Can we render this component?
     */
    canRender() {
      return Object.values(Enums.PackageVersionCompatibilityStatus).includes(this.status) && this.status !== Enums.PackageVersionCompatibilityStatus.UNKNOWN;
    },
    /**
     * Whether the module has risky compatibility
     * @returns {boolean} - Is this package risky?
     */
    isUnverified() {
      return this.status === Enums.PackageVersionCompatibilityStatus.RISKY;
    },
    /**
     * Whether the module is incompatible
     * @returns {boolean} - Is this package incompatible?
     */
    isIncompatible() {
      return this.status === Enums.PackageVersionCompatibilityStatus.INCOMPATIBLE;
    },
    /**
     * Whether the module is verified compatible
     * @returns {boolean} - Is this package verified as compatible?
     */
    isVerified() {
      return this.status === Enums.PackageVersionCompatibilityStatus.COMPATIBLE;
    },
    /**
     * Depending on the compat status of the package in question, change the badge's styling.
     * @returns {string} A CSS class representing the package's compatibility with the user's installed core version.
     */
    badgeClass() {
      if (this.isUnverified) {
        return "bazaar-compatibility-badge--compatibility-risk";
      }
      if (this.isIncompatible) {
        return "bazaar-compatibility-badge--incompatible";
      }
      if (this.isVerified) {
        return "bazaar-compatibility-badge--compatible";
      }
      return null;
    },
    /**
     * Depending on the compat status of the package in question, change the badge's messaging.
     * @returns {string} A translation key representing the package's compatibility with the user's installed core version.
     */
    text() {
      if (this.isIncompatible) {
        return t("Incompatible");
      }
      if (this.isUnverified) {
        return t("Unverified");
      }
      if (this.isVerified) {
        return t("Verified");
      }
      return "";
    },
    /**
     * Depending on the compat status of the package in question, change the badge's icon.
     * @returns {string} A FontAwesome icon class related to the package's compatibility with the user's installed core version.
     */
    icon() {
      if (this.isUnverified) {
        return "fa-exclamation-triangle";
      }
      if (this.isIncompatible) {
        return "fa-window-close";
      }
      if (this.isVerified) {
        return "fa-check-square";
      }
      return null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarCreatorProfile"] = Vue.component(
                    "BazaarCreatorProfile",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<main-page showsides> <template #header> <b-img v-if=\"!!banner\" :src=\"banner\" rounded class=\"creator-banner\" @error=\"errorBanner = true\"></b-img> </template> <b-card class=\"creator-body\" no-body> <b-card-body class=\"p-0\"> <b-row class=\"my-3 mx-1\"> <b-col md=\"auto\"> <b-img v-if=\"avatar\" rounded v-bind=\"avatarImageData\" :src=\"avatar\" @error=\"errorAvatar = true\"></b-img> </b-col> <b-col> <b-row class=\"creator-name font-weight-bold\"> {{ creator.name }} </b-row> <b-row md=\"auto\" class=\"d-flex flex-row\"> <div v-if=\"false\"> <b-button @click=\"followCreator\"> <span v-if=\"isFollowing\"> <i class=\"fas fa-check\"></i> {{ t(\"Following\") }} </span> <span v-else> {{ t(\"Follow\") }} </span> </b-button> </div> <div class=\"social-links ml-2\"> <span v-for=\"(item, index) in socialLinks\" :key=\"index\" :title=\"item.name\" class=\"mr-1\"> <a :href=\"item.link\"> <img :src=\"`/images/social/${item.icon}`\" width=\"30\" height=\"30\" /> </a> </span> </div> </b-row> </b-col> </b-row> <b-row> <b-col> <b-tabs v-if=\"!noData\" v-model=\"tabIndex\" card pills :content-class=\"showPackages ? 'showing-packages' : ''\" active-nav-item-class=\"font-weight-bold\" nav-wrapper-class=\"border border-left-0 border-right-0\" nav-class=\"mx-0\" > <b-tab v-for=\"tab in tabs\" :key=\"tab.id\" :title=\"tab.label\" @click=\"changeTab(tab.id)\"> <b-card-text v-if=\"tab.id === 'about'\"> <span v-html=\"sanitized_description\"></span> </b-card-text> </b-tab> <template #tabs-end> <li v-if=\"showSearch\" role=\"presentation\" class=\"nav-item align-self-end search-item\"> <search-field v-model=\"filterTags\" class=\"ml-2\" :packages=\"packages\" :placeholder=\"t('Filter content...')\" visibility-key=\"creatorSearch\" :show-example=\"false\" :search-tags=\"searchTags\" ></search-field> </li> </template> </b-tabs> <template v-if=\"showPackages\"> <b-alert v-if=\"reloadingInstalls\" show class=\"notification-alert\"> <loading-indicator small :label=\"t('Verifying your content')\"></loading-indicator> </b-alert> <b-card-text class=\"p-2\"> <package-list :packages=\"filteredPackages\" :can-install=\"installsLoaded\" :can-select=\"true\" :user-integrations=\"userIntegrations\" :minimum-packages=\"5\" @selected=\"selectPackage\" @tag=\"addTag\" @install=\"installPackage\" @uninstall=\"uninstallPackage\" @check-update=\"checkUpdate\" @purchase=\"purchasePackage\" @ddb-installed=\"DDBPackageInstalled\" ></package-list> </b-card-text> </template> <b-alert v-if=\"noData\" show variant=\"warning\" class=\"notification-alert text-center\"> {{ t(\"This Creator currently has no information to display\") }} </b-alert> </b-col> </b-row> </b-card-body> </b-card> <bazaar-full-package-modal v-model=\"showFullPackage\" :package=\"currentPackage\" :can-install=\"installsLoaded\" :core-version=\"coreVersion\" :user-integrations=\"userIntegrations\" :show-creator-link=\"false\" @close=\"displayPackage(null)\" @install=\"installPackage\" @uninstall=\"uninstallPackage\" @check-update=\"checkUpdate\" @toggle-lock=\"togglePackageLock\" @purchase=\"purchasePackage\" @purchase-gift=\"purchaseGiftPackage\" @ddb-installed=\"DDBPackageInstalled\" @add-tag=\"addPackageTag\" > </bazaar-full-package-modal> </main-page>",
  beforeCreate() {
    Utils.loadCss({
      content: ".creator-banner { width: 100%; height: auto; max-height: 25vw; /* 25% of the viewport width, with 100% width ensures a fixed aspect ratio of 4/1 */ object-fit: cover; object-position: top center; } .creator-body { min-height: 100%; } .creator-body .creator-name { font-size: 24pt; } .creator-body .creator-avatar { object-fit: contain; } .creator-body .social-links { font-size: 22px; } .creator-body .search-item { flex-grow: 1; } .tab-content.showing-packages .tab-pane { padding: 0px; }"
    });
  },
  extends: VueComponents["PackageHelper"],
  props: {
    initialData: Array,
    creator: Object,
    coreVersion: String
  },
  data() {
    return {
      loaded: false,
      installsLoaded: false,
      reloadingInstalls: false,
      showFullPackage: false,
      currentPackage: null,
      errorBanner: false,
      errorAvatar: false,
      hash: null,
      filterTags: {},
      packages: [],
      tabIndex: 0,
      following: false,
      searchUtil: new Search(),
      socialLinksTemplate: {
        website: {
          name: "Website",
          icon: "website-icon.png",
          link: url => {
            if (url.startsWith("http")) {
              return url;
            }
            return `https://${url}`;
          }
        },
        twitter: {
          name: "Twitter",
          icon: "twitter.png",
          link: "https://twitter.com/{0}"
        },
        facebook: {
          name: "Facebook",
          icon: "facebook.png",
          link: "https://facebook.com/{0}"
        },
        patreon: {
          name: "Patreon",
          icon: "patreon.png",
          link: "https://patreon.com/{0}"
        },
        discord: {
          name: "Discord",
          icon: "discord.png",
          link: "https://discord.gg/{0}"
        }
      },
      tabList: [{
        id: "all",
        label: t("All"),
        filterTag: {},
        searchField: true
      }, {
        id: "sale",
        label: t("On Sale"),
        filterTag: {
          price: ["on-sale"]
        },
        searchField: true
      }, {
        id: "assets",
        label: t("Asset Packs"),
        filterTag: {
          forge: ["asset"]
        },
        searchField: true
      }, {
        id: "worlds",
        label: t("Worlds"),
        filterTag: {
          foundry: ["world"]
        },
        searchField: true
      }, {
        id: "systems",
        label: t("Systems"),
        filterTag: {
          foundry: ["system"]
        },
        searchField: true
      }, {
        id: "modules",
        label: t("Modules"),
        filterTag: {
          foundry: ["module"]
        },
        searchField: true
      }, {
        id: "about",
        label: t("About"),
        canShow: () => !!this.creator.description,
        searchField: false
      }],
      avatarImageData: {
        blankColor: "#fff",
        width: 100,
        height: 100,
        class: "creator-avatar"
      },
      installedModules: [],
      installedSystems: [],
      installedAssets: [],
      entitlements: [],
      userIntegrations: null
    };
  },
  watch: {
    hash() {
      this.updateTabFromHash();
    },
    filterTags: {
      handler(newValue, oldValue) {
        let hash = Utils.hashProps(window.location.hash);
        const tab = hash.tab;
        hash = {};
        for (let [k, v] of Object.entries(this.filterTags)) {
          hash[k] = v instanceof Array ? v.join(",") : v;
        }
        this.hash = window.location.hash = `#${Utils.buildHash(hash, {
          tab
        })}`;
      },
      deep: true
    },
    entitlements() {
      for (let entitlement of this.entitlements) {
        const pkg = this.packages.find(p => p.type === entitlement.type && p.name === entitlement.name);
        if (pkg) {
          pkg.entitled = true;
          pkg.purchased = entitlement.entitlement === "purchase";
          pkg.entitlement = entitlement.entitlement;
        }
      }
    },
    async currentPackage() {
      // Save it in case it changes during the await
      const currentPackage = this.currentPackage;
      if (currentPackage && !currentPackage.fullyLoaded && !currentPackage.loading) {
        currentPackage.loading = true;
        Utils.api(`bazaar/package/${currentPackage.name}?full=1&manifest=1${this.coreVersion ? `&coreVersion=${this.coreVersion}` : ""}`).then(resp => {
          if (resp.success) {
            for (const key in resp.package) {
              // Need to use $set so that it is reactive to the new fields being added
              this.$set(currentPackage, key, resp.package[key]);
            }
            this.$set(currentPackage, "manifest", resp.manifest);
          }
          currentPackage.fullyLoaded = true;
          currentPackage.loading = false;
          this.showFullPackage = true;
        });
      }
      this.showFullPackage = !!currentPackage && currentPackage.loading === false;
    }
  },
  computed: {
    sanitized_description() {
      return DOMPurify.sanitize(this.creator.description);
    },
    tabs() {
      // If the tab has a function to determine if the tab can be shown, use that.
      // Otherwise, check to see if any packages match the tabs packageFilter
      return this.tabList.filter(t => {
        if (t.canShow) {
          return t.canShow(t);
        }
        if (t.filterTag) {
          return this.searchUtil.search(this.packages, t.filterTag).length;
        }
        return false;
      });
    },
    searchTags() {
      return this.searchUtil.searchTags;
    },
    packageList() {
      const tab = this.currentTab;
      if (tab.filterTag) {
        return this.searchUtil.search(this.packages, tab.filterTag);
      }
      return [];
    },
    filteredPackages() {
      const filteredPackages = this.searchUtil.search(this.packageList, this.filterTags);
      const sortedPackages = Sort.sort(filteredPackages);
      // In order to maintain Vue reactivity, we have to return a new array
      return Array.from(sortedPackages);
    },
    avatar() {
      if (this.errorAvatar) {
        return false;
      }
      return this.creator.picture;
    },
    banner() {
      if (this.errorBanner) {
        return false;
      }
      return this.creator.banner;
    },
    socialLinks() {
      return Object.entries(this.creator.social || {}).filter(([_, v]) => v).map(([k, v]) => {
        return Object.assign({}, this.socialLinksTemplate[k], {
          value: v,
          link: typeof this.socialLinksTemplate[k].link === "function" ? this.socialLinksTemplate[k].link(v) : this.socialLinksTemplate[k].link.replace("{0}", v)
        });
      });
    },
    isFollowing() {
      return this.following;
    },
    currentTab() {
      return this.tabs[this.tabIndex];
    },
    showSearch() {
      const tab = this.currentTab;
      return tab && tab.searchField && !this.noData;
    },
    showPackages() {
      const tab = this.currentTab;
      return tab && !!tab.filterTag && !this.noData;
    },
    noData() {
      return this.tabs.length === 0;
    }
  },
  methods: {
    updateTabFromHash() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        const newTab = this.tabs.findIndex(t => t.id === hash.tab);
        if (newTab !== -1) {
          this.tabIndex = newTab;
        } else {
          // If we didn't find the tab, then reset
          this.tabIndex = 0;
        }
        if (hash.package) {
          const pkg = this.packages && this.packages.find(p => p.id === hash.package);
          if (pkg) {
            this.currentPackage = pkg;
          } else {
            this.currentPackage = null;
          }
        } else {
          this.currentPackage = null;
        }
        const newTags = {};
        for (let [k, v] of Object.entries(hash)) {
          if (this.searchUtil.searchTags[k]) {
            newTags[k] = Search.splitString(v, ",");
          }
        }
        if (JSON.stringify(this.filterTags) !== JSON.stringify(newTags)) {
          this.filterTags = newTags;
        }
      } else {
        this.filterTags = {};
        this.tabIndex = 0;
        this.currentPackage = null;
      }
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    changeTab(tab) {
      this.buildHash({
        tab: tab
      });
    },
    async loadIntegrations() {
      const response = await Utils.api("profile/integrations");
      if (response.success) {
        this.userIntegrations = response;
      } else if (response.error && response.code !== 401) {
        UI.error(t("Error retrieving account information: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      }
    },
    followCreator() {
      this.following = !this.following;
    },
    selectPackage(pkgData) {
      this.displayPackage(pkgData);
    },
    /*
    // Use this code, instead of addPackageTag, if you want the Full Package to redirect to the Bazaar instead
    redirectToBazaar(tag) {
      const [key, value] = tag.split(":");
      if (key && value) {
        window.location = `/bazaar#${key}=${value}`;
      }
    },
    */
    addPackageTag(tag) {
      this.showFullPackage = false;
      this.addTag(tag);
    },
    addTag(tag) {
      const [key, value] = tag.split(":");
      // confirm that key and value is valid
      if (key && value && this.searchTags[key]) {
        const searchTag = this.searchTags[key];
        if (!searchTag.strict || searchTag.options && searchTag.options().find(o => o.key === value)) {
          // Add the tag to the filterTags (which will trigger a re-render)
          const tags = {};
          tags[key] = [value];
          this.filterTags = tags;
        }
      }
    },
    purchasePackage(pkg, gift = false) {
      //this needs to be taken to the bazaar, where there's a cart and purchase support
      window.location = `/bazaar#foundry=module&purchase=${gift ? "gift" : "true"}&package=${pkg.name}`;
    },
    purchaseGiftPackage(pkg) {
      this.purchasePackage(pkg, true);
    },
    displayPackage(pkg) {
      this.buildHash({
        package: pkg && pkg.name
      });
    },
    async reloadInstalls() {
      this.reloadingInstalls = true;
      this.customPackages = [];
      const [systems, modules, assets, entitlements] = await Promise.all([Utils.api("data/systems"), Utils.api("data/modules"), Utils.api("data/assets"), Utils.api("profile/entitlements")]);
      if (systems.error || modules.error || entitlements.error) {
        this.reloadingInstalls = false;
        return;
      }
      this.installedSystems = systems;
      this.installedModules = modules;
      this.installedAssets = assets;
      this.entitlements = entitlements;
      for (const installed of [...systems, ...modules]) {
        const pkg = this.packages.find(p => p.type === installed.type && p.name === installed.name);
        if (!pkg) {
          this.customPackages.push(Bazaar.customPackageToBazaar(installed.type, installed));
          continue;
        }
        pkg.installed = String(installed.version);
        pkg.secret = installed.secret;
        pkg.locked = installed.locked;
        // If the package is premium but not in the user's entitlements, consider it as a custom installed package
        if (pkg.premium && !this.entitlements.find(p => p.type === installed.type && p.name === pkg.name)) {
          pkg.custom = true;
          pkg.manifest = installed.manifest;
          pkg.latest = null;
          pkg.versions = [pkg.installed];
          pkg.versionToInstall = null;
          pkg.purchased = false;
          pkg.fullyLoaded = true;
        }
      }
      for (let pack of assets) {
        const pkg = this.packages.find(p => p.type === "asset" && p.name === pack.name);
        if (!pkg) {
          continue;
        }
        pkg.installed = String(pack.version);
        pkg.secret = pack.secret;
      }
      this.installsLoaded = true;
      this.reloadingInstalls = false;
    }
  },
  async created() {
    // Need to have these fields set in advance so they can be reactive
    this.initialData.forEach(pkg => {
      pkg.installed = null;
      pkg.processing = false;
      pkg.entitled = false;
      pkg.entitlement = "";
      pkg.purchased = false;
      pkg.fullyLoaded = false;
      pkg.locked = false;
      pkg.versionToInstall = pkg.latest;
    });
    this.packages = this.initialData;
    await this.searchUtil.init(this.packages);
    await this.reloadInstalls();
    await Utils.loadDependencies(["vuescroll"]);
    await this.loadIntegrations();
    this.loaded = true;
    this.updateTabFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => {
      this.hash = window.location.hash;
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarDndBeyond"] = Vue.component(
                    "BazaarDndBeyond",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"title\" size=\"lg\" no-close-on-esc no-close-on-backdrop hide-header-close :busy=\"importing\" @shown=\"onShown\" @hidden=\"onHidden\" > <div v-if=\"!extensionInstalled\"> <i18n :path=\"t('You need the {0} browser extension installed in order to integrate D&D Beyond with The Forge.')\" tag=\"p\" > <strong>{{ t(\"Beyond The Forge\") }}</strong> </i18n> <p>{{ t(\"Click below install the extension, then reload the page to try again.\") }}</p> </div> <div v-else> <b-overlay fixed :show=\"visible && waiting\" no-wrap> <template #overlay> {{ t(\"Please follow the prompts on the D&D Beyond window\") }} <div class=\"text-center text-success\"> <a href=\"#\" @click.prevent=\"focusWindow\">{{ t(\"Continue\") }}</a> </div> </template> </b-overlay> <div v-if=\"waiting\">{{ t(\"Please follow the prompts on the D&D Beyond window\") }}</div> <div v-else-if=\"!confirmed\"> <p>{{ t(\"You have not confirmed your authorization for The Forge to download your D&D Content.\") }}</p> <p> <em>{{ t( \"(If you did not see the D&D Beyond window pop open, make sure you do not have an adblocker preventing the popup window from appearing)\" ) }}</em> </p> </div> <div v-else-if=\"!success\">{{ t(\"Unable to retrieve your content.\") }}</div> <div v-else-if=\"error\"> <b-alert variant=\"danger\" show>{{ error }}</b-alert> </div> <div v-else> <div v-if=\"token\"> <p> {{ t( \"You have confirmed your authorization for The Forge to download this content from D&D Beyond on your behalf.\" ) }} </p> <p> {{ t( \"Would you like to convert the content into a new Foundry World or a Foundry Module to use in your existing Worlds?\" ) }} </p> </div> <div v-else-if=\"importing\"> {{ t(\"Verifying and Importing your Content into Foundry, please wait…\") }} <ul class=\"list-unstyled\"> <li v-for=\"({ status, label, level }, index) in importSteps\" :key=\"index\" :class=\"`progress-status-level-${level || 1}`\" > <i v-if=\"status !== progressStatusEnum.IN_PROGRESS\" :class=\"statusIcon(status)\" class=\"fa-fw inline-block\" ></i> <span v-if=\"status === progressStatusEnum.IN_PROGRESS\" class=\"spinner-border spinner-border-sm align-middle list-sized\" ></span> {{ label }} </li> </ul> </div> <div v-else> {{ t(\"Import is complete. Your D&D content is now available in your Foundry Game.\") }} </div> </div> <div v-if=\"showMarketplace && !!marketplace\"> <i18n :path=\"t('Purchase this content from the D&D Beyond {0}.')\"> <a :href=\"marketplace\" target=\"_blank\">{{ t(\"Marketplace\") }}</a> </i18n> </div> </div> <!-- Footer Buttons --> <template #modal-footer=\"{ cancel }\"> <b-button v-if=\"!imported\" :disabled=\"importing\" variant=\"secondary\" class=\"float-left\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <template v-if=\"!extensionInstalled\"> <a class=\"btn btn-primary\" href=\"https://chrome.google.com/webstore/detail/beyond-the-forge/cfjlogdnkgmokpoenibjicddbabfkfid\" target=\"_blank\" > {{ t(\"Install Extension\") }} </a> <b-button variant=\"primary\" @click=\"reloadPage\"> {{ t(\"Reload\") }} </b-button> </template> <template v-else> <template v-if=\"waiting\"></template> <template v-else-if=\"!confirmed\"> <b-button variant=\"primary\" @click=\"showModal\"> {{ t(\"Reopen Popup\") }} </b-button> </template> <template v-else-if=\"!success\"></template> <template v-else-if=\"error\"></template> <template v-else> <template v-if=\"token\"> <b-button variant=\"primary\" @click.prevent=\"importContent('world')\">{{ t(\"Import as World\") }}</b-button> <b-button variant=\"primary\" @click.prevent=\"importContent('module')\">{{ t(\"Import as Module\") }}</b-button> </template> <template v-else-if=\"importing\"></template> <template v-else> <b-button variant=\"secondary\" @click=\"cancel\"> {{ t(\"Close\") }} </b-button> </template> </template> </template> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".list-unstyled .spinner-border-sm.list-sized { margin: 0 0.175rem; width: 0.9rem; height: 0.9rem; } .list-unstyled .progress-status-level-2 { margin-left: 1rem; }"
    });
  },
  props: {
    value: Boolean,
    package: Object
  },
  data() {
    return {
      // popup: null, // can't make popup into vue getters/setters as it breaks the window.open
      // return value being accessed from cross-origin
      boundMethods: {},
      waiting: true,
      success: false,
      error: "",
      confirmed: false,
      token: null,
      importing: false,
      showMarketplace: false,
      importStatus: "",
      statusChecker: 0,
      progressStatusEnum: Enums.ProgressStatus,
      importSteps: [{
        id: Enums.DDBImportSteps.PENDING,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Preparing download from D&D Beyond")
      }, {
        id: Enums.DDBImportSteps.MANIFEST,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Updating manifest data from D&D Beyond")
      }, {
        id: Enums.DDBImportSteps.VERIFYING,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Requesting access to content from D&D Beyond")
      }, {
        id: Enums.DDBImportSteps.DOWNLOADING,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Downloading content from D&D Beyond")
      }, {
        id: Enums.DDBImportSteps.ASSETS,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Downloading from D&D Beyond and uploading to the Assets Library")
      }, {
        id: Enums.DDBImportSteps.CONVERTING,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Converting content to Foundry")
      }, {
        id: Enums.DDBImportSteps.DEPENDENCY,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Downloading referenced dependency content from D&D Beyond"),
        level: 2
      }, {
        id: Enums.DDBImportSteps.CONVERTING_DEPENDENCY,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Converting referenced dependency content to Foundry"),
        level: 2
      }, {
        id: Enums.DDBImportSteps.ASSETS_DEPENDENCY,
        status: Enums.ProgressStatus.NOT_STARTED,
        label: t("Uploading referenced dependency content to the Assets Library"),
        level: 2
      }]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    extensionInstalled() {
      return !(typeof BeyondTheForge === "undefined" || !BeyondTheForge);
    },
    url() {
      return `https://www.dndbeyond.com/sources/${this.slug}`;
    },
    params() {
      return {
        slug: this.slug,
        name: this.name
      };
    },
    name() {
      return this.package.title;
    },
    title() {
      return t(`Purchase and Import {{- name}}`, {
        name: this.name
      });
    },
    slug() {
      return this.package.dndbeyond.slug;
    },
    marketplace() {
      return this.package.dndbeyond.marketplace;
    },
    imported() {
      return this.importStatus === "done";
    },
    isImporting() {
      return this.importing;
    }
  },
  methods: {
    onShown() {
      if (!this.extensionInstalled) {
        return;
      }
      this.showModal();
      this.closeTimer = setInterval(this.checkForClose.bind(this), 500);
    },
    onHidden() {
      this.waiting = true, this.success = false;
      this.confirmed = false;
      this.error = "";
      this.importing = false;
      this.showMarketplace = false;
      this.importStatus = "";
      this.$emit("input", false);
    },
    focusWindow() {
      if (this.popup) {
        this.popup.focus();
        this.popup.postMessage(this.params, "https://www.dndbeyond.com");
      }
    },
    onUnload() {
      console.log("Unload");
      this.popup = null;
      this.waiting = false;
    },
    checkForClose() {
      if (!this.popup || this.popup.closed) {
        clearInterval(this.closeTimer);
        this.closeTimer = 0;
        this.onUnload();
      }
    },
    showModal() {
      const padding = 30;
      const innerWidth = window.innerWidth / 2 + padding * 2;
      const innerHeight = window.innerHeight / 2 + padding * 2;
      const left = window.screenX + innerWidth / 2 - padding;
      const top = window.screenY + innerHeight / 2 - padding;
      const windowFeatures = `toolbar=0, location=0, menubar=0, titlebar=0, scrollbars=1, innerWidth=${innerWidth}, innerHeight=${innerHeight}, left=${left}, top=${top}`;
      this.popup = window.open(this.url, "_blank", windowFeatures);
      window.addEventListener("message", this.boundMethods.message, true);
    },
    async receiveMessage(event) {
      if (event.origin !== "https://www.dndbeyond.com") {
        return;
      }
      if (event.data === "ready") {
        return this.focusWindow();
      }
      if (event.data === "closed") {
        return this.onUnload();
      }
      // Make sure the message is coming from the right extension
      if (!event.data || event.data.source !== "Beyond The Forge") {
        return;
      }
      event.stopPropagation();
      window.removeEventListener("message", this.boundMethods.message, true);
      window.removeEventListener("unload", this.boundMethods.unload, false);
      this.popup.close();
      this.waiting = false;
      this.popup = null;
      this.token = event.data.token;
      this.confirmed = event.data.confirmed;
      this.success = !!event.data.token;

      // For rule books, don't give the choice to convert to a world
      if (this.confirmed && this.token && this.package.category === "Rule") {
        this.importContent("module");
      }
    },
    updateImportStatues(status) {
      if (status !== this.importStatus) {
        this.importStatus = status;
        const index = this.importSteps.findIndex(step => step.id === status);
        if (index >= 0) {
          const currentStep = this.importSteps[index];
          const convertingIndex = this.importSteps.findIndex(step => step.id === Enums.DDBImportSteps.CONVERTING);
          currentStep.status = Enums.ProgressStatus.IN_PROGRESS;
          // Mark all steps before the current one as complete. However, all steps after 'converting'
          // are part of the conversion process, so don't mark 'converting' and any after it as complete
          // until we're actually done.
          for (let i = 0; i < Math.min(index, convertingIndex); i++) {
            // The 'manifest' step is marked as skipped if it wasn't previously in progress
            if (this.importSteps[i].id === Enums.DDBImportSteps.MANIFEST) {
              if (this.importSteps[i].status === Enums.ProgressStatus.IN_PROGRESS) {
                this.importSteps[i].status = Enums.ProgressStatus.COMPLETE;
              } else {
                this.importSteps[i].status = Enums.ProgressStatus.SKIPPED;
              }
            } else {
              this.importSteps[i].status = Enums.ProgressStatus.COMPLETE;
            }
          }
          for (let i = convertingIndex; i < index; i++) {
            this.importSteps[i].status = Enums.ProgressStatus.IN_PROGRESS;
          }
        }
      }
    },
    async importContent(type) {
      if (!this.token) {
        return;
      }
      const token = this.token;
      this.resetImportStatuses();
      this.importing = true;
      this.token = null;
      try {
        const response = await Utils.apiTask(`bazaar/dndbeyond/import`, {
          id: this.package.dndbeyond.id,
          token,
          type
        }, null, {
          status: (status, response) => {
            this.updateImportStatues(status);
          }
        });
        if (response.error) {
          if (response.error === "User cannot access that content") {
            this.showMarketplace = true;
            throw new Error(t("You need to purchase this content from D&D Beyond before being able to import it"));
          } else {
            UI.alert("danger", t(`Failed to import content: {{- error}}`, {
              error: response.error
            }));
            throw new Error(response.error);
          }
        } else {
          this.$emit("installed", response);
        }
        this.importing = false;
      } catch (err) {
        this.error = err.message;
        this.importing = false;
      }
    },
    reloadPage() {
      window.location.reload();
    },
    resetImportStatuses() {
      this.importSteps.forEach((step, index) => {
        step.status = index === 0 ? Enums.ProgressStatus.IN_PROGRESS : Enums.ProgressStatus.NOT_STARTED;
      });
      this.importStatus = this.importSteps[0].id;
    },
    statusIcon(status) {
      switch (status) {
        case Enums.ProgressStatus.COMPLETE:
          return "fas fa-check-circle text-success";
        case Enums.ProgressStatus.SKIPPED:
          return "far fa-check-circle text-black-50";
        case Enums.ProgressStatus.NOT_STARTED:
          return "far fa-circle";
        default:
          return "";
      }
    }
  },
  created() {
    this.boundMethods.message = this.receiveMessage.bind(this);
    this.boundMethods.unload = this.onUnload.bind(this);
  },
  destroyed() {
    window.removeEventListener("message", this.boundMethods.message, true);
    window.removeEventListener("unload", this.boundMethods.unload, false);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarFilters"] = Vue.component(
                    "BazaarFilters",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"bazaar-filters\" @wheel=\"$emit('wheel', $event)\"> <div v-if=\"!isGiftCard\"> <b-form-group :label=\"t('Sort by:')\"> <b-form-select v-model=\"sortBy\" :options=\"sortOptions\" size=\"sm\"></b-form-select> </b-form-group> <b-form-group> <template #label> {{ t(\"Search Terms:\") }} <b-button-group v-show=\"customTags.length > 1\"> <b-button size=\"sm\" :variant=\"matchAll ? 'primary' : 'secondary'\" @click=\"$emit('match-all', true)\">{{ t(\"Match All\") }}</b-button> <b-button size=\"sm\" :variant=\"matchAll ? 'secondary' : 'primary'\" @click=\"$emit('match-all', false)\">{{ t(\"Match Any\") }}</b-button> </b-button-group> </template> <b-form-tags v-model=\"customTags\" :placeholder=\"t('Add search term…')\"></b-form-tags> </b-form-group> <div v-if=\"numCategories > 0\" class=\"categories-filters mb-2\"> <span @click=\"showCategories = !showCategories\"> <i class=\"fas fa-th\"></i> {{ t(\"Filter by Category:\") }} <i class=\"fas\" :class=\"showCategories ? 'fa-caret-up' : 'fa-caret-down'\"></i> </span> <div> <transition enter-active-class=\"animate__animated animate__faster animate__slideInDown\" leave-active-class=\"animate__animated animate__faster animate__slideOutUp\" > <div v-show=\"showCategories\" class=\"category-list bg-light border rounded m-1 p-1\"> <div v-for=\"(num, category) of categories\" :key=\"category\"> <small ><a href=\"#\" class=\"text-dark\" @click.prevent=\"tagCategory(category)\" >{{ category }} ({{ num }})</a ></small > </div> </div> </transition> </div> </div> <div v-if=\"languages\" class=\"language-filters mb-2\"> <span @click=\"showLangs = !showLangs\"> <i class=\"fas fa-globe-americas\"></i> {{ t(\"Filter by Language:\") }} <i class=\"fas\" :class=\"showLangs ? 'fa-caret-up' : 'fa-caret-down'\"></i> </span> <div> <transition enter-active-class=\"animate__animated animate__faster animate__slideInDown\" leave-active-class=\"animate__animated animate__faster animate__slideOutUp\" > <div v-show=\"showLangs\" class=\"language-list bg-light border rounded m-1 p-1\"> <span v-for=\"lang of languages\" :key=\"lang.lang\"> <a href=\"#\" class=\"border border-secondary rounded-pill px-1 language-name text-dark\" @click.prevent=\"tagLanguage(lang.lang)\" >{{ lang.name }}</a >&nbsp; </span> </div> </transition> </div> </div> </div> <!-- Modules --> <div class=\"accordion\" role=\"tablist\"> <b-card no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-modules size=\"sm\" block :pill=\"type !== 'module'\" variant=\"primary\"> <img src=\"/images/bazaar/module-icon-32.png\" /> {{ t(\"Add-on Modules\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-modules\" :visible=\"type === 'module'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'module')\" > <b-card-body> <b-card-text> <div v-for=\"(tag, key) of filters\" :key=\"key\"> <span v-show=\"filter === key\" class=\"text-success\">•&nbsp;</span> <small ><a href=\"#\" @click.prevent=\"$emit('filter', key)\">{{ tag }}</a></small > </div> </b-card-text> </b-card-body> </b-collapse> </b-card> <!-- Systems --> <b-card no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-systems size=\"sm\" block :pill=\"type !== 'system'\" variant=\"primary\"> <img src=\"/images/bazaar/system-icon-32.png\" /> {{ t(\"Game Systems\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-systems\" :visible=\"type === 'system'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'system')\" > <b-card-body> <b-card-text> <div v-for=\"(tag, key) of filters\" :key=\"key\"> <span v-show=\"filter === key\" class=\"text-success\">•&nbsp;</span> <small ><a href=\"#\" @click.prevent=\"$emit('filter', key)\">{{ tag }}</a></small > </div> </b-card-text> </b-card-body> </b-collapse> </b-card> <!-- Worlds --> <b-card no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-worlds size=\"sm\" block :pill=\"type !== 'world'\" variant=\"primary\"> <img src=\"/images/bazaar/world-icon-32.png\" /> {{ t(\"Worlds\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-worlds\" :visible=\"type === 'world'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'world')\" > <b-card-body> <b-card-text> <div v-for=\"(tag, key) of filters\" :key=\"key\"> <span v-show=\"filter === key\" class=\"text-success\">•&nbsp;</span> <small ><a href=\"#\" @click.prevent=\"$emit('filter', key)\">{{ tag }}</a></small > </div> </b-card-text> </b-card-body> </b-collapse> </b-card> <!-- Assets --> <b-card v-show=\"showAssets\" no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-assets size=\"sm\" block :pill=\"type !== 'asset'\" variant=\"primary\"> <img src=\"/images/bazaar/asset-icon-32.png\" /> {{ t(\"Assets\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-assets\" :visible=\"type === 'asset'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'asset')\" > <b-card-body> <b-card-text> <div v-for=\"(tag, key) of filters\" :key=\"key\"> <span v-show=\"filter === key\" class=\"text-success\">•&nbsp;</span> <small ><a href=\"#\" @click.prevent=\"$emit('filter', key)\">{{ tag }}</a></small > </div> </b-card-text> </b-card-body> </b-collapse> </b-card> <!-- D&D Beyond --> <b-card no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-dndb size=\"sm\" block :pill=\"type !== 'dndbeyond'\" variant=\"primary\"> <i class=\"fab fa-d-and-d-beyond align-middle\" style=\"font-size: 32px; color: red\"></i> {{ t(\"D&D Beyond\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-dndb\" :visible=\"type === 'dndbeyond'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'dndbeyond')\" > <b-card-body> <b-card-text> <div v-for=\"(tag, key) of filters\" :key=\"key\"> <span v-show=\"filter === key\" class=\"text-success\">•&nbsp;</span> <small ><a href=\"#\" @click.prevent=\"$emit('filter', key)\">{{ tag }}</a></small > </div> </b-card-text> </b-card-body> </b-collapse> </b-card> <!-- Gift cards --> <b-card no-body class=\"mb-1\"> <b-card-header header-tag=\"header\" class=\"p-1\" role=\"tab\"> <b-button v-b-toggle.bazaar-filter-gift size=\"sm\" block :pill=\"type !== 'forge-gift-card'\" variant=\"primary\"> <img src=\"/images/bazaar.png\" width=\"32\" height=\"32\" /> {{ t(\"Gift Cards\") }} </b-button> </b-card-header> <b-collapse id=\"bazaar-filter-gift\" :visible=\"type === 'forge-gift-card'\" accordion=\"my-accordion\" role=\"tabpanel\" @show=\"$emit('type', 'forge-gift-card')\" > </b-collapse> </b-card> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-filters .language-filters > span { cursor: pointer; } .bazaar-filters .language-filters > div { overflow: hidden; } .bazaar-filters .language-filters .language-list { word-wrap: break-word; overflow: hidden; } .bazaar-filters .language-name { white-space: nowrap; } .bazaar-filters .categories-filters > div { overflow: hidden; } .bazaar-filters .categories-filters .language-list { word-wrap: break-word; overflow: hidden; }"
    });
  },
  props: {
    value: {
      type: Array,
      default: []
    },
    languages: Array,
    categories: Object,
    filters: Object,
    type: String,
    filter: String,
    sort: String,
    matchAll: Boolean,
    showAssets: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showLangs: false,
      showCategories: false,
      sortBy: "installs"
    };
  },
  watch: {
    sortBy(val) {
      this.$emit("sort", val);
    },
    sort(val) {
      this.sortBy = val;
    },
    customTags(val) {
      this.$emit("search", val);
    }
  },
  computed: {
    customTags: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isCustom() {
      return this.filter === "custom";
    },
    isGiftCard() {
      return this.type === "forge-gift-card";
    },
    sortOptions() {
      const options = [];
      if (!this.isCustom) {
        options.push({
          value: "installs",
          text: t("Most Popular")
        }, {
          value: "updated",
          text: t("Latest Releases")
        });
      }
      options.push({
        value: "title",
        text: t("Alphabetically")
      });
      return options;
    },
    numCategories() {
      return this.categories ? Object.keys(this.categories).length : 0;
    }
  },
  methods: {
    addTag(tag) {
      this.customTags.push(tag);
    },
    tagLanguage(lang) {
      this.$emit("tag", `language:${lang}`);
    },
    tagCategory(category) {
      this.$emit("tag", `category:${category}`);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarFloatingCart"] = Vue.component(
                    "BazaarFloatingCart",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"bazaar-floating-cart__icon\" :class=\"{ 'animate__animated animate__bounce': cart.length > 0 }\" :style=\"{ bottom: '150px' }\" > <b-button :aria-label=\"t('My Cart')\" :variant=\"cart.length > 0 ? 'success' : 'outline-primary'\" size=\"lg\" @click=\"checkoutCart\" > <i class=\"fas\" :class=\"cart.length ? 'fa-cart-plus' : 'fa-shopping-cart'\"></i> <span v-if=\"cart.length\" class=\"badge-counter badge badge-danger\" :aria-label=\"t('You have {{items}} items in your Cart.', { items: cart.length })\" > {{ cart.length }} </span> </b-button> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-floating-cart__icon { position: fixed; right: 1.5rem; z-index: 9999; cursor: grab; transition: top 0.05s ease-out; }"
    });
  },
  name: "BazaarFloatingCart",
  props: {
    cart: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    checkoutCart() {
      this.$emit("checkout-cart");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarFullPackage"] = Vue.component(
                    "BazaarFullPackage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* global PACKAGE_MEDIA_TYPES */
var _default = exports.default = {
  template: "<b-container fluid class=\"foundry-full-package-view\"> <b-row> <!-- Right hand side --> <b-col cols=\"12\" lg=\"4\" md=\"6\" order-md=\"12\"> <div class=\"text-center mb-2\"> <b-button v-if=\"canInstall && marketplace && !isGiftCard && isApproved\" v-b-tooltip.hover variant=\"primary\" :title=\"t('Offer a gift to someone')\" @click.prevent=\"$emit('purchase-gift', pkg)\" > <i class=\"fas fa-gift\"></i> <i18n :path=\"t('Give {0} to a friend!')\"> <strong>{{ title }}</strong> </i18n> </b-button> </div> <b-row class=\"package-header package-header--controls\"> <!-- Install/Uninstall button --> <b-col class=\"d-flex text-center mb-3\"> <bazaar-package-install-button :package=\"pkg\" :can-install=\"canInstall\" @install=\"$emit('install', $event)\" @uninstall=\"$emit('uninstall', $event)\" @check-update=\"$emit('check-update', $event)\" @purchase=\"$emit('purchase', $event)\" @ddb-installed=\"$emit('ddb-installed', $event)\" ></bazaar-package-install-button> <bazaar-package-patreon-button v-if=\"!isPurchased && hasPatreon\" :package=\"pkg\" :can-install=\"canInstall\" :user-integrations=\"userIntegrations\" @setup=\"setupPatreon\" @subscribe=\"subscribePatreon\" @install=\"$emit('install', $event)\" > </bazaar-package-patreon-button> </b-col> </b-row> <b-row v-if=\"compatibility\"> <b-col> <bazaar-compatibility v-bind=\"compatibility\" :core-version=\"coreVersion\" :package-version=\"packageVersionForCompatibility\" ></bazaar-compatibility> <bazaar-package-compatible-versions v-bind=\"compatibility\"></bazaar-package-compatible-versions> </b-col> </b-row> <b-row v-if=\"hasCreator && showCreatorLink\" class=\"package-header\"> <!-- More from this creator --> <b-col class=\"text-center mb-3 package-creator-info\"> <b-row> <b-col md=\"auto\" class=\"p-0\"> <b-img v-if=\"creatorPicture\" v-bind=\"avatarImageData\" :src=\"creatorPicture\"></b-img> </b-col> <b-col md=\"auto\" class=\"text-left ml-2 mt-1\"> <b-row> <b-col md=\"auto\" class=\"p-0\"> {{ t(\"Presented by:\") }} </b-col> <b-col class=\"creator-name\"> {{ pkg.creator.name }} </b-col> </b-row> <b-row> <a :href=\"moreFromCreatorLink\" target=\"_blank\"> {{ t(\"See more from this creator\") }} <i class=\"fas fa-arrow-circle-right\"></i> </a> </b-row> </b-col> </b-row> </b-col> </b-row> <b-row class=\"package-details\"> <b-col> <!-- Package type --> <b-row class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category package-type\"> {{ t(\"Package Type\") }} </b-col> <b-col class=\"detail-value\"> <!-- t(\"System\") --> <!-- t(\"Asset\") --> <!-- t(\"World\") --> <!-- t(\"Module\") --> <i18n :path=\"t('{0} {{pkgType}}', { pkgType: t(Utils.capitalize(pkg.type.replace(/-/g, ' '))) })\"> <img :src=\"defaultIcon()\" height=\"32\" /> </i18n> </b-col> </b-row> <!-- Version --> <b-row v-if=\"pkg.installed\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Installed Version\") }} </b-col> <b-col class=\"detail-value\"> {{ version }} <b-button class=\"package-lock\" variant=\"link\" size=\"sm\" @click.prevent=\"togglePackageLock\" @mouseover=\"lockIconHovered = true\" @mouseleave=\"lockIconHovered = false\" > <i v-show=\"showPackageLocked\" v-b-tooltip class=\"fas fa-lock text-danger\" :title=\"t(`Click to Lock this package to version {{version}} and prevent updates`, { version })\" ></i> <i v-show=\"!showPackageLocked\" v-b-tooltip class=\"fas fa-lock-open text-success\" :title=\" t(`You have locked package version to {{version}} Click to unlock and allow updates`, { version }) \" ></i> </b-button> </b-col> </b-row> <!-- Latest Version --> <b-row v-if=\"!pkg.custom && !isGiftCard\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Latest Version\") }} </b-col> <b-col class=\"detail-value\"> {{ pkg.latest }} <help-icon v-if=\"coreVersion\" url=\"/setup\" :tooltip=\" t( 'This is the latest package version listed for Foundry {{coreVersion}}. Please check the minimum and compatible core version fields below to confirm that it is compatible with your games', { coreVersion } ) \" ></help-icon> </b-col> </b-row> <!-- Package installs --> <b-row v-if=\"!pkg.custom && pkg.installs\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Forge Installs\") }} </b-col> <b-col class=\"detail-value\"> {{ pkg.installs }}% <help-icon :tooltip=\" t(`This {{type}} has been installed in {{percent}}% of Forge games`, { type: pkg.type, percent: pkg.installs, }) \" ></help-icon> </b-col> </b-row> <!-- Authors --> <b-row v-if=\"authors.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"PLURAL.Authors\", { count: authors.length }) }} </b-col> <b-col class=\"detail-value\"> <p v-for=\"author of authors\" :key=\"author.name\" class=\"m-0\"> <b-link v-b-tooltip.hover @click=\"authorSearch(author.name)\"> {{ author.name }} </b-link> <a v-if=\"author.url\" v-b-tooltip.hover.viewport :href=\"author.url\" target=\"_blank\" class=\"mr-2\" :title=\"author.url\" > <i class=\"fa fa-globe mr-1\"></i> </a> <a v-if=\"author.email\" v-b-tooltip.hover.viewport :href=\"`mailto:${author.email}`\" target=\"_blank\" :title=\"author.email\" > <i class=\"far fa-envelope mr-1\"></i> </a> <a v-if=\"!!getAuthorProperty(author, 'twitter')\" v-b-tooltip.hover.viewport :href=\"authorURL('https://twitter.com/', getAuthorProperty(author, 'twitter'))\" target=\"_blank\" :title=\"getAuthorProperty(author, 'twitter')\" > <i class=\"fab fa-twitter mr-1\"></i> </a> <a v-if=\"!!getAuthorProperty(author, 'reddit')\" v-b-tooltip.hover.viewport :href=\"authorURL('https://reddit.com/', getAuthorProperty(author, 'reddit'))\" target=\"_blank\" :title=\"getAuthorProperty(author, 'reddit')\" > <i class=\"fab fa-reddit mr-1\"></i> </a> <span v-if=\"!!getAuthorProperty(author, 'discord')\" v-b-tooltip.hover.viewport :title=\"getAuthorProperty(author, 'discord')\" > <i class=\"fab fa-discord mr-1\"></i> </span> <a v-if=\"!!getAuthorProperty(author, 'patreon')\" v-b-tooltip.hover.viewport :href=\"authorURL('https://patreon.com/', getAuthorProperty(author, 'patreon'))\" target=\"_blank\" :title=\"getAuthorProperty(author, 'patreon')\" > <i class=\"fab fa-patreon mr-1\"></i> </a> <a v-if=\"authorKofi(author)\" v-b-tooltip.hover.viewport :href=\"authorURL('https://ko-fi.com/', authorKofi(author))\" target=\"_blank\" :title=\"authorKofi(author)\" > <img src=\"/images/social/ko-fi-icon.svg\" style=\"width: 1em; height: 1em\" /> </a> <a v-if=\"!!getAuthorProperty(author, 'github')\" v-b-tooltip.hover.viewport :href=\"authorURL('https://github.com/', getAuthorProperty(author, 'github'))\" target=\"_blank\" :title=\"getAuthorProperty(author, 'github')\" > <i class=\"fab fa-github mr-1\"></i> </a> <a v-if=\"!!getAuthorProperty(author, 'mastodon')\" v-b-tooltip.hover.viewport target=\"_blank\" :title=\"getAuthorProperty(author, 'mastodon')\" > <i class=\"fab fa-mastodon mr-1\"></i> </a> </p> </b-col> </b-row> <!-- Languages --> <b-row v-if=\"languages.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Supported languages\") }} </b-col> <b-col class=\"detail-value\"> <p v-for=\"lang of languages\" :key=\"lang.lang\" class=\"m-0\"> <b-link @click=\"bazaarSearch('language', lang.lang || lang.name)\"> {{ lang.name || lang.lang }} </b-link> </p> </b-col> </b-row> <!-- System --> <b-row v-if=\"pkg.type === 'world'\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"System\") }} </b-col> <b-col class=\"detail-value\"> <p v-for=\"system of pkg.systems\" :key=\"system\" class=\"m-0\"> <b-link @click=\"bazaarSearch('system', system)\"> {{ system }} </b-link> </p> </b-col> </b-row> <b-row v-if=\"pkg.type === 'module'\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Supported system\") }}<span v-if=\"!pkg.systems || pkg.systems.length > 1\">s</span> </b-col> <b-col class=\"detail-value\"> <span v-if=\"!pkg.systems\"> {{ t(\"All systems\") }} <template v-if=\"pkg.compendiumPackSystems && pkg.compendiumPackSystems.length > 0\"> <help-icon :tooltip=\" t( 'This module can be used with any system, and it also has one or more compendium packs that are specific to: {{val, list(type: disjunction;)}}', { val: pkg.compendiumPackSystems } ) \" ></help-icon> <p class=\"m-0\"> {{ t(\"With compendium packs for:\") }} </p> <p v-for=\"system of pkg.compendiumPackSystems\" :key=\"system\" class=\"m-0\"> <b-link @click=\"bazaarSearch('system', system)\"> {{ system }} </b-link> </p> </template> </span> <p v-for=\"system of pkg.systems\" v-else :key=\"system\" class=\"m-0\"> <b-link @click=\"bazaarSearch('system', system)\"> {{ system }} </b-link> </p> </b-col> </b-row> <!-- Dependencies --> <b-row v-if=\"requiredPackages.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Required Packages\") }} </b-col> <b-col class=\"detail-value\"> <p v-if=\"loadingRequiredPackages\" class=\"m-0\"> <loading-indicator small></loading-indicator> </p> <p v-for=\"required of requiredPackages\" v-else :key=\"required.id\" class=\"m-0\"> <img :src=\"defaultIcon(required.type)\" height=\"32\" /> <b-link v-b-tooltip.hover :title=\"`${required.id} ${ packagesData[required.id]['compatible'] ? '' : '-' + t('Incompatible Foundry version') }`\" @click=\"bazaarSearch('id', required.id)\" > {{ packagesData[required.id][\"title\"] ? packagesData[required.id][\"title\"] : required.id }} </b-link> </p> </b-col> </b-row> <b-row v-if=\"recommendedPackages.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Recommended Packages\") }} </b-col> <b-col class=\"detail-value\"> <p v-if=\"loadingRecommendedPackages\" class=\"m-0\"> <loading-indicator small></loading-indicator> </p> <p v-for=\"recommended of recommendedPackages\" v-else :key=\"recommended.id\" class=\"m-0\"> <img :src=\"defaultIcon(recommended.type)\" height=\"32\" /> <b-link v-b-tooltip.hover :title=\"`${recommended.id} ${ packagesData[recommended.id]['compatible'] ? '' : '-' + t('Incompatible Foundry version') }`\" @click=\"bazaarSearch('id', recommended.id)\" > {{ packagesData[recommended.id][\"title\"] ? packagesData[recommended.id][\"title\"] : recommended.id }} <i v-if=\"!packagesData[recommended.id]['compatible']\" class=\"fas fa-exclamation-triangle text-warning\" ></i> </b-link> </p> </b-col> </b-row> <b-row v-if=\"tagList.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Tags\") }} </b-col> <b-col class=\"detail-value\"> <b-badge v-for=\"{ key, label } of tagList\" :key=\"key\" pill class=\"m-0 mr-1\" variant=\"info\"> <b-link class=\"text-white\" :title=\"label\" @click=\"bazaarSearch('tag', key)\"> {{ label }} </b-link> </b-badge> </b-col> </b-row> <!-- Categories --> <b-row v-if=\"categories.length\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Categories\") }} </b-col> <b-col class=\"detail-value\"> <p v-for=\"{ key, label } of categories\" :key=\"key\" class=\"m-0\"> <b-link v-b-tooltip.hover :title=\"label\" @click=\"bazaarSearch('tag', key)\"> {{ label }} </b-link> </p> </b-col> </b-row> <!-- Created --> <b-row v-if=\"!pkg.custom && !isGiftCard\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Created\") }} </b-col> <b-col class=\"detail-value\"> {{ createdAt }} </b-col> </b-row> <!-- Last updated --> <b-row v-if=\"!pkg.custom && !isGiftCard\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Last updated\") }} </b-col> <b-col class=\"detail-value\"> {{ updatedAt }} </b-col> </b-row> <!-- Project URL --> <b-row v-if=\"url\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Project Website\") }} </b-col> <b-col class=\"detail-value\"> <a v-b-tooltip.hover :href=\"url\" target=\"_blank\" class=\"text-body\" :title=\"url\"> <i class=\"fas fa-external-link-alt\"></i> </a> </b-col> </b-row> <!-- Foundry Hub --> <b-row v-if=\"!pkg.custom && !isGiftCard\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ t(\"Foundry Hub\") }} <img src=\"/images/fhub_logo4_32px.png\" width=\"24\" height=\"24\" /> </b-col> <b-col class=\"detail-value\"> <a v-b-tooltip.hover :href=\"`https://www.foundryvtt-hub.com/package/${pkg.name}/`\" target=\"_blank\" class=\"text-body\" :title=\"t('{{title}} on Foundry Hub', { title: pkg.title })\" > <i class=\"fas fa-external-link-alt\"></i> </a> </b-col> </b-row> <!-- Extra fields --> <template v-for=\"extra of extras\"> <b-row v-if=\"pkg.manifest && extraValue(extra)\" :key=\"extra.field\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category\"> {{ extra.label }} </b-col> <b-col :key=\"`${extra.field}-value`\" class=\"detail-value\"> <a v-if=\"extra.url\" v-b-tooltip.hover :href=\"extraValue(extra)\" target=\"_blank\" class=\"text-body\" :title=\"extraValue(extra)\" > <i class=\"fas fa-external-link-alt\"></i> </a> <span v-else>{{ extraValue(extra) }}</span> </b-col> </b-row> </template> <!-- Version install selection --> <b-row v-if=\"!isGiftCard && hasVersions\" class=\"package-details-row\" cols=\"2\"> <b-col class=\"detail-category install-version\"> {{ t(\"Version to install\") }} </b-col> <b-col class=\"detail-value\"> <b-form-select v-model=\"pkg.versionToInstall\" :options=\"availableVersions\"></b-form-select> </b-col> </b-row> </b-col> <!-- Loading --> <b-col v-if=\"!pkg.fullyLoaded\" class=\"detail-value text-center\" cols=\"12\"> <loading-indicator small></loading-indicator> </b-col> </b-row> <b-alert v-if=\"protectedPackage\" variant=\"info\" show class=\"mt-2\"> <p> <strong>{{ t(\"Premium Foundry content\") }}</strong> </p> <p>{{ t(\"This content is official Premium content from a Foundry partner\") }}</p> <p> {{ t( \"Although it can be installed from the Bazaar, the content is not part of The Forge's Bazaar offering and will therefore count against your storage quotas.\" ) }} </p> <i18n :path=\"t('Click {0} for more information.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/docs?topic=11537\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> </b-alert> <b-alert v-else-if=\"isGiftCard\" variant=\"info\" show class=\"mt-2\"> <p> <strong>{{ t(\"Premium Forge Content\") }}</strong> </p> <p> {{ t(\"This gift card allows you to transfer the value on the gift card to someone else's account balance.\") }} </p> <p> {{ t( \"Gift cards are not subject to sales tax, and a user's balance can be applied on all future purchases made on The Forge.\" ) }} </p> <i18n :path=\"t('Click {0} for more information.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/purchasing-bazaar-content/12464\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> </b-alert> <!-- Forge Premium and Patreon info --> <b-card v-else-if=\"marketplace || (hasPatreon && !isPurchased)\" header-text-variant=\"dark\" header-bg-variant=\"info\" border-variant=\"info\" class=\"mt-2 patreon-conditions-info\" > <template #header> <strong>{{ t(\"Premium Forge Partner Content\") }}</strong> </template> <p> {{ t(\"The creator of this content chose to partner with the Forge to offer their work as a premium package.\") }} </p> <p> {{ t( \"This content from the Forge lets you financially compensate the module creator for their work, while providing you the convenience of an instant-deployment—no downloads and importing required!\" ) }} </p> <i18n :path=\"t('Click {0} for more information.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/purchasing-bazaar-content/12464\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> <bazaar-package-patreon-info v-if=\"hasPatreon\" :package=\"pkg\" :user-integrations=\"userIntegrations\" ></bazaar-package-patreon-info> <b-alert v-if=\"pkg.downloadable\" show variant=\"success\" class=\"border border-success\"> {{ t(\"This content is available for download for use outside of The Forge if you have purchased it.\") }} <i18n :path=\"t('Click {0} to see your downloads.')\" tag=\"p\"> <a href=\"/account#purchases\">{{ t(\"here\") }}</a> </i18n> </b-alert> <b-alert v-else show variant=\"warning\" class=\"border border-warning\"> {{ t(\"This content is not available for download and can only be used within The Forge through The Bazaar.\") }} </b-alert> </b-card> </b-col> <!-- Left hand side --> <b-col cols=\"12\" lg=\"8\" md=\"6\"> <!-- Alert for the LiveKit module --> <b-alert v-if=\"name === 'avclient-livekit'\" variant=\"success\" show class=\"mt-2\"> <p> <strong>{{ t(\"The Forge LiveKit servers\") }}</strong> </p> <p> {{ t( \"The Forge provides pre-configured LiveKit servers for World Builder subscribers. Just set the server type to The Forge and enjoy! No setup necessary!\" ) }} </p> <i18n :path=\"t('Click {0} for more information.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/livekit-voice-and-video-chat/17792\" target=\"_blank\"> {{ t(\"here\") }} </a> </i18n> <p> <em> <i18n :path=\" t( 'The LiveKit AV Client module is created and maintained by {0}, a team building a growing collection of products and services to help you improve your communities.' ) \" > <a href=\"https://tavern.at/\" target=\"_blank\">{{ t(\"At the Tavern\") }}</a> </i18n> </em> </p> </b-alert> <template v-if=\"showCreatorAlerts\"> <b-alert v-if=\"pkg.isCreator && !ready\" variant=\"danger\" show> {{ t( \"This package has not been published yet and is only visible to you to test in the Bazaar, before submitting it for publication.\" ) }}<br /> <i18n :path=\"t('Click {0} to edit your package.')\"> <a :href=\"creatorPackageLink\">{{ t(\"here\") }}</a> </i18n> </b-alert> <b-alert v-else-if=\"pkg.isCreator && isWaitingApproval\" variant=\"info\" show> {{ t( \"This package is currently awaiting approval and will only be visible to you in the Bazaar until approval is completed.\" ) }} </b-alert> </template> <div v-if=\"loadedDOMPurify\" class=\"package-description\"> <b-carousel v-if=\"media.length\" v-model=\"mediaIdx\" :interval=\"carouselInterval\" :controls=\"media.length > 1\" :indicators=\"media.length > 1\" img-width=\"1024\" img-height=\"576\" :background=\"media.length > 1 ? 'black' : 'transparent'\" style=\"text-shadow: 1px 1px 2px #333\" > <!-- Text slides with image --> <b-carousel-slide v-for=\"screenshot in media\" :key=\"screenshot.url\" img-blank> <template #img> <!-- img-blank --> <img src=\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%221024%22%20height%3D%22576%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20%25%7Bw%7D%20%25%7Bh%7D%22%20preserveAspectRatio%3D%22none%22%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20style%3D%22fill%3Atransparent%3B%22%3E%3C%2Frect%3E%3C%2Fsvg%3E\" width=\"1024\" height=\"576\" class=\"img-fluid w-100 d-block\" /> <b-img v-if=\"['cover', 'screenshot', 'icon'].includes(screenshot.type)\" :src=\"screenshot.url\" fluid class=\"carousel-image-content\" ></b-img> <video v-else-if=\"screenshot.type === 'video' && screenshot.url.match(/(\.mp4|\.webm|\.ogg)$/i)\" class=\"carousel-image-content\" :loop=\"screenshot.loop\" :muted=\"screenshot.loop\" :autoplay=\"screenshot.loop\" > <source :src=\"screenshot.url\" /> </video> <video-embed v-else class=\"carousel-image-content\" :src=\"screenshot.url\"></video-embed> </template> </b-carousel-slide> </b-carousel> <!-- Description --> <div class=\"py-3\" style=\"overflow-y: hidden\"> <span v-html=\"sanitized_description\"></span> <loading-indicator v-if=\"!pkg.fullyLoaded\"></loading-indicator> </div> </div> </b-col> </b-row> </b-container>",
  beforeCreate() {
    Utils.loadCss({
      content: ".foundry-full-package-view .package-details { border: dashed rgba(0, 0, 0, 0.3) 1px; border-radius: 3px; } .foundry-full-package-view .package-details .detail-category { border-right: dotted black 1px; } .foundry-full-package-view .package-details .package-details-row .package-type { line-height: 30px; } .foundry-full-package-view .package-details .package-details-row .install-version { line-height: 38px; } .foundry-full-package-view .package-details .package-details-row:nth-child(even) { background: rgb(220, 220, 220, 0.3); } /* Need to move the carousel control away from youtube controls */ .foundry-full-package-view .carousel-control-prev, .foundry-full-package-view .carousel-control-next { margin-bottom: 75px; } .foundry-full-package-view .carousel-image-content { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: contain; } .package-header--controls .d-flex { justify-content: center; gap: 8px; } .package-header .creator-avatar { object-fit: contain; } .package-header .creator-name { font-weight: bold; } .package-header .package-creator-info { border: 3px outset; border-radius: 5px; font-size: 1.1rem; } .success-action { color: green; } .fail-action { color: red; } .foundry-full-package-view .patreon-tier { color: #f8523b; padding-left: 20px; font-style: italic; } .foundry-full-package-view .patreon-tier li.subscribed { color: green; } .foundry-full-package-view .patreon-conditions-info .card-header { border-radius: 0px; } .foundry-full-package-view .patreon-conditions-info { border-width: 3px; border-radius: 3px; }"
    });
  },
  props: {
    package: Object,
    canInstall: Boolean,
    coreVersion: String,
    numericVersion: String,
    showCreatorAlerts: {
      type: Boolean,
      default: true
    },
    userIntegrations: Object,
    showCreatorLink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadedDOMPurify: false,
      mediaIdx: 0,
      lockIconHovered: false,
      keyDownHandler: null,
      extras: [{
        field: "readme",
        label: t("Read Me"),
        url: true
      }, {
        field: "notes",
        label: t("Changelog"),
        package: true,
        url: true
      }, {
        field: "license",
        label: t("License"),
        url: true
      }, {
        field: "bugs",
        label: t("Report issues"),
        url: true
      }, {
        field: "minimumCoreVersion",
        label: t("Minimum Core Version")
      }, {
        field: "compatibleCoreVersion",
        label: t("Compatible Core Version")
      }, {
        field: "maximumCoreVersion",
        label: t("Maximum Core Version")
      }],
      avatarImageData: {
        blankColor: "#fff",
        width: 60,
        height: 60,
        class: "creator-avatar"
      },
      serverTags: [],
      packagesData: null,
      loadingRequiredPackages: true,
      loadingRecommendedPackages: true
    };
  },
  watch: {
    async requiredPackages(newValue) {
      if (newValue.length !== 0) {
        await this.getPackagesData(this.requiredPackages, "required");
      }
    },
    async recommendedPackages(newValue) {
      if (newValue.length !== 0) {
        await this.getPackagesData(this.recommendedPackages, "recommended");
      }
    }
  },
  computed: {
    pkg() {
      return this.package || {};
    },
    compatibility() {
      return this.package.compatibility?.[this.packageVersionForCompatibility];
    },
    packageVersionForCompatibility() {
      return this.package.installed || this.package.versionToInstall;
    },
    name() {
      return this.package.name;
    },
    description() {
      return this.package.description_full || this.package.description || this.package.short_description;
    },
    short_description() {
      return this.package.short_description || this.package.description;
    },
    sanitized_description() {
      return DOMPurify.sanitize(this.description);
    },
    sanitized_short_description() {
      return DOMPurify.sanitize(this.short_description);
    },
    ready() {
      return this.package.marketplace && this.package.marketplace.ready;
    },
    isWaitingApproval() {
      return this.ready && !this.package.available;
    },
    categories() {
      return Object.entries(this.package.tags || {}).map(([key, label]) => {
        return {
          key,
          label
        };
      });
    },
    requiredPackages() {
      let packages = [];
      if (this.package.fullyLoaded && this.package.manifest && this.package.manifest.relationships) {
        if (typeof this.package.manifest.relationships.requires === "object") {
          packages = [].concat(this.package.manifest.relationships.requires);
        }
        if ((this.package.manifest.relationships.requires || []).length > 0) {
          packages = this.package.manifest.relationships.requires.filter(r => !!r);
        }
      }
      return packages;
    },
    recommendedPackages() {
      let packages = [];
      if (this.package.fullyLoaded && this.package.manifest && this.package.manifest.relationships) {
        if (typeof this.package.manifest.relationships.recommends === "object") {
          packages = [].concat(this.package.manifest.relationships.recommends);
        }
        if ((this.package.manifest.relationships.recommends || []).length > 0) {
          packages = this.package.manifest.relationships.recommends.filter(r => !!r);
        }
      }
      return packages;
    },
    authors() {
      if (this.package.fullyLoaded && this.package.manifest && (this.package.manifest.authors || []).length > 0) {
        return this.package.manifest.authors;
      }
      if (!this.package.authors) {
        return [];
      }
      return this.package.authors.map(name => ({
        name
      }));
    },
    url() {
      return this.package.url;
    },
    title() {
      return this.package.title;
    },
    version() {
      return this.package.installed || this.package.latest;
    },
    updatedAt() {
      if (this.package.updated) {
        return new Date(this.package.updated).toDateString();
      }
      return t("Unknown");
    },
    createdAt() {
      if (this.package.created) {
        return new Date(this.package.created).toDateString();
      }
      return t("Unknown");
    },
    premium() {
      return !!this.package.premium;
    },
    hasPatreon() {
      if (!this.package.patreon) {
        return false;
      }
      return this.package.patreon.creator && this.package.patreon.tiers && this.package.patreon.tiers.length;
    },
    price() {
      return this.payMore ? this.package.pwywMinimum : this.package.price;
    },
    payMore() {
      return this.package.pwywMinimum > 0;
    },
    // protected is a reserved word, so eslint complains even if it actually works
    protectedPackage() {
      return this.package.premium === "protected";
    },
    marketplace() {
      return this.package.premium === "marketplace";
    },
    isGiftCard() {
      return this.package.type === "forge-gift-card";
    },
    isEntitled() {
      return this.package.entitled;
    },
    isPurchased() {
      return this.package.purchased;
    },
    isApproved() {
      return !this.package.marketplace || this.package.available;
    },
    image() {
      return this.getMedia(PACKAGE_MEDIA_TYPES.COVER, "width=250") || this.defaultImage;
    },
    defaultImage() {
      switch (this.package.type) {
        case "world":
          return "/images/bazaar/world-cover.png";
        case "system":
          return "/images/bazaar/system-cover.png";
        case "module":
          return "/images/bazaar/module-cover.png";
        case "asset":
          return "/images/bazaar/asset-cover.png";
        default:
          return "/images/bazaar.png";
      }
    },
    languages() {
      return this.package.languages || [];
    },
    translated() {
      return this.languages.length > 0;
    },
    systems() {
      return this.package.systems || [];
    },
    media() {
      const media = (this.package.media || []).filter(m => Object.values(PACKAGE_MEDIA_TYPES).includes(m.type))
      // Always show cover first
      .sort((a, b) => {
        if (a.type === PACKAGE_MEDIA_TYPES.COVER) {
          return -1;
        }
        if (b.type === PACKAGE_MEDIA_TYPES.COVER) {
          return 1;
        }
        return 0;
      })
      // Don't put duplicate images
      .reduce((media, current) => {
        if (!media.find(m => m.url === current.url)) {
          media.push(current);
        }
        return media;
      }, []).map(m => m.type === PACKAGE_MEDIA_TYPES.VIDEO ? {
        ...m,
        autoplay: true,
        loop: true
      } : m);
      // If there is a cover image, do not display the icon image
      if (media.some(m => m.type === PACKAGE_MEDIA_TYPES.COVER)) {
        return media.filter(m => m.type !== PACKAGE_MEDIA_TYPES.ICON);
      }
      return media;
    },
    carouselInterval() {
      const media = this.media[this.mediaIdx];
      if (media && media.type === PACKAGE_MEDIA_TYPES.VIDEO) {
        return 0;
      }
      return 5000;
    },
    showPackageLocked() {
      const show = this.package.locked;
      return this.lockIconHovered ? !show : show;
    },
    availableVersions() {
      const versions = this.package.versions.map(v => {
        let versionLabel = "";
        if (this.package.latest === v) {
          versionLabel = ` (${t("Latest")})`;
        } else if (this.package.installed === v) {
          versionLabel = ` (${t("Installed")})`;
        }
        return {
          value: v,
          text: v + versionLabel
        };
      });
      return versions;
    },
    hasVersions() {
      return this.package.versions.length > 1;
    },
    isInstalled() {
      return this.package.installed;
    },
    standaloneLink() {
      return `/bazaar/package/${this.package.name}`;
    },
    creatorPackageLink() {
      return `/account/creator#packages=${this.package.name}`;
    },
    moreFromCreatorLink() {
      return `/creator/${this.pkg.creator.vanity}`;
    },
    hasCreator() {
      return this.package.creator && this.package.creator.vanity;
    },
    creatorPicture() {
      return this.package.creator && this.package.creator.picture;
    },
    userHasLinkedPatreon() {
      return this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon.linked;
    },
    minForgeTier() {
      // Default to 3 (story teller)
      if (!this.package || !this.package.patreon || this.package.patreon.minimumForgeTier === undefined) {
        return 3;
      }
      return this.package.patreon.minimumForgeTier;
    },
    minForgeTierCode() {
      return {
        2: "game-master",
        3: "story-teller",
        4: "world-builder"
      }[this.minForgeTier] || "";
    },
    userHasForgeTier() {
      return this.userIntegrations && this.userIntegrations.tier >= this.minForgeTier;
    },
    patreonCreator() {
      return this.package && this.package.patreon && this.package.patreon.creator;
    },
    tagList() {
      // t(`BAZAAR_TAG.${tag}`, label || tag);
      // remove this method and replace tags with the above code
      // when rendering
      return this.package.bazaarTags !== undefined ? this.package.bazaarTags.map(tag => {
        // Check to see that the tag key appears in the list of tags from the database
        const availableTag = this.serverTags.find(t => t.tag === tag);
        if (availableTag) {
          return {
            label: availableTag.label,
            key: availableTag.tag
          };
        }
        return {
          label: tag,
          key: tag
        };
      }).sort((a, b) => a.label.localeCompare(b.label)) : [];
    }
  },
  methods: {
    defaultIcon(packageType) {
      const type = packageType || this.package.type;
      switch (type) {
        case "world":
          return "/images/bazaar/world-icon-32.png";
        case "system":
          return "/images/bazaar/system-icon-32.png";
        case "module":
          return "/images/bazaar/module-icon-32.png";
        case "asset":
          return "/images/bazaar/asset-icon-32.png";
        default:
          return "/images/bazaar.png";
      }
    },
    close() {
      this.package.versionToInstall = this.package.latest;
      this.$emit("close");
    },
    getMedia(type, thumbnailParams) {
      if (!this.package) {
        return;
      }
      const media = this.package.media.find(m => m.type === type);
      if (media && media.url) {
        return thumbnailParams && media.url.startsWith("https://assets.forge-vtt.com") ? `${media.url}?${thumbnailParams}` : media.url;
      }
    },
    extraValue(extra) {
      let value = extra.package ? this.package[extra.field] : this.package.manifest[extra.field];
      if (!value && extra.field === "minimumCoreVersion" && this.package.manifest.compatibility) {
        value = this.package.manifest.compatibility.minimum;
      }
      if (!value && extra.field === "compatibleCoreVersion" && this.package.manifest.compatibility) {
        value = this.package.manifest.compatibility.verified;
      }
      if (!value && extra.field === "maximumCoreVersion" && this.package.manifest.compatibility) {
        value = this.package.manifest.compatibility.maximum;
      }
      if (extra.url && value && !value.match(/^https?:\/\//)) {
        const relativePath = value.replace(/^.\//, "").replace(/\/+/, "/").replace(/^\//, "");
        return `https://assets.forge-vtt.com/bazaar/${this.package.type}/${this.package.manifest.version}/${relativePath}`;
      }
      return value;
    },
    getAuthorProperty(author, key) {
      if (!author || !key) {
        return;
      }
      // support array for common misspellings or variants of key
      if (Array.isArray(key)) {
        for (const k of key) {
          const authorProperty = this.getAuthorProperty(author, k);
          if (authorProperty) {
            return authorProperty;
          }
        }
      } else {
        const authorFlags = author.flags || {};
        let property = Object.keys(authorFlags).find(prop => prop && prop.toLowerCase() === key.toLowerCase());
        if (property) {
          return authorFlags[property];
        }
        property = Object.keys(author).find(prop => prop && prop.toLowerCase() === key.toLowerCase());
        return author[property];
      }
    },
    // Handle cases where a full URL was added to manifest
    authorURL(prefix, path = "") {
      // Make sure that path is a string, to prevent errors when a non-string is supplied
      path = "" + path;
      if (path.startsWith(prefix)) {
        return path;
      }
      return prefix + path;
    },
    authorKofi(author) {
      return this.getAuthorProperty(author, ["ko-fi", "kofi", "ko_fi"]);
    },
    togglePackageLock() {
      this.$emit("toggle-lock", this.package);
      this.lockIconHovered = false;
    },
    installPackage(pkg) {
      this.$emit("install", pkg);
    },
    setupPatreon(ev) {
      if (!this.userHasLinkedPatreon) {
        // Go to the profile page, patreon tab
        window.location = "/account#patreon";
      } else if (!this.userHasForgeTier) {
        // Go to the profile page, and launch subscription manager
        window.location = `/account#membership&subscribe=${this.minForgeTierCode}`;
      }
    },
    subscribePatreon() {
      // Open the patreon link for the creator
      window.open(`/account/redirect/patreon/${this.patreonCreator}`, "_blank");
      // TODO: open patreon in a pop up window or iframe, and listen for when the tab is closed before doing a refresh pledges via API
      // See #987 - https://github.com/ForgeVTT/theforge/issues/987
      // window.location = "/account#patreon";
    },

    async getPackagesData(packages, dependencyType) {
      if (packages.length > 0) {
        const packageIds = packages.map(p => p.id);
        const response = await Utils.api(`bazaar/packages?names=${packageIds.join(",")}`);
        if (response.success && response.packages) {
          this.packagesData = {
            ...this.packagesData,
            ...response.packages
          };
          for (const pkg of Object.keys(this.packagesData)) {
            const pkgData = this.packagesData[pkg];
            if (pkgData && this.numericVersion) {
              // checking package compatibility
              const minimumVersion = pkgData.compatibility && pkgData.compatibility.minimum || pkgData.minimumCoreVersion;
              let minimumVersionCompatible = true;
              let maximumVersionCompatible = true;
              const maximumVersion = pkgData.compatibility && pkgData.compatibility.maximum || pkgData.maximumCoreVersion;
              if (minimumVersion) {
                minimumVersionCompatible = Utils.compareFoundryVersions(this.numericVersion, minimumVersion) >= 0;
              }
              if (maximumVersion) {
                maximumVersionCompatible = Utils.compareFoundryVersions(this.numericVersion, maximumVersion, true) <= 0;
              }
              this.packagesData[pkg].compatible = minimumVersionCompatible && maximumVersionCompatible;
            } else {
              this.packagesData[pkg].compatible = true;
            }
          }
        }
        if (dependencyType === "required") {
          this.loadingRequiredPackages = false;
        } else if (dependencyType === "recommended") {
          this.loadingRecommendedPackages = false;
        }
      }
    },
    authorSearch(author) {
      this.$emit("add-tag", `author:"${author}"`);
    },
    bazaarSearch(key, value) {
      this.$emit("add-tag", `${key}:${value}`);
    },
    async getTagData() {
      const tagsResponse = await Utils.api("bazaar/tags");
      if (tagsResponse.success) {
        this.serverTags = tagsResponse.tags;
        localStorage.setItem("bazaarTags", JSON.stringify(tagsResponse.tags));
      }
    }
  },
  async created() {
    await Utils.loadDependencies(["dompurify", "v-video-embed"]);
    this.loadedDOMPurify = true;
    this.serverTags = localStorage.getItem("bazaarTags");
    if (this.serverTags) {
      // If there's a value there then try and parse it
      try {
        this.serverTags = JSON.parse(this.serverTags);
      } catch (e) {
        this.serverTags = [];
      }
    }
    if (!this.serverTags.length) {
      // We don't have the data yet, so wait for it
      await this.getTagData();
    } else {
      // We have the data, but we want to update it in the background
      this.getTagData();
    }
    await this.getPackagesData(this.requiredPackages, "required");
    await this.getPackagesData(this.recommendedPackages, "recommended");
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarFullPackageModal"] = Vue.component(
                    "BazaarFullPackageModal",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" center scrollable size=\"xl\" footer-class=\"d-none\" header-class=\"p-2\" body-class=\"p-1\" modal-class=\"full-package-modal\" @hidden=\"close\" > <template #modal-header=\"{ close }\"> <h1 class=\"mb-0 mt-1\" style=\"flex: 1\"><img :src=\"icon\" height=\"48\" /> {{ title }}</h1> <div> <b-dropdown v-if=\"showPopout\" right split variant=\"info\" class=\"popout-link\" @click=\"popoutLink\"> <template #button-content> {{ t(\"Pop Out!\") }} </template> <b-dropdown-item @click=\"copyToClipboard\"> {{ t(\"Copy to clipboard\") }} </b-dropdown-item> </b-dropdown> <b-button variant=\"danger\" class=\"m-2 close-button\" @click.prevent=\"close\"> &times; </b-button> </div> </template> <b-card class=\"p-2\" :class=\"`border-${border}`\" no-body> <bazaar-full-package :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" :core-version=\"coreVersion\" :numeric-version=\"numericVersion\" :show-creator-link=\"showCreatorLink\" :show-creator-alerts=\"showCreatorAlerts\" v-on=\"$listeners\" > </bazaar-full-package> </b-card> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".full-package-modal .modal-dialog { margin: 100px 80px 10px 80px; max-width: calc(100% - 160px); max-height: calc(100% - 110px); } .full-package-modal .modal-header { display: flex; align-items: center; } .full-package-modal .modal-header .close-button { font-size: 2rem; line-height: 1.5rem; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    package: Object,
    canInstall: Boolean,
    coreVersion: String,
    numericVersion: String,
    showCreatorAlerts: {
      type: Boolean,
      default: true
    },
    userIntegrations: Object,
    showCreatorLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value && !!this.package;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    pkg() {
      // if the package is not loaded, return an empty object
      // This is needed because the full package modal can still be shown while the package is null
      // And BazaarFullPackage is not set up to handle a null package
      return this.package || {
        title: "",
        type: "",
        versions: [],
        authors: [],
        languages: []
      };
    },
    title() {
      return this.pkg.title;
    },
    icon() {
      return this.getMedia(PACKAGE_MEDIA_TYPES.ICON, "height=32") || this.defaultIcon;
    },
    defaultIcon() {
      switch (this.pkg.type) {
        case "world":
          return "/images/bazaar/world-icon-32.png";
        case "system":
          return "/images/bazaar/system-icon-32.png";
        case "module":
          return "/images/bazaar/module-icon-32.png";
        case "asset":
          return "/images/bazaar/asset-icon-32.png";
        default:
          return "/images/bazaar.png";
      }
    },
    border() {
      switch (this.pkg.type) {
        case "module":
          return "primary";
        case "system":
          return "success";
        case "world":
          return "secondary";
        case "asset":
          return "danger";
        default:
          return "info";
      }
    },
    standaloneLink() {
      return `/bazaar/package/${this.package.name}`;
    },
    showPopout() {
      if (this.pkg.custom) {
        return this.pkg.premium === "marketplace";
      }
      return this.pkg.premium !== "dndbeyond";
    }
  },
  methods: {
    getMedia(type, thumbnailParams) {
      if (!this.pkg.media) {
        return;
      }
      const media = this.pkg.media.find(m => m.type === type);
      if (media && media.url) {
        return thumbnailParams && media.url.startsWith("https://assets.forge-vtt.com") ? `${media.url}?${thumbnailParams}` : media.url;
      }
    },
    popoutLink() {
      window.open(this.standaloneLink, "_blank");
    },
    copyToClipboard() {
      const url = new URL(this.standaloneLink, window.location.href);
      navigator.clipboard.writeText(url.href);
      UI.info(t(`Copied link {{- link}} to clipboard`, {
        link: url.href
      }));
    },
    onKeyDown(ev) {
      if (ev.code === "Escape") {
        this.visible = false;
      }
    },
    close() {
      this.visible = false;
      this.$emit("close");
    }
  },
  mounted() {
    this.keyDownHandler = this.onKeyDown.bind(this);
    window.addEventListener("keydown", this.keyDownHandler);
  },
  destroyed() {
    // with vue 3, it should be unmounted
    window.removeEventListener("keydown", this.keyDownHandler);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarInstallWorld"] = Vue.component(
                    "BazaarInstallWorld",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" title=\"Install World\" @hidden=\"visible = false\" @shown=\"dialogShown\"> <div v-if=\"loading\"> <loading-indicator></loading-indicator> </div> <div v-else> <i18n :path=\"t('Installing {0}')\" tag=\"p\"> <strong>'{{ pkg.title }}'</strong> </i18n> <b-form-group class=\"mt-3\" :label=\"t('Enter the folder name to install the world into:')\"> <b-form-input v-model=\"destinationName\" debounce=\"500\" :formatter=\"slugify\" :placeholder=\"pkg.name\" autofocus trim @keyup=\"inputKeyUp\" > </b-form-input> </b-form-group> <b-form-group class=\"mt-3\" :label=\"t(`Enter the new world's title:`)\"> <b-form-input v-model=\"title\" :placeholder=\"pkg.title\" trim @keyup=\"inputKeyUp\"></b-form-input> </b-form-group> <b-alert v-if=\"worldExists\" variant=\"danger\" show>{{ t(\"A world already exists with this folder name\") }}</b-alert> </div> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button variant=\"success\" :disabled=\"!validName || installing\" @click=\"installWorld\"> <loading-indicator v-if=\"installing\" tag=\"span\" small :label=\"t('Installing world…')\"> </loading-indicator> <span v-else>{{ t(\"Install World\") }}</span> </b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    package: Object
  },
  data() {
    return {
      loading: true,
      installing: false,
      destinationName: "",
      title: "",
      worlds: []
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    pkg() {
      return this.package;
    },
    slug() {
      return Utils.slugify(this.destinationName);
    },
    worldExists() {
      return !!this.worlds.find(m => m.name === this.slug);
    },
    validName() {
      return this.slug.length > 0 && !this.worldExists;
    }
  },
  methods: {
    async dialogShown() {
      this.destinationName = this.package.name;
      this.title = this.package.title;
      this.installing = false;
      this.loading = true;
      const response = await Utils.api(`data/worlds`);
      if (!(response instanceof Array)) {
        const error = response && response.error || "";
        UI.alert("danger", t("ERROR.ErrorRetrievingData", {
          error
        }));
      } else {
        this.worlds = response;
      }
      if (this.worldExists) {
        this.destinationName = "";
      }
      this.loading = false;
    },
    slugify(input) {
      return Utils.slugify(input);
    },
    async installWorld() {
      if (!this.validName || this.installing) {
        return;
      }
      this.installing = true;
      const response = await Utils.api("data/worlds/install", {
        name: this.package.name,
        destination: this.destinationName,
        title: this.title || this.package.title
      });
      if (response.error) {
        UI.alert("danger", t(`Error installing world: {{- error}}`, {
          error: response.error
        }), true, 10000);
      } else {
        UI.alert("success", t(`World installed successfully`), true, 10000);
      }
      this.$emit("installed", response);
      this.installing = false;
      this.visible = false;
    },
    inputKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.installWorld();
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarListGroup"] = Vue.component(
                    "BazaarListGroup",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <div class=\"font-weight-bold border-bottom border-left w-100 mt-2 mb-3 px-2 py-1 bg-secondary text-white small rounded\" > {{ label }} </div> <b-skeleton-wrapper :loading=\"loading\"> <template #loading> <div class=\"bazaar-list-group-skeleton\"> <div v-for=\"n in 30\" :key=\"n\" class=\"bazaar-list-group-skeleton__card\"> <b-skeleton class=\"bazaar-list-group-skeleton__header\" width=\"100%\" /> <div class=\"bazaar-list-group-skeleton__content\"> <div class=\"bazaar-list-group-skeleton__metadata\"> <b-skeleton class=\"bazaar-list-group-skeleton__platform\" width=\"55%\" /> <b-skeleton class=\"bazaar-list-group-skeleton__compatibility\" width=\"8%\" /> </div> <b-skeleton class=\"bazaar-list-group-skeleton__title\" width=\"89%\" /> <b-skeleton class=\"bazaar-list-group-skeleton__author\" width=\"34%\" /> </div> <div class=\"bazaar-list-group-skeleton__footer\"> <b-skeleton class=\"bazaar-list-group-skeleton__price\" width=\"21%\" /> <b-skeleton class=\"bazaar-list-group-skeleton__button\" width=\"13%\" /> </div> </div> </div> </template> <package-list :packages=\"packages\" :can-install=\"canInstall\" :can-select=\"canSelect\" :user-integrations=\"userIntegrations\" v-on=\"$listeners\" ></package-list> </b-skeleton-wrapper> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-list-group-skeleton{display:grid;grid-template-columns:repeat(auto-fit, minmax(25ch, 1fr));width:100%;gap:1em}.bazaar-list-group-skeleton::after{content:\"\";width:0;padding-left:calc(100% - 1em);grid-column:1/-1}.bazaar-list-group-skeleton__card{background-color:var(--color-card-bg);font-size:var(--font-size-base);border-radius:.4em;max-width:100%;display:flex;flex-direction:column;gap:.5em}.bazaar-list-group-skeleton__header{aspect-ratio:1;width:100%;height:100%;border-radius:.4em .4em 0 0}.bazaar-list-group-skeleton__content{padding:0 .5em}.bazaar-list-group-skeleton__metadata{display:flex;justify-content:space-between;margin-bottom:.5em}.bazaar-list-group-skeleton__platform,.bazaar-list-group-skeleton__compatibility{height:18px}.bazaar-list-group-skeleton__title{height:22px;margin-bottom:.5em}.bazaar-list-group-skeleton__author{height:16px}.bazaar-list-group-skeleton__footer{display:flex;justify-content:space-between;padding:.25em .5em .5em}.bazaar-list-group-skeleton__price,.bazaar-list-group-skeleton__button{height:32px}"
    });
  },
  props: {
    label: {
      type: String,
      default: null
    },
    loading: Boolean,
    canInstall: Boolean,
    canSelect: Boolean,
    userIntegrations: {
      type: Object,
      default: () => {
        return {};
      }
    },
    packages: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarManifestInstaller"] = Vue.component(
                    "BazaarManifestInstaller",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"md\" :no-close-on-backdrop=\"processing\" :no-close-on-esc=\"processing\" :hide-header-close=\"processing\" :title=\"t('Install Package from Manifest URL')\" @hidden=\"visible = false\" > <b-form-group :label=\"t('Enter the Manifest URL of the package to install')\"> <b-form-input id=\"manifest-install-url\" v-model=\"manifestURL\" :readonly=\"processing\" autofocus trim placeholder=\"https://example.com/module.json\" @keyup=\"queryKeyUp\" > </b-form-input> </b-form-group> <b-form-group inline label-cols=\"10\" :label=\"t('Install from the Bazaar if the package is found')\" label-for=\"option-use-bazaar\" > <!-- Container div to fix vertical alignment --> <div class=\"h-100 d-flex flex-wrap align-content-center\"> <b-form-checkbox id=\"option-use-bazaar\" v-model=\"useBazaar\" :disabled=\"processing\" switch></b-form-checkbox> </div> </b-form-group> <loading-indicator v-if=\"processing && importStatus\" tag=\"h6\" small :label=\"importStatus\"></loading-indicator> <h6 v-if=\"!processing && importStatus\" class=\"text-center\">{{ importStatus }}</h6> <template #modal-footer=\"{ cancel }\"> <b-button v-show=\"!importStatus\" variant=\"secondary\" :disabled=\"processing\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button v-show=\"importStatus\" variant=\"secondary\" :disabled=\"processing\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> <b-button v-if=\"processing\" variant=\"secondary\" :disabled=\"true\"> <loading-indicator tag=\"span\" small :label=\"t('Installing…')\"> </loading-indicator> </b-button> <b-button v-else-if=\"importStatus\" variant=\"info\" @click=\"resetModal\"> <i18n :path=\"t('Install another {{packageType}}', { packageType })\"></i18n> </b-button> <b-button v-else variant=\"success\" :disabled=\"!validURL\" @click=\"install\"> <i18n :path=\"t('Install {{packageType}}', { packageType })\"></i18n> </b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ""
    });
  },
  props: {
    value: Boolean,
    type: String,
    processing: Boolean,
    importStatus: String
  },
  data() {
    return {
      manifestURL: "",
      useBazaar: true
    };
  },
  watch: {
    processing(value) {
      // Reset on success
      if (!value && this.importStatus) {
        this.manifestURL = "";
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        if (!value) {
          // Cleanup when closing
          this.manifestURL = "";
          this.useBazaar = true;
          this.$emit("closed", value);
        }
      }
    },
    realType() {
      const [path, hash] = this.manifestURL.split("?");
      // Create regex to match module, system, or world
      // [^/]* will not match a forward slash, so the match will be in the last part of the URL path before .json
      const moduleRegex = /module[^/]*\.json$/;
      const systemRegex = /system[^/]*\.json$/;
      const worldRegex = /world[^/]*\.json$/;
      if (moduleRegex.test(path)) {
        return "module";
      }
      if (systemRegex.test(path)) {
        return "system";
      }
      if (worldRegex.test(path)) {
        return "world";
      }
      // Fallback to hash if it exists and the type cannot be determined from the URL
      // e.g. https://example.com/unknown.json?type=module
      if (hash) {
        if (hash.includes("module")) {
          return "module";
        }
        if (hash.includes("system")) {
          return "system";
        }
        if (hash.includes("world")) {
          return "world";
        }
      }
      return this.type;
    },
    packageType() {
      return Utils.capitalize(this.realType);
    },
    validURL() {
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(this.manifestURL);
    }
  },
  methods: {
    install() {
      if (!this.validURL) {
        return;
      }
      const finalURL = Bazaar.getPackageManifestUrl(this.manifestURL, this.useBazaar);
      this.$emit("install", {
        type: this.realType,
        manifest: finalURL
      });
    },
    queryKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.install();
      }
    },
    resetModal() {
      this.$emit("closed");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackage"] = Vue.component(
                    "BazaarPackage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card ref=\"card\" class=\"m-2 foundry-package\" :class=\"`border-${border} foundry-package-${pkg.type} ${canSelect ? 'foundry-package-selectable' : ''} ${ noFooter ? 'foundry-package-nofooter' : '' }`\" no-body @mouseover=\"mouseOver\" @mouseleave=\"mouseLeave\" > <div v-if=\"onSale\" class=\"sale-ribbon\"> <span>{{ t(\"Sale!\") }}</span> </div> <div v-if=\"showStatus\" class=\"status-indicator\"> <package-status-indicator :package=\"pkg\"></package-status-indicator> </div> <div class=\"cover-image-wrapper\" @click.prevent=\"clicked\"> <img :src=\"image\" :alt=\"name\" class=\"cover-image\" @error=\"errorLoadingImage\" /> <bazaar-compatibility-badge v-if=\"compatibility\" v-bind=\"compatibility\" :core-version=\"coreVersion\" ></bazaar-compatibility-badge> </div> <div class=\"package-name-container\"> <!-- Create a card here so the transparent card header with absolute positioning doesn't show the the description bleeding through --> <b-card no-body> <b-card-header class=\"p-2 package-name package-name-truncated\"> <strong>{{ title }}</strong> <small v-if=\"authors.length\"> &nbsp;{{ t(\"by\") }}&nbsp; <span v-for=\"(author, index) of authors\" :key=\"author\"> <a href=\"#\" class=\"rounded-pill pl-1 author-name\" @click.prevent=\"tagAuthor(author)\">{{ author }}</a ><span v-if=\"index != authors.length - 1\">, </span> </span> </small> </b-card-header> </b-card> </div> <b-card-body v-if=\"loadedDOMPurify\" ref=\"body\" class=\"package-short-description\" :class=\"`bg-${bgVariant} text-${textVariant}`\" @click=\"clicked\" > <span v-html=\"sanitized_short_description\"></span> </b-card-body> <b-card-footer v-if=\"!noFooter && hasPatreon && !isPurchased && !isInstalled\" class=\"p-1 patreon-footer\"> <slot name=\"footer\"> <div class=\"d-flex flex-row justify-content-around align-items-center\"> <img src=\"/images/social/patreon.png\" class=\"patreon-icon\" width=\"20px\" height=\"20px\" /> {{ t(\"Patreon\") }} <help-icon :id=\"`patreon-footer-help-${pkg.id}`\" :html=\"true\"></help-icon> <b-tooltip :target=\"`patreon-footer-help-${pkg.id}`\" trigger=\"hover\" custom-class=\"wide-tooltip\"> <bazaar-package-patreon-info class=\"package-patreon-tooltip\" :package=\"pkg\" :user-integrations=\"userIntegrations\" ></bazaar-package-patreon-info> </b-tooltip> <bazaar-package-patreon-button v-if=\"!isPurchased && patreonTierCount\" :full-view=\"false\" :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" @setup=\"setupPatreon\" @subscribe=\"subscribePatreon\" @install=\"$emit('install', $event)\" > </bazaar-package-patreon-button> </div> </slot> </b-card-footer> <b-card-footer v-if=\"!noFooter\" class=\"p-1 package-footer\"> <slot name=\"footer\"> <div class=\"d-flex flex-row justify-content-around align-items-center\"> <a v-if=\"url\" v-b-tooltip.hover :href=\"url\" target=\"_blank\" class=\"text-body\" :title=\"t('Project website')\"> <i class=\"fas fa-external-link-alt\"></i> </a> <a v-if=\"translated\" ref=\"languages\" href=\"#\" class=\"text-body\" @click.prevent> <i class=\"fas fa-globe-americas\"></i> </a> <b-popover v-if=\"translated\" :target=\"() => $refs.languages\" triggers=\"hover\"> <template #title>{{ t(\"BAZAAR.PackageTranslationsAvailable\", { count: languages.length }) }}</template> <div class=\"foundry-package-popover\"> <span v-for=\"(lang, index) of languages\" :key=\"lang.lang\"> <a href=\"#\" class=\"border border-secondary rounded-pill px-1 language-name\" @click.prevent=\"tagLanguage(lang.lang)\" >{{ lang.name || lang.lang }}</a > <span v-if=\"index != languages.length - 1\">, </span> </span> </div> </b-popover> <a v-if=\"pkg.type === 'system'\" v-b-tooltip.hover href=\"#\" class=\"text-body\" :title=\"t('Search for compatible modules')\" @click.prevent=\"searchSystem(name)\" > <i class=\"fas fa-search\"></i> </a> <a v-else-if=\"systems\" ref=\"systems\" href=\"#\" class=\"text-body\" @click.prevent> <i class=\"fas fa-book\"></i> </a> <b-popover v-if=\"pkg.systems\" :target=\"() => $refs.systems\" triggers=\"hover\"> <template #title>{{ t(\"BAZAAR.PackageCompatibleSystems\", { count: systems.length }) }}</template> <div class=\"foundry-package-popover\"> <span v-for=\"(system, index) of systems\" :key=\"system\"> <a href=\"#\" class=\"border border-secondary rounded-pill px-1 language-name\" @click.prevent=\"searchSystem(system)\" >{{ system }}</a > <span v-if=\"index != systems.length - 1\">, </span> </span> </div> </b-popover> <!-- Hide version to make room for sale information if needed --> <template v-if=\"onSale && !isInstalled && !isProcessing\"> <span class=\"pre-sale-price\">$ {{ pkg.preSalePrice.toFixed(2) }}</span> <span class=\"discount badge badge-pill badge-success\">-{{ salePercent }}%</span> </template> <span v-else class=\"package-version\">{{ version.slice(0, 8) }}</span> <bazaar-package-install-button :full-view=\"false\" :package=\"pkg\" :can-install=\"canInstall\" @install=\"$emit('install', $event)\" @uninstall=\"$emit('uninstall', $event)\" @check-update=\"$emit('check-update', $event)\" @purchase=\"$emit('purchase', $event)\" @ddb-installed=\"$emit('ddb-installed', $event)\" > </bazaar-package-install-button> </div> </slot> </b-card-footer> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".foundry-package { width: 270px; max-width: 270px; height: 450px; max-height: 450px; } .foundry-package-asset { height: 450px; max-height: 450px; } .foundry-package-dndbeyond { height: 500px; max-height: 500px; } .foundry-package.foundry-package-nofooter { width: 270px; max-width: 270px; height: 350px; max-height: 350px; } .foundry-package .cover-image { object-fit: cover; width: 100%; height: 135px; max-height: 135px; } .foundry-package .cover-image-wrapper { position: relative; z-index: 0; } .foundry-package .cover-image-wrapper .bazaar-compatibility-badge { position: absolute; bottom: 4px; left: 4px; } /* Larger for gift cards */ .foundry-package.foundry-package-forge-gift-card { width: 270px; max-width: 270px; height: 450px; max-height: 450px; } .foundry-package.foundry-package-forge-gift-card.foundry-package-nofooter { width: 270px; max-width: 270px; height: 400px; max-height: 400px; } .foundry-package .sale-ribbon { position: absolute; overflow: hidden; top: 0; left: 0; width: 100px; height: 100px; z-index: 1; } .foundry-package .sale-ribbon span { position: absolute; display: block; color: white; background-color: red; box-shadow: 0 5px 10px rgb(0 0 0 / 10%); text-shadow: 1px 1px black; transform: rotate(-45deg); width: 100px; top: 10px; left: -30px; text-align: center; } .foundry-package .status-indicator { position: absolute; top: 0; right: 10px; font-size: 32px; } /* Square cover image for DNDB and asset packs */ .foundry-package.foundry-package-dndbeyond .cover-image { object-position: top; height: 270px; max-height: 270px; } .foundry-package.foundry-package-asset .cover-image { object-position: center; object-fit: contain; height: 270px; max-height: 270px; } .foundry-package-popover .language-name { white-space: nowrap; } .foundry-package .package-name-container { position: relative; height: 2.5em; } .foundry-package .package-name-container > .card { position: absolute; width: 100%; z-index: 1; } .foundry-package .package-name-truncated { /*height: 40px;*/ overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .foundry-package .package-name-truncated:hover { overflow: hidden; text-overflow: unset; white-space: unset; max-height: 270px; } .foundry-package .package-footer .package-version { max-width: 85px; /* text-truncate */ overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .foundry-package .package-footer .pre-sale-price { text-decoration: line-through; } .foundry-package .package-footer .discount { font-size: 1em; } .foundry-package .package-short-description { overflow: hidden; height: 150px; position: relative; /* For the transparency layer at the bottom of the text */ -webkit-mask-image: linear-gradient(rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0)); mask-image: linear-gradient(rgba(0, 0, 0, 1) 70%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0)); } .foundry-package-selectable .package-short-description, .foundry-package-selectable .cover-image { cursor: pointer; } .foundry-package .package-footer { height: 40px; max-height: 40px; } .patreon-footer .patreon-icon { width: 20px; height: 20px; } .wide-tooltip .tooltip-inner { max-width: 500px; text-align: left; } .success-action { color: green; } .fail-action { color: red; } .patreon-tier { color: #f8523b; padding-left: 60px; font-style: italic; } .patreon-tier li.subscribed { color: #3bf86a; } .package-patreon-tooltip a { text-decoration: underline dotted; }"
    });
  },
  props: {
    package: Object,
    canInstall: Boolean,
    canSelect: Boolean,
    noFooter: Boolean,
    userIntegrations: Object,
    allowStatusIndicator: {
      type: Boolean,
      default: true
    },
    coreVersion: String
  },
  data() {
    return {
      loadedDOMPurify: false,
      hover: false
    };
  },
  computed: {
    border() {
      switch (this.package.type) {
        case "module":
          return "primary";
        case "system":
          return "success";
        case "world":
          return "secondary";
        case "asset":
          return "danger";
        default:
          return "info";
      }
    },
    pkg() {
      return this.package;
    },
    compatibility() {
      return this.package.compatibility?.[this.packageVersionForCompatibility];
    },
    packageVersionForCompatibility() {
      return this.package.installed || this.package.versionToInstall;
    },
    name() {
      return this.package.name;
    },
    description() {
      return this.package.description || this.package.short_description;
    },
    short_description() {
      return this.package.short_description || this.package.description;
    },
    sanitized_description() {
      return DOMPurify.sanitize(this.description);
    },
    sanitized_short_description() {
      return DOMPurify.sanitize(this.short_description);
    },
    authors() {
      return this.package.authors || [];
    },
    url() {
      return this.package.url;
    },
    title() {
      return this.package.title;
    },
    version() {
      return this.package.installed || this.package.latest;
    },
    image() {
      const media = this.package && this.package.media || [];
      const bg = media.find(m => m.type === PACKAGE_MEDIA_TYPES.COVER);
      if (bg && bg.url) {
        return bg.url.startsWith("https://assets.forge-vtt.com") ? `${bg.url}?width=500` : bg.url;
      }
      return this.defaultImage;
    },
    defaultImage() {
      switch (this.package.type) {
        case "world":
          return "/images/bazaar/world-cover.png";
        case "system":
          return "/images/bazaar/system-cover.png";
        case "module":
          return "/images/bazaar/module-cover.png";
        case "asset":
          return "/images/bazaar/asset-cover.png";
        default:
          return "/images/bazaar.png";
      }
    },
    languages() {
      return this.package.languages || [];
    },
    translated() {
      return this.package.languages && this.package.languages.length > 0;
    },
    systems() {
      return this.package.systems || [];
    },
    bgVariant() {
      if (this.canSelect && this.hover) {
        return "dark";
      }
      return null;
    },
    textVariant() {
      if (this.canSelect && this.hover) {
        return "light";
      }
      return null;
    },
    onSale() {
      return this.package.preSalePrice && this.package.price < this.package.preSalePrice;
    },
    salePercent() {
      if (!this.onSale) {
        return 0;
      }
      return Math.round((1 - this.package.price / this.package.preSalePrice) * 100);
    },
    showStatus() {
      return this.allowStatusIndicator && this.package.isCreator && !this.package.available;
    },
    userHasLinkedPatreon() {
      return this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon.linked;
    },
    minForgeTier() {
      // Default to 3 (story teller)
      if (!this.package || !this.package.patreon || this.package.patreon.minimumForgeTier === undefined) {
        return 3;
      }
      return this.package.patreon.minimumForgeTier;
    },
    minForgeTierCode() {
      return {
        2: "game-master",
        3: "story-teller",
        4: "world-builder"
      }[this.minForgeTier] || "";
    },
    userHasForgeTier() {
      return this.userIntegrations && this.userIntegrations.tier >= this.minForgeTier;
    },
    patreonTierCount() {
      if (!this.package.patreon || !this.package.patreon.creator) {
        return 0;
      }
      return this.package.patreon.tiers.length;
    },
    patreonCreator() {
      return this.package && this.package.patreon && this.package.patreon.creator;
    },
    hasPatreon() {
      if (!this.package.patreon) {
        return false;
      }
      return this.package.patreon.creator && this.package.patreon.tiers && this.package.patreon.tiers.length;
    },
    isEntitled() {
      return this.package.entitled;
    },
    isPurchased() {
      return this.package.purchased;
    },
    isInstalled() {
      return this.package.installed;
    },
    isProcessing() {
      return this.package.processing;
    }
  },
  methods: {
    tagAuthor(author) {
      this.$emit("tag", `author:${author}`);
    },
    tagLanguage(lang) {
      this.$emit("tag", `language:${lang}`);
    },
    searchSystem(name) {
      this.$emit("tag", `system:${name}`);
    },
    clicked() {
      if (this.canSelect) {
        this.$emit("selected", this.package);
      }
    },
    mouseOver() {
      this.hover = true;
    },
    mouseLeave() {
      this.hover = false;
    },
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, this.defaultImage);
    },
    setupPatreon(ev) {
      if (!this.userHasLinkedPatreon) {
        // Go to the profile page, patreon tab
        window.location = "/account#patreon";
      } else if (!this.userHasForgeTier) {
        // Go to the profile page, and launch subscription manager
        window.location = `/account#membership&subscribe=${this.minForgeTierCode}`;
      }
    },
    subscribePatreon(ev) {
      // Open the patreon link for the creator
      window.open(`/account/redirect/patreon/${this.patreonCreator}`, "_blank");
      // TODO: open patreon in a pop up window or iframe, and listen for when the tab is closed before doing a refresh pledges via API
      // See #987 - https://github.com/ForgeVTT/theforge/issues/987
      // window.location = "/account#patreon";
    }
  },

  async created() {
    await Utils.loadDependencies(["dompurify"]);
    this.loadedDOMPurify = true;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageCard"] = Vue.component(
                    "BazaarPackageCard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* global PACKAGE_MEDIA_TYPES */
var _default = exports.default = {
  template: "<article v-if=\"pkg\" :id=\"pkg.id\" tabindex=\"0\" :class=\"['bazaar-package-card', `bazaar-package-card--${pkg.type || 'unset'}`]\" @click=\"onClick\" > <header class=\"bazaar-package-card__header\" :style=\"`--package-card-banner: url(${image})`\"> <div class=\"bazaar-package-card__banner\"> <img class=\"bazaar-package-card__banner__image\" :src=\"image\" alt=\"\" /> </div> <span v-if=\"isOnSale\" class=\"bazaar-package-card__sale-flag\">{{ t(\"Sale\") }}</span> </header> <div class=\"bazaar-package-card__content\"> <div class=\"bazaar-package-card__metadata\"> <span v-if=\"associatedPlatform\" :class=\"['bazaar-package-card__platform', `bazaar-package-card__platform--${associatedPlatform.type}`]\" > <img v-if=\"associatedPlatform.image\" :src=\"associatedPlatform.image\" /> <i v-else-if=\"associatedPlatform.icon\" :class=\"associatedPlatform.icon\" role=\"presentation\"></i> {{ associatedPlatform.label }} </span> <span class=\"bazaar-package-card__compatibility\"> <bazaar-compatibility-badge v-bind=\"compatibilityData\" :core-version=\"coreVersion\" ></bazaar-compatibility-badge> </span> </div> <h1 class=\"bazaar-package-card__title\">{{ pkg.title }}</h1> <span v-if=\"authorsString\" class=\"bazaar-package-card__author\">{{ authorsString }}</span> </div> <footer class=\"bazaar-package-card__footer\"> <template v-if=\"pkg.pwyw\"> <span v-if=\"pkg.pwywMinimum\" class=\"bazaar-package-card__price\"> <span class=\"bazaar-package-card__price__dollars\">${{ payWhatYouCanDollars }}</span> <span class=\"bazaar-package-card__price__cents\">{{ payWhatYouCanCents }}</span> + </span> <em v-else>{{ payWhatYouCanString }}</em> </template> <template v-else-if=\"!!priceString\"> <span v-if=\"salePercent\" class=\"bazaar-package-card__sale-price\"> <span class=\"bazaar-package-card__sale-price__percent\">-{{ salePercent }}%</span> <span class=\"bazaar-package-card__sale-price__prices\"> <span class=\"bazaar-package-card__price bazaar-package-card__price--reduced\"> <span class=\"bazaar-package-card__price__dollars\">${{ priceDollars }}</span> <span class=\"bazaar-package-card__price__cents\">{{ priceCents }}</span> </span> <span class=\"bazaar-package-card__price\"> <span class=\"bazaar-package-card__price__dollars\">${{ salePriceDollars }}</span> <span class=\"bazaar-package-card__price__cents\">{{ salePriceCents }}</span> </span> </span> </span> <span v-else class=\"bazaar-package-card__price\"> <span class=\"bazaar-package-card__price__dollars\">${{ priceDollars }}</span> <span class=\"bazaar-package-card__price__cents\">{{ priceCents }}</span> </span> </template> <bazaar-package-button class=\"bazaar-package-card__controls\" :pkg=\"pkg\" :can-install=\"canInstall\" :full-view=\"false\" :user-integrations=\"userIntegrations\" @install=\"$emit('install', $event)\" @uninstall=\"$emit('uninstall', $event)\" @check-update=\"$emit('check-update', $event)\" @purchase=\"$emit('purchase', $event)\" @ddb-installed=\"$emit('ddb-installed', $event)\" /> </footer> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-card{background-color:var(--color-card-bg);color:var(--color-body-color);font-family:\"Inter\",sans-serif;cursor:pointer;font-size:var(--font-size-base);border-radius:.4em;max-width:100%;overflow:clip;display:flex;flex-direction:column;gap:.5em;font-optical-sizing:auto;container-name:package-card;container-type:inline-size}.bazaar-package-card__header{position:relative;overflow:clip;background-image:var(--package-card-banner);background-position:center;background-size:cover;background-repeat:no-repeat}.bazaar-package-card__banner{overflow:clip;border-top-left-radius:.4em;border-top-right-radius:.4em;backdrop-filter:blur(9px) brightness(0.5) sepia(0.5);width:101%;height:101%}.bazaar-package-card__banner__image{width:100%;height:100%;object-fit:contain;aspect-ratio:1;transition:scale ease-in-out 333ms}:is(.bazaar-package-card:hover,.bazaar-package-card:focus-within) .bazaar-package-card__banner__image{scale:1.05}:is(.bazaar-package-card:focus-within){outline:1px solid var(--color-primary);box-shadow:0 0 0 .2rem color-mix(in srgb, var(--color-primary), transparent 50%)}.bazaar-package-card__sale-flag{position:absolute;top:0;left:0;padding:.625em 1.25em;background-color:var(--color-forge-green-dark);color:#fff;line-height:1em}.bazaar-package-card__content{max-width:100%;padding:0 .5em;margin-bottom:auto}.bazaar-package-card__metadata{display:flex;align-items:center;justify-content:space-between;margin-block-end:.5em}.bazaar-package-card__platform{font-size:.875em;font-weight:400;line-height:1;display:flex;align-items:center;gap:.5em}.bazaar-package-card__platform img{width:1.25em;height:1.25em}.bazaar-package-card__platform i{font-size:1.25em}.bazaar-package-card__platform--foundry i{color:#c9593f}.bazaar-package-card__platform--asset i{color:var(--color-forge-green)}.bazaar-package-card__platform--dndbeyond i{color:#e40712}.bazaar-package-card__title{font-family:inherit;font-size:1.25em;font-weight:700;line-height:1.1;color:var(--color-body-color);display:-webkit-box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.bazaar-package-card__author{font-family:inherit;font-size:.875em;font-weight:700;line-height:1.1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block;max-width:100%;opacity:.7}.bazaar-package-card__footer{display:flex;align-items:center;justify-content:space-between;padding:.25em .5em .5em}.bazaar-package-card__sale-price{background-color:var(--color-forge-green-dark);border-radius:.2em;overflow:clip;padding:0 0 .125em .5em;display:flex;flex-direction:row;align-items:stretch}.bazaar-package-card__sale-price__percent{color:var(--color-forge-gold);font-weight:600;font-size:1.25em}.bazaar-package-card__sale-price__prices{background-color:var(--color-gray-900);padding:0em .5em .125em .5em;margin:0 0 1px .5em;border-bottom-left-radius:.2em;color:var(--color-gray-500);display:flex;align-items:center;gap:.5em}.bazaar-package-card__sale-price__prices .bazaar-package-card__price{font-size:1em;line-height:1}.bazaar-package-card__sale-price__prices .bazaar-package-card__price:not(.bazaar-package-card__price--reduced){color:var(--color-forge-gold);font-size:1.25em}.bazaar-package-card__price{font-size:1.25em;font-weight:600;position:relative;display:flex}.bazaar-package-card__price--reduced:after{position:absolute;content:\"\";left:0;top:50%;right:0;height:2px;background-color:currentcolor;rotate:-12deg}.bazaar-package-card__price__cents{font-size:.75em;line-height:1;vertical-align:super;font-variant:all-small-caps}.bazaar-package-card__controls{margin-inline-start:auto}@container package-card (max-width: 310px){::v-deep .bazaar-package-patreon-button__label{display:none}}"
    });
  },
  props: {
    /** A Bazaar package. */
    package: {
      type: Object,
      default: null
    },
    /** The version of Foundry this package will be installed for. */
    coreVersion: {
      type: String || undefined,
      default: undefined
    },
    /** Can the user install this package? */
    canInstall: {
      type: Boolean,
      default: false
    },
    /** Can the user click on this package? */
    canSelect: Boolean,
    /** Per-user integration data, sourced from `GET /profile/integrations` */
    userIntegrations: {
      type: Object,
      default: null
    },
    /**
     * Should the card display information about this package's compatibility
     * with the user's active Foundry version?
     */
    allowStatusIndicator: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * @returns {string} The package's price as a string, if one exists;
     * otherwise, an empty string.
     */
    priceString() {
      if (!this.package?.price) {
        return "";
      }
      const formatter = new Intl.NumberFormat({
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(this.package?.preSalePrice || this.package?.price);
    },
    /**
     * @returns {string} The dollars portion of the package's price.
     */
    priceDollars() {
      return this.priceString.split(/[.,]/)[0];
    },
    /**
     * @returns {string} The cents portion of the package's price.
     */
    priceCents() {
      const str = this.priceString.split(/[.,]/)[1];
      if (!str) {
        return "00";
      }
      if (str.length === 1) {
        return `${str}0`;
      }
      return str;
    },
    /**
     * Whether or not the package is on sale.
     * @returns {boolean} Is the package on sale?
     */
    isOnSale() {
      return this.package.preSalePrice && this.package.price < this.package.preSalePrice;
    },
    /**
     * How much of a discount the sale price is, in percent.
     * @returns {number} The percent difference between the normal and sale price.
     */
    salePercent() {
      if (!this.isOnSale) {
        return 0;
      }
      return Math.round((1 - this.package.price / this.package.preSalePrice) * 100);
    },
    /**
     * @returns {string} The package's price as a string, if one exists;
     * otherwise, an empty string.
     */
    salePriceString() {
      if (!this.package?.price && !this.package?.preSalePrice) {
        return "";
      }
      const formatter = new Intl.NumberFormat({
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(this.package?.price);
    },
    /**
     * @returns {string} The dollars portion of the package's price.
     */
    salePriceDollars() {
      return this.salePriceString.split(/[.,]/)[0];
    },
    /**
     * @returns {string} The cents portion of the package's price.
     */
    salePriceCents() {
      const str = this.salePriceString.split(/[.,]/)[1];
      if (!str) {
        return "00";
      }
      if (str.length === 1) {
        return `${str}0`;
      }
      return str;
    },
    /**
     * @returns {string} The package's price as a string, if one exists;
     * otherwise, an empty string.
     */
    payWhatYouCanString() {
      if (!this.package?.pwyw) {
        return "";
      }
      if (!this.package.pwywMinimum) {
        return t("Pay what you can");
      }
      const formatter = new Intl.NumberFormat({
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(this.package?.pwywMinimum);
    },
    /**
     * @returns {string} The dollars portion of the package's price.
     */
    payWhatYouCanDollars() {
      if (!this.package.pwywMinimum) {
        return "";
      }
      return this.payWhatYouCanString.split(/[.,]/)[0];
    },
    /**
     * @returns {string} The cents portion of the package's price.
     */
    payWhatYouCanCents() {
      if (!this.package.pwywMinimum) {
        return "";
      }
      const str = this.payWhatYouCanString.split(/[.,]/)[1];
      if (!str) {
        return "00";
      }
      if (str.length === 1) {
        return `${str}0`;
      }
      return str;
    },
    /**
     * @returns {string} A comma separated list of the package's authors.
     */
    authorsString() {
      if (!this.package?.authors.length) {
        return "";
      }
      return this.package.authors.join(", ");
    },
    /**
     * Given a package and its associated media, return either the first cover image or the default image associated with the package's type.
     * @returns {string} The cover image to use for this package.
     */
    image() {
      const media = this.package?.media || [];
      const bg = media.find(m => m.type === PACKAGE_MEDIA_TYPES.COVER);
      if (bg && bg.url) {
        return bg.url.startsWith("https://assets.forge-vtt.com") ? `${bg.url}?width=500` : bg.url;
      }
      return this.defaultImage;
    },
    /**
     * Given the package's type, return a filepath to use if the package has
     * no cover image.
     * @returns {string} The default cover image for this type of package.
     */
    defaultImage() {
      switch (this.package.type) {
        case "world":
          return "/images/bazaar/world-cover.png";
        case "system":
          return "/images/bazaar/system-cover.png";
        case "module":
          return "/images/bazaar/module-cover.png";
        case "asset":
          return "/images/bazaar/asset-cover.png";
        default:
          return "/images/bazaar.png";
      }
    },
    /**
     * This computed aliases `package`, so we can use it in the template without
     * complaints over using the keyword "package"
     * @returns {object|null} The package object or null if not set.
     */
    pkg() {
      return this.package;
    },
    /**
     * Returns the compatibility data for the current package version, or a default incompatible status if not found.
     * @returns {object|null} The compatibility data object or null if not available.
     */
    compatibilityData() {
      return this.hasCompatibleVersions ? this.package.compatibility?.[this.packageVersionForCompatibility] : {
        status: Enums.PackageVersionCompatibilityStatus.INCOMPATIBLE
      };
    },
    hasCompatibleVersions() {
      return this.package?.versions.length > 0;
    },
    /**
     * The package version to use when determining compatibility.
     * @returns {string} The package version to compare
     */
    packageVersionForCompatibility() {
      return this.package.installed || this.package.versionToInstall;
    },
    /**
     * The package version that this card represents.
     * @returns {string} The version string.
     */
    version() {
      return this.package.installed || this.package.latest;
    },
    /**
     * Whether or not to indicate the package's availability status.
     * @returns {boolean} Should we show the status of the package?
     */
    showStatus() {
      return this.allowStatusIndicator && this.package.isCreator && !this.package.available;
    },
    /**
     * Whether or not the user has a linked Patreon account related to this
     * package.
     * @returns {boolean} Does the user have a linked Patreon account?
     */
    userHasLinkedPatreon() {
      return this.userIntegrations?.patreon?.linked;
    },
    /**
     * The minimum Forge subscription tier that can use this package.
     * @returns {number} The subscription tier.
     */
    minForgeTier() {
      // Default to 3 (story teller)
      if (!this.package || !this.package.patreon || this.package.patreon.minimumForgeTier === undefined) {
        return 3;
      }
      return this.package.patreon.minimumForgeTier;
    },
    /**
     * Map the minimum Forge subscription tier to a string-based code.
     * @returns {string} The Forge subscription tier code.
     */
    minForgeTierCode() {
      return {
        2: "game-master",
        3: "story-teller",
        4: "world-builder"
      }[this.minForgeTier] || "";
    },
    /**
     * Whether or not the user has the correct Forge subscription tier for this
     * package.
     * @returns {boolean} Does the user's Forge subscription tier match this
     * package?
     */
    userHasForgeTier() {
      return this.userIntegrations && this.userIntegrations.tier >= this.minForgeTier;
    },
    /**
     * Given an associated Patreon, count the tiers this package is associated
     * with.
     * @returns {boolean} The count of Patreon tiers that this package is associated with.
     */
    patreonTierCount() {
      if (!this.package?.patreon?.creator) {
        return 0;
      }
      return this.package.patreon.tiers.length;
    },
    /**
     * The Patreon creator for this package.
     * @returns {string} The creator the package is associated with.
     */
    patreonCreator() {
      return this.package?.patreon?.creator;
    },
    /**
     * Whether or not the package is associated with a Patreon
     * @returns {boolean} Is the package associated with a Patreon?
     */
    hasPatreon() {
      if (!this.package.patreon) {
        return false;
      }
      return this.package.patreon.creator && this.package.patreon.tiers && this.package.patreon.tiers.length;
    },
    /**
     * Whether or not the user is entitled to this package.
     * @returns {boolean} Is the user entitled to this package?
     */
    isEntitled() {
      return this.package.entitled;
    },
    /**
     * Whether or not the package has been purhcased.
     * @returns {boolean} Has the package been purchased?
     */
    isPurchased() {
      return this.package.purchased;
    },
    /**
     * Whether or not the package is installed.
     * @returns {boolean} Is the package installed?
     */
    isInstalled() {
      return this.package.installed;
    },
    /**
     * Whether or not the package is doing something that requires network
     * traffic.
     * @returns {boolean} Is the package processing?
     */
    isProcessing() {
      return this.package.processing;
    },
    /**
     * The platform that this module is associated with. Can be one of the
     * following:
     * - a Foundry module, with subtypes for the type of module it is
     * - an asset pack
     * - a resource from D&D Beyond
     * @returns {unknown|null} the platform type, name, and iconography, if any
     * apply.
     */
    associatedPlatform() {
      if (this.package.type === "module" || this.package.type === "world" || this.package.type === "system") {
        const baseLabel = this.t("Foundry");
        const subLabel = this.t(this.package.type.charAt(0).toUpperCase() + this.package.type.slice(1));
        return {
          type: "foundry",
          icon: "fas fa-dice-d20",
          label: `${baseLabel} • ${subLabel}`
        };
      }
      if (this.package.type === "asset") {
        return {
          type: "asset",
          icon: "fas fa-boxes",
          label: this.t("Asset Pack")
        };
      }
      if (this.package.premium === "dndbeyond") {
        return {
          type: "dndbeyond",
          icon: "fas fa-dragon",
          label: this.t("D&D Beyond")
        };
      }
      return null;
    }
  },
  methods: {
    onClick() {
      if (this.readonly) {
        return;
      }
      this.$emit("click", this.package);
    },
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, this.defaultImage);
    },
    setupPatreon(_ev) {
      if (!this.userHasLinkedPatreon) {
        // Go to the profile page, patreon tab
        window.location = "/account#patreon";
      } else if (!this.userHasForgeTier) {
        // Go to the profile page, and launch subscription manager
        window.location = `/account#membership&subscribe=${this.minForgeTierCode}`;
      }
    },
    subscribePatreon(_ev) {
      // Open the patreon link for the creator
      window.open(`/account/redirect/patreon/${this.patreonCreator}`, "_blank");
      // TODO: open patreon in a pop up window or iframe, and listen for when the tab is closed before doing a refresh pledges via API
      // See #987 - https://github.com/ForgeVTT/theforge/issues/987
      // window.location = "/account#patreon";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageCompatibleVersions"] = Vue.component(
                    "BazaarPackageCompatibleVersions",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<p class=\"bazaar-package-compatible-versions\"> <i18n v-if=\"rangeString && verified\" :path=\"t(`Compatible with Foundry {{range}} (Verified {{verified}})`, { range: rangeString, verified: verified })\" tag=\"span\" ></i18n> <i18n v-else-if=\"verified && !rangeString\" :path=\"t(`Verified with Foundry {{verified}}`, { verified: verified })\" tag=\"span\" ></i18n> <i18n v-else-if=\"!verified && rangeString\" :path=\"t(`Compatible with Foundry {{range}}`, { range: rangeString })\" tag=\"span\" ></i18n> <i18n v-else :path=\"t(`This package has no Foundry compatibility data`)\" tag=\"span\"></i18n> </p>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-compatible-versions{text-align:center;font-size:.75em;font-weight:bold;margin:0}"
    });
  },
  props: {
    minimum: {
      type: String || undefined,
      default: undefined
    },
    maximum: {
      type: String || undefined,
      default: undefined
    },
    verified: {
      type: String || undefined,
      default: undefined
    }
  },
  computed: {
    rangeString() {
      const {
        minimum,
        maximum
      } = this;
      if (minimum && maximum) {
        return minimum === maximum ? `${minimum}` : `${minimum}-${maximum}`;
      } else if (minimum) {
        return `${minimum} +`;
      } else if (maximum) {
        return `<${maximum}`;
      }
      return "";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageInstallButton"] = Vue.component(
                    "BazaarPackageInstallButton",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span class=\"bazaar-package__install-button\"> <!-- The package this component represents is processing -- it's not interactive, and should display a loading spinner. --> <b-button v-if=\"pkg?.processing\" :size=\"size\" variant=\"secondary\" disabled> <loading-indicator tag=\"span\" :small=\"size == 'sm'\" :label=\"t('Processing…')\"> </loading-indicator> </b-button> <!-- The package this component represents is not processing; we know if it's installed or not, and should display a UI matching one of a number of cases, as seen below. Note: you can jump to a specific case with your editor's Find tool. ## UNINSTALLED: * U01: Uninstalled, incompatible * U02: Uninstalled, installable, not purchasable, multiple versions, full view * U03: Uninstalled, installable, not purchasable * U04: Uninstalled, premium, from the Bazaar Marketplace * U05: Uninstalled, premium, from D&D Beyond * U06: Uninstalled, premium, from Patreon * U07: Uninstalled, premium, from the Bazaar (default case) ## INSTALLED: * I01: Installed, but the package's latest version is incompatible * I02: Installed, and the package has an update * I03: Installed, but it's a custom package that doesn't have a manifest * I04: Installed, but it's a custom package and isn't the latest version * I05: Installed and up to date (default case) --> <template v-else> <!-- If the package is not installed, try one of the following cases --> <template v-if=\"!isInstalled\"> <!-- # U01 If the following are true: * The package does not have any releases that are compatible with the Foundry versions the user uses. Display a warning to the user that this package cannot be installed due to a version mismatch. --> <button-with-tooltip v-if=\"!hasCompatibleVersions\" :tooltip=\"tooltip\" :size=\"size\" disabled variant=\"warning\" icon=\"fas fa-exclamation-circle\" > {{ t(\"Incompatible\") }} </button-with-tooltip> <!-- # U02 If the following are true: * This component is used in the full package view * There are multiple installable versions of this package * The package is installable * The package is not for sale This package has multiple valid versions that can be installed. Offer a dropdown to the user with options for which version of this package to install. --> <span v-else-if=\"isFullViewWithMultipleInstallableVersions\" v-b-tooltip.hover=\"tooltip\"> <b-dropdown v-bind=\"commonProps\" right split variant=\"success\" @click.prevent=\"install\"> <template #button-content> <i class=\"fas fa-download\" aria-role=\"presentation\"></i> {{ installLabel }} </template> <component :is=\"`b-dropdown-${option.element}`\" v-for=\"(option, index) in availableVersions\" :key=\"index\" @click=\"changeVersionToInstall(option)\" > {{ option.text }} </component> </b-dropdown> </span> <!-- # U03 If the following are true: * This package is installable * This package is not for sale Either there is a single valid version for this package, or this component is used on the search view. Display a button to allow the user to install the package. --> <button-with-tooltip v-else-if=\"installable && !purchasable\" v-bind=\"commonProps\" :tooltip=\"tooltip\" variant=\"success\" icon=\"fas fa-download\" @click.prevent=\"install\" > {{ installLabel }} </button-with-tooltip> <!-- # U04 If the following are true: * This package is available to purchase through the Bazaar We sell this package; therefore, display the price of the package, with iconography for PWYW/paying more for the package. --> <button-with-tooltip v-else-if=\"marketplace\" v-bind=\"commonProps\" :tooltip=\"marketplacePurchaseTooltip\" variant=\"primary\" icon=\"fas fa-shopping-cart\" @click.prevent=\"purchasePremium\" > {{ priceDisplay }} <i v-if=\"payWhatYouWant || payMore\" class=\"fas fa-plus\" aria-role=\"presentation\"></i> </button-with-tooltip> <!-- # U05 If the following are true: * This package is from D&D Beyond In addition to a button, we include a modal that'll help the user import their D&D Beyond content. --> <template v-else-if=\"dndbeyond\"> <button-with-tooltip :disabled=\"!canInstall\" size=\"sm\" :tooltip=\"t('Import from D&amp;D Beyond')\" variant=\"primary\" icon=\"fas fa-arrow-circle-down\" @click.prevent=\"dndbeyondFrame = true\" > {{ t(\"Import\") }} </button-with-tooltip> <bazaar-dnd-beyond v-model=\"dndbeyondFrame\" :package=\"pkg\" @installed=\"$emit('ddb-installed', $event)\" ></bazaar-dnd-beyond> </template> <!-- # U06 If the following are true: * This package is from Patreon This package can only be acquired through Patreon. Inform the user with a disabled button. --> <button-with-tooltip v-else-if=\"premiumPatreon\" :disabled=\"!canInstall\" size=\"sm\" :tooltip=\"t('Only available through Patreon')\" variant=\"primary\" icon=\"fas fa-external-link-alt\" @click.prevent=\"openPremiumLink\" > {{ t(\"Patreon only\") }} </button-with-tooltip> <!-- # U07 This package must be for sale. Show the purchase button. --> <button-with-tooltip v-else v-bind=\"commonProps\" :tooltip=\"tooltip\" variant=\"primary\" icon=\"fas fa-shopping-cart\" @click.prevent=\"openPremiumLink\" > {{ t(\"Purchase\") }} </button-with-tooltip> <!-- End of uninstalled cases --> </template> <!-- If the component is installed, try one of the following cases --> <template v-else> <!-- # I01 If the following are true: * This package has no version that are compatible with the user's Foundry version. The user should be notified about the incompatibility, and given the option to uninstall the package. --> <template v-if=\"!hasCompatibleVersions\"> <button-with-tooltip v-bind=\"commonProps\" :tooltip=\"uninstallLabel\" :aria-label=\"uninstallLabel\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"uninstall\" ></button-with-tooltip> <button-with-tooltip :size=\"size\" :tooltip=\"tooltip\" :aria-label=\"tooltip\" disabled variant=\"warning\" icon=\"fas fa-exclamation-circle\" > {{ t(\"Incompatible\") }} </button-with-tooltip> </template> <!-- # I02 If the following are true: * This package has updates Offer the user a button to update this component, as well as a means to uninstall the package. --> <template v-else-if=\"hasUpdate\"> <button-with-tooltip v-bind=\"commonProps\" :tooltip=\"uninstallLabel\" :aria-label=\"uninstallLabel\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"uninstall\" ></button-with-tooltip> <button-with-tooltip :size=\"size\" :tooltip=\"updateButtonTooltip\" :aria-label=\"updateButtonTooltip\" :disabled=\"!canInstall || isLocked\" :variant=\"isLocked ? `secondary` : `success`\" :icon=\"`fas fa-${isLocked ? 'lock' : `arrow-alt-circle-up`}`\" @click.prevent=\"install\" > {{ updateLabel }} </button-with-tooltip> </template> <!-- # I03 If the following are true: * This package is a custom package; the user installed it from outside of the Bazaar * This package does not have a manifest We don't know if this package is up to date, because we don't have a manifest to check against. Offer the uninstall button. --> <button-with-tooltip v-else-if=\"isCustom && !hasManifest\" v-bind=\"commonProps\" :aria-label=\"uninstallLabel\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"uninstall\" > {{ uninstallLabel }} </button-with-tooltip> <!-- # I05 If the following are true: * This package is a custom package; the user installed it from outside of the Bazaar * This package needs to check for if it's updated. We need to check if this package is up-to-date; offer a button to perform the check, as well as the uninstall button. --> <template v-else-if=\"isCustom && customNeedsCheck\"> <button-with-tooltip v-bind=\"commonProps\" :tooltip=\"uninstallLabel\" :aria-label=\"uninstallLabel\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"uninstall\" ></button-with-tooltip> <button-with-tooltip v-bind=\"commonProps\" :tooltip=\"t('Check for Updates')\" :aria-label=\"t('Check for Updates')\" variant=\"warning\" icon=\"fas fa-sync-alt\" @click.prevent=\"checkUpdate\" > {{ t(\"Check\") }} </button-with-tooltip> </template> <!-- # I06 The package is installed and up to date. Display iconography to mark it as up to date, as well as the uninstall button. --> <template v-else> <i v-b-tooltip.hover=\"t('Up to Date!')\" class=\"fas fa-check text-success\" :aria-label=\"t('Up to Date!')\"></i> <button-with-tooltip v-bind=\"commonProps\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"uninstall\"> {{ uninstallLabel }} </button-with-tooltip> </template> <!-- End of installed cases --> </template> </template> </span>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package__install-button{display:flex;align-items:center;gap:.25em}.bazaar-package__install-button .btn{white-space:nowrap}"
    });
  },
  props: {
    package: Object,
    canInstall: Boolean,
    fullView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dndbeyondFrame: false
    };
  },
  computed: {
    /**
     * Common props for buttons created by this component.
     * @returns {unknown}  a `v-bind`-able object with props shared by all components.
     */
    commonProps() {
      return {
        size: this.size,
        disabled: !this.canInstall
      };
    },
    pkg() {
      return this.package;
    },
    name() {
      return this.package.name;
    },
    url() {
      return this.package.url;
    },
    title() {
      return this.package.title;
    },
    version() {
      return this.package.installed || this.package.latest;
    },
    price() {
      return Number(this.package.pwywMinimum === undefined ? this.package.price : this.package.pwywMinimum) || 0;
    },
    payWhatYouWant() {
      return this.package.pwywMinimum === 0;
    },
    payMore() {
      return this.package.pwywMinimum > 0;
    },
    premium() {
      return !!this.package.premium;
    },
    patreon() {
      return this.package.patreon && this.package.patreon.creator && this.package.patreon.tiers && this.package.patreon.tiers.length;
    },
    protectedPackage() {
      return this.package.premium === "protected";
    },
    marketplace() {
      return this.package.premium === "marketplace";
    },
    dndbeyond() {
      return this.package.premium === "dndbeyond";
    },
    premiumPatreon() {
      return this.package.premium === "patreon";
    },
    installable() {
      return !this.premium || this.isEntitled;
    },
    isInstalled() {
      return this.package?.installed;
    },
    isCustom() {
      return this.package?.custom;
    },
    hasManifest() {
      return !!this.package?.manifest;
    },
    hasUpdate() {
      const target = this.package?.versionToInstall || this.package?.latest;
      return this.hasCompatibleVersions && target && this.package?.installed !== target;
    },
    hasCompatibleVersions() {
      return this.package?.versions.length > 0;
    },
    /**
     * Check for the following state:
     * - we're using this button on the full Package view
     * - there are multiple versions available for install
     * - the package is installable
     * - the package does not need to be purchased
     *
     * @returns {boolean} Does this package fit this specific state?
     */
    isFullViewWithMultipleInstallableVersions() {
      return this.installable && !this.purchasable && this.hasVersions && this.fullView;
    },
    isLocked() {
      return this.package.locked;
    },
    customNeedsCheck() {
      return this.isCustom && !this.package.latest;
    },
    isEntitled() {
      return this.package.entitled;
    },
    isOwner() {
      return ["admin", "creator"].includes(this.package.entitlement);
    },
    isPurchased() {
      return this.package.purchased;
    },
    purchasable() {
      return this.marketplace && (!this.isEntitled || this.package.entitlement === "patreon") && !this.isOwner && !this.isPurchased;
    },
    /**
     * The tooltip to display when hovering over the install button's wrapping span.
     * We put this tooltip on the wrapping span because `b-button` doesn't activate tooltips for disabled elements.
     * @returns {string} A message to display on hover.
     */
    tooltip() {
      if (!this.canInstall) {
        return t("Sign in to Install");
      }
      if (!this.hasCompatibleVersions) {
        return t("Not Compatible with your Foundry Version");
      }
      if (this.isInstalled) {
        return "";
      }
      switch (this.package.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return "";
      }
    },
    updateButtonTooltip() {
      if (this.package.locked) {
        return t(`You have locked this package to version {{version}}`, {
          version: this.version
        });
      }
      const versionToInstall = this.package.versionToInstall || this.package.latest;
      return t(`Update to {{version}}`, {
        version: versionToInstall
      });
    },
    installLabel() {
      if (this.package.type === "asset") {
        return t("Enable");
      }
      const versionToInstall = this.package.versionToInstall || this.package.latest;
      //Additional text will only show in full view mode
      return versionToInstall !== this.package.latest && this.fullView ? t("Install {{version}}", {
        version: versionToInstall
      }) : t("Install");
    },
    updateLabel() {
      //Additional text will only show in full view mode
      const showVersion = this.package.versionToInstall && this.package.versionToInstall !== this.package.latest && this.fullView;
      return showVersion ? t(`Update to {{version}}`, {
        version: this.package.versionToInstall
      }) : t("Update");
    },
    uninstallLabel() {
      return this.package.type === "asset" ? t("Disable") : t("Uninstall");
    },
    marketplacePurchaseTooltip() {
      if (this.payWhatYouWant) {
        return t("Pay what you can!");
      }
      if (this.payMore) {
        return t(`Pay {{price}} or more!`, {
          price: this.priceDisplay
        });
      }
      if (this.package.type === "forge-gift-card") {
        return t("This is a great gift!");
      }
      return t("Purchase");
    },
    priceDisplay() {
      if (!this.package.price) {
        // This should never appear to users, but prevents console errors if price is not set.
        return "Err";
      }
      if (this.payWhatYouWant && this.size === "md") {
        return t("Pay what you can");
      }
      return `$ ${this.price.toFixed(2)}`;
    },
    size() {
      return this.fullView ? "md" : "sm";
    },
    availableVersions() {
      //The versions returned has a header item added to increase clarity when viewed from the dropdown button and is not strctly an actual version.
      const header = {
        element: "header",
        value: null,
        text: t("Versions")
      };
      const versions = [header, ...this.package.versions.map(v => ({
        element: "item",
        value: v,
        text: v + (v === this.package.latest ? ` ${t("(Latest)")}` : v === this.package.installed ? ` ${t("(Installed)")}` : "")
      }))];
      return versions;
    },
    hasVersions() {
      return this.package.versions && this.package.versions.length > 1;
    }
  },
  methods: {
    install() {
      this.$emit("install", this.package);
    },
    uninstall() {
      this.$emit("uninstall", this.package);
    },
    openPremiumLink() {
      window.open(this.url, "_blank");
    },
    purchasePremium() {
      this.$emit("purchase", this.package);
    },
    checkUpdate() {
      this.$emit("check-update", this.package);
    },
    changeVersionToInstall(option) {
      if (option.value) {
        this.package.versionToInstall = option.value;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackagePatreonButton"] = Vue.component(
                    "BazaarPackagePatreonButton",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span class=\"bazaar-package-patreon-button\"> <b-button v-if=\"pkg.processing\" :size=\"size\" variant=\"secondary\" disabled> <loading-indicator tag=\"span\" :small=\"size === 'sm'\" :label=\"t('Processing…')\"> </loading-indicator> </b-button> <template v-else> <b-button v-if=\"!hasPatreon || !hasForgeTier\" v-b-tooltip.hover=\"setupTooltip\" :size=\"size\" variant=\"warning\" tabindex=\"0\" @click.prevent=\"setup\" > <img src=\"/images/social/patreon.png\" class=\"patreon-icon\" width=\"20px\" height=\"20px\" /> <span class=\"bazaar-package-patreon-button__label\"> {{ t(\"Setup\") }} </span> </b-button> <b-button v-else-if=\"!hasSubscribed || !hasTier\" v-b-tooltip.hover=\"subscribeTooltip\" :size=\"size\" class=\"btn-patreon\" tabindex=\"0\" @click.prevent=\"subscribe\" > <img src=\"/images/social/patreon.png\" class=\"patreon-icon\" width=\"20px\" height=\"20px\" /> <span class=\"bazaar-package-patreon-button__label\"> {{ t(\"Subscribe\") }} </span> </b-button> <b-button v-else-if=\"!isInstalled && installable\" v-b-tooltip.hover=\"installTooltip\" :size=\"size\" :disabled=\"!canInstall\" variant=\"success\" tabindex=\"0\" @click.prevent=\"install\" > <i class=\"fas fa-download\"></i> <span class=\"bazaar-package-patreon-button__label\"> {{ installLabel }} </span> </b-button> </template> </span>",
  beforeCreate() {
    Utils.loadCss({
      content: "button:disabled { cursor: not-allowed; pointer-events: all; } .bazaar-package-patreon-button .patreon-icon { width: 20px; height: 20px; }"
    });
  },
  props: {
    package: Object,
    userIntegrations: Object,
    canInstall: Boolean,
    fullView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    pkg() {
      return this.package;
    },
    url() {
      return this.package.url;
    },
    installable() {
      return this.hasPatreon && this.hasForgeTier && this.hasSubscribed && this.hasTier && this.hasMinimumContribution;
    },
    isInstalled() {
      return this.package.installed;
    },
    patreonCreator() {
      return this.package && this.package.patreon && this.package.patreon.creator;
    },
    hasPatreon() {
      return this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon.linked;
    },
    minForgeTier() {
      // Default to 3 (story teller)
      if (!this.package || !this.package.patreon || this.package.patreon.minimumForgeTier === undefined) {
        return 3;
      }
      return this.package.patreon.minimumForgeTier;
    },
    minForgeTierName() {
      return {
        0: t("Player"),
        1: t("Explorer"),
        2: t("Game Master"),
        3: t("Story Teller"),
        4: t("World Builder")
      }[this.minForgeTier] || t("Story Teller");
    },
    hasForgeTier() {
      return this.userIntegrations.tier >= this.minForgeTier;
    },
    patreonPledge() {
      return this.hasPatreon && this.userIntegrations.patreon.pledges.find(p => p.vanity === this.package.patreon.creator);
    },
    hasSubscribed() {
      return !!this.patreonPledge;
    },
    hasTier() {
      const patreonPledge = this.patreonPledge;
      return patreonPledge && !!patreonPledge.tiers.find(t => this.package.patreon.tiers.includes(t.title));
    },
    hasMinimumContribution() {
      return this.userContribution == "creator" || this.userContribution >= this.minimumContribution;
    },
    userContribution() {
      const patreonPledge = this.patreonPledge;
      if (!patreonPledge) {
        return 0;
      }
      if (patreonPledge.creator) {
        return "creator";
      }
      return patreonPledge.lifetime_contribution || 0;
    },
    minimumContribution() {
      return this.package && this.package.patreon && this.package.patreon.minimumContribution || 0;
    },
    setupTooltip() {
      if (!this.hasPatreon) {
        return t("Link your Patreon account");
      } else if (!this.hasForgeTier) {
        return t("Subscribe to {{tier}} tier or higher", {
          tier: this.minForgeTierName
        });
      }
      return t("Unknown Setup function");
    },
    subscribeTooltip() {
      if (!this.hasSubscribed) {
        return t("Subscribe to {{creator}}'s Patreon", {
          creator: this.patreonCreator
        });
      } else if (!this.hasTier) {
        return t("Subscribe to this creators Patreon tier");
      }
      return t("Unknown Subscribe function");
    },
    installTooltip() {
      switch (this.package.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return t("Your Patreon subscription allows you to install this package");
      }
    },
    installLabel() {
      if (this.package.type === "asset") {
        return t("Enable");
      }
      const versionToInstall = this.package.versionToInstall || this.package.latest;
      // Additional text will only show in full view mode
      return `${this.fullView ? t("Install from Patreon") : t("Install")}${versionToInstall !== this.package.latest && this.fullView ? " " + versionToInstall : ""}`;
    },
    size() {
      return this.fullView ? "md" : "sm";
    }
  },
  methods: {
    setup() {
      this.$emit("setup");
    },
    subscribe() {
      this.$emit("subscribe");
    },
    install() {
      this.$emit("install", this.package);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackagePatreonInfo"] = Vue.component(
                    "BazaarPackagePatreonInfo",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"m-2\"> <i18n :path=\" t( 'This content is available through a one time purchase, or to Patreon subscribers of {0}, at the following tiers:' ) \" tag=\"p\" > <b>{{ patreonCreator }}</b> </i18n> <ul class=\"patreon-tier\"> <li v-for=\"tier in pkg.patreon.tiers\" :key=\"tier\" :class=\"tierClass(tier)\"> {{ tier }} </li> </ul> <p>{{ t(\"To get Patreon access to the package, make sure you have completed the steps below:\") }}</p> <ul style=\"list-style: none\"> <li v-if=\"minForgeTier > 0\"> <i class=\"fas\" :class=\"userHasForgeTier ? 'fa-check success-action' : 'fa-times fail-action'\"></i> <a :href=\"`/account#membership&amp;subscribe=${minForgeTierCode}`\"> <i18n :path=\"t('Have a {0} subscription or higher')\" tag=\"span\"> {{ minForgeTierName }} </i18n> </a> </li> <li> <i class=\"fas\" :class=\"userHasLinkedPatreon ? 'fa-check success-action' : 'fa-times fail-action'\"></i> <a href=\"/account#patreon\"> {{ t(\"Link your Patreon account\") }} </a> </li> <li> <i class=\"fas\" :class=\"userHasSubscribed ? 'fa-check success-action' : 'fa-times fail-action'\"></i> <a :href=\"`/account/redirect/patreon/${patreonCreator}`\"> {{ t(\"Subscribed to the Patreon creator\") }} </a> </li> <li> <i class=\"fas\" :class=\"userHasTier ? 'fa-check success-action' : 'fa-times fail-action'\"></i> <a :href=\"`/account/redirect/patreon/${patreonCreator}`\"> {{ t(\"Subscribed to the correct Patreon tier\") }} </a> </li> <li v-if=\"minimumContribution > 0\"> <i class=\"fas\" :class=\"userHasMinimumContribution ? 'fa-check success-action' : 'fa-times fail-action'\"></i> <a :href=\"`/account/redirect/patreon/${patreonCreator}`\"> <i18n :path=\"t('Minimum Lifetime Contribution: ${0} {1}')\" tag=\"span\"> <span>{{ minimumContribution }}</span> <small v-if=\"!userContribution === 'creator'\">(your total ${{ userContribution }})</small> </i18n> </a> </li> </ul> <p> {{ t( \"If you unsubscribe from the creator's Patreon or downgrade below the permitted tiers, you will lose access to future package updates.\" ) }} </p> <i18n :path=\"t('Read {0} for more information')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/how-to-install-patreon-exclusive-modules/11785\" target=\"_blank\">{{ t(\"here\") }}</a> </i18n> </div>",
  props: {
    package: {
      type: Object,
      default: null
    },
    userIntegrations: {
      type: Object,
      default: null
    }
  },
  computed: {
    pkg() {
      return this.package;
    },
    userHasLinkedPatreon() {
      return this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon.linked;
    },
    minForgeTier() {
      // Default to 3 (story teller)
      if (!this.package || !this.package.patreon || this.package.patreon.minimumForgeTier === undefined) {
        return 3;
      }
      return this.package.patreon.minimumForgeTier;
    },
    minForgeTierName() {
      return {
        0: t("Player"),
        1: t("Explorer"),
        2: t("Game Master"),
        3: t("Story Teller"),
        4: t("World Builder")
      }[this.minForgeTier] || t("Story Teller");
    },
    minForgeTierCode() {
      return {
        2: "game-master",
        3: "story-teller",
        4: "world-builder"
      }[this.minForgeTier] || "";
    },
    userHasForgeTier() {
      return this.userIntegrations && this.userIntegrations.tier >= this.minForgeTier;
    },
    patreonPledge() {
      if (!this.userHasLinkedPatreon) {
        return false;
      }
      return this.userIntegrations.patreon.pledges.find(p => p.vanity === this.patreonCreator);
    },
    userHasSubscribed() {
      return !!this.patreonPledge;
    },
    userHasTier() {
      const patreonPledge = this.patreonPledge;
      return patreonPledge && !!patreonPledge.tiers.find(t => this.package.patreon.tiers.includes(t.title));
    },
    userContribution() {
      const patreonPledge = this.patreonPledge;
      if (!patreonPledge) {
        return 0;
      }
      if (patreonPledge.creator) {
        return "creator";
      }
      return patreonPledge.lifetime_contribution || 0;
    },
    patreonCreator() {
      return this.package && this.package.patreon && this.package.patreon.creator;
    },
    userHasMinimumContribution() {
      return this.userContribution == "creator" || this.userContribution >= this.minimumContribution;
    },
    minimumContribution() {
      return this.package && this.package.patreon && this.package.patreon.minimumContribution || 0;
    }
  },
  methods: {
    tierClass(tier) {
      const patreonPledge = this.patreonPledge;
      const tiers = patreonPledge && patreonPledge.tiers || [];
      if (tiers.find(t => t.title === tier)) {
        return "subscribed";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageView"] = Vue.component(
                    "BazaarPackageView",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card ref=\"card\" class=\"m-2 bazaar-package-view\" :class=\"`border-${border}`\" no-body> <template #header> <h1 class=\"mb-0\" style=\"flex: 1\"><img :src=\"icon\" height=\"48\" /> {{ title }}</h1> <div> <b-button variant=\"success\" :href=\"Bazaar.bazaarLink(pkg)\"> {{ t(\"Return to Bazaar\") }} <i class=\"fas fa-chevron-right\"></i> </b-button> </div> </template> <b-card-body> <bazaar-full-package :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" @install=\"installPackage\" @uninstall=\"uninstallPackage\" @check-update=\"checkUpdate\" @toggle-lock=\"togglePackageLock\" @purchase=\"purchasePackage\" @purchase-gift=\"purchasePackageGift\" @add-tag=\"addPackageTag\" > </bazaar-full-package> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-view .card-header { display: flex; align-items: center; }"
    });
  },
  extends: VueComponents["PackageHelper"],
  props: {
    pkgname: String,
    packages: Array,
    entitlements: Array,
    canInstall: {
      type: Boolean,
      default: false
    },
    userIntegrations: Object
  },
  data() {
    return {
      loaded: false,
      pkg: null
    };
  },
  computed: {
    title() {
      return this.pkg.title;
    },
    icon() {
      return this.getMedia(PACKAGE_MEDIA_TYPES.ICON, "height=32") || this.defaultIcon;
    },
    defaultIcon() {
      switch (this.pkg.type) {
        case "world":
          return "/images/bazaar/world-icon-32.png";
        case "system":
          return "/images/bazaar/system-icon-32.png";
        case "module":
          return "/images/bazaar/module-icon-32.png";
        case "asset":
          return "/images/bazaar/asset-icon-32.png";
        default:
          return "/images/bazaar.png";
      }
    },
    border() {
      switch (this.pkg.type) {
        case "module":
          return "primary";
        case "system":
          return "success";
        case "world":
          return "secondary";
        case "asset":
          return "danger";
        default:
          return "info";
      }
    }
  },
  methods: {
    getMedia(type, thumbnailParams) {
      if (!this.pkg) {
        return;
      }
      const media = this.pkg.media.find(m => m.type === type);
      if (media && media.url) {
        return thumbnailParams && media.url.startsWith("https://assets.forge-vtt.com") ? `${media.url}?${thumbnailParams}` : media.url;
      }
    },
    purchasePackage(pkg, gift = false) {
      //this needs to be taken to the bazaar, where there's a cart and purchase support
      const link = Bazaar.bazaarLink(pkg, true, gift);
      window.location = link;
    },
    purchasePackageGift(pkg) {
      this.purchasePackage(pkg, true);
    },
    addPackageTag(tag) {
      const [key, value] = tag.split(":");
      if (key && value) {
        window.location = `/bazaar#${key}=${value}`;
      }
    }
  },
  async created() {
    // Need to have these fields set in advance so they can be reactive
    this.packages.forEach(pkg => {
      const entitlement = this.entitlements.find(e => pkg.type === e.type && pkg.name === e.name);
      pkg.processing = false;
      pkg.entitled = !!entitlement;
      pkg.purchased = entitlement && entitlement.entitlement === "purchase";
      pkg.fullyLoaded = true;
      pkg.versionToInstall = pkg.latest;
      pkg.installed = pkg.installed; // Make sure it's reactive on installed if it was originally unset
    });

    this.pkg = this.packages.find(p => p.name == this.pkgname);
    this.loaded = true;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPromotions"] = Vue.component(
                    "BazaarPromotions",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<section v-if=\"currentPromotionSlides.length\" :class=\"containerClasses\"> <b-carousel :id=\"id\" :interval=\"interval\" class=\"bazaar-promotions__carousel\" controls> <template v-for=\"(slide, slideIndex) in currentPromotionSlides\"> <a v-if=\"slide.url\" :key=\"`${slideIndex}-link`\" :href=\"`${slide.url}`\" :title=\"slide.altText\"> <b-carousel-slide :img-src=\"slide.art\" :img-alt=\"slide.altText || ''\" class=\"bazaar-promotions__carousel__slide\" ></b-carousel-slide> </a> <b-carousel-slide v-else :key=\"`${slideIndex}-no-link`\" :img-src=\"slide.art\" :img-alt=\"slide.altText || ''\" class=\"bazaar-promotions__carousel__slide\" ></b-carousel-slide> </template> </b-carousel> </section>",
  beforeCreate() {
    Utils.loadCss({
      content: "@property --carousel-control-bg-left{syntax:\"<color>\";inherits:false;initial-value:rgba(0,0,0,0)}@property --carousel-control-bg-right{syntax:\"<color>\";inherits:false;initial-value:rgba(0,0,0,0)}.bazaar-promotions{border-radius:.25rem;overflow:clip;padding:0}.bazaar-promotions__carousel{background:#ababab}.bazaar-promotions__carousel :is(.carousel-control-prev-icon,.carousel-control-next-icon){filter:drop-shadow(1px 1px 1px #000);width:1em;height:1em;font-size:clamp(.5rem,10vw,2rem)}.bazaar-promotions__carousel :is(.carousel-control-prev,.carousel-control-next){background:rgba(0,0,0,0);transition:--carousel-control-bg-left ease-in-out 333ms,--carousel-control-bg-right ease-in-out 333ms,background ease-in-out 333ms,opacity ease-in-out 333ms;min-width:4rem;width:5%;opacity:.7;background:linear-gradient(to right, var(--carousel-control-bg-left), var(--carousel-control-bg-right))}.bazaar-promotions__carousel .carousel-control-prev:hover{--carousel-control-bg-left: rgba(0, 0, 0, 0.7)}.bazaar-promotions__carousel .carousel-control-next:hover{--carousel-control-bg-right: rgba(0, 0, 0, 0.7)}.bazaar-promotions__carousel__slide{cursor:pointer}"
    });
  },
  props: {
    /** The HTML ID to apply to the component's root element. */
    id: {
      type: String || undefined,
      default: undefined
    },
    /** How quickly to advance the component's slider, in milliseconds. */
    interval: {
      type: Number,
      default: 5000
    },
    /** BazaarPromotion objects to display in this carousel. */
    promotions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    /**
     * CSS classes to apply to the promotion slider's container.
     * @returns {string} the CSS classes to apply.
     */
    containerClasses() {
      return `bazaar-promotions mb-2 ${this.$vnode.data.staticClass}`;
    },
    /**
     * The current active promotions.
     * @todo Does this even need to be here, if we can filter it on the server
     * side?
     * @returns {BazaarPromotionAPIObject[]} the promotion slides to display.
     */
    currentPromotionSlides() {
      if (!this.promotions.length) {
        return [];
      }
      const now = Date.now();
      return this.promotions.filter(s => {
        const start = new Date(s.startDate);
        const end = new Date(s.endDate);
        return now >= start && now <= end;
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarSearch"] = Vue.component(
                    "BazaarSearch",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-col class=\"p-0\"> <bazaar-promotions id=\"promo-carousel-small\" class=\"d-xl-none\" :promotions=\"promotionSlides\"></bazaar-promotions> <collapsible-side-panel v-model=\"filterCollapsed\" :panel-width=\"panelWidth\" class=\"mt-2 collapsible-filter-panel\" :overlap=\"smallScreen\" > <template #collapsed> <b-button v-b-tooltip.hover.noninteractive class=\"mb-1 w-100\" :title=\"t('Expand Filter')\" @click=\"toggleSidebarCollapse\" > <i class=\"fas fa-caret-right\"></i> </b-button> <b-button v-b-tooltip.hover.noninteractive class=\"my-1 w-100\" variant=\"info\" :title=\"t('Install From Manifest')\" @click.prevent=\"showManifestInstall = true\" > <i class=\"fas fa-file-import\"></i> </b-button> <b-button v-if=\"updateCount\" v-b-tooltip.hover.noninteractive class=\"my-1 w-100\" :title=\"t('Update All Packages')\" variant=\"success\" @click.prevent=\"showUpdateAll = true\" > <b-badge variant=\"warning\">{{ updateCount }}</b-badge> <i class=\"fas fa-arrow-alt-circle-up\"></i> </b-button> <b-button v-else class=\"mb-2 w-100\" variant=\"success\" @click.prevent=\"showUpdateAll = true\"> <i class=\"fas fa-arrow-alt-circle-up\"></i> </b-button> </template> <template #panel> <b-card no-body class=\"border-0 p-0 filter-card w-100 h-100\"> <b-card-header class=\"px-2 py-1 text-center\"> <span>{{ t(\"Toolbox\") }}</span> <b-link v-b-tooltip.hover class=\"float-right text-secondary position-absolute collapse-link\" :title=\"t('Collapse Filters')\" @click=\"toggleSidebarCollapse\" > <i class=\"fas fa-caret-left\"></i> </b-link> </b-card-header> <b-card-body class=\"p-0 m-0\"> <b-row class=\"m-0 w-100 justify-content-center\"> <b-col class=\"px-2 w-100 action-buttons\"> <b-button class=\"my-2 w-100\" variant=\"info\" @click.prevent=\"showManifestInstall = true\"> <i class=\"fas fa-file-import\"></i> {{ t(\"Install From Manifest\") }} </b-button> <b-button v-if=\"updateCount\" class=\"mb-2 w-100\" variant=\"success\" @click.prevent=\"showUpdateAll = true\"> <i class=\"fas fa-arrow-alt-circle-up\"></i> {{ t(\"Update All Packages\") }} <b-badge variant=\"warning\">{{ updateCount }}</b-badge> </b-button> <b-button v-else class=\"mb-2 w-100\" variant=\"success\" @click.prevent=\"showUpdateAll = true\"> <i class=\"fas fa-arrow-alt-circle-up\"></i> {{ t(\"Check for Updates\") }} </b-button> </b-col> <b-card no-body class=\"w-100 rounded-0 rounded-bottom\"> <filter-field ref=\"filterField\" v-model=\"filterTags\" :menu=\"filterMenu\" :package-list=\"packages\" :search-tags=\"searchTags\" visibility-key=\"bazaarFilter\" display-icons ></filter-field> </b-card> <b-col class=\"text-right\"> <small class=\"text-muted ml-2\"> {{ t(\"What is the Bazaar?\") }} <help-icon url=\"https://forums.forge-vtt.com/docs?topic=4877\" :tooltip=\"t('Click to find out more about the Bazaar')\" ></help-icon> </small> </b-col> </b-row> </b-card-body> </b-card> </template> <template #default> <b-card no-body class=\"border-0 bg-transparent h-100 pt-2 px-3 mx-0\"> <b-row> <b-col class=\"pr-3\"> <bazaar-promotions id=\"promo-carousel-large\" class=\"d-none d-xl-block\" :promotions=\"promotionSlides\" ></bazaar-promotions> <search-field v-model=\"filterTags\" :presets=\"allPresets\" :packages=\"filteredPackages\" :search-tags=\"searchTags\" visibility-key=\"bazaarSearch\" @sort=\"sort = $event\" > <template #description> <b-row> <b-col> <div v-if=\"showFoundry\"> {{ t(\"Foundry\") }} <i class=\"fas fa-dice-d20\"></i> <strong>{{ coreVersion }}</strong> <help-icon url=\"/setup\" :tooltip=\" t( 'Only packages/versions that support your Foundry server version are shown. If using the Game Manager, you can set the version in the Game Manager tab' ) \" ></help-icon> </div> </b-col> <b-col class=\"text-right\"> <i18n :path=\"t('{{length}} results found {0}', { length: filteredPackages.length })\" class=\"mb-0\" tag=\"p\" > </i18n> </b-col> </b-row> </template> </search-field> </b-col> </b-row> <b-row> <b-col style=\"text-align: right\"> <sort-field v-model=\"sort\"> </sort-field> </b-col> </b-row> <b-row> <b-col> <b-alert v-if=\"!installsLoaded\" show class=\"p-0 mt-1 mb-0\"> <div class=\"ml-1 mb-0 d-inline-block\"> <b-spinner class=\"mr-2 align-middle\" small></b-spinner> </div> <h5 class=\"mb-0 mt-1 d-inline-block\"> {{ t( \"Please wait while we verify your content. Package list could update once your content is verified.\" ) }} </h5> </b-alert> <b-alert v-if=\"importingDDB\" show variant=\"warning\" class=\"mt-1 mb-0\"> <div class=\"ml-1 mb-0 d-inline-block\"> <b-spinner class=\"mr-2 align-middle\" small></b-spinner> </div> <h5 class=\"mb-0 mt-1 d-inline-block\">{{ importingDDB }}</h5> </b-alert> <b-alert v-if=\"hasDnDBeyond\" show class=\"mt-1\"> <b-row> <b-col class=\"flex-grow-0 flex-nowrap text-nowrap\"> <div class=\"info-ribbon\"> <span>{{ t(\"Beta\") }}</span> </div> <img src=\"images/dnd-beyond.png\" width=\"50\" height=\"50\" /> </b-col> <b-col> <i18n :path=\" t( 'The Forge features integration with {0} please see important information on how to view this content.' ) \" tag=\"span\" > <b>D&amp;D Beyond</b> </i18n> </b-col> <b-col class=\"flex-grow-0 flex-nowrap text-nowrap\"> <b-button v-b-modal.ddb-modal-info variant=\"warning\">{{ t(\"Important Information\") }}</b-button> <b-button variant=\"success\" @click.prevent=\"installDDBManifest\">{{ t(\"Refresh List\") }}</b-button> </b-col> </b-row> </b-alert> <b-alert v-if=\"hasAssetPacks\" show class=\"mt-1\"> <b-row> <b-col class=\"flex-grow-0 flex-nowrap text-nowrap\"> <img src=\"images/bazaar/asset-icon-125.png\" width=\"50\" height=\"50\" /> </b-col> <b-col> <i18n :path=\" t( `Asset packs are currently only browsable from within Foundry's file browser, under The Bazaar tab.` ) \" tag=\"span\" > <b>{{ t(\"Please Note:\") }}</b> </i18n> </b-col> </b-row> </b-alert> <div class=\"mt-3\"> <div> <b-alert v-if=\"loadingPackages\" show class=\"notification-alert\"> <loading-indicator small :label=\"t('Loading Packages')\"></loading-indicator> </b-alert> <bazaar-list-group v-if=\"filteredPackages.length || loadingPackages\" :label=\"`${t('Packages')} - ${filteredPackages.length} packages found`\" :loading=\"loadingPackages\" :packages=\"sortedPackages\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" :can-select=\"true\" @tag=\"addTag\" @selected=\"showPackage\" @install=\"installPackage\" @uninstall=\"uninstallPackage\" @check-update=\"checkUpdate\" @purchase=\"purchasePackage\" @ddb-installed=\"DDBPackageInstalled\" ></bazaar-list-group> <!-- else display a message that there are no results --> <div v-else-if=\"installsLoaded\" class=\"text-center\"> <b><i18n :path=\"t('No results found')\"></i18n></b> </div> </div> </div> </b-col> </b-row> </b-card> </template> </collapsible-side-panel> <div v-if=\"showScrollToTop\" class=\"scroll-to-top position-fixed text-center w-100 d-flex pt-1\"> <div class=\"rounded-top py-1 px-3 bg-light border border-secondary mx-auto\"> <b-link class=\"text-primary\" @click=\"scrollToTop\"> <i class=\"fas fa-arrow-up\"></i> {{ t(\"Scroll to top\") }} <i class=\"fas fa-arrow-up\"></i> </b-link> </div> </div> <b-modal id=\"ddb-modal-info\" size=\"xl\" ok-only title=\"D&amp;D Beyond\"> <i18n :path=\" t( 'The Forge now features integration with D&D Beyond, giving you the convenience of downloading the 5th edition content that you own, and converting it to a Foundry-compatible format! {0}.' ) \" tag=\"p\" > <strong>{{ t(\"However, this service is still in alpha/beta\") }}</strong> </i18n> <p> {{ t( \"The feature is available to users of Story Teller tier or higher. During the beta testing phase, major changes will be made to the service, bugs will be ironed out, and the implementation will be a work-in-progress.\" ) }} </p> <p> {{ t( \"Until the beta is over and the product is officially released, converted data may be incomplete, and the worlds may be unusable or unsuitable for general usage. Please keep this in mind if you decide to beta test Beyond integration.\" ) }} </p> <i18n :path=\" t( 'The Free Content from D&D Beyond ({0}, {1} and {2}) are available to beta test for everyone, regardless of Patreon support.' ) \" tag=\"p\" > <code>Basic Rules</code> <code>Lost Mine of Phandelver</code> <code>Frozen Sick</code> </i18n> <i18n :path=\"t('For more information, {0}.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/d-d-beyond-integration/13331\" target=\"_blank\">{{ t(\"click here\") }}</a> </i18n> </b-modal> <bazaar-update-all v-model=\"showUpdateAll\" :packages=\"allUpdatesPackages\" :custom-packages=\"allCustomPackages\" @update=\"updatePackage\" @check-update=\"checkUpdate\" @done=\"idleGames\" @lock-packages=\"lockPackages\" @show-package=\"showPackage\" ></bazaar-update-all> <bazaar-manifest-installer v-model=\"showManifestInstall\" :type=\"manifestInstallerType\" :processing=\"processingManifest\" :import-status=\"manifestImportStatus\" @install=\"installCustomManifest\" @closed=\"closedManifestDialog\" ></bazaar-manifest-installer> <bazaar-install-world v-model=\"installWorldVisible\" :package=\"installWorld\" @installed=\"worldInstalled\" ></bazaar-install-world> <bazaar-full-package-modal v-model=\"showFullPackage\" :package=\"currentPackage\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" :core-version=\"coreVersion\" :numeric-version=\"numericVersion\" @close=\"showPackage\" @install=\"installPackage\" @uninstall=\"uninstallPackage\" @check-update=\"checkUpdate\" @toggle-lock=\"togglePackageLock\" @purchase=\"purchasePackage\" @purchase-gift=\"purchaseGiftPackage\" @ddb-installed=\"DDBPackageInstalled\" @add-tag=\"addPackageTag\" > </bazaar-full-package-modal> <!-- Cart toaster --> <bazaar-cart v-model=\"cartVisible\" :packages=\"allMarketplacePackages\" :add-package=\"addToCart\" :add-gift=\"addGiftToCart\" :cart=\"cart\" :user-integrations=\"userIntegrations\" @cart-emptied=\"emptyCart\" @cart-updated=\"cartUpdated\" @cart-purchased=\"cartPurchased\" ></bazaar-cart> <bazaar-floating-cart :cart=\"cart\" @checkout-cart=\"checkoutCart\" /> </b-col>",
  beforeCreate() {
    Utils.loadCss({
      content: ".action-buttons { min-width: 275px; max-width: 400px; } .package-overlay { width: calc(100vw - 80px); height: calc(100vh - 5rem - 25px); margin-top: calc(5rem + 25px); border-radius: 10px; } .package-overlay > div { overflow: auto; border-radius: 0.3rem; height: 100%; background-color: var(--light); } .package-overlay .foundry-full-package-view { min-height: 100%; } .info-ribbon { position: absolute; overflow: hidden; top: -12px; left: -5px; width: 100px; height: 100px; } .info-ribbon span { position: absolute; display: block; color: white; background-color: #007bff; box-shadow: 0 5px 10px rgb(0 0 0 / 10%); text-shadow: 1px 1px black; transform: rotate(-45deg); width: 100px; top: 10px; left: -30px; text-align: center; } .scroll-to-top { left: 0px; bottom: 0px; z-index: 99; background: rgba(0, 0, 0, 0.5); pointer-events: none; } .scroll-to-top * { pointer-events: auto; } .collapse-link { font-size: 24px; line-height: 5px; width: 25px; right: 0.2em; } .collapsible-filter-panel .sidebar-panel-collapsed .card { min-height: 800px; }"
    });
  },
  extends: VueComponents["PackageHelper"],
  props: {
    coreVersion: String,
    numericVersion: String,
    username: String,
    creator: String
  },
  data() {
    return {
      installsLoaded: false,
      installsCollected: false,
      loadingPackages: true,
      canInstall: false,
      importingDDB: "",
      packages: [],
      installedModules: [],
      installedSystems: [],
      installedAssets: [],
      entitlements: [],
      cart: [],
      addToCart: null,
      addGiftToCart: false,
      cartVisible: false,
      hash: "",
      showScrollToTop: false,
      filterCollapsed: null,
      showUpdateAll: false,
      showFullPackage: false,
      currentPackage: null,
      displayPackageId: null,
      // Used if the packed is requested but the packages hasn't been loaded yet
      userIntegrations: null,
      smallScreen: false,
      // Keep track of small screen size to hide the filter panel
      largeBreakpoint: 0,
      panelWidth: "350px",
      filterTags: {},
      sort: {
        key: Sort.defaultSort,
        dir: "asc"
      },
      searchUtil: new Search(),
      /**
       * Promotions to display in either of the carousels.
       * @type {unknown[]}
       */
      promotionSlides: [],
      presets: [{
        key: "bazaar-marketplace",
        name: t("Bazaar Marketplace"),
        items: [{
          key: "latest-releases",
          name: t("Latest Releases"),
          tags: {
            price: ["marketplace"]
          },
          sort: {
            key: "newest",
            dir: "asc"
          }
        }, {
          key: "sale",
          name: t("On Sale"),
          tags: {
            price: ["on-sale"]
          }
        }, {
          key: "patreon",
          name: t("Patreon"),
          tags: {
            price: ["patreon"]
          }
        }]
      }, {
        key: "foundry-modules",
        name: t("Foundry Modules"),
        items: [{
          key: "free",
          name: t("Free Modules"),
          tags: {
            foundry: ["module"],
            price: ["free"]
          }
        }, {
          key: "installed",
          name: t("Installed"),
          tags: {
            is: ["foundry"],
            has: ["installed"]
          }
        }, {
          key: "update",
          name: t("Has Update"),
          tags: {
            is: ["foundry"],
            has: ["updates"]
          }
        }]
      }, {
        key: "foundry-system",
        name: t("Foundry System"),
        tags: {
          foundry: ["system"]
        }
      }, {
        key: "asset-packs",
        name: t("Asset Pack"),
        tags: {
          forge: ["asset"]
        }
      }, {
        key: "forge-gift-card",
        name: t("Gift Card"),
        tags: {
          forge: ["forge-gift-card"]
        }
      }],
      filterMenu: [{
        tag: "is",
        header: true,
        selectable: false,
        sort: 0
      }, {
        tag: "tag",
        header: true,
        selectable: false,
        sort: 1
      }, {
        tag: "system",
        header: true,
        selectable: false,
        sort: 2
      }, {
        tag: "language",
        header: true,
        selectable: false,
        sort: 3
      }, {
        tag: "price",
        header: true,
        selectable: false,
        sort: 4
      }, {
        tag: "has",
        header: true,
        selectable: false,
        sort: 5
      }],
      dndbeyondDataCacheKey: "forge-bazaar-dndbeyond",
      /**
       * The IndexedDB database to store cached packages in.
       *
       * From client/constants.js
       */
      packageCacheDB: globalThis.bazaarCachingKeys.db,
      /**
       * The row to store cached packages in.
       *
       * This row is stored in `this.packageCacheTable`, which is set in
       * the component's computed props.
       *
       * @see client/constants.js - That's is where this is set.
       */
      packageCacheTable: globalThis.bazaarCachingKeys.table,
      decompressedData: ""
    };
  },
  watch: {
    hash: {
      handler() {
        if (!this.convertHashFromPreviousVersion()) {
          this.updatePropsFromHash();
        }
      },
      deep: true
    },
    filterTags: {
      handler() {
        const hash = {};
        for (let [k, v] of Object.entries(this.filterTags)) {
          if (!v || v.length === 0) {
            delete this.filterTags[k];
            continue;
          }
          hash[k] = v instanceof Array ? v.join(",") : v;
        }
        hash.sort = `${this.sort.dir === "desc" ? "-" : ""}${this.sort.key}`;
        hash.package = this.currentPackage && this.currentPackage.name;
        const builtHash = `#${Utils.buildHash(hash)}`;
        if (this.hash !== builtHash) {
          this.hash = window.location.hash = builtHash;
        }
      },
      deep: true
    },
    sort: {
      handler(newValue) {
        const sortObj = {
          sort: `${newValue.dir === "desc" ? "-" : ""}${newValue.key}`
        };
        const hash = Utils.hashProps(window.location.hash);
        this.hash = window.location.hash = `#${Utils.buildHash(hash, sortObj)}`;
      },
      deep: true
    },
    installWorldVisible(val) {
      if (!val && this.installWorldResolve) {
        this.installWorldResolve(false);
      }
    },
    currentPackage() {
      const currentPackage = this.currentPackage;
      if (currentPackage && !currentPackage.fullyLoaded && !currentPackage.loading) {
        currentPackage.loading = true;
        Utils.api(`bazaar/package/${currentPackage.name}?full=1&manifest=1${this.coreVersion ? `&coreVersion=${this.coreVersion}` : ""}`).then(resp => {
          if (resp.success) {
            for (const key in resp.package) {
              // Need to use $set so that it is reactive to the new fields being added
              this.$set(currentPackage, key, resp.package[key]);
            }
            this.$set(currentPackage, "manifest", resp.manifest);
          }
          currentPackage.fullyLoaded = true;
          currentPackage.loading = false;
          this.showFullPackage = true;
        });
      }
      this.showFullPackage = !!currentPackage; // && currentPackage.loading === false;
    }
  },

  computed: {
    filteredPackages() {
      return this.searchUtil.search(this.allPackages, this.filterTags);
    },
    sortedPackages() {
      const sortedPackages = Sort.sort(this.filteredPackages, this.sort);
      // In order to maintain Vue reactivity, we have to return a new array
      return Array.from(sortedPackages);
    },
    searchTags() {
      return this.searchUtil.searchTags;
    },
    showFoundry() {
      return Object.keys(this.filterTags).length === 0 || this.filterTags.foundry || this.filterTags.category || this.filterTags.is && this.filterTags.is.includes("foundry") || this.filteredPackages.some(p => ["system", "module", "world"].includes(p.type));
    },
    updateCount() {
      return this.allPackages.filter(p => p.installed && p.latest && p.installed !== p.latest && !!p.versions.length).length;
    },
    hasDnDBeyond() {
      return Object.keys(this.filterTags).length && this.filteredPackages.some(p => p.type === "dndbeyond") || this.filterTags.is && this.filterTags.is.includes("dndbeyond") || this.filterTags.dndbeyond;
    },
    hasAssetPacks() {
      return Object.keys(this.filterTags).length && this.filteredPackages.some(p => p.type === "asset") || this.filterTags.forge && this.filterTags.forge.includes("asset");
    },
    allUpdatesPackages() {
      return this.allPackages.filter(p => !p.custom && p.installed && p.latest && p.installed !== p.latest && !!p.versions.length);
    },
    allCustomPackages() {
      return this.allPackages.filter(p => p.custom);
    },
    allMarketplacePackages() {
      return this.allPackages.filter(p => p.premium === "marketplace");
    },
    manifestInstallerType() {
      return this.filterTags && this.filterTags.foundry && this.filterTags.foundry[0] || "module";
    },
    userInstallsCacheKey() {
      return `forge-bazaar-installs-${this.username}`;
    },
    allPresets() {
      const presets = this.presets;
      if (this.creator) {
        presets.unshift({
          key: "creator-modules",
          name: t("Creator Modules"),
          items: [{
            key: "my-modules",
            name: t("My Modules"),
            tags: {
              creator: [`=${this.creator}`]
            },
            sort: {
              key: "newest",
              dir: "asc"
            }
          }]
        });
      }
      return presets;
    },
    packageCacheKey() {
      return globalThis.bazaarCachingKeys.row(this.coreVersion);
    }
  },
  methods: {
    updatePropsFromHash() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        const originalHash = {
          ...hash
        };
        // Update the package
        if (hash.package) {
          if (this.packages.length) {
            const pkg = this.allPackages.find(
            // A custom manifest may have a conflicting name with a Bazaar package. To be sure we address the correct package, we also check the hash for a "custom" flag
            p => p.name === hash.package && Boolean(p.custom) === Boolean(hash.custom));
            this.currentPackage = pkg;
          } else {
            this.displayPackageId = hash.package;
          }
          delete hash.package; // Remove it from the function's hash variable so that filter tags doesn't try and use it
        } else {
          this.currentPackage = null;
        }
        // Update the sort component
        if (hash.sort) {
          const oldSort = JSON.stringify(this.sort);
          const newSort = {
            key: hash.sort.startsWith("-") ? hash.sort.substring(1) : hash.sort,
            dir: hash.sort.startsWith("-") ? "desc" : "asc"
          };
          // If the sort key is not valid, then use the default sort
          if (!Object.entries(Sort.sortTags).find(([key, val]) => key === newSort.key && val.visible !== false)) {
            newSort.key = Sort.defaultSort;
            // Replace the hash if the sort key is invalid
            this.hash = window.location.hash = `#${Utils.buildHash(originalHash, {
              sort: Sort.defaultSort
            })}`;
          }
          if (oldSort !== JSON.stringify(newSort)) {
            this.sort = newSort;
          }
          delete hash.sort;
        }
        // Update the Search and Filter components
        const newTags = {};
        for (let [k, v] of Object.entries(hash)) {
          newTags[k] = Search.splitString(v, ",");
        }
        if (JSON.stringify(this.filterTags) !== JSON.stringify(newTags)) {
          this.filterTags = newTags;
        }
      } else {
        // Clear the search
        this.filterTags = {};
        this.sort = {
          key: Sort.defaultSort,
          dir: "asc"
        };
        this.currentPackage = null;
      }
    },
    convertHashFromPreviousVersion() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        let newhash = {};
        switch (hash.type) {
          case "module":
          case "system":
          case "world":
            newhash.foundry = hash.type;
            break;
          case "asset":
          case "forge-gift-card":
            newhash.forge = hash.type;
            break;
          case "dndbeyond":
            newhash.is = hash.type;
            break;
        }
        switch (hash.filter) {
          case "premium":
          case "marketplace":
          case "patreon":
            newhash.price = hash.filter;
            break;
          case "installed":
          case "updates":
          case "custom":
            newhash.has = hash.filter;
            break;
          case "sale":
            newhash.price = "on-sale";
            break;
          case "dndb-rules":
            newhash.dndbeyond = "rule";
            break;
          case "dndb-adventures":
            newhash.dndbeyond = "adventure";
            break;
        }
        switch (hash.sort) {
          case "updated":
            newhash.sort = "latest";
            break;
          case "installs":
            newhash.sort = "installs";
            break;
          case "title":
            newhash.sort = "name";
            break;
        }
        if (hash.search) {
          try {
            const searchArray = JSON.parse(hash.search);
            const tags = [];
            const language = [];
            const terms = [];
            const tagOptions = this.searchTags.tag.options();
            for (const search of searchArray) {
              let [tag, text] = search.split(":");
              if (tag === "category") {
                const bazaarTag = tagOptions.find(t => t.name === text);
                tags.push(bazaarTag ? bazaarTag.key : text);
              } else if (tag === "language") {
                language.push(text);
              } else {
                if (text) {
                  tag = `${tag}:${text}`;
                }
                if (tag.indexOf(" ") > -1) {
                  tag = `"${tag}"`;
                }
                terms.push(tag);
              }
            }
            if (tags.length) {
              newhash.tag = tags.join(",");
            }
            if (language.length) {
              newhash.language = language.join(",");
            }
            if (terms.length) {
              newhash.terms = terms.join(",");
            }
          } catch {
            // Failed to parse the search hash prop. Swallow the error and move on.
          }
        }
        if (Object.keys(newhash).length) {
          this.hash = window.location.hash = `#${Utils.buildHash(newhash)}`;
          return true;
        }
        return false;
      }
    },
    async loadPackages(packages = []) {
      this.loadingPackages = true;

      // Need to have these fields set in advance so they can be reactive
      packages.forEach(pkg => {
        pkg.installed = null;
        pkg.processing = false;
        pkg.entitled = false;
        pkg.entitlement = "";
        pkg.purchased = false;
        pkg.fullyLoaded = false;
        pkg.locked = false;
        pkg.versionToInstall = pkg.latest;
      });
      this.searchUtil.init(packages).then(() => {
        // Initializing is only really used to make sure the filter component doesn't load before the packages get loaded
        if (this.$refs.filterField) {
          this.$refs.filterField.refresh();
        }
      });
      let dndbeyondData = localStorage.getItem(this.dndbeyondDataCacheKey);
      if (dndbeyondData) {
        dndbeyondData = JSON.parse(dndbeyondData);
        packages = this.updateDDBContent(packages, dndbeyondData);
      }

      // Get the install information from cache
      // If the data doesn't exist yet, then it should be on it's way
      // If the data does exist, then use it, but the installs could be refreshed when they are loaded
      // Loading the installs will handle what to do when we get that information
      let installData = localStorage.getItem(this.userInstallsCacheKey);
      this.installsCollected = true;
      if (installData) {
        installData = JSON.parse(installData);
        packages = this.addInstallsToPackages(packages, installData);
      }
      this.packages = packages;
      this.loadingPackages = false;
    },
    /**
     * Given an array of updated packages and an array of existing packages,
     * update the package cache and load the updated set of packages.
     *
     * @param updates {Array}  The list of updated packages to cache.
     * @param packages {Array}  The existing set of packages, likely from cache.
     * @param schema {Number}  The schema version of the package cache.
     *
     * @async
     */
    async updatePackages(updates, packages, schema) {
      let packageUpdates = [];
      try {
        const originalPackageCount = packages.length;
        // Get an array of all id's from updates, and an array of all updates that have more than just the id property
        const updatedPackageIDs = updates.map(u => u.id);
        const updatedPackages = updates.filter(u => Object.keys(u).length > 1);

        // Remove the packages that don't have an id in updatedPackageIDs, and any that are in the updates array
        // Then add the updates
        packageUpdates = packages.filter(p => updatedPackageIDs.includes(p.id) && !updatedPackages.find(u => u.id === p.id)).concat(updatedPackages);
        if (updatedPackages.length || packageUpdates.length !== originalPackageCount) {
          try {
            await this.compressPackages(packageUpdates, schema);
          } catch (e) {
            console.error(e);
          }
        }
      } catch {
        throw new Error("Failed to update the Bazaar package cache");
      } finally {
        this.loadPackages(packageUpdates);
      }
    },
    loadCart(cart) {
      // If we are purchasing a package, then do it now
      this.cart = cart || [];
      if (this.installsLoaded) {
        this.postLoadPackageHandling();
      }
    },
    loadInstalls() {
      console.log("Please wait while we verify your content");
      Utils.api("bazaar/installs").then(({
        success,
        systems,
        modules,
        assets,
        entitlements
      }) => {
        if (!success) {
          this.installsLoaded = true;
          return;
        }
        const saveData = JSON.stringify({
          systems: systems,
          modules: modules,
          assets: assets,
          entitlements: entitlements
        });

        // Compare this with the cache to see if we need to refresh the data
        let installData = localStorage.getItem(this.userInstallsCacheKey);
        if (installData && installData === saveData) {
          this.canInstall = true;
          this.installsLoaded = true;
          if (!this.loadingPackages) {
            this.postLoadPackageHandling();
          }
          console.log("Content verified, cache matches data, no need to refresh, thank you for your patience");
          return; // Data is the same, no need to refresh the packages
        }

        localStorage.setItem(this.userInstallsCacheKey, saveData);
        // If the packages havn't loaded yet, then they'll be refreshed from the cache when they do
        if (!this.loadingPackages) {
          // Packages have already loaded, we need to refresh them
          this.packages = this.addInstallsToPackages(this.packages, {
            systems: systems,
            modules: modules,
            assets: assets,
            entitlements: entitlements
          });
          this.postLoadPackageHandling();
        } else if (this.loadingPackages && this.installsCollected && !this.packages.length) {
          // The packages are still loading, the installs have already been collected, but the packages are not ready yet
          // We should never get here, but if we do then we need to update the packages as soon as the packages are ready
          this.$nextTick(() => {
            if (this.packages.length) {
              this.packages = this.addInstallsToPackages(this.packages, {
                systems: systems,
                modules: modules,
                assets: assets,
                entitlements: entitlements
              });
              this.postLoadPackageHandling();
            }
          });
        }
        console.log("Content verified, cache refreshed, package liste updated, thank you for your patience");
        this.canInstall = true;
        this.installsLoaded = true;
      });
    },
    addInstallsToPackages(packages, installs) {
      if (!packages) {
        packages = this.packages;
      }
      let customPackages = [];
      this.installedSystems = installs.systems || [];
      this.installedModules = installs.modules || [];
      this.installedAssets = installs.assets || [];
      this.entitlements = installs.entitlements || [];
      this.updateEntitlements(packages);
      for (let installed of [...installs.systems, ...installs.modules]) {
        const pkg = Bazaar.findPackage(installed, packages);
        if (!pkg) {
          customPackages.push(Bazaar.customPackageToBazaar(installed.type, installed));
          continue;
        }
        pkg.installed = String(installed.version);
        pkg.secret = installed.secret;
        pkg.locked = installed.locked;
        // If the package is premium but not in the user's entitlements, consider it as a custom installed package
        if (pkg.premium && !this.entitlements.find(p => p.type === installed.type && p.name === pkg.name)) {
          pkg.custom = true;
          pkg.manifest = installed.manifest;
          pkg.latest = null;
          pkg.versions = [pkg.installed];
          pkg.versionToInstall = null;
          pkg.purchased = false;
          pkg.fullyLoaded = true;
        }
      }
      for (let pack of installs.assets) {
        const pkg = packages.find(p => p.type === "asset" && p.name === pack.name);
        if (!pkg) {
          continue;
        }
        pkg.installed = String(pack.version);
        pkg.secret = pack.secret;
      }
      this.customPackages = customPackages;
      return packages;
    },
    async loadPromotions() {
      const response = await Utils.api("bazaar/promotions");
      if (response.success) {
        this.promotionSlides = response.promotions;
      }
    },
    loadDDBContent() {
      Utils.api("bazaar/dndbeyond").then(dndbeyond => {
        if (dndbeyond && dndbeyond.packages) {
          let dndbeyondData = localStorage.getItem(this.dndbeyondDataCacheKey);
          const saveData = JSON.stringify({
            packages: dndbeyond.packages
          });
          if (saveData === dndbeyondData) {
            return;
          }
          localStorage.setItem(this.dndbeyondDataCacheKey, saveData);
          if (!this.loadingPackages) {
            this.packages = this.updateDDBContent(this.packages, dndbeyond);
          }
        }
      });
    },
    updateDDBContent(packages, dndbeyond) {
      dndbeyond.packages.forEach(pkg => {
        pkg.installed = null;
        pkg.processing = false;
        pkg.purchased = false;
        pkg.fullyLoaded = true;
      });
      packages = packages.filter(p => p.type !== "dndbeyond");
      packages.push(...dndbeyond.packages);
      return packages;
    },
    postLoadPackageHandling() {
      if (this.purchasePackageId && this.purchasePackageGift !== null) {
        const pkg = this.allPackages.find(p => p.id === this.purchasePackageId);
        if (pkg) {
          this.purchasePackage(pkg, this.purchasePackageGift);
        }
      } else if (this.displayPackageId) {
        const pkg = this.allPackages.find(p => p.name === this.displayPackageId);
        this.currentPackage = pkg;
        this.displayPackageId = null;
      }
    },
    updateEntitlements(packages) {
      if (!packages) {
        packages = this.packages;
      }
      for (let entitlement of this.entitlements) {
        const pkg = Bazaar.findPackage(entitlement, packages);
        if (pkg) {
          pkg.entitled = true;
          pkg.purchased = entitlement.entitlement === "purchase";
          pkg.entitlement = entitlement.entitlement;
        } else if (entitlement.title) {
          // If entitled package is not available, and we receive the full pkg info, then add it to the list of packages
          // This ensures that if a package was purchased, then removed from the Bazaar. People who bought it can still install it
          const installedArray = this[`installed${Utils.capitalize(entitlement.type)}s`] || [];
          const installed = installedArray.find(pkg => pkg.name === entitlement.name);
          entitlement.secret = installed && installed.secret;
          this.$set(entitlement, "installed", installed && installed.version);
          this.$set(entitlement, "processing", false);
          this.$set(entitlement, "entitled", true);
          this.$set(entitlement, "purchased", true);
          this.$set(entitlement, "fullyLoaded", true);
          packages.push(entitlement);
        }
      }
    },
    async updatePackage(pkg) {
      return this.installPackage(pkg, false);
    },
    closedManifestDialog() {
      this.manifestImportStatus = "";
    },
    addPackageTag(tag) {
      this.showFullPackage = false;
      this.addTag(tag);
    },
    addTag(tag) {
      const [key, value] = tag.split(":");
      // confirm that key and value is valid
      if (key && value && this.searchTags[key]) {
        const searchTag = this.searchTags[key];
        if (!searchTag.strict || searchTag.options && searchTag.options().find(o => o.key === value)) {
          // Add the tag to the filterTags (which will trigger a re-render)
          const tags = {};
          tags[key] = [value];
          this.filterTags = tags;
        }
      }
    },
    showPackage(pkg, hash) {
      this.showUpdateAll = false;
      //this.currentPackage = pkg;
      hash = hash || Utils.hashProps(window.location.hash);
      // A custom manifest may have a conflicting name with a Bazaar package. To be sure we display the correct package, we also pass a "custom" flag
      this.hash = window.location.hash = `#${Utils.buildHash(hash, {
        package: pkg?.name,
        custom: pkg?.custom
      })}`;
    },
    worldInstalled(event) {
      if (this.installWorldResolve) {
        this.installWorldResolve(event);
      }
    },
    loadIntegrations() {
      Utils.api("profile/integrations").then(response => {
        if (response.success) {
          this.userIntegrations = response;
        } else if (response.error && response.code !== 401) {
          UI.error(t("Error retrieving account information: {{- error}}", {
            error: response.error || t("Unknown Error")
          }));
        }
      });
    },
    emptyCart() {
      this.cartUpdated(null);
    },
    checkoutCart() {
      this.addToCart = null;
      this.cartVisible = true;
    },
    async cartUpdated(cart) {
      const response = await Utils.api("bazaar/cart", {
        cart: cart
      });
      this.cart = response.cart || [];
    },
    async cartPurchased() {
      const entitlements = await Utils.api("profile/entitlements");
      if (!entitlements.error) {
        this.entitlements = entitlements;
        this.updateEntitlements(this.packages);
      }
    },
    async installDDBManifest() {
      const result = await UI.query(t(`Download D&D Beyond content list`), `<p>${t("In order to display available content, The Forge will need to fetch the list of source books from D&D Beyond on your behalf. The Forge does not own or distribute this content—we are merely converting content you own from one format to another.")}</p>
        <p>${t("This operation will take some time and will use a small portion of your Data and Assets storage.")}</p>
        <p>${t("Do you authorize The Forge to access D&D Beyond on your behalf and upload the content to your personal storage space on The Forge?")}</p>`, {
        buttons: [{
          id: "import-no",
          type: "danger",
          label: t("Cancel"),
          response: "no"
        }, {
          id: "import-yes",
          type: "success",
          label: t(`Import`),
          response: "yes"
        }],
        dialog_classes: "modal-lg modal-dialog-centered"
      });
      if (result !== "yes") {
        return;
      }
      this.importingDDB = t("Downloading D&D Beyond content listing");
      const response = await Utils.apiTask(`bazaar/dndbeyond/import`, null, null, {
        status: (status, response) => {
          this.importingDDB = {
            download: t("Downloading D&D Beyond content listing"),
            assets: t("Uploading to Assets Library the downloaded content")
          }[status] || t("Installing D&D Beyond content");
        }
      });
      if (response.error) {
        UI.alert("danger", t(`Failed to import content: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.importingDDB = t("Done importing D&D Beyond content listing");
        this.loadDDBContent();
      }
      this.importingDDB = "";
    },
    purchasePackage(pkg, gift = false) {
      this.addGiftToCart = gift;
      this.addToCart = pkg;
      this.cartVisible = true;
    },
    purchaseGiftPackage(pkg) {
      return this.purchasePackage(pkg, true);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    toggleSidebarCollapse() {
      this.filterCollapsed = !this.filterCollapsed;
      this.saveStateToStorage();
    },
    remToPx(rem) {
      return rem * (this.$el ? parseFloat(getComputedStyle(this.$el).fontSize) : 15);
    },
    windowResize() {
      // Change sidebar behaviour based on viewport width
      this.largeBreakpoint = this.largeBreakpoint || 1000;
      if (this.$el) {
        this.largeBreakpoint = Number(getComputedStyle(this.$el).getPropertyValue("--breakpoint-lg").replace(" ", "").replace("px", ""));
      }
      this.smallScreen = window.innerWidth < this.largeBreakpoint;
      if (window.innerWidth <= 550) {
        const width = window.innerWidth - $(".sidebar-panel").offset().left * 3;
        this.panelWidth = `${width}px`;
      } else {
        this.panelWidth = "350px";
      }
    },
    loadStateFromStorage() {
      if (!localStorage.bazaar) {
        console.log("First time mounting Bazaar, saving default configuration.");
        this.saveStateToStorage();
      } else {
        const saved = JSON.parse(localStorage.bazaar);
        // Load configuration from localStorage, making sure not to overwrite any attrs with undefined/null/etc...
        if (saved.filterCollapsed !== undefined) {
          this.filterCollapsed = saved.filterCollapsed;
        } else if (this.filterCollapsed === undefined) {
          this.filterCollapsed = !this.smallScreen;
        }
      }
    },
    saveStateToStorage() {
      localStorage.bazaar = JSON.stringify({
        filterCollapsed: this.filterCollapsed === undefined ? !this.smallScreen : this.filterCollapsed
      });
    },
    /**
     * Given a list of Bazaar packages, compress them and store them
     * to IndexedDB.
     *
     * @param packages {Array}  The packages to compress.
     * @param schema {Number}  The schema version of the package cache.
     * @async
     */
    async compressPackages(packages, schema) {
      if (!packages || !Array.isArray(packages)) {
        throw new TypeError("Invalid JSON array provided.");
      }
      try {
        await Utils.compressAndStore(packages, this.packageCacheDB, this.packageCacheTable, this.packageCacheKey, schema, globalThis.INDEXEDDB_VERSION_BAZAAR);
      } catch {
        throw new Error("Failed to compress packages");
      }
      Utils.Logger.info("Bazaar Cache", "Package list successfully cached.");
    },
    /**
     * Rehydrate existing cached packages.
     * @async
     */
    async decompressPackages() {
      return await Utils.retrieveAndDecompress(this.packageCacheDB, this.packageCacheTable, this.packageCacheKey, globalThis.INDEXEDDB_VERSION_BAZAAR);
    },
    /**
     * Attempt to get cached packages and the last updated date, and
     * rehydrate/update the cached data if it exists.
     *
     * If it doesn't exist, fetch the most recent package list and cache it.
     *
     * If we can't cache, don't cache. The most likely case for this is Safari,
     * due to its quirks with IndexedDB.
     *
     * Depending on how we get our package data, we restore the user's cart with
     * either a dedicated API call or with data from an API call that fetches
     * all of the Bazaar data.
     */
    async preparePackageListFromCached() {
      let packageData, lastSchema, lastUpdate, cart;
      try {
        ({
          packageData,
          schema: lastSchema,
          lastUpdate
        } = await this.decompressPackages());
        if (!lastUpdate) {
          throw new TypeError("Last updated time is unset.");
        }
      } catch {
        Utils.Logger.info("Bazaar Cache", "Failed to retrieve cached packages, or packages have not yet been cached. Falling back to the uncached state.");
        localStorage.removeItem("forge-bazaar-last-update");
      }
      if (packageData && lastUpdate) {
        try {
          const packageUpdateParams = new URLSearchParams({
            lastUpdate,
            coreVersion: this.coreVersion,
            schema: lastSchema || 0
          });
          const {
            packages,
            schema
          } = await Utils.api(`bazaar/package-updates?${packageUpdateParams}`);
          this.updatePackages(packages, packageData, schema);
          Utils.Logger.info("Bazaar Cache", "Cached packages successfully rehydrated.");
        } catch {
          Utils.Logger.info("Bazaar Cache", "Failed to update cached packages. Falling back to last known package list.");
          localStorage.removeItem("forge-bazaar-last-update");
          this.loadPackages(packageData);
          // There was an error with the updates, clear the cache and use what we currently have. Next refresh will get the full data
          Utils.clearDBEntry(this.packageCacheDB, this.packageCacheTable, this.packageCacheKey);
        }
        ({
          cart
        } = await Utils.api(`bazaar/cart`));
      } else {
        // If the package is not in the local cache, make a full call to
        // the server to get the data and update the last update time
        try {
          let packages, schema;
          ({
            packages,
            cart,
            schema
          } = await Utils.api(`bazaar${this.coreVersion ? `?coreVersion=${this.coreVersion}` : ""}`));
          try {
            this.compressPackages(packages, schema);
          } catch (e) {
            // The package object failing to compress doesn't necessarily mean
            // that we can't use the package list. Log the error and continue.
            console.error(e);
          }
          this.loadPackages(packages);
        } catch (e) {
          console.error(e);
        }
      }
      this.loadCart(cart);
    }
  },
  /**
   * Perform some data operations before making the Bazaar available for use:
   *
   * 1. Prepares the package list, from either cache or the server.
   * 2. Loads user-specific data if a username is present.
   * 3. Checks the URL hash to handle package purchases and updates
   *    component properties based on the hash.
   * 4. Sets up a listener to update the component properties when the
   *    URL hash changes.
   *
   * @async
   * @returns {Promise<void>} A promise that resolves once all initialization tasks are complete.
   */
  async created() {
    await Promise.all([this.preparePackageListFromCached(), this.loadPromotions()]);
    if (this.username) {
      this.loadDDBContent();
      this.loadIntegrations();
      this.loadInstalls();
    } else {
      this.installsLoaded = true;
    }

    // Check to see if we are purchasing a package and clear it from the cache so it doesn't keep opening up
    const hash = Utils.hashProps(window.location.hash);
    if ((hash.package || hash.id) && hash.purchase) {
      this.purchasePackageId = hash.package || hash.id;
      this.purchasePackageGift = hash.purchase === "gift";
      hash.purchase = null;
      hash.package = null;
      window.location.hash = `#${Utils.buildHash(hash)}`;
    }
    if (!this.convertHashFromPreviousVersion()) {
      this.updatePropsFromHash();
    }
    this.hash = window.location.hash;
    window.addEventListener("hashchange", () => {
      this.hash = window.location.hash;
    });
    window.addEventListener("scroll", () => {
      this.showScrollToTop = window.scrollY > 950;
    });
  },
  async mounted() {
    // Limit height to fit within the viewport
    this.windowResize();
    window.addEventListener("resize", this.windowResize);

    // Load last state from localStorage
    this.loadStateFromStorage();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarTagsDropdown"] = Vue.component(
                    "BazaarTagsDropdown",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"position-absolute w-100 bazaar-tag-dropdown-container\"> <b-collapse v-model=\"visible\"> <b-card no-body class=\"w-100 px-3 py-2 bazaar-tag-dropdown\"> <slot></slot> <nav-tree v-model=\"availableTags\" class=\"w-100\" :collapsible=\"canCollapse\" v-on=\"$listeners\"> <template #itemrow=\"{ item, toggle, expanded }\"> <b-row class=\"align-items-center\" :class=\"item.children ? 'border-bottom' : ''\" @click.stop.prevent=\"toggle(item)\" > <b-col class=\"p-0 no-select\"> <b-badge v-if=\"item.clickable\" class=\"bazaar-dropdown-item\" :variant=\"tagDropdownItemVariant(item)\" @click.stop.prevent=\"selectTag(item)\" > <i v-if=\"item.selected\" class=\"fas fa-check\"></i> {{ item.label }} </b-badge> <span v-else> {{ item.label }} </span> </b-col> <b-col v-if=\"item.children && canCollapse\" class=\"flex-grow-0 py-1 mr-1\"> <i v-if=\"!expanded[item.id]\" class=\"fas fa-plus\"></i> <i v-else class=\"fas fa-minus\"></i> </b-col> </b-row> </template> </nav-tree> <b-nav-text v-if=\"availableTags.length === 0\" class=\"text-center\"> {{ noTagMessage }} </b-nav-text> </b-card> </b-collapse> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-tag-dropdown-container { left: 0px; top: 100%; z-index: 100; min-width: 400px; } input + .bazaar-tag-dropdown-container { min-width: unset; margin-left: 8px; width: calc(100% - 16px) !important; } .bazaar-tag-dropdown-container .card { border-top-left-radius: 0px; border-top-right-radius: 0px; } .bazaar-tag-dropdown { max-height: 500px; overflow-y: auto; } .bazaar-dropdown-item { font-size: 0.9rem; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    selection: {
      type: Array,
      default: []
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    filter: {
      type: String,
      default: ""
    },
    noTagMessage: {
      type: String,
      default: t("There are no tags available to select")
    }
  },
  data() {
    return {
      maxTagDepth: 8
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    canCollapse() {
      return !this.filter || this.filter.length < 2;
    },
    availableTags() {
      // Localised function to test if the tag is part of the current search
      const isPartOfSearch = bazaarTag => {
        return !this.filter || bazaarTag.label.toLowerCase().includes(this.filter.toLowerCase());
      };

      // Localised function to collect the children of a parent tag
      const getChildren = (parent, depth) => {
        if (depth > this.maxTagDepth) {
          // Make sure we don't run into a circular loop
          return [];
        }
        return this.tags
        // Find the ones that are visible, and a child of this parent
        .filter(t => t.visible && t.parent === parent)
        // Get the data for the child
        .map(t => {
          const result = {
            id: `${t.parent || "_"}.${t.tag}`,
            label: t.label,
            clickable: t.selectable,
            displayOrder: t.displayOrder,
            disabled: t.disabled,
            selected: !!this.selection.find(bt => t.tag === bt) && t.selectable,
            original: t
          };
          const children = getChildren(t.tag, depth + 1);
          if (children.length) {
            result.children = children;
          }
          return result;
        })
        // Check to see if these children are part of the current search
        .filter(t => t.clickable && isPartOfSearch(t) || t.children && t.children.length).sort((a, b) => {
          // Sort by displayOrder, then label
          if (a.displayOrder !== b.displayOrder) {
            return a.displayOrder - b.displayOrder;
          }
          return a.label.localeCompare(b.label);
        });
      };
      return getChildren(null, 0);
    }
  },
  methods: {
    tagDropdownItemVariant(item) {
      if (item.selected) {
        return "success";
      }
      if (item.disabled || !this.canSelect) {
        return "secondary";
      }
      return "info";
    },
    selectTag(item) {
      if (item.disabled) {
        return;
      }
      this.$emit("selected", item.original);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarUpdateAll"] = Vue.component(
                    "BazaarUpdateAll",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"t('Update all Packages')\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <div class=\"mb-4\"> {{ t(\"If your game is currently online, make sure to restart the server for the updates to take effect.\") }}<br /> </div> <div class=\"bazaar-updates-list\" @wheel=\"scrollWheel\"> <vue-scroll ref=\"vuescroll\" :ops=\"scrollOps\"> <bazaar-update-all-list ref=\"nativePackages\" :custom=\"false\" :packages=\"packages\" @lock-packages=\"lockPackages\" @selected-change=\"setSelected\" @check-update=\"checkUpdate\" @update=\"updatePackage\" @processing=\"setProcessing\" @done=\"setDone\" @show-package=\"$emit('show-package', $event)\" > </bazaar-update-all-list> <bazaar-update-all-list ref=\"customPackages\" :custom=\"true\" :packages=\"customPackages\" @lock-packages=\"lockPackages\" @selected-change=\"setSelected\" @check-update=\"checkUpdate\" @done-check-updates=\"customUpdatesChecked\" @update=\"updatePackage\" @processing=\"setProcessing\" @done=\"setDone\" @show-package=\"$emit('show-package', $event)\" > </bazaar-update-all-list> </vue-scroll> </div> <template #modal-footer=\"{ cancel }\"> <b-button v-if=\"processing\" variant=\"primary\" disabled ><loading-indicator tag=\"span\" small :label=\"t('Working…')\"> </loading-indicator ></b-button> <b-button v-else-if=\"allSelected && hasModulesToUpdate\" variant=\"success\" :disabled=\"done\" @click=\"updateAll\">{{ t(\"Update All\") }}</b-button> <b-button v-else-if=\"selected.native && hasModulesToUpdate\" variant=\"success\" :disabled=\"done\" @click=\"updateAll\" >{{ t(\"Update Selected\") }} </b-button> <b-button v-else-if=\"selected.custom && hasModulesToUpdate\" variant=\"success\" :disabled=\"done\" @click=\"updateAll\"> {{ t(\"Update Custom\") }} </b-button> <b-button v-else-if=\"!updatesChecked\" variant=\"warning\" :disabled=\"done\" @click=\"checkUpdates\">{{ t(\"Check for Updates\") }}</b-button> <b-button v-else-if=\"lockDiff.length\" variant=\"success\" :disabled=\"done\" @click=\"updateAll\">{{ t(\"Lock Versions without Updating\") }}</b-button> <b-button v-else-if=\"done\" variant=\"primary\" disabled>{{ t(\"Updates Completed\") }}</b-button> <div v-else-if=\"(!selected.native || !selected.custom) && !lockDiff.length\" v-b-tooltip.hover :title=\"t('You have locked all package versions and have not selected any packages to update above')\" > <b-button variant=\"outline-primary\" disabled>{{ t(\"No Updates\") }}</b-button> </div> <b-button variant=\"secondary\" @click=\"cancel\">Close</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-updates-list { max-height: calc(75vh - 150px); height: calc(75vh - 150px); }"
    });
  },
  props: {
    value: Boolean,
    type: String,
    packages: Array,
    customPackages: Array
  },
  data() {
    return {
      childProcessing: {
        native: false,
        custom: false
      },
      childDone: {
        native: false,
        custom: false
      },
      selected: {
        // Tri-state values: 0=none, 1=some, 2=all
        native: 0,
        custom: 0
      },
      updatesChecked: false,
      scrollOps: {
        vuescroll: {
          mode: "slide",
          zooming: false
        },
        scrollPanel: {
          scrollingX: false
        },
        rail: {},
        bar: {
          keepShow: true
        }
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    processing() {
      return this.childProcessing.native || this.childProcessing.custom;
    },
    done() {
      return this.childDone.native && this.childDone.custom;
    },
    hasModulesToUpdate() {
      return this.packages.length || this.customPackages.length;
    },
    allSelected() {
      const getUpdateable = p => p.oldVersion !== p.versionToInstall;
      if (!this.selected.native && !this.selected.custom) {
        return false;
      }
      const allNativeSelected = !this.packages.some(getUpdateable) || this.selected.native === 2;
      const allCustomSelected = !this.customPackages.some(getUpdateable) || this.selected.custom === 2;
      return allNativeSelected && allCustomSelected;
    },
    lockDiff() {
      const lockDiff = [];
      if (this.$refs.nativePackages && this.$refs.customPackages) {
        if (this.$refs.nativePackages.lockDiff.length) {
          lockDiff.concat(this.$refs.nativePackages.lockDiff);
        }
        if (this.$refs.customPackages.lockDiff.length) {
          lockDiff.concat(this.$refs.customPackages.lockDiff);
        }
      }
      return lockDiff;
    }
  },
  methods: {
    dialogShown() {
      this.$refs.nativePackages.init();
      this.$refs.customPackages.init();
      this.childDone.native = false;
      this.childDone.custom = false;
    },
    setProcessing(value, custom) {
      if (!custom) {
        this.childProcessing.native = value;
      } else {
        this.childProcessing.custom = value;
      }
    },
    setDone(value, custom) {
      if (!custom) {
        this.childDone.native = value;
      } else {
        this.childDone.custom = value;
      }
    },
    setSelected(sel, custom) {
      if (!custom) {
        this.selected.native = sel;
      } else {
        this.selected.custom = sel;
      }
    },
    checkUpdate(pkg) {
      this.$emit("check-update", pkg);
    },
    async updatePackage(pkg) {
      this.$emit("update", pkg);
    },
    customUpdatesChecked(custom) {
      if (custom) {
        this.updatesChecked = true;
      }
    },
    async checkUpdates() {
      this.$refs.customPackages.checkUpdates();
    },
    async updateAll() {
      if (this.processing || this.done) {
        return;
      }
      // Update selected packages
      this.$refs.nativePackages.updateAll();
      this.$refs.customPackages.updateAll();

      // After updating native Bazaar packages, check if there are any custom packages
      // that need to be checked for updates.
      this.$refs.customPackages.checkUpdates();
    },
    lockPackages(packages) {
      this.$emit("lock-packages", packages);
    },
    pkgFailed(pkg) {
      return !!this.failed.find(p => p.name === pkg.name);
    },
    scrollWheel(ev) {
      this.$refs.vuescroll.scrollBy({
        dx: ev.deltaX,
        dy: ev.deltaY
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarUpdateAllList"] = Vue.component(
                    "BazaarUpdateAllList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-row class=\"font-weight-bold m-1 no-gutters\"> <b-col cols=\"1\" class=\"text-center\" ><i v-b-tooltip.hover class=\"far fa-arrow-alt-circle-up\" :title=\"t('Select packages to update. Deselected packages will have their versions locked.')\" ></i ></b-col> <b-col v-if=\"!custom\" cols=\"5\">{{ t(\"Package Name\") }}</b-col> <b-col v-else cols=\"5\">{{ t(\"Custom Package Name\") }}</b-col> <b-col cols=\"3\">{{ t(\"Installed Version\") }}</b-col> <b-col cols=\"2\">{{ t(\"New Version\") }}</b-col> <b-col cols=\"1\" class=\"text-center\">{{ t(\"Status\") }}</b-col> </b-row> <div v-if=\"!updates.length\" class=\"text-center m-2\"> <b><i18n :path=\"t('Up to Date!')\"></i18n></b> </div> <b-row v-for=\"pkg of updates\" v-else :key=\"pkg.name\" class=\"m-1\"> <b-col cols=\"1\" class=\"text-center\"> <b-form-checkbox v-model=\"pkg.selected\" :disabled=\"processing || done || !pkg.latest || pkg.oldVersion === pkg.latest\" ></b-form-checkbox> </b-col> <b-col cols=\"5\" class=\"border rounded d-flex\"> <img :src=\"`/images/bazaar/${pkg.type}-icon-32.png`\" width=\"24\" height=\"24\" />&nbsp; <b-link class=\"text-truncate flex-grow-1\" @click=\"$emit('show-package', pkg)\">{{ pkg.title }}</b-link> &nbsp; <small v-if=\"!custom\" ><a :href=\"`/bazaar/package/${pkg.name}`\" target=\"_blank\"><i class=\"fas fa-external-link-alt\"></i></a></small >&nbsp; <small v-if=\"pkg.notes\" ><a v-b-tooltip.hover :href=\"`${pkg.notes}`\" target=\"_blank\" :title=\"t('Click to open Changelog in a new tab')\" ><i class=\"fas fa-scroll\"></i></a ></small> </b-col> <b-col cols=\"2\" :class=\"`text-warning ${pkg.selected && pkg.oldVersion !== pkg.latest ? `border` : ``}`\"> {{ pkg.oldVersion }} </b-col> <b-col cols=\"1\"> <i v-show=\"pkg.selected && pkg.oldVersion !== pkg.latest\" class=\"fas fa-long-arrow-alt-right\"></i> </b-col> <b-col cols=\"2\" :class=\"`text-success ${pkg.selected && pkg.oldVersion !== pkg.latest ? `border` : ``}`\"> <span v-show=\"pkg.selected && pkg.oldVersion !== pkg.latest\">{{ pkg.latest }}</span> </b-col> <b-col cols=\"1\" class=\"rounded text-center\"> <span v-if=\"pkg.processing\" v-b-tooltip.hover class=\"text-primary\" :title=\"t('Updating…')\" ><loading-indicator tag=\"span\" small label=\"\"></loading-indicator ></span> <span v-else-if=\"pkg.custom && !pkg.manifest\" v-b-tooltip.hover class=\"text-danger\" :title=\"t('Custom module has no manifest, cannot update')\" ><i class=\"fas fa-times\"></i ></span> <span v-else-if=\"pkg.custom && !!pkg.manifest && pkg.latest_incompatible\" v-b-tooltip.hover class=\"text-danger\" :title=\"t('Latest version not compatible with your Foundry Version')\" ><i class=\"fas fa-exclamation-circle\"></i ></span> <span v-else-if=\"pkg.custom && !!pkg.manifest && !pkg.latest\" v-b-tooltip.hover class=\"text-warning\" :title=\"t('Custom module, need to check for update')\" ><i class=\"fas fa-question-circle\"></i ></span> <span v-else-if=\"!pkg.selected\" v-b-tooltip.hover class=\"text-danger\" :title=\"t('Version locked, will not update')\" ><i class=\"fas fa-lock\"></i ></span> <span v-else-if=\"pkg.selected && pkg.oldVersion === pkg.latest\" v-b-tooltip.hover class=\"text-success\" :title=\"t('Up to date')\" ><i class=\"fas fa-check\"></i ></span> <span v-else-if=\"pkg.selected && pkg.installed !== pkg.latest && done\" v-b-tooltip.hover class=\"text-danger\" :title=\"t('Update failed')\" ><i class=\"fas fa-times\"></i ></span> <span v-else-if=\"pkg.installed !== pkg.latest\" v-b-tooltip.hover class=\"text-warning\" :title=\"t('Update pending')\" ><i class=\"far fa-arrow-alt-circle-up\"></i ></span> <span v-else v-b-tooltip.hover class=\"text-success\" :title=\"t('Updated')\"><i class=\"fas fa-check\"></i></span> </b-col> </b-row> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-updates-list { max-height: calc(75vh - 150px); height: calc(75vh - 150px); }"
    });
  },
  props: {
    custom: Boolean,
    packages: Array
  },
  data() {
    return {
      processing: false,
      done: false,
      updates: []
    };
  },
  watch: {
    processing() {
      this.$emit("processing", this.processing, this.custom);
    },
    done() {
      this.$emit("done", this.done, this.custom);
    },
    selected() {
      let sel = 0;
      if (this.updates.length) {
        if (this.allSelected) {
          sel = 2;
        } else if (this.selected.length > 0) {
          sel = 1;
        }
      }
      this.$emit("selected-change", sel, this.custom);
    }
  },
  computed: {
    lockDiff() {
      const lockDiff = [];
      for (const pkg of this.updates) {
        // Only add packages which have successfully checked for updates.
        if (!pkg.custom || pkg.manifest && pkg.latest) {
          if (!pkg.selected && !pkg.locked) {
            lockDiff.push({
              type: pkg.type,
              name: pkg.name,
              locked: true
            });
          } else if (pkg.selected && pkg.locked) {
            lockDiff.push({
              type: pkg.type,
              name: pkg.name,
              locked: false
            });
          }
        }
      }
      return lockDiff;
    },
    needsCheck() {
      if (!this.packages.length) {
        return false;
      }
      for (let pkg of this.packages) {
        if (pkg.custom && !!pkg.manifest && !pkg.latest) {
          return true;
        }
      }
      return false;
    },
    selected() {
      return this.updates.filter(p => p.selected && p.oldVersion !== p.latest && p.installed !== p.latest);
    },
    allSelected() {
      return this.selected && this.selected.length == this.updates.length;
    }
  },
  methods: {
    sortPackages(a, b) {
      // Sort first by update availability, then by type, then by title.
      const avail_a = a.latest && a.oldVersion !== a.latest;
      const avail_b = b.latest && b.oldVersion !== b.latest;
      // Note: before checking updates, avail_a and avail_b will both be null.
      const avail = !avail_a && !avail_b || avail_a && avail_b ? 0 : avail_a && !avail_b ? -1 : 1;
      if (avail != 0) {
        return avail;
      }
      const t = b.type.localeCompare(a.type);
      if (t == 0) {
        return a.title.localeCompare(b.title);
      }
      return t;
    },
    init() {
      this.done = false;
      this.updatesChecked = false;
      this.updates = this.packages.filter(p => !p.custom || !!p.manifest).map(pkg => {
        pkg.oldVersion = pkg.installed;
        // Make selected reactive. Custom package must also have a manifest and a newer version available
        this.$set(pkg, "selected", !pkg.locked && (!pkg.custom || !!pkg.manifest && pkg.latest));
        return pkg;
      }).sort(this.sortPackages);
    },
    async updateAll() {
      if (this.processing || this.done) {
        return;
      }
      this.processing = true;
      // Lock packages that aren't selected for update
      if (!this.needsCheck && this.lockDiff.length) {
        this.$emit("lock-packages", this.lockDiff);
      }
      for (let pkg of this.selected) {
        if (pkg.oldVersion !== pkg.latest && pkg.installed !== pkg.latest) {
          this.$emit("update", pkg);
          while (pkg.processing) {
            await new Promise(r => setTimeout(r, 100));
          }
        }
      }
      this.processing = false;
      this.done = !this.needsCheck;
    },
    async checkUpdates() {
      if (!this.needsCheck || this.processing || this.done) {
        return;
      }
      this.processing = true;
      // Set done true for now, will set false if there is a custom update available
      let finished = true;
      for (let pkg of this.packages) {
        this.$emit("check-update", pkg);
        while (pkg.processing) {
          await new Promise(r => setTimeout(r, 100));
        }
        if (pkg.latest) {
          // Ignore manifests that failed to fetch
          if (pkg.oldVersion !== pkg.latest) {
            pkg.selected = true;
            finished = false;
          } else if (pkg.oldVersion === pkg.latest) {
            // Set selected so that we get the checkmark on the right indicating up-to-date
            pkg.selected = true;
          }
        }
      }
      this.updates.sort(this.sortPackages);
      this.done = finished;
      this.processing = false;
      this.$emit("done-check-updates", this.custom);
    },
    pkgFailed(pkg) {
      return !!this.failed.find(p => p.name === pkg.name);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PackageList"] = Vue.component(
                    "PackageList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"loaded\"> <transition-group tag=\"div\" class=\"package-list\" :class=\"checkJustifyContent\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" > <bazaar-package-card v-for=\"pkg in displayedPackages\" :key=\"Bazaar.getDisplayedPackageKey(pkg)\" :package=\"pkg\" :user-integrations=\"userIntegrations\" :can-install=\"canInstall\" :can-select=\"canSelect\" :no-footer=\"noFooters\" :core-version=\"coreVersion\" @tag=\"$emit('tag', $event)\" @click=\"$emit('selected', $event)\" @install=\"$emit('install', $event)\" @uninstall=\"$emit('uninstall', $event)\" @check-update=\"$emit('check-update', $event)\" @purchase=\"$emit('purchase', $event)\" @ddb-installed=\"$emit('ddb-installed', $event)\" > </bazaar-package-card> </transition-group> <infinite-loading :identifier=\"infiniteId\" spinner=\"bubbles\" @infinite=\"infiniteHandler\"> <span slot=\"no-more\"></span> <h3 slot=\"no-results\"> <span v-if=\"packages.length === 0\">{{ t(\"No results found\") }}</span> </h3> </infinite-loading> </div> <loading-indicator v-else class=\"mt-4\"></loading-indicator>",
  beforeCreate() {
    Utils.loadCss({
      content: ".package-list{display:grid;grid-template-columns:repeat(auto-fit, minmax(25ch, 1fr));width:100%;gap:1em}.package-list::after{content:\"\";width:0;padding-left:calc(100% - 1em);grid-column:1/-1}"
    });
  },
  props: {
    packages: Array,
    noFooters: Boolean,
    canInstall: Boolean,
    canSelect: Boolean,
    userIntegrations: Object,
    coreVersion: String,
    minimumPackages: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loaded: false,
      infiniteId: Date.now(),
      displayedPackages: [],
      smallScreen: false,
      SMALL_SCREEN_WIDTH: 900
    };
  },
  watch: {
    packages() {
      this.displayedPackages = (this.packages || []).slice(0, Math.max(this.minimumPackages, this.displayedPackages.length));
      //this.infiniteHandler()
      this.infiniteId = Date.now();
    }
  },
  computed: {
    checkJustifyContent() {
      if (this.smallScreen) {
        return "justify-content-center";
      }
      return "";
    }
  },
  methods: {
    infiniteHandler($state) {
      if (this.packages.length === this.displayedPackages.length) {
        if ($state) {
          $state.complete();
        }
        return;
      }
      this.displayedPackages = (this.packages || []).slice(0, this.displayedPackages.length + 30);
      if ($state) {
        $state.loaded();
      }
    },
    windowResize() {
      this.smallScreen = window.innerWidth < this.SMALL_SCREEN_WIDTH;
    }
  },
  async mounted() {
    // Limit height to fit within the viewport
    this.windowResize();
    window.addEventListener("resize", this.windowResize);
  },
  async created() {
    await Utils.loadDependencies(["infinite-loading"]);
    this.loaded = true;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetDetails"] = Vue.component(
                    "AssetDetails",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"asset-details d-flex flex-column\"> <b-card v-if=\"selectedCount > 0\" no-title class=\"mt-1 mb-1 asset-details-selection-info\"> <div v-if=\"selectedMultiPath\" class=\"warning\"> <strong class=\"text-danger\">{{ t(\"Warning:\") }}</strong> {{ t(\"You have files selected from multiple different folders.\") }} </div> <div v-else-if=\"selectedOtherPath\" v-b-tooltip.hover.noninteractive class=\"warning\" :title=\"t('The princess is in another castle!')\" > <strong class=\"text-danger\">{{ t(\"Warning:\") }}</strong> {{ t(\"You have files selected in another folder.\") }} </div> <b-row> <b-col cols=\"6\">{{ t(\"Selected:\") }}</b-col> <b-col cols=\"3\"><i class=\"fas fa-folder\"></i> {{ selectedFolders }}</b-col> <b-col cols=\"3\"><i class=\"fas fa-file\"></i> {{ selectedFiles }}</b-col> </b-row> <b-row> <b-col cols=\"6\"> <strong>{{ t(\"Total Size:\") }}</strong> </b-col> <b-col cols=\"6\">{{ selectedTotalSizeH }}</b-col> </b-row> </b-card> <transition enter-active-class=\"animate__animated animate__faster animate__fadeIn\" leave-active-class=\"animate__animated animate__faster animate__fadeOut\" > <div v-if=\"file\"> <!-- Title --> <h4 class=\"asset-preview-title\">{{ name }}</h4> <div class=\"d-flex flex-column\"> <!-- Size and modified date --> <b-row> <b-col cols=\"4\" class=\"pr-1\"> <strong>{{ t(\"Size:\") }}</strong> </b-col> <b-col cols=\"8\" class=\"pl-1\">{{ sizeH }}</b-col> </b-row> <b-row> <b-col cols=\"4\" class=\"pr-1\"> <strong>{{ t(\"Modified:\") }}</strong> </b-col> <b-col cols=\"8\" class=\"pl-1\">{{ modTime }}</b-col> </b-row> <!-- Delete, open file, copy link controls --> <div class=\"d-flex justify-content-between\"> <div v-b-tooltip.hover.top class=\"w-100 mr-1\" :title=\"buttonTooltip(t('Open in New Tab'))\"> <b-button v-b-tooltip.hover.top size=\"sm\" class=\"w-100\" :disabled=\"!fileSelected\" @click=\"openLink\"> <i class=\"fas fa-external-link-alt\"></i> {{ t(\"Open\") }} </b-button> </div> <div v-b-tooltip.hover.top class=\"w-100\" :title=\"buttonTooltip(t('Copy Link'))\"> <b-button size=\"sm\" class=\"w-100\" :disabled=\"!fileSelected\" @click=\"copyLink\"> <i class=\"fas fa-link\"></i> {{ t(\"Link\") }} </b-button> </div> <div v-b-tooltip.hover.top class=\"w-100 ml-1\" :title=\"buttonTooltip(t('Set as Avatar'))\"> <b-button v-if=\"isImage && isOwner\" size=\"sm\" class=\"w-100\" :disabled=\"!fileSelected\" @click=\"setAvatar\"> <i class=\"fas fa-user-cog\"></i> {{ t(\"Avatar\") }} </b-button> </div> </div> </div> <!-- Large thumbnail --> <div class=\"asset-preview text-center img-thumbnail mt-1\"> <template v-if=\"isVideo\"> <div v-if=\"file.size > videoAutoplayMax && !loadVideo\" v-b-tooltip.hover.top class=\"w-100 h-100 click-to-play\" :title=\"t('Click to play video')\" @click=\"loadVideo = true\" > <i class=\"far fa-play-circle fa-5x\"></i> </div> <video v-else :src=\"url\" controls autoplay loop muted class=\"w-100 h-100\"></video> </template> <div v-else-if=\"isAudio\" class=\"d-flex align-items-center w-100 h-100\"> <audio :src=\"url\" controls></audio> </div> <template v-else> <a :title=\"tooltip\" :href=\"downloadUrl\" :download=\"name\" target=\"_blank\"> <b-img :src=\"thumbnailUrl\" @error=\"errorLoadingImage\"></b-img> </a> </template> </div> </div> </transition> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-details { word-wrap: break-word; } .asset-details .asset-preview-title { font-family: \"Montserrat\", sans-serif; font-size: 1.1em; font-weight: bold; } .asset-details .asset-preview { width: 100%; } .asset-details .asset-preview img { width: 100%; max-height: 14em; object-fit: contain; } .asset-details-selection-info .card-body { padding: 0.5rem; } .asset-details-selection-info .warning { font-size: 0.85rem; } .asset-details .asset-preview .click-to-play { cursor: pointer; }"
    });
  },
  props: {
    file: Object,
    fileSelected: Boolean,
    isOwner: Boolean,
    selectedStats: {
      type: Object,
      default: () => ({
        files: 0,
        folders: 0,
        totalSize: 0
      })
    },
    selectedOtherPath: Boolean,
    selectedMultiPath: Boolean
  },
  data() {
    return {
      asset_image_error: false,
      loadVideo: false,
      videoAutoplayMax: 5 * Assets.MB // 5 MB limit for rendering video previews
    };
  },

  watch: {
    file() {
      // Reset video autoplay when the file changes
      this.loadVideo = false;
    }
  },
  computed: {
    name() {
      if (!this.file) {
        return "";
      }
      return this.file.basename;
    },
    tooltip() {
      if (!this.file) {
        return "";
      }
      return this.asset_image_error ? t("Error loading image") : this.file.basename;
    },
    size() {
      if (!this.file) {
        return t("Unknown");
      }
      return this.file.size;
    },
    modTime() {
      if (!this.file || !this.file.mtime) {
        return "";
      }
      return new Date(this.file.mtime).toLocaleString();
    },
    url() {
      if (!this.file) {
        return "";
      }
      return this.file.url;
    },
    downloadUrl() {
      if (this.isImage) {
        return `${this.url}?optimizer=disabled`;
      }
      return this.url;
    },
    thumbnailUrl() {
      switch (this.fileType) {
        case "image":
          return `${this.url}?width=500`;
        case "video":
          return "/images/file-video.png";
        case "audio":
          return "/images/file-audio.png";
        case "3d":
          return "/images/file-3d.png";
        case "pdf":
          return "/images/file-pdf.png";
        default:
          return "/images/file-unknown.png";
      }
    },
    fileExt() {
      return this.name.split(".").pop() || "";
    },
    fileType() {
      return Utils.extensionType(this.fileExt);
    },
    isImage() {
      return this.fileType === "image";
    },
    isVideo() {
      return this.fileType === "video";
    },
    isAudio() {
      return this.fileType === "audio";
    },
    sizeH() {
      return Utils.bytesToHuman(this.size);
    },
    selectedTotalSizeH() {
      return Utils.bytesToHuman(this.selectedStats.totalSize || 0);
    },
    selectedFolders() {
      return this.selectedStats.folders;
    },
    selectedFiles() {
      return this.selectedStats.files;
    },
    selectedCount() {
      return this.selectedStats.files + this.selectedStats.folders;
    }
  },
  methods: {
    errorLoadingImage(ev) {
      this.asset_image_error = true;
      Utils.errorLoadingImage(ev, "/images/assets_library_64x64.png");
    },
    buttonTooltip(defaultMessage) {
      if (!this.file) {
        return t("No assets selected.");
      }
      if (!this.fileSelected) {
        return t("This asset is not selected.");
      }
      return defaultMessage;
    },
    async setAvatar() {
      if (!this.url) {
        return;
      }
      const response = await Utils.api("profile", {
        avatar: this.url
      });
      if (response.success) {
        UI.success(t("Avatar updated."));
      } else {
        UI.error(t("Error setting avatar."));
      }
    },
    openLink() {
      window.open(this.file.url, "_blank");
    },
    copyLink() {
      navigator.clipboard.writeText(this.url);
      UI.success(t("Link copied to clipboard for file: {{fileName}}", {
        fileName: this.name
      }));
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetFile"] = Vue.component(
                    "AssetFile",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<asset-object ref=\"asset\" :asset=\"file\" :href=\"url\" :selected=\"selected\" :dragging=\"dragging\" :is-writable=\"isWritable\" :image=\"thumbnailUrl\" :video=\"isVideo ? url : null\" :name=\"name\" :icons=\"combinedIcons\" :card-width=\"cardSize\" :popover=\"false /*isImage*/\" > </asset-object>",
  props: {
    file: {
      type: Object,
      required: true
    },
    selected: Boolean,
    selectVisible: Boolean,
    isWritable: Boolean,
    dragging: Boolean,
    cardSize: {
      type: Number,
      default: 100
    },
    icons: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showOptions: false,
      defaultIcons: [{
        icon: "fas fa-link",
        tooltip: t("Copy Link"),
        callback: this.copyLink
      }, {
        icon: "fas fa-external-link-alt",
        tooltip: t("Open File"),
        callback: this.openLink
      }],
      asset_image_error: false
    };
  },
  computed: {
    path() {
      return this.file.name;
    },
    name() {
      return this.file.basename;
    },
    tooltip() {
      return this.asset_image_error ? t("Error loading image") : this.file.basename;
    },
    combinedIcons() {
      return [...this.icons, ...this.defaultIcons];
    },
    size() {
      return this.file.size;
    },
    url() {
      return this.file.url;
    },
    downloadUrl() {
      if (this.isImage) {
        return `${this.url}?optimizer=disabled`;
      }
      return this.url;
    },
    thumbnailUrl() {
      switch (this.fileType) {
        case "image":
          return `${this.url}?width=500`;
        case "video":
          return "/images/file-video.png";
        case "audio":
          return "/images/file-audio.png";
        case "3d":
          return "/images/file-3d.png";
        case "pdf":
          return "/images/file-pdf.png";
        default:
          return "/images/file-unknown.png";
      }
    },
    fileExt() {
      return this.name.split(".").pop() || "";
    },
    fileType() {
      return Utils.extensionType(this.fileExt);
    },
    isImage() {
      return this.fileType === "image";
    },
    isVideo() {
      return this.fileType === "video";
    },
    isAudio() {
      return this.fileType === "audio";
    },
    sizeH() {
      return Utils.bytesToHuman(this.size);
    }
  },
  methods: {
    copyLink() {
      Utils.copyToClipboard(this.url);
      UI.alert("success", t("Link copied to clipboard for file: {{fileName}}", {
        fileName: this.name
      }), true, 10000);
    },
    openLink() {
      window.open(this.downloadUrl, "_blank");
    },
    errorLoadingImage(ev) {
      this.asset_image_error = true;
      Utils.errorLoadingImage(ev, "/images/assets_library_64x64.png");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetFolder"] = Vue.component(
                    "AssetFolder",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<asset-object checkbox-select dropzone :asset=\"folder\" :href=\"url\" :selected=\"selected\" :dragging=\"dragging\" :is-writable=\"isWritable\" :name=\"name\" :image=\"image\" :icons=\"folderIcons\" :card-width=\"cardSize\" > <template #header> <span class=\"font-weight-bold text-info\">{{ name }}</span> </template> <template #image> <a :href=\"url\"> <b-img :src=\"image\" :alt=\"name\" class=\"w-100 h-100 object-fit-contain\"> </b-img> <span class=\"asset-folder-item-count text-dark text-center font-weight-bold\"> {{ label }} </span> <small class=\"asset-folder-size text-dark text-center font-weight-bold\"> {{ sizeLabel }} </small> </a> </template> </asset-object>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-folder-item-count { position: absolute; top: 35%; left: 0px; width: 100%; height: 100%; pointer-events: none; /* To prevent it from blocking clicks to the footer */ } .asset-folder-size { position: absolute; top: 55%; left: 0px; width: 100%; height: 100%; pointer-events: none; /* To prevent it from blocking clicks to the footer */ }"
    });
  },
  props: {
    folder: {
      type: Object,
      required: true
    },
    isOwner: Boolean,
    isWritable: Boolean,
    selected: Boolean,
    selectVisible: Boolean,
    dragging: Boolean,
    cardSize: {
      type: Number,
      default: 100
    },
    icons: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      dropdownTextClass: "text-white-50"
    };
  },
  computed: {
    path() {
      return this.folder.name;
    },
    name() {
      return this.folder.basename;
    },
    url() {
      return Assets.genHash(this.path);
    },
    children() {
      return this.folder.children || [];
    },
    items() {
      return this.children.length;
    },
    image() {
      return "/images/folder-blue.png";
    },
    label() {
      if (this.items === 0) {
        return t("Empty");
      }
      return t("ASSETS.items", {
        count: this.items
      });
    },
    folderIcons() {
      return this.isOwner ? [...this.icons, {
        icon: "fas fa-share-alt",
        tooltip: t("Share Folder"),
        callback: this.shareFolder
      }] : this.icons;
    },
    size() {
      return this.folder.size;
    },
    sizeLabel() {
      if (!this.size) {
        return "";
      }
      return Utils.bytesToHuman(this.size);
    }
  },
  methods: {
    shareFolder() {
      this.$emit("share-folder", this.folder);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetNewFolder"] = Vue.component(
                    "AssetNewFolder",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" :title=\"t('New Folder')\" @ok=\"createFolder\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <div class=\"text-center\"> <b-form-input ref=\"input\" v-model=\"folderName\" type=\"text\" name=\"newFolder\" :placeholder=\"t('Name of the folder to create')\" @keyup=\"keyUp\" > </b-form-input> </div> <template #modal-footer=\"{ ok, cancel }\"> <b-button variant=\"success\" :disabled=\"!folderName\" @click=\"ok()\">{{ t(\"Create Folder\") }}</b-button> <b-button variant=\"secondary\" @click=\"cancel()\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    // Whether the modal is shown
    path: {
      type: String,
      default: ""
    },
    assetsHandler: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      folderName: ""
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    dialogShown() {
      this.$refs.input.focus();
    },
    keyUp(ev) {
      if (ev.keyCode === 13) {
        this.createFolder();
      }
    },
    async createFolder() {
      const newFolder = this.folderName.trim();
      if (newFolder != "") {
        const path = `${this.path}/${newFolder}`;
        const response = await this.assetsHandler.newFolder(path);
        if (response.success) {
          this.$emit("created");
          this.folderName = "";
        } else {
          UI.alert("danger", t("Error creating folder"));
        }
        this.visible = false;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetObject"] = Vue.component(
                    "AssetObject",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card ref=\"card\" class=\"m-2 asset-object\" no-body :style=\"sizeStyle\"> <b-card-header v-b-tooltip.hover.noninteractive class=\"p-1 asset-object-header text-truncate text-center\" :title=\"name\" > <slot name=\"header\"> <span class=\"font-weight-bold\">{{ name }}</span> </slot> </b-card-header> <b-card-body ref=\"body\" class=\"p-0 asset-object-body\" :class=\"selected ? 'selected' : ''\" @mouseover=\"mouseOver\" @mouseleave=\"mouseLeave\" @mousedown=\"mouseDown\" > <drag class=\"w-100 h-100\" :image-x-offset=\"75\" :image-y-offset=\"50\" drop-effect=\"move\" @drag=\"drag\"> <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <slot name=\"image\"> <a :href=\"href\" @click.prevent=\"$emit('click', $event)\"> <template v-if=\"!!video && (hoverPlay || asset.size < videoPreviewMax)\"> <video :src=\"video\" muted preload=\"metadata\" class=\"w-100 h-100 object-fit-contain asset-object-content\" :class=\"hoverPlay ? 'd-none' : ''\" ></video> <!-- Note: this cannot use a standard v-if/v-else. The top element needs to stay in the DOM (and be hidden), otherwise the autoplay attribute just gets set non-reactively on the existing video element. --> <video v-if=\"hoverPlay\" :src=\"video\" muted autoplay loop class=\"w-100 h-100 object-fit-contain asset-object-content\" ></video> </template> <b-img-lazy v-else class=\"w-100 h-100 object-fit-contain asset-object-content\" blank-src=\"/images/file-loading.webp\" :src=\"image\" :alt=\"name\" @error.native=\"errorLoadingImage\" ></b-img-lazy> </a> </slot> <div v-show=\"selected\" class=\"selection-overlay\"> <span class=\"tile-overlay asset-selected-icon\"><i class=\"fas fa-check\"></i></span> </div> <div v-if=\"checkboxSelect && hover\" v-b-tooltip.hover.noninteractive class=\"asset-object-select-box text-dark bg-light d-flex align-items-center justify-content-center\" :title=\"t('Select {{type}}', { type })\" @click.prevent=\"$parent.$emit('selected', asset)\" > <i :class=\"selectedIcon\"></i> </div> <drop v-if=\"dropzone && dragging && !selected\" class=\"asset-object-drop-target w-100 h-100\" tag=\"span\" :dragging=\"dragging\" @drop=\"drop\" /> </drag> </b-card-body> <b-popover v-if=\"popover\" ref=\"thumbnail\" :show=\"hover\" :target=\"() => $refs.body\" triggers=\"focus\" placement=\"bottom\" fallback-placement=\"counterclockwise\" delay=\"1000\" > <template #title>{{ name }}</template> <video v-if=\"!!video\" :src=\"video\" autoplay loop muted></video> <b-img v-else thumbnail :src=\"image\" @error=\"errorLoadingImage\"></b-img> </b-popover> <transition tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__zoomIn\" leave-active-class=\"animate__animated animate__faster animate__zoomOut\" > <b-card-footer v-show=\"hover && footerIcons.length\" class=\"p-1 asset-object-footer\" @mouseover=\"mouseOver\" @mouseleave=\"mouseLeave\" > <slot name=\"footer\"> <div class=\"d-flex flex-row justify-content-around bg-light\"> <a v-for=\"icon of footerIcons\" :key=\"icon.icon\" v-b-tooltip.hover href=\"#\" :class=\"icon.hidden ? 'd-none' : 'text-dark'\" :title=\"icon.tooltip\" @click.prevent=\"icon.callback\" > <i :class=\"icon.icon\"></i> </a> </div> </slot> </b-card-footer> </transition> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".object-fit-contain { object-fit: contain; } .asset-object { background-color: transparent; } .asset-object-body { position: relative; } .asset-object-body.selected { cursor: move; } .asset-object-header { height: 30px; max-height: 30px; min-height: 30px; } .asset-object-footer { width: 100%; max-width: 100%; height: 30px; max-height: 30px; position: absolute; bottom: 0px; left: 0px; z-index: 15; } .asset-object-select-box { position: absolute; cursor: pointer; top: 0.5rem; left: 0.5rem; z-index: 15; font-size: 1.64rem; font-family: \"El Messiri\", serif; width: 1.3rem; max-width: 1.3rem; height: 1.3rem; max-height: 1.3rem; border-radius: 3px; } .asset-selected-icon.tile-overlay { font-size: 2.4rem; } .asset-object-body .asset-object-drop-target { position: absolute; top: 0px; left: 0px; } .asset-object .asset-object-content { border-radius: 0 0 0.25rem 0.25rem; } .asset-object .selection-overlay { position: absolute; top: 0px; left: 0px; height: 100%; width: 100%; display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.5); pointer-events: none; border-radius: 0 0 0.25rem 0.25rem; }"
    });
  },
  props: {
    asset: Object,
    image: String,
    video: {
      type: String,
      default: null
    },
    checkboxSelect: {
      type: Boolean,
      default: false
    },
    cardWidth: Number,
    href: {
      type: String,
      default: "#"
    },
    icons: {
      type: Array,
      default: []
    },
    selected: {
      type: Boolean,
      default: false
    },
    popover: {
      type: Boolean,
      default: false
    },
    dropzone: {
      type: Boolean,
      default: false
    },
    dragging: {
      type: Boolean,
      default: false
    },
    isWritable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hover: false,
      hoverTimeout: null,
      hoverPlay: false,
      hoverPlayTimeout: null,
      videoPreviewMax: 5 * Assets.MB // 5 MB limit for rendering video previews
    };
  },

  computed: {
    clickDebounceDelay() {
      return 500;
    },
    name() {
      return this.asset.basename;
    },
    sizeStyle() {
      // Default is 125 wide by 150 tall, which is 5:6 ratio.
      const height = this.cardWidth / 5 * 6;
      return `width: ${this.cardWidth}px; max-width: ${this.cardWidth}px; height: ${height}px; max-height: ${height}px;`;
    },
    selectedIcon() {
      return this.selected ? "far fa-check-square" : "far fa-square";
    },
    type() {
      return this.asset.isDirectory ? t("Folder") : t("File");
    },
    footerIcons() {
      /*  // This code has been left here in case we change our minds about preventing users from deleting a system folder.
      //don't display the option to rename or delete base64data as it's a system folder
      if (this.asset.name === "base64data/") {
        return [...this.icons];
      }
      */

      return this.isWritable ? [...this.icons, {
        icon: "fas fa-edit",
        tooltip: t("Rename {{type}}", {
          type: this.type
        }),
        callback: () => this.$parent.$emit("rename", this.asset)
      }, {
        icon: "fas fa-download",
        hidden: this.asset.size > Assets.MAX_DOWNLOAD_SIZE || this.asset.isDirectory,
        tooltip: t("Download {{type}}", {
          type: this.type
        }),
        callback: () => this.$parent.$emit("download", this.asset)
      }, {
        icon: "fas fa-trash-alt text-danger",
        tooltip: t("Delete {{type}}", {
          type: this.type
        }),
        callback: () => this.$parent.$emit("delete", this.asset)
      }] : this.icons;
    }
  },
  methods: {
    showPopover(show = true) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.hoverTimeout = null;
      if (show) {
        this.hover = true;
      } else {
        this.hoverTimeout = setTimeout(() => this.hover = false, 250);
      }
      this.$parent.$emit("hover", show);
    },
    mouseOver() {
      if (!this.hoverPlayTimeout) {
        this.hoverPlayTimeout = setTimeout(() => this.hoverPlay = true, 1000);
      }
      this.showPopover(true);
    },
    mouseLeave() {
      clearTimeout(this.hoverPlayTimeout);
      this.hoverPlayTimeout = null;
      this.hoverPlay = false;
      this.showPopover(false);
    },
    mouseDown(event) {
      // Ignore the event if this asset is using checkbox selection
      if (this.checkboxSelect) {
        return;
      }
      // If we start dragging, skip all of it. Only count left-click.
      if (!this.dragging && event.button === 0) {
        this.$parent.$emit("selected", this.asset, event);
      }
    },
    drag({
      name,
      nativeEvent
    }) {
      this.$parent.$emit("drag", {
        asset: this.asset,
        name,
        nativeEvent
      });
    },
    drop({
      name,
      nativeEvent
    }) {
      if (name === "drop") {
        this.$parent.$emit("drop", {
          asset: this.asset,
          nativeEvent
        });
      } else {
        this.drag({
          name,
          nativeEvent
        });
      }
    },
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, "/images/assets_library_64x64.png");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetRename"] = Vue.component(
                    "AssetRename",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"!!asset\" size=\"lg\" :title=\"t(`Rename {{type}}`, { type: `${isDir ? t('Folder') : t('File')}` })\" @ok=\"renameAsset\" @hidden=\"asset = null\" @shown=\"dialogShown\" > <div class=\"mb-2\"> <i18n :path=\"t(`Are you sure you want to rename the {{type}} '{0}'`, { type: isDir ? t('folder') : t('file') })\"> <strong>{{ name }}</strong> </i18n> </div> <b-alert v-if=\"isSystemObject\" variant=\"danger\" show> <i18n :path=\"t(`The {0} folder is a system folder created automatically by The Forge.`)\"> <b>base64data</b> </i18n> <br /> {{ t(\"It is strongly recommended that you do not rename this folder.\") }} </b-alert> <b-alert v-else variant=\"warning\" show> {{ isDir ? t( \"If you rename this folder, any assets used in your games which refer to this folder and any of its contents will become broken and you will need to manually reset them.\" ) : t( \"If you rename this file, any assets used in your games which refer to this file will become broken and you will need to manually reset them.\" ) }} <br />{{ t(\"It is recommended to only rename assets that are unused and not referenced in any of your games.\") }} </b-alert> <div class=\"text-center\"> <b-form-input ref=\"input\" v-model=\"newName\" type=\"text\" name=\"newName\" :placeholder=\"t('New {{type}} name', { type: isDir ? t('folder') : t('file') })\" :state=\"newNameValid\" @keyup=\"keyUp\" > </b-form-input> </div> <b-alert variant=\"warning\" :show=\"newNameValid === false\"> {{ t(\"The new name must not include the '/' character\") }} </b-alert> <b-alert variant=\"warning\" :show=\"collision\"> <b-form-group v-slot=\"{ ariaDescribedby }\" :label=\"confirmationLabel\"> <b-form-checkbox id=\"confirm-overwrite\" v-model=\"overwrite\" class=\"float-right\" name=\"confirm-overwrite\" :aria-describedby=\"ariaDescribedby\" > {{ isDir ? t(\"Confirm Merge\") : t(\"Confirm Overwrite\") }} </b-form-checkbox> </b-form-group> </b-alert> <template #modal-footer=\"{ ok, cancel }\"> <b-button :variant=\"renameButtonVariant\" :disabled=\"!newName || (collision && !overwrite) || newNameValid === false\" @click=\"ok()\" > <i18n :path=\"t(`Rename {{type}}`, { type: isDir ? t('Folder') : t('File') })\"></i18n> </b-button> <b-button variant=\"secondary\" @click=\"cancel()\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  props: {
    value: Object,
    assetNeighbors: Array,
    assetsHandler: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newName: "",
      overwrite: false
    };
  },
  watch: {
    asset() {
      if (this.asset) {
        this.newName = this.name;
      }
    }
  },
  computed: {
    asset: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isDir() {
      return this.asset && this.asset.isDirectory;
    },
    path() {
      return this.asset && this.asset.name;
    },
    name() {
      return this.asset && this.asset.basename;
    },
    dirname() {
      return this.asset && Utils.dirname(this.asset.name);
    },
    isSystemObject() {
      return this.asset && this.asset.name === "base64data/";
    },
    renameButtonVariant() {
      return this.isSystemObject ? "danger" : "warning";
    },
    newNameValid() {
      if (!this.newName) {
        return null;
      }
      if (this.newName.includes("/")) {
        return false;
      }
      return true;
    },
    collision() {
      if (this.newName === "") {
        return false;
      }
      return this.assetNeighbors.includes(this.newName);
    },
    confirmationLabel() {
      if (this.isDir) {
        return t("That folder name already exists, performing this rename will merge the two folders.");
      }
      return t("That file name already exists, performing this rename will overwrite it with the renamed asset.");
    }
  },
  methods: {
    dialogShown() {
      this.overwrite = false;
      const upTo = this.isDir ? this.name.length : this.name.lastIndexOf(".");
      this.$refs.input.focus();
      this.$refs.input.setSelectionRange(0, upTo === -1 ? this.name.length : upTo);
    },
    keyUp(ev) {
      if (ev.keyCode === 13) {
        this.renameAsset();
      }
    },
    async renameAsset() {
      if (this.collision && !this.overwrite) {
        return;
      }
      const newName = this.newName.trim();
      if (newName != "") {
        const destination = Utils.cleanPath(`${this.dirname}/${newName}`) + (this.isDir ? "/" : "");
        const response = (await this.assetsHandler.renameAssets({
          [this.path]: destination
        }).catch(null)) || {};
        if (response.success) {
          this.$emit("renamed");
        } else {
          UI.alert("danger", `${response.error || t("Error renaming {{type}}", {
            type: this.isDir ? t("folder") : t("file")
          })}`);
        }
        this.asset = null;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetSearch"] = Vue.component(
                    "AssetSearch",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-form-group> <!-- Search bar --> <b-input-group size=\"sm\"> <b-form-input v-model=\"searchText\" type=\"search\" :placeholder=\"t('Search')\" @keyUp=\"searchKeyUp\"> </b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> <!-- Search scope --> <b-dropdown class=\"search-scope-dropdown float-right w-100\" size=\"sm\" variant=\"secondary\"> <template #button-content> <i class=\"fa fas fa-search\"></i> {{ searchScopes[searchScope] }} </template> <b-dropdown-item v-for=\"(scope, key) in searchScopes\" :key=\"key\" @click=\"onClickSearchScope(key)\"> {{ scope }} </b-dropdown-item> </b-dropdown> </b-form-group>",
  beforeCreate() {
    Utils.loadCss({
      content: ".search-scope-dropdown .dropdown-toggle-split { flex-grow: 0; padding-left: 0.75em; padding-right: 0.75em; }"
    });
  },
  data() {
    return {
      searchText: "",
      searchScope: "local",
      path: "",
      hashChange: null
    };
  },
  watch: {
    searchText() {
      this.newSearch();
    },
    searchScope() {
      this.newSearch();
    }
  },
  computed: {
    searchScopes() {
      return {
        local: t("This folder only"),
        recursive: t("This folder and subfolders"),
        global: t("Entire Asset Library")
      };
    }
  },
  methods: {
    onClickSearchScope(scopeKey) {
      this.searchScope = scopeKey;
    },
    searchKeyUp(ev) {
      // Pressing 'ESC' key triggers cancels the search
      if (ev.keyCode == 27) {
        this.searchText = "";
      }
    },
    debounceHash(value) {
      // Delay actual changes to the hash until typing has stopped for 250ms
      if (this.hashChange) {
        clearTimeout(this.hashChange);
      }
      this.hashChange = setTimeout(() => window.location.hash = value, 250);
    },
    updateHash() {
      const newHash = Assets.parseHash(window.location.hash);
      this.path = newHash.path;
      if (newHash.search) {
        this.searchText = newHash.search.terms.join("+");
        this.searchScope = newHash.search.scope;
        if (!Object.keys(this.searchScopes).includes(this.searchScope)) {
          this.searchScope = "local";
        }
      } else {
        this.searchText = "";
      }
    },
    newSearch() {
      // Separate terms by whitespace and commas
      const search = {
        terms: this.searchText.split("+").filter(term => term.length),
        scope: this.searchScope
      };
      // Update the hash on every key stroke
      this.debounceHash(Assets.genHash(this.path, this.searchText.length ? search : undefined));
    }
  },
  mounted() {
    this.updateHash();
    $(window).on("hashchange", this.updateHash);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetUploadDialog"] = Vue.component(
                    "AssetUploadDialog",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :id=\"id\" v-model=\"modalVisible\" centered size=\"lg\" content-class=\"asset-upload-dialog\" no-close-on-esc :no-close-on-backdrop=\"uploading\" :title=\"t('Upload files to Library')\" @close=\"cancel\" > <asset-upload-drop watermark-variant=\"info\" :dragging=\"dragging\" :drag-type=\"dragType\" :uploading=\"uploading\" :is-writable=\"assetsHandler.isWritable\" @drag-files=\"$emit('drag-files', $event)\" @drop-files=\"formFiles = $event\" @drop-to-folder=\"$emit('drop-to-folder', $event)\" > <template #message=\"props\"> <p><i class=\"watermark\" :class=\"props.icon\" style=\"font-size: 5rem\"></i></p> </template> </asset-upload-drop> <b-input-group> <b-form-file v-if=\"!dragging\" v-model=\"formFiles\" style=\"cursor: pointer !important\" multiple :placeholder=\"t('Or click here to browse for a file or zip')\" :disabled=\"uploading\" ></b-form-file> <b-input-group-append> <b-button :disabled=\"uploading || !(formFiles && formFiles.length)\" variant=\"primary\" @click=\"uploadAssets(formFiles)\" > <i class=\"fas fa-cloud-upload-alt\"></i> </b-button> </b-input-group-append> </b-input-group> <b-row class=\"py-2\"> <b-col cols=\"6\"> <i18n v-if=\"formFiles && formFiles.length\" :path=\"t('{{count}} files selected for upload', { count: formFiles.length })\" ></i18n> </b-col> <b-col cols=\"6\"> <b-form-checkbox id=\"asset-upload-unzip\" v-model=\"unzipAll\" class=\"float-right\" :disabled=\"uploading\"> {{ t(\"Unzip files before uploading\") }} </b-form-checkbox> </b-col> </b-row> <asset-uploader ref=\"uploader\" no-close-button no-cancel-button :show=\"showProgress\" :path=\"currentPath\" :unzip-all=\"unzipAll\" :cancel=\"cancelUpload\" :assets-handler=\"assetsHandler\" @alert=\"alert\" @uploading=\"uploadingChange\" @assets-uploaded=\"$emit('assets-uploaded', $event)\" ></asset-uploader> <template #modal-footer=\"{ close }\"> <b-button v-if=\"!uploading && !uploaded\" variant=\"primary\" class=\"float-right\" :disabled=\"!formFiles || uploading\" @click=\"uploadAssets(formFiles)\" > <span><i class=\"fas fa-cloud-upload-alt\"></i> {{ t(\"Upload\") }}</span> </b-button> <b-button v-if=\"!uploading\" variant=\"secondary\" class=\"float-right\" @click=\"close\">{{ t(\"Close\") }}</b-button> <b-button v-if=\"uploading\" variant=\"danger\" class=\"float-right\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-upload-dialog { font-family: \"Montserrat\", sans-serif; } .asset-upload-dialog .assets-library-upload-zone { height: 10em; margin-bottom: 1em; } .asset-upload-dialog .assets-library-upload-zone.uploading { height: 4em; } .asset-upload-dialog button.disabled { cursor: not-allowed; }"
    });
  },
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    id: String,
    currentPath: String,
    assetsHandler: {
      type: Object,
      required: true
    },
    dragging: Boolean,
    dragType: String,
    uploading: Boolean,
    visible: Boolean
  },
  data() {
    return {
      modalVisible: false,
      formFiles: null,
      unzipAll: false,
      showProgress: false,
      cancelUpload: false,
      uploaded: false
    };
  },
  watch: {
    visible(newValue) {
      this.modalVisible = newValue;
      // Clear state when shown
      if (newValue) {
        this.formFiles = null;
        this.unzipAll = false;
        this.uploaded = false;
        this.showProgress = false;
        if (this.$refs.uploader) {
          this.$refs.uploader.clearUploadStats();
        }
      }
    },
    modalVisible(newValue) {
      if (!newValue) {
        this.$emit("change", newValue);
        // Prevent race conditions which could show the upload overlay with no state on the main browser
        this.$emit("uploading", false);
      }
    }
  },
  methods: {
    alert(alertData) {
      this.$emit("alert", alertData);
    },
    uploadAssets(files) {
      this.uploaded = true;
      if (this.uploading) {
        return;
      }
      console.log("uploadAssets", files);
      if (!this.$refs.uploader) {
        this.alert({
          variant: "danger",
          message: t("Error: asset uploader not mounted!")
        });
      } else {
        this.showProgress = true;
        this.$refs.uploader.uploadAssets(files);
      }
    },
    cancel() {
      this.cancelUpload = true;
      this.$nextTick(() => {
        this.cancelUpload = false;
        this.modalVisible = false;
      });
    },
    uploadingChange(uploading) {
      this.$emit("uploading", uploading);
      if (!uploading && this.$refs.uploader && !this.$refs.uploader.problems.length) {
        // Close the modal when upload is done and there were no problems
        this.modalVisible = false;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetUploadDrop"] = Vue.component(
                    "AssetUploadDrop",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <drop v-if=\"!invalidDrag\" class=\"position-relative assets-library-upload-zone bg-light text-primary text-center d-flex flex-column justify-content-center\" :class=\"dropClass\" :dragging=\"showDropOverlay\" :overlay-opacity=\"0.5\" @drop=\"dropFiles\" @over=\"dragOver\" > <loading-indicator v-if=\"uploading\" :label=\"t('Uploading assets…')\" class=\"d-flex justify-content-center align-items-center mb-0\" > </loading-indicator> <template v-else> <i v-if=\"watermark\" class=\"asset-library-upload-watermark\" :class=\"watermarkIcon\"></i> <div style=\"position: relative; z-index: 10\"> <slot name=\"message\" :icon=\"watermarkIcon\"></slot> </div> <span style=\"position: relative; z-index: 10\">{{ dropTargetText }}</span> </template> </drop> <div v-else class=\"position-relative assets-library-upload-zone bg-light text-primary text-center d-flex flex-column justify-content-center\" :class=\"dropClass\" > <i v-if=\"watermark\" class=\"asset-library-upload-watermark\" :class=\"watermarkIcon\"></i> <div style=\"position: relative; z-index: 10\"> <i v-if=\"!watermark\" :class=\"watermarkIcon\"></i> </div> <span style=\"position: relative; z-index: 10\">{{ dropTargetText }}</span> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".assets-library-upload-zone { border: 3px dashed; border-radius: 10px; width: 100%; height: 100%; font-size: 1.1rem; font-weight: bold; padding: 0.25rem 1rem; } .assets-library-upload-zone.uploading { border: 3px solid; } .assets-library-upload-zone.drag-over, .assets-library-upload-zone.drag-over i.asset-library-upload-watermark { color: var(--success) !important; } .assets-library-upload-zone.invalid, .assets-library-upload-zone.drag-over.invalid, .assets-library-upload-zone.invalid i.asset-library-upload-watermark, .assets-library-upload-zone.drag-over.invalid i.asset-library-upload-watermark, .assets-library-upload-zone.invalid .drop-overlay, .assets-library-upload-zone.invalid .drop-overlay { color: var(--gray) !important; } i.asset-library-upload-watermark { position: absolute; text-align: center; left: 0; right: 0; opacity: 35%; font-size: 3rem; }"
    });
  },
  props: {
    watermark: Boolean,
    watermarkVariant: {
      type: String,
      default: "info",
      validator: function (value) {
        return ["primary", "secondary", "info", "success", "warning", "danger", "light", "dark", "body", "muted", "white", "black-50", "white-50"].includes(value);
      }
    },
    dragging: Boolean,
    dragType: String,
    invalidDrag: Boolean,
    isWritable: Boolean,
    uploading: Boolean
  },
  data() {
    return {
      showDropOverlay: null,
      fileDropIsFile: false
    };
  },
  computed: {
    dropClass() {
      if (this.uploading) {
        return "uploading";
      }
      if (!this.isWritable || this.dragging && this.invalidDrag) {
        return "invalid";
      }
      if (this.showDropOverlay) {
        return "drag-over";
      }
      return "";
    },
    dropTargetText() {
      if (!this.isWritable) {
        return t("You do not have permission to write to this folder");
      }
      if (this.dragging) {
        if (this.invalidDrag) {
          return t("All selected assets already exist here");
        } else if (this.dragType === "copy") {
          return t("Drop assets here to copy them to this folder");
        }
        return t("Drop assets here to move them to this folder");
      }
      return t("Drop files here to upload them to this folder");
    },
    watermarkIcon() {
      let watermark = `text-${this.watermarkVariant} `;
      if (!this.isWritable) {
        return `${watermark}fas fa-ban`;
      }
      if (this.dragging) {
        if (!this.isWritable || this.invalidDrag) {
          return watermark + "fas fa-ban";
        } else if (this.dragType === "copy") {
          return watermark + "far fa-copy";
        }
        return watermark + "fas fa-file-export";
      }
      return watermark + "fas fa-cloud-upload-alt";
    }
  },
  methods: {
    async _parseDataTransferItems(items, files = []) {
      for (const item of items) {
        if (item.isFile) {
          // Get file
          const file = await new Promise(r => item.file(r, err => r(null)));
          if (file) {
            file.assetPath = item.fullPath;
            files.push(file);
          }
        } else if (item.isDirectory) {
          // Get folder contents
          const dirReader = item.createReader();
          const entries = await new Promise(r => dirReader.readEntries(r, err => r([])));
          await this._parseDataTransferItems(entries, files);
        }
      }
    },
    dragOver(event) {
      this.showDropOverlay = event;
      if (!this.showDropOverlay && this.fileDropIsFile) {
        // Stopped dragging files
        this.$emit("drag-files", false);
        this.fileDropIsFile = false;
      }
    },
    async dropFiles({
      name,
      nativeEvent
    }) {
      // Ignore drop events while uploading
      if (this.uploading) {
        return;
      }
      if (name === "drop") {
        if (this.fileDropIsFile) {
          const files = [];
          const entries = [];
          // Can't use `.map` since it doesn't exist
          for (const item of nativeEvent.dataTransfer.items) {
            if (item.webkitGetAsEntry) {
              entries.push(item.webkitGetAsEntry());
            } else if (item.getAsEntry) {
              // Future proofing - webkitGetAsEntry may be renamed to getAsEntry in non-webkit browsers in the future.
              // See: https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
              entries.push(item.getAsEntry());
            } else {
              UI.alert("danger", t("Error, unable to parse files for upload."));
              return;
            }
          }
          await this._parseDataTransferItems(entries, files);
          this.$emit("drop-files", files);
        } else if (this.dragging) {
          this.$emit("drop-to-folder", nativeEvent);
        }
      } else if (name === "dragover") {
        const isFile = nativeEvent.dataTransfer.types.includes("Files");
        if (isFile && !this.fileDropIsFile) {
          // Started dragging files
          this.$emit("drag-files", true);
        }
        this.fileDropIsFile = isFile;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetUploader"] = Vue.component(
                    "AssetUploader",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"show\" class=\"asset-uploader d-flex flex-column\"> <!-- Overall progress --> <div class=\"progress-container position-relative my-2\"> <b-progress max=\"1\" height=\"100%\"> <b-progress-bar variant=\"success\" :value=\"successFraction\"></b-progress-bar> <b-progress-bar variant=\"danger\" :value=\"failureFraction\"></b-progress-bar> <b-progress-bar variant=\"dark\" :value=\"1 - totalProgress\"></b-progress-bar> </b-progress> <div class=\"progress-label\">{{ mainProgressMessage }}</div> </div> <!-- Progress on current file --> <div v-if=\"uploading\" class=\"progress-container my-2 text-truncate\"> <span>{{ subProgressMessage }}</span> <b-progress max=\"1\"> <b-progress-bar variant=\"info\" :value=\"fileSubProgress - fileProgress\" :animated=\"uploadStage === 'hash'\" ></b-progress-bar> <b-progress-bar variant=\"success\" :value=\"fileProgress\" :animated=\"uploadStage === 'upload' && totalProgress < 1\" ></b-progress-bar> <b-progress-bar variant=\"dark\" :value=\"1 - Math.max(fileSubProgress, fileProgress)\"></b-progress-bar> </b-progress> </div> <div v-if=\"uploading && !noCancelButton\" class=\"d-flex justify-content-end\"> <b-button class=\"float-right\" variant=\"danger\" :disabled=\"cancelUpload\" @click=\"cancelUpload = true\"> <span v-if=\"!cancelUpload\">{{ t(\"Cancel\") }}</span> <loading-indicator v-else small tag=\"span\" :label=\"t('Cancelling…')\"></loading-indicator> </b-button> </div> <transition enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\"> <div v-if=\"problems.length\"> <i18n tag=\"strong\" class=\"text-danger\" :path=\"t('Problems during upload:')\"></i18n> <ul style=\"max-height: 15em; overflow-y: scroll\" class=\"forge-custom-scrollbar\"> <li v-for=\"problem in problems\">{{ problem }}</li> </ul> <b-button v-if=\"!noCloseButton && !uploading\" class=\"float-right\" @click=\"$emit('uploading', false)\"> {{ t(\"Close\") }} </b-button> </div> </transition> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-uploader .progress-container { height: 3em; } .asset-uploader .progress-label { position: absolute; left: 0; right: 0; top: 0; bottom: 0; color: var(--light); display: flex; justify-content: center; align-items: center; }"
    });
  },
  props: {
    show: Boolean,
    path: {
      type: String,
      default: ""
    },
    unzipAll: Boolean,
    noCancelButton: Boolean,
    noCloseButton: Boolean,
    cancel: Boolean,
    assetsHandler: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      uploading: false,
      unzipping: false,
      openingZip: false,
      totalCount: 0,
      totalProgress: 0,
      totalSuccessCount: 0,
      fileProgress: 0,
      fileSubProgress: 0,
      uploadStage: "",
      currentFile: "",
      cancelUpload: false,
      problems: []
    };
  },
  watch: {
    cancel(newValue) {
      // Cancel upload on rising edge of cancel prop
      if (newValue) {
        this.cancelUpload = true;
      }
    }
  },
  computed: {
    finishedCount() {
      return Math.round(this.totalCount * this.totalProgress);
    },
    successFraction() {
      return this.totalSuccessCount / this.totalCount;
    },
    failureFraction() {
      return (this.finishedCount - this.totalSuccessCount) / this.totalCount;
    },
    uploadCancelledMessage() {
      return t("Upload cancelled. {{count}} of {{total}} uploaded.", {
        count: this.finishedCount,
        total: this.totalCount
      });
    },
    mainProgressMessage() {
      if (this.unzipping) {
        return t("Extracted {{count}} of {{total}}", {
          count: this.finishedCount,
          total: this.totalCount
        });
      } else if (this.uploading) {
        return t("Uploaded {{count}} of {{total}}", {
          count: this.finishedCount,
          total: this.totalCount
        });
      } else if (this.cancelUpload) {
        return this.uploadCancelledMessage;
      } else if (!this.problems.length) {
        return t("{{count}} files uploaded successfully", {
          count: this.finishedCount
        });
      }
      return t("Errors occurred during upload, see below");
    },
    subProgressMessage() {
      if (this.totalProgress < 1 && this.unzipping && this.openingZip) {
        return t("Opening {{- filename}}", {
          filename: this.currentFile
        });
      } else if (this.totalProgress < 1 && this.unzipping && !this.openingZip) {
        return t("Extracting {{- filename}}", {
          filename: this.currentFile
        });
      } else if (this.totalProgress < 1 && this.uploadStage === "hash") {
        return t("Processing {{- filename}}", {
          filename: this.currentFile
        });
      } else if (this.totalProgress < 1 && this.uploadStage === "upload") {
        return t("Uploading {{- filename}}", {
          filename: this.currentFile
        });
      }
      return this.currentFile;
    }
  },
  methods: {
    clearUploadStats() {
      this.uploading = false;
      this.unzipping = false;
      this.openingZip = false;
      this.totalCount = 0;
      this.totalProgress = 0;
      this.totalSuccessCount = 0;
      this.fileProgress = 0;
      this.fileSubProgress = 0;
      this.currentFile = "";
      this.uploadStage = "";
      this.cancelUpload = false;
      this.problems = [];
    },
    keyDown(ev) {
      if (this.show && this.uploading && ev.key === "Escape") {
        this.cancelUpload = true;
      }
    },
    async uploadAssets(_files) {
      console.log("Upload Assets", _files);
      if (!_files) {
        return;
      }
      // Make a copy of the files array so we can modify it
      let files = _files.slice(0);
      // Initialize
      this.$emit("uploading", true);
      this.clearUploadStats();
      this.totalCount = files.length;
      this.uploading = true;

      // Unzip files if requested
      if (this.unzipAll) {
        files = await this.unzipper(files);
      }
      this.totalCount = files.length;
      const cancelErr = t("Upload cancelled");
      let response = {
        error: cancelErr
      };
      // Do the upload if user hasn't cancelled yet
      files = files.sort((a, b) => a.size - b.size);
      if (!this.cancelUpload) {
        response = await this.assetsHandler.uploadFiles(this.path, files, this.uploadProgressCallback);
      }
      this.uploading = false;
      // Process upload responses and reload assets
      console.log("Upload response", response);
      if (response.error) {
        let error = response.error;
        // If the response itself doesn't have an error message, check the result for the first file.
        if (!error && response.results && response.results.length && response.results[0].error) {
          error = response.results[0].error;
        }
        if (error) {
          // If user cancelled it's not really an error, but we should still provide feedback.
          if (error === cancelErr) {
            this.$emit("alert", {
              show: true,
              variant: "info",
              message: this.uploadCancelledMessage,
              timeout: 10000
            });
          } else {
            this.$emit("alert", {
              show: true,
              variant: "danger",
              message: t("Error uploading files: {{- error}}", {
                error: error || t("Unknown error")
              }),
              timeout: 0
            });
          }
        }
      }
      // Check the result for each asset
      if (response.results) {
        response.results.forEach(res => {
          if (!res.success) {
            this.problems.push(`${res.path ? Utils.basename(res.path) : t("Unknown file")}${res.error ? `: ${res.error}` : ""}`);
          }
        });
      }
      const uploaded = response.results ? response.results.filter(res => res.success) : [];
      // Tell parent to reload assets data
      this.$emit("assets-uploaded", uploaded);
      if (!response.error && uploaded.length) {
        this.$emit("alert", {
          show: true,
          variant: "success",
          message: t("{{count}} files uploaded successfully", {
            count: uploaded.length
          }),
          timeout: 10000
        });
      }
      // Emitting uploading false is how the component signals to its parent that uploading is finished.
      // If there are problems, don't emit immediately. Give user a chance to see the problems first.
      // Event will be emitted when user clicks the Close button.
      if (this.noCloseButton || response.success && !this.problems.length || this.cancelUpload && !this.problems.length) {
        this.$emit("uploading", false);
      }
    },
    uploadProgressCallback(type, ...args) {
      switch (type) {
        case "hash":
          // args is [fraction, filename]
          if (args.length < 2) {
            return;
          }
          if (this.currentFile !== args[1]) {
            // New file, clear progress
            this.fileSubProgress = 0;
            this.fileProgress = 0;
          }
          this.uploadStage = type;
          this.fileSubProgress = args[0];
          this.currentFile = args[1];
          break;
        case "upload":
          // args is [fraction, filename]
          if (args.length < 2) {
            return;
          }
          if (this.currentFile !== args[1]) {
            // New file, clear progress
            this.fileSubProgress = 0;
            this.fileProgress = 0;
          }
          this.uploadStage = type;
          this.fileProgress = args[0];
          this.currentFile = args[1];
          break;
        case "files":
          // args is [fraction, successes, failures]
          if (args.length < 3) {
            return;
          }
          this.totalProgress = args[0];
          this.totalSuccessCount = args[1];
          break;
        default:
          break;
      }
      // Return false to indicate upload should be cancelled.
      return !this.cancelUpload;
    },
    async unzipper(files) {
      // Filter for files which are known to be zips and unknown file types.
      const zipFiles = files.filter(f => f.type && (f.type.startsWith("application/zip") || f.type.startsWith("application/x-zip")));
      if (!zipFiles || !zipFiles.length) {
        return files;
      }
      this.unzipping = true;
      this.openingZip = false;
      this.totalCount = zipFiles.length;
      this.totalProgress = 0;
      // Unzip each zip file
      for (const file of zipFiles) {
        // Before each zip file, check whether user cancelled.
        if (this.cancelUpload) {
          break;
        }
        let contents = [];
        this.openingZip = true;
        this.currentFile = file.name;
        this.fileProgress = 0;
        try {
          const zip = await JSZip.loadAsync(file);
          contents = Object.values(zip.files);
          this.openingZip = false;
        } catch (err) {
          console.error("Error unzipping file:", file, err);
          this.$emit("alert", {
            show: true,
            variant: "danger",
            message: t("Error reading ZIP file."),
            timeout: 0
          });
          this.problems.push(t("Error reading ZIP file {{- file}}", {
            file: file.name || t("Unknown ZIP file")
          }));
          this.openingZip = false;
          continue;
        }
        if (!contents || !contents.length) {
          continue;
        }

        // If we reach here, zip file has processable contents. Remove the zip itself from the upload array.
        files.splice(files.findIndex(f => f === file), 1);
        // Extract files from the current zip
        const extracted = [];
        for (const zipFile of contents) {
          // Before each new file, check whether user cancelled.
          if (this.cancelUpload) {
            break;
          }
          if (zipFile.dir) {
            continue;
          }
          let blob = null;
          let failures = 0;
          try {
            this.currentFile = zipFile.name;
            this.fileProgress = extracted.length / contents.length;
            blob = await zipFile.async("blob");
            blob.name = zipFile.name;
            extracted.push(blob);
          } catch (err) {
            failures += 1;
          }
          if (failures > 0) {
            this.problems.push(t("Failed to extract {{count}} files from {{- zipName}}", {
              count: failures,
              zipName: zipFile.name || t("Unknown ZIP file")
            }));
          }
        }
        // Check if user cancelled while we were processing this zip's files.
        if (this.cancelUpload) {
          // Add the file back into the array on cancel, so that an accurate number of files is reported to the user
          files.push(file);
          break;
        }
        this.totalSuccessCount += 1;
        this.totalProgress = this.totalSuccessCount / this.totalCount;
        // Add the extracted files to the upload array
        files.push(...extracted);
      }
      this.unzipping = false;
      // Return the original upload array with zips removed and extracted files added
      return files;
    }
  },
  created() {
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetViewControls"] = Vue.component(
                    "AssetViewControls",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"asset-view-controls d-flex flex-column flex-xl-row justify-content-end\"> <div class=\"d-flex align-items-center justify-content-end\"> {{ t(\"Sort by:\") }} <b-dropdown v-b-tooltip.hover.noninteractive=\"t('Change sorting method')\" size=\"sm\" class=\"mx-1\" variant=\"secondary\" > <template #button-content> {{ sortModes[sortMode].text }} <i :class=\"sortModes[sortMode].icon\"></i> </template> <b-dropdown-item v-for=\"(mode, key) in sortModes\" :key=\"key\" size=\"sm\" @click=\"onClickSortMode(key)\"> {{ mode.text }} <i :class=\"mode.icon\"></i> </b-dropdown-item> </b-dropdown> <b-button v-b-tooltip.hover.noninteractive=\"tileMode ? t('Switch to details view') : t('Switch to tile view')\" size=\"sm\" class=\"mx-1\" @click=\"toggleViewMode\" > <i class=\"fas\" :class=\"tileMode ? 'fa-th-large' : 'fas fa-list'\"></i> </b-button> </div> <!-- Icon/card size slider --> <div class=\"asset-icon-slider flex-fill d-flex align-items-center justify-content-end mx-1 pb-2\"> {{ t(\"Thumbnail:\") }} <vue-slider v-model=\"iconSize\" class=\"flex-fill pl-3\" drag-on-click adsorb silent :contained=\"true\" :marks=\"sliderMarks\" :min=\"iconSizeRange.min\" :max=\"iconSizeRange.max\" :interval=\"iconSizeRange.interval\" :dot-options=\"sliderDotOptions\" :rail-style=\"sliderRailStyle\" :process-style=\"sliderProcessStyle\" :step-style=\"sliderStepStyle\" :step-active-style=\"sliderStepActiveStyle\" /> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-view-controls .asset-icon-slider { min-width: 250px; max-width: 300px; } .asset-view-controls .vue-slider { cursor: pointer; } .asset-view-controls .vue-slider-ltr .vue-slider-mark-label { margin-top: 0.5em; }"
    });
  },
  props: {
    newSortBy: String,
    newSortDesc: Boolean,
    tileSizeRange: {
      type: Object,
      default: function () {
        return {
          min: 50,
          max: 500,
          interval: 50
        };
      }
    },
    listSizeRange: {
      type: Object,
      default: function () {
        return {
          min: 10,
          max: 100,
          interval: 5
        };
      }
    }
  },
  data() {
    return {
      tileMode: true,
      sortMode: "alphabetic_asc",
      iconSize: 125,
      tileIconSize: 125,
      listIconSize: 30
    };
  },
  watch: {
    newSortBy(newValue) {
      if (newValue !== this.sortBy) {
        this.changeSorting(newValue, this.sortDesc);
      }
    },
    newSortDesc(newValue) {
      if (newValue !== this.sortDesc) {
        this.changeSorting(this.sortBy, newValue);
      }
    },
    iconSize() {
      if (this.tileMode) {
        this.tileIconSize = this.iconSize;
      } else {
        this.listIconSize = this.iconSize;
      }
      this.emitIconSize();
    }
  },
  computed: {
    sortModes() {
      return {
        alphabetic_asc: {
          text: t("Alphabetic"),
          icon: "fas fa-sort-amount-down-alt"
        },
        alphabetic_desc: {
          text: t("Alphabetic"),
          icon: "fas fa-sort-amount-down"
        },
        size_asc: {
          text: t("File size"),
          icon: "fas fa-sort-amount-down-alt"
        },
        size_desc: {
          text: t("File size"),
          icon: "fas fa-sort-amount-down"
        },
        time_asc: {
          text: t("Modified time"),
          icon: "fas fa-sort-amount-down-alt"
        },
        time_desc: {
          text: t("Modified time"),
          icon: "fas fa-sort-amount-down"
        }
      };
    },
    sortBy() {
      return this.sortMode.split("_")[0];
    },
    sortDesc() {
      return this.sortMode.split("_")[1] === "desc";
    },
    iconSizeRange() {
      if (this.tileMode) {
        return this.tileSizeRange;
      }
      return this.listSizeRange;
    },
    sliderMarks() {
      const marks = {};
      if (this.tileMode) {
        marks[`${this.tileSizeRange.min}`] = this.tileSizeRange.min;
        marks[`${this.tileSizeRange.max}`] = this.tileSizeRange.max;
      } else {
        marks[`${this.listSizeRange.min}`] = t("Icon");
        marks[`${this.listSizeRange.max}`] = this.listSizeRange.max;
      }
      return marks;
    },
    sliderDotOptions() {
      return {
        style: {
          "background-color": "var(--light)",
          border: "2px solid var(--info)"
        }
      };
    },
    sliderProcessStyle() {
      return {
        "background-color": "var(--info)"
      };
    },
    sliderRailStyle() {
      return {
        "background-color": "var(--secondary)"
      };
    },
    sliderStepStyle() {
      return {
        "background-color": "var(--light)",
        "box-shadow": "0 0 0 2px var(--secondary)"
      };
    },
    sliderStepActiveStyle() {
      return {
        "background-color": "var(--light)",
        "box-shadow": "0 0 0 2px var(--info)"
      };
    }
  },
  methods: {
    changeSorting(sortBy, sortDesc) {
      switch (sortBy) {
        case "alphabetic":
          this.sortMode = sortDesc ? "alphabetic_desc" : "alphabetic_asc";
          break;
        case "size":
          this.sortMode = sortDesc ? "size_desc" : "size_asc";
          break;
        case "time":
          this.sortMode = sortDesc ? "time_desc" : "time_asc";
          break;
      }
      this.saveToStorage();
    },
    emitViewMode() {
      this.saveToStorage();
      this.$emit("view-mode", {
        tileMode: this.tileMode,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      });
    },
    toggleViewMode() {
      this.tileMode = !this.tileMode;
      this.emitViewMode();
      this.$nextTick(function () {
        this.iconSize = this.tileMode ? this.tileIconSize : this.listIconSize;
      });
    },
    onClickSortMode(key) {
      this.sortMode = key;
      this.emitViewMode();
    },
    emitIconSize() {
      this.saveToStorage();
      this.$emit("icon-size-change", this.iconSize);
    },
    loadFromStorage() {
      if (!localStorage.assetViewControls) {
        console.log("First time mounting AssetViewControls, saving default configuration.");
        this.saveToStorage();
      } else {
        const saved = JSON.parse(localStorage.assetViewControls);
        // Load configuration from localStorage, making sure not to overwrite any attrs with undefined/null/etc...
        this.tileMode = saved.tileMode || false; // Must use false since this.tileMode is true on mount.
        this.sortMode = saved.sortMode || this.sortMode;
        this.tileIconSize = saved.tileIconSize || this.tileIconSize;
        this.listIconSize = saved.listIconSize || this.listIconSize;
        // Set icon size according to mode
        this.iconSize = this.tileMode ? this.tileIconSize : this.listIconSize;
      }
    },
    saveToStorage() {
      localStorage.assetViewControls = JSON.stringify({
        tileMode: this.tileMode,
        sortMode: this.sortMode,
        tileIconSize: this.tileIconSize,
        listIconSize: this.listIconSize
      });
    }
  },
  mounted() {
    this.loadFromStorage();
    this.$nextTick(() => {
      this.emitViewMode();
      this.emitIconSize();
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsBrowser"] = Vue.component(
                    "AssetsBrowser",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"assets-browser\"> <!-- Breadcrumbs and buttons --> <b-row ref=\"topBar\"> <b-col> <path-bread-crumbs class=\"pl-0 pt-0\" :path=\"currentPath\" :root=\"activeSource.name\" :available-sources=\"sortedSources\" :active-source=\"activeSourceId\" :dragging=\"dragging\" :invalid-drag-path=\"invalidDragPath\" :is-writable=\"isWritable\" @change-source=\"changeSource\" @drop=\"dropPath\" ></path-bread-crumbs> </b-col> <b-col md=\"5\" lg=\"4\" xl=\"5\"> <asset-view-controls class=\"float-right pb-2\" :new-sort-by=\"sortBy\" :new-sort-desc=\"sortDesc\" :tile-size-range=\"{ min: 125, max: 500, interval: 25 }\" :list-size-range=\"{ min: 20, max: 100, interval: 10 }\" @view-mode=\"changeViewMode\" @icon-size-change=\"iconSizeChange\" > </asset-view-controls> </b-col> </b-row> <!-- Progress bar overlay for upload/move/copy, if upload dialog is not showing --> <b-overlay class=\"asset-op-overlay\" rounded=\"sm\" :show=\"(uploading && !showUploadDialog) || moving || copying || deleting\" > <template #overlay> <div class=\"asset-op-overlay-contents\"> <loading-indicator v-if=\"!(uploading && uploadDone)\" :label=\"overlayHeader\"></loading-indicator> <h2 v-else class=\"text-center\">{{ overlayHeader }}</h2> <!-- Asset uploader & progress bars --> <asset-uploader v-if=\"uploading\" ref=\"uploader\" :show=\"true\" :path=\"currentPath\" :unzip-all=\"unzipAll\" :assets-handler=\"assetsHandler\" @alert=\"showAlert\" @uploading=\"uploading = $event\" @assets-uploaded=\"assetsUploaded\" ></asset-uploader> <!-- Copy progress bar & cancel button --> <div v-if=\"copying\"> <div class=\"progress-container position-relative my-2\"> <b-progress :max=\"opTotalCount\" height=\"100%\"> <b-progress-bar variant=\"info\" :value=\"opDoneCount\"></b-progress-bar> <b-progress-bar variant=\"dark\" :value=\"opTotalCount - opDoneCount\"></b-progress-bar> </b-progress> <div class=\"progress-label\">{{ opDoneCount }} / {{ opTotalCount }}</div> </div> <div v-if=\"largeCopy\" class=\"d-flex justify-content-end\"> <b-button class=\"float-right\" variant=\"danger\" @click=\"cancelCopy = true\">{{ t(\"Cancel\") }}</b-button> </div> </div> </div> </template> <!-- Main container. Left sidebar (toolbox), center main area (asset tiles/detail table) --> <drop class=\"assets-main-container d-flex\" :style=\"{ height: `calc(100vh - ${totalMargin}px)` }\" @drop=\"dropFiles\" @over=\"dragOver\" > <!-- Toolbox sidebar --> <collapsible-side-panel v-model=\"sidebarCollapsed\" panel-width=\"300px\" :overlap=\"smallScreen\"> <template #collapsed> <assets-browser-toolbar :current-path=\"currentPath\" :assets-handler=\"assetsHandler\" :selected-stats=\"selectedStats\" :selected-other-path=\"selectedOtherPath\" :selected-multi-path=\"multiPath\" :invalid-drag-path=\"invalidDragPath\" :download-in-progress=\"downloadInProgress\" @folder-created=\"reloadData\" @upload-assets=\"showUploadDialog = true\" @move-assets=\"initMoveAssets\" @copy-assets=\"copyAssets\" @drag=\"drag\" @clear-selection=\"clearSelection\" @delete-selection=\"deleteSelection\" @download-selection=\"downloadSelection\" @collapse=\"toggleSidebarCollapse\" ></assets-browser-toolbar> </template> <template #panel> <assets-browser-toolbox class=\"w-100\" :quota=\"quota\" :assets-handler=\"assetsHandler\" :current-path=\"currentPath\" :selected-stats=\"selectedStats\" :selected-other-path=\"selectedOtherPath\" :selected-multi-path=\"multiPath\" :download-in-progress=\"downloadInProgress\" :details-asset=\"detailsAsset || singleSelectedFileAsset\" :details-asset-selected=\"detailsAssetSelected\" :dragging=\"dragging\" :invalid-drag-path=\"invalidDragPath\" :drag-type=\"dragType\" :uploading=\"uploading\" @folder-created=\"reloadData\" @assets-uploaded=\"assetsUploaded\" @upload-assets=\"showUploadDialog = true\" @move-assets=\"initMoveAssets\" @copy-assets=\"copyAssets\" @drag=\"drag\" @clear-selection=\"clearSelection\" @delete-selection=\"deleteSelection\" @download-selection=\"downloadSelection\" @drop-files=\"uploadFiles\" @drop-to-folder=\"dropToFolder\" @collapse=\"toggleSidebarCollapse\" @share-folder=\"shareFolder\" @manage-shared-folders=\"showSharedFoldersModal = true\" ></assets-browser-toolbox> </template> <template #default> <!-- Asset upload dialog --> <asset-upload-dialog v-model=\"showUploadDialog\" :current-path=\"currentPath\" :uploading=\"uploading\" :assets-handler=\"assetsHandler\" @alert=\"showAlert\" @assets-uploaded=\"assetsUploaded\" @uploading=\"uploading = $event\" @drop-files=\"uploadFiles\" @drop-to-folder=\"dropToFolder\" ></asset-upload-dialog> <!-- Dialog for handling asset name collisions on move/rename --> <b-modal id=\"collision-dialog\" v-model=\"showCollisionDialog\" centered no-close-on-backdrop no-close-on-esc hide-header-close :title=\"t('Overwrite Existing Assets?')\" > <i18n v-if=\"remainingCollisions > 0\" tag=\"p\" :path=\" t('{0} and {{collisionCount}} other assets already exist at their destinations.', { collisionCount: remainingCollisions, }) \" > <b>'{{ collisions[currentCollision] && collisions[currentCollision][1] }}'</b> </i18n> <i18n v-else tag=\"p\" :path=\"t('{0} already exists at its destination.')\"> <b>'{{ collisions[currentCollision] && collisions[currentCollision][1] }}'</b> </i18n> <i18n tag=\"p\" :path=\"t('Do you want to skip or overwrite {0}?')\"> <b>'{{ collisions[currentCollision] && collisions[currentCollision][1] }}'</b> </i18n> <b-form-checkbox v-if=\"remainingCollisions > 0\" id=\"collision-apply-to-all\" v-model=\"collisionApplyToAll\" name=\"collision-apply-to-all\" class=\"float-right\" :value=\"true\" > <i18n :path=\" t('Apply your choice to all {{collisionCount}} remaining conflicts', { collisionCount: remainingCollisions, }) \" ></i18n> </b-form-checkbox> <template #modal-footer> <b-button variant=\"secondary\" @click=\"clearCollisionState\">{{ t(\"Cancel\") }}</b-button> <b-button variant=\"secondary\" @click=\"collisionSkip\">{{ t(\"Skip\") }}</b-button> <b-button variant=\"danger\" @click=\"iterateCollision\">{{ t(\"Overwrite\") }}</b-button> </template> </b-modal> <!-- Assets view - tiles or details table --> <div class=\"filemanager-container\"> <div class=\"filemanager-scroll-area forge-custom-scrollbar\"> <div class=\"filemanager\"> <!-- Loading or searching --> <div v-if=\"loading || (searching && !searchDone)\" class=\"text-center loading pt-3 d-flex align-items-center justify-content-center\" > <div class=\"spinner-border\" role=\"status\"> <span class=\"sr-only align-middle\">{{ loading ? t(\"Loading…\") : t(\"Searching…\") }}</span> </div> <span class=\"px-3\">{{ loading ? t(\"Loading…\") : t(\"Searching…\") }}</span> </div> <template v-else> <div v-if=\"searching && searchDone\" class=\"mr-auto p-2 breadcrumbs\"> <strong>{{ t(\"Search results:\") }} {{ searchResultsLabel }}</strong> </div> <!-- Nothing to show - either empty folder or empty search results --> <template v-if=\"!files.length && !folders.length\"> <asset-upload-drop v-if=\"!searching\" class=\"m-2 fm-fill\" :watermark-variant=\"isWritable ? 'info' : 'secondary'\" :dragging=\"dragging\" :drag-type=\"dragType\" :uploading=\"uploading\" :is-writable=\"isWritable\" @drop-files=\"uploadFiles\" @drop-to-folder=\"dropToFolder\" > <template #message=\"props\"> <p><i class=\"watermark\" :class=\"props.icon\" style=\"font-size: 10rem\"></i></p> <p>{{ t(\"Nothing here yet!\") }}</p> </template> </asset-upload-drop> </template> <div v-else class=\"fm-fill\"> <b-alert :show=\"withinBase64Data\"> <i18n :path=\" t( `The {0} folder is used by The Forge to optimise image retrieval and reduce users's game storage limits.` ) \" > <b>base64data</b> </i18n> <br /> <i18n :path=\"t('Click {0} for more information.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/what-is-the-base64-folder-in-my-asset-library-what-is-this-folder-for/16751\" >{{ t(\"here\") }}</a > </i18n> </b-alert> <!-- Tile view --> <template v-if=\"viewMode === 'tile'\"> <!-- <ul class=\"data\">--> <transition-group tag=\"div\" class=\"d-flex flex-wrap\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" > <!-- Folders --> <div v-for=\"folder in folders\" :key=\"folder.name\"> <asset-folder :id=\"`asset-folder-${folder.name}`\" :folder=\"folder\" :is-owner=\"isOwner\" :is-writable=\"isWritable\" :selected=\"selectedAssets.includes(folder.name)\" :select-visible=\"selectedAssets.length > 0\" :dragging=\"dragging && isFolderValidDrop(folder.name)\" :card-size=\"tileSize\" @rename=\"renameAsset\" @delete=\"deleteFolder\" @selected=\"selectAsset\" @download=\"downloadAssets\" @drag=\"dragAsset\" @drop=\"drop\" @share-folder=\"shareFolder\" ></asset-folder> <!-- Tooltip on search results with full path and button to open containing folder --> <b-popover v-if=\"searching && searchDone\" :target=\"`asset-folder-${folder.name}`\" triggers=\"hover\" placement=\"top\" custom-class=\"asset-search-popover\" > <div class=\"d-flex justify-content-center align-items-center\"> <b-button v-b-tooltip.hover.top variant=\"outline-info\" size=\"sm\" class=\"m-0 mr-2 flex-shrink-1\" :title=\"t('Open containing folder')\" :href=\"Assets.genHash(Utils.dirname(folder.name))\" > <i class=\"fas fa-folder-open\"></i> </b-button> <span class=\"flex-grow text-break\">{{ folder.name }}</span> </div> </b-popover> </div> <!-- Files --> <div v-for=\"file in files\" :key=\"file.name\"> <asset-file :id=\"`asset-file-${file.name}`\" :file=\"file\" :is-writable=\"isWritable\" :selected=\"selectedAssets.includes(file.name)\" :select-visible=\"selectedAssets.length > 0\" :dragging=\"dragging\" :card-size=\"tileSize\" @hover=\"assetHover(file, $event)\" @rename=\"renameAsset\" @delete=\"deleteFile\" @selected=\"selectAsset\" @download=\"downloadFileAsset\" @drag=\"dragAsset\" ></asset-file> <!-- Tooltip on search results with full path and button to open containing folder --> <b-popover v-if=\"searching && searchDone\" :target=\"`asset-file-${file.name}`\" triggers=\"hover\" placement=\"top\" custom-class=\"asset-search-popover\" > <div class=\"d-flex justify-content-center align-items-center\"> <b-button v-b-tooltip.hover.top variant=\"outline-info\" size=\"sm\" class=\"m-0 mr-2 flex-shrink-1\" :title=\"t('Open containing folder')\" :href=\"Assets.genHash(Utils.dirname(file.name))\" > <i class=\"fas fa-folder-open\"></i> </b-button> <span class=\"flex-grow text-break\">{{ file.name }}</span> </div> </b-popover> </div> <!-- </ul>--> </transition-group> <infinite-loading :identifier=\"infiniteId\" spinner=\"bubbles\" @infinite=\"infiniteHandler\"> <span slot=\"no-more\"></span> <span slot=\"no-results\"></span> </infinite-loading> </template> <assets-list-view v-else :assets=\"currentView\" :all-assets=\"currentData\" :selected-assets=\"selectedAssets\" :infinite-id=\"infiniteId\" :search-result-mode=\"searching && searchDone\" :thumbnail-size=\"listIconSize\" :sort-by=\"sortBy\" :sort-desc=\"sortDesc\" :dragging=\"dragging\" :invalid-drag-path=\"invalidDragPath\" :is-owner=\"isOwner\" :is-writable=\"isWritable\" @sort-changed=\"onTableSortChanged\" @selected=\"selectAsset\" @rename=\"renameAsset\" @download=\"downloadFileAsset\" @drag=\"dragAsset\" @drop=\"drop\" @infinite=\"infiniteHandler\" @hover=\"assetHover\" @share-folder=\"shareFolder\" > </assets-list-view> </div> </template> </div> </div> <!-- Transient drop target across the bottom of the file manager --> <transition enter-active-class=\"animate__animated animate__faster animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > <asset-upload-drop v-if=\"isWritable && fileDrag && (files.length || folders.length)\" class=\"m-2 upload-to-current\" watermark watermark-variant=\"info\" :dragging=\"dragging\" :drag-type=\"dragType\" :uploading=\"uploading\" :is-writable=\"isWritable\" @drop-files=\"uploadFiles\" @drop-to-folder=\"dropToFolder\" > </asset-upload-drop> </transition> </div> </template> </collapsible-side-panel> </drop> </b-overlay> <asset-rename v-model=\"assetToRename\" :assets-handler=\"assetsHandler\" :asset-neighbors=\"assetRenameNeighbors\" @renamed=\"reloadData\" > </asset-rename> <assets-share-folder v-model=\"pathToShare\"> </assets-share-folder> <shared-folder-manager v-model=\"showSharedFoldersModal\"> </shared-folder-manager> <b-toast variant=\"warning\" class=\"mr-3\" toaster=\"b-toaster-bottom-right\" auto-hide-delay=\"10000\" :title=\"t('Warning!')\" :visible=\"downloadWarningToastVisible\" @hidden=\"downloadWarningToastVisible = false\" > <i18n tag=\"p\" :path=\" t( '{0} Note that if you wish to make a local backup of your Forge games and assets, we strongly recommend using the {1}. {2}Placing these downloaded assets in your local Foundry data is not enough to make any worlds exported from Forge use the local assets instead of the ones hosted in your Assets Library. All actors, scenes, items, journals, etc... must be updated to reference the local assets instead of the ones hosted by Forge, which the Asset Sync tool will do automatically.' ) \" > <i class=\"fas fa-exclamation-triangle text-warning\"></i> <a href=\"https://forums.forge-vtt.com/t/backing-up-your-assets-library-locally/13704\" target=\"_blank\" >Asset Sync Tool</a > <br /> </i18n> </b-toast> <b-modal id=\"max-selected-files-download-error-dialog\" :visible=\"maxFilesSelectedDownloadError\" :title=\"t('Error!')\" ok-only @ok=\"maxFilesSelectedDownloadError = false\" @cancel=\"maxFilesSelectedDownloadError = false\" @hide=\"maxFilesSelectedDownloadError = false\" > <i18n tag=\"p\" :path=\" t( 'The number of files selected exceeds the maximum number of files ({0}) that can be downloaded at once. Please select fewer files.' ) \" > <b>{{ Assets.MAX_DOWNLOAD_FILES }}</b> </i18n> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".assets-main-container { border: 1px solid rgba(0, 0, 0, 0.6); border-radius: 5px; min-height: 500px; } .assets-main-container .asset-browser-toolbox { min-width: 300px; width: 300px; background-color: rgba(0, 0, 0, 0.15); } .assets-main-container .filemanager-scroll-area { flex-grow: 1; overflow: scroll; border-radius: 0px 4px 4px 0px; } .assets-main-container .filemanager-container { display: flex; flex-direction: column; position: relative; overflow: hidden; width: 100%; border-radius: 5px; /*Prevent the scroll bar from clipping into the parent's border*/ height: 100%; } .filemanager { width: 100%; height: 100%; } .filemanager .fm-fill { height: calc(100% - 2em); width: -moz-available; width: -webkit-fill-available; } .filemanager .nothingfound i.watermark { text-align: center; width: 100%; } .filemanager .asset-selected-icon { color: var(--success); text-shadow: 2px 2px 2px rgb(0 0 0 / 30%); } .filemanager-container .upload-to-current { position: absolute; left: 0; right: 0; bottom: 0; width: -moz-available; width: -webkit-fill-available; height: 30%; } .asset-search-popover .popover-body { padding: 0.25rem; } .asset-op-overlay-contents .progress-container { height: 3em; } .asset-op-overlay-contents .progress-label { position: absolute; left: 0; right: 0; top: 0; bottom: 0; color: var(--light); display: flex; justify-content: center; align-items: center; }"
    });
  },
  props: {
    initialQuota: Object,
    // JSON object
    restrictSources: {
      type: Object,
      default: null
    },
    loadAmount: {
      type: Number,
      default: 28
    }
  },
  data() {
    return {
      totalMargin: 0,
      quota: {
        remaining: 0,
        total: 0,
        used: 0,
        percent: 0
      },
      sources: this.restrictSources ? this.restrictSources : {
        "my-assets": {
          id: "my-assets",
          name: t("My Assets Library"),
          permissions: ["read-assets", "write-assets"],
          key: null
        }
        // "forge-bazaar": {
        //   id: "forge-bazaar",
        //   name: t("Forge Bazaar"),
        //   permissions: ["read-assets"],
        //   key: null,
        // },
      },

      activeSourceId: "my-assets",
      assetsHandler: Assets.MyAssetsLibrary,
      assets: [],
      detailsAsset: null,
      detailsAssetTimeout: null,
      sidebarCollapsed: null,
      smallScreen: false,
      // With small viewports (i.e. mobile), set true so the sidebar uses full width
      largeBreakpoint: 0,
      viewedAssets: {
        folders: [],
        files: []
      },
      viewMode: "tile",
      // or "detail"
      sortBy: "alphabetic",
      // or "size", "time"
      sortDesc: false,
      tileSize: 120,
      listIconSize: 30,
      selectedAssets: [],
      assetsByPath: {},
      lastSelectedAsset: null,
      searchScopes: ["local", "recursive", "global"],
      infiniteId: Date.now(),
      loadingData: true,
      loadingSources: true,
      rendering: false,
      searchDone: false,
      searchResults: {
        files: [],
        folders: []
      },
      hash: "",
      assetToRename: null,
      assetRenameNeighbors: [],
      pathToShare: null,
      showSharedFoldersModal: false,
      dragging: false,
      dragType: "",
      fileDrag: false,
      fileDragTimeout: null,
      showUploadDialog: false,
      uploading: false,
      uploadDone: false,
      unzipAll: false,
      moving: false,
      moveMapping: {},
      showCollisionDialog: false,
      cancelMove: false,
      collisions: [],
      // Array of [src, dest] for each colliding move
      currentCollision: 0,
      collisionApplyToAll: false,
      copying: false,
      largeCopy: false,
      cancelCopy: false,
      deleting: false,
      opTotalCount: 0,
      // For move/copy progress bar
      opDoneCount: 0,
      // For move/copy progress bar
      downloadWarningToastVisible: false,
      maxFilesSelectedDownloadError: false,
      hideWarning: false,
      assetsToDownload: [],
      downloadInProgress: false
    };
  },
  watch: {
    data() {
      this.viewedAssets = {
        folders: [],
        files: []
      };
      this.infiniteHandler();
      this.infiniteId = Date.now();
    },
    activeSource(oldValue, newValue) {
      if (oldValue.key !== newValue.key) {
        // Reset the hash when changing sources, so the user sees the root of the new source with no active search.
        const hash = Assets.genHash("");
        window.location.hash = hash;
        this.reloadData();
      }
    },
    search() {
      if (this.search) {
        if (!this.loading) {
          this.searchAssets();
        } else {
          // Schedule a search for when loading is finished
          new Promise(resolve => {
            const interval = setInterval(() => {
              if (!this.loading) {
                clearInterval(interval);
                resolve();
              }
            }, 10);
          }).then(() => {
            this.searchAssets();
          });
        }
      }
    },
    uploading() {
      if (this.uploading) {
        // Hide file upload target once upload starts
        this.fileDrag = false;
      }
    }
  },
  computed: {
    parsedHash() {
      return Assets.parseHash(this.hash);
    },
    sortedSources() {
      // Sort sources by name, with your own Asset Library first, then Forge Bazaar, then alphabetically
      return Object.values(this.sources).sort((a, b) => {
        if (a.id === "my-assets" || b.id === "my-assets") {
          return a.id === "my-assets" ? -1 : 1;
        }
        if (a.id === "forge-bazaar" || b.id === "forge-bazaar") {
          return a.id === "forge-bazaar" ? -1 : 1;
        }
        return a.name.localeCompare(b.name);
      });
    },
    activeSource() {
      // Default to "my-assets" if activeSourceId is not valid
      if (!Object.keys(this.sources).includes(this.activeSourceId)) {
        return this.sources["my-assets"];
      }
      return this.sources[this.activeSourceId];
    },
    loading() {
      return this.loadingData || this.loadingSources;
    },
    search() {
      if (this.parsedHash.search) {
        return this.parsedHash.search;
      }
      return null;
    },
    searching() {
      return this.search !== null;
    },
    hotkeys() {
      return ["a", "v", "Delete", "Escape"];
    },
    currentPath() {
      const path = this.parsedHash.path.trim().replace(/\/+$|^\/+/g, "") // remove trailing and leading slash
      .replace(/\/+/g, "/"); // remove duplicate slash
      //.trim(); // Commented this out so that directories with a trailing space will continue to function.
      return path.length > 0 ? `${path}/` : "";
    },
    data() {
      if (this.loading) {
        return {
          files: [],
          folders: []
        };
      }
      this.rendering = false;
      this.$nextTick(() => this.rendering = true);
      let assets = {};
      if (this.searching && this.searchDone) {
        assets = this.searchResults;
      } else {
        assets = this.searchByPath(this.currentPath);
      }
      assets.files = assets.files.sort((a, b) => {
        switch (this.sortBy) {
          case "size":
            return this._sortSize(a, b, this.sortDesc);
          case "time":
            return this._sortTime(a, b, this.sortDesc);
          case "alphabetic":
          default:
            return this._sortAlpha(a, b, this.sortDesc);
        }
      });
      assets.folders = assets.folders.sort((a, b) => {
        switch (this.sortBy) {
          case "size":
            return this._sortSize(a, b, this.sortDesc);
          case "time":
            return this._sortTime(a, b, this.sortDesc);
          case "alphabetic":
          default:
            return this._sortAlpha(a, b, this.sortDesc);
        }
      });
      return assets;
    },
    files() {
      return this.viewedAssets.files;
    },
    folders() {
      return this.viewedAssets.folders;
    },
    currentView() {
      return this.folders.concat(this.files);
    },
    currentData() {
      return this.data.folders.concat(this.data.files);
    },
    singleSelectedFileAsset() {
      if (this.selectedAssets.length !== 1) {
        return null;
      }
      return this.viewedAssets.files.find(asset => asset.name === this.selectedAssets[0]);
    },
    detailsAssetSelected() {
      if (!this.singleSelectedFileAsset) {
        return false;
      }
      if (this.singleSelectedFileAsset && !this.detailsAsset) {
        return true;
      }
      if (this.singleSelectedFileAsset && this.detailsAsset) {
        return this.singleSelectedFileAsset.name === this.detailsAsset.name;
      }
      return false;
    },
    selectedAssetPaths() {
      const paths = new Set();
      this.selectedAssets.forEach(a => paths.add(Utils.dirname(a)));
      return paths;
    },
    selectedOtherPath() {
      if (this.selectedAssetPaths.size !== 1) {
        return false;
      }
      // Need to trim trailing slash from current path for accurate comparison
      return this.selectedAssetPaths.values().next().value !== this.currentPath.replace(/\/$/, "");
    },
    invalidDragPath() {
      if (this.selectedAssetPaths.size === 1) {
        // Apparently you can't access Set values without using an iterator of some kind?
        for (const item of this.selectedAssetPaths.values()) {
          return item;
        }
      }
      return null;
    },
    isOwner() {
      return this.assetsHandler.isOwner;
    },
    isWritable() {
      return this.assetsHandler.isWritable;
    },
    selectedStats() {
      if (this.selectedAssets.length === 0) {
        return {
          files: 0,
          folders: 0,
          totalSize: this.selectedTotalSize
        };
      }
      let folders = 0;
      let files = 0;
      this.selectedAssets.forEach(a => {
        if (a.endsWith("/")) {
          folders += 1;
        } else {
          files += 1;
        }
      });
      return {
        files,
        folders,
        totalSize: this.selectedTotalSize
      };
    },
    selectionLabel() {
      return this.fileCountLabel(this.selectedStats.folders, this.selectedStats.files);
    },
    selectedTotalSize() {
      const selectedMinusChildren = this.selectedAssets.filter(selected => {
        // If another asset's name is in this asset's name, this asset is a child of a selected folder
        return !this.selectedAssets.some(other => selected !== other && selected.includes(other));
      });
      return selectedMinusChildren.reduce((total, assetName) => {
        const folder = this.assetsByPath[Utils.dirname(assetName)];
        const asset = folder.children.find(a => a.name === assetName);
        return total += asset.size || 0;
      }, 0);
    },
    searchResultsLabel() {
      if (this.loading) {
        return "";
      }
      return this.fileCountLabel(this.data.folders.length, this.data.files.length);
    },
    withinBase64Data() {
      return this.currentPath.startsWith("base64data");
    },
    overlayHeader() {
      if (this.uploading && !this.uploadDone) {
        return t("Uploading…");
      }
      if (this.uploading && this.uploadDone) {
        return t("Upload Finished");
      }
      if (this.moving) {
        return t("Moving…");
      }
      if (this.copying) {
        return t("Copying…");
      }
      if (this.deleting) {
        return t("Deleting…");
      }
    },
    remainingCollisions() {
      // Number of collisions remaining to resolve after the current one
      return this.collisions.length - 1 - this.currentCollision;
    },
    multiPath() {
      return this.selectedAssetPaths.size > 1;
    }
  },
  methods: {
    async reloadData() {
      this.uploadDone = true;
      this.loadingData = true;
      this.clearSelection();
      this.assetsHandler = new Assets(this.activeSource.key);
      const assets = await this.assetsHandler.getFiles();
      // Freeze the data so it's not reactive, for performance reasons
      this.assetsByPath = Object.freeze(this._populateAllAssets(assets));
      this.assets = Object.freeze(assets);
      this.loadingData = false;
      this.updateQuota((await Assets.ensureQuotas()).assets);
      this.windowResize();
    },
    collapseSelection(selected, asset) {
      // Recursive method for selecting a directory if all assets in that directory are selected
      const dir = Utils.dirname(asset);
      const dirAssets = this.assetsByPath[dir].children;
      // If all of the assets in the containing directory are selected, select the directory instead
      if (Array.isArray(dirAssets) && dirAssets.every(da => selected.includes(da.name))) {
        selected = selected.filter(s => !dirAssets.some(da => da.name === s));
        selected.push(`${dir}/`);
        // Recursively check if the parent directory is also fully selected
        selected = this.collapseSelection(selected, dir);
      }
      return selected;
    },
    async assetsUploaded(assets) {
      await this.reloadData();
      if (!assets || !assets.length) {
        return;
      }
      // Clear selection and select all uploaded assets
      this.selectedAssets = (assets || []).reduce((selected, asset) => {
        if (!asset || !asset.path) {
          return selected;
        }
        // Add the asset to the selection
        selected.push(asset.path);
        return this.collapseSelection(selected, asset.path);
      }, []);
    },
    updateQuota(quotaData) {
      this.quota.total = quotaData.total;
      this.quota.used = quotaData.used;
      this.quota.remaining = quotaData.remaining || 0;
      this.quota.percent = Math.round(this.quota.used / this.quota.total * 100.0);
    },
    showAlert(alertData) {
      UI.alert(alertData.variant, alertData.message, true, alertData.timeout || 15000);
    },
    infiniteHandler($state) {
      if (this.viewedAssets.folders.length === this.data.folders.length && this.viewedAssets.files.length === this.data.files.length) {
        if ($state) {
          $state.complete();
        }
        return;
      }
      let target = this.viewedAssets.folders.length + this.viewedAssets.files.length + this.loadAmount;
      if (this.viewedAssets.folders.length < this.data.folders.length) {
        this.viewedAssets.folders = this.data.folders.slice(0, target);
        target -= this.viewedAssets.folders.length;
      }
      if (target > 0 && this.viewedAssets.files.length < this.data.files.length) {
        this.viewedAssets.files = this.data.files.slice(0, target);
      }
      if ($state) {
        $state.loaded();
      }
    },
    remToPx(rem) {
      return rem * (this.$el ? parseFloat(getComputedStyle(this.$el).fontSize) : 15);
    },
    windowResize() {
      // Calculate the total margin size to inform the main container height.
      const topBarRect = this.$refs.topBar ? this.$refs.topBar.getBoundingClientRect() : null;
      let topBarHeight = 0;
      if (topBarRect) {
        topBarHeight = topBarRect.bottom - topBarRect.top;
      }
      // Main container top margin is 4rem+25px, plus 1rem padding
      const topMargin = this.remToPx(5) + 25 + topBarHeight;
      // Leave 1.5rem at bottom of viewport
      const botMargin = this.remToPx(1.5);
      this.totalMargin = topMargin + botMargin;

      // Change sidebar behaviour based on viewport width
      this.largeBreakpoint = this.largeBreakpoint || 1000;
      if (this.$el) {
        this.largeBreakpoint = Number(getComputedStyle(this.$el).getPropertyValue("--breakpoint-lg").replace(" ", "").replace("px", ""));
      }
      this.smallScreen = window.innerWidth < this.largeBreakpoint;
    },
    toggleSidebarCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      this.saveStateToStorage();
    },
    async loadSources() {
      if (this.restrictSources) {
        return;
      }
      this.loadingSources = true;
      const response = await Utils.api("shared-keys", {}, {
        method: "GET"
      });
      if (!response.success) {
        console.error(response.message);
        UI.error(t("Error: Failed to load shared keys."));
        this.activeSourceId = "my-assets";
      } else {
        response.keys.filter(key => key.key).forEach(key => {
          if (Utils.isValidAPIKey(key.key)) {
            const keyData = Assets.parseKey(key.key);
            let name = keyData.name;
            if (name.length > 50) {
              name = `${name.slice(0, 50)}…`;
            }
            this.$set(this.sources, key.id, {
              id: key.id,
              name: t("Shared Folder: {{- folderName}}", {
                folderName: name
              }),
              permissions: keyData.permissions || [],
              key: key.key
            });
          }
        });
      }
      this.loadingSources = false;
    },
    loadStateFromStorage() {
      if (!localStorage.assetsBrowser) {
        console.log("First time mounting AssetsBrowser, saving default configuration.");
        this.saveStateToStorage();
      } else {
        const saved = JSON.parse(localStorage.assetsBrowser);
        // Load configuration from localStorage, making sure not to overwrite any attrs with undefined/null/etc...
        if (saved.sidebarCollapsed !== undefined) {
          this.sidebarCollapsed = saved.sidebarCollapsed;
        } else if (this.sidebarCollapsed === undefined) {
          this.sidebarCollapsed = !this.smallScreen;
        }
      }
    },
    saveStateToStorage() {
      localStorage.assetsBrowser = JSON.stringify({
        sidebarCollapsed: this.sidebarCollapsed === null ? !this.smallScreen : this.sidebarCollapsed
      });
    },
    changeSource(sourceId) {
      this.activeSourceId = sourceId;
    },
    hotkeyHandler(event) {
      if (!event.key) {
        return;
      }
      if (!this.hotkeys.includes(event.key)) {
        return;
      }
      // If the user has focused an input element, ignore hotkeys so typing works normally
      if (["input"].includes(document.activeElement.tagName.toLowerCase())) {
        return;
      }
      switch (event.key) {
        case "a":
          if (event.ctrlKey) {
            event.preventDefault();
            if (this.parsedHash.search) {
              // Viewing search results, use data
              this.data.files.concat(this.data.folders).forEach(a => {
                if (!this.selectedAssets.includes(a.name)) {
                  this.toggleAssetSelection(a, true);
                }
              });
            } else {
              // No search, so we are viewing a folder path. Use assetsByPath.
              let path = this.currentPath;
              if (path.endsWith("/")) {
                path = path.slice(0, -1);
              }
              this.assetsByPath[path].children.forEach(a => {
                if (!this.selectedAssets.includes(a.name)) {
                  this.toggleAssetSelection(a, true);
                }
              });
            }
          }
          break;
        case "v":
          if (event.ctrlKey) {
            event.preventDefault();
            this.pasteAssets();
          }
          break;
        case "Delete":
          event.preventDefault();
          this.deleteSelection();
          break;
        case "Escape":
          event.preventDefault();
          this.clearSelection();
          break;
      }
    },
    changeViewMode(event) {
      if (event.tileMode) {
        this.viewMode = "tile";
      } else {
        this.viewMode = "detail";
      }
      this.sortBy = event.sortBy;
      this.sortDesc = event.sortDesc;
    },
    iconSizeChange(newSize) {
      if (this.viewMode === "tile") {
        this.tileSize = newSize;
      } else {
        this.listIconSize = newSize;
      }
    },
    onTableSortChanged(event) {
      this.sortDesc = event.sortDesc;
      switch (event.sortBy) {
        case "basename":
          this.sortBy = "alphabetic";
          break;
        case "size":
          this.sortBy = "size";
          break;
        case "mtime":
          this.sortBy = "time";
          break;
      }
    },
    _sortAlpha(a, b, desc) {
      if (!desc) {
        return a.basename.localeCompare(b.basename);
      }
      return b.basename.localeCompare(a.basename);
    },
    _sortSize(a, b, desc) {
      // Empty folders have no size attribute, so fill with 0's as needed
      if (!desc) {
        return (a.size || 0) - (b.size || 0);
      }
      return (b.size || 0) - (a.size || 0);
    },
    _sortTime(a, b, desc) {
      const aDate = Date.parse(a.mtime);
      const bDate = Date.parse(b.mtime);
      if (aDate === bDate) {
        return this._sortAlpha(a, b, false);
      }
      if (!desc) {
        return Date.parse(a.mtime) - Date.parse(b.mtime);
      }
      return Date.parse(b.mtime) - Date.parse(a.mtime);
    },
    fileCountLabel(dirs, files) {
      if (!dirs && !files) {
        return t("nothing");
      }
      if (!dirs) {
        return t("ASSETS.files", {
          count: files
        });
      }
      if (!files) {
        return t("ASSETS.folders", {
          count: dirs
        });
      }
      return t("ASSETS.files and folders", {
        count: dirs + files
      });
    },
    // Locates a file by path
    searchByPath(dir) {
      const path = Utils.cleanPath(dir);
      const assets = this.assetsByPath[path] || {
        children: []
      };
      return {
        folders: assets.children.filter(a => a.isDirectory),
        files: assets.children.filter(a => !a.isDirectory)
      };
    },
    // Search through the file tree according to current search scope
    async searchAssets() {
      this.searchDone = false;
      this.searchResults.files = [];
      this.searchResults.folders = [];
      if (!this.search || !this.search.terms || !this.search.terms.length) {
        this.searchDone = true;
        return;
      }
      if (!this.searchScopes.includes(this.search.scope)) {
        this.search.scope = "local";
      }
      let startDir = "";
      switch (this.search.scope) {
        case "local":
          this.searchResults = this._searchAssetsLocal(this.currentPath);
          this.searchDone = true;
          return;
        case "recursive":
          // Strip trailing slash from currentPath so we can find it in this.assetsByPath
          startDir = Utils.cleanPath(this.currentPath);
          // If current path is empty we are at the root.
          // Recursive search from root is the same as global search.
          if (!startDir) {
            this.searchResults = this._searchAssetsGlobal();
            this.searchDone = true;
            return;
          }
          // Otherwise, find initial folder
          this.searchResults = this._searchAssetsRecursive(this.assetsByPath[startDir].asset);
          this.searchDone = true;
          return;
        case "global":
          this.searchResults = this._searchAssetsGlobal();
          this.searchDone = true;
          return;
      }
    },
    _matchesTerms(name) {
      if (!this.search || !name) {
        return false;
      }
      name = name.toLowerCase();
      // Effectively AND terms - first term which fails to match returns false.
      for (const t of this.search.terms) {
        if (!name.includes(t.toLowerCase())) {
          return false;
        }
      }
      return true;
    },
    // Search only assets in a given folder
    _searchAssetsLocal(path) {
      const localFiles = this.searchByPath(path);
      const results = {
        folders: localFiles.folders.filter(f => this._matchesTerms(f.basename || Utils.basename(f.name))),
        files: localFiles.files.filter(f => this._matchesTerms(f.basename || Utils.basename(f.name)))
      };
      return results;
    },
    // Search for assets in the current folder and recursively through child folders
    _searchAssetsRecursive(folder) {
      // Get the search results for the given folder.
      const results = this._searchAssetsLocal(folder.name);
      // Then recursively collect the search results in each child folder.
      this.searchByPath(folder.name).folders.forEach(folder => {
        const folderResults = this._searchAssetsRecursive(folder);
        results.files = results.files.concat(folderResults.files);
        results.folders = results.folders.concat(folderResults.folders);
      });
      return results;
    },
    // Search for assets recursively throughout the whole tree
    _searchAssetsGlobal() {
      let folders = [];
      let files = [];
      this.assets.forEach(d => {
        const name = d.basename || Utils.basename(d.name);
        if (this._matchesTerms(name)) {
          if (d.isDirectory) {
            folders.push(d);
          } else {
            files.push(d);
          }
        }
      });
      return {
        folders,
        files
      };
    },
    _populateAllAssets(assets) {
      return assets.reduce((all, a) => {
        a.basename = Utils.basename(a.name);
        a.isDirectory = a.name.endsWith("/");
        let parent = Utils.dirname(a.name);
        all[parent] = all[parent] || {
          asset: null,
          children: [],
          size: 0
        };
        all[parent].children.push(a);
        if (a.isDirectory) {
          const path = Utils.cleanPath(a.name);
          all[path] = all[path] || {
            asset: null,
            children: [],
            size: 0
          };
          a.children = all[path].children;
          all[path].asset = a;
        } else {
          all[parent].size += a.size;
          if (all[parent].asset) {
            all[parent].asset.size = all[parent].size;
          }
          while (parent != "") {
            parent = Utils.dirname(parent);
            all[parent] = all[parent] || {
              asset: null,
              children: [],
              size: 0
            };
            all[parent].size += a.size;
            if (all[parent].asset) {
              all[parent].asset.size = all[parent].size;
            }
          }
        }
        return all;
      }, {});
    },
    renameAsset(asset) {
      if (!asset) {
        return;
      }
      this.assetToRename = asset;
      // Only check collisions with other assets of the same type (folder vs file)
      this.assetRenameNeighbors = this.assetsByPath[Utils.dirname(asset.name)].children.filter(n => n.name !== asset.name && n.isDirectory === asset.isDirectory).reduce((n, a) => {
        n.push(a.basename);
        return n;
      }, []);
    },
    async downloadFileAsset(asset) {
      this.assetsToDownload = [asset];
      this.downloadWarningToastVisible = true;
      this.downloadInProgress = true;
      await Assets.downloadAssets(this.assetsToDownload);
      this.downloadInProgress = false;
    },
    async downloadAssets() {
      this.assetsToDownload = [];
      let childrenCount = this.selectedStats.files;
      if (childrenCount > Assets.MAX_DOWNLOAD_FILES) {
        this.maxFilesSelectedDownloadError = true;
        return;
      }
      if (this.selectedStats.folders > 0) {
        for (const asset of this.selectedAssets) {
          if (asset.endsWith("/")) {
            const folder = this.assetsByPath[asset.slice(0, -1)];
            childrenCount += Assets.childrenCount(folder.asset);
            if (childrenCount > Assets.MAX_DOWNLOAD_FILES) {
              // early exit
              this.maxFilesSelectedDownloadError = true;
              return;
            }
          }
        }
      }
      this.selectedAssets.forEach(assetName => {
        const baseAsset = this.assetsByPath[Utils.dirname(assetName)].children.find(a => a.name === assetName);
        if (baseAsset.isDirectory) {
          this.addAssetChildrenToDownload(baseAsset);
        } else {
          this.assetsToDownload.push({
            ...baseAsset
          });
        }
      });
      this.downloadWarningToastVisible = true;
      this.downloadInProgress = true;
      await Assets.downloadAssets(this.assetsToDownload);
      this.downloadInProgress = false;
    },
    addAssetChildrenToDownload(assetFolder) {
      if (assetFolder.children) {
        assetFolder.children.forEach(child => {
          if (child.isDirectory) {
            this.addAssetChildrenToDownload(child);
          } else {
            this.assetsToDownload.push({
              ...child
            });
          }
        });
      }
    },
    assetHover(asset, isOver) {
      // console.log("assetHover", asset, isOver);
      if (this.detailsAssetTimeout) {
        clearTimeout(this.detailsAssetTimeout);
      }
      this.detailsAssetTimeout = null;
      if (isOver) {
        this.detailsAsset = asset;
      } else {
        this.detailsAssetTimeout = setTimeout(() => this.detailsAsset = null, 250);
      }
    },
    async selectAsset(asset, event) {
      const shiftPressed = event ? event.shiftKey : false;
      if (this.selectedAssets.includes(asset.name)) {
        this.toggleAssetSelection(asset, false);
        this.lastSelectedAsset = null;
      } else {
        if (shiftPressed && this.lastSelectedAsset) {
          const lastIdx = this.currentView.findIndex(a => a.name === this.lastSelectedAsset.name);
          const currentIdx = this.currentView.findIndex(a => a.name === asset.name);
          console.log("Shift select from ", lastIdx, " to ", currentIdx);
          if (lastIdx !== -1 && currentIdx !== -1) {
            const first = Math.min(lastIdx, currentIdx);
            const last = Math.max(lastIdx, currentIdx);
            for (let idx = first; idx < last; idx++) {
              const current = this.currentView[idx];
              if (!this.selectedAssets.includes(current.name)) {
                this.toggleAssetSelection(current, true);
              }
            }
          }
        }
        this.toggleAssetSelection(asset, true);
        this.lastSelectedAsset = asset;
      }
    },
    toggleAssetSelection(asset, select) {
      if (select) {
        this.selectedAssets.push(asset.name);
      } else {
        this.selectedAssets = this.selectedAssets.filter(a => a !== asset.name);
      }
    },
    clearSelection() {
      this.selectedAssets = [];
    },
    pasteAssets() {
      if (this.searching) {
        UI.alert("warning", t("You cannot paste assets into search results. Clear your search or navigate into a folder and try again."));
        return;
      }
      this.copyAssets(this.currentPath);
    },
    deleteFile(asset) {
      return this.deleteAssets([asset.name]);
    },
    deleteFolder(asset) {
      return this.deleteAssets([asset.name]);
    },
    deleteSelection() {
      return this.deleteAssets(this.selectedAssets);
    },
    downloadSelection() {
      this.downloadAssets();
    },
    async deleteAssets(paths) {
      if (paths.length === 0) {
        return;
      }
      const dirs = paths.some(a => a.endsWith("/"));
      const files = paths.some(a => !a.endsWith("/"));
      let type = "";
      let content = "";
      let warning = "";
      if (!dirs) {
        type = t("PLURAL.Files", {
          count: paths.length
        });
        content = t("ASSETS.ConfirmDeleteFiles", {
          count: paths.length,
          toDelete: `<strong>${t(`ASSETS.files`, {
            count: paths.length
          })}</strong>`,
          assetName: `“<strong>${Utils.escapeHTML(Utils.basename(paths[0]))}</strong>”`
        });
      } else if (!files) {
        type = t("PLURAL.Folders", {
          count: paths.length
        });
        content = t("ASSETS.ConfirmDeleteFolders", {
          count: paths.length,
          toDelete: `<strong>${t(`ASSETS.folders`, {
            count: paths.length
          })}</strong>`,
          assetName: `“<strong>${Utils.escapeHTML(Utils.basename(paths[0]))}</strong>”`
        });
      } else {
        type = t("PLURAL.Assets", {
          count: paths.length
        });
        content = t("ASSETS.ConfirmDeleteAssets", {
          count: paths.length,
          toDelete: `<strong>${t(`ASSETS.files and folders`, {
            count: paths.length
          })}</strong>`,
          assetName: `“<strong>${Utils.escapeHTML(Utils.basename(paths[0]))}</strong>”`
        });
      }
      if (dirs && paths.find(p => p === "base64data/")) {
        warning = `<div class="alert alert-danger mt-2">${t("The base64data folder is a system folder created automatically by The Forge. It is strongly recommended not to delete this folder.")}</div>`;
      }
      const result = await UI.query(t(`Delete {{type}}`, {
        type
      }), `${content}${warning}`, {
        buttons: [{
          id: "delete-assets-no",
          type: "success",
          label: t("No"),
          response: "no"
        }, {
          id: "delete-assets-yes",
          type: "danger",
          label: t("Yes, Delete {{type}}", {
            type
          }),
          response: "yes"
        }]
      });
      console.log("Delete assets, result : ", result);
      if (result === "yes") {
        this.deleting = true;
        let response = {
          success: false
        };
        if (paths.length === 1 && !paths[0].endsWith("/")) {
          response = await this.assetsHandler.deleteFile(paths[0]);
        } else {
          response = await this.assetsHandler.deleteMany(paths);
        }
        this.deleting = false;
        console.log("Delete response:", response);
        if (response.success) {
          UI.alert("success", t("{{type}} deleted successfully", {
            type
          }), true, 10000);
          this.reloadData();
        } else {
          UI.alert("danger", t("Error deleting {{type}}: {{- error}}", {
            type: type.toLowerCase(),
            error: response.error || t("Unknown error")
          }));
        }
      }
    },
    dragAsset({
      asset,
      name,
      nativeEvent
    }) {
      if (name === "dragstart" && !this.selectedAssets.includes(asset.name)) {
        this.selectedAssets.push(asset.name);
      }
      this.drag({
        name,
        nativeEvent
      });
    },
    drag({
      name,
      nativeEvent
    }) {
      if (name === "dragstart") {
        this.dragging = true;
        this.dragType = nativeEvent.dataTransfer.dropEffect;
        nativeEvent.dataTransfer.setData("text/plain", `forge-asset-${nativeEvent.dataTransfer.dropEffect}`);
      }
      if (name === "dragend") {
        this.dragging = false;
        this.dragType = "";
      }
    },
    isFolderValidDrop(folderName) {
      // This needs to be a method because you can't inline regex in Vue template
      return this.isWritable && folderName.replace(/\/+$/, "") !== this.invalidDragPath;
    },
    async drop({
      asset,
      nativeEvent
    }) {
      return this.dropPath({
        path: asset.name,
        nativeEvent
      });
    },
    dropFiles({
      name,
      nativeEvent
    }) {
      // Show an upload target in the file manager area when files are dragged from the OS into the browser
      if (name === "dragover") {
        this.fileDrag = nativeEvent.dataTransfer.types.includes("Files");
        if (this.fileDrag) {
          if (this.fileDragTimeout) {
            clearTimeout(this.fileDragTimeout);
          }
          // Safeguard to make sure that the drop target gets hidden if we miss the dragleave or drop events
          this.fileDragTimeout = setTimeout(() => {
            this.fileDrag = false;
            this.fileDragTimeout = null;
          }, 2000);
        }
      } else if (name === "drop") {
        this.fileDrag = false;
      }
    },
    dragOver(event) {
      if (!event) {
        this.fileDrag = false;
      }
    },
    async dropPath({
      path,
      nativeEvent
    }) {
      let type = "";
      try {
        // Prevent a desktop file being dropped on the page from activating a move
        type = nativeEvent.dataTransfer.getData("text/plain");
        if (type !== "forge-asset-move" && type !== "forge-asset-copy") {
          return;
        }
      } catch (err) {
        return;
      }
      if (this.selectedAssets.length === 0) {
        return;
      }
      switch (type) {
        case "forge-asset-move":
          console.log("Moving selected files into path ", path);
          await this.initMoveAssets(path);
          break;
        case "forge-asset-copy":
          console.log("Copying selected files into path ", path);
          await this.copyAssets(path);
          break;
        default:
          console.error("Invalid asset drop type: ", type);
          break;
      }
    },
    async initMoveAssets(path) {
      if (this.selectedAssets.length === 0) {
        return;
      }
      if (!path.endsWith("/")) {
        path += "/";
      }
      const root = path === "/" ? t("Root folder") : t("folder");
      const htmlPath = path === "/" ? "" : `&apos;<strong>${path}</strong>&apos; `;
      const result = await UI.query(t("Move {{selectionLabel}}", {
        selectionLabel: this.selectionLabel
      }), `<div>
          ${t("Are you sure you want to move {{selectionLabel}} to the {{rootFolder}} {{- htmlPath}}?", {
        selectionLabel: this.selectionLabel,
        rootFolder: root,
        htmlPath
      })}
        </div>
        
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
          ${t("If you proceed, any assets used in your games which refer to this {{selectionLabel}} will become broken and you will need to manually reset them.", {
        selectionLabel: this.selectionLabel
      })} <br />
          ${t("It is recommended to only move assets that are unused and not referenced in any of your games.")}
        </div>
        `, {
        buttons: [{
          id: "move-assets-no",
          type: "success",
          label: t("No"),
          response: "no"
        }, {
          id: "move-assets-yes",
          type: "danger",
          label: t(`Yes, I'm sure`),
          response: "yes"
        }]
      });
      console.log("Move assets, result : ", result);
      if (result === "yes") {
        this.clearCollisionState();
        // remove leading slash on root folder
        if (path === "/") {
          path = "";
        }
        this.moveMapping = this.selectedAssets.reduce((mapping, asset) => {
          mapping[asset] = `${path}${Utils.basename(asset)}${asset.endsWith("/") ? "/" : ""}`;
          // Remove a rename to itself
          if (asset === mapping[asset]) {
            delete mapping[asset];
          }
          return mapping;
        }, {});
        console.log("Mapping is: ", this.moveMapping);
        if (Object.keys(this.moveMapping).length === 0) {
          UI.alert("warning", t("Move aborted: all selected assets already exist at the destination"), true, 20000);
          return;
        }

        // Generate an array from the move mapping, so that we can iterate it in a predictable fashion.
        for (const [src, dest] of Object.entries(this.moveMapping)) {
          const dirname = Utils.dirname(dest);
          if (this.assetsByPath[dirname] && this.assetsByPath[dirname].children.some(c => c.name === dest)) {
            this.collisions.push([src, dest]);
          }
        }
        if (this.collisions.length > 0) {
          this.currentCollision = 0;
          this.showCollisionDialog = true;
        } else {
          // No collisions, just do the move immediately.
          this.moveAssets();
        }
      }
    },
    async moveAssets() {
      console.log(`Move ${Object.keys(this.moveMapping).length} assets`);
      if (Object.keys(this.moveMapping).length < 1) {
        return;
      }
      this.moving = true;
      const response = (await this.assetsHandler.renameAssets(this.moveMapping).catch(null)) || {};
      this.moving = false;
      console.log("Move response:", response);
      if (response.success) {
        UI.alert("success", t("{{selectionLabel}} moved successfully", {
          selectionLabel: this.selectionLabel
        }), true, 10000);
        this.reloadData();
      } else {
        UI.alert("danger", `${response.error || t("Unknown error while moving assets")}`);
      }
      // Clear collision resolver state
      this.clearCollisionState();
    },
    collisionSkip() {
      if (this.collisionApplyToAll) {
        for (; this.currentCollision < this.collisions.length; this.currentCollision++) {
          delete this.moveMapping[this.collisions[this.currentCollision][0]];
        }
      } else {
        // Remove current collision from mapping
        delete this.moveMapping[this.collisions[this.currentCollision][0]];
      }
      this.iterateCollision();
    },
    iterateCollision() {
      this.currentCollision++;
      // If no more collisions, execute move
      if (this.collisionApplyToAll || this.currentCollision >= this.collisions.length) {
        this.showCollisionDialog = false;
        this.moveAssets();
      }
    },
    clearCollisionState() {
      this.showCollisionDialog = false;
      this.cancelMove = false;
      this.moveMapping = {};
      this.collisions = [];
      this.currentCollision = 0;
      this.collisionApplyToAll = false;
    },
    async copyAssets(path) {
      if (this.selectedAssets.length === 0) {
        return;
      }
      if (!path.endsWith("/")) {
        path += "/";
      }
      let toCopy = this.selectedAssets.filter(selected => {
        // If another asset's name is in this asset's name, this asset is a child of a selected folder
        return !this.selectedAssets.some(other => selected !== other && selected.includes(other));
      }).reduce((assets, assetName) => {
        // Find all selected assets, recursing folders as necessary, and build the objects needed for the assets/create API
        const baseAsset = this.assetsByPath[Utils.dirname(assetName)].children.find(a => a.name === assetName);
        if (baseAsset.isDirectory) {
          assets.push(...this._copyRecurseFolders(path, baseAsset.basename, baseAsset));
        } else {
          const asset = {
            path: `${path}${Utils.basename(assetName)}`,
            etag: baseAsset.hash,
            size: baseAsset.size
          };
          assets.push(asset);
        }
        return assets;
      }, []);
      const fullCopySize = toCopy.length;
      // Filter out target asset paths which already exist
      toCopy = this._copyFilterExistingPaths(toCopy);
      // Warn the user if any target asset paths were filtered out
      if (!toCopy.length) {
        UI.alert("warning", t("Copy aborted: all selected assets already exist at the destination"), true, 20000);
        return;
      } else if (fullCopySize - toCopy.length > 0) {
        UI.alert("warning", t("{{ignoredCount}} assets will not be copied because they already exist at the destination", {
          ignoredCount: fullCopySize - toCopy.length
        }), true, 20000);
      }
      // Confirm user intent if there are a lot of assets to copy
      this.largeCopy = toCopy.length > 250;
      if (this.largeCopy) {
        const copySize = Utils.bytesToHuman(toCopy.reduce((total, asset) => total + asset.size, 0));
        const result = await UI.query(t("Confirm Large Copy Set"), `<div>
            ${t("Are you sure you want to copy {{count}} assets?", {
          count: toCopy.length
        })}
          </div>
          
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-warning">
            ${t("If you proceed, {{copySize}} of your asset quota will be used by the copied assets.", {
          copySize
        })}
          </div>
          `, {
          buttons: [{
            id: "copy-assets-no",
            type: "success",
            label: t("No"),
            response: "no"
          }, {
            id: "copy-assets-yes",
            type: "warning",
            label: t(`Yes, I'm sure`),
            response: "yes"
          }]
        });
        if (result !== "yes") {
          return;
        }
      }
      // Start copying assets
      let successTotal = 0;
      let failureTotal = 0;
      let success = true;
      this.cancelCopy = false;
      this.copying = true;
      this.opTotalCount = toCopy.length;
      this.opDoneCount = 0;
      const response = await this.assetsHandler.createAssets(toCopy, partial => {
        if (partial.success) {
          const failures = partial.results.filter(res => !res.success).length;
          failureTotal += failures;
          successTotal += partial.results.length - failures;
        } else {
          success = false;
        }
        this.opDoneCount += partial.results.length;
        return !this.cancelCopy;
      });
      console.log(`${successTotal} successes and ${failureTotal} failures.`);
      this.cancelCopy = false;
      this.copying = false;
      // Inform user of success or failure
      if (success) {
        if (failureTotal) {
          UI.alert("danger", t("{{failureLabel}} failed to copy. {{successLabel}} copied successfully.", {
            failureLabel: this.fileCountLabel(0, failureTotal),
            successLabel: this.fileCountLabel(0, successTotal)
          }), true, 10000);
        } else {
          UI.alert("success", t("{{selectionLabel}} copied successfully", {
            selectionLabel: this.fileCountLabel(0, successTotal)
          }), true, 10000);
        }
        this.reloadData();
      } else {
        UI.alert("danger", `${response.error || t("Unknown error while copying assets")}`);
      }
    },
    _copyRecurseFolders(newPath, subPath, folder) {
      const children = [];
      const path = `${newPath}${subPath}/`;
      folder.children.forEach(asset => {
        if (asset.isDirectory) {
          children.push(...this._copyRecurseFolders(newPath, `${subPath}/${asset.basename}`, asset));
        } else {
          children.push({
            path: `${path}${Utils.basename(asset.name)}`,
            etag: asset.hash,
            size: asset.size
          });
        }
      });
      return children;
    },
    _copyFilterExistingPaths(payload) {
      // Remove new paths which already exist
      return payload.filter(target => {
        const dir = this.assetsByPath[Utils.dirname(target.path)];
        return !dir || !this.assetsByPath[Utils.dirname(target.path)].children.map(a => a.name).includes(target.path);
      });
    },
    dropToFolder(event) {
      this.dropPath({
        path: this.currentPath,
        nativeEvent: event
      });
    },
    async uploadFiles(files) {
      this.uploading = true;
      this.uploadDone = false;
      const zipFiles = files.filter(f => f.type === "application/zip");
      if (zipFiles && zipFiles.length) {
        let zipList = zipFiles.reduce((list, f) => {
          return list + `<li>${f.name}</li>`;
        }, "<ul>");
        zipList += "</ul>";
        // Using UI.query instead of a b-modal to avoid needing a set of data fields to pass the file list to _uploadFiles.
        const result = await UI.query(t("Unzip Files?"), `<p>${t("The following files you dropped are ZIP files. Would you like them to be unzipped before upload?")}</p>${zipList}`, {
          buttons: [{
            id: "unzip-no",
            label: t("Don't Unzip"),
            response: "no"
          }, {
            id: "unzip-yes",
            type: "success",
            label: t("Unzip"),
            response: "yes"
          }],
          dialog_classes: "modal-lg modal-dialog-centered"
        });
        this.unzipAll = result === "yes";
      }
      this.$nextTick(() => this._uploadFiles(files));
    },
    async _uploadFiles(files) {
      if (this.$refs.uploader) {
        console.log("Invoking uploader");
        // Don't need to set or unset this.uploading, the uploading will emit events itself.
        await this.$refs.uploader.uploadAssets(files);
        // Clear unzipAll to be ready for next upload
        this.unzipAll = false;
      } else {
        // Fallback if the uploader isn't mounted for some reason
        console.log("Uploader component is not available, fallback to using the API directly.");
        this.uploading = true;
        await this.assetsHandler.uploadFiles(this.currentPath, files, null, this.assets);
        this.uploading = false;
        this.reloadData();
      }
    },
    async shareFolder(folder = null) {
      if (!folder) {
        this.pathToShare = this.currentPath || "/";
      } else {
        this.pathToShare = folder.name;
      }
    }
  },
  async mounted() {
    // Limit height to fit within the viewport
    this.windowResize();
    window.addEventListener("resize", this.windowResize);
    // Respond to hash changes
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
    // Get the source list from User's account
    this.loadSources();
    // Load last state from localStorage
    this.loadStateFromStorage();
    // Initialize quota feedback
    this.updateQuota(this.initialQuota);
    // Load asset data
    this.reloadData();
    // Add hotkeys to window
    $(window).keydown(this.hotkeyHandler);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsBrowserToolbar"] = Vue.component(
                    "AssetsBrowserToolbar",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"asset-browser-toolbar\"> <b-button v-b-tooltip.hover.noninteractive class=\"my-1 w-100\" :title=\"t('Expand Toolbar')\" @click=\"$emit('collapse')\" > <i class=\"fas fa-caret-right\"></i> </b-button> <b-button v-if=\"isWritable\" v-b-tooltip.hover.noninteractive class=\"my-1 w-100\" :title=\"t('New Folder')\" @click=\"showNewFolder = true\" > <i class=\"fas fa-folder-plus\"></i> <asset-new-folder v-model=\"showNewFolder\" :path=\"currentPath\" :assets-handler=\"assetsHandler\" @created=\"$emit('folder-created')\" ></asset-new-folder> </b-button> <b-button v-if=\"isWritable\" v-b-tooltip.hover.noninteractive class=\"my-1 w-100 upload-button\" :title=\"t('Upload')\" @click=\"$emit('upload-assets')\" > <i class=\"fas fa-cloud-upload-alt\"></i> </b-button> <hr class=\"my-1\" /> <div v-b-tooltip.hover.noninteractive :title=\"getTooltip(moveButtonTooltip)\"> <drag tag=\"span\" :draggable=\"isWritable\" :image-x-offset=\"75\" :image-y-offset=\"50\" drop-effect=\"move\" @drag=\"$emit('drag', $event)\" > <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <b-button variant=\"info\" style=\"cursor: move\" :disabled=\"!selectedCount || !isWritable\" class=\"my-1 w-100\" @click=\"move\" > <i class=\"fas fa-arrows-alt\"></i> </b-button> </drag> </div> <div v-b-tooltip.hover.noninteractive :title=\"getTooltip(copyButtonTooltip)\"> <drag tag=\"span\" :draggable=\"isWritable\" :image-x-offset=\"75\" :image-y-offset=\"50\" drop-effect=\"copy\" @drag=\"$emit('drag', $event)\" > <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <b-button class=\"my-1 w-100\" style=\"cursor: move\" :disabled=\"!selectedCount || !isWritable\" @click=\"copy\"> <i class=\"fas fa-copy\"></i> </b-button> </drag> </div> <div v-b-tooltip.hover.noninteractive :title=\"getTooltip(t('Delete all selected assets'))\"> <b-button variant=\"danger\" class=\"my-1 w-100\" :disabled=\"!selectedCount || !isWritable\" @click=\"$emit('delete-selection')\" > <i class=\"far fa-trash-alt\"></i> </b-button> </div> <div v-b-tooltip.hover.noninteractive :title=\"getTooltip(t('Deselect all assets'), false)\"> <b-button class=\"my-1 w-100\" :disabled=\"!selectedCount\" @click.prevent=\"$emit('clear-selection')\"> <i class=\"far fa-minus-square\"></i> </b-button> </div> <div v-b-tooltip.hover.noninteractive :title=\"downloadInProgress ? getTooltip(t('Downloading'), false) : getTooltip(t('Download'), false)\" > <b-button class=\"my-1 w-100\" :disabled=\" selectedStats.totalSize === 0 || selectedStats.totalSize > Assets.MAX_DOWNLOAD_SIZE || downloadInProgress \" @click.prevent=\"$emit('download-selection')\" > <i v-if=\"downloadInProgress\" class=\"fa fa-spinner fa-spin\"></i> <i v-else class=\"fa fa-download\"></i> </b-button> </div> <div v-if=\"selectedMultiPath || selectedOtherPath\" id=\"warning-details\" class=\"mt-1\"> <div class=\"btn btn-outline-secondary\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </div> <b-tooltip target=\"warning-details\" triggers=\"hover\" custom-class=\"asset-details-selection-tooltip\"> <b-card no-title class=\"mt-1 mb-1 asset-details-selection-info bg-light text-dark\"> <div v-if=\"selectedMultiPath\" class=\"warning\"> <strong class=\"text-danger\">{{ t(\"Warning:\") }}</strong> {{ t(\"You have files selected from multiple different folders.\") }} <hr /> </div> <div v-else-if=\"selectedOtherPath\" v-b-tooltip.hover.noninteractive class=\"warning\" :title=\"t('The princess is in another castle!')\" > <strong class=\"text-danger\">{{ t(\"Warning:\") }}</strong> {{ t(\"You have files selected in another folder.\") }} </div> <b-row> <b-col cols=\"6\">{{ t(\"Selected:\") }}</b-col> <b-col cols=\"3\"><i class=\"fas fa-folder\"></i> {{ selectedFolders }}</b-col> <b-col cols=\"3\"><i class=\"fas fa-file\"></i> {{ selectedFiles }}</b-col> </b-row> <b-row> <b-col cols=\"6\"> <strong>{{ t(\"Total Size:\") }}</strong> </b-col> <b-col cols=\"6\">{{ selectedTotalSizeH }}</b-col> </b-row> </b-card> </b-tooltip> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".upload-button { padding-left: 0.65rem; /* The upload cload icon is not centered in the button */ } .asset-browser-toolbar button.disabled { cursor: not-allowed !important; } .asset-details-selection-tooltip .tooltip-inner { min-width: 300px; } .asset-details-selection-info .card-body { padding: 0.5rem; } .asset-details-selection-info .warning { font-size: 0.85rem; }"
    });
  },
  props: {
    currentPath: String,
    selectedStats: {
      type: Object,
      default: () => ({
        files: 0,
        folders: 0,
        totalSize: 0
      })
    },
    selectedOtherPath: Boolean,
    selectedMultiPath: Boolean,
    invalidDragPath: {
      type: String,
      default: null
    },
    assetsHandler: {
      type: Object,
      required: true
    },
    downloadInProgress: Boolean
  },
  data() {
    return {
      showNewFolder: false
    };
  },
  computed: {
    isWritable() {
      return !!(this.assetsHandler && this.assetsHandler.isWritable);
    },
    isOwner() {
      return this.assetsHandler.isOwner;
    },
    selectedCount() {
      return this.selectedStats.files + this.selectedStats.folders;
    },
    noSelectionTooltip() {
      return !this.selectedCount ? t("No assets selected") : "";
    },
    invalidDrag() {
      return this.currentPath.replace(/\/+$/, "") === this.invalidDragPath;
    },
    moveButtonTooltip() {
      let tt = "";
      if (!this.invalidDrag) {
        tt += t("Click to move all selected assets to this folder.") + " ";
      }
      return tt + t("Drag from here to move all selected assets to a new location.");
    },
    copyButtonTooltip() {
      let tt = "";
      if (!this.invalidDrag) {
        tt += t("Click to copy all selected assets to this folder.") + " ";
      }
      return tt + t("Drag from here to copy all selected assets to a new location.");
    },
    selectedTotalSizeH() {
      return Utils.bytesToHuman(this.selectedStats.totalSize || 0);
    },
    selectedFolders() {
      return this.selectedStats.folders;
    },
    selectedFiles() {
      return this.selectedStats.files;
    }
  },
  methods: {
    getTooltip(defaultMessage, writeNeeded = true) {
      if (writeNeeded && !this.isWritable) {
        return t("You do not have permission to write to this folder");
      }
      if (!this.selectedCount) {
        return t("No assets selected");
      }
      return defaultMessage;
    },
    move() {
      if (this.invalidDrag) {
        return;
      }
      this.$emit("move-assets", this.currentPath);
    },
    copy() {
      if (this.invalidDrag) {
        return;
      }
      this.$emit("copy-assets", this.currentPath);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsBrowserToolbox"] = Vue.component(
                    "AssetsBrowserToolbox",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body class=\"border-0 p-0 asset-browser-toolbox w-100 h-100\"> <b-card-header class=\"px-2 py-1 text-center\"> <span>{{ t(\"Toolbox\") }}</span> <b-link v-b-tooltip.hover class=\"float-right text-secondary position-absolute collapse-link\" :title=\"t('Collapse Toolbox')\" @click=\"$emit('collapse')\" > <i class=\"fas fa-caret-left\"></i> </b-link> </b-card-header> <b-card-body class=\"p-0 m-0 asset-browser-toolbox__container forge-custom-scrollbar\"> <div class=\"d-flex flex-column asset-browser-toolbox__body h-100\"> <!-- Upload, new folder --> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > <b-row v-if=\"isWritable\" ref=\"controls\" class=\"button-controls pb-1\"> <b-col class=\"pr-1\"> <b-button variant=\"secondary\" size=\"sm\" class=\"w-100 px-0\" @click=\"showNewFolder = true\"> <i class=\"fas fa-folder-plus\"></i> {{ t(\"New Folder\") }} <asset-new-folder v-model=\"showNewFolder\" :path=\"currentPath\" :assets-handler=\"assetsHandler\" @created=\"$emit('folder-created')\" ></asset-new-folder> </b-button> </b-col> <b-col class=\"pl-1\"> <b-button variant=\"secondary\" size=\"sm\" class=\"w-100 px-0\" @click=\"$emit('upload-assets')\"> <i class=\"fas fa-cloud-upload-alt\"></i> {{ t(\"Upload\") }} </b-button> </b-col> </b-row> </transition> <!-- share folder, manage shared folders --> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > <b-row v-if=\"canShare\" class=\"py-1\"> <b-col v-b-tooltip.hover.noninteractive class=\"pr-1\" :title=\"t('Share the current folder')\"> <b-button class=\"w-100\" size=\"sm\" variant=\"secondary\" @click=\"$emit('share-folder', null)\"> <i class=\"fas fa-share-alt\"></i> {{ t(\"Share\") }} </b-button> </b-col> <b-col v-b-tooltip.hover.noninteractive class=\"pl-1\" :title=\"t('Manage shared folders')\"> <b-button class=\"w-100\" size=\"sm\" variant=\"secondary\" @click=\"$emit('manage-shared-folders')\"> <i class=\"fas fa-share-alt\"></i> <i class=\"fas fa-cog\"></i> {{ t(\"Manage\") }} </b-button> </b-col> </b-row> </transition> <asset-search class=\"pt-1\"> </asset-search> <!-- Assets quota --> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"animate__animated animate__fast animate__fadeOut\" > <div v-if=\"isOwner\" class=\"mb-3\"> <div class=\"d-flex justify-content-between align-items-center quota-stats br-0\"> <strong>{{ t(\"Asset Quota\") }}</strong> <span style=\"font-size: small\">{{ bytesToHuman(quota.used) }} / {{ bytesToHuman(quota.total) }}</span> </div> <div> <b-progress max=\"100\" height=\"2em\" :variant=\"badgeColourPercentage(quota.percent)\"> <b-progress-bar class=\"text-right text-light pr-2\" :value=\"Math.min(quota.percent, 100.0)\" :label=\"quota.percent >= 15 ? `${quota.percent}%` : ''\" ></b-progress-bar> <b-progress-bar class=\"text-left text-light quota-progress-remainder\" :class=\"quotaRemainingPercent > 15 ? 'pl-2' : ''\" :value=\"quotaRemainingPercent\" :label=\"quota.percent < 15 ? `${quota.percent}%` : ''\" ></b-progress-bar> </b-progress> </div> </div> </transition> <div> <small id=\"asset-controls-reference\" class=\"cursor-pointer text-muted\" @click=\"toggleControlRef\" ><i class=\"fas fa-info-circle\"></i> {{ t(\"Controls & Hotkeys\") }} </small> <br /> <b-popover :show=\"showControlRef\" target=\"asset-controls-reference\" trigger=\"manual\" placement=\"bottomleft\" boundary=\"window\" custom-class=\"controls-reference\" > <template #title> <div class=\"d-flex justify-content-between align-items-center\"> {{ t(\"Assets Library Controls\") }} <!-- Use the same close button styling as Bootstrap modals, dialogs, etc... --> <button type=\"button\" class=\"close px-1\" aria-label=\"Close\" @click=\"toggleControlRef\"> <span aria-hidden=\"true\">&times;</span> </button> </div> </template> <ul class=\"pl-3 mb-1\"> <li>{{ t(\"Click anywhere on a folder to enter\") }}</li> <li>{{ t(\"Click the checkbox on a folder to select\") }}</li> <li>{{ t(\"Click anywhere on an asset to select\") }}</li> <li> <i18n :path=\"t('Hold {0} to select all assets between two selections')\"> <span class=\"controls-key\">{{ t(\"KEY_SHIFT\") }}</span> </i18n> </li> <li> <i18n :path=\"t('Press {0}+{1} to select all assets in the current folder or search results')\"> <span class=\"controls-key\">{{ t(\"KEY_CTRL\") }}</span> <span class=\"controls-key\">{{ t(\"KEY_A\") }}</span> </i18n> </li> <li> <i18n :path=\"t('Press {0}+{1} to paste selected assets into the current folder')\"> <span class=\"controls-key\">{{ t(\"KEY_CTRL\") }}</span> <span class=\"controls-key\">{{ t(\"KEY_V\") }}</span> </i18n> </li> <li> <i18n :path=\"t('Press {0} to clear selection')\"> <span class=\"controls-key\">{{ t(\"KEY_ESC\") }}</span> </i18n> </li> <li> <i18n :path=\"t('Press {0} to delete selected assets (with confirmation)')\"> <span class=\"controls-key\">{{ t(\"KEY_DEL\") }}</span> </i18n> </li> <li> {{ t(\"Enter additional search terms with '+', only results which match all terms will be shown\") }} </li> </ul> </b-popover> </div> <!-- Move, copy --> <b-row class=\"py-1\"> <b-col v-b-tooltip.hover.noninteractive class=\"pr-1\" :title=\"getTooltip(moveButtonTooltip)\"> <drag tag=\"span\" drop-effect=\"move\" :image-x-offset=\"75\" :image-y-offset=\"50\" :draggable=\"isWritable\" @drag=\"$emit('drag', $event)\" > <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <b-button class=\"w-100\" size=\"sm\" variant=\"info\" style=\"cursor: move\" :disabled=\"!selectedCount || !isWritable\" @click=\"move\" > <i class=\"fas fa-arrows-alt\"></i> {{ t(\"Move\") }} </b-button> </drag> </b-col> <b-col v-b-tooltip.hover.top.noninteractive class=\"pl-1\" :title=\"getTooltip(copyButtonTooltip)\"> <drag tag=\"span\" drop-effect=\"copy\" :image-x-offset=\"75\" :image-y-offset=\"50\" :draggable=\"isWritable\" @drag=\"$emit('drag', $event)\" > <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <b-button class=\"w-100\" size=\"sm\" style=\"cursor: move\" :disabled=\"!selectedCount || !isWritable\" @click=\"copy\" > <i class=\"fas fa-copy\"></i> {{ t(\"Copy & Paste\") }} </b-button> </drag> </b-col> </b-row> <!-- Delete, clear selection --> <b-row class=\"py-1\"> <b-col v-b-tooltip.hover.noninteractive class=\"pr-1\" :title=\"getTooltip(t('Delete all selected assets'))\"> <b-button class=\"w-100\" size=\"sm\" variant=\"danger\" :disabled=\"!selectedCount || !isWritable\" @click=\"$emit('delete-selection')\" > <i class=\"far fa-trash-alt\"></i> {{ t(\"Delete\") }} </b-button> </b-col> <b-col v-b-tooltip.hover.noninteractive class=\"pl-1\" :title=\"getTooltip(t('Deselect all assets'), false)\"> <b-button class=\"w-100\" size=\"sm\" :disabled=\"!selectedCount\" @click.prevent=\"$emit('clear-selection')\"> <i class=\"far fa-minus-square\"></i> {{ t(\"Deselect\") }} </b-button> </b-col> </b-row> <!-- Download --> <b-row class=\"py-1\"> <b-col v-b-tooltip.hover.noninteractive :title=\"getTooltip(downloadButtonTooltip, false)\"> <b-button class=\"w-100\" size=\"sm\" variant=\"info\" :disabled=\" selectedStats.totalSize === 0 || selectedStats.totalSize > Assets.MAX_DOWNLOAD_SIZE || downloadInProgress \" @click=\"$emit('download-selection')\" > <i v-if=\"downloadInProgress\" class=\"fa fa-spinner fa-spin\"></i> <i v-else class=\"fa fa-download\"></i> {{ downloadInProgress ? t(\"Downloading…\") : t(\"Download\") }} </b-button> </b-col> </b-row> <!-- Selected asset details --> <asset-details class=\"pb-2\" :selected-stats=\"selectedStats\" :selected-other-path=\"selectedOtherPath\" :selected-multi-path=\"selectedMultiPath\" :file=\"detailsAsset\" :file-selected=\"detailsAssetSelected\" :is-owner=\"isOwner\" ></asset-details> <div v-if=\"isWritable\" class=\"d-flex flex-column-reverse flex-grow-1\"> <div class=\"cursor-pointer\" @click=\"$emit('upload-assets')\"> <asset-upload-drop watermark :dragging=\"dragging\" :drag-type=\"dragType\" :uploading=\"uploading\" :invalid-drag=\"invalidDrag\" :is-writable=\"isWritable\" @drag-files=\"$emit('drag-files', $event)\" @drop-files=\"$emit('drop-files', $event)\" @drop-to-folder=\"$emit('drop-to-folder', $event)\" ></asset-upload-drop> </div> </div> </div> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-browser-toolbox__container { overflow-x: hidden; overflow-y: scroll; } .asset-browser-toolbox__body { min-height: max-content; padding: 1em 0.25em 1em 1em; } .quota-stats .quota-bytes { font-size: small; } .quota-progress-remainder { background-color: #1c1e22 !important; } .asset-browser-toolbox button.disabled { cursor: not-allowed !important; } .cursor-pointer { cursor: pointer; } .controls-reference .controls-key { padding: 0em 0.2em; background: var(--light); color: var(--dark); border: 1px solid rgba(0, 0, 0, 0.25); border-radius: 5px; box-shadow: 1px 1px 1px 0.6px #000000b3; } .collapse-link { font-size: 24px; line-height: 5px; width: 25px; right: 0.2em; }"
    });
  },
  props: {
    currentPath: String,
    quota: Object,
    assetsHandler: {
      type: Object,
      required: true
    },
    selectedStats: {
      type: Object,
      default: () => ({
        files: 0,
        folders: 0,
        totalSize: 0
      })
    },
    selectedOtherPath: Boolean,
    selectedMultiPath: Boolean,
    downloadInProgress: Boolean,
    detailsAsset: Object,
    detailsAssetSelected: Boolean,
    dragging: Boolean,
    dragType: String,
    invalidDragPath: {
      type: String,
      default: null
    },
    uploading: Boolean
  },
  data() {
    return {
      showNewFolder: false,
      searchAssets: "",
      searchScope: "",
      showControlRef: false
    };
  },
  computed: {
    isWritable() {
      return !!(this.assetsHandler && this.assetsHandler.isWritable);
    },
    isOwner() {
      return this.assetsHandler.isOwner;
    },
    canShare() {
      return !!(this.assetsHandler && !this.assetsHandler.apiKey);
    },
    quotaRemainingPercent() {
      return Math.max(100 - this.quota.percent, 0.0);
    },
    selectedCount() {
      return this.selectedStats.files + this.selectedStats.folders;
    },
    invalidDrag() {
      return this.currentPath.replace(/\/+$/, "") === this.invalidDragPath;
    },
    moveButtonTooltip() {
      let tt = "";
      if (!this.invalidDrag) {
        tt += t("Click to move all selected assets to this folder.") + " ";
      }
      return tt + t("Drag from here to move all selected assets to a new location.");
    },
    copyButtonTooltip() {
      let tt = "";
      if (!this.invalidDrag) {
        tt += t("Click to copy all selected assets to this folder.") + " ";
      }
      return tt + t("Drag from here to copy all selected assets to a new location.");
    },
    downloadButtonTooltip() {
      if (this.selectedStats.totalSize === 0) {
        return t("No assets selected");
      }
      if (this.selectedStats.totalSize > Assets.MAX_DOWNLOAD_SIZE) {
        return t("Selected assets exceed the maximum download size of {{maxDownloadSize}}", {
          maxDownloadSize: Utils.bytesToHuman(Assets.MAX_DOWNLOAD_SIZE)
        });
      }
      return t("Download all selected assets");
    }
  },
  methods: {
    bytesToHuman(bytes) {
      return Utils.bytesToHuman(bytes);
    },
    badgeColourPercentage(percent) {
      if (percent < 60) {
        return "success";
      }
      if (percent < 85) {
        return "warning";
      }
      return "danger";
    },
    getTooltip(defaultMessage, writeNeeded = true) {
      if (writeNeeded && !this.isWritable) {
        return t("You do not have permission to write to this folder");
      }
      if (!this.selectedCount) {
        return t("No assets selected");
      }
      return defaultMessage;
    },
    toggleControlRef() {
      this.showControlRef = !this.showControlRef;
    },
    move() {
      if (this.invalidDrag) {
        return;
      }
      this.$emit("move-assets", this.currentPath);
    },
    copy() {
      if (this.invalidDrag) {
        return;
      }
      this.$emit("copy-assets", this.currentPath);
    }
  },
  mounted() {
    this.searchScope = "local";
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsKeyGenerator"] = Vue.component(
                    "AssetsKeyGenerator",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"assets-key-generator\"> <div> <b-form-group :label=\"t('Permissions')\" label-for=\"write-assets\" label-align=\"left\" label-align-md=\"right\" label-cols=\"0\" label-cols-md=\"4\" label-cols-lg=\"3\" > <div class=\"d-flex align-items-center w-100 h-100\"> <b-dropdown class=\"flex-grow-1\" :disabled=\"loading || processing || !!shareUrl\" :text=\"permissionsDropdownText\" variant=\"primary\" > <b-dropdown-form> <div v-for=\"permission in permissionOptions\" :id=\"`permission-${permission.value}`\" :key=\"permission.value\" > <b-form-checkbox v-model=\"permissions\" class=\"align-self-center\" :value=\"permission.value\" :disabled=\"!permission.configurable || loading || processing || !!shareUrl\" > {{ permission.text }} </b-form-checkbox> <b-tooltip v-if=\"permission.tooltip\" :target=\"`permission-${permission.value}`\" triggers=\"hover\"> {{ permission.tooltip }} </b-tooltip> </div> </b-dropdown-form> </b-dropdown> </div> </b-form-group> <b-form-group :label=\"t('Key expiration')\" label-for=\"expiration\" label-align=\"left\" label-align-md=\"right\" label-cols=\"0\" label-cols-md=\"4\" label-cols-lg=\"3\" > <b-form-select v-model=\"expiration\" name=\"expiration\" :options=\"expirationList\" :disabled=\"loading || processing || !!shareUrl\" class=\"custom-select\" ></b-form-select> </b-form-group> <b-form-group :label=\"t('Key name')\" :description=\" t( 'Give it a descriptive name to help you remember what the key is for. It will be listed in your account using this name, and can be revoked from there if needed.' ) \" label-for=\"keyname\" label-align=\"left\" label-align-md=\"right\" label-cols=\"0\" label-cols-md=\"4\" label-cols-lg=\"3\" > <input v-if=\"loading\" :value=\"t('Loading…')\" class=\"form-control\" type=\"text\" disabled=\"disabled\" /> <b-form-input v-else id=\"keyName\" v-model=\"keyName\" v-b-tooltip.hover.top :title=\"!validKeyName ? keyNameRequirements : ''\" :disabled=\"processing || !!shareUrl\" :state=\"validKeyName\" :formatter=\"formatKeyName\" autocomplete=\"off\" lazy-formatter name=\"keyname\" @keyup.prevent=\"keyUp\" > </b-form-input> <b-form-invalid-feedback id=\"keyName\"> <span v-if=\"!validKeyNameNotBlank\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"Key name cannot be blank.\") }} </span> <span v-if=\"!validKeyNameLength && keyName.length > 1\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"Key name must be less than 250 characters.\") }} </span> <span v-if=\"!validKeyNameUnique\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"You have already used this key name.\") }} </span> </b-form-invalid-feedback> </b-form-group> <transition tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__fadeIn\"> <loading-indicator v-if=\"loading\" :label=\"t('Checking your existing API keys, please wait…')\" tag=\"p\" ></loading-indicator> <b-card v-else border-variant=\"info\" class=\"mb-2 api-key-confirm-info\"> <i18n :path=\"t('This API key will share {0} access to {1} and {2}.')\" tag=\"p\"> <span> <b-badge variant=\"success\" pill> {{ t(\"Read\") }} </b-badge> <b-badge v-if=\"permissions.includes('write-assets')\" variant=\"warning\" pill> {{ t(\"Write\") }} </b-badge> </span> <strong v-if=\"sharingAllAssets\">{{ t(\"your entire assets library\") }}</strong> <i18n v-else tag=\"strong\" :path=\"t('the folder {{folderName}}', { folderName })\"></i18n> <strong>{{ expirationLabel }}</strong> </i18n> <i18n v-if=\"keyName\" :path=\"t('The key name will be “{0}” and you can revoke it at any time from {1}.')\" tag=\"p\" > <strong>{{ keyName || \"?\" }}</strong> <strong> <a v-if=\"!locationIsAccount\" href=\"/account#api\" target=\"_blank\">{{ t(\"your account\") }}</a> <span v-else>{{ t(\"your account\") }}</span> </strong> </i18n> <i18n v-else :path=\"t('The key will be unnamed and can be revoked by resetting all keys from {0}')\" tag=\"p\"> <strong> <a v-if=\"!locationIsAccount\" href=\"/account#api\" target=\"_blank\">{{ t(\"your account\") }}</a> <span v-else>{{ t(\"your account\") }}</span> </strong> </i18n> <p class=\"mb-0\"> {{ t(\"This key will give the access mentioned above to anyone you share it with.\") }} <a href=\"https://forums.forge-vtt.com/docs?topic=1403\" target=\"_blank\">{{ t(\"Click here to see how to use it.\") }}</a> </p> </b-card> </transition> </div> <loading-indicator v-if=\"processing\" class=\"flex-grow-1\" :label=\"t('Generating API key…')\"></loading-indicator> <transition v-if=\"builtInAlerts\" tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__fadeIn\" leave-active-class=\"animate__animated animate__faster animate__fadeOut\" > <b-alert v-model=\"alertShow\" :variant=\"alertVariant\" dismissible @dismissed=\"clearAlert\"> {{ alertMessage }} </b-alert> </transition> <transition tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__fadeInDown\" leave-active-class=\"animate__animated animate__faster animate__fadeOut\" > <b-form-group v-if=\"!processing && shareUrl\" class=\"flex-grow-1\"> <b-input-group v-b-tooltip.hover.top class=\"mb-2\" :title=\"t('Copy share link to clipboard')\" @click.prevent=\"copyResult('share-link')\" > <template #prepend> <b-button variant=\"outline-info\">{{ resultTypes[\"share-link\"] }}</b-button> </template> <b-form-input :value=\"output('share-link')\" class=\"copy-result\"></b-form-input> <b-input-group-append> <b-button><i class=\"far fa-copy\"></i></b-button> </b-input-group-append> </b-input-group> <p> {{ t( \"Anyone who is logged into their Forge account and follows the share link will have the key added to their account.\" ) }} </p> <hr class=\"bg-info\" /> <b-alert variant=\"warning\" show> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"Be sure to save the API key if you need it. It won’t be shown again!\") }} </b-alert> <b-input-group v-b-tooltip.hover.top class=\"mb-2\" :title=\"t('Copy API key to clipboard')\" @click.prevent=\"copyResult('api-key')\" > <template #prepend> <b-button variant=\"outline-info\">{{ resultTypes[\"api-key\"] }}</b-button> </template> <b-form-input :value=\"output('api-key')\" class=\"copy-result\"></b-form-input> <b-input-group-append> <b-button><i class=\"far fa-copy\"></i></b-button> </b-input-group-append> </b-input-group> <p> <span>{{ t( \"The API key allows someone to access the associated assets from within Foundry without logging in to the Forge.\" ) }}</span> <a href=\"https://forums.forge-vtt.com/docs?topic=1403#how-to-use-an-api-key-in-foundry-vtt-5\" target=\"_blank\" >{{ t(\"Click here to see how to add an API key in Foundry.\") }}</a > </p> </b-form-group> </transition> <transition tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__fadeInDown\" leave-active-class=\"animate__animated animate__faster animate__fadeOut\" > <div v-if=\"!processing && shareUrl\"></div> </transition> <transition tag=\"div\" enter-active-class=\"animate__animated animate__faster animate__fadeIn\" leave-active-class=\"animate__animated animate__faster animate__fadeOut\" > <b-button v-if=\"!processing && !shareUrl\" variant=\"primary\" class=\"float-right mt-1 mt-lg-0\" :disabled=\"!validKeyName || loading || processing || !!shareUrl\" @click.prevent=\"generate\" > <i class=\"fas fa-share-alt\"></i> {{ sharingAllAssets ? t(\"Share Assets Library\") : t(\"Share Folder\") }} </b-button> </transition> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".assets-key-generator button.disabled{cursor:not-allowed}.copy-result{cursor:pointer}.api-key-confirm-info{border-width:3px}.assets-key-generator .badge{font-size:.9rem}"
    });
  },
  props: {
    folderName: {
      type: String,
      required: true
    },
    builtInAlerts: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expirationList: [{
        value: "",
        text: t("Never")
      }, {
        value: "30d",
        text: t("TIME.days", {
          count: 30
        })
      }, {
        value: "7d",
        text: t("TIME.days", {
          count: 7
        })
      }, {
        value: "24h",
        text: t("TIME.hours", {
          count: 24
        })
      }, {
        value: "6h",
        text: t("TIME.hours", {
          count: 6
        })
      }, {
        value: "1h",
        text: t("TIME.hours", {
          count: 1
        })
      }, {
        value: "15m",
        text: t("TIME.minutes", {
          count: 15
        })
      }],
      permissionOptions: [{
        value: "read-assets",
        text: t("Read Assets Library"),
        shortText: t("Read Assets"),
        tooltip: t("All API keys include Read Assets permission."),
        configurable: false
      }, {
        value: "write-assets",
        text: t("Write Assets Library (create folder, upload, delete assets)"),
        shortText: t("Write Assets"),
        tooltip: null,
        configurable: true
      }],
      resultTypes: {
        "share-link": t("Share Link"),
        "api-key": t("API Key")
      },
      shareUrl: "",
      apiKey: "",
      keyName: "",
      expiration: "",
      permissions: ["read-assets"],
      loading: true,
      existingKeys: [],
      maxNameLength: 250,
      processing: false,
      alertShow: false,
      alertVariant: null,
      alertMessage: null
    };
  },
  watch: {
    alertMessage(newValue, oldValue) {
      if (newValue !== null) {
        this.alertShow = true;
      }
    },
    reset(newValue) {
      if (!this.processing && newValue) {
        this.shareUrl = "";
        this.apiKey = "";
        this.keyName = "";
        this.expiration = "";
        this.permissions = ["read-assets"];
        this.alertShow = false;
        this.alertVariant = null;
        this.alertMessage = null;
        this.getExistingKeys().then(() => {
          this.generateKeyName();
        });
      }
    }
  },
  computed: {
    locationIsAccount() {
      return window.location.pathname === "/account";
    },
    sharingAllAssets() {
      return this.folderName === "/";
    },
    permissionsDropdownText() {
      let text = "";
      for (const permission of this.permissions) {
        const option = this.permissionOptions.find(o => o.value === permission);
        if (option) {
          text += `${option.shortText}, `;
        }
      }
      // Remove the final comma and space
      return text.slice(0, -2);
    },
    expirationLabel() {
      if (!this.expiration) {
        return t("does not expire");
      }
      const label = this.expirationList.find(data => data.value === this.expiration);
      return t("expires in {{expiration}}", {
        expiration: label ? label.text : this.expiration
      });
    },
    validKeyNameNotBlank() {
      return !!(this.keyName && this.keyName.length > 0);
    },
    validKeyNameLength() {
      return !!(this.keyName && this.keyName.length <= this.maxNameLength);
    },
    validKeyNameUnique() {
      return !this.existingKeys.some(k => k === this.keyName);
    },
    validKeyName() {
      return this.validKeyNameNotBlank && this.validKeyNameLength && this.validKeyNameUnique;
    },
    keyNameRequirements() {
      return t("Key name must be unique, cannot be blank, and must be less than 250 characters long.");
    }
  },
  methods: {
    clearAlert() {
      this.alertShow = false;
      this.alertVariant = null;
      this.alertMessage = null;
    },
    async getExistingKeys() {
      this.loading = true;
      // Get existing keys so we can generate a name that doesn't exist yet
      const response = await Utils.api("keys", {}, {
        method: "GET"
      });
      this.loading = false;
      if (response.error) {
        UI.error(t("Error getting existing API Keys: {{response.error}}", {
          response
        }));
        this.existingKeys = [];
        return;
      }
      // Cache the key names for later
      this.existingKeys = response.keys ? response.keys.map(k => k.name) : [];
    },
    async generateKeyName() {
      const baseName = this.sharingAllAssets ? UI.i18n.translateNoEscape("All assets") : this.folderName.replace(/\/$/, ""); // Remove any trailing slash
      if (!this.existingKeys.length) {
        await this.getExistingKeys();
      }
      // If the key name doesn't exist, return the base name
      if (!this.existingKeys.some(k => k === baseName)) {
        this.keyName = baseName;
        return this.keyName;
      }
      // If the key name exists, append a number to it until it doesn't
      let i = 0;
      // Shorten the name if it's too long. 7 characters is the maximum added by the ellipsis and number.
      let generated = baseName.length > this.maxNameLength ? `${baseName.slice(0, this.maxNameLength - 7)}…` : baseName;
      while (this.existingKeys.some(key => key === generated) && i < 100) {
        generated = `${baseName} (${++i})`;
      }
      this.keyName = generated;
      return this.keyName;
    },
    formatKeyName(value) {
      return value.trim();
    },
    keyUp(ev) {
      // Enter key
      if (ev.keyCode === 13) {
        this.generate();
        ev.stopPropagation();
      }
    },
    async generate() {
      this.processing = true;
      this.$emit("processing", true);
      const response = await Utils.api("generate-key", {
        permissions: this.permissions,
        options: {
          assets: {
            rootDir: this.folderName
          }
        },
        expiration: this.expiration,
        name: this.keyName || undefined,
        share: true
      });
      this.processing = false;
      this.$emit("processing", false);
      if (response.error) {
        this.alertVariant = "danger";
        this.alertMessage = t("Error sharing folder: {{error}}", {
          error: response.error
        });
        return UI.error(this.alertMessage);
      }
      this.shareUrl = response.shareUrl;
      this.apiKey = response.key;
      this.alertVariant = "success";
      this.alertMessage = t("Folder shared. Share link copied to clipboard.");
      UI.success(this.alertMessage);
      navigator.clipboard.writeText(this.shareUrl);
      this.$emit("new-key", this.keyName);
      return true;
    },
    output(resultKey) {
      switch (resultKey) {
        case "api-key":
          return this.apiKey;
        case "share-link":
        default:
          return this.shareUrl;
      }
    },
    copyResult(resultType) {
      this.alertVariant = "info";
      if (resultType === "share-link") {
        navigator.clipboard.writeText(this.shareUrl);
        this.alertMessage = t("Copied share link to clipboard");
      } else {
        navigator.clipboard.writeText(this.apiKey);
        this.alertMessage = t("Copied API key to clipboard");
      }
      UI.info(this.alertMessage);
    }
  },
  mounted() {
    this.generateKeyName();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsListView"] = Vue.component(
                    "AssetsListView",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"assets-list-view\"> <b-table-simple hover small sort-icon-left @sort-changed=\"$emit('sort-changed', $event)\"> <!-- Set column widths --> <colgroup> <col v-for=\"field in tableFields\" :key=\"field.key\" :style=\"`width: ${field.width};`\" /> </colgroup> <b-thead head-variant=\"light\"> <b-tr> <b-th v-for=\"field in tableFields\" :id=\"headerId(field)\" :key=\"field.key\" class=\"border-top-0 border-right border-secondary\" :class=\"field.sortable ? 'pl-3 b-table-sort-icon-left' : 'align-middle'\" :aria-sort=\"headerAriaSort(field)\" @click.prevent=\"headerClick(field)\" > {{ field.label }} <span v-if=\"field.sortable\" class=\"sr-only\">({{ sortTooltip(field) }})</span> <b-tooltip v-if=\"field.sortable\" :target=\"headerId(field)\" placement=\"left\" boundary=\"window\" noninteractive > {{ sortTooltip(field) }} </b-tooltip> <div v-if=\"field.key === 'selected'\" v-b-tooltip.hover.noninteractive class=\"asset-row-select-box text-dark bg-light d-flex align-items-center justify-content-center\" :title=\"selectAllTooltip\" @click.prevent.stop=\"selectAllClicked\" > <i :class=\"selectAllIcon\"></i> </div> </b-th> </b-tr> </b-thead> <transition-group tag=\"b-tbody\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" move-class=\"animate__animated animate__fast row-move\" > <!-- Rows for each viewed asset --> <drag v-for=\"asset in assetItems\" :id=\"assetRowId(asset)\" :key=\"asset.name\" tag=\"b-tr\" drop-effect=\"move\" :class=\"assetRowClass(asset)\" :image-x-offset=\"75\" :image-y-offset=\"50\" :style=\"`height: calc(${thumbnailSize}px + 0.6rem);`\" @click=\"assetClick(asset, $event)\" @drag=\"assetDrag(asset, $event)\" @mouseover=\"mouseEnter(asset)\" @mouseleave=\"mouseLeave(asset)\" > <template #image> <b-img width=\"150\" src=\"/images/assets-move.png\"></b-img> </template> <!-- Selected checkmark --> <b-td class=\"align-middle\"> <div v-b-tooltip.hover.noninteractive class=\"asset-row-select-box text-dark bg-light d-flex justify-content-center\" :title=\"asset.isDirectory ? t('Select Folder') : t('Select File')\" @click.prevent.stop=\"$emit('selected', asset, $event)\" > <i :class=\"selectedIcon(asset.selected)\"></i> </div> </b-td> <!-- Icon/thumbnail --> <b-td class=\"align-middle\"> <b-img v-if=\"asset.isDirectory\" src=\"/images/folder-blue.png\" center :width=\"thumbnailSize\" :height=\"thumbnailSize\" ></b-img> <video v-else-if=\"fileType(asset) === 'video' && thumbnailSize > iconSizeThreshold\" muted :src=\"asset.url\" :width=\"thumbnailSize\" :height=\"thumbnailSize\" ></video> <b-img-lazy v-else :src=\"thumbnailUrl(asset)\" blank-src=\"/images/file-loading.webp\" center :style=\"`max-width: ${thumbnailSize}px; max-height: ${thumbnailSize}px;`\" ></b-img-lazy> </b-td> <!-- File name and action icons --> <b-td class=\"align-middle\"> <div class=\"d-flex justify-content-between align-items-center\"> {{ searchResultMode ? asset.name : asset.basename }} <span class=\"asset-action-icons\"> <a v-if=\"searchResultMode\" :href=\"Assets.genHash(Utils.dirname(asset.name))\" @click.stop=\"() => null\"> <i v-b-tooltip.hover.noninteractive class=\"fas fa-folder-open\" :title=\"t('Open containing folder')\" ></i> </a> <i v-if=\"isWritable && isOwner && asset.isDirectory\" v-b-tooltip.hover.noninteractive class=\"fas fa-share-alt\" :title=\"t('Share folder')\" @click.stop=\"$emit('share-folder', asset)\" ></i> <i v-if=\"isWritable\" v-b-tooltip.hover.noninteractive class=\"far fa-edit\" :title=\"renameAssetTooltip(asset)\" @click.stop=\"$emit('rename', asset)\" ></i> <i v-if=\"isWritable && isDownloadable(asset)\" v-b-tooltip.hover.noninteractive class=\"fa fa-download\" :title=\"t('Download')\" @click.stop=\"$emit('download', asset)\" > </i> </span> </div> </b-td> <!-- Human-readable file size --> <b-td class=\"align-middle text-right pr-3\"> {{ sizeH(asset.size) }} </b-td> <!-- Formatted datetime string --> <b-td class=\"align-middle\"> {{ timestamp(asset.mtime) }} </b-td> <!-- Drop target, overlays the full row. --> <drop v-if=\"dragging && asset.isDirectory && !asset.selected && isFolderValidDrop(asset.name)\" class=\"asset-drop-zone w-100 h-100\" :class=\"dragging ? 'dragging' : ''\" tag=\"span\" :dragging=\"dragging\" @drop=\"assetRowDrop(asset, $event)\" > <template #overlay=\"props\"> <b-overlay :show=\"props.isDragging\" rounded=\"sm\" :opacity=\"props.isOver ? '0.5' : '0.3'\" no-wrap :class=\"dropOverlayClass(props)\" > <template #overlay> <span :style=\"`font-size: ${thumbnailSize}px;`\"> <i class=\"fas fa-angle-double-down\"></i> </span> </template> </b-overlay> </template> </drop> </drag> </transition-group> <infinite-loading :identifier=\"infiniteId\" spinner=\"bubbles\" @infinite=\"$emit('infinite', $event)\"> <span slot=\"no-more\"></span> <span slot=\"no-results\"></span> </infinite-loading> </b-table-simple> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".asset-list-row { user-select: none; } .asset-list-row.asset-dir { cursor: pointer !important; } .asset-list-row .asset-action-icons { cursor: pointer !important; display: none; } .asset-list-row:hover .asset-action-icons { display: inline-block; } .asset-list-row.row-move { transition: transform 1s; } .asset-list-row .asset-drop-zone { position: absolute; left: 0; right: 0; bottom: 0; top: 0; } .asset-list-row .asset-drop-overlay { border: dotted 2px; border-radius: 0.25rem; } .asset-row-select-box { cursor: pointer; font-size: 1.3rem; font-family: \"El Messiri\", serif; width: 1rem; max-width: 1rem; height: 1rem; max-height: 1rem; border-radius: 3px; margin: auto; } #asset-list-header-selected { padding-right: 1rem !important; padding-left: 1rem !important; }"
    });
  },
  props: {
    assets: Array,
    allAssets: Array,
    selectedAssets: Array,
    searchResultMode: Boolean,
    infiniteId: Number,
    thumbnailSize: Number,
    sortBy: String,
    sortDesc: Boolean,
    dragging: Boolean,
    invalidDragPath: String,
    isOwner: Boolean,
    isWritable: Boolean
  },
  data() {
    return {
      clicks: 0,
      clickDebounce: null,
      selectTimeout: null,
      clickedAsset: null
    };
  },
  computed: {
    tableFields() {
      return [{
        key: "selected",
        // Virtual column for selected checkmark
        label: "",
        tdClass: "align-middle",
        sortable: false,
        width: "2rem"
      }, {
        key: "icon",
        // Virtual column for icon/thumbnail
        label: "",
        sortable: false,
        width: `calc(${this.thumbnailSize}px + 1rem)`
      }, {
        key: "basename",
        label: t("File Name"),
        tdClass: "align-middle",
        sortable: true,
        // 100% minus the sum of the other columns
        width: "calc(100% - ${this.thumbnailSize}px - 3rem - 350px)"
      }, {
        key: "size",
        label: t("Size"),
        tdClass: "align-middle",
        sortable: true,
        width: "150px" // 130px is enough for "1023.00 Bytes" though be careful of i18n
      }, {
        key: "mtime",
        label: t("Last Modified"),
        tdClass: "align-middle",
        sortable: true,
        width: "200px" // Enough for a full date though be careful of localization
      }];
    },

    clickDebounceDelay() {
      return 500;
    },
    iconSizeThreshold() {
      return 20;
    },
    assetItems() {
      return this.assets.map(a => {
        return {
          ...a,
          selected: this.selectedAssets.includes(a.name)
        };
      });
    },
    sortByField() {
      if (this.sortBy === "size") {
        return "size";
      }
      if (this.sortBy === "time") {
        return "mtime";
      }
      return "basename";
    },
    isAllSelected() {
      return this.selectedAssets.length === this.allAssets.length;
    },
    selectAllTooltip() {
      if (this.isAllSelected) {
        return t("Deselect all");
      }
      return t("Select all");
    },
    selectAllIcon() {
      return this.selectedIcon(this.isAllSelected);
    }
  },
  methods: {
    assetRowClass(asset) {
      return "asset-list-row position-relative" + (asset.selected ? " asset-selected" : "") + (asset.isDirectory ? " asset-dir" : "");
    },
    assetRowId(asset) {
      return `asset-row-${asset.name}`;
    },
    selectedIcon(selected) {
      return selected ? "far fa-check-square" : "far fa-square";
    },
    fileType(asset) {
      const ext = asset.name.split(".").pop() || "";
      return Utils.extensionType(ext);
    },
    thumbnailUrl(asset) {
      switch (this.fileType(asset)) {
        case "image":
          if (this.thumbnailSize > this.iconSizeThreshold) {
            return `${asset.url}?width=500`;
          }
          return "/images/assets_library_64x64.png";
        case "video":
          if (this.thumbnailSize > this.iconSizeThreshold) {
            return asset.url;
          }
          return "/images/file-video.png";
        case "audio":
          return "/images/file-audio.png";
        case "3d":
          return "/images/file-3d.png";
        case "pdf":
          return "/images/file-pdf.png";
        default:
          return "/images/file-unknown.png";
      }
    },
    sizeH(size) {
      return Utils.bytesToHuman(size || 0);
    },
    timestamp(time) {
      return new Date(time).toLocaleString();
    },
    headerId(field) {
      return `asset-list-header-${field.key}`;
    },
    headerAriaSort(field) {
      if (!field.sortable) {
        return "";
      }
      if (field.key !== this.sortByField) {
        return "none";
      }
      if (this.sortDesc) {
        return "descending";
      }
      return "ascending";
    },
    sortTooltip(field) {
      if (!field.sortable) {
        return "";
      }
      if (field.key !== this.sortByField || this.sortDesc) {
        return t("Click to sort ascending");
      }
      return t("Click to sort descending");
    },
    headerClick(field) {
      if (this.sortByField === field.key) {
        this.$emit("sort-changed", {
          sortBy: field.key,
          sortDesc: !this.sortDesc
        });
      } else {
        this.$emit("sort-changed", {
          sortBy: field.key,
          sortDesc: false
        });
      }
    },
    assetClick(asset, event) {
      // Only recognize left clicks, and if we start dragging skip all of it
      if (event.button !== 0 || this.dragging) {
        return;
      }
      if (asset.isDirectory) {
        // Clicking folders navigates
        window.location.hash = Assets.genHash(asset.name);
      } else {
        // Clicking files selects
        this.$emit("selected", asset, event);
      }
    },
    assetDrag(asset, {
      name,
      nativeEvent
    }) {
      this.$emit("drag", {
        asset,
        name,
        nativeEvent
      });
    },
    assetRowDrop(asset, {
      name,
      nativeEvent
    }) {
      if (name === "drop") {
        this.$emit("drop", {
          asset,
          nativeEvent
        });
      } else {
        this.assetDrag(asset, {
          name,
          nativeEvent
        });
      }
    },
    dropOverlayClass(props) {
      const base = "asset-drop-overlay w-100 h-100 text-center";
      if (!props.isDragging) {
        return base;
      }
      return base + `${props.isOver ? " border-success text-success" : " border-secondary text-secondary"}`;
    },
    isFolderValidDrop(folderName) {
      // This needs to be a method because you can't inline regex in Vue template
      return folderName.replace(/\/+$/, "") !== this.invalidDragPath;
    },
    selectAllClicked() {
      const newState = !this.isAllSelected;
      for (const asset of this.allAssets) {
        if (this.selectedAssets.includes(asset.name) === newState) {
          continue;
        }
        this.$emit("selected", asset);
      }
    },
    mouseEnter(asset) {
      if (asset.isDirectory) {
        return;
      }
      this.$emit("hover", asset, true);
    },
    mouseLeave(asset) {
      if (asset.isDirectory) {
        return;
      }
      this.$emit("hover", asset, false);
    },
    renameAssetTooltip(asset) {
      return asset.isDirectory ? t("Rename Folder") : t("Rename File");
    },
    countChildren(asset) {
      return Assets.childrenCount(asset);
    },
    isDownloadable(asset) {
      return asset.size < Assets.MAX_DOWNLOAD_SIZE && !asset.isDirectory;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AssetsShareFolder"] = Vue.component(
                    "AssetsShareFolder",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Heavily inspired by the ProfileApiKeyManagerSection.vue component
var _default = exports.default = {
  template: "<b-modal :visible=\"!!path\" size=\"lg\" :title=\"t(`Share Folder`)\" @hidden=\"path = null\" @shown=\"dialogShown\"> <b-alert info show> <i class=\"fas fa-info-circle\"></i> <i18n :path=\"t('You can view your existing API keys by visiting {0}.')\" tag=\"span\"> <strong ><a href=\"/account#api\" target=\"_blank\">{{ t(\"your account\") }}</a></strong > </i18n> </b-alert> <i18n :path=\"t('You can share access to the folder {0} by creating an API Key.')\" tag=\"p\"> <strong>{{ path }}</strong> </i18n> <p> {{ t( \"The API keys you generate can give read-only or read-write access to a folder, and can also be set to expire automatically.\" ) }} </p> <hr /> <assets-key-generator :folder-name=\"path\" built-in-alerts @new-key=\"newKey = $event\" @processing=\"processing = $event\" ></assets-key-generator> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" :disabled=\"processing\" @click.prevent=\"cancel()\"> {{ newKey !== null ? t(\"Close\") : t(\"Cancel\") }} </b-button> </template> </b-modal>",
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      processing: false,
      newKey: null
    };
  },
  computed: {
    path: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    dialogShown() {
      this.newKey = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PathBreadCrumbs"] = Vue.component(
                    "PathBreadCrumbs",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"path-bread-crumbs d-flex flex-row align-items-center mr-auto font-weight-bold\"> <b-dropdown v-if=\"availableSources.length > 1\" id=\"source-selector\" v-b-tooltip.hover.bottom variant=\"secondary\" class=\"h-100 mr-2 d-flex align-items-center\" :title=\"t('Select a different source')\" > <template #button-content> <i class=\"fas fa-users-cog\"></i> </template> <b-dropdown-item v-for=\"source in availableSources\" :key=\"source.id\" :active=\"source.id === activeSource\" @click=\"$emit('change-source', source.id)\" > <i class=\"mr-2 fas\" :class=\"sourceIcon(source)\"></i> {{ source.name }} </b-dropdown-item> </b-dropdown> <b-button v-if=\"items.length > 1\" v-b-tooltip.hover.bottom variant=\"secondary\" class=\"h-100 mr-1 px-2 d-flex align-items-center\" :title=\"t('Go up one folder')\" :href=\"upOneFolderHref\" > <i class=\"fas fa-level-up-alt\"></i> </b-button> <b-breadcrumb class=\"text-dark mb-0 px-0 py-0\"> <b-breadcrumb-item v-for=\"item in items\" :key=\"item.href\" :href=\"item.href\" :active=\"item.active\" class=\"py-1\"> <drop v-if=\"!(item.active || !isWritable || (invalidDragPath && item.path === invalidDragPath))\" tag=\"div\" :dragging=\"dragging\" @drop=\"drop(item.path, $event)\" > <template #overlay=\"props\"> <span :class=\"spanClass(props)\">{{ item.text }}</span> </template> </drop> <span v-else :class=\"spanClass({ isDragging: false, isOver: false })\">{{ item.text }}</span> </b-breadcrumb-item> </b-breadcrumb> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".path-bread-crumbs { font-size: 1.6em; font-family: \"El Messiri\", serif; padding: 0.5rem; } /*Need to do this via custom style instead of \"px-2\" etc... because the b-dropdown component doesn't have a prop to add classes to the embedded button component. */ .path-bread-crumbs #source-selector .btn.dropdown-toggle { display: flex; align-items: center; padding-left: 0.5rem; padding-right: 0.5rem; } .path-bread-crumbs .breadcrumb { background-color: transparent; } .path-bread-crumbs .breadcrumb a { display: inline-block !important; } .breadcrumb-item + .breadcrumb-item { padding-left: 0.2rem; } .breadcrumb-item + .breadcrumb-item::before { padding-right: 0.2rem; } .border-dotted { border: 3px dotted; } .border-invisible { border-color: transparent !important; }"
    });
  },
  props: {
    path: String,
    root: String,
    availableSources: Array,
    activeSource: {
      type: String,
      default: "my-assets"
    },
    dragging: Boolean,
    invalidDragPath: {
      type: String,
      // Path string which is invalid as a drop target
      default: null
    },
    isWritable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    urls() {
      let path = this.path.split("/").filter(p => p !== "");
      for (let i = 1; i < path.length; i++) {
        path[i] = `${path[i - 1]}/${path[i]}`;
      }
      return path;
    },
    items() {
      const elements = [{
        href: Assets.genHash(""),
        path: "",
        text: this.root
      }];
      elements.push(...this.urls.map((url, _) => {
        return {
          href: Assets.genHash(url),
          path: url,
          text: Utils.basename(url)
        };
      }));
      elements[elements.length - 1].active = true;
      return elements;
    },
    upOneFolderHref() {
      if (this.items.length < 2) {
        return "";
      }
      // Return the href of the 2nd last item
      return this.items[this.items.length - 2].href;
    }
  },
  methods: {
    drop(path, {
      name,
      nativeEvent
    }) {
      if (name === "drop") {
        this.$emit("drop", {
          path,
          nativeEvent
        });
      } else {
        this.$emit("drag", {
          name,
          nativeEvent
        });
      }
    },
    spanClass(props) {
      let classes = "px-1 border-dotted rounded ";
      if (props.isDragging) {
        classes += props.isOver ? "border-success text-success" : "border-secondary text-secondary";
      } else {
        classes += "border-invisible";
      }
      return classes;
    },
    sourceIcon(source) {
      if (!source || !source.id) {
        return "";
      }
      if (source.id === "my-assets") {
        return "fa-user";
      }
      // For future, Bazaar source not supported yet
      if (source.id === "forge-bazaar") {
        return "fa-store";
      }
      // Default - shared folder
      return "fa-users";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SharedFolderManager"] = Vue.component(
                    "SharedFolderManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal size=\"xl\" centered :title=\"t(`Manage Shared Folders`)\" :visible=\"visible\" @hidden=\"visible = false\"> <p> <i class=\"fas fa-info-circle\"></i> {{ t( \"Click on the folder name to browse to that location. Click the 'Unshare' button to remove other users' access to any shared folder.\" ) }} </p> <loading-indicator v-if=\"loading\"></loading-indicator> <b-table v-else class=\"shared-folder-table mb-0\" striped hover sort-icon-left show-empty small head-variant=\"light\" stacked=\"lg\" primary-key=\"name\" :sort-compare=\"sortKeys\" :sort-by.sync=\"sortBy\" :sort-desc.sync=\"sortDesc\" :items=\"sharedFolders\" :fields=\"tableFields\" :tbody-transition-props=\"transitionProps\" > <!-- Headers --> <template #head()=\"data\"> <div :id=\"headerId(data.field)\"> {{ data.label }} <span v-if=\"data.field.sortable\" class=\"sr-only\">({{ sortTooltip(data.field) }})</span> <b-tooltip v-if=\"data.field.sortable\" :target=\"headerId(data.field)\" placement=\"left\" boundary=\"window\" noninteractive > {{ sortTooltip(data.field) }} </b-tooltip> </div> </template> <!-- Data --> <template #cell(name)=\"data\"> <div v-if=\"true || data.value !== data.item.folder\"> <strong>{{ data.value }}</strong> <p class=\"ml-2 mb-0 font-italic\"> <i18n tag=\"a\" style=\"font-size: 0.9rem\" :path=\"t('Folder: {{folder}}', { folder: data.item.folder })\" :href=\"`#path=${encodeURIComponent(data.item.folder)}`\" @click=\"visible = false\" ></i18n> </p> </div> <div v-else> <b-link :href=\"`#path=${encodeURIComponent(data.value)}`\" @click=\"visible = false\"> <strong>{{ data.value }}</strong> </b-link> </div> </template> <template #cell(permissions)=\"data\"> <b-badge v-if=\"readPermission(data.value)\" variant=\"success\" pill> {{ t(\"Read Only\") }} </b-badge> <b-badge v-if=\"writePermission(data.value)\" variant=\"warning\" pill> {{ t(\"Read/Write\") }} </b-badge> </template> <template #cell(created)=\"data\"> {{ data.item.createdString }} </template> <template #cell(expiration)=\"data\"> <div v-if=\"expired(data.item)\"> <b-badge v-b-tooltip.hover.top variant=\"danger\" :title=\"t('Expired folder shares can be Unshared without harm.')\" > {{ t(\"Expired\") }} <i class=\"fas fa-question-circle\"></i> </b-badge> </div> <span v-else>{{ data.item.expiresString }}</span> </template> <template #cell(actions)=\"data\"> <b-button v-b-tooltip.hover.top.noninteractive size=\"sm\" class=\"action-button\" variant=\"danger\" :title=\"t('Unshare')\" :aria-label=\"t('Unshare')\" @click=\"promptUnshare(data.item)\" > <i class=\"fas fa-trash-alt\"></i> </b-button> <b-button v-b-tooltip.hover.top.noninteractive size=\"sm\" class=\"action-button\" variant=\"info\" :title=\"t('Share URL')\" :aria-label=\"t('Share URL')\" @click=\"getShareUrl(data.item)\" > <i class=\"fas fa-share-alt\"></i> </b-button> </template> </b-table> <!-- Confirmation dialog before unsharing --> <b-modal v-model=\"showRemoveKeyModal\" custom-class=\"confirm-remove-key\" centered :title=\"t('Unshare Folder')\" @ok=\"unshare(keyToRemove)\" > <i18n tag=\"p\" :path=\"t('Are you sure you want to unshare this folder, which is associated with the API key {0}?')\" > <strong>{{ keyToRemove ? keyToRemove.name : \"\" }}</strong> </i18n> <b-alert show variant=\"warning\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"This will immediately prevent all other users from accessing the assets in that folder.\") }} </b-alert> </b-modal> <template #modal-footer=\"{ close }\"> <b-button variant=\"secondary\" :disabled=\"processing\" @click.prevent=\"close()\"> {{ t(\"Close\") }} </b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".shared-folder-table .actions-header { width: 9em; } .shared-folder-table .action-button { white-space: nowrap; } .shared-folder-table .badge { font-size: 0.9rem; } .shared-folder-table a { text-decoration: underline; } .shared-folder-table .row-move { transition: transform 1s; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "shared-folder-manager"
    }
  },
  data() {
    return {
      loading: true,
      processing: false,
      apiKeys: [],
      sortBy: "name",
      sortDesc: false,
      showRemoveKeyModal: false,
      keyToRemove: null,
      transitionProps: {
        enterActiveClass: "animate__animated animate__faster animate__fadeIn",
        leaveActiveClass: "animate__animated animate__faster animate__fadeOut",
        moveClass: "animate__animated animate__fast row-move"
      }
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.loadKeys();
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    tableFields() {
      return [{
        key: "name",
        label: t("Share Name & Folder"),
        sortable: true,
        tdClass: "py-1 pl-3 align-middle",
        thClass: "pl-3 align-middle border-top-0 border-right border-secondary"
      }, {
        key: "permissions",
        label: t("Permissions"),
        sortable: true,
        tdClass: "py-3 pl-3 align-middle",
        thClass: "pl-3 align-middle border-top-0 border-right border-secondary"
      }, {
        key: "created",
        label: t("Shared On"),
        sortable: true,
        tdClass: "py-3 pl-3 align-middle",
        thClass: "pl-3 align-middle border-top-0 border-right border-secondary"
      }, {
        key: "expiration",
        label: t("Expires"),
        sortable: true,
        tdClass: "py-3 pl-3 align-middle",
        thClass: "pl-3 align-middle border-top-0 border-right border-secondary"
      }, {
        key: "actions",
        label: t("Actions"),
        tdClass: "py-3 pl-3 pl-lg-1 align-middle text-lg-center",
        thClass: "actions-header align-middle text-lg-center border-top-0 border-secondary"
      }];
    },
    sharedFolders() {
      return this.apiKeys.filter(k => k.folder);
    }
  },
  methods: {
    async loadKeys() {
      this.loading = true;
      const response = await Utils.api("keys?includeKeys=1", {
        includeKey: true
      }, {
        method: "GET"
      });
      this.loading = false;
      if (response.error) {
        UI.error(t("Error getting shared folders: {{response.error}}", {
          response
        }));
        this.apiKeys = [];
        return;
      }
      const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric"
      };
      this.apiKeys = (response.keys || []).filter(k => this.keyIsSharedFolder(k)).map(k => {
        const keyData = k.key ? JSON.parse(atob(k.key.split(".")[1])) : null;
        return {
          name: k.name,
          created: Date.parse(k.created),
          createdString: k.created ? new Date(k.created).toLocaleDateString(undefined, dateOptions) : t("Unknown"),
          expiration: k.expiration ? Date.parse(k.expiration) : null,
          expiresString: k.expiration ? Utils.timeSince(Date.parse(k.expiration)) : t("Never"),
          permissions: k.permissions,
          folder: keyData && keyData.keyOptions && keyData.keyOptions.assets ? keyData.keyOptions.assets.rootDir || null : null
        };
      });
    },
    keyIsSharedFolder(key) {
      const assetPermissions = ["read-assets", "write-assets"];
      return key && key.name && key.key && key.permissions && key.permissions.some(p => assetPermissions.includes(p));
    },
    sortKeys(a, b, field) {
      switch (field) {
        case "created":
          return a.created - b.created;
        case "expiration":
          if (a.expiration === null) {
            return 1;
          }
          if (b.expiration === null) {
            return -1;
          }
          return a.expiration - b.expiration;
        case "permissions":
          return a.permissions.length - b.permissions.length;
        case "name":
        default:
          return a.name.localeCompare(b.name);
      }
    },
    headerId(field) {
      return `${this.id}--header-${field.key}`;
    },
    sortTooltip(field) {
      if (!field.sortable) {
        return "";
      }
      if (field.key !== this.sortBy || this.sortDesc) {
        return t("Click to sort ascending");
      }
      return t("Click to sort descending");
    },
    readPermission(value) {
      return value && Array.isArray(value) && value.includes("read-assets") && !value.includes("write-assets");
    },
    writePermission(value) {
      return value && Array.isArray(value) && value.includes("write-assets");
    },
    expired(item) {
      return item && item.expiration && item.expiration < Date.now();
    },
    promptUnshare(item) {
      this.keyToRemove = item;
      this.showRemoveKeyModal = true;
    },
    async unshare(item) {
      if (!item || !item.name) {
        return false;
      }
      this.processing = true;
      const response = await Utils.api(`revoke-key`, {
        name: item.name
      });
      if (response.error) {
        this.processing = false;
        UI.error(t("Error revoking API Key: {{response.error}}", {
          response
        }));
        return false;
      }
      this.apiKeys = this.apiKeys.filter(k => k.name !== item.name);
      this.processing = false;
      return true;
    },
    async getShareUrl(key) {
      const response = await Utils.api("share-url", {
        name: key.name
      });
      if (response.error) {
        UI.error(t("Error getting share URL: {{response.error}}", {
          response
        }));
        return false;
      }
      navigator.clipboard.writeText(response.url);
      UI.info(t("Copied Share URL to clipboard"));
      return true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["FoundryTelemetry"] = Vue.component(
                    "FoundryTelemetry",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal centered size=\"lg\" :visible=\"visible\" :title=\"t('Allow Sharing Usage Data?')\" body-class=\"v11-telemetry\" footer-class=\"v11-telemetry\" @hidden=\"visible = false\" > <b-alert :show=\"error\" variant=\"danger\">{{ error }}</b-alert> <i18n :path=\" t( '{0} adds the capability for {1} to collect, only with your permission, anonymous usage data that helps them to improve the platform.' ) \" tag=\"p\" > <span>Foundry Virtual Tabletop Version 11</span> <a href=\"https://foundryvtt.com/\" target=\"_blank\">Foundry Gaming LLC</a> </i18n> <i18n :path=\" t( 'Allow sharing usage data with {0} that helps them to improve Foundry Virtual Tabletop. The data collected if this option is enabled is documented in their {1} and does not contain any personally identifying information and is not shared with any other party. Sharing usage data helps them to answer questions like “which Foundry Virtual Tabletop software versions are most heavily used”, “which Game Systems are most played”, and “which Module versions are frequently installed”. They use insights from this data to help them improve software compatibility, provide better customer support, and share aggregate insights with the community. If this option is disabled, no data will be shared.' ) \" class=\"telemetry-quote\" tag=\"p\" > <a href=\"https://foundryvtt.com/\" target=\"_blank\">Foundry Gaming LLC</a> <a href=\"https://foundryvtt.com/article/privacy-policy/\" target=\"_blank\">{{ t(\"Privacy Policy\") }}</a> </i18n> <i18n :path=\"upgradeMessage\" class=\"mb-0\" tag=\"p\"> <a href=\"/setup#manager=1\">{{ t(\"Game Manager\") }}</a> </i18n> <i18n :path=\" t( 'FOUNDRY_TELEMETRY.preview', 'If you have launched Foundry v11 or higher before, you can preview the collected Foundry telemetry data {0}.' ) \" class=\"mb-0\" tag=\"p\" > <a v-b-tooltip.hover=\"{ title: t('Click to preview') }\" href=\"/data/fvtt-diagnostics.json\" target=\"_blank\"> {{ t(\"FOUNDRY_TELEMETRY.preview.here\", \"here\") }}</a > </i18n> <template #modal-footer> <b-button variant=\"outline-success\" @click=\"save(true)\" ><i class=\"fas fa-check\"></i> {{ t(\"Allow Sharing\") }}</b-button > <b-button variant=\"outline-danger\" @click=\"save(false)\" ><i class=\"fas fa-times\"></i> {{ t(\"Decline Sharing\") }}</b-button > </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: "div.modal-body.v11-telemetry .telemetry-quote { font-style: italic; margin-left: 1.25rem; margin-right: 1.25rem; } footer.v11-telemetry { display: grid; grid-template-columns: 1fr 1fr; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    upgrading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null
  }),
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    upgradeMessage() {
      return this.upgrading ? t("You can change your preferences regarding sharing usage data at any time in the {0}.") : t("You can change your preferences regarding sharing usage data at any time.");
    }
  },
  methods: {
    async save(enable) {
      const response = await Utils.api("game/foundry/telemetry", {
        enable
      });
      if (response.error) {
        this.error = t("Error changing Foundry telemetry: {{- error}}", {
          error: response.error
        });
        return;
      }
      this.$emit("telemetry", enable);
      this.visible = false;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameCard"] = Vue.component(
                    "GameCard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card v-if=\"loaded\" ref=\"card\" :class=\"`game-card game-card-${horizontal ? 'horizontal' : 'vertical'} border-${border}`\" no-body @mouseover=\"mouseOver\" @mouseleave=\"mouseLeave\" > <!-- Game card Popver --> <game-card-popover v-if=\"isPlayer\" :game=\"game\" :target=\"() => $refs.card\" triggers=\"hover\"></game-card-popover> <!-- Horizontal --> <div v-if=\"horizontal\" class=\"row no-gutters card-container\"> <div v-if=\"!hideBanner\" class=\"col-xl-6 game-card-banner\"> <a :href=\"game.url\"> <b-img-lazy :src=\"game.banner\" class=\"card-img\" @error.native=\"errorLoadingImage\" @load.native=\"onBannerLoaded\" ></b-img-lazy> </a> </div> <div :class=\"`${hideBanner ? 'col-xl-12 p-5' : 'col-xl-6'}`\"> <div class=\"card-body h-100\"> <h5 class=\"card-title\"> <b-row> <b-col md=\"auto\" class=\"pr-0\"> <game-status-indicator :status=\"game.status\"></game-status-indicator> </b-col> <b-col class=\"pl-2 pr-1\"> {{ game.title }} </b-col> <b-col v-if=\"isPlayer\" md=\"auto\" class=\"pl-0\"> <!-- Favorite --> <div v-show=\"hover || game.favorite\" class=\"no-select favorite-icon\" @click.prevent=\"toggleFavorite\"> <i v-if=\"game.favorite\" v-b-tooltip.hover class=\"fas fa-star favorite-star\" :title=\"t('Remove Favorite')\" ></i> <i v-else v-b-tooltip.hover class=\"far fa-star\" :title=\"t('Set Favorite')\"></i> </div> </b-col> </b-row> </h5> <div class=\"card-text game-card-description forge-custom-scrollbar mb-2\" v-html=\"htmlDescription\"></div> <p class=\"card-text last-played\"> <small class=\"text-muted\">{{ t(\"Last Played:\") }} {{ Utils.timeSince(game.lastAccess, \"h\") }}</small> </p> </div> </div> </div> <!-- Vertical --> <template v-else> <div v-if=\"!hideBanner\" class=\"game-card-banner\"> <a :href=\"game.url\"> <b-img-lazy :src=\"game.banner\" class=\"card-img\" @error.native=\"errorLoadingImage\" @load.native=\"onBannerLoaded\" ></b-img-lazy> </a> </div> <div class=\"card-body\"> <h5 class=\"card-title\"> <b-row> <b-col md=\"auto\" class=\"pr-0\"> <game-status-indicator :status=\"game.status\"></game-status-indicator> </b-col> <b-col class=\"pl-2 pr-1\"> {{ game.title }} </b-col> <b-col v-if=\"isPlayer\" md=\"auto\" class=\"pl-0\"> <!-- Favorite --> <div v-show=\"hover || game.favorite\" class=\"no-select favorite-icon\" @click.prevent=\"toggleFavorite\"> <i v-if=\"game.favorite\" v-b-tooltip.hover class=\"fas fa-star favorite-star\" :title=\"t('Remove Favorite')\" ></i> <i v-else v-b-tooltip.hover class=\"far fa-star\" :title=\"t('Set Favorite')\"></i> </div> </b-col> </b-row> </h5> <div class=\"card-text game-card-description forge-custom-scrollbar mb-2\" v-html=\"htmlDescription\"></div> <p class=\"card-text last-played\"> <small class=\"text-muted\">{{ t(\"Last Played:\") }} {{ Utils.timeSince(game.lastAccess, \"h\") }}</small> </p> </div> </template> <!-- Footer --> <slot name=\"footer\"> <div v-if=\"nextGameSessionDate !== ''\" :class=\"sessionInGracePeriod ? 'p-2 next-session bg-primary text-white' : 'p-2 next-session'\" > <b-row> <b-col>{{ t(\"Next game session on\") }}</b-col> <b-col class=\"text-right\"><i class=\"fas fa-clock\"></i> {{ formatNextGameSessionDate }}</b-col> </b-row> </div> <div class=\"card-footer text-muted text-center\"> <!-- Launch --> <a v-if=\"isOwner\" v-b-tooltip.hover.top :href=\"game.url\" class=\"btn btn-primary\" :title=\"game.table ? t('Launch Foundry') : t('Launch Game')\" >{{ t(\"Launch\") }}</a > <span v-else-if=\"game.status === 'offline'\" v-b-tooltip.top tabindex=\"0\" :title=\"t('Game is Offline')\"> <a class=\"btn btn-info disabled\">{{ t(\"Offline\") }}</a> </span> <a v-else v-b-tooltip.hover.top :href=\"game.url\" class=\"btn btn-primary\" :title=\"t('Launch Game')\">{{ t(\"Launch\") }}</a> <!-- Buttons to display for invited players only (logged out user could see a public game card) --> <template v-if=\"isPlayer\"> <!-- Leave game --> <a v-if=\"full\" v-b-tooltip.hover.top href=\"#\" class=\"btn btn-danger\" :title=\"t('Leave Game')\" @click.prevent=\"leaveGame\" >{{ t(\"Leave Game\") }}</a > <!-- Configure Players --> <a v-if=\"full\" v-b-tooltip.hover.top href=\"#\" class=\"btn btn-secondary\" :title=\"isOwner ? t('Configure Players') : t('View Players')\" @click.prevent=\"configurePlayersVisible = true\" >{{ t(\"Players\") }}</a > <!-- Configure/Details --> <a v-if=\"isOwner && !full\" v-b-tooltip.hover.top :href=\"`/setup#${game.slug}`\" class=\"btn btn-secondary\" :title=\"game.table ? t('Configure Foundry Server') : t('Configure Game')\" >{{ t(\"Configure\") }}</a > <a v-else-if=\"!full\" v-b-tooltip.hover.top :href=\"`/game/${game.slug}`\" class=\"btn btn-secondary\" :title=\"t('View more options')\" >{{ t(\"Details\") }}</a > <!-- Party Chat --> <a v-if=\"game.privateChatId\" v-b-tooltip.hover.top :href=\"Utils.getForumLink(`/t/${game.privateChatId}`)\" class=\"btn btn-info\" target=\"_blank\" :title=\"t('Open Party Chat')\" >{{ t(\"Chat\") }}</a > <b-button v-else-if=\"isOwner\" v-b-tooltip.hover.top variant=\"success\" :disabled=\"creatingPrivateChat\" :title=\"t('Start Party Chat')\" @click.prevent=\"createPrivateChatAndNavigate\" > <loading-indicator v-if=\"creatingPrivateChat\" tag=\"span\" small :label=\"t('Starting…')\"></loading-indicator> <span v-else>{{ t(\"Chat\") }}</span> </b-button> <span v-else v-b-tooltip.top tabindex=\"0\" :title=\"t('Please ask the game owner to enable party chat')\"> <a class=\"btn btn-info disabled\">{{ t(\"Chat\") }}</a> </span> </template> </div> </slot> <game-configure-players v-model=\"configurePlayersVisible\" :game=\"game\" @leave=\"leaveGame\" @update=\"updateGame\" ></game-configure-players> </b-card> <loading-indicator v-else></loading-indicator>",
  beforeCreate() {
    Utils.loadCss({
      content: ".no-select { -webkit-user-select: none; /* Safari */ -ms-user-select: none; /* IE 10 and IE 11 */ user-select: none; /* Standard syntax */ } /* Max heights are computed inside `_gamelist.scss` */ .game-card { min-width: 335px; } .game-card .card-body { display: flex; flex-direction: column; } .game-card .card-container { /* Make space for the footer */ height: calc(100% - 4rem); /* Buttons: 2.5rem height, 0.75rem padding */ } .game-card .favorite-icon { position: relative; } .game-card .favorite-icon .fa-star { position: absolute; top: 0px; left: -1rem; } .game-card .card-footer { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; justify-content: center; } .game-card-description { overflow-y: scroll; /* Move the padding from the card container to the description box, to keep readability */ padding-right: 1.25rem; margin-right: -1.25rem; } .game-card-description p { margin-bottom: 0; } .game-card-description p + p { margin-top: 0.75rem; } .game-card-vertical .game-card-banner { max-height: 50%; } .game-card-banner a img { max-height: 100%; object-fit: contain; } .game-card .next-session { gap: 12px; } @media (min-width: 1200px) { .game-card-horizontal .col-xl-6 { max-height: 100%; } .game-card-horizontal .col-xl-12 { max-height: 100%; } } @media (max-width: 1199px) { .game-card-horizontal .col-xl-6 { max-height: 50%; } .game-card-horizontal .col-xl-12 { max-height: 100%; } }"
    });
  },
  props: {
    game: Object,
    full: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    maxDescription: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      loaded: false,
      hover: false,
      hoverTimeout: null,
      configurePlayersVisible: false,
      creatingPrivateChat: false,
      hideBanner: false
    };
  },
  computed: {
    border() {
      return this.game.owner ? "primary" : "secondary";
    },
    isOwner() {
      return this.game.owner;
    },
    isPlayer() {
      return !!this.game.playerId;
    },
    canLaunch() {
      return this.game.owner || this.game.status !== "offline";
    },
    htmlDescription() {
      const fullDescription = marked(this.game.description, {
        breaks: true,
        headerIds: false
      });
      const description = fullDescription.slice(0, this.maxDescription) + (this.maxDescription > 0 && fullDescription.length > this.maxDescription ? "…" : "");
      return DOMPurify.sanitize(description);
    },
    nextGameSessionDate() {
      if (this.game.nextSessionSchedule.startDate === null) {
        return "";
      }
      const now = new Date();
      now.setHours(now.getHours() - SHOW_SCHEDULE_SESSION_GRACE_PERIOD);
      try {
        const nextDate = Utils.calculateNextDateFromRepeats(this.game.nextSessionSchedule, now);
        if (nextDate === null) {
          return "";
        }
        return nextDate;
      } catch (err) {
        console.error("Error calculating next game session date.", err);
        return "";
      }
    },
    formatNextGameSessionDate() {
      const formattedDateTime = this.nextGameSessionDate.toLocaleString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        weekday: "short"
      });
      return formattedDateTime;
    },
    sessionInGracePeriod() {
      if (this.nextGameSessionDate === "") {
        return false;
      }
      const now = new Date();
      const diff = now.getTime() - this.nextGameSessionDate.getTime();
      // Next game session date is calculated using a time 4 hours in the past for the grace period. When the grace period finishes, diff will be 0.
      return diff <= SHOW_SCHEDULE_SESSION_GRACE_PERIOD * HOUR_MS && diff >= 0;
    }
  },
  methods: {
    capitalize(s) {
      return Utils.capitalize(s);
    },
    setHover(hover = true) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.hoverTimeout = null;
      if (hover) {
        this.hover = true;
      } else {
        this.hoverTimeout = setTimeout(() => this.hover = false, 250);
      }
    },
    mouseOver() {
      this.setHover(true);
    },
    mouseLeave() {
      this.setHover(false);
    },
    async toggleFavorite() {
      const response = await Utils.api("game/configure", {
        game: this.game.slug,
        favorite: !this.game.favorite
      });
      if (response.error) {
        UI.alert("warning", t("Failed to {{verb}} Favorite: {{- error}}", {
          verb: this.game.favorite ? t("unset") : t("set"),
          error: response.error
        }));
      } else {
        this.game.favorite = response.game.favorite;
        this.$emit("update", response.game);
      }
    },
    async leaveGame() {
      const result = await UI.query(t(`Leave Game`), t(`Are you sure you want to leave this game?<br/>You will not be able to join it again without the invitation link and all your statistics will be lost.`), {
        buttons: [{
          id: "kick-player-no",
          type: "success",
          label: t("Cancel"),
          response: "no"
        }, {
          id: "kick-player-yes",
          type: "danger",
          label: t(`Leave Game`),
          response: "yes"
        }]
      });
      if (result === "yes") {
        const response = await Utils.api("game/players", {
          game: this.game.slug,
          action: "rm",
          player: this.game.playerId
        });
        //console.log("Delete response:", response);
        if (response.error) {
          UI.alert("danger", t("Error removing player from game: {{- error}}", {
            error: response.error
          }));
        } else {
          window.location.reload();
        }
      }
    },
    updateGame({
      game
    }) {
      this.game = game;
    },
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, "/images/fight-goblins-1920.webp");
    },
    async createPrivateChatAndNavigate() {
      this.creatingPrivateChat = true;
      const response = await Utils.api("game/private-chat", {
        game: this.game.slug
      });
      if (response.error) {
        UI.alert("danger", t("Error creating party chat: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", {
          ...this.game,
          privateChatId: response.privateChatId
        });
        window.open(Utils.getForumLink(`/t/${response.privateChatId}`));
      }
      this.creatingPrivateChat = false;
    },
    onBannerLoaded(ev) {
      // Interpret banner size to determine whether to hide it
      this.hideBanner = ev.target && ev.target.height > 1 && (ev.target.naturalWidth <= 1 || ev.target.naturalHeight <= 1);
    }
  },
  async created() {
    await Utils.loadDependencies(["simple-markdown", "rrule"]);
    this.loaded = true;
    if (window.location.hash.includes("#players") && this.full) {
      this.configurePlayersVisible = true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameCardPopover"] = Vue.component(
                    "GameCardPopover",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-popover :html=\"true\" v-bind=\"$attrs\"> <template #title>{{ game.title }}</template> <div class=\"d-flex flex-column\"> <div> <strong>{{ t(\"Players:\") }}</strong> {{ game.players.length }} <ul> <li v-for=\"player in playersToShow\" :key=\"player.id\"> <b-img v-b-tooltip.hover.top=\"roleName(player.role)\" :src=\"roleImg(player.role)\" :alt=\"roleName(player.role)\" width=\"24\" > </b-img> &nbsp;{{ player.name }} ({{ player.usage }} hours) </li> <li v-if=\"playersHidden.length\"> <em><i18n :path=\"t('{{count}} more players hidden…', { count: playersHidden.length })\"></i18n></em> </li> </ul> </div> <div>Status : {{ game.status }} <game-status-indicator :status=\"game.status\"></game-status-indicator></div> <template v-if=\"game.privateChatId\"> &nbsp; <a :href=\"Utils.getForumLink(`/t/${game.privateChatId}`)\" class=\"btn btn-info\" target=\"_blank\">{{ t(\"Party Chat\") }}</a> </template> </div> </b-popover>",
  props: {
    game: Object
  },
  data() {
    return {
      numPlayersToShow: 10
    };
  },
  computed: {
    playersToShow() {
      return this.game.players.slice(0, this.sliceLimit);
    },
    playersHidden() {
      return this.game.players.slice(this.sliceLimit);
    },
    sliceLimit() {
      if (this.game.players.length > this.numPlayersToShow + 1) {
        return this.numPlayersToShow;
      }
      return this.game.players.length;
    }
  },
  methods: {
    roleImg(role) {
      return Games.roleImg(role);
    },
    roleName(role) {
      return Games.roleName(role);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameConfiguration"] = Vue.component(
                    "GameConfiguration",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div v-if=\"loaded\"> <b-form class=\"game-configuration\"> <div class=\"text-center m-3\"> <!-- t(\"Foundry\") --> <!-- t(\"Game\") --> <a :href=\"game.url\" class=\"btn btn-success\"> <span v-if=\"game.table\">{{ t(\"Launch My Foundry\") }}</span> <span v-else>{{ t(\"Launch My Game\") }}</span> </a> </div> <h3 class=\"text-center mt-2 mb-4\"> <span v-if=\"game.table\">{{ t(\"Configure your Foundry Server\") }}</span> <span v-else>{{ t(\"Configure your Foundry Game\") }}</span> </h3> <!-- Slug --> <b-form-group label-cols-lg=\"3\" :label-for=\"slugID\"> <template #label> <span v-show=\"isSlugModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> <span v-if=\"game.table\">{{ t(\"Server URL:\") }}</span> <span v-else>{{ t(\"Game URL:\") }}</span> </template> <b-input-group prepend=\"https://\"> <b-form-input :id=\"slugID\" v-model=\"form.slug\" v-b-popover.manual.d200.top=\"t('Game URL copied to clipboard')\" name=\"url\" minlength=\"3\" maxlength=\"63\" :state=\"slugIsValid\" lazy-formatter :formatter=\"slugify\" :placeholder=\"t('Leave empty to auto-generate')\" > </b-form-input> <b-input-group-append> <b-input-group-text v-b-tooltip.hover.top class=\"clickable no-select\" :title=\"t('Copy Link to clipboard')\" @click=\"copyUrl\" >.{{ domain }}</b-input-group-text > <b-input-group-text v-b-tooltip.hover.top class=\"text-success clickable no-select\" :title=\"t('Access Game')\" @click=\"openUrl\" ><i class=\"fas fa-play\"></i ></b-input-group-text> </b-input-group-append> </b-input-group> <small class=\"form-text text-muted\">{{ t(\"May only contain numbers, letters, underscores and dashes.\") }}</small> <p> <small ><strong>{{ t(\"Note:\") }}</strong> {{ t(\"The game must be offline or idle for the change to take effect.\") }}</small > </p> </b-form-group> <!-- Invitation link --> <b-form-group label-cols-lg=\"3\" :label=\"t('Invitation Link:')\" :label-for=\"inviteID\"> <b-input-group> <b-form-input :id=\"inviteID\" ref=\"inviteInput\" v-b-popover.manual.d200.top=\"t('Invitation Link copied to clipboard')\" :type=\"invitationInputType\" name=\"invite\" :value=\"invitationLink\" readonly @click=\"copyInvite\" > </b-form-input> <b-input-group-append> <b-input-group-text v-b-tooltip.hover.top class=\"clickable no-select\" :title=\"t('Copy Link to clipboard')\" @click=\"copyInvite\" >{{ t(\"Copy\") }}</b-input-group-text > <b-input-group-text v-b-tooltip.hover.top class=\"clickable no-select\" :title=\"t('Reset Invitation Link')\" @click=\"resetInvite\" >{{ t(\"Reset\") }}</b-input-group-text > <information-toggle v-model=\"invitationInputType\" :noun=\"t('Invitation Link')\"></information-toggle> </b-input-group-append> </b-input-group> <small class=\"form-text text-muted\">{{ t(\"Share this link with your friends to invite them to your private games.\") }}</small> </b-form-group> <!-- Current world --> <b-form-group v-if=\"true\" label-cols-lg=\"3\" label-size=\"sm\"> <template #label> <span>{{ t(\"Currently launched Foundry world:\") }}</span> <span v-b-tooltip.hover.top=\" t( `This only updates after the server idles, and it resets once the server stops. It does not update when you launch a world from the Foundry setup screen.` ) \" > <i class=\"fas fa-question-circle\"></i> </span> </template> <b-form-input :value=\"game.world || `*** ${t('None')} ***`\" size=\"sm\" readonly></b-form-input> </b-form-group> <b-form-group v-else label-cols-lg=\"3\" label-size=\"sm\" :label=\"t('This Game is linked to the Foundry World:')\"> <b-input-group size=\"sm\"> <b-form-input :value=\"game.world\" size=\"sm\" readonly></b-form-input> <b-input-group-append> <b-input-group-text ><i18n :path=\"t('System: {{system}}', { system: game.system })\"></i18n ></b-input-group-text> </b-input-group-append> </b-input-group> </b-form-group> <!-- Title --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isTitleModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\" ><i class=\"fas fa-exclamation-triangle text-warning\"></i ></a> &nbsp; </span> <span v-if=\"game.table\">{{ t(\"Server Title:\") }}</span> <span v-else>{{ t(\"Game Title:\") }}</span> </template> <b-input-group> <b-form-input v-model=\"form.title\" type=\"text\" name=\"title\"> </b-form-input> <b-input-group-append> <b-input-group-text class=\"clickable no-select\" @click.prevent=\"toggleFavorite\"> <i v-if=\"game.favorite\" v-b-tooltip.hover class=\"fas fa-star\" :title=\"t('Remove Favorite')\"></i> <i v-else v-b-tooltip.hover class=\"far fa-star\" :title=\"t('Set Favorite')\"></i> </b-input-group-text> </b-input-group-append> </b-input-group> </b-form-group> <!-- Banner --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isBannerModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> <span v-if=\"game.table\">{{ t(\"Server Banner:\") }}</span> <span v-else>{{ t(\"Game Banner:\") }}</span> </template> <b-row> <b-col cols=\"2\"> <b-img ref=\"bannerImg\" thumbnail rounded :src=\"form.banner\" :alt=\"game.table ? t('Server Banner:') : t('Game Banner:')\" class=\"game-configuration-banner-thumbnail\" @error=\"errorLoadingImage\" ></b-img> </b-col> <b-col cols=\"10\"> <drop :dragging=\"bannerDropOverlay && bannerDropIsFile\" @drop=\"dropBanner\" @over=\"bannerDropOverlay = $event\" > <h3 class=\"game-configuration-banner-upload-zone bg-light text-primary text-center d-flex flex-column justify-content-center\" @click=\"browseBanner\" > <loading-indicator v-if=\"bannerUploading\" :label=\"t('Uploading…')\"> </loading-indicator> <span v-else>{{ t(\"Drop files or click to browse\") }}</span> </h3> </drop> </b-col> <b-popover :target=\"() => $refs.bannerImg\" triggers=\"hover\" placement=\"right\"> <i18n v-if=\"game_banner_error\" :path=\"t('Could not find file {{name}}', { name: form.banner })\"></i18n> <b-img v-else thumbnail :src=\"form.banner\" @error=\"errorLoadingImage\"></b-img> </b-popover> <b-form-file ref=\"fileInput\" v-model=\"fileModel\" class=\"d-none\" accept=\"image/*\"></b-form-file> </b-row> </b-form-group> <!-- Description --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isDescriptionModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> <span v-if=\"game.table\">{{ t(\"Server Description:\") }}</span> <span v-else>{{ t(\"Game Description:\") }}</span> </template> <vue-simple-mde ref=\"mde\" v-model=\"form.description\" name=\"description\" class=\"mde-editor w-100 bg-light border\" preview-class=\"mde-halfscreen\" :configs=\"mdeConfig\" @blur=\"simplemdeBlur\" > </vue-simple-mde> </b-form-group> <!-- Tavern Private Chat --> <b-form-group label-cols-lg=\"3\"> <template #label> {{ t(\"Tavern Private Chat:\") }} </template> <template v-if=\"game.privateChatId\"> <a :href=\"Utils.getForumLink(`/t/${game.privateChatId}`)\" class=\"btn btn-info\" target=\"_blank\">{{ t(\"Access Party Chat\") }}</a> <a href=\"#\" class=\"btn btn-warning\" @click.prevent=\"showConfirmDeletePrivateChat = true\">{{ t(\"Clear Party Chat\") }}</a> </template> <b-button v-else variant=\"success\" :disabled=\"creatingPrivateChat\" @click.prevent=\"createPrivateChat\"> <loading-indicator v-if=\"creatingPrivateChat\" tag=\"span\" small :label=\"t('Starting…')\"> </loading-indicator> <span v-else>{{ t(\"Start Party Chat\") }}</span> </b-button> <small class=\"form-text text-muted\">{{ t(\"Send messages and notifications to your party!\") }}</small> </b-form-group> <!-- Privacy mode --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isPrivacyModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> <i18n :path=\"game.table ? t('Server Privacy Mode {0}:') : t('Game Privacy Mode {0}:')\"> <help-icon url=\"https://forums.forge-vtt.com/t/public-private-games/3588\" :tooltip=\"t('Private vs Public')\" ></help-icon> </i18n> </template> <div v-if=\"game.manageUsers\" v-b-tooltip.hover.top :title=\"t('Game must be private for the User Management to function')\" > <b-form-select value=\"private\" disabled :options=\"privacyOptions\"> </b-form-select> </div> <b-form-select v-else v-model=\"form.privacy\" :options=\"privacyOptions\"></b-form-select> <p> <small> {{ t(\"Public Games: Anyone who knows the game URL, can access it.\") }}<br /> {{ t(\"Private Games: Only players who joined the game using your invitation link will be able to access it.\") }} </small> </p> </b-form-group> <!-- Admin Key --> <b-form-group v-if=\"game.table\" label-cols-lg=\"3\" :label=\"t('Foundry setup admin key:')\"> <template #label> <span v-show=\"isAdminKeyModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> {{ t(\"Foundry setup admin key:\") }} </template> <b-input-group> <b-form-input v-model=\"form.adminKey\" :type=\"adminKeyVisible || !adminKeyEdit ? 'text' : 'password'\" placeholder=\"Admin Access Key\" autocomplete=\"off\" :readonly=\"!adminKeyEdit\" > </b-form-input> <b-input-group-append> <b-input-group-text v-show=\"form.adminKey && !adminKeyEdit\" v-b-tooltip.hover.top :title=\"t('Clear/Set a new access key')\" @click=\"resetAdminKey\" > <i class=\"fas fa-backspace\"></i> </b-input-group-text> <b-input-group-text v-show=\"form.adminKey && adminKeyEdit\" v-b-tooltip.hover.top :title=\"t('Reveal/Hide access key')\" @click=\"toggleAdminKey\" > <i v-if=\"!adminKeyVisible\" class=\"fas fa-eye\"></i> <i v-else class=\"fas fa-eye-slash\"></i> </b-input-group-text> </b-input-group-append> </b-input-group> <p> <small>{{ t(\"If an access key is not set, then only the game owner (you) can access its setup page.\") }}</small> </p> <p> <small>{{ t( \"Setting an access key will allow someone other than the owner to access the Foundry VTT setup page (after they authenticate to it).\" ) }}</small> </p> <p> <small ><strong>{{ t(\"Note:\") }}</strong> {{ t(\"The game must be offline or idle for the change to take effect.\") }}</small > </p> </b-form-group> <!-- Core Language Selection --> <b-form-group label-cols-lg=\"3\" :label=\"t('Foundry core language:')\"> <template #label> <span v-show=\"isLanguageModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> {{ t(\"Foundry core language:\") }} </template> <b-form-select v-model=\"form.language\" :options=\"languageOptions\"></b-form-select> <p> <small ><strong>{{ t(\"Note:\") }}</strong> {{ t(\"The game must be offline or idle for the change to take effect.\") }}</small > </p> </b-form-group> <!-- Foundry options --> <b-form-group v-if=\"game.table\" label-cols-lg=\"3\" :label=\"t('Foundry telemetry:')\"> <b-button :variant=\"`outline-${foundry_telemetry ? 'success' : 'danger'}`\" :disabled=\"showFoundryTelemetry\" @click=\"showFoundryTelemetry = true\" > {{ foundry_telemetry ? t(\"Enabled\") : t(\"Disabled\") }} </b-button> <foundry-telemetry v-model=\"showFoundryTelemetry\" @telemetry=\"foundry_telemetry = $event\"></foundry-telemetry> </b-form-group> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isFoundryCSSThemeModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> {{ t(\"Foundry VTT Theme:\") }} </template> <b-form-select v-model=\"form.foundryCssTheme\" :options=\"foundryCssThemeOptions\"></b-form-select> <p> <small> <strong>{{ t(\"Note:\") }}</strong> {{ t( \"Themes will be active only where supported by the configured Foundry server version. Requires Foundry v11 or newer.\" ) }} </small> </p> </b-form-group> <!-- Next Game Session Schedule --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isGameScheduleModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> {{ t(\"Schedule Session:\") }} </template> <b-row> <b-col> <b-card no-body> <template #header> <b-form-checkbox v-model=\"showNextGameSession\" type=\"checkbox\" :aria-label=\"t('Schedule Next Game Session')\" > {{ t(\"Schedule Next Game Session\") }} </b-form-checkbox> </template> <b-card-body v-if=\"showNextGameSession\"> <b-row> <b-col cols=\"12\" md=\"2\">{{ t(\"Date\") }}</b-col> <b-col> <b-form-datepicker v-model=\"nextSessionDate\" class=\"mb-2\" value-as-date></b-form-datepicker> <b-form-timepicker v-model=\"nextSessionTime\"></b-form-timepicker> </b-col> </b-row> <b-row class=\"mt-2\"> <b-col cols=\"12\" md=\"2\">{{ t(\"Frequency\") }}</b-col> <b-col> <b-form-select v-model=\"selectedRepeat\" :options=\"nextGameSessionRepeat\"> </b-form-select> <b-input-group v-if=\"isWeeklyFrequencySelected\" class=\"mt-2\" :prepend=\"t('Repeats Every')\" :append=\"repeatInterval === 1 ? t('Week') : t('Weeks')\" > <b-form-select v-model=\"repeatInterval\" :options=\"repeatIntervals\"></b-form-select> </b-input-group> </b-col> </b-row> <b-row v-if=\"isDailyFrequencySelected\" class=\"py-3\"> <b-col cols=\"12\" md=\"2\">{{ t(\"On\") }}</b-col> <b-col class=\"text-center\"> <div v-for=\"day in nextGameSessionRepeatWeekday\" :key=\"day.value\" :class=\"`mx-1 weekday ${selectedWeekdays.includes(day.value) ? 'selected' : ''}`\" :data-value=\"day.value\" @click=\"onRepeatDaySelection\" > {{ day.text }} </div> </b-col> </b-row> <b-row v-if=\"isDailySelectionInvalid\"> <b-col cols=\"12\" md=\"2\"></b-col> <b-col> <b-alert variant=\"danger\" show> {{ t(\"You must select at least two days or switch to Weekly schedule\") }} </b-alert> </b-col> </b-row> <b-row v-else-if=\"isOnceDaySelectedInPast\" class=\"mt-2\"> <b-col cols=\"12\" md=\"2\"></b-col> <b-col> <b-alert variant=\"danger\" show> {{ t(\"You must select a date and time in the future\") }} </b-alert> </b-col> </b-row> <b-row v-else class=\"py-2\"> <b-col cols=\"12\" md=\"2\"></b-col> <b-col> <b-alert variant=\"success\" show> <i18n v-if=\"isNextSessionDateInFuture\" :path=\"t(`Your schedule is starting on: {0}`)\" tag=\"p\"> <strong>{{ startGameSessionDate }}</strong> </i18n> <i18n :path=\"t(`The next session is scheduled on: {0}`)\" tag=\"div\"> <strong>{{ nextGameSessionDate }}</strong> </i18n> </b-alert> </b-col> </b-row> </b-card-body> </b-card> </b-col> </b-row> </b-form-group> <!-- Foundry Version --> <b-form-group label-cols-lg=\"3\" :label=\"t('Foundry VTT Server Version')\"> <template #label> <span v-show=\"isVersionModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a >&nbsp; </span> {{ t(\"Foundry VTT Server Version:\") }} </template> <b-form-select v-model=\"form.version\" :options=\"versionOptions\"></b-form-select> <div class=\"mt-3\"> <a href=\"https://forums.forge-vtt.com/t/foundry-vtt-version-selection/16637\" target=\"_blank\" ><i class=\"fas fa-question-circle\"></i> {{ t(\"Click here for more information about Foundry VTT versions\") }}</a > </div> <div v-if=\"game.lastVersion && !isVersionModified\" class=\"mt-3\"> <i18n :path=\"t('Last Foundry VTT version used on this release channel: {0}')\"> <strong>{{ game.lastVersion }}</strong> </i18n> <span v-if=\"fvttHasUpdate\"> &nbsp;<b-button tag=\"a\" variant=\"success\" size=\"sm\" href=\"/setup/foundry-update\" target=\"_blank\" ><i18n :path=\"t('Update to {{latestChannelVersion}}', { latestChannelVersion })\"></i18n> </b-button> </span> </div> <div v-if=\"!game.table && form.version !== 'default'\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> <i18n :path=\" t( 'It is recommended to keep all games to the same version and set the default version in the {0} instead. This ensures modules in the Bazaar are matching your Foundry version.' ) \" > <a href=\"#manager=1\">{{ t(\"Game Manager tab\") }}</a> </i18n> </div> <div v-else-if=\"!game.table\"> <i18n :path=\" t( 'You can change the default Foundry version in the {0}. This helps ensure systems and modules installed from the Bazaar are compatible with all your games.' ) \" > <a href=\"#manager=1\">{{ t(\"Game Manager tab\") }}</a> </i18n> </div> <p> <small ><strong>{{ t(\"Note:\") }}</strong> {{ t(\"The game must be offline or idle for the change to take effect.\") }}</small > </p> </b-form-group> </b-form> <b-toaster name=\"game-configuration-toaster\" :class=\"toastIntersected ? '' : 'fixed'\"></b-toaster> <!-- Add padding to avoid toaster jumping from fixed to non fixed then add intersection observer beneath the padding --> <div :style=\"!toastIntersected && isConfigurationChanged ? 'height: 70px' : ''\"></div> <intersection @enter=\"toastIntersected = true\" @leave=\"toastIntersected = false\"> <div></div> </intersection> <!-- Pending modifications toaster --> <b-toast key=\"toast\" :visible=\"isConfigurationChanged\" toaster=\"game-configuration-toaster\" variant=\"primary\" no-auto-hide no-close-button > <div class=\"text-center\" :class=\"toastAnimationClass\"> {{ t(\"You have unsaved changes to your game configuration.\") }} <b-button size=\"sm\" class=\"m-1\" variant=\"secondary\" @click.prevent=\"resetSettings\" ><i class=\"fas fa-undo\"></i> {{ t(\"Reset changes\") }}</b-button > <b-button size=\"sm\" class=\"m-1\" variant=\"success\" :disabled=\"savingConfig\" @click.prevent=\"saveConfig\"> <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\"> </loading-indicator> <span v-else><i class=\"fas fa-save\"></i> {{ t(\"Save Changes\") }}</span> </b-button> </div> </b-toast> <!-- Confirm changing Foundry version --> <confirm-message v-model=\"showConfirmVersionChange\" :title=\"t('Confirm Foundry version change')\" @cancel=\"cancelVersionChange\" > <i18n :path=\" t( 'WARNING: Overriding the default Foundry VTT version can cause problems due to module incompatibility. If you wish to set a different default version of Foundry VTT, we recommend doing so in the {0} tab. By default, the modules and systems available will respect your default version of Foundry VTT.' ) \" tag=\"p\" > <a href=\"#manager=1\" @click=\"cancelVersionChange\">{{ t(\"Game Manager\") }}</a> </i18n> {{ t(\"Are you sure you wish to continue?\") }} </confirm-message> <!-- Confirm changing game privacy mode --> <confirm-message v-model=\"showConfirmPrivacyChange\" :title=\"t('Confirm Game privacy mode change')\" @cancel=\"cancelPrivacyChange\" > <p> {{ t( \"We do not recommend setting your world as public. We provide this option for people to use The Forge without creating an account, in respecting that groups with younger users will want to use The Forge.\" ) }} </p> <i18n :path=\" t( 'If you are not playing with children, we recommend that players create a free account, and join via invitation URL. Please read more about it {0}.' ) \" tag=\"p\" > <a target=\"_blank\" href=\"https://forums.forge-vtt.com/t/public-private-games/3588\">{{ t(\"here\") }}</a> </i18n> {{ t(\"Are you sure you wish to continue?\") }} </confirm-message> <!-- Confirm clearing Tavern Private Chat --> <confirm-message v-model=\"showConfirmDeletePrivateChat\" :title=\"t('Clear Party Chat')\" @ok=\"deletePrivateChat\"> <p>{{ t(\"Are you sure you want to clear your game's party chat?\") }}</p> <p>{{ t(\"Messages cannot be recovered after being deleted.\") }}</p> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-configuration .clickable { cursor: pointer; } .game-configuration-banner-thumbnail { height: 75px; width: auto; } .game-configuration-banner-upload-zone { border: 3px dotted; border-radius: 10px; height: 75px; width: 100%; cursor: pointer; } .b-toaster.game-configuration-toaster.fixed { position: fixed; bottom: 0.5rem; left: 0.5rem; right: 0.5rem; margin: 0px; padding: 0px; } .b-toaster.game-configuration-toaster .b-toaster-slot, .b-toaster.game-configuration-toaster .b-toaster-slot .b-toast, .b-toaster.game-configuration-toaster .b-toaster-slot .toast { width: 100%; max-width: 100%; } .mde-editor .editor-toolbar.fullscreen::before { display: none; } .mde-editor .editor-toolbar.fullscreen::after { display: none; } .mde-editor .mde-halfscreen.editor-preview-active-side { width: calc(50% - 100px); bottom: 100px; top: 150px; right: 100px; z-index: 1050; border-right: 1px #b9b9b9 solid; border-bottom: 1px #b9b9b9 solid; } .mde-editor .editor-toolbar.fullscreen { width: calc(100% - 200px); top: 100px; left: 100px; z-index: 1050; border-top: 1px #b9b9b9 solid; border-left: 1px #b9b9b9 solid; border-right: 1px #b9b9b9 solid; background: white; } .mde-editor .CodeMirror-sided { width: calc(50% - 100px) !important; border-left: 1px #b9b9b9 solid; border-bottom: 1px #b9b9b9 solid; } .mde-editor .CodeMirror-fullscreen { top: 150px; left: 100px; right: 100px; bottom: 100px; height: auto; z-index: 1050; } .no-select { -webkit-user-select: none; /* Safari */ -ms-user-select: none; /* IE 10 and IE 11 */ user-select: none; /* Standard syntax */ } .weekday { float: left; border-radius: 50%; text-align: center; width: 42px; padding: 6px; margin-right: 0.25rem; cursor: pointer; background-color: var(--gray-dark); color: var(--white); } .weekday.selected { background-color: var(--primary); font-weight: bold; }"
    });
  },
  props: {
    game: Object,
    table: Object,
    fvttVersions: Object,
    coreLanguages: Array
  },
  data() {
    return {
      loaded: false,
      savingConfig: false,
      mdeConfig: {
        forceSync: true,
        spellChecker: false
      },
      privacyOptions: [{
        value: "public",
        text: t("Public Game")
      }, {
        value: "private",
        text: t("Private Game")
      }],
      unsavedTooltipTitle: t("Modified value is not saved"),
      toastAnimationClass: "animate__animated animate__fast animate__tada",
      toastIntersected: false,
      form: {
        slug: "",
        title: "",
        description: "",
        banner: "",
        adminKey: "",
        language: "",
        version: "",
        privacy: "private",
        nextSessionSchedule: {},
        scheduleSessionString: "",
        foundryCssTheme: ""
      },
      fileModel: null,
      bannerDropIsFile: false,
      bannerDropOverlay: false,
      bannerUploading: false,
      adminKeyVisible: false,
      adminKeyEdit: false,
      popover_hide_timeout: null,
      popover_show_timeout: null,
      showConfirmVersionChange: false,
      showConfirmPrivacyChange: false,
      showConfirmDeletePrivateChat: false,
      showInvitation: false,
      invitationInputType: "password",
      game_banner_error: false,
      creatingPrivateChat: false,
      versionAlert: null,
      // Next game session options
      showNextGameSession: false,
      nextSessionDate: null,
      nextSessionTime: null,
      nextGameSessionRepeat: [{
        value: Enums.GameSessionRepeat.ONCE,
        text: t("Once")
      }, {
        value: Enums.GameSessionRepeat.WEEKLY,
        text: t("Weekly")
      }, {
        value: Enums.GameSessionRepeat.DAILY,
        text: t("Daily")
      }],
      nextGameSessionRepeatWeekday: [{
        value: Enums.DayOfWeek.SUNDAY,
        text: t(`DayOfWeek.SUNDAY`, "SU")
      }, {
        value: Enums.DayOfWeek.MONDAY,
        text: t(`DayOfWeek.MONDAY`, "MO")
      }, {
        value: Enums.DayOfWeek.TUESDAY,
        text: t(`DayOfWeek.TUESDAY`, "TU")
      }, {
        value: Enums.DayOfWeek.WEDNESDAY,
        text: t(`DayOfWeek.WEDNESDAY`, "WE")
      }, {
        value: Enums.DayOfWeek.THURSDAY,
        text: t(`DayOfWeek.THURSDAY`, "TH")
      }, {
        value: Enums.DayOfWeek.FRIDAY,
        text: t(`DayOfWeek.FRIDAY`, "FR")
      }, {
        value: Enums.DayOfWeek.SATURDAY,
        text: t(`DayOfWeek.SATURDAY`, "SA")
      }],
      selectedWeekdays: [],
      selectedRepeat: Enums.GameSessionRepeat.WEEKLY,
      repeatIntervals: [1, 2, 3, 4, 5, 6],
      repeatInterval: 1,
      // Foundry options
      showFoundryTelemetry: false,
      foundry_telemetry: false
    };
  },
  watch: {
    fileModel() {
      if (this.fileModel) {
        this.uploadBanner(this.fileModel);
      }
    },
    game() {
      this.resetSettings();
    },
    "form.version": function (newVal, oldVal) {
      if (newVal != "default" && oldVal === "default" && this.form.version != this.game.version) {
        this.showConfirmVersionChange = true;
      }
    },
    "form.privacy": function (newVal, oldVal) {
      if (newVal == "public" && this.form.privacy != this.game.privacy) {
        this.showConfirmPrivacyChange = true;
      }
    },
    nextGameSessionRule(newVal, oldVal) {
      this.form.nextSessionSchedule = newVal;
    }
  },
  computed: {
    domain() {
      return window.location.host;
    },
    invitationLink() {
      return `https://${this.domain}/invite/${this.game.slug}/${this.game.invite}`;
    },
    versionOptions() {
      const versions = [];
      const specificVersions = this.fvttVersions.versions.map(v => ({
        value: v,
        text: v
      }));
      if (this.game.version !== "default" && !this.fvttVersions.versions.includes(this.fvttVersion)) {
        specificVersions.push({
          value: this.fvttVersion,
          text: t("{{version}} (Deprecated)", {
            version: this.fvttVersion
          })
        });
      }
      if (this.game.table) {
        versions.push({
          label: t("Automatically update games to:"),
          options: [{
            value: "recommended",
            text: t(`Forge Recommended ({{version}})`, {
              version: this.fvttVersions.channels.recommended
            })
          }, {
            value: "latest",
            text: t(`Latest Foundry VTT Release ({{version}})`, {
              version: this.fvttVersions.channels.latest
            })
          }]
        });
        versions.push({
          label: t("Specific Foundry VTT Version:"),
          options: specificVersions
        });
      } else {
        versions.push({
          label: t("Auto-update to default version (set in Game Manager tab):"),
          options: [{
            value: "default",
            text: t(`Default Version ({{version}})`, {
              version: Utils.capitalize(this.table ? this.table.lastVersion || this.table.version : "")
            })
          }]
        });
        versions.push({
          label: t("Override Foundry VTT Version:"),
          options: specificVersions
        });
      }
      return versions;
    },
    latestChannelVersion() {
      return this.fvttVersions.channels[this.game.version] || this.game.version;
    },
    fvttHasUpdate() {
      if (!this.game.lastVersion) {
        return false;
      }
      return this.game.lastVersion !== this.latestChannelVersion;
    },
    languageOptions() {
      const languages = [{
        value: "en.core",
        text: t("English")
      }];
      languages.push(...this.coreLanguages.map(lang => ({
        value: `${lang.lang}.${lang.module}`,
        text: lang.name
      })));
      return languages;
    },
    foundryCssThemeOptions() {
      // These themes were added in v11. Must exist in Foundry itself for it to be functional, otherwise, it defaults.
      // Currently (v11), these themes only affect the setup and join screens. In the future,
      //  they will likely affect individual games and should be displayed even if not on table.
      const foundryThemeValue = this.game.table && !this.form.foundryCssTheme ? null : "foundry";
      const themeOptions = [{
        value: foundryThemeValue,
        text: t("FOUNDRY_CSS_THEME.foundry", "Foundry Virtual Tabletop")
      }, {
        value: "fantasy",
        text: t("FOUNDRY_CSS_THEME.fantasy", "Classic Fantasy")
      }, {
        value: "scifi",
        text: t("FOUNDRY_CSS_THEME.scifi", "Science Fiction")
      }];
      if (!this.game.table) {
        const tableTheme = this.table && this.table.foundry_css_theme || "foundry"; // "foundry" is default
        const tableThemeText = t(`FOUNDRY_CSS_THEME.${tableTheme}`); // No need for string extraction, just translate
        const defaultThemeText = t("DefaultWithTheme", {
          defaultValue: "Default Theme ({{defaultTheme}})",
          defaultTheme: tableThemeText
        });
        // Foundry defaults to "foundry" if null. If it wasn't set already, add null as option, else "default"
        const defaultThemeValue = this.form.foundryCssTheme ? "default" : null;
        themeOptions.unshift({
          value: defaultThemeValue,
          text: defaultThemeText
        });
      }
      return themeOptions;
    },
    inviteID() {
      return `invite-${this._uid}`;
    },
    slugID() {
      return `slug-${this._uid}`;
    },
    slugIsValid() {
      return this.form.slug.length === 0 || this.form.slug.length >= 3 && this.slugify(this.form.slug) === this.form.slug;
    },
    isSlugModified() {
      return this.game.slug !== this.form.slug;
    },
    isTitleModified() {
      return this.game.title !== this.form.title;
    },
    isDescriptionModified() {
      return this.game.description !== this.form.description;
    },
    isBannerModified() {
      return this.game.banner !== this.form.banner;
    },
    isAdminKeyModified() {
      return this.adminKeyEdit && (!!this.form.adminKey || this.game.keySet);
    },
    isPrivacyModified() {
      return this.game.privacy !== this.form.privacy;
    },
    isLanguageModified() {
      return this.game.language !== this.form.language;
    },
    isFoundryCSSThemeModified() {
      return this.game.foundry_css_theme !== this.form.foundryCssTheme;
    },
    isVersionModified() {
      return this.game.version !== this.form.version;
    },
    isConfigurationChanged() {
      return this.isSlugModified || this.isTitleModified || this.isDescriptionModified || this.isBannerModified || this.isAdminKeyModified || this.isLanguageModified || this.isPrivacyModified || this.isVersionModified || this.isFoundryCSSThemeModified || this.isGameScheduleModified;
    },
    fvttVersion() {
      const useTableVersion = !this.game.table && this.game.version === "default" && this.table;
      const version = useTableVersion ? this.table.version : this.game.version;
      return this.fvttVersions.channels[version] || version;
    },
    isWeeklyFrequencySelected() {
      return this.selectedRepeat === Enums.GameSessionRepeat.WEEKLY;
    },
    isDailyFrequencySelected() {
      return this.selectedRepeat === Enums.GameSessionRepeat.DAILY;
    },
    isDailySelectionInvalid() {
      return this.selectedWeekdays.length < 2 && this.selectedRepeat === Enums.GameSessionRepeat.DAILY;
    },
    isOnceDaySelectedInPast() {
      if (!this.isDailySelectionInvalid) {
        const nextDate = this.getNextSessionDate();
        return nextDate === null;
      }
      return false;
    },
    isNextSessionDateInFuture() {
      const newDate = new Date(this.nextSessionDate.getFullYear(), this.nextSessionDate.getMonth(), this.nextSessionDate.getDate());
      return newDate.getTime() > new Date().getTime();
    },
    isRepeatIntervalValid() {
      return this.repeatInterval > 0;
    },
    nextGameSessionRule() {
      if (this.showNextGameSession) {
        const timeSplitted = this.nextSessionTime.split(":");
        const newDate = new Date(this.nextSessionDate.getFullYear(), this.nextSessionDate.getMonth(), this.nextSessionDate.getDate(), ...timeSplitted);
        let interval = this.repeatInterval;
        if (interval < 0 && this.game.nextSessionSchedule.startDate) {
          interval = this.game.nextSessionSchedule.repeatInterval;
        } else if (interval <= 0) {
          return {
            startDate: null,
            repeats: [],
            repeatInterval: 1,
            tzid: null
          };
        }
        let weekDays = this.selectedWeekdays;
        if (this.selectedRepeat === Enums.GameSessionRepeat.ONCE) {
          weekDays = [];
          interval = 1;
        } else if (this.selectedRepeat === Enums.GameSessionRepeat.WEEKLY) {
          weekDays = [this.getWeekDayAbbreviation(this.nextSessionDate.getDay())];
        } else {
          interval = 1;
          weekDays = this.selectedWeekdays;
        }
        weekDays.sort();
        return {
          startDate: new Date(newDate),
          repeats: weekDays,
          repeatInterval: parseInt(interval),
          tzid: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
      }
      return {
        startDate: null,
        repeats: [],
        repeatInterval: 1,
        tzid: null
      };
    },
    startGameSessionDate() {
      return this.formatNextSessionDate(this.form.nextSessionSchedule.startDate);
    },
    nextGameSessionDate() {
      const nextDate = this.getNextSessionDate();
      if (nextDate === null) {
        return "";
      }
      return this.formatNextSessionDate(nextDate);
    },
    isGameScheduleModified() {
      return JSON.stringify(this.game.nextSessionSchedule) !== JSON.stringify(this.form.nextSessionSchedule);
    }
  },
  methods: {
    getWeekDayAbbreviation(weekDay) {
      return {
        0: "SU",
        1: "MO",
        2: "TU",
        3: "WE",
        4: "TH",
        5: "FR",
        6: "SA"
      }[weekDay || 0];
    },
    getNextSessionDate() {
      return Utils.calculateNextDateFromRepeats(this.form.nextSessionSchedule);
    },
    setSessionInformation() {
      // setting next game session initial date
      if (this.game.nextSessionSchedule.startDate) {
        const ruleStartDate = new Date(this.game.nextSessionSchedule.startDate);
        this.nextSessionDate = ruleStartDate;
        this.nextSessionTime = `${ruleStartDate.getHours()}:${ruleStartDate.getMinutes()}`;
        this.showNextGameSession = true;
        if (this.game.nextSessionSchedule.repeats.length === 0) {
          this.selectedRepeat = Enums.GameSessionRepeat.ONCE;
        } else if (this.game.nextSessionSchedule.repeats.length === 1) {
          this.selectedRepeat = Enums.GameSessionRepeat.WEEKLY;
          this.repeatInterval = this.game.nextSessionSchedule.repeatInterval;
        } else {
          this.selectedRepeat = Enums.GameSessionRepeat.DAILY;
        }
        this.selectedWeekdays = [...this.game.nextSessionSchedule.repeats];
      } else {
        const now = new Date();
        this.nextSessionDate = now;
        this.nextSessionTime = `${now.getHours()}:${now.getMinutes()}`;
        this.showNextGameSession = false;
        this.selectedWeekdays = [this.getWeekDayAbbreviation(now.getDay())];
        this.selectedRepeat = Enums.GameSessionRepeat.WEEKLY;
        this.repeatInterval = 1;
      }
    },
    formatNextSessionDate(date) {
      const formattedDateTime = date.toLocaleString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        weekday: "short"
      });
      return formattedDateTime;
    },
    slugify(input) {
      return Utils.slugify(input, globalThis.GAME_SLUG_MIN_LENGTH, globalThis.GAME_SLUG_MAX_LENGTH);
    },
    copyInvite() {
      Utils.copyToClipboard(this.invitationLink);
      this.$root.$emit("bv::hide::popover");
      clearTimeout(this.popover_show_timeout);
      clearTimeout(this.popover_hide_timeout);
      this.popover_show_timeout = setTimeout(() => this.$root.$emit("bv::show::popover", this.inviteID), 300);
      this.popover_hide_timeout = setTimeout(() => this.$root.$emit("bv::hide::popover", this.inviteID), 3000);
    },
    copyUrl() {
      Utils.copyToClipboard(this.game.url);
      this.$root.$emit("bv::hide::popover");
      clearTimeout(this.popover_show_timeout);
      clearTimeout(this.popover_hide_timeout);
      this.popover_show_timeout = setTimeout(() => this.$root.$emit("bv::show::popover", this.slugID), 300);
      this.popover_hide_timeout = setTimeout(() => this.$root.$emit("bv::hide::popover", this.slugID), 3000);
    },
    openUrl() {
      window.location = this.game.url;
    },
    async toggleFavorite() {
      const response = await Utils.api("game/configure", {
        game: this.game.slug,
        favorite: !this.game.favorite
      });
      if (response.error) {
        UI.alert("warning", t(`Failed to {{verb}} Favorite: {{- error}}`, {
          verb: this.game.favorite ? t("unset") : t("set"),
          error: response.error
        }));
      } else {
        this.game.favorite = response.game.favorite;
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
    },
    toggleAdminKey(ev) {
      this.adminKeyVisible = !this.adminKeyVisible;
    },
    async resetInvite() {
      const response = await Utils.api("game/configure", {
        game: this.game.slug,
        invite: true
      });
      if (response.error) {
        UI.alert("warning", t(`Failed to reset invitation link: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.game.invite = response.game.invite;
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
    },
    async saveConfig() {
      this.savingConfig = true;
      if (this.isLanguageModified) {
        const lang = this.coreLanguages.find(lang => this.form.language === `${lang.lang}.${lang.module}`);
        if (lang && lang.module) {
          const response = await Utils.api(`data/modules/install`, {
            name: lang.module
          });
          if (response.installed) {
            UI.alert("info", t(`Installed Foundry Core Language module: {{title}}`, {
              title: response.title
            }));
          }
        }
      }
      const response = await Utils.api("game/configure", {
        game: this.game.slug,
        slug: this.form.slug,
        title: this.form.title,
        description: this.form.description,
        banner: this.form.banner,
        adminKey: this.isAdminKeyModified ? this.form.adminKey : null,
        language: this.form.language,
        privacy: this.form.privacy,
        version: this.form.version,
        foundryCssTheme: this.form.foundryCssTheme,
        nextSessionSchedule: this.form.nextSessionSchedule
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t(`Error setting game configuration: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
    },
    browseBanner() {
      this.$refs.fileInput.$refs.input.click();
    },
    dropBanner({
      name,
      nativeEvent
    }) {
      if (name === "drop") {
        const files = [...nativeEvent.dataTransfer.files];
        const image = files.find(f => Utils.extensionType(f.name.split(".").pop() || "") === "image");
        if (image) {
          this.fileModel = image;
        }
      } else if (name === "dragover") {
        this.bannerDropIsFile = nativeEvent.dataTransfer.types.includes("Files");
      }
    },
    async uploadBanner(file) {
      console.log("Upload file : ", file);
      this.bannerUploading = true;
      const response = await Assets.uploadFiles("Game Banners", [file]).catch(err => null);
      this.bannerUploading = false;
      console.log("Uploaded : ", response);
      if (response && response.results && response.results[0] && response.results[0].url) {
        this.form.banner = response.results[0].url;
      }
      this.fileModel = null;
    },
    resetAdminKey() {
      this.adminKeyEdit = true;
      this.form.adminKey = "";
    },
    resetSettings() {
      this.form.slug = this.game.slug;
      this.form.title = this.game.title;
      this.form.description = this.game.description;
      this.form.banner = this.game.banner;
      this.form.privacy = this.game.privacy;
      this.form.version = this.game.version;
      this.form.language = this.game.language;
      this.form.foundryCssTheme = this.game.foundry_css_theme;
      this.form.nextSessionSchedule = Utils.duplicate(this.game.nextSessionSchedule);
      this.setSessionInformation();
      this.adminKeyEdit = !this.game.keySet;
      this.form.adminKey = "";
      if (this.game.keySet) {
        this.form.adminKey = `***${t("Encrypted Access Key")}***`;
      }
    },
    simplemdeBlur(ev) {
      // Vue-SimpleMDE expects a value change to happen after a blur, which causes reset to fail.
      this.$refs.mde.isValueUpdateFromInner = false;
    },
    toastNeedsAttention() {
      this.toastAnimationClass = "";
      this.$nextTick(() => this.toastAnimationClass = "animate__animated animate__fast animate__tada");
    },
    cancelVersionChange() {
      this.form.version = "default";
    },
    cancelPrivacyChange() {
      this.form.privacy = "private";
    },
    errorLoadingImage(ev) {
      this.game_banner_error = true;
      Utils.errorLoadingImage(ev, "/images/fight-goblins-1920.webp");
    },
    async createPrivateChat() {
      this.creatingPrivateChat = true;
      const response = await Utils.api("game/private-chat", {
        game: this.game.slug
      });
      if (response.error) {
        UI.alert("danger", t("Error creating party chat: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: {
            ...this.game,
            privateChatId: response.privateChatId
          }
        });
      }
      this.creatingPrivateChat = false;
    },
    async deletePrivateChat() {
      const response = await Utils.api("game/private-chat", {
        game: this.game.slug
      }, {
        method: "DELETE"
      });
      if (response.error) {
        UI.alert("danger", t("Error deleting party chat: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: {
            ...this.game,
            privateChatId: null
          }
        });
      }
    },
    onRepeatDaySelection(event) {
      const day = event.target.dataset.value;
      if (this.selectedWeekdays.includes(day)) {
        const index = this.selectedWeekdays.indexOf(day);
        this.selectedWeekdays.splice(index, 1);
        event.target.classList.toggle("selected");
      } else {
        this.selectedWeekdays.push(day);
        event.target.classList.toggle("selected");
      }
    }
  },
  // Cannot use beforeCreate because gulp uses it for loadCSS
  async created() {
    this.foundry_telemetry = this.table ? this.table.foundry_telemetry : this.game.foundry_telemetry;
    await Utils.loadDependencies(["simple-markdown-editor", "rrule"]);
    this.loaded = true;
    this.setSessionInformation();
  },
  mounted() {
    this.resetSettings();
    if (!this.fvttVersions.versions.includes(this.fvttVersion)) {
      this.versionAlert = UI.alert("warning", t(`Foundry VTT version <strong>{{version}}</strong> is now deprecated on The Forge. Please read this {{- guide}} and {{- backupLink}} before updating your Foundry VTT server to the next available version or higher.`, {
        version: this.fvttVersion,
        backupLink: `<a href="${this.game.table || this.game.version === "default" ? "/setup/export" : `/setup/export/${this.game.world}`}" target="_blank">${t("back up your data")}</a>`,
        guide: `<a href="https://forums.forge-vtt.com/t/how-to-update-foundry-vtt-on-the-forge/14139" target="_blank">${t("guide")}</a>`
      }), true);
    }
  },
  destroyed() {
    if (this.versionAlert) {
      this.versionAlert.remove();
      this.versionAlert = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameConfigurePlayers"] = Vue.component(
                    "GameConfigurePlayers",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal v-model=\"visible\" :title=\"`${t('Configure Players')} - ${game.title}`\" :no-enforce-focus=\"releaseFocus\" shadow backdrop lazy centered scrollable size=\"lg\" > <transition enter-active-class=\"animate__animated animate__faster animate__fadeInDown\" leave-active-class=\"animate__animated animate__faster animate__fadeOutUp\" > <b-alert v-model=\"alertData.show\" :variant=\"alertData.variant\" dismissible>{{ alertData.message }}</b-alert> </transition> <div class=\"game-configure-players px-3 py-2 h-100\" @click=\"dismissPopovers\"> <!-- Invitation link --> <b-form-group v-if=\"game.owner\" class=\"mt-2\" :label=\"t('Invitation Link')\" :label-for=\"`invite-${_uid}`\" label-cols=\"4\" > <b-input-group> <b-form-input :id=\"`invite-${_uid}`\" v-b-popover.manual.d200.top=\"t('Invitation Link copied to clipboard')\" v-b-tooltip.hover.top :type=\"invitationInputType\" :value=\"invitationLink\" :title=\"t('Invitation Link')\" readonly @click=\"copyInvite\" > </b-form-input> <b-input-group-append> <b-button v-b-tooltip.hover.top class=\"clickable no-select\" :title=\"t('Copy Link to clipboard')\" @click=\"copyInvite\" ><i class=\"far fa-copy\"></i ></b-button> <information-toggle v-model=\"invitationInputType\" :noun=\"t('Invitation Link')\"></information-toggle> </b-input-group-append> </b-input-group> </b-form-group> <!-- User Management --> <b-row v-if=\"game.owner\" class=\"mt-2\" align-v=\"center\"> <b-col cols=\"4\"> {{ t(\"Automatic User Management\") }} <help-icon v-b-tooltip.hover.top :title=\"t('Click here to learn more')\" url=\"https://forums.forge-vtt.com/t/the-user-manager/11039\" style=\"color: inherit\" ></help-icon> </b-col> <b-col v-b-tooltip.hover.left.noninteractive=\" game.table ? t('User Management requires the Game Manager to be enabled') : t('Toggle User Management') \" cols=\"2\" > <b-form-checkbox v-model=\"manageUsers\" :disabled=\"game.table\" switch></b-form-checkbox> </b-col> <!-- Reset Access Keys --> <b-col v-if=\"game.owner && !game.table\" cols=\"6\" class=\"pl-3 text-right\"> <b-button v-if=\"!game.manageUsers\" v-b-tooltip.hover.top size=\"sm\" variant=\"warning\" :title=\"t('Reset player passwords within the world')\" @click=\"resetKeys\" >{{ t(\"Reset Player Passwords\") }} </b-button> </b-col> </b-row> <!-- Tabs for Player Management vs User Assignment --> <b-card v-if=\"canAccessUserAssignment\" no-body class=\"mt-3\"> <b-tabs justified pills card content-class=\"mt-1\"> <!-- Player management tab --> <b-tab active> <template #title> <div class=\"d-inline-flex align-items-center\"> <b-img src=\"/images/the-forge-logo-32x32.png\" width=\"16\" height=\"16\" class=\"mr-1\"></b-img> <i class=\"fas fa-users mr-1\"></i> {{ t(\"Manage Players\") }} </div> </template> <game-configure-players-list :game=\"game\" @alert=\"alert\" @update=\"$emit('update', $event)\" @leave=\"$emit('leave', $event)\" ></game-configure-players-list> </b-tab> <!-- User management/assignment tab --> <b-tab> <template #title> <div v-if=\"game.manageUsers\" class=\"d-inline-flex align-items-center\"> <b-img src=\"/images/the-forge-logo-32x32.png\" width=\"16\" height=\"16\" class=\"mr-1\"></b-img> <i class=\"fas fa-random mr-1\"></i> <b-img src=\"/images/fvtt-d20-32x32.png\" width=\"16\" height=\"16\" class=\"mr-1\"></b-img> {{ t(\"Edit User Assignment\") }} </div> <div v-else class=\"d-inline-flex align-items-center\"> <b-img src=\"/images/fvtt-d20-32x32.png\" width=\"16\" height=\"16\" class=\"mr-1\"></b-img> <i class=\"fas fa-users mr-1\"></i> {{ t(\"Manage Users\") }} </div> </template> <user-manager-assign-players ref=\"playerAssigner\" :game=\"game\" @alert=\"alert\" @update=\"$emit('update', $event)\" @pending-assignments=\"pendingAssignments = $event\" @assigning=\"assigning = $event\" ></user-manager-assign-players> </b-tab> </b-tabs> </b-card> <!-- Player list, for users who can't access user assignment --> <div v-else> <game-configure-players-list :game=\"game\" @alert=\"alert\" @update=\"$emit('update', $event)\" @leave=\"$emit('leave', $event)\" ></game-configure-players-list> </div> </div> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> <b-button v-if=\"game.manageUsers && canAccessUserAssignment\" :variant=\"pendingAssignments ? 'success' : 'secondary'\" :disabled=\"assigning || !pendingAssignments\" @click=\"assignPlayers\" > <loading-indicator v-if=\"assigning\" tag=\"span\" small :label=\"t('Saving Assignments…')\"> </loading-indicator> <span v-else>{{ t(\"Save Assignments\") }}</span> </b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-configure-players .player-config-list { overflow: hidden; }"
    });
  },
  props: {
    value: Boolean,
    game: Object
  },
  data() {
    return {
      invitationInputType: "password",
      releaseFocus: false,
      // Release focus so query dialogs don't cause stack depth errors
      mode: "players",
      // "players" or "assignments"
      manageUsers: false,
      alertData: {
        show: false,
        variant: "info",
        message: ""
      },
      pendingAssignments: false,
      assigning: false
    };
  },
  watch: {
    manageUsers(value) {
      if (value !== this.game.manageUsers) {
        this.toggleManager(value);
        this.$nextTick(() => this.manageUsers = this.game.manageUsers);
      }
    },
    game() {
      this.manageUsers = this.game.manageUsers;
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.mode = "players";
        this.alertData = {
          show: false,
          variant: "info",
          message: ""
        };
        this.$emit("input", value);
      }
    },
    player() {
      return this.game.players.find(p => p.id === this.game.playerId);
    },
    canAccessUserAssignment() {
      return !this.game.table && this.game.owner || this.game.manageUsers && this.player && this.player.role === "gm";
    },
    invitationLink() {
      if (!this.game.invite) {
        return "";
      }
      return `https://${window.location.host}/invite/${this.game.slug}/${this.game.invite}`;
    },
    playerMode() {
      return this.mode === "players";
    },
    assignmentMode() {
      return this.mode === "assignments";
    }
  },
  methods: {
    dismissPopovers() {
      this.$root.$emit("bv::hide::popover");
    },
    alert(alertData) {
      this.alertData = {
        ...alertData
      };
    },
    copyInvite() {
      navigator.clipboard.writeText(this.invitationLink);
      this.dismissPopovers();
      clearTimeout(this.popover_show_timeout);
      clearTimeout(this.popover_hide_timeout);
      this.popover_show_timeout = setTimeout(() => this.$root.$emit("bv::show::popover", `invite-${this._uid}`), 300);
      this.popover_hide_timeout = setTimeout(() => this.$root.$emit("bv::hide::popover", `invite-${this._uid}`), 3000);
    },
    async toggleManager(enable) {
      this.releaseFocus = true;
      const result = await UI.query(enable ? t("Enable User Manager") : t("Disable User Manager"), enable ? `${t("Are you sure you want to enable the User Manager?")}
        <ul>
          <li>${t("The game server will be shut down.")}</li>
          <li>${t("Any existing Foundry user that was not previously created by the User Manager will be disabled. You can map your players to the existing users if needed.")}</li>
          <li>${t("The game's privacy mode will be set to Private.")}</li>
        </ul>` : `${t("Are you sure you want to disable the User Manager?")}
        <ul>
          <li>${t("The game server will be shut down.")}</li>
          <li>${t("All users that were created by the User Manager will be disabled.")}</li>
        </ul>`, {
        buttons: [{
          id: "toggle-manager-no",
          type: "secondary",
          label: t("Cancel"),
          response: "no"
        }, {
          id: "toggle-manager-yes",
          type: enable ? "success" : "danger",
          label: enable ? t("Enable User Manager") : t("Disable User Manager"),
          response: "yes"
        }]
      });
      this.releaseFocus = false;
      if (result === "yes") {
        const response = await Utils.api("game/configure", {
          game: this.game.slug,
          manageUsers: enable
        });
        if (response.error) {
          this.alertData = {
            show: true,
            variant: "danger",
            message: enable ? t(`Error enabling the User Manager: {{- error}}`, {
              error: response.error
            }) : t(`Error disabling the User Manager: {{- error}}`, {
              error: response.error
            })
          };
        } else {
          this.$emit("update", {
            slug: this.game.slug,
            game: response.game
          });
        }
      }
    },
    async resetKeys() {
      this.releaseFocus = true;
      const result = await UI.query(t("Reset Player Passwords"), `${t("Are you sure you want to reset the player passwords in Foundry?")}
      <ul>
        <li>${t("The game server will be shut down.")}</li>
        <li>${t("All Foundry passwords will be reset, allowing all users (including GMs!) to log in without a password until new passwords are set within Foundry's User Management.")}</li>
      </ul>`, {
        buttons: [{
          id: "reset-keys-no",
          type: "secondary",
          label: t("Cancel"),
          response: "no"
        }, {
          id: "reset-keys-yes",
          type: "danger",
          label: t("Reset Player Passwords"),
          response: "yes"
        }]
      });
      this.releaseFocus = false;
      if (result === "yes") {
        const response = await Utils.api("game/players", {
          game: this.game.slug,
          action: "reset"
        });
        if (response.error) {
          this.alertData = {
            show: true,
            variant: "danger",
            message: t(`Error resetting access keys: {{- error}}`, {
              error: response.error
            })
          };
        } else {
          this.alertData = {
            show: true,
            variant: "success",
            message: t(`All player access keys have been reset`)
          };
        }
      }
    },
    toggleMode() {
      this.mode = this.playerMode ? "assignments" : "players";
    },
    assignPlayers() {
      if (!this.$refs.playerAssigner) {
        return;
      }
      this.$refs.playerAssigner.assignPlayers();
    }
  },
  mounted() {
    this.manageUsers = this.game.manageUsers;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameConfigurePlayersList"] = Vue.component(
                    "GameConfigurePlayersList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"forge-configure-players-list\"> <strong>{{ t(\"Players:\") }}</strong> {{ game.players.length }} <help-icon :tooltip=\"editTooltip\"></help-icon> <!-- Search bar for games with lots of players --> <b-input-group v-if=\"game.players.length >= searchThreshold\"> <b-form-input v-model=\"searchPlayers\" type=\"search\" :placeholder=\"t('Find players')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> <b-list-group class=\"mt-2 text-body\"> <transition-group enter-active-class=\"animate__animated animate__faster config-player-list-shrink-in-down\" leave-active-class=\"animate__animated animate__faster config-player-list-shrink-out-up\" > <b-list-group-item v-for=\"player in filteredPlayers\" :key=\"player.id\"> <b-row align-v=\"center\"> <b-col cols=\"0\" sm=\"2\" class=\"p-0 d-none d-sm-block\"> <template v-if=\"player.avatar\"> <b-img :id=\"`player-avatar-${player.id}`\" thumbnail rounded :src=\"player.avatar\" :alt=\"player.name\" width=\"40\" center > </b-img> <b-popover :target=\"`player-avatar-${player.id}`\" boundary=\"window\" triggers=\"hover\" placement=\"right\"> <b-img thumbnail :src=\"player.avatar\"></b-img> </b-popover> </template> <b-img v-else :id=\"`player-avatar-${player.id}`\" thumbnail rounded :src=\"randomAvatarImage()\" :alt=\"player.name\" width=\"40\" center > </b-img> </b-col> <b-col cols=\"8\" sm=\"6\" lg=\"8\"> <player-name-input :player=\"player\" :editable=\"canEditName(player)\" :processing=\"nameUpdating(player)\" @change=\"editPlayerName(player, $event)\" ></player-name-input> <div> <i18n :path=\"t('{{count}} hours', { count: player.usage })\"></i18n> </div> </b-col> <b-col cols=\"2\" lg=\"1\" class=\"p-0\"> <b-img :id=\"`player-role-${player.id}`\" v-b-tooltip.hover.top=\"roleName(player.role)\" :src=\"roleImg(player.role)\" class=\"role-img\" :alt=\"roleName(player.role)\" width=\"24\" center > </b-img> <b-popover v-if=\"isGM\" :target=\"`player-role-${player.id}`\" boundary=\"window\" triggers=\"click\" placement=\"left\" > <small v-for=\"target of ['gm', 'assistant', 'trusted', 'player']\" :key=\"target\" class=\"d-block\"> <a v-if=\"player.role !== target\" href=\"#\" @click.prevent=\"changeRole(player, target)\"> <b-img :src=\"roleImg(target)\" width=\"24\"> </b-img> &nbsp; <i18n :path=\"t('PROMOTE_PLAYER_ROLE_A_TO_B')\"> <span>{{ rolePromoteText(player.role, target) }}</span> <span>{{ roleName(target) }}</span> </i18n> </a> </small> <span v-if=\"!game.manageUsers\"> <b-img src=\"/images/warning.png\" width=\"16\"> </b-img> {{ t(\"Role changes will have no effect in Foundry while the User Manager is disabled.\") }} </span> </b-popover> </b-col> <b-col v-if=\"!player.owner && (isGM || player.id === game.playerId)\" cols=\"2\" lg=\"1\" class=\"text-center\"> <a href=\"#\" class=\"text-danger delete-player\" @click.prevent=\"deletePlayer(player)\"> <i v-b-tooltip.hover.top class=\"fas fa-trash-alt\" :title=\"kickTooltip(player)\"></i> </a> </b-col> </b-row> </b-list-group-item> </transition-group> </b-list-group> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".forge-configure-players-list .role-img { cursor: pointer; } .forge-configure-players-list .delete-player { font-size: 1.3em; } .config-player-list-shrink-in-down { animation: config-player-list-shrink-in-down; overflow-y: hidden; } .config-player-list-shrink-out-up { animation: config-player-list-shrink-in-down reverse; overflow-y: hidden; } @keyframes config-player-list-shrink-in-down { 0% { height: 0; padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; } 100% { height: 4.85em; } }"
    });
  },
  props: {
    game: Object
  },
  data() {
    return {
      updatingPlayer: null,
      searchPlayers: ""
    };
  },
  computed: {
    searchThreshold() {
      return 10;
    },
    player() {
      return this.game.players.find(p => p.id === this.game.playerId);
    },
    isGM() {
      return this.game.owner || this.player && this.player.role === "gm";
    },
    editTooltip() {
      if (this.isGM) {
        return t("Click the player's name or the dice to change their display name or role");
      }
      return t("Click on your name to edit it");
    },
    filteredPlayers() {
      if (this.game.players.length < this.searchThreshold) {
        return this.game.players;
      }
      const search = this.searchPlayers.trim().toLowerCase();
      return this.game.players.filter(p => p.name.toLowerCase().includes(search));
    }
  },
  methods: {
    kickTooltip(player) {
      if (player.id === this.game.playerId) {
        return t("Leave Game");
      }
      return t("Kick player");
    },
    async deletePlayer(player) {
      if (player.id === this.game.playerId) {
        return this.$emit("leave");
      }
      const result = await UI.query(t(`Kick player from this game`), t(`Are you sure you want to remove {{- name}} from this game?<br/>Your Game Invitation link will automatically be reset.`, {
        name: `“<strong>${Utils.escapeHTML(player.name)}</strong>”`
      }), {
        buttons: [{
          id: "kick-player-no",
          type: "success",
          label: t("Cancel"),
          response: "no"
        }, {
          id: "kick-player-yes",
          type: "danger",
          label: t(`Kick player`),
          response: "yes"
        }]
      });
      if (result === "yes") {
        const response = await Utils.api("game/players", {
          game: this.game.slug,
          action: "rm",
          player: player.id
        });
        if (response.error) {
          this.$emit("alert", {
            show: true,
            variant: "danger",
            message: t(`Error removing player from game: {{- error}}`, {
              error: response.error
            })
          });
        } else {
          this.$emit("update", {
            slug: this.game.slug,
            game: response.game
          });
        }
      }
    },
    roleImg(role) {
      return Games.roleImg(role);
    },
    roleName(role) {
      return Games.roleName(role);
    },
    rolePromoteText(role, to) {
      switch (role) {
        case "gm":
          return t("Demote");
        case "assistant":
          if (to === "gm") {
            return t("Promote");
          }
          return t("Demote");
        case "trusted":
          if (to === "player") {
            return t("Demote");
          }
          return t("Promote");
        case "player":
        default:
          return t("Promote");
      }
    },
    async changeRole(player, role) {
      const response = await Utils.api("game/players", {
        game: this.game.slug,
        action: "role",
        role,
        player: player.id
      });
      if (response.error) {
        this.$emit("alert", {
          show: true,
          variant: "danger",
          message: t(`Error setting role: {{- error}}`, {
            error: response.error
          })
        });
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
    },
    async editPlayerName(player, event) {
      const newName = event.newValue;
      if (newName === player.name) {
        this.updatingPlayer = null;
        return;
      }
      this.updatingPlayer = player.id;
      const response = await Utils.api("game/players", {
        game: this.game.slug,
        action: "name",
        name: newName,
        player: player.id
      });
      if (response.error) {
        UI.alert("danger", t(`Error changing name: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
      this.updatingPlayer = null;
    },
    canEditName(player) {
      return !(this.updatingPlayer === player.id) && (this.isGM || player.id === this.game.playerId);
    },
    nameUpdating(player) {
      return this.updatingPlayer === player.id;
    },
    randomAvatarImage() {
      const idx = Math.floor(1 + Math.random() * 3);
      return `/images/avatars/Goblin${idx}.png`;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameLaunch"] = Vue.component(
                    "GameLaunch",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _socket = _interopRequireDefault(require("socket.io-client"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = {
  template: "<div class=\"game-launch\"> <b-card> <template #header> <h3 class=\"text-center\">{{ gameTitle }}</h3> </template> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fadeIn\" leave-active-class=\"animate__animated animate__fadeOut\" > <b-alert :show=\"!!error\" variant=\"danger\">{{ error }}</b-alert> </transition> <b-row> <b-col class=\"d-none d-lg-flex justify-content-end pt-0 pr-3 pl-3 pb-3\"> <img v-if=\"gameBanner\" :src=\"gameBanner\" class=\"game-launch__banner\" alt=\"Game Banner\" /> </b-col> <b-col class=\"d-flex flex-column justify-content-center\"> <h5 v-if=\"!error\" class=\"text-center\"> {{ t(\"Please wait while your game is launched…\") }} </h5> <h5 v-else class=\"text-center text-danger\"> <i class=\"fas fa-exclamation-triangle text-danger\"></i> {{ t(\"Foundry failed to launch. Click below to go back.\") }} </h5> <div class=\"d-flex flex-row justify-content-center\"> <ul v-if=\"!error\" class=\"game-launch__steps\"> <li v-for=\"(step, index) in steps\" :key=\"index\"> <i v-if=\"currentStep !== index\" :class=\"[ 'fas', 'fa-check-circle', { 'text-success': currentStep > index }, { 'text-secondary': currentStep <= index }, ]\" ></i> <div v-else class=\"spinner-border text-success\"></div> <span v-if=\"currentStep <= index\">{{ step.pre }}</span> <span v-else>{{ step.post }}</span> </li> </ul> <b-button v-else variant=\"primary\" :href=\"`/games`\">{{ t(\"Return to Game List\") }}</b-button> </div> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\"> <b-button v-if=\"currentStep === steps.length\" variant=\"success\" :href=\"gameUrl\"> {{ t(\"Go To Game\") }} </b-button> </transition> </b-col> </b-row> <div v-if=\"!error && !isPreV11\" class=\"game-launch__progress\"> <b-progress :value=\"stepProgress\" :max=\"100\" :label=\"stepLabel\" class=\"game-launch__progress-step\" variant=\"success\" ></b-progress> <b-progress :value=\"overallProgress\" :max=\"100\" :label=\"t('Launch progress')\" class=\"game-launch__progress-overall\" variant=\"success\" ></b-progress> <label class=\"text-center\">{{ overallProgressLabel }}</label> </div> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-launch{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%}.game-launch .card{min-width:400px;width:80%}.game-launch__banner{max-width:100%;max-height:60vh;border-radius:10px;object-fit:cover}.game-launch__steps{list-style-type:none}.game-launch__steps .spinner-border{width:1rem;height:1rem}.game-launch__progress{position:relative}.game-launch__progress label{position:absolute;margin:0;font-size:1.3em;bottom:0;left:50%;transform:translateX(-50%)}.theme--slate .game-launch__progress label{color:#fff}.game-launch__progress-step{border-bottom-left-radius:0;border-bottom-right-radius:0;transition:width .2s ease}.game-launch__progress-overall{border-top-left-radius:0;border-top-right-radius:0;height:2rem;transition:width .2s ease}"
    });
  },
  props: {
    initialGame: {
      type: Object,
      default: () => ({})
    },
    fvttVersion: {
      type: String,
      default: ""
    },
    setupMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      game: null,
      socket: null,
      currentStep: 0,
      stepProgress: 0,
      overallProgress: 0,
      error: null
    };
  },
  computed: {
    gameTitle() {
      return this.game?.title || "Unknown Game";
    },
    gameBanner() {
      return this.game?.banner || "";
    },
    gameUrl() {
      if (!this.game) {
        return "";
      }
      return this.game.url;
    },
    isPreV11() {
      return Utils.compareFoundryVersions(this.fvttVersion, "11.0.0") < 0;
    },
    isV11() {
      return Utils.compareFoundryVersions(this.fvttVersion, "11.0.0") > 0 && Utils.compareFoundryVersions(this.fvttVersion, "12.0.0") < 0;
    },
    isV12Plus() {
      return Utils.compareFoundryVersions(this.fvttVersion, "12.0.0") >= 0;
    },
    steps() {
      // All versions of Foundry use this step - it's our step for starting the Foundry process
      const steps = [{
        step: "startFoundry",
        pre: t("Waiting for Foundry to start…"),
        post: t("Connected to Foundry")
      }];
      if (this.setupMode) {
        // If we are not launching into a world, we don't need any more steps
        return steps;
      }
      if (this.isPreV11) {
        // For Foundry v10 and earlier, we use essentially the same steps as v11
        // However, connectWorld won't actually receive progress reports. The progress
        // bar will jump to 100% once the world is launched.
        steps.push({
          step: "connectWorld",
          pre: t("Loading world data…"),
          post: t("World is ready!")
        });
        return steps;
      }
      if (this.isV11) {
        // Foundry v11 reports progress on world data loading
        steps.push({
          step: "connectWorld",
          pre: t("Loading world data…"),
          post: t("World is ready!")
        });
      }
      if (this.isV12Plus) {
        // Foundry v12+ reports progress on several more steps of the world launch process
        steps.push({
          step: "connectWorld",
          pre: t("Loading world data…"),
          post: t("World data loaded")
        }, {
          step: "migrateWorld",
          pre: t("Migrating world data…"),
          post: t("World data migrated")
        }, {
          step: "connectPackage",
          pre: t("Loading package data…"),
          post: t("Package data loaded")
        }, {
          step: "migratePackage",
          pre: t("Migrating package data…"),
          post: t("Package data migrated")
        });
      }
      return steps;
    },
    stepLabel() {
      return this.steps[this.currentStep]?.pre || "";
    },
    overallProgressLabel() {
      return Math.floor(this.overallProgress) + "%";
    }
  },
  methods: {
    socketConnect() {
      if (!this.game) {
        console.error("No game to connect to");
        return;
      }
      if (this.socket) {
        console.log("Connecting existing socket to:", this.gameUrl);
        this.socket.connect();
        return;
      }
      console.log("Connecting socket to:", this.gameUrl);
      this.socket = (0, _socket.default)(this.gameUrl, {
        path: "/socket.io",
        transports: ["websocket"],
        upgrade: false,
        reconnection: true,
        forceNew: true,
        autoConnect: true,
        cookie: false
      });
      this.socket.on("connect", () => {
        console.log("Connected to FVTT socket");
        this.currentStep = 1;
      });
      this.socket.on("disconnect", () => {
        console.log("Disconnected from FVTT socket");
      });
      this.socket.on("progress", this.progressMessage);
      this.socket.open();
    },
    progressMessage(message) {
      if (!message.action === "launchWorld" || !message.step ||
      // Percent is undefined or null for error and complete messages
      !["error", "complete"].includes(message.step) && !message.pct && message.pct !== 0) {
        console.error("Invalid launch progress message:", message);
        return;
      }
      if (message.step === "complete") {
        this.currentStep = this.steps.length;
        this.stepProgress = 100;
        this.overallProgress = 100;
        console.log("World launch complete, redirecting to game.");
        setTimeout(() => {
          this.redirectToGame();
        }, 1 * globalThis.SECOND_MS);
      } else if (message.step === "error") {
        this.error = message.message || t("Foundry failed to launch.");
        this.socket.disconnect();
      } else {
        this.currentStep = this.steps.findIndex(step => step.step === message.step);
        this.stepProgress = parseInt(message.pct);
        this.overallProgress = this.currentStep * (100 / this.steps.length) + message.pct / this.steps.length;
      }
    },
    redirectToGame() {
      window.location.href = this.gameUrl;
    },
    async checkGameInfoApi() {
      // Periodically check /game/info/:slug to see if the game is already running
      // This is a fallback in case something weird happens with the websocket,
      //    or if this game is too old to provide the world launch websocket messages.
      try {
        const response = await Utils.api(`launch/info/${this.game.slug}`);
        if (!response || !response.status) {
          throw new Error("Invalid response from game launch info API");
        }
        if (response.status === "online") {
          // Change the UI to show the game is already running
          this.currentStep = this.steps.length;
          this.stepProgress = 100;
          this.overallProgress = 100;
          // Redirect to game immediately
          this.redirectToGame();
        } else if (["starting", "idle"].includes(response.status)) {
          const task = response.task;
          if (!task) {
            throw new Error(t("No task provided in game info response"));
          }
          if (task.status === "error") {
            // If the task is errored, show an error alert
            this.error = task.result?.error || t("Foundry failed to launch.");
            this.socket.disconnect();
          } else if (task.status === "launchWorld" && !this.socket?.connected) {
            // Once the task is starting Foundry, initiate websocket connection
            this.socketConnect();
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!this.error) {
          // Check again in 2 seconds
          setTimeout(this.checkGameInfoApi, 2 * globalThis.SECOND_MS);
        }
      }
    }
  },
  created() {
    this.game = this.initialGame;
    // checkGameInfoApi will initiate the socket connection once the start task has reached launchWorld
    this.checkGameInfoApi();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameList"] = Vue.component(
                    "GameList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-row class=\"game-header\"> <b-col><!-- This is just here for padding to balance the filter field --></b-col> <b-col class=\"text-center\"> <h2>{{ t(\"Your Games\") }}</h2> <p>{{ t(\"Select the game you would like to play.\") }}</p> </b-col> <b-col class=\"d-flex align-items-center justify-content-end game-list__controls\"> <search-button v-model=\"filter\" title=\"Filter Games\" position=\"left\" :autohide=\"false\"></search-button> <b-button v-b-tooltip.hover.top.viewport squared variant=\"outline-info\" :pressed=\"shouldDisplayNewGame\" :title=\"t('CreateANewGame')\" @click=\"createGame\" > <i class=\"fas fa-fw fa-plus\"></i> </b-button> </b-col> </b-row> <b-container fluid style=\"padding: 0\"> <b-alert v-if=\"loading\" show class=\"notification-alert\"> <loading-indicator class=\"d-sm-block d-md-none\" small :label=\"t('Loading…')\"></loading-indicator> <loading-indicator class=\"d-none d-md-block\" small :label=\"t('Loading your Games, thank you for your patience')\" ></loading-indicator> </b-alert> <b-skeleton-wrapper :loading=\"loading\"> <template #loading> <div :class=\"cardDeckClass\"> <b-card v-for=\"n in skeletonLength\" :key=\"n\" :class=\"`mb-3 foundry-game-skeleton border-primary game-card game-card-${ horizontalGame ? 'horizontal' : 'vertical' }`\" style=\"min-width: 335px; height: calc(100vh - 1em - 11.9rem)\" no-body > <b-skeleton-img></b-skeleton-img> <b-card-body> <b-skeleton width=\"85%\"></b-skeleton> <b-skeleton width=\"55%\"></b-skeleton> <b-skeleton width=\"70%\"></b-skeleton> </b-card-body> </b-card> </div> </template> <transition-group tag=\"div\" name=\"flip-list\" :class=\"cardDeckClass\"> <game-card v-for=\"game of sortedGames\" :key=\"game.slug\" class=\"mb-3\" style=\"min-width: 335px; height: calc(100vh - 1em - 11.9rem)\" :game=\"game\" :horizontal=\"horizontalGame\" @update=\"updateGame\" ></game-card> </transition-group> </b-skeleton-wrapper> </b-container> <b-modal v-model=\"shouldDisplayNewGame\" v-b-modal.modal-center scrollable size=\"xl\" :title=\"t('CreateANewGame')\" :ok-disabled=\"isCreateAllowed\" :ok-only=\"!manageGames\" dialog-class=\"game-manager-new-game-modal\" @ok.prevent=\"onCreateOk\" @shown=\"$refs.newGameDialog && $refs.newGameDialog.reset\" > <new-game-form v-if=\"manageGames\" ref=\"newGameDialog\" @created=\"newGameCreated\" @reload=\"reloadGames\" @loading=\"onCreatingNewGame\" @loaded=\"onFinishedCreatingNewGame\" /> <div v-else> <p> {{ t( `To create a new game, first open your Foundry installation in your browser. If you are brought to the login screen for an existing game, click \"Return to Setup\". Once at your setup screen, find the \"Create World\" button. On older versions of Foundry, this button can be found at the bottom of your game list; on newer versions, it can be found toward the top. Once you click this button, you can create a new game.` ) }} </p> <i18n v-if=\"canEnableGameManager\" :path=\"t('Want to make managing your games even easier? Enable {0} to manage games from the Forge!')\" tag=\"p\" > <a href=\"/setup#manager=1\">{{ t(\"Game Management\") }}</a> </i18n> <i18n v-else :path=\" t( `Want to make managing your games even easier? Upgrade to the Story Teller tier or higher and enjoy access to {0} from the Forge!` ) \" tag=\"p\" > <a href=\"https://forums.forge-vtt.com/docs?topic=11004\" target=\"_blank\">{{ t(\"Game Management\") }}</a> </i18n> </div> <template slot=\"modal-ok\"> <span v-if=\"!isCreatingANewGame\">{{ t(\"OK\") }}</span> <loading-indicator v-else tag=\"span\" small></loading-indicator> </template> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-list__controls { gap: 0.5em; } .flip-list-move { transition: transform 0.5s; } .game-header .col { min-width: 350px; } @media (min-width: 700px) and (max-width: 1099px) { .game-header .col { min-width: unset; } } .foundry-game-skeleton { min-width: 335px; height: calc(100vh - 1em - 11.9rem); }"
    });
  },
  props: {
    canEnableGameManager: Boolean,
    manageGames: Boolean,
    initialGames: Array
  },
  data() {
    return {
      games: [],
      filter: "",
      loading: true,
      shouldDisplayNewGame: false,
      isCreatingANewGame: false
    };
  },
  computed: {
    horizontalGame() {
      return this.games.length < 3;
    },
    filteredGames() {
      if (!this.filter) {
        return this.games;
      }
      const filter = this.filter.toLowerCase();
      return this.games.filter(g => {
        return g.title.toLowerCase().includes(filter) || (g.world || "").toLowerCase().includes(filter);
      });
    },
    sortedGames() {
      return this.games && Utils.sortGames(this.filteredGames);
    },
    cardDeckClass() {
      if (this.loading) {
        return `card-deck${this.initialGames.length > 3 ? " card-deck-grid" : ""}`;
      }
      return `card-deck${this.games.length > 3 ? " card-deck-grid" : ""}`;
    },
    skeletonLength() {
      return this.initialGames.length || 10;
    },
    isCreateAllowed() {
      if (!this.$refs.newGameDialog) {
        return false;
      }
      return this.$refs.newGameDialog.canSubmit;
    }
  },
  methods: {
    onCreateOk() {
      this.isCreatingANewGame = false;
      if (!this.$refs.newGameDialog) {
        if (!this.isCreateAllowed) {
          // If you can't create a new game from here, close the dialog.
          this.shouldDisplayNewGame = false;
        }
        return;
      }
      this.$refs.newGameDialog.create();
    },
    onCreatingNewGame() {
      this.isCreatingANewGame = true;
    },
    onFinishedCreatingNewGame() {
      this.isCreatingANewGame = false;
    },
    createGame() {
      this.shouldDisplayNewGame = true;
    },
    async reloadGames() {
      const list = await Utils.api("game/list");
      this.games = list && list.games ? list.games : this.games;
      this.loading = false;
      this.shouldDisplayNewGame = false;
    },
    updateGame(game) {
      const idx = this.games.findIndex(g => g.slug === game.slug);
      if (idx !== -1) {
        this.games.splice(idx, 1, game);
      }
    },
    newGameCreated(game) {
      this.games.push(game);
      this.games = Utils.sortGames(this.games);
      this.shouldDisplayNewGame = false;
      this.isCreatingANewGame = false;
    }
  },
  async created() {
    await Utils.loadDependencies(["simple-markdown", "rrule"]);
    if (this.initialGames) {
      this.games = this.initialGames;
      this.loading = false;
    } else {
      this.reloadGames();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameManagerTab"] = Vue.component(
                    "GameManagerTab",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <div v-if=\"!manageGames\"> <p> {{ t( \"You can choose The Forge's simple hosting service where one Game URL points to your Foundry Server, similar to a self hosted experience, or you can choose to use The Forge's Game Management service where each Foundry World will be given its own unique URL with its own configuration and set of invited players.\" ) }} </p> <i18n :path=\" t( `With The Forge's Game Management {0} enabled, you'll have a true cloud experience, your server will automatically switch to the correct world based on the URL your players are accessing. You will never need to 'Go back to Setup' ever again!` ) \" tag=\"p\" > <help-icon url=\"https://forums.forge-vtt.com/t/the-game-manager/11004\" :tooltip=\"t('Learn more about the Game Manager')\" ></help-icon> </i18n> <i18n :path=\" t( `The Game Manager also allows the use of the Forge's User Management {0} feature which allows you to login into your games automatically and manages the users based on who was invited.` ) \" tag=\"p\" > <help-icon url=\"https://forums.forge-vtt.com/t/the-user-manager/11039\" :tooltip=\"t('Learn more about the User Manager')\" ></help-icon> </i18n> <p> <em ><i18n :path=\"t(`This feature is only available to users of Story Teller {0} tier and higher.`)\" tag=\"p\"> <tier-badge-icon :tier=\"3\"></tier-badge-icon> </i18n ></em> </p> <div class=\"text-center\"> <b-button variant=\"success\" size=\"lg\" @click=\"toggleGameManager\">{{ t(\"Enable Game Management\") }}</b-button> </div> </div> <div v-else> <b-form-group label-cols-lg=\"3\" size=\"sm\"> <template #label> {{ t(\"The Forge's Game manager is enabled\") }}&nbsp; <help-icon url=\"https://forums.forge-vtt.com/t/the-game-manager/11004\" :tooltip=\"t('Learn more about the Game Manager')\" ></help-icon> </template> <b-button size=\"sm\" variant=\"danger\" @click=\"toggleGameManager\">{{ t(\"Disable Game Management\") }}</b-button> </b-form-group> <!-- Foundry Version --> <b-form-group label-cols-lg=\"3\" size=\"sm\"> <template #label> {{ t(\"Select the default Foundry VTT Version for your games:\") }} </template> <div> <b-form-select v-model=\"version\" size=\"sm\" :options=\"versionOptions\" class=\"version-selection\" ></b-form-select> <!-- If the version is modified, it will get automatically saved --> <span v-show=\"isVersionModified\" class=\"mx-5\"> <b-spinner small label=\"Saving setting…\"></b-spinner> <span>{{ t(\"Saving setting…\") }}</span> </span> </div> <div class=\"mt-3\"> <a href=\"https://forums.forge-vtt.com/t/foundry-vtt-version-selection/16637\" target=\"_blank\" ><i class=\"fas fa-question-circle\"></i> {{ t(\"Click here for more information about Foundry VTT versions\") }}</a > </div> <div v-if=\"table.lastVersion && !isVersionModified\" class=\"mt-3\"> <i18n :path=\"t('Last Foundry VTT version used on this release channel: {0}')\"> <strong>{{ table.lastVersion }}</strong> </i18n> <span v-if=\"fvttHasUpdate\"> &nbsp;<b-button tag=\"a\" variant=\"success\" size=\"sm\" href=\"/setup/foundry-update\" target=\"_blank\" ><i18n :path=\"t('Update to {{latestChannelVersion}}', { latestChannelVersion })\"></i18n> </b-button> </span> </div> <p class=\"mb-0\"> <small>{{ t(\"This will affect the available packages in the Bazaar.\") }}</small ><br /> <strong>{{ t(\"Due to module incompatibilities, it is recommended that all your games use the same Foundry version.\") }}</strong> </p> </b-form-group> <!-- Foundry options --> <b-form-group label-cols-lg=\"3\" size=\"sm\" :label=\"t('Foundry telemetry:')\"> <b-button :variant=\"`outline-${foundry_telemetry ? 'success' : 'danger'}`\" :disabled=\"showFoundryTelemetry\" @click=\"showFoundryTelemetry = true\" > {{ foundry_telemetry ? t(\"Enabled\") : t(\"Disabled\") }} </b-button> <foundry-telemetry v-model=\"showFoundryTelemetry\" @telemetry=\"foundry_telemetry = $event\"></foundry-telemetry> </b-form-group> <b-form-group label-cols-lg=\"3\" size=\"sm\" :label=\"t('Default Foundry VTT Theme:')\"> <b-form-select v-model=\"foundryCssTheme\" :options=\"foundryCssThemeOptions\"></b-form-select> <p> <small> <strong>{{ t(\"Note:\") }}</strong> {{ t( \"Themes will be active only where supported by the configured Foundry server version. Requires Foundry v11 or newer.\" ) }} </small> </p> </b-form-group> </div> <div v-if=\"manageGames\"> <div v-if=\"games.length\"> <transition-group tag=\"div\" name=\"flip-list\" :class=\"`card-deck${games.length > 3 ? ' card-deck-grid' : ''}`\"> <game-card v-for=\"game of sortedGames\" :key=\"game.slug\" :max-description=\"250\" :game=\"game\" :horizontal=\"false\" class=\"mb-3\" style=\"min-width: 250px\" > <template #footer> <div class=\"card-footer\"> <a :href=\"game.url\" class=\"btn btn-primary w-100\">{{ t(\"Launch\") }}</a> <a :href=\"`/setup#${game.slug}`\" class=\"btn btn-secondary w-100 mt-1\">{{ t(\"Configure\") }}</a> <a href=\"#\" class=\"btn btn-danger w-100 mt-1\" @click.prevent=\"gameToDelete = game\">{{ t(\"Delete\") }}</a> </div> </template> </game-card> </transition-group> </div> <div v-else class=\"border p-3\"> {{ t(\"You have no yet created any games. Create one now to start playing!\") }} <div class=\"text-center\"> <b-button variant=\"primary\" @click=\"$emit('create')\"> {{ t(\"Create Game\") }} </b-button> </div> </div> </div> <table-tool-delete-query v-model=\"showDeleteQuery\" :secret=\"querySecret\" :name=\"queryName\" :in-progress=\"deleteInProgress\" type=\"Game\" @delete=\"deleteGame\" ></table-tool-delete-query> <b-modal v-model=\"showToggleModal\" :title=\"t('Toggle Game Management')\" centered size=\"lg\" :ok-only=\"!canManage\" @ok=\"toggleOK\" > <div v-if=\"canManage\"> <div v-if=\"manageGames\"> <p> {{ t( \"Disabling the Game Management features will release all of your currently allocated Game URLs, and a single Game will become available to access your Foundry Server.\" ) }} </p> <p>{{ t(\"Players may need to be re-invited into the Foundry Game, and usage statistics may be reset.\") }}</p> </div> <div v-else> <p> {{ t( \"Enabling the Game Management features will create a new Forge Game for each of your Foundry Worlds, and your currently used Game URL will be released.\" ) }} </p> <p> {{ t(\"Players may need to be re-invited into the appropriate Games, and usage statistics may be reset.\") }} </p> <p> <em>{{ t(\"Reminder:\") }}</em> <i18n :path=\"t('Account sharing is not allowed on The Forge according to the {0}.')\"> <a href=\"/tos\" target=\"_blank\">{{ t(\"Terms of Service\") }}</a> </i18n ><br /> <i18n :path=\"t('Please refer to the {0} to see which specific use cases fall within acceptable use.')\"> <a href=\"/faq\" target=\"_blank\">{{ t(\"FAQ\") }}</a> </i18n> </p> </div> </div> <div v-else> <i18n :path=\" t( `You must be of Story Teller {0} tier of higher to be able to enable The Forge's Game Manager {1} features.` ) \" > <tier-badge-icon :tier=\"3\"></tier-badge-icon> <help-icon url=\"https://forums.forge-vtt.com/t/the-game-manager/11004\" :tooltip=\"t('Learn more about the Game Manager')\" ></help-icon> </i18n ><br /> <i18n :path=\"t('You can upgrade your account from your {0} page.')\"> <a href=\"/account\">{{ t(\"My Account\") }}</a> </i18n> </div> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".flip-list-move { transition: transform 0.5s; } .version-selection { max-width: 50rem; }"
    });
  },
  props: {
    games: Array,
    table: Object,
    fvttVersions: Object,
    canManage: Boolean,
    manageGames: Boolean
  },
  data() {
    return {
      manageGamesCheckbox: false,
      showToggleModal: false,
      gameToDelete: null,
      deleteInProgress: false,
      version: "",
      versionAlert: null,
      showFoundryTelemetry: false,
      foundry_telemetry: false,
      foundryCssTheme: ""
    };
  },
  watch: {
    manageGamesCheckbox(value) {
      if (value !== this.manageGames) {
        this.toggleGameManager();
      }
      this.$nextTick(() => this.manageGamesCheckbox = this.manageGames);
    },
    async version(value) {
      if (this.isVersionModified) {
        await this.saveVersion();
      }
    },
    async foundryCssTheme(value) {
      if (this.isFoundryCssThemeModified) {
        await this.saveFoundryCssTheme();
      }
    }
  },
  computed: {
    sortedGames() {
      return this.games && Utils.sortGames(this.games);
    },
    showDeleteQuery: {
      get() {
        return !!this.querySecret;
      },
      set(val) {
        if (!val) {
          this.gameToDelete = null;
        }
      }
    },
    querySecret() {
      return this.gameToDelete && this.gameToDelete.delete;
    },
    queryName() {
      return this.gameToDelete && this.gameToDelete.title;
    },
    versionOptions() {
      const specificVersions = this.fvttVersions.versions.map(v => ({
        value: v,
        text: v
      }));
      if (!this.fvttVersions.versions.includes(this.fvttVersion)) {
        specificVersions.push({
          value: this.fvttVersion,
          text: t("{{version}} (Deprecated)", {
            version: this.fvttVersion
          })
        });
      }
      return [{
        label: t("Automatically update games to:"),
        options: [{
          value: "recommended",
          text: t(`Forge Recommended ({{version}})`, {
            version: this.fvttVersions.channels.recommended
          })
        }, {
          value: "latest",
          text: t(`Latest Foundry VTT Release ({{version}})`, {
            version: this.fvttVersions.channels.latest
          })
        }]
      }, {
        label: t("Specific Foundry VTT Version:"),
        options: specificVersions
      }];
    },
    latestChannelVersion() {
      return this.fvttVersions.channels[this.table.version] || this.table.version;
    },
    fvttHasUpdate() {
      if (!this.table.lastVersion) {
        return false;
      }
      return this.table.lastVersion !== this.latestChannelVersion;
    },
    isVersionModified() {
      return this.table && this.table.version !== this.version;
    },
    fvttVersion() {
      if (!this.table) {
        return null;
      }
      return this.fvttVersions.channels[this.table.version] || this.table.version;
    },
    foundryCssThemeOptions() {
      // These themes were added in v11. The value must be accepted by Foundry, otherwise it errors and defaults.
      // Currently (v11), these themes only affect the setup and join screens.
      // The theme of the table will serve as the default theme for an individual game manager world.
      const themeOptions = [{
        value: "fantasy",
        text: t("FOUNDRY_CSS_THEME.fantasy", "Classic Fantasy")
      }, {
        value: "scifi",
        text: t("FOUNDRY_CSS_THEME.scifi", "Science Fiction")
      }];
      const defaultThemeValue = this.foundryCssTheme ? "foundry" : null;
      themeOptions.unshift({
        value: defaultThemeValue,
        text: t("FOUNDRY_CSS_THEME.foundry", "Foundry Virtual Tabletop")
      });
      return themeOptions;
    },
    isFoundryCssThemeModified() {
      return this.table && this.table.foundry_css_theme !== this.foundryCssTheme;
    }
  },
  methods: {
    toggleGameManager() {
      this.showToggleModal = true;
    },
    async toggleOK() {
      if (!this.canManage) {
        return;
      }
      const response = await Utils.api("game/manager", {
        enabled: !this.manageGames
      });
      if (response.error) {
        UI.alert("danger", response.error);
      } else {
        window.location.reload();
      }
    },
    async deleteGame(secret) {
      // Save the game before it gets set to null by the watch
      const gameToDelete = this.gameToDelete;
      console.log("Delete", gameToDelete, secret);
      if (!gameToDelete || !secret || gameToDelete.delete !== secret) {
        return;
      }
      if (gameToDelete.table || !gameToDelete.world) {
        return;
      }
      this.deleteInProgress = true;
      const response = await Utils.api(`data/worlds/delete`, {
        name: gameToDelete.world,
        secret
      });
      console.log("Delete response : ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`Game {{- title}} deleted successfully`, {
          title: `<strong>'${Utils.escapeHTML(gameToDelete.title)}'</strong>`
        }), true, 10000);
      }
      if (this.gameToDelete === gameToDelete) {
        this.gameToDelete = null;
      }
      this.$emit("change");
      this.deleteInProgress = false;
    },
    async saveVersion() {
      if (this.savingVersion) {
        return;
      }
      this.savingVersion = true;
      const response = await Utils.api("game/configure", {
        game: this.table.slug,
        version: this.version
      });
      this.savingVersion = false;
      if (response.error) {
        UI.alert("danger", t(`Error setting version: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.table.version = response.game.version;
        this.table.lastVersion = response.game.lastVersion;
      }
    },
    async saveFoundryCssTheme() {
      if (this.savingFoundryCssTheme) {
        return;
      }
      this.savingFoundryCssTheme = true;
      const response = await Utils.api("game/configure", {
        game: this.table.slug,
        foundryCssTheme: this.foundryCssTheme
      });
      this.savingFoundryCssTheme = false;
      if (response.error) {
        UI.alert("danger", t(`Error saving theme: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.table.foundry_css_theme = response.game.foundry_css_theme;
      }
    }
  },
  mounted() {
    this.manageGamesCheckbox = this.manageGames;
    this.version = this.table && this.table.version;
    this.foundryCssTheme = this.table && this.table.foundry_css_theme;
    if (this.fvttVersion && !this.fvttVersions.versions.includes(this.fvttVersion)) {
      this.versionAlert = UI.alert("warning", t(`Foundry VTT version <strong>{{version}}</strong> is now deprecated on The Forge. Please read this {{- guide}} and {{- backupLink}} before updating your Foundry VTT server to the next available version or higher.`, {
        version: this.fvttVersion,
        backupLink: `<a href="/setup/export" target="_blank">${t("back up your data")}</a>`,
        guide: `<a href="https://forums.forge-vtt.com/t/how-to-update-foundry-vtt-on-the-forge/14139" target="_blank">${t("guide")}</a>`
      }), true);
    }
  },
  async created() {
    await Utils.loadDependencies(["simple-markdown", "rrule"]);
    this.foundry_telemetry = !!this.table && this.table.foundry_telemetry;
  },
  destroyed() {
    if (this.versionAlert) {
      this.versionAlert.remove();
      this.versionAlert = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameSetup"] = Vue.component(
                    "GameSetup",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-container v-if=\"loaded\" fluid> <div v-if=\"canConfigure\"> <!-- Setup tools --> <game-setup-tools :game=\"game\" :worlds=\"worlds\" :modules=\"modules\" :explorer-mode=\"explorerMode\" :managing-games=\"manageGames\" :can-time-machine=\"canTimeMachine\" @change=\"reloadGames\" @update=\"updateGame\" @create=\"createGame\" @select=\"selectGame\" @gamesUpdated=\"handleGamesUpdated\" ></game-setup-tools> <!-- Main body --> <b-card no-body> <b-card-header class=\"game-setup-header d-flex flex-wrap flex-sm-nowrap p-2\"> <!-- New game button --> <b-button v-if=\"manageGames\" v-b-tooltip.hover.top.viewport squared variant=\"outline-primary\" :pressed=\"newGame\" :title=\"t('Create new Game')\" @click=\"createGame\" > <i class=\"fas fa-fw fa-plus\"></i> </b-button> <!-- Filter games --> <search-button v-if=\"manageGames\" v-model=\"filter\" :title=\"t('Filter Games')\"></search-button> <!-- Games list --> <vue-scroll :ops=\"scrollOps\" class=\"game-scroll-list\"> <div class=\"game-scroll-inner d-flex\"> <b-button v-for=\"g in filteredGames\" :key=\"g.slug\" squared class=\"p-2\" variant=\"outline-success\" :pressed=\"game && g.slug === game.slug\" @click=\"selectGame(g)\" > <game-status-indicator :status=\"g.status\"></game-status-indicator> {{ g.title }} <i v-if=\"g.favorite\" v-b-tooltip.hover.top.viewport class=\"fas fa-star favorite-star\" :title=\"t('Favorite Game!')\" ></i> </b-button> </div> </vue-scroll> <!-- Games Manager button --> <b-button squared variant=\"primary\" class=\"ml-auto game-manager-button\" @click=\"selectGame(null)\"> <img class=\"fa-fw fi-game-manager\" src=\"/images/icons/server-cog.svg\" /> <span class=\"d-none d-md-inline-block\">{{ t(\"Game Manager\") }}</span> </b-button> </b-card-header> <!-- Game Configuration / Game Manager --> <b-card-body> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" > <game-configuration v-if=\"game\" :game=\"game\" :table=\"table\" :fvtt-versions=\"fvttVersions\" :core-languages=\"coreLanguages\" @update=\"updateGame\" ></game-configuration> <game-manager-tab v-else-if=\"manager\" :can-manage=\"canManage\" :manage-games=\"manageGames\" :fvtt-versions=\"fvttVersions\" :games=\"games\" :table=\"table\" @change=\"reloadGames\" @create=\"createGame\" ></game-manager-tab> </transition> </b-card-body> </b-card> </div> <!-- Cannot configure --> <div v-else> <div class=\"border border-warning p-2\"> <i18n :path=\"t('You need a valid Game Master {0} or higher before you can configure your games.')\"> <a href=\"/account\">{{ t(\"subscription\") }}</a> </i18n> </div> <b-row> <b-col v-if=\"worlds.length\"> <b-button size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" @click=\"exportWorldsVisible = true\"> {{ t(\"Export Worlds\") }} </b-button> <table-tool-export v-model=\"exportWorldsVisible\" type=\"worlds\"></table-tool-export> </b-col> <b-col v-if=\"modules.length\"> <b-button size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" @click=\"exportCompendiumsVisible = true\"> {{ t(\"Export Compendium Modules\") }} </b-button> <table-tool-export v-model=\"exportCompendiumsVisible\" type=\"modules\"></table-tool-export> </b-col> <b-col v-if=\"worlds.length\"> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"warning\" class=\"mt-1 w-100\" :title=\"t('Select worlds, modules, systems and other files to delete from your Data folder')\" @click=\"deleteToolVisible = true\" > {{ t(\"View Data Storage\") }} </b-button> <table-tool-delete v-model=\"deleteToolVisible\"></table-tool-delete> </b-col> </b-row> <div v-if=\"canTryFoundry\" class=\"border border-success mt-3 p-2\"> {{ t( \"As a Forge user, you can try Foundry using a limited time License Key giving you full access to all Foundry features as well as The Forge Game Manager features.\" ) }} <explorer-mode-button></explorer-mode-button> </div> </div> <b-modal v-model=\"newGame\" v-b-modal.modal-center scrollable size=\"xl\" :title=\"t('CreateANewGame')\" :ok-disabled=\"isCreateAllowed\" dialog-class=\"game-manager-new-game-modal\" @ok.prevent=\"onCreateOk\" @shown=\"$refs.newGame && $refs.newGame.reset\" > <new-game-form ref=\"newGame\" @created=\"newGameCreated\" @loading=\"onCreatingNewGame\" @loaded=\"onFinishedCreatingNewGame\" @reload=\"reloadGames\" /> <template slot=\"modal-ok\"> <span v-if=\"!isCreatingANewGame\">{{ t(\"OK\") }}</span> <loading-indicator v-else tag=\"span\" small></loading-indicator> </template> </b-modal> <!-- Restart popup dialog --> <b-modal v-model=\"shouldRestartOnlineGames\" centered :title=\"t('Attention: Server Restart Required')\" :no-close-on-backdrop=\"restartGamesInProgress\" :no-close-on-esc=\"restartGamesInProgress\" @hide=\"preventModalClose\" > <div> <div class=\"restart-server-text-container\"> <i v-if=\"!restartGamesComplete && !restartGamesInProgress\" class=\"fas fa-exclamation-triangle text-warning fa-2x\" ></i> <i v-if=\"restartGamesComplete\" class=\"fas fa-check text-success fa-2x\"></i> <p v-if=\"!restartGamesInProgress && !restartGamesComplete && !restartErrorMessage\"> {{ t( \"You are about to initiate a server restart. This action will temporarily halt all current gaming sessions. The restart is necessary to apply new modules changes.\" ) }} </p> <p v-if=\"restartGamesComplete && !restartErrorMessage\"> {{ t(\"All your online games have successfully restarted.\") }} </p> <p v-if=\"restartErrorMessage\">{{ t(\"Error restarting games: \") }}{{ restartErrorMessage }}</p> <loading-indicator v-if=\"restartGamesInProgress\" :label=\"t('Restarting online games, please wait…')\" ></loading-indicator> </div> </div> <template #modal-footer> <b-button :disabled=\"restartGamesInProgress\" @click=\"cancel()\"> <span v-if=\"!restartGamesComplete\">{{ t(\"Cancel\") }}</span> <span v-else>{{ t(\"Close\") }}</span> </b-button> <b-button v-if=\"!restartGamesComplete\" :disabled=\"restartGamesInProgress\" variant=\"warning\" @click=\"onRestart()\" > <i class=\"fas fa-refresh\"></i> {{ t(\"Restart\") }} </b-button> </template> </b-modal> </b-container>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-setup-header, .game-setup-header .game-scroll-inner { gap: 0.5rem; } .game-setup-header .game-scroll-list .game-scroll-inner { white-space: nowrap; } .game-setup-header button, .game-setup-header input { box-shadow: none !important; } @media screen and (min-width: 768px) { .game-setup-header .game-manager-button { white-space: pre; } } .game-setup-header .game-scroll-list { overflow: clip visible !important; min-width: 0; } @media screen and (max-width: 575px) { .game-setup-header .game-scroll-list { order: 1; flex: 0 0 100%; } } .game-setup-header .game-scroll-list .__rail-is-horizontal { bottom: -7px !important; } .game-setup-header .game-scroll-list .__bar-is-horizontal { background: var(--info) !important; } .fi-game-manager { padding-bottom: 0.2em; /* Font baseline */ filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3)); } .restart-server-text-container { display: flex; align-items: center; > p { margin: 0.75em; } }"
    });
  },
  props: {
    initialGames: {
      type: Array,
      required: true
    },
    initialTable: {
      type: Object,
      required: false,
      default: null
    },
    worlds: {
      type: Array,
      required: true
    },
    modules: {
      type: Array,
      required: true
    },
    canConfigure: Boolean,
    canManage: Boolean,
    canTimeMachine: Boolean,
    manageGames: Boolean,
    canTryFoundry: Boolean,
    explorerMode: Boolean,
    fvttVersions: {
      type: Object,
      required: true
    },
    coreLanguages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      games: null,
      table: null,
      game: null,
      manager: false,
      newGame: false,
      hash: null,
      filter: "",
      exportWorldsVisible: false,
      exportCompendiumsVisible: false,
      deleteToolVisible: false,
      scrollOps: {
        vuescroll: {
          mode: "slide",
          zooming: false
        },
        scrollPanel: {
          scrollingY: false
        },
        rail: {},
        bar: {
          keepShow: true
        }
      },
      shouldRestartGames: false,
      restartGamesInProgress: false,
      restartGamesComplete: false,
      restartErrorMessage: "",
      isCreatingANewGame: false
    };
  },
  watch: {
    hash() {
      const slug = this.hash.slice(1);
      if (slug === "manager=1") {
        this.switchTab(null);
      } else {
        const game = this.games.find(g => !slug && g || g.slug === slug);
        this.switchTab(game || this.games[0]);
      }
    }
  },
  computed: {
    filteredGames() {
      if (!this.filter) {
        return this.games;
      }
      const filter = this.filter.toLowerCase();
      return this.games.filter(g => {
        return g.title.toLowerCase().includes(filter) || (g.world || "").toLowerCase().includes(filter);
      });
    },
    isCreateAllowed() {
      if (!this.$refs.newGame) {
        return false;
      }
      return this.$refs.newGame.canSubmit;
    },
    shouldRestartOnlineGames() {
      return this.games.some(game => game.status === "online") && this.shouldRestartGames;
    },
    onlineGameSlugs() {
      return this.games.filter(game => game.status === "online").map(game => game.slug);
    }
  },
  methods: {
    async reloadGames() {
      const list = await Utils.api("game/list?owner=1");
      this.games = list && list.games ? list.games : this.games;
      this.games = Utils.sortGames(this.games);
      if (this.game) {
        this.game = this.games.find(g => g.slug === this.game.slug) || this.game;
      }
      this.newGame = false;
    },
    updateGame({
      slug,
      game
    }) {
      const idx = this.games.findIndex(g => g.slug === slug);
      if (idx !== -1) {
        this.games.splice(idx, 1, game);
        this.switchTab(this.game && this.games[idx]);
      }
    },
    newGameCreated(game) {
      this.isCreatingANewGame = false;
      this.games.push(game);
      this.games = Utils.sortGames(this.games);
      window.location.hash = `#${game.slug}`; //changing the hash will switch the tab
      this.newGame = false;
    },
    onCreatingNewGame() {
      this.isCreatingANewGame = true;
    },
    onFinishedCreatingNewGame() {
      this.isCreatingANewGame = false;
    },
    selectGame(game) {
      window.location.hash = game ? `#${game.slug}` : "#manager=1";
    },
    handleGamesUpdated(updatedGames) {
      this.games = updatedGames;
    },
    onCreateOk() {
      if (!this.$refs.newGame) {
        return;
      }
      this.$refs.newGame.create();
    },
    createGame() {
      this.newGame = true;
    },
    switchTab(game) {
      if (game) {
        this.manager = false;
        if (this.game && this.game.slug === game.slug) {
          this.game = game;
        } else {
          this.game = null;
          this.$nextTick(() => this.game = game);
        }
      } else {
        this.game = null;
        this.manager = true;
      }
    },
    preventModalClose(bvModalEvt) {
      if (this.restartGamesInProgress) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
      }
    },
    onRestart() {
      this.restartGamesInProgress = true;
      this.restartErrorMessage = "";
      const promises = this.onlineGameSlugs.map(async gameSlug => {
        try {
          const stopResponse = await Utils.api(`game/stop`, {
            game: gameSlug
          });
          if (stopResponse.error) {
            throw new Error(stopResponse.error);
          }
          const startResponse = await Utils.api(`game/idle`, {
            game: gameSlug
          });
          if (startResponse.error) {
            throw new Error(startResponse.errorMessage);
          }
          return startResponse;
        } catch (error) {
          // If an error occurred during the stop or start operation, reject the promise with the error
          return Promise.reject(error);
        }
      });

      // Wait for all promises to complete
      Promise.all(promises).then(() => {
        this.$emit("gamesUpdated", this.games);
        UI.alert("success", t("Games have successfully restarted."), true, 10000);
      }).catch(error => {
        this.restartErrorMessage = error || "An unknown error occurred";
        UI.alert("danger", t("Error restarting server: {{- error}}", {
          error: this.restartErrorMessage
        }), true, 10000);
      }).finally(() => {
        this.restartGamesInProgress = false;
        this.restartGamesComplete = !this.restartErrorMessage;
        if (!this.restartErrorMessage) {
          this.reloadGames();
        }
      });
    },
    cancel() {
      this.shouldRestartGames = false;
    }
  },
  async created() {
    await Utils.loadDependencies(["vuescroll"]);
    this.games = this.initialGames;
    this.table = this.initialTable;
    if (this.games) {
      this.games = Utils.sortGames(this.games);
    } else {
      await this.reloadGames();
    }
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
    this.loaded = true;
  },
  mounted() {
    // Refresh horizontal game-list scroll after styling applied to show entire range
    setTimeout(vuescroll.refreshAll, 100);
    const hashProps = Utils.hashProps(window.location.hash);
    if (hashProps.restart) {
      this.shouldRestartGames = true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameSetupFoundryUpdate"] = Vue.component(
                    "GameSetupFoundryUpdate",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-container fluid> <b-alert variant=\"info\" show> <i18n :path=\"t('Please read this {0} before updating!')\"> <a href=\"https://forums.forge-vtt.com/t/how-to-update-foundry-virtual-tabletop-on-the-forge/14139\" target=\"_blank\" >{{ t(\"guide\") }}</a > </i18n> </b-alert> <div v-if=\"updated\"> <i18n :path=\"t('You have updated your Foundry game settings to use the version {0}.')\" tag=\"p\"> <strong>{{ updated }}</strong> </i18n> <p> {{ t( \"If a game is currently active and uses a different version, you will need to restart it for the new version to be used.\" ) }} </p> <p v-html=\" t( 'You should also make sure to <strong>update all your systems and modules</strong> from the {{- bazaarLink}}', { bazaarLink: `<a href='/bazaar'>${t('Bazaar')}</a>` } ) \" ></p> </div> <div v-else> <i18n :path=\" t('Your Foundry Game is configured to use the {0} channel, which currently has its latest version set to {1}') \" tag=\"p\" > <strong>{{ table.version }}</strong> <strong>{{ latestVersion }}</strong> </i18n> <div v-if=\"table.lastVersion !== latestVersion\"> <i18n :path=\"t('Your Foundry Game is currently running on the {0} version of Foundry.')\" tag=\"p\"> <strong>{{ table.lastVersion }}</strong> </i18n> <div v-if=\"isV9 || isV10\"> <p v-html=\" t( 'We <b>strongly recommend</b> that you check the Systems &amp; Modules Compatibility spreadsheet, prepared by the Foundry VTT team, to make sure your game system and critical modules are compatible with the new Foundry VTT version you are upgrading to.' ) \" ></p> <ul> <li v-if=\"isV9\"> <a href=\"https://docs.google.com/spreadsheets/d/1ppPR348igxL75M_G7dWl3otzXYpPwrnj7NVSDP8GmVw\" target=\"_blank\" >{{ t(\"VERSIONS.PackageCompatibility\", { version: \"v9\" }) }}</a > </li> <li v-if=\"isV10\"> <a href=\"https://docs.google.com/spreadsheets/d/14PHGJzvjhX19rzSHD7VNXtq9UZne4pUxnBn4bxvoM9k\" target=\"_blank\" >{{ t(\"VERSIONS.PackageCompatibility\", { version: \"v10\" }) }}</a > </li> </ul> <i18n :path=\"t('Alternatively, you can also use the {0} module, which can greatly help with the process.')\" tag=\"p\" > <a href=\"https://forge-vtt.com/bazaar/package/mcc\" target=\"_blank\">{{ t(\"Module Compatibility Checker\") }}</a> </i18n> </div> <i18n :path=\" t( 'Before upgrading your Foundry game to the most recent {0} release, we recommend you backup all of your worlds, so you can recover them in case the update causes any issues with your worlds.' ) \" tag=\"p\" > <strong>{{ table.version }}</strong> </i18n> <b-button variant=\"primary\" @click.prevent=\"exportAllWorlds\">{{ t(\"Export All worlds\") }}</b-button> <i18n :path=\"t('Once you have backed up your worlds, you can upgrade your Foundry games to {0}.')\" tag=\"p\"> <strong>{{ latestVersion }}</strong> </i18n> <b-button variant=\"success\" :disabled=\"savingVersion\" @click.prevent=\"upgradeFoundry\">{{ t(\"VERSIONS.UpgradeTo\", { version: latestVersion }) }}</b-button> <i18n :path=\" t( 'Alternatively, if you do not wish to upgrade Foundry at this time, you can set your Foundry games to use the {0} instead of the {1} channel.' ) \" tag=\"p\" > <strong>{{ table.lastVersion }}</strong> <strong>{{ table.version }}</strong> </i18n> <b-button variant=\"secondary\" :disabled=\"savingVersion\" @click.prevent=\"freezeFoundry\">{{ t(\"VERSIONS.RemainOn\", { version: table.lastVersion }) }}</b-button> <i18n :path=\" t( 'If you choose this option, you will need to manually update your Foundry games to newer releases as they come out, by going to your {0} page.' ) \" tag=\"p\" > <a href=\"/setup\">{{ t(\"My Foundry\") }}</a> </i18n> </div> <div v-else> {{ t(\"You are already on the latest version of Foundry for the release channel you have chosen.\") }} </div> </div> </b-container>",
  props: {
    initialTable: Object,
    fvttVersions: Object,
    latestVersion: String
  },
  data() {
    return {
      table: null,
      version: null,
      savingVersion: false,
      updated: null
    };
  },
  computed: {
    isV9() {
      return /v9|version *9/i.test(this.latestVersion);
    },
    isV10() {
      return /v10|version *10/i.test(this.latestVersion);
    }
  },
  methods: {
    exportAllWorlds() {
      window.location = "/setup/export";
    },
    async upgradeFoundry() {
      if (this.savingVersion) {
        return;
      }
      this.savingVersion = true;
      const response = await Utils.api("game/configure", {
        game: this.table.slug,
        version: this.version,
        lastVersion: this.version
      });
      this.savingVersion = false;
      if (response.error) {
        UI.alert("danger", t("Error setting version: {{- error}}", {
          error: response.error
        }));
      } else {
        this.updated = this.latestVersion;
      }
    },
    async freezeFoundry() {
      if (this.savingVersion) {
        return;
      }
      this.savingVersion = true;
      const response = await Utils.api("game/configure", {
        game: this.table.slug,
        version: this.table.lastVersion
      });
      this.savingVersion = false;
      if (response.error) {
        UI.alert("danger", t("Error setting version: {{- error}}", {
          error: response.error
        }));
      } else {
        this.updated = this.table.lastVersion;
      }
    }
  },
  async created() {
    this.table = this.initialTable;
    this.version = this.table.version;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameSetupTools"] = Vue.component(
                    "GameSetupTools",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-row class=\"game-setup-tools\"> <b-col class=\"border border-primary p-2 m-2\"> <b-row> <b-col> <h5 class=\"text-center\">-= {{ t(\"Table Tools\") }} =-</h5> </b-col> </b-row> <!-- Column 1 - Import + Compendium --> <b-row cols=\"2\"> <b-col> <import-wizard v-model=\"showImportWizard\" @change=\"$emit('change', $event)\"></import-wizard> <b-button v-b-tooltip.hover.top size=\"sm\" variant=\"primary\" class=\"mt-1 w-100\" :title=\"t('Import worlds, modules, systems from your local machine')\" @click=\"showImportWizard = true\" > <i class=\"fas fa-magic\"></i>{{ t(\"Summon Import Wizard\") }} </b-button> </b-col> <b-col> <b-button v-b-tooltip.hover.top size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t('Create a module to share game entities between worlds')\" @click=\"createCompendiumVisible = true\" > <i class=\"fas fa-atlas\"></i>{{ t(\"Create Shared Compendium\") }} </b-button> <table-tool-shared-compendium v-model=\"createCompendiumVisible\"> </table-tool-shared-compendium> </b-col> <!-- Column 2 - Export + Delete --> <b-col v-if=\"modules.length\"> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" :disabled=\"explorerMode\" :title=\"t('Export a backup of your compendium modules in case you have customized them')\" @click=\"exportCompendiumsVisible = true\" > <i class=\"fas fa-download\"></i>{{ t(\"Export Compendium Modules\") }} </b-button> <table-tool-export v-model=\"exportCompendiumsVisible\" type=\"modules\" :title=\"t('Export Compendium Modules')\" ></table-tool-export> </b-col> <b-col> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"warning\" class=\"mt-1 w-100\" :title=\"t('View and manage worlds, modules, systems, and other files in your Data folder')\" @click=\"deleteToolVisible = true\" > <i class=\"fas fa-clipboard-list\"></i>{{ t(\"View Data Storage\") }} </b-button> <table-tool-delete v-model=\"deleteToolVisible\"></table-tool-delete> </b-col> <b-col> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t('Time to visit the Bazaar!')\" @click=\"gotoBazaar\" > <i class=\"fas fa-toolbox\"></i>{{ t(\"Install System & Modules\") }} </b-button> </b-col> <b-col> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t('Read Foundry debugging info and look for error messages')\" @click=\"showLogViewer = true\" > {{ t(\"View Foundry Logs\") }} </b-button> <log-viewer-foundry v-model=\"showLogViewer\"></log-viewer-foundry> </b-col> </b-row> </b-col> <!-- Column 3 - Start/Stop - Clone --> <b-col v-if=\"game\" class=\"border border-secondary p-2 m-2\"> <b-row> <b-col> <h5 class=\"text-center\">-= {{ t(\"Game Tools\") }} =-</h5> </b-col> </b-row> <b-row cols=\"2\"> <b-col> <b-button v-b-tooltip.hover.top=\"startStopTooltipTitle\" size=\"sm\" class=\"mt-1 w-100\" :variant=\"isOffline ? 'success' : 'danger'\" :disabled=\"startStopping\" @click=\"startStopServer\" > <loading-indicator v-if=\"startStopping\" tag=\"span\" small :label=\"isOffline ? t('Starting Server') : t('Stopping Server')\" > </loading-indicator> <span v-else> <span v-if=\"isOffline\" ><i class=\"fas fa-play\"></i> {{ t(\"Start Server\") }} </span> <span v-else ><i class=\"fas fa-stop\"></i> {{ t(\"Stop Server\") }} </span> </span> </b-button> </b-col> <b-col> <b-button v-b-tooltip.hover.top size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t('Make a copy of your world under a different name')\" @click=\"cloneWorldVisible = true\" > <i class=\"fas fa-copy\"></i>{{ t(\"Clone World\") }} </b-button> <table-tool-clone-world v-model=\"cloneWorldVisible\" :game=\"game\"></table-tool-clone-world> </b-col> <!-- Column 4 - Export - Players - Delete --> <b-col v-if=\"worlds.length\"> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" :disabled=\"explorerMode\" :title=\"t('Export an archive backup of your world')\" @click=\"exportWorld\" > <i class=\"fas fa-download\"></i>{{ t(\"Export World\") }} </b-button> <table-tool-export v-model=\"exportWorldsVisible\" type=\"worlds\" :title=\"t('Export World')\"></table-tool-export> </b-col> <b-col> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" :title=\"t('See your list of invited players and configure their settings')\" @click=\"configurePlayersVisible = true\" > <i class=\"fas fa-users\"></i>{{ t(\"Configure Players\") }} </b-button> <game-configure-players v-model=\"configurePlayersVisible\" :game=\"game\" @update=\"$emit('update', $event)\" ></game-configure-players> </b-col> <b-col v-show=\"!game.table\"> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t('Disables all modules, stops all playlists and deactivates the scene')\" @click=\"enableSafeMode\" > <loading-indicator v-if=\"enablingSafeMode\" tag=\"span\" small :label=\"t(`Enabling Safe Configuration…`)\"> </loading-indicator> <span v-else><i class=\"fas fa-shield-alt\"></i>{{ t(\"Launch in Safe Configuration\") }}</span> </b-button> </b-col> <!-- Save Points --> <b-col> <b-button v-b-tooltip.hover.bottom size=\"sm\" variant=\"info\" class=\"mt-1 w-100\" :title=\"t(`Configure/Browse your game's save points`)\" @click=\"configureSavePointsVisible = true\" > <i class=\"fas fa-save\"></i>{{ t(\"Save Points\") }} </b-button> <save-points-dialog v-model=\"configureSavePointsVisible\" :game=\"game\" :managing-games=\"managingGames\" :can-time-machine=\"canTimeMachine\" :backups=\"backups\" @found-worlds=\"onFoundWorlds\" @change=\"$emit('change', $event)\" @update=\"$emit('update', $event)\" ></save-points-dialog> </b-col> <b-col v-show=\"!game.table\"> <b-button size=\"sm\" variant=\"danger\" class=\"mt-1 w-100\" @click=\"gameToDelete = game\"> <i class=\"fas fa-trash-alt\"></i>{{ t(\"Delete World\") }} </b-button> <table-tool-delete-query v-model=\"showDeleteQuery\" :secret=\"querySecret\" :name=\"queryName\" :in-progress=\"deleteInProgress\" type=\"Game\" @delete=\"deleteGame\" ></table-tool-delete-query> </b-col> </b-row> </b-col> <!-- Column 4 - Game Manager : Create Game / Export All --> <b-col v-else class=\"border border-secondary p-2 m-2\"> <b-row> <b-col> <h5 class=\"text-center\">-= {{ t(\"Game Manager Tools\") }} =-</h5> </b-col> </b-row> <b-row cols=\"2\"> <b-col> <b-button v-b-tooltip.hover.top size=\"sm\" variant=\"primary\" class=\"mt-1 w-100\" :title=\"t('Create a new game')\" @click=\"$emit('create')\" > <i class=\"fas fa-plus-circle\"></i>{{ t(\"Create Game\") }} </b-button> </b-col> <b-col v-if=\"worlds.length\"> <b-button v-b-tooltip.hover.top size=\"sm\" variant=\"secondary\" class=\"mt-1 w-100\" :title=\"t('Export all of your worlds in a single backup archive')\" @click=\"exportAllWorlds\" > <i class=\"fas fa-download\"></i>{{ t(\"Export All Worlds\") }} </b-button> <table-tool-export v-model=\"exportWorldsVisible\" type=\"worlds\"></table-tool-export> </b-col> </b-row> </b-col> </b-row>",
  beforeCreate() {
    Utils.loadCss({
      content: "/* Icon spacing */ .game-setup-tools .fas { margin-right: 0.5rem; }"
    });
  },
  props: {
    game: Object,
    worlds: Array,
    modules: Array,
    explorerMode: Boolean,
    canTimeMachine: Boolean,
    managingGames: Boolean
  },
  data() {
    return {
      createCompendiumVisible: false,
      deleteToolVisible: false,
      exportCompendiumsVisible: false,
      exportWorldsVisible: false,
      cloneWorldVisible: false,
      configurePlayersVisible: false,
      configureSavePointsVisible: false,
      startStopping: false,
      enablingSafeMode: false,
      gameToDelete: null,
      deleteInProgress: false,
      backups: null,
      loadingBackups: false,
      showLogViewer: false,
      showImportWizard: false
    };
  },
  watch: {
    deleteToolVisible(val) {
      if (!val) {
        this.$emit("change");
      }
    },
    cloneWorldVisible(val) {
      if (!val) {
        this.$emit("change");
      }
    },
    showDeleteQuery(val) {
      if (!val) {
        this.$emit("change");
      }
    },
    configureSavePointsVisible(val) {
      if (val && !this.backups) {
        this.loadBackups();
      }
    },
    game() {
      if (window.location.hash.includes("&players") && this.game) {
        window.location.hash = window.location.hash.replace("&players", "");
        this.configurePlayersVisible = true;
      }
    }
  },
  computed: {
    isTable() {
      return this.game.table;
    },
    isOffline() {
      return this.game.status === "offline";
    },
    startStopTooltipTitle() {
      if (this.isOffline) {
        return t("As the owner, accessing the game URL will automatically start the Foundry server");
      }
      return t("A stopped server cannot be accessed by your players until you start it again");
    },
    showDeleteQuery: {
      get() {
        return !!this.querySecret;
      },
      set(val) {
        if (!val) {
          this.gameToDelete = null;
        }
      }
    },
    querySecret() {
      return this.gameToDelete && this.gameToDelete.delete;
    },
    queryName() {
      return this.gameToDelete && this.gameToDelete.title;
    }
  },
  methods: {
    async startStopServer() {
      const action = this.isOffline ? this.isTable ? "start" : "idle" : "stop";
      this.startStopping = true;
      const response = await Utils.api(`game/${action}`, {
        game: this.game.slug
      });
      this.startStopping = false;
      if (response.error) {
        UI.alert("danger", this.isOffline ? t("Error starting server: {{- error}}", {
          error: response.error
        }) : t("Error stopping server: {{- error}}", {
          error: response.error
        }), true, 10000);
      } else {
        UI.alert("success", this.isOffline ? t("Server started") : t("Server stopped"), true, 10000);
      }
      this.$emit("change");
    },
    exportWorld() {
      if (!this.game) {
        return;
      }
      if (this.game.table) {
        this.exportWorldsVisible = true;
      } else {
        window.location = `/setup/export/${this.game.world}`;
      }
    },
    exportAllWorlds() {
      window.location = "/setup/export";
    },
    gotoBazaar() {
      window.location = "/bazaar#foundry=module%2Csystem";
    },
    async enableSafeMode() {
      this.enablingSafeMode = true;
      const response = await Utils.api(`game/safe-mode`, {
        game: this.game.slug
      });
      this.enablingSafeMode = false;
      if (response.error) {
        UI.alert("danger", t(`Error enabling Safe Configuration: {{- error}}`, {
          error: response.error
        }), true, 10000);
      } else {
        UI.alert("success", t(`Safe Configuration enabled`), true, 10000);
      }
    },
    async deleteGame(secret) {
      // Save the game before it gets set to null by the watch
      const gameToDelete = this.gameToDelete;
      console.log("Delete", gameToDelete, secret);
      if (!gameToDelete || !secret || gameToDelete.delete !== secret) {
        return;
      }
      if (gameToDelete.table || !gameToDelete.world) {
        return;
      }
      this.deleteInProgress = true;
      const response = await Utils.api(`data/worlds/delete`, {
        name: gameToDelete.world,
        secret
      });
      console.log("Delete response: ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`Game {{- title}} deleted successfully`, {
          title: `<strong>'${Utils.escapeHTML(gameToDelete.title)}'</strong>`
        }), true, 10000);
      }
      if (this.gameToDelete === gameToDelete) {
        this.gameToDelete = null;
      }
      this.$emit("select");
      this.deleteInProgress = false;
      this.showDeleteQuery = false;
    },
    async loadBackups() {
      if (this.loadingBackups) {
        return;
      }
      this.loadingBackups = true;
      const response = await Utils.api("saves/backups");
      if (response.success) {
        this.backups = response.backups;
      } else {
        this.backups = [];
      }
      this.loadingBackups = false;
    },
    async onFoundWorlds(backupId, worlds) {
      const backup = this.backups.find(backup => backup.id === backupId);
      if (backup) {
        // Save the found worlds for this backup, and make it reactive
        this.$set(backup, "worlds", worlds);
      }
    }
  },
  mounted() {
    const hash = Utils.hashProps(window.location.hash);
    if (hash.players) {
      this.configurePlayersVisible = true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameSetupUpgradeWorld"] = Vue.component(
                    "GameSetupUpgradeWorld",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-container fluid> <div v-if=\"upgradedWorld\"> <i18n :path=\"t('Your World {0} has been upgraded to version {1} and can now be launched!')\" tag=\"p\"> <strong>{{ game.title }}</strong> <strong>{{ targetGameVersion }}</strong> </i18n> <i18n :path=\"t('Please remember to check {0} for any available package updates.')\" tag=\"p\"> <a href=\"https://forge-vtt.com/bazaar\" target=\"_blank\">{{ t(\"The Bazaar\") }}</a> </i18n> <div> <a :href=\"game.url\" class=\"btn btn-success\">{{ t(\"Launch Game\") }}</a> </div> </div> <div v-else> <b-alert variant=\"info\" show> <i18n :path=\"t('Please read this {0} before upgrading!')\"> <a href=\"https://forums.forge-vtt.com/t/how-to-update-foundry-virtual-tabletop-on-the-forge/14139\" target=\"_blank\" >{{ t(\"guide\") }}</a > </i18n> </b-alert> <div v-if=\"currentGameVersion !== targetNumericVersion\"> <i18n :path=\" t( 'In order to launch your World, {0}, you need to allow Foundry to migrate its World Data from its current Foundry core version ({1}) to {2}' ) \" tag=\"p\" > <strong>{{ game.title }}</strong> <b>{{ currentGameVersion }}</b> <strong>{{ targetGameVersion }}</strong> </i18n> <template v-if=\"majorUpgrade\"> <p v-html=\" t( `As part of this process, your {{ packageCount }} installed <u>modules will be disabled</u> automatically in the World and must be re-enabled in Foundry manually in order to use them.`, { packageCount } ) \" ></p> <p v-html=\" t( `After the World Data has been migrated to the new Foundry VTT version, you <u>may not be able to downgrade the world</u> anymore.` ) \" ></p> </template> <i18n v-if=\"system\" :path=\"t(`This World is using the Game System {0}. {1}`)\" tag=\"p\"> <b>{{ system.title }}</b> <i18n v-if=\"systemIsSupported\" :path=\" t( `The system version currently installed is {0} which has already been updated to support Foundry VTT {1}.` ) \" > <b>{{ system.version }}</b> <b>{{ targetGameVersion }}</b> </i18n> <i18n v-else :path=\"t(`The system version currently installed is {0} which currently does not support Foundry VTT {1}.`)\" > <b>{{ system.version }}</b> <b>{{ targetGameVersion }}</b> </i18n> </i18n> <i18n v-else :path=\" t( 'This World depends on the Game System {0} which is not currently installed. You will not be able to launch this World until you install its system. Check out the {1} to install the system.' ) \" tag=\"p\" > <b>{{ systemName }}</b> <a :href=\"`/bazaar#foundry=system&package=${Utils.escapeHTML(systemName)}`\">{{ t(\"Bazaar\") }}</a> </i18n> <b-alert v-if=\"!systemIsSupported\" show variant=\"warning\"> <i18n :path=\" t( 'You will not be able to upgrade your World until the {0} has been installed or updated to a version which is compatible with the Foundry VTT {1}.' ) \" > <a :href=\"`/bazaar#foundry=system&package=${Utils.escapeHTML(systemName)}`\">{{ t(\"Game System\") }}</a> <b>{{ targetGameVersion }}</b> </i18n> </b-alert> <div v-else> <!-- Backup --> <p> {{ t( \"We strongly recommend that you backup your World so that you are able to recover it in case there are any issues during the upgrade process.\" ) }} </p> <b-button variant=\"primary\" :disabled=\"exporting\" @click.prevent=\"exportWorld\"> <span v-if=\"exporting\"> <i class=\"fa fa-fw fa-spinner fa-spin\"></i> {{ t(\"Exporting Backup\") }} </span> <span v-else>{{ t(\"Export World Backup\") }}</span> </b-button> <!-- Version upgrade --> <i18n :path=\"t('Once you have backed up your World, you can upgrade it for version {0} compatibility.')\" tag=\"p\" class=\"mt-3\" > <strong>{{ targetGameVersion }}</strong> </i18n> <b-button variant=\"success\" :disabled=\"upgradingWorld\" @click.prevent=\"upgradeWorld\"> <span v-if=\"upgradingWorld\" ><i class=\"fa fa-fw fa-spinner fa-spin\"></i> <i18n :path=\"t('Upgrading to {0}')\"> <b>{{ targetGameVersion }}</b> </i18n> </span> <i18n v-else :path=\"t('Upgrade to {0}')\"> <b>{{ targetGameVersion }}</b> </i18n> </b-button> <!-- Version specific options popups chain, ending with `upgradeWorld` --> <foundry-telemetry v-model=\"showFoundryTelemetryDialog\" :upgrading=\"true\" @telemetry=\"setTelemetry\" ></foundry-telemetry> <!-- No upgrade --> <p class=\"mt-3\"> {{ t( \"Alternatively, you can choose to not upgrade this World at this time. This will return you to the game setup page.\" ) }} </p> <b-button variant=\"secondary\" :disabled=\"upgradingWorld\" @click.prevent=\"declineUpgradeWorld\"> {{ t(\"Do not upgrade\") }} </b-button> </div> </div> <div v-else> <i18n :path=\"t('Your World {0} has already been migrated to version {1}.')\"> <strong>{{ game.title }}</strong> <b>{{ currentGameVersion }}</b> </i18n> <div> <a :href=\"game.url\" class=\"btn btn-success\">{{ t(\"Launch Game\") }}</a> </div> </div> </div> </b-container>",
  props: {
    game: Object,
    currentGameVersion: String,
    targetGameVersion: String,
    targetNumericVersion: String,
    packageCount: Number,
    system: Object,
    systemName: String,
    systemIsSupported: Boolean,
    majorUpgrade: Boolean,
    foundryTelemetry: Boolean // Tristate boolean
  },

  data() {
    return {
      upgradingWorld: false,
      upgradedWorld: false,
      exporting: false,
      exported: false,
      // Foundry options
      showFoundryTelemetryDialog: false,
      telemetry: undefined
    };
  },
  methods: {
    isUpgradingToMajorVersion(major) {
      return Utils.compareFoundryVersions(this.currentGameVersion, major) < 0 && Utils.compareFoundryVersions(this.targetNumericVersion, major) >= 0;
    },
    async exportWorld() {
      this.exporting = true;
      window.location = `/setup/export/${this.game.world}`;
      // Wait one second before considering the export completed
      await new Promise(r => setTimeout(r, 1000));
      this.exported = true;
      this.exporting = false;
    },
    declineUpgradeWorld() {
      window.location = `/game/${this.game.slug}`;
    },
    setTelemetry(enable) {
      this.telemetry = enable;
      // Telemetry dialog only opens on upgradeWorld but interrupts it
      // so we need to call upgradeWorld again to continue the upgrade
      this.upgradeWorld();
    },
    async upgradeWorld() {
      if (this.upgradingWorld) {
        return;
      }
      /* If upgrading to v11+, prompt for telemetry the first time */
      if (this.isUpgradingToMajorVersion(11) && this.telemetry === undefined) {
        this.showFoundryTelemetryDialog = true;
        return;
      }
      this.upgradingWorld = true;
      if (!this.exported) {
        UI.alert("warning", t("You have not saved a backup of your world! Exporting a backup before proceeding with the upgrade."));
        await this.exportWorld();
      }
      const response = await Utils.api("game/upgrade-world", {
        game: this.game.slug,
        version: this.targetGameVersion
      });
      this.upgradingWorld = false;
      if (response.error) {
        UI.alert("danger", t("Error upgrading World: {{- error}}", {
          error: response.error
        }));
      } else {
        this.upgradedWorld = true;
      }
    }
  },
  created() {
    this.telemetry = this.foundryTelemetry;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["GameStatusIndicator"] = Vue.component(
                    "GameStatusIndicator",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<i v-b-tooltip.hover.viewport.top class=\"game-status-indicator align-middle\" :class=\"icon\" :style=\"`color: ${color}`\" :title=\"showTooltip ? t('This game is currently {{status}}', { status }) : null\" ></i>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-status-indicator{max-height:1em;max-width:1em}"
    });
  },
  props: {
    status: String,
    showTooltip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    color() {
      switch (this.status) {
        case "starting":
        case "online":
          return "green";
        case "idle":
          return "orange";
        case "offline":
          return "red";
        default:
          return "black";
      }
    },
    icon() {
      switch (this.status) {
        case "starting":
        case "online":
          return "fas fa-play";
        case "idle":
          return "fas fa-pause";
        case "offline":
          return "fas fa-stop";
        default:
          return "fas fa-circle";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NewGameForm"] = Vue.component(
                    "NewGameForm",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const tabs = {
  systems: 0,
  bazaarWorlds: 1,
  userWorlds: 2
};
function findAndFlagEntitledPackages({
  packages,
  entitlements
}) {
  const findEntitledAndPurchased = (ent, sys) => sys.type === ent.type && sys.name === ent.name;
  return packages.map(sys => {
    const entitled = Boolean(entitlements.some(ent => findEntitledAndPurchased(ent, sys)));
    const purchased = Boolean(entitlements.filter(ent => findEntitledAndPurchased(ent, sys)).length > 1);
    return {
      ...sys,
      entitled,
      purchased
    };
  });
}
function addCustomSystems({
  systems,
  installedSystems
}) {
  installedSystems.forEach(iSys => {
    if (!systems.find(sys => sys.name === iSys.name)) {
      const customSystem = Bazaar.customPackageToBazaar("system", iSys);
      systems.push({
        ...customSystem,
        custom: true // Will show a "Custom" badge in NewGameFormListItem
      });
    }
  });

  return systems;
}
function assignInstallationStatus({
  systems,
  installedSystems
}) {
  return systems.map(sys => {
    const matchingInstalledSys = installedSystems.find(iSys => iSys.name === sys.name);
    return {
      ...sys,
      installed: matchingInstalledSys ? matchingInstalledSys.version : ""
    };
  });
}
var _default = exports.default = {
  template: "<section class=\"new-game-form\"> <b-tabs ref=\"tabs\" v-model=\"activeTab\" justified @activate-tab=\"loadTabData\"> <new-game-form-search ref=\"filter\" :has-installed-toggle=\"activeTab === tabs.systems\" :system-filter-options=\"activeTab !== tabs.systems ? availableSystems : []\" :can-sort-by-access=\"activeTab === tabs.userWorlds\" /> <div id=\"new-game-form-error\"></div> <b-alert :show=\"loading\"> <loading-indicator class=\"mb-0\" small :label=\"t('Loading…')\"></loading-indicator> </b-alert> <b-tab id=\"systems\" class=\"new-game-form__tab\" :title=\"t('BlankGame')\" active lazy> <section v-if=\"!loading\" class=\"new-game-form__list\"> <new-game-form-list-item v-for=\"pkg in filteredResults\" :key=\"pkg.name\" :item=\"pkg\" :default-image=\"defaultImage\" :selected=\"selection && selection.name === pkg.name\" can-link @click=\"setSelection\" /> </section> </b-tab> <b-tab id=\"bazaar-worlds\" class=\"new-game-form__tab\" :title=\"t('FromTheBazaar')\" lazy> <section v-if=\"!loading\" class=\"new-game-form__list\"> <new-game-form-list-item v-for=\"pkg in filteredResults\" :key=\"pkg.name\" :item=\"pkg\" :default-image=\"defaultImage\" :selected=\"selection && selection.name === pkg.name\" can-link @click=\"setSelection\" /> </section> </b-tab> <b-tab id=\"user-worlds\" class=\"new-game-form__tab\" :disabled=\"userWorldsList.length === 0\" :title=\"t('CloneWorld')\" lazy > <section v-if=\"!loading\" class=\"new-game-form__list\"> <new-game-form-list-item v-for=\"pkg in filteredResults\" :key=\"pkg.slug\" :item=\"pkg\" :default-image=\"defaultImage\" :selected=\"selection && selection.slug === pkg.slug\" @click=\"setSelection\" /> </section> </b-tab> </b-tabs> <b-card no-body class=\"new-game-form__controls border border-primary p-2 mt-2 shadow-sm\"> <b-row class=\"new-game-form__name-fields\"> <b-col> <b-form-group :label=\"t('World Name')\" label-align-md=\"right\" label-cols-md=\"4\"> <b-form-input v-model=\"worldName\" :state=\"nameState\" autofocus trim @keydown=\"submitOnEnter\" /> <b-form-invalid-feedback id=\"input-world-title-feedback\"> {{ t(\"NEWGAME.GAME_NAME_REQUIRED\") }} </b-form-invalid-feedback> </b-form-group> </b-col> <b-col> <b-form-group label-align-md=\"right\" label-cols-md=\"4\"> <template slot=\"label\"> {{ t(\"Folder\") }} <help-icon custom-class=\"game-manager-new-game-folder-tooltip\" :tooltip=\"t('NEWGAME.FOLDER_DESCRIPTION')\" ></help-icon> </template> <b-form-input v-model=\"worldFolder\" debounce=\"500\" lazy-formatter :formatter=\"slugify\" :placeholder=\"worldSlug\" :state=\"folderState\" trim @keydown=\"submitOnEnter\" /> <b-form-invalid-feedback id=\"input-world-name-feedback\"> {{ worldNameError }} </b-form-invalid-feedback> </b-form-group> </b-col> </b-row> <div class=\"new-game-form__buttons\"> {{/* If this component is used outside of a modal, use this slot to add controls to it. */}} <slot name=\"form-controls\"></slot> </div> </b-card> </section>",
  beforeCreate() {
    Utils.loadCss({
      content: ".new-game-form{position:relative;container-type:inline-size}.new-game-form,.new-game-form .tabs{min-height:50vh}.modal-dialog .new-game-form__list{max-height:50vh;overflow-y:auto}.new-game-form__list{--horizontal-gap: 1em;display:grid;gap:.5em var(--horizontal-gap)}@container (min-width: 40ch){.new-game-form__list{grid-template-columns:repeat(auto-fit, minmax(40ch, 1fr))}.new-game-form__list::after{content:\"\";width:0;padding-left:calc(100% - var(--horizontal-gap));grid-column:1/-1}}.new-game-form__controls .form-group{margin-bottom:0}@container (max-width: 575.98px){.new-game-form__controls .form-group legend{padding-top:0;padding-bottom:0}}.new-game-form__buttons:empty{display:none}"
    });
  },
  data() {
    return {
      // Component state
      selection: undefined,
      activeTab: 0,
      loadingSystems: false,
      loadingWorlds: false,
      loadingGames: false,
      triedToSave: false,
      creating: false,
      // Data lists
      entitlements: null,
      entitlementsPromise: null,
      systemsList: [],
      bazaarWorldsList: [],
      userWorldsList: [],
      // New world labels
      worldName: "",
      worldFolder: ""
    };
  },
  computed: {
    list() {
      return !this.tabKey ? [] : this[`${this.tabKey}List`];
    },
    filteredResults() {
      const filter = this.$refs.filter;
      return !filter ? this.list : this.list.filter(filter.filter).sort(filter.sort || undefined);
    },
    tabs() {
      return tabs;
    },
    loading() {
      switch (this.activeTab) {
        case this.tabs.systems:
          return this.loadingSystems;
        case this.tabs.bazaarWorlds:
          return this.loadingWorlds;
        case this.tabs.userWorlds:
          return this.loadingGames;
        default:
          return false;
      }
    },
    availableSystems() {
      return [...new Set(this.list.map(item => {
        if (item.system) {
          return item.system;
        }
        if (item.systems && item.systems.length) {
          return item.systems[0];
        }
        return "";
      }))];
    },
    defaultImage() {
      if (this.activeTab === this.tabs.systems) {
        return defaultImage.system;
      }
      return defaultImage.world;
    },
    tabKey() {
      return Object.keys(this.tabs).find(t => this.tabs[t] === this.activeTab);
    },
    canSubmit() {
      return this.validName && this.validFolder && !!this.selection;
    },
    worldNameError() {
      if (this.worldExists) {
        return t("NEWGAME.A_WORLD_ALREADY_EXISTS");
      }
      if (!this.worldFolder) {
        return t("NEWGAME.FOLDER_NAME_REQUIRED");
      }
      return "";
    },
    folderState() {
      if (!this.triedToSave) {
        return null;
      }
      return this.validFolder;
    },
    nameState() {
      if (!this.triedToSave) {
        return null;
      }
      return this.validName;
    },
    validFolder() {
      return this.worldSlug.length > 0 && !this.worldExists;
    },
    validName() {
      return this.worldName.length > 0;
    },
    worldSlug() {
      return this.findUnusedSlug(this.slugify((this.worldName || this.worldFolder).trim()));
    },
    worldExists() {
      return !!this.userWorldsList.find(m => m.world === this.worldFolder);
    }
  },
  methods: {
    slugify(input) {
      if (!input) {
        return "";
      }
      return Utils.slugify(input, globalThis.GAME_SLUG_MIN_LENGTH, globalThis.GAME_SLUG_MAX_LENGTH);
    },
    async getEntitlements() {
      if (this.entitlements && this.entitlements.length) {
        return Promise.resolve(this.entitlements);
      }
      // Entitlements aren't populated and we haven't asked for them yet. Start the API call.
      if (!this.entitlementsPromise) {
        this.entitlementsPromise = Utils.api("profile/entitlements");
      }
      // Return the promise that will resolve when the entitlements are fetched.
      return this.entitlementsPromise;
    },
    async loadSystems(force) {
      if (!force && this.systemsList.length) {
        return;
      }
      this.loadingSystems = true;
      try {
        const [bazaar, entitlements, installedSystems] = await Promise.all([Utils.api("bazaar/systems"), this.getEntitlements(), Utils.api("data/systems")]);
        this.entitlements = entitlements;
        const systems = findAndFlagEntitledPackages({
          packages: bazaar.packages,
          entitlements
        });

        // Add installed non-Bazaar systems to the list of valid systems as Bazaar systems
        addCustomSystems({
          systems,
          installedSystems
        });
        this.systemsList = assignInstallationStatus({
          systems,
          installedSystems
        });
      } catch (err) {
        UI.alert("danger", t("ERROR.ErrorRetrievingData"), true, 10000, "#new-game-form-error");
      } finally {
        this.loadingSystems = false;
      }
    },
    async loadWorlds(force) {
      if (!force && this.bazaarWorldsList.length) {
        return;
      }
      this.loadingWorlds = true;
      try {
        const [bazaar, entitlements] = await Promise.all([Utils.api("bazaar/worlds"), this.getEntitlements()]);
        this.entitlements = entitlements;
        this.bazaarWorldsList = findAndFlagEntitledPackages({
          packages: bazaar.packages,
          entitlements
        });
      } catch (err) {
        UI.alert("danger", t("ERROR.ErrorRetrievingData"), true, 10000, "#new-game-form-error");
      } finally {
        this.worldsLoaded = true;
        this.loadingWorlds = false;
      }
    },
    async loadGames(force) {
      if (!force && this.userWorldsList.length) {
        return;
      }
      this.loadingGames = true;
      const list = await Utils.api("game/list?owner=1");
      this.userWorldsList = list && list.games ? list.games : [];
      this.loadingGames = false;
    },
    reset() {
      this.selection = undefined;
      this.worldName = "";
      this.worldFolder = "";
    },
    async loadTabData(i) {
      this.reset();
      switch (i) {
        case this.tabs.systems:
          await this.loadSystems();
          break;
        case this.tabs.bazaarWorlds:
          await this.loadWorlds();
          break;
        case this.tabs.userWorlds:
          await this.loadGames();
          break;
        default:
          break;
      }
      this.$refs.filter.resetSearchConfig();
    },
    setSelection(pkg) {
      this.selection = pkg;
      if (!pkg) {
        this.worldName = "";
        this.worldFolder = "";
        return;
      }
      if (this.activeTab === this.tabs.bazaarWorlds) {
        this.worldName = this.selection.title;
        this.worldFolder = this.findUnusedSlug(this.selection.name || this.selection.slug);
      } else if (this.activeTab === this.tabs.userWorlds) {
        this.worldName = `${this.selection.title} (${t("Copy")})`;
        this.worldFolder = this.findUnusedSlug(this.worldName);
      }
    },
    findUnusedSlug(slug) {
      const baseslug = this.slugify(slug || this.worldName);
      let result = baseslug;
      let count = 0;
      while (this.userWorldsList.find(m => m.world === (result || baseslug))) {
        result = `${baseslug}_${count}`;
        count++;
      }
      return result;
    },
    submitOnEnter(e) {
      if (!this.creating && e.key.toLowerCase() === "enter") {
        this.create(e);
      }
    },
    async create(e) {
      this.triedToSave = true;
      this.creating = true;
      this.$emit("loading");
      if (!this.canSubmit) {
        this.creating = false;
        this.$emit("loaded");
        if (!this.selection) {
          UI.alert("danger", t("ERROR.FailedToCreateGame.NoSystemSelected"), true, 10000, "#new-game-form-error");
        }
        return;
      }
      if (e) {
        e.preventDefault();
      }
      if (this.activeTab === this.tabs.systems) {
        this.createGame();
      } else if (this.activeTab === this.tabs.bazaarWorlds) {
        this.installWorld();
      } else if (this.activeTab === this.tabs.userWorlds) {
        this.cloneWorld();
      }
    },
    async createGame() {
      const didInstallations = this.installSystem(this.selection.name);
      if (!didInstallations) {
        this.$emit("loaded");
        this.creating = false;
        return;
      }

      // Create a new blank game
      const response = await Utils.api(`data/worlds/create`, {
        system: this.selection.name,
        name: this.worldSlug,
        title: this.worldName
      });
      this.creating = false;
      if (response.error) {
        this.$emit("loaded");
        UI.alert("danger", t("ERROR.FailedToCreateGame", {
          error: response.error
        }));
        return;
      }
      this.$emit("created", response.game);
      this.$emit("loaded");
      UI.alert("success", t("SUCCESS.WorldCreatedSuccessfully"), true, 10000);
      this.loadGames(true);
    },
    async installWorld() {
      for (const system of this.selection.systems) {
        if ((await this.installSystem(system)) === false) {
          this.creating = false;
          return;
        }
      }
      const response = await Utils.api("data/worlds/install", {
        name: this.selection.name,
        destination: this.worldSlug,
        title: this.worldName
      });
      this.creating = false;
      if (response.error || !response.installed) {
        const error = !response.installed ? t("ERROR.CouldNotInstallWorld") : response.error;
        UI.alert("danger", t("ERROR.ErrorRetrievingData", {
          error
        }), true, 10000, "#new-game-form-error");
        this.$emit("loaded");
        return;
      }
      this.$emit("created", response.game);
      this.$emit("loaded");
      UI.alert("success", t("SUCCESS.WorldInstalledSuccessfully"), true, 10000);
      this.loadGames(true);
    },
    async cloneWorld() {
      const response = await Utils.api("data/worlds/clone", {
        source: this.selection.world,
        destination: this.worldSlug,
        title: this.worldName
      });
      this.creating = false;
      if (response.error) {
        UI.alert("danger", t("ERROR.ErrorCloningWorld", {
          error: response.error
        }), true, 10000);
        return;
      }
      if (this.$listeners.reload) {
        this.$emit("loaded");
        this.$emit("reload");
      } else {
        this.$emit("created");
        this.loadGames(true);
      }
      UI.alert("success", t("SUCCESS.WorldClonedSuccessfully"), true, 10000);
    },
    async installSystem(system) {
      const systems = await Utils.api("data/systems");
      const installed = systems.find(p => {
        return p.name === system;
      });
      if (!installed) {
        const response = await Utils.api(`data/systems/install`, {
          name: system
        });
        if (response.error) {
          UI.alert("danger", t("ERROR.FailedToInstallSystem", {
            error: response.error
          }));
          return false;
        }
      }
      return true;
    }
  },
  async mounted() {
    this.loadSystems();
    this.loadWorlds();
    this.loadGames();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NewGameFormListItem"] = Vue.component(
                    "NewGameFormListItem",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article :class=\"containerClasses\" tabindex=\"0\" :aria-selected=\"selected\" @keydown=\"selectItem\" @click.stop=\"selectItem\" > <img class=\"new-game-form-list-item__thumbnail\" :src=\"banner\" :alt=\"item.title\" @error=\"errorLoadingImage($event)\" /> <div class=\"new-game-form-list-item__detail\"> <header> <h5>{{ item.title }}</h5> <div class=\"new-game-form-list-item__badges\"> <b-badge v-show=\"lastAccessed\" v-b-tooltip=\"{ placement: 'top', container: 'body', boundary: 'viewport' }\" :title=\"t('This world was last accessed {{lastAccessed}}', { lastAccessed })\" variant=\"warning\" > {{ lastAccessed }} </b-badge> <b-badge v-show=\"system\" v-b-tooltip=\"{ placement: 'top', container: 'body', boundary: 'viewport' }\" :title=\"t('This world uses the {{system}} game system', { system })\" variant=\"warning\" > {{ system }} </b-badge> <b-badge v-show=\"item.custom\" variant=\"warning\">{{ t(\"Custom\") }}</b-badge> <b-badge v-show=\"item.installed\" variant=\"success\">{{ t(\"Installed\") }}</b-badge> </div> <b-button v-if=\"needsPurchase\" :href=\"bazaarLink\" size=\"sm\" variant=\"primary\"> {{ t(\"Purchase\") }} </b-button> <b-button v-if=\"canLink\" v-b-tooltip=\"{ placement: 'top', container: 'body', boundary: 'viewport' }\" variant=\"outline-secondary\" size=\"sm\" :href=\"bazaarLink\" target=\"_blank\" :title=\"t('View in the Bazaar')\" @keydown.stop=\"swallowEventForLink\" @click.stop=\"swallowEventForLink\" > <i class=\"fas fa-external-link-alt\"></i> </b-button> </header> <!-- eslint-disable-next-line vue/no-v-html --> <div v-once class=\"new-game-form-list-item__description\" v-html=\"description\" /> </div> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".new-game-form-list-item{--header-columns: 1fr min-content;display:grid;gap:.5em;box-shadow:inset 0 1px 0 rgba(255,255,255,.15),0 1px 1px rgba(0,0,0,.075);border-radius:.25em;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;cursor:pointer;max-width:100%;overflow:auto;grid-template-columns:1fr}@container (min-width: 50ch){.new-game-form-list-item{grid-template-columns:10ch 1fr}}.new-game-form-list-item.bg-primary{color:var(--white)}.new-game-form-list-item.bg-primary a{transition:color .15s ease-in-out,opacity .15s ease-in-out;color:inherit;border-color:currentcolor;text-decoration:underline}.new-game-form-list-item.bg-primary a:hover{opacity:.7}.new-game-form-list-item:hover,.new-game-form-list-item:focus{outline:none;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.new-game-form-list-item--can-link{--header-columns: 1fr min-content min-content}.new-game-form-list-item header{display:grid;grid-template-columns:var(--header-columns);grid-auto-flow:column;gap:1em;align-items:center}.new-game-form-list-item header h5{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-bottom:0;line-height:1em;margin:.25em 0}.new-game-form-list-item__thumbnail{border-radius:.125em;overflow:hidden;width:100%;height:auto;display:block;align-self:center}@container (max-width: 49.9ch){.new-game-form-list-item__thumbnail{display:none}}.new-game-form-list-item__badges{display:flex;gap:.5em}.new-game-form-list-item__description{display:none}@container (min-width: 768px){.new-game-form-list-item__description{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}}.new-game-form-list-item__description *:last-child{margin-bottom:0}"
    });
  },
  props: {
    item: {
      type: [Object, null],
      default: null
    },
    installed: Boolean,
    selected: Boolean,
    canLink: Boolean,
    defaultImage: {
      type: String,
      default: "/images/bazaar.png"
    }
  },
  data() {
    return {};
  },
  computed: {
    bazaarLink() {
      return Bazaar.bazaarLink(this.item, true);
    },
    system() {
      if (this.item.type !== "world" && !this.item.world) {
        return "";
      }
      if (this.item.system) {
        return this.item.system;
      }
      if (this.item.systems && this.item.systems.length) {
        return this.item.systems[0];
      }
      return "";
    },
    lastAccessed() {
      if (!this.item.lastAccess) {
        return null;
      }
      return Utils.timeSince(this.item.lastAccess, "d");
    },
    needsPurchase() {
      return this.item.premium && !this.item.entitled;
    },
    description() {
      return DOMPurify.sanitize(marked(this.item.description, {
        breaks: true,
        headerIds: false
      }));
    },
    banner() {
      if (!this.item.media) {
        return this.defaultImage;
      }
      const coverImage = this.item.media.find(m => m.type === PACKAGE_MEDIA_TYPES.COVER);
      return coverImage ? coverImage.url : this.defaultImage;
    },
    containerClasses() {
      return {
        "new-game-form-list-item": true,
        "new-game-form-list-item--can-link": this.canLink,
        "border-primary": true,
        "p-2": true,
        "bg-primary": this.selected,
        border: true
      };
    }
  },
  methods: {
    errorLoadingImage(ev) {
      Utils.errorLoadingImage(ev, this.defaultImage);
    },
    selectItem(ev) {
      if (ev.type === "keydown") {
        if (ev.code !== "Space" && ev.code !== "Enter") {
          return;
        }
        ev.preventDefault();
      }
      if (this.needsPurchase) {
        this.$emit("message", t("NEWGAME.CANNOT_CREATE_WO_PURCHASE"));
      }
      this.$emit("click", !this.selected ? this.item : null);
    },
    swallowEventForLink(ev) {
      return ev.type === "keydown" && ev.code !== "Enter";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NewGameFormSearch"] = Vue.component(
                    "NewGameFormSearch",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const defaultSortType = "descending";
const installedSort = (a, b) => {
  if (a.installed && !b.installed) {
    return -1;
  }
  if (!a.installed && b.installed) {
    return 1;
  }
  return 0;
};
var _default = exports.default = {
  template: "<div class=\"new-game-form-search mt-3 mb-4\"> <b-input-group class=\"new-game-form-search__title\"> <template #prepend> <b-input-group-text variant=\"outline-secondary\"> <i class=\"fa fas fa-search\"></i> </b-input-group-text> </template> <b-form-input v-model=\"query\" /> <b-button v-if=\"query\" v-b-tooltip.hover variant=\"outline-secondary\" :title=\"t('Clear search')\" @click=\"clearSearch\" > <i class=\"fas fa-times\"></i> </b-button> </b-input-group> <div v-if=\"hasInstalledToggle\" class=\"custom-control custom-switch d-none d-md-inline\"> <input id=\"new-game-filter-include-installed\" v-model=\"includeUninstalled\" type=\"checkbox\" class=\"custom-control-input\" /> <label class=\"custom-control-label\" for=\"new-game-filter-include-installed\">{{ t(\"Show uninstalled\") }}</label> </div> <b-input-group v-if=\"filterOptions.length\" class=\"d-none d-md-flex\"> <template #prepend> <b-input-group-text variant=\"outline-secondary\"> <i class=\"fa fas fa-filter\"></i> </b-input-group-text> </template> <b-form-select id=\"new-game-filter-system\" v-model=\"systemFilter\" v-b-tooltip.hover :title=\"t('Filter by game system')\" class=\"new-game-form-search__dropdown\" :placeholder=\"t('System filter')\" > <b-form-select-option value=\"\"></b-form-select-option> <b-form-select-option v-for=\"system in filterOptions\" :key=\"system\" :value=\"system\">{{ system }}</b-form-select-option> </b-form-select> </b-input-group> <b-input-group class=\"d-none d-md-flex\"> <template #prepend> <b-input-group-text variant=\"outline-secondary\"> <i :class=\"{ fa: true, fas: true, [selectedIcon]: true }\"></i> </b-input-group-text> </template> <b-form-select id=\"new-game-sort\" v-model=\"sortType\" v-b-tooltip.hover :title=\"t('Sort direction')\" class=\"new-game-form-search__dropdown\" > <b-form-select-option v-for=\"(sortOption, i) in sortOptions\" :key=\"i\" :value=\"sortOption.key\">{{ t(sortOption.label) }}</b-form-select-option> </b-form-select> </b-input-group> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".new-game-form-search { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1em; align-items: baseline; } @container (max-width: 59.9ch) { .new-game-form-search__title { grid-column: 1/3; } } @container (min-width: 60ch) { .new-game-form-search { grid-template-columns: 1fr max-content max-content; } #new-game-sort, #new-game-filter-system { min-width: 20ch; } } .new-game-form-search__dropdown { flex: unset; width: max-content; } label[for=\"new-game-filter-include-installed\"] { user-select: none; }"
    });
  },
  props: {
    systemFilterOptions: {
      type: Array,
      default: () => []
    },
    hasInstalledToggle: Boolean,
    canSortByAccess: Boolean
  },
  data() {
    return {
      // Search props
      query: "",
      systemFilter: "",
      includeUninstalled: true,
      sortType: defaultSortType
    };
  },
  computed: {
    sort() {
      const sorterObject = this.sortOptions.find(o => o.key === this.sortType);
      return sorterObject ? sorterObject.sorter : undefined;
    },
    filterOptions() {
      return this.systemFilterOptions.filter(i => !!i);
    },
    sortOptions() {
      const sortOptions = [{
        key: "descending",
        label: "Name: A-Z",
        sorter: this.sortDescending,
        direction: "descending",
        icon: "fa-sort-alpha-down"
      }, {
        key: "ascending",
        label: "Name: Z-A",
        sorter: this.sortAscending,
        direction: "ascending",
        icon: "fa-sort-alpha-up"
      }];
      if (this.canSortByAccess) {
        sortOptions.push({
          key: "accessAscending",
          label: "Recently Opened",
          sorter: this.sortAccessAscending,
          direction: "ascending"
        }, {
          key: "accessDescending",
          label: "Seldom Opened",
          sorter: this.sortAccessDescending,
          direction: "descending"
        });
      }
      return sortOptions;
    },
    isAscending() {
      const option = this.sortOptions.find(o => o.key === this.sortType);
      if (!option) {
        return false;
      }
      return option.direction === "ascending";
    },
    selectedIcon() {
      const option = this.sortOptions.find(o => o.key === this.sortType);
      if (option.icon) {
        return option.icon;
      }
      return `fa-sort-amount-${this.isAscending ? "up" : "down"}`;
    }
  },
  methods: {
    filter(i) {
      return this.filterSystemMismatch(i) && this.filterUninstalled(i) && this.filterQueryMismatches(i);
    },
    filterUninstalled(i) {
      if (!this.hasInstalledToggle || this.includeUninstalled) {
        return true;
      }
      return i.installed;
    },
    filterQueryMismatches(i) {
      if (!this.query) {
        return true;
      }
      if (!i.title) {
        // How did we get a system/world with no title?
        return false;
      }
      return i.title.toLowerCase().includes(this.query.toLowerCase());
    },
    filterSystemMismatch(i) {
      if (this.systemFilter) {
        if (i.system) {
          return i.system === this.systemFilter;
        }
        if (i.systems && i.systems.length) {
          return i.systems.includes(this.systemFilter);
        }
      }
      return true;
    },
    clearSearch() {
      this.query = "";
    },
    resetSearchConfig() {
      this.clearSearch();
      this.includeUninstalled = true;
      this.systemFilter = "";
      this.sortType = defaultSortType;
    },
    sortAscending(a, b) {
      return installedSort(a, b) || b.title.localeCompare(a.title);
    },
    sortDescending(a, b) {
      return installedSort(a, b) || a.title.localeCompare(b.title);
    },
    sortAccessAscending(a, b) {
      return a.lastAccess < b.lastAccess ? 1 : -1;
    },
    sortAccessDescending(a, b) {
      return a.lastAccess > b.lastAccess ? 1 : -1;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PlayerNameInput"] = Vue.component(
                    "PlayerNameInput",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"forge-game-player-name\" :class=\"editable && !processing ? 'clickable' : ''\" @click=\"startEdit\"> <b-form-input v-if=\"editing\" ref=\"nameInput\" :disable=\"processing\" size=\"sm\" :value=\"player.name\" autofocus @blur=\"editName($event)\" @keyup=\"editNameKeyUp($event)\" > </b-form-input> <div v-else class=\"text-truncate\"> {{ player.name }} <i v-if=\"editable && !processing\" class=\"far fa-edit pl-3\"></i> <loading-indicator v-if=\"processing\" tag=\"span\" small label=\"\"></loading-indicator> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".forge-game-player-name { border: 1px solid transparent; /*Invisible border so that element size stays the same on hover*/ border-radius: 3px; } .forge-game-player-name.clickable { cursor: pointer; } .forge-game-player-name.clickable:hover { border-color: black; }"
    });
  },
  props: {
    player: Object,
    editable: Boolean,
    processing: Boolean
  },
  data() {
    return {
      editing: false
    };
  },
  methods: {
    startEdit() {
      if (this.editable && !this.processing) {
        this.editing = true;
      }
    },
    editNameKeyUp(event) {
      if (event.keyCode === 13) {
        this.editName(event);
      }
    },
    editName(event) {
      if (this.processing) {
        return;
      }
      this.editing = false;
      event.newValue = this.$refs.nameInput.localValue;
      this.$emit("change", event);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolCloneWorld"] = Vue.component(
                    "TableToolCloneWorld",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"modalTitle\" @hidden=\"visible = false\" @shown=\"dialogShown\"> <div v-if=\"loading\"> <loading-indicator></loading-indicator> </div> <div v-else-if=\"worlds.length === 0\">{{ t(\"Could not find any world to clone\") }}</div> <div v-else-if=\"!selectedWorld\"> <p>{{ t(\"Select the world you would like to clone.\") }}</p> <table-tool-package-list :packages=\"worlds\" default-sort-key=\"title\" default-sort=\"title\" type=\"world\" :max-description=\"maxDescription\" :action=\"cloneAction\" @selected=\"selectedWorld = $event\" > </table-tool-package-list> </div> <div v-else> <i18n :path=\"t('Cloning {0}')\" tag=\"p\"> <strong>{{ selectedWorld.title }}</strong> </i18n> <!-- No point in warning the user if the world is already offline. --> <b-alert variant=\"warning\" :show=\"!gameIsOffline && worldUsesLevelDB\"> {{ t(\"Note: The world will be shut down before cloning to avoid data corruption.\") }} </b-alert> <b-form-group class=\"mt-3\" :label=\"t('Enter the folder name to copy the world into:')\"> <b-form-input v-model=\"destinationName\" debounce=\"500\" :formatter=\"slugify\" :placeholder=\"t(`World name (for example: {{name}})`, { name: defaultFolderName })\" autofocus trim @keyup=\"inputKeyUp\" > </b-form-input> </b-form-group> <b-form-group class=\"mt-3\" :label=\"t(`Enter the new world's title:`)\"> <b-form-input v-model=\"title\" :placeholder=\"placeholder\" trim @keyup=\"inputKeyUp\"></b-form-input> </b-form-group> <b-alert v-if=\"worldExists\" variant=\"danger\" show>{{ t(\"A world already exists with this folder name\") }}</b-alert> </div> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" @click=\"cancel\">Cancel</b-button> <b-button v-show=\"selectedWorld\" variant=\"success\" :disabled=\"!validName || cloning\" @click=\"cloneWorld\"> <loading-indicator v-if=\"cloning\" tag=\"span\" small :label=\"t('Cloning world…')\"> </loading-indicator> <span v-else>{{ t(\"Clone World\") }}</span> </b-button> </template> </b-modal>",
  props: {
    game: Object,
    value: Boolean,
    maxDescription: {
      type: Number,
      default: 350
    },
    modalTitle: {
      type: String,
      default: t("Clone Game World")
    },
    titlePlaceholder: String,
    defaultName: String,
    clone: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: true,
      cloning: false,
      selectedWorld: null,
      destinationName: "",
      title: "",
      worlds: [],
      cloneAction: {
        label: t("Clone"),
        iconType: "fas fa-copy",
        variant: "text-secondary",
        event: "selected"
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    slug() {
      return Utils.slugify(this.destinationName);
    },
    worldExists() {
      return !!this.worlds.find(m => m.name === this.slug);
    },
    gameIsOffline() {
      return this.game && this.game.status === "offline";
    },
    worldUsesLevelDB() {
      if (!this.selectedWorld) {
        return false;
      }
      const world = this.worlds.find(m => m.id === this.selectedWorld.name);
      return Utils.compareFoundryVersions(world && world.coreVersion ? world.coreVersion : "0", "11") >= 0;
    },
    validName() {
      return this.slug.length > 0 && !this.worldExists;
    },
    placeholder() {
      return this.titlePlaceholder || (this.selectedWorld ? t("{{title}} (Copy)", {
        title: this.selectedWorld.title
      }) : "");
    },
    defaultFolderName() {
      return this.defaultName || (this.selectedWorld ? t("{{name}}-copy", {
        name: this.selectedWorld.name
      }) : "");
    }
  },
  methods: {
    dialogShown() {
      this.selectedWorld = this.game && !this.game.table ? {
        title: this.game.title,
        name: this.game.world
      } : null;
      this.destinationName = this.defaultFolderName;
      this.cloning = false;
      this.reloadData();
    },
    async reloadData() {
      this.loading = true;
      const response = await Utils.api(`data/worlds`);
      if (!(response instanceof Array)) {
        const error = response && response.error || "";
        UI.alert("danger", t("ERROR.ErrorRetrievingData", {
          error
        }));
      } else {
        this.worlds = response;
        if (this.worldExists) {
          this.destinationName = "";
        }
      }
      this.loading = false;
    },
    slugify(input) {
      return Utils.slugify(input);
    },
    async cloneWorld() {
      if (!this.validName || this.cloning) {
        return;
      }
      if (this.clone) {
        this.cloning = true;
        const response = await Utils.api("data/worlds/clone", {
          source: this.selectedWorld.name,
          destination: this.slug,
          title: this.title
        });
        if (response.error) {
          UI.alert("danger", t("ERROR.ErrorCloningWorld", {
            error: response.error
          }), true, 10000);
        } else {
          UI.alert("success", t(`SUCCESS.WorldClonedSuccessfully`), true, 10000);
        }
        this.title = "";
        this.cloning = false;
        this.visible = false;
      } else {
        this.$emit("clone-world", this.destinationName, this.title);
      }
    },
    inputKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.cloneWorld();
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolDelete"] = Vue.component(
                    "TableToolDelete",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"t('View Data Storage')\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <div v-if=\"loading\"> <loading-indicator></loading-indicator> </div> <div v-else-if=\"emptyData\">{{ t(\"Your Data folder is completely empty!\") }}</div> <div v-else> <b-tabs pills card justified> <!-- Worlds Tab --> <b-tab v-if=\"worlds.length\" ref=\"worlds\" :title=\"t('Worlds')\" :active=\"active === 'worlds'\"> <p>{{ t(\"Select the world to delete. A confirmation will be required before the world is deleted.\") }}</p> <p> <strong>{{ t(\"Note:\") }}</strong> {{ t( \"If a game is currently online with the world loaded, you must first stop the server for any change to take effect.\" ) }} </p> <table-tool-package-list :packages=\"worlds\" type=\"world\" :default-sort=\"tableSettings.world.currentSortColumn\" :default-current-page=\"tableSettings.world.currentActivePage\" :max-description=\"maxDescription\" :action=\"deleteAction\" @selected=\"deleteWorld\" @update-config=\"setCurrentTableParameters\" > </table-tool-package-list> </b-tab> <!-- Systems Tab --> <b-tab v-if=\"systems.length\" ref=\"systems\" :title=\"t('Systems')\" :active=\"active === 'systems'\"> <p>{{ t(\"Select the system to delete. A confirmation will be required before the system is deleted.\") }}</p> <table-tool-package-list :packages=\"systems\" type=\"system\" :default-sort=\"tableSettings.system.currentSortColumn\" :default-current-page=\"tableSettings.system.currentActivePage\" :max-description=\"maxDescription\" :action=\"deleteAction\" @selected=\"deleteSystem\" @update-config=\"setCurrentTableParameters\" > </table-tool-package-list> </b-tab> <!-- Modules Tab --> <b-tab v-if=\"modules.length\" ref=\"modules\" :title=\"t('Modules')\" :active=\"active === 'modules'\"> <p>{{ t(\"Select the module to delete. A confirmation will be required before the module is deleted.\") }}</p> <table-tool-package-list :packages=\"modules\" type=\"module\" :default-sort=\"tableSettings.module.currentSortColumn\" :default-current-page=\"tableSettings.module.currentActivePage\" :max-description=\"maxDescription\" :action=\"deleteAction\" @selected=\"deleteModule\" @update-config=\"setCurrentTableParameters\" > </table-tool-package-list> </b-tab> <!-- Orphans Tab --> <b-tab v-if=\"orphans.length\" ref=\"orphans\" :title=\"t('Others')\" :active=\"active === 'orphans'\"> <p> {{ t( \"These files are those that are neither part of a world, system or module. In theory, you should only have your Foundry log files listed here, but if Foundry VTT fails to update or install a custom module via manifest for example, it could leave some orphan files as well.\" ) }} </p> <p>{{ t(\"On click, the file will be deleted, without requiring a confirmation from you.\") }}</p> <table-tool-package-list :packages=\"directories\" type=\"orphanDirectories\" pkg-heading=\"Directories\" default-sort-key=\"file\" :default-sort=\"tableSettings.orphanDirectories.currentSortColumn\" :default-current-page=\"tableSettings.orphanDirectories.currentActivePage\" :max-description=\"0\" :action=\"deleteAction\" @selected=\"deleteFile\" @update-config=\"setCurrentTableParameters\" > </table-tool-package-list> <table-tool-package-list :packages=\"files\" default-sort-key=\"file\" :default-sort=\"tableSettings.orphanFiles.currentSortColumn\" type=\"orphanFiles\" pkg-heading=\"Files\" :default-current-page=\"tableSettings.orphanFiles.currentActivePage\" :max-description=\"0\" :action=\"deleteAction\" @selected=\"deleteFile\" @update-config=\"setCurrentTableParameters\" > </table-tool-package-list> </b-tab> <!-- Query secret modal  --> <table-tool-delete-query v-model=\"showDeleteQuery\" :secret=\"querySecret\" :name=\"queryName\" :type=\"queryType\" :in-progress=\"deleteWorldInProgress\" @delete=\"queryDelete\" ></table-tool-delete-query> </b-tabs> </div> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" size=\"lg\" @click=\"cancel()\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    maxDescription: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      loading: true,
      worlds: [],
      systems: [],
      modules: [],
      orphans: [],
      active: "worlds",
      tableSettings: {
        world: {
          currentSortColumn: "id",
          currentActivePage: 1
        },
        module: {
          currentSortColumn: "id",
          currentActivePage: 1
        },
        system: {
          currentSortColumn: "id",
          currentActivePage: 1
        },
        orphanFiles: {
          currentSortColumn: "file",
          currentActivePage: 1
        },
        orphanDirectories: {
          currentSortColumn: "file",
          currentActivePage: 1
        }
      },
      querySecret: null,
      queryName: null,
      queryType: null,
      queryCallback: null,
      showDeleteQuery: false,
      deleteAction: {
        label: t("Delete"),
        iconType: "fas fa-trash-alt",
        variant: "text-danger",
        event: "selected"
      },
      deleteWorldInProgress: false
    };
  },
  watch: {
    showDeleteQuery(val) {
      if (!val) {
        this.querySecretHidden();
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    emptyData() {
      return this.worlds.length === 0 && this.systems.length === 0 && this.modules.length === 0 && this.orphans.length === 0;
    },
    directories() {
      return this.orphans.filter(o => o.directory);
    },
    files() {
      return this.orphans.filter(o => !o.directory);
    }
  },
  methods: {
    dialogShown() {
      this.reloadData();
    },
    async reloadData(type) {
      this.loading = true;
      const packages = await Utils.api(`data/files`);
      this.worlds = packages.worlds;
      this.systems = packages.systems;
      this.modules = packages.modules;
      this.orphans = packages.orphans;
      this.loading = false;
      if (!type && this.worlds.length) {
        type = "worlds";
      }
      if (!type && this.systems.length) {
        type = "systems";
      }
      if (!type && this.modules.length) {
        type = "modules";
      }
      if (!type && this.orphans.length) {
        type = "orphans";
      }
      this.active = type;
    },
    async setCurrentTableParameters(type, sortBy, currentPage) {
      this.tableSettings[type].currentSortColumn = sortBy;
      this.tableSettings[type].currentActivePage = currentPage;
    },
    async deleteWorld(world) {
      const secret = await this._querySecret("World", world.title, world.secret, true);
      if (!secret) {
        return;
      }
      this.deleteWorldInProgress = true;
      const response = await Utils.api(`data/worlds/delete`, {
        name: world.name,
        secret
      });
      console.log("Delete response : ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`{{type}} {{- title}} deleted successfully`, {
          type: t("World"),
          title: `<strong>'${Utils.escapeHTML(world.title)}'</strong>`
        }), true, 10000);
      }
      this.reloadData("worlds");
      this.deleteWorldInProgress = false;
      this.showDeleteQuery = false;
    },
    async deleteSystem(system) {
      const secret = await this._querySecret("System", system.title, system.secret);
      if (!secret) {
        return;
      }
      const response = await Utils.api(`data/systems/delete`, {
        name: system.name,
        secret
      });
      console.log("Delete response : ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`{{type}} {{- title}} deleted successfully`, {
          type: t("System"),
          title: `<strong>'${Utils.escapeHTML(system.title)}'</strong>`
        }), true, 10000);
      }
      this.reloadData("systems");
    },
    async deleteModule(module) {
      const secret = await this._querySecret("Module", module.title, module.secret);
      if (!secret) {
        return;
      }
      const response = await Utils.api(`data/modules/delete`, {
        name: module.name,
        secret
      });
      console.log("Delete response : ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`{{type}} {{- title}} deleted successfully`, {
          type: t("Module"),
          title: `<strong>'${Utils.escapeHTML(module.title)}'</strong>`
        }), true, 10000);
      }
      this.reloadData("modules");
    },
    async deleteFile(file) {
      const response = await Utils.api(`data/files/delete`, {
        name: file.file,
        secret: file.secret,
        type: file.type
      });
      console.log("Delete response : ", response);
      if (response.error) {
        UI.alert("danger", response.error);
      } else if (response.success) {
        UI.alert("success", t(`{{type}} {{- title}} deleted successfully`, {
          type: t("File"),
          title: `<strong>'${Utils.escapeHTML(file.file)}'</strong>`
        }), true, 10000);
      }
      this.reloadData("orphans");
    },
    async _querySecret(type, name, secret, persist = false) {
      const userSecret = await new Promise(resolve => {
        this.userSecret = "";
        this.queryName = name;
        this.queryType = type;
        this.queryCallback = resolve;
        this.querySecret = secret;
        this.showDeleteQuery = true;
      });
      this.showDeleteQuery = userSecret ? persist : false;
      this.queryName = null;
      this.queryType = null;
      this.queryCallback = null;
      this.querySecret = null;
      return userSecret;
    },
    queryDelete(secret) {
      if (secret !== this.querySecret) {
        return;
      }
      if (this.queryCallback) {
        this.queryCallback(secret);
      }
    },
    querySecretHidden() {
      if (this.queryCallback) {
        this.queryCallback(null);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolDeleteQuery"] = Vue.component(
                    "TableToolDeleteQuery",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"md\" :title=\"title || t(`Delete {{name}}`, { name })\" @ok=\"queryOk\" @hidden=\"visible = false\" @shown=\"userSecret = null\" > <slot> <p v-if=\"inProgress\">{{ t(\"TABLE_TOOL.OperationInProgress\", { operation: verb }) }}</p> <i18n v-else :path=\"t('Please confirm the deletion of the {0} by entering the following code in the entry below {1}.')\" tag=\"p\" > {{ type }} <strong>{{ secret }}</strong> </i18n> <div> {{ t( \"Please note that once deleted, the operation is irreversible, so make sure you have a local backup if you don't want to lose any data.\" ) }} </div> </slot> <div class=\"text-center\"> <b-form-input v-model=\"userSecret\" autofocus trim :placeholder=\"placeholder || t('Enter deletion code: {{code}}', { code: secret })\" class=\"w-100\" @keyup=\"queryKeyUp\" > </b-form-input> </div> <template #modal-footer=\"{ ok, cancel }\"> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button variant=\"danger\" :disabled=\"inProgress || userSecret !== secret\" @click=\"ok\"> <loading-indicator v-if=\"inProgress\" tag=\"span\" small :label=\"t('TABLE_TOOL.OperationInProgress', { operation: verb })\" > </loading-indicator> <span v-else>{{ verb }}</span> </b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    name: String,
    type: String,
    secret: String,
    placeholder: String,
    title: String,
    verb: {
      type: String,
      default: t("Delete")
    },
    inProgress: Boolean
  },
  data() {
    return {
      userSecret: null
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    queryKeyUp(ev) {
      if (ev.keyCode === 13 && this.userSecret === this.secret) {
        this.queryOk(ev);
      }
    },
    queryOk(ev) {
      ev.preventDefault();
      this.$emit("delete", this.userSecret);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolExport"] = Vue.component(
                    "TableToolExport",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"title\" @hidden=\"visible = false\" @shown=\"dialogShown\"> <div v-if=\"loading\"> <loading-indicator></loading-indicator> </div> <div v-else-if=\"emptyData\" v-text=\"t('Could not find any {{type}} to export', { type: Utils.capitalize(type) })\" ></div> <div v-else-if=\"type === 'worlds'\"> <p>{{ t(\"You can export your Foundry Worlds and save them as backups, or to use them locally.\") }}</p> <p> {{ t( \"Note that the worlds will still refer to your content from your assets library, which allows the worlds export to be smaller and easier to use. It will work without a problem on a local machine as long as you have internet access.\" ) }} </p> <p> {{ t( \"An interface to export/synchronize the assets library with a local folder and migrate world data to use the local files is coming as a feature to the Forge in the near future.\" ) }} </p> <table-tool-package-list :packages=\"worlds\" default-sort-key=\"title\" default-sort=\"title\" type=\"world\" :max-description=\"maxDescription\" :action=\"downloadAction('text-primary')\" @selected=\"exportWorld($event)\" > </table-tool-package-list> </div> <div v-else-if=\"type === 'modules'\"> <i18n :path=\" t( `You can export your Foundry Modules that include Compendiums in case you have a custom compendium module, such as The Forge's {0} module.` ) \" tag=\"p\" > <a href=\"https://forums.forge-vtt.com/t/how-to-share-content-between-worlds/5653\" target=\"_blank\">{{ t(\"Shared Compendium\") }}</a> </i18n> <p> <b>{{ t(\"Note:\") }}</b> {{ t( \"If you are exporting a module that was installed through the Bazaar, the module will not be usable in a local system, but you can copy its compendiums over to overwrite your local files if needed.\" ) }} </p> <table-tool-package-list :packages=\"compendiums\" default-sort-key=\"title\" default-sort=\"title\" type=\"module\" :max-description=\"maxDescription\" :action=\"downloadAction('text-success')\" @selected=\"exportModule($event)\" > </table-tool-package-list> </div> <template #modal-footer=\"{ cancel }\"> <b-button v-b-tooltip.hover variant=\"primary\" :title=\"t('Export all modules, including non-compendium modules.')\" @click=\"exportAll\" >{{ t(\"Export All\") }}</b-button > <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    type: {
      type: String,
      default: "worlds"
    },
    title: {
      type: String,
      default: t("Export Game Content")
    },
    maxDescription: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      loading: true,
      worlds: [],
      modules: []
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    compendiums() {
      return this.modules.filter(m => m.packs > 0);
    },
    emptyData() {
      return this.worlds.length === 0 && this.compendiums.length === 0;
    }
  },
  methods: {
    dialogShown() {
      this.reloadData();
    },
    async reloadData(type) {
      this.loading = true;
      let response = null;
      if (this.type === "worlds") {
        response = await Utils.api(`data/worlds`);
      } else if (this.type === "modules") {
        response = await Utils.api(`data/modules`);
      }
      if (!(response instanceof Array)) {
        const error = response && response.error || "";
        UI.alert("danger", t("ERROR.ErrorRetrievingData", {
          error
        }));
      } else {
        if (this.type === "worlds") {
          this.worlds = response;
        } else if (this.type === "modules") {
          this.modules = response;
        }
      }
      this.loading = false;
    },
    downloadAction(variant = "text-primary") {
      return {
        label: t("Download"),
        iconType: "fas fa-cloud-download-alt",
        variant: `${variant}`,
        event: "selected"
      };
    },
    async exportWorld(world) {
      window.location = `/setup/export/${world.id}`;
    },
    async exportModule(module) {
      window.location = `/setup/modules/export/${module.id}`;
    },
    async exportAll() {
      if (this.type === "worlds") {
        window.location = "/setup/export";
      } else if (this.type === "modules") {
        window.location = "/setup/modules/export";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolPackageList"] = Vue.component(
                    "TableToolPackageList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* global MB */
var _default = exports.default = {
  template: "<div class=\"pt-2\"> <h2 v-if=\"pkgHeading\">{{ pkgHeading }}</h2> <b-alert :show=\"hasSizeAlert\" variant=\"info\" v-html=\"getSizeMessageContent()\" /> <b-table id=\"packages-table\" hover striped stacked=\"lg\" show-empty small sort-icon-left head-variant=\"light\" class=\"mb-0\" :sort-by.sync=\"sortBy\" :sort-desc.sync=\"sortDesc\" :items=\"packagesList\" :fields=\"packageFields\" :per-page=\"perPage\" :current-page=\"currentPage\" :primary-key=\"sortKey\" :tbody-transition-props=\"transitionProps\" > <template #cell(title)=\"{ item }\"> <span v-if=\"item.title.length > 30\" v-b-tooltip.hover.noninteractive=\"item.title\"> {{ `${item.title.substring(0, 29)}…` }} </span> <span v-else> {{ item.title }} </span> </template> <template #cell(size)=\"{ item }\"> {{ bytesToHuman(item.size) }} <i v-if=\"isDangerSize(item.size)\" class=\"fas fa-exclamation-triangle text-danger\" /> <i v-else-if=\"isWarningSize(item.size)\" class=\"fas fa-exclamation-triangle text-warning\" /> <i v-else-if=\"isInfoSize(item.size)\" class=\"fas fa-exclamation-circle text-info\" /> </template> <template #cell(info)=\"{ item }\"> <i v-b-popover.hover=\"popoverConfig(item)\" class=\"fas fa-info-circle\"></i> </template> <template #cell(action)=\"{ item }\"> <a href=\"#\" class=\"text-center\" @click.prevent=\"$emit(action.event, item)\"> <i :label=\"action.label\" :class=\"`${action.iconType} ${action.variant}`\"></i> </a> </template> </b-table> <div v-if=\"packagesList.length > perPage\" class=\"mt-2\"> <b-pagination v-model=\"currentPage\" :total-rows=\"packagesList.length\" :per-page=\"perPage\" align=\"center\" first-number last-number > </b-pagination> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: "table#packages-table th, table#packages-table td { border-top: none; } table#packages-table .th-border-success { border-right: 1px var(--success) solid; } table#packages-table .td-border-success { border-bottom: 1px var(--success) solid; } table#packages-table .th-border-info { border-right: 1px var(--info) solid; } table#packages-table .td-border-info { border-bottom: 1px var(--info) solid; } table#packages-table .th-border-primary { border-right: 1px var(--primary) solid; } table#packages-table .td-border-primary { border-bottom: 1px var(--primary) solid; } table#packages-table .th-border-secondary { border-right: 1px var(--secondary) solid; } table#packages-table .td-border-secondary { border-bottom: 1px var(--secondary) solid; } .flip-list-move { transition: transform 1s; }"
    });
  },
  name: "TableToolPackageList",
  props: {
    packages: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    },
    defaultSort: {
      type: String,
      default: "id"
    },
    defaultSortKey: {
      type: String,
      default: "id"
    },
    pkgHeading: {
      type: String,
      default: undefined
    },
    showSize: {
      type: Boolean,
      default: true
    },
    maxDescription: {
      type: Number,
      default: 350
    },
    defaultCurrentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    action: {
      type: Object,
      default: () => ({
        name: "Action",
        variant: "text-success"
      })
    }
  },
  data() {
    return {
      sortBy: this.defaultSort,
      sortKey: this.defaultSortKey,
      sortDesc: false,
      showSearch: false,
      searchFilter: "",
      searchType: "any",
      viewAll: false,
      hash: null,
      transitionProps: {
        name: "flip-list"
      },
      packageContent: [],
      currentPage: this.defaultCurrentPage
    };
  },
  watch: {
    sortBy() {
      this.$emit("update-config", this.type, this.sortBy, this.currentPage);
    },
    currentPage() {
      this.$emit("update-config", this.type, this.sortBy, this.currentPage);
    }
  },
  computed: {
    packageFields() {
      switch (this.type) {
        case "world":
          {
            const worldFields = this.allPackageFields("border-info");
            return [worldFields.title, worldFields.system, worldFields.size, worldFields.worldVersion, worldFields.info, worldFields.action];
          }
        case "system":
          {
            const systemFields = this.allPackageFields("border-success");
            return [systemFields.id, systemFields.title, systemFields.size, systemFields.version, systemFields.info, systemFields.action];
          }
        case "module":
          {
            const moduleFields = this.allPackageFields("border-primary");
            // prettier-ignore
            return [moduleFields.title, moduleFields.size, moduleFields.version, moduleFields.info, moduleFields.action];
          }
        case "orphanFiles":
        case "orphanDirectories":
          {
            const orphanFields = this.allPackageFields("border-secondary");
            // prettier-ignore
            return [orphanFields.orphanName, orphanFields.size, orphanFields.action];
          }
        default:
          {
            return [];
          }
      }
    },
    packagesList() {
      return this.packages;
    },
    hasSizeAlert() {
      return this.packagesList.some(item => this.isInfoSize(item.size) || this.isWarningSize(item.size) || this.isDangerSize(item.size));
    }
  },
  methods: {
    bytesToHuman(size) {
      return Utils.bytesToHuman(size);
    },
    allPackageFields(customBorderClass) {
      return {
        name: {
          key: "title",
          label: t("Name"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        id: {
          key: "id",
          label: t("ID"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        title: {
          key: "title",
          label: t("Title"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        system: {
          key: "system",
          label: t("System"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        size: {
          key: "size",
          label: t("Size"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        version: {
          key: "version",
          label: t("Version"),
          sortable: false,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        type: {
          key: "type",
          label: t("Type"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        worldVersion: {
          key: "coreVersion",
          label: t("Version"),
          sortable: false,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        orphanName: {
          key: "file",
          label: t("Name"),
          sortable: true,
          stickyColumn: true,
          tdClass: `py-3 pl-3 align-middle td-${customBorderClass}`,
          thClass: `pl-3 th-${customBorderClass}`
        },
        delete: {
          key: "delete",
          label: t("Delete"),
          sortable: false,
          stickyColumn: true,
          tdClass: `py-3 align-middle text-center td-${customBorderClass} text-danger`,
          thClass: `text-center th-${customBorderClass}`
        },
        info: {
          key: "info",
          label: t("Info"),
          sortable: false,
          stickyColumn: true,
          tdClass: `py-3 align-middle text-center td-${customBorderClass} text-info`,
          thClass: `text-center th-${customBorderClass}`
        },
        action: {
          key: "action",
          label: this.action.label,
          sortable: false,
          stickyColumn: true,
          tdClass: `py-3 align-middle text-center td-${customBorderClass} text-info`,
          thClass: `text-center th-${customBorderClass}`
        }
      };
    },
    popoverConfig(data) {
      if (!this.maxDescription) {
        return null;
      }
      const description = `<div style="overflow: hidden">${data.description.slice(0, this.maxDescription)}${data.description.length > this.maxDescription ? "…" : ""}</div>`;
      switch (this.type) {
        case "world":
          return {
            placement: "top",
            content: description,
            title: `${data.title} (${data.name})`,
            html: true,
            show: 500,
            hide: 100
          };
        case "system":
          return {
            placement: "top",
            content: description,
            title: `${data.title} (${data.author})`,
            html: true,
            show: 500,
            hide: 100
          };
        case "module":
          return {
            placement: "top",
            content: description,
            title: `${data.title} (${data.author})`,
            html: true,
            show: 500,
            hide: 100
          };
        case "orphanFiles":
        case "orphanDirectories":
          return {
            placement: "top",
            content: description,
            title: `${data.name} (${data.author})`,
            html: true,
            show: 500,
            hide: 100
          };
        default:
          return {};
      }
    },
    isDangerSize(size) {
      switch (this.type) {
        case "orphanDirectories":
          return size > 150 * MB;
        case "orphanFiles":
          return size > 15 * MB;
        case "world":
          return size > 150 * MB;
        default:
          return false;
      }
    },
    isWarningSize(size) {
      switch (this.type) {
        case "orphanDirectories":
          return size > 100 * MB;
        case "orphanFiles":
          return size > 10 * MB;
        case "world":
          return size > 100 * MB;
        default:
          return false;
      }
    },
    isInfoSize(size) {
      switch (this.type) {
        case "world":
          return size > 50 * MB;
        default:
          return false;
      }
    },
    getSizeMessageContent() {
      switch (this.type) {
        case "orphanDirectories":
          return t("Large directory detected. If it's not needed, feel free to delete it!");
        case "orphanFiles":
          return t("Large file detected. If it's not needed, feel free to delete it!");
        case "world":
          return t("Large world detected. If you are experiencing long loading times, please click {{- here}} to see tips to reduce world size.", {
            here: `<a class="alert-link" href="https://forums.forge-vtt.com/docs?topic=12105" target="_blank">${t("here")}</a>`
          });
        default:
          return "";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TableToolSharedCompendium"] = Vue.component(
                    "TableToolSharedCompendium",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal size=\"lg\" :visible=\"visible\" :title=\"t('Create Shared Compendium')\" centered @hidden=\"visible = false\" @shown=\"dialogShown\" > <div v-if=\"loading\"> <loading-indicator></loading-indicator> </div> <div v-else> <div class=\"shared-compendium-tool\"> <div class=\"m-2\"> {{ t( \"The Forge will create and import a module with empty Compendiums. You can enable the module in your worlds and share content between them through its compendiums.\" ) }} </div> <div class=\"text-center\"> <b-form-input v-model=\"compendiumName\" :placeholder=\"t('Name of the Compendium module to create')\" autofocus trim @keyup=\"inputKeyUp\" /> <b-form-select v-model=\"compendiumSystem\" class=\"mt-3\" :options=\"systems\" :disabled=\"perPackSystems\"> <template #first> <b-form-select-option :value=\"null\">-- {{ t(\"Please select a default system\") }} --</b-form-select-option> </template> </b-form-select> <b-form-textarea v-model=\"compendiumDesc\" class=\"mt-3\" :placeholder=\"t('Compendium Description')\" rows=\"3\" max-rows=\"6\" /> </div> <div class=\"ml-2 mt-2\"> <b-link href=\"#\" :aria-expanded=\"advanced ? 'true' : 'false'\" aria-controls=\"advanced-collapse\" @click=\"advanced = !advanced\" > <i :class=\"advanced ? 'fas fa-chevron-down' : 'fas fa-chevron-right'\"></i> {{ t(\"Customize Compendium Content\") }} </b-link> </div> <b-collapse id=\"advanced-collapse\" v-model=\"advanced\" class=\"advanced-collapse mt-2\"> <b-table ref=\"packsList\" class=\"compendium-packs-list\" striped small sticky-header foot-clone :fields=\"fields\" :items=\"packs\" > <template #cell(add)=\"data\"> <span v-if=\"!validEntry(data)\" v-b-tooltip.hover.top=\"issueTooltip(data)\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </span> </template> <template #cell(name)=\"data\"> <b-form-input v-model=\"data.item.name\" class=\"compendium-entry-name\" :placeholder=\"t('Enter a name')\" @keyup=\"slugifyEntry(data)\" ></b-form-input> </template> <template #cell(type)=\"data\"> <b-form-select v-model=\"data.item.type\" :options=\"entityOptions\"></b-form-select> </template> <template #cell(system)=\"data\"> <b-form-select v-if=\"needSystem(data.item)\" v-model=\"data.item.system\" :options=\"systems\" :disabled=\"!!compendiumSystem\" > <template #first> <b-form-select-option :value=\"null\">-- {{ t(\"Please select an option\") }} --</b-form-select-option> </template> </b-form-select> </template> <template #cell(delete)=\"data\"> <b-link href=\"#\" @click=\"deleteRow(data.index)\"><i class=\"fas fa-trash\"></i></b-link> </template> <template #foot(name)> <b-form-input v-model=\"dummyName\" :placeholder=\"t('Create a new entry')\" @keyup=\"addRow\"></b-form-input> </template> <template #foot(type)> <b-form-select v-model=\"dummyType\" :options=\"entityOptions\" @change=\"addRow\"> <template #first> <b-form-select-option :value=\"null\" disabled >-- {{ t(\"Please select an option\") }} --</b-form-select-option > </template> </b-form-select> </template> <template #foot(system)> &nbsp; </template> </b-table> </b-collapse> </div> </div> <b-alert variant=\"danger\" :show=\"moduleExists\">{{ t(\"A module with the same name already exists\") }}</b-alert> <b-alert variant=\"danger\" :show=\"!hasPacks\">{{ t(\"Cannot create a compendium that has no content\") }}</b-alert> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"primary\" class=\"mr-auto\" @click=\"openInformation\" ><i class=\"fas fa-question-circle\"></i> {{ t(\"More Information\") }}</b-button > <b-button variant=\"success\" :disabled=\"!canCreate\" @click=\"createCompendium\">{{ t(\"Create Compendium\") }}</b-button> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".shared-compendium-tool .add-column { width: 40px; } .shared-compendium-tool .compendium-packs-list { max-height: calc(100vh - 550px); } .shared-compendium-tool .compendium-packs-list thead tr th { border-top: 0px; } .shared-compendium-tool .compendium-packs-list tfoot tr th { position: -webkit-sticky; position: sticky; bottom: -1px; z-index: 2; color: #212529; background-color: #fff; border-bottom: 0px; }"
    });
  },
  props: {
    value: Boolean,
    type: {
      type: String,
      default: "worlds"
    },
    maxDescription: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      loading: true,
      advanced: false,
      modules: [],
      systems: [],
      systemsLoaded: false,
      dummyName: null,
      dummyType: null,
      compendiumName: "",
      compendiumSystem: null,
      compendiumDesc: "",
      defaultPacks: [{
        name: t("Actors"),
        type: "Actor"
      }, {
        name: t("Monsters"),
        type: "Actor"
      }, {
        name: t("Spells"),
        type: "Item"
      }, {
        name: t("Items"),
        type: "Item"
      }, {
        name: t("Cards"),
        type: "Cards"
      }, {
        name: t("Class Features"),
        type: "Item"
      }, {
        name: t("Monster Features"),
        type: "Item"
      }, {
        name: t("Journal Entries"),
        type: "JournalEntry"
      }, {
        name: t("Scenes"),
        type: "Scene"
      }, {
        name: t("Macros"),
        type: "Macro"
      }, {
        name: t("Roll Tables"),
        type: "RollTable"
      }],
      fields: [{
        key: "add",
        label: "",
        class: "align-middle text-center",
        tdClass: "add-column"
      }, {
        key: "name",
        label: t("Name")
      }, {
        key: "type",
        label: t("Type")
      }, {
        key: "system",
        label: t("System")
      }, {
        key: "delete",
        label: "",
        class: "align-middle text-center"
      }],
      packs: [],
      entityOptions: [{
        value: "Actor",
        text: t("Actor")
      }, {
        value: "Item",
        text: t("Item")
      }, {
        value: "Cards",
        text: t("Cards")
      }, {
        value: "JournalEntry",
        text: t("Journal Entry")
      }, {
        value: "Macro",
        text: t("Macro")
      }, {
        value: "RollTable",
        text: t("Roll Table")
      }, {
        value: "Playlist",
        text: t("Playlist")
      }, {
        value: "Scene",
        text: t("Scene")
      }, {
        value: "Adventure",
        text: t("Adventure")
      }]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    slug() {
      return Utils.slugify(this.compendiumName);
    },
    moduleName() {
      return `forge-vtt-shared-compendiums-${this.slug}`;
    },
    moduleExists() {
      return !!this.modules.find(m => m.name === this.moduleName);
    },
    validName() {
      return this.slug.length > 0 && !this.moduleExists;
    },
    validEntryNames() {
      const notBlankNames = this.packs.filter(v => v.name);
      return notBlankNames.length == this.packs.length;
    },
    validSystems() {
      // Either a default system has been set or the specific system has been set.
      if (this.compendiumSystem) {
        return true;
      }
      const noSystem = this.packs.find(p => this.needSystem(p) && !p.system);
      return !noSystem;
    },
    hasPacks() {
      return this.packs.length > 0;
    },
    canCreate() {
      return this.validName && this.validEntryNames && this.validSystems && this.hasPacks;
    },
    perPackSystems() {
      return this.packs.some(p => this.needSystem(p) && p.system);
    }
  },
  methods: {
    dialogShown() {
      this.reloadData();
      //reset form values
      this.packs = Utils.duplicate(this.defaultPacks);
      this.compendiumName = "";
      this.compendiumSystem = null;
      this.compendiumDesc = "";
    },
    async reloadData(type) {
      this.loading = true;
      const response = await Utils.api(`data/modules`);
      if (response instanceof Array) {
        this.modules = response;
      }
      await this.loadSystems();
      this.loading = false;
    },
    async createCompendium() {
      if (!this.canCreate) {
        return;
      }
      const typeCount = {};
      const packs = this.packs
      // Make sure this is on the list of valid entities
      .filter(i => this.entityOptions.find(e => e.value == i.type))
      // Create the slug/pathname, incrementing each entity type to ensure uniqueness
      .map(i => {
        const type = Utils.slugify(i.type);
        typeCount[type] = (typeCount[type] || 0) + 1;
        const slug = `${type}-${typeCount[type]}-${Utils.slugify(i.name)}`;
        const data = {
          name: slug,
          label: t(`{{name}} (Shared)`, {
            name: i.name
          }),
          path: `packs/${slug}.db`,
          entity: i.type,
          type: i.type,
          package: this.moduleName
        };
        if (i.system) {
          data.system = i.system;
        }
        return data;
      });
      const packFolders = [{
        name: this.compendiumName,
        sorting: "m",
        color: "#3f8230",
        // $forgeGreenDark from /sass/_variables.scss
        packs: packs.map(data => data.name)
      }];
      const description = DOMPurify.sanitize(marked(this.compendiumDesc, {
        breaks: true,
        headerIds: false
      }));
      const manifest = {
        id: this.moduleName,
        name: this.moduleName,
        title: `${this.compendiumName} (Shared Compendiums)`,
        description: `${description} <br/><div style="border: 1px solid #eee;border-left-width: .25rem;border-left-color: #f0ad4e;border-radius: .25rem;padding: 10px;">
        <h5 style="margin:0px;">Shared Compendium</h5>
        <p style="margin-bottom:0px;">This module allows you to share compendiums between your worlds.</p>
        <p style="margin-bottom:0px;">It cannot be auto-updated, therefore it cannot overwrite your compendiums and is therefore <strong>safe to unlock</strong>.</p></div>`,
        version: "1.0",
        minimumCoreVersion: "0.6.0",
        compatibleCoreVersion: "11",
        compatibility: {
          minimum: "0.6.0",
          verified: "11"
        },
        author: "The Forge",
        // v9
        authors: [{
          name: "The Forge"
        }],
        // v10
        packs,
        packFolders
      };
      if (this.compendiumSystem) {
        manifest.relationships = {
          systems: [{
            id: this.compendiumSystem
          }]
        };
      }
      const zip_file = new JSZip();
      zip_file.file(`${this.slug}/packs/`, null, {
        dir: true
      });
      zip_file.file(`${this.slug}/module.json`, JSON.stringify(manifest, null, 2));
      for (let pack of packs) {
        zip_file.file(`${this.slug}/${pack.path}`, "");
      }
      const blob = await zip_file.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        streamFiles: true,
        compressionOptions: {
          level: 1
        }
      });
      const formData = new FormData();
      formData.append("type", "module");
      formData.append("zip", blob);
      const response = await Utils.api("data/import", formData, {
        json: false
      });
      if (response.error) {
        UI.alert("danger", t(`Error importing Shared Compendium: {{- error}}`, {
          error: response.error
        }), true, 10000);
      } else {
        UI.alert("success", t(`New Shared Compendium module imported successfully. Click {{- link}} to view.`, {
          link: `<a href="bazaar#foundry=module&has=custom&package=${Utils.escapeHTML(this.moduleName)}">${t("here")}</a>`
        }), true, 10000);
      }
      this.visible = false;
    },
    async loadSystems() {
      if (this.systemsLoaded) {
        return;
      }

      // Find all the user's installed systems
      const installedSystems = await Utils.api("data/systems");
      if (installedSystems.error) {
        UI.alert("danger", t("ERROR.ErrorRetrievingData", {
          error: installedSystems.error
        }));
        return;
      }
      // For each installed system get the package information and add it to the installed systems list
      this.systems = installedSystems.map(s => {
        return {
          value: s.id,
          text: s.title
        };
      }).sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
      this.systemsLoaded = true;
    },
    inputKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.createCompendium();
      }
    },
    openInformation() {
      window.open("https://forums.forge-vtt.com/t/how-to-share-content-between-worlds/5653", "_blank").focus();
    },
    slugifyEntry(data) {
      data.item.slug = Utils.slugify(data.item.name);
    },
    validEntry(data) {
      return data.item.name != "" && (this.compendiumSystem || !this.needSystem(data.item) || data.item.system);
    },
    needSystem(item) {
      return ["Actor", "Item"].includes(item.type);
    },
    issueTooltip(data) {
      if (data.item.name == "") {
        return t("Name cannot be blank");
      }
      if (this.needSystem(data.item) && !(this.compendiumSystem || data.item.system)) {
        return t("System is not defined");
      }
      return "";
    },
    addRow(ev) {
      if (!this.$data.dummyName && !this.$data.dummyType) {
        return;
      }
      const name = this.$data.dummyName || "";
      const type = this.$data.dummyType || "Actor";
      this.packs.push({
        name: name,
        type: type
      });
      this.$data.dummyName = "";
      this.$data.dummyType = null;
      this.focusLastInput();
    },
    deleteRow(idx) {
      this.packs.splice(idx, 1);
    },
    focusLastInput() {
      this.$nextTick(() => {
        const table = $(this.$refs.packsList.$el).closest(".b-table-sticky-header");
        // scroll to the bottom so the newly created line is in view.  Technically, focus will do this too,
        // except that the sticky footer will cover the last entry if it's already scrolled to the bottom.
        table.scrollTop(table.prop("scrollHeight"));
        $(".compendium-entry-name", this.$refs.packsList.$el).last().focus();
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["UserManagerAssignPlayers"] = Vue.component(
                    "UserManagerAssignPlayers",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"forge-user-manager-assignments\"> <div v-if=\"loading\"> <loading-indicator :label=\"t('Retrieving Foundry users')\"></loading-indicator> </div> <div v-else-if=\"loadingError\" class=\"mt-5 d-flex align-items-center users-loading-error\"> <i class=\"text-danger fas fa-exclamation-triangle m-3\"></i> <p> {{ t(\"Failed to load Foundry users. You can attempt to load them again by closing and re-opening the dialog.\") }} </p> </div> <div v-else class=\"forge-user-manager-assignments\"> <div v-if=\"game.manageUsers\"> <p>{{ t(\"Assign your Players to existing Foundry Users from your world.\") }}</p> <p>{{ t(\"Click the Player then the User in order to link them together.\") }}</p> <span id=\"why-assign-players\"> {{ t(\"What is this for?\") }} <help-icon></help-icon></span> <b-popover target=\"why-assign-players\" boundary=\"window\" triggers=\"hover\" placement=\"right\" :title=\"t('Why Assign Players?')\" > <p> {{ t( \"The User Manager will automatically create, update, and delete users as you invite players into your Game, a player leaves, or settings are modified.\" ) }} </p> <p> {{ t( \"Existing Foundry worlds will have their existing users disabled which can lead to a loss of character assignment, user settings, actor and journal permissions, audio/video settings and permissions, etc…\" ) }} </p> <p> {{ t( \"This tool allows you to assign an existing Foundry User to the invited Forge Player, so that all those settings are retained even with the User Manager enabled.\" ) }} </p> <p> {{ t( \"Note that unassigned Foundry users will be disabled but will remain in the world, so that no information is lost. Automatically created Forge users will be disabled if the player is assigned to a different user, or deleted if they leave the game.\" ) }} </p> </b-popover> </div> <div v-else> <strong>{{ t(\"Foundry Users:\") }}</strong> {{ users.length }} <help-icon :tooltip=\"t(`Click the user's name to edit`)\"></help-icon> </div> <!-- Search bar for games with lots of players and/or users --> <b-row v-if=\"showSearch\"> <b-col v-if=\"game.manageUsers\" class=\"pr-0\"> <b-input-group> <b-form-input v-model=\"searchPlayers\" type=\"search\" :placeholder=\"t('Find players')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> </b-col> <!-- Empty space in center to match the player/user lists below --> <b-col v-if=\"game.manageUsers\" cols=\"2\" class=\"p=0\"></b-col> <b-col :class=\"game.manageUsers ? 'pl-0' : 'py-2'\"> <b-input-group> <b-form-input v-model=\"searchUsers\" type=\"search\" :placeholder=\"t('Find users')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> </b-col> </b-row> <!-- Player-to-user assignments --> <b-list-group v-if=\"game.manageUsers\" class=\"mt-2\"> <b-list-group-item class=\"pl-0 pr-0\"> <div class=\"linked-player-row\"> <div class=\"forge-player text-center\"> <b-img src=\"/images/the-forge-logo-32x32.png\" width=\"16\" height=\"16\" class=\"m-1\"></b-img> <b>{{ t(\"Forge Player\") }}</b> <i18n v-if=\"filteredPlayersCount !== game.players.length\" :path=\" t('(Showing {{count}} of {{total}})', { count: filteredPlayersCount, total: game.players.length }) \" ></i18n> </div> <div class=\"center-icon text-center\"> <i class=\"fas fa-random\"></i> </div> <div class=\"foundry-user text-center\"> <b>{{ t(\"Foundry User\") }}</b> <b-img src=\"/images/fvtt-d20-32x32.png\" width=\"16\" height=\"16\" class=\"m-1\"></b-img> <i18n v-if=\"filteredUsersCount !== users.length\" :path=\"t('(Showing {{count}} of {{total}})', { count: filteredUsersCount, total: users.length })\" ></i18n> </div> </div> </b-list-group-item> <transition-group enter-active-class=\"animate__animated animate__faster user-assign-list-shrink-in-down\" leave-active-class=\"animate__animated animate__faster user-assign-list-shrink-out-up\" > <b-list-group-item v-for=\"(user, player) in filteredNewAssignments\" :id=\"`player-assignment-${player}`\" :key=\"player\" action class=\"user-assignment-row\" @click=\"cancelAssignment(player)\" @mouseenter=\"hoverAssignment(player, true)\" @mouseleave=\"hoverAssignment(player, false)\" > <div class=\"linked-player-row\" align-v=\"center\"> <div class=\"forge-player-icon-1\"> <b-img v-b-tooltip.hover.top=\"roleNameFromId(player)\" left :src=\"roleImgFromId(player)\" :alt=\"roleNameFromId(player)\" width=\"24\" > </b-img> </div> <div class=\"forge-player text-center text-truncate text-success\"> {{ playerNameFromId(player) }} </div> <div class=\"center-icon text-center\"> <i class=\"fas\" :class=\"assignedPlayerLinkClass(player)\"></i> </div> <div class=\"foundry-user text-center text-truncate text-success\"> {{ userNameFromId(user) }} </div> <div class=\"foundry-user-icon-1\"> <b-img v-b-tooltip.hover.top=\"roleNameFromId(user)\" right class=\"role-overridden\" :src=\"roleImgFromId(user)\" :alt=\"roleNameFromId(user)\" width=\"24\" > </b-img> </div> </div> <b-tooltip :target=\"`player-assignment-${player}`\" triggers=\"hover\"> {{ t(\"Click to remove the assignment\") }} </b-tooltip> </b-list-group-item> </transition-group> </b-list-group> <!-- Unassigned Forge Players --> <b-row v-if=\"game.manageUsers\"> <b-col cols=\"12\" class=\"text-center m-1\"> <span>{{ unassignedPlayersAndUsersLabel }}</span> </b-col> </b-row> <b-row> <b-col v-if=\"game.manageUsers\" cols=\"5\" class=\"pr-0\"> <b-list-group v-if=\"filteredUnassignedPlayers.length\"> <transition-group enter-active-class=\"animate__animated animate__faster user-assign-list-shrink-in-down\" leave-active-class=\"animate__animated animate__faster user-assign-list-shrink-out-up\" > <b-list-group-item v-for=\"player in filteredUnassignedPlayers\" :key=\"player.id\" :active=\"selectedPlayer === player.id\" action class=\"selectable-player pr-0\" @click=\"selectPlayer(player)\" @mouseenter=\"hoverPlayer(player, true)\" @mouseleave=\"hoverPlayer(player, false)\" > <div v-if=\"player\" class=\"player-assign-row align-items-center text-center text-truncate text-body\"> <div class=\"forge-player-icon-1\"> <b-img v-b-tooltip.hover.top=\"roleName(player.role)\" left :src=\"roleImg(player.role)\" :alt=\"roleName(player.role)\" width=\"24\" > </b-img> </div> <div class=\"forge-player\"> {{ player.name }} <span v-if=\"selectedPlayer === player.id || hoveredPlayer === player.id\" class=\"selected-icon position-absolute\" :class=\"pulsePlayerClass(player)\" > <i class=\"fas fa-link pr-2\"></i><i class=\"fas fa-long-arrow-alt-right\"></i> </span> </div> </div> </b-list-group-item> </transition-group> </b-list-group> </b-col> <!-- Center 'column' white space --> <b-col v-if=\"game.manageUsers\" cols=\"2\" class=\"p-0\"></b-col> <!-- Unassigned Foundry Users --> <b-col :cols=\"game.manageUsers ? 5 : 12\" :class=\"game.manageUsers ? 'pl-0' : ''\"> <b-list-group> <transition-group enter-active-class=\"animate__animated animate__faster user-assign-list-shrink-in-down\" leave-active-class=\"animate__animated animate__faster user-assign-list-shrink-out-up\" > <b-list-group-item v-for=\"user in filteredUnassignedUsers\" :key=\"user.id\" :action=\"game.manageUsers\" :class=\"unassignedUserClass\" :active=\"selectedUser === user.id\" @click=\"selectUser(user)\" @mouseenter=\"hoverUser(user, true)\" @mouseleave=\"hoverUser(user, false)\" > <div v-if=\"user\" class=\"user-assign-row align-items-center text-center text-truncate text-body\"> <div class=\"foundry-user\"> <span v-if=\"game.manageUsers && (selectedUser === user.id || hoveredUser === user.id)\" class=\"selected-icon position-absolute\" :class=\"pulseUserClass(user)\" > <i class=\"fas fa-long-arrow-alt-left\"></i><i class=\"fas fa-link pl-2\"></i> </span> <span v-if=\"game.manageUsers\">{{ user.name }}</span> <player-name-input v-else :player=\"user\" :editable=\"canEditName(user)\" :processing=\"nameUpdating(user)\" @change=\"editUserName(user, $event)\" ></player-name-input> </div> <div class=\"foundry-user-icon-2\"> <b-img v-b-tooltip.hover.top=\"roleName(user.role)\" center :src=\"roleImg(user.role)\" :alt=\"roleName(user.role)\" width=\"24\" > </b-img> </div> <div class=\"foundry-user-icon-1\"> <a href=\"#\" class=\"text-danger delete-player\" @click.prevent.stop=\"deleteUser(user)\"> <i v-b-tooltip.hover.top class=\"fas fa-trash-alt\" :title=\"t('Delete Foundry user')\"></i> </a> </div> </div> </b-list-group-item> </transition-group> <b-list-group-item class=\"text-center\"> <b-input-group> <b-form-input ref=\"newUserName\" type=\"text\" sm :disabled=\"updating\" :placeholder=\"t('New Foundry User')\" @keyup=\"newUserKeyUp($event)\" ></b-form-input> <b-input-group-append> <b-button v-b-tooltip.hover.top :disabled=\"updating\" variant=\"success\" :title=\"t('Add new Foundry user')\" @click=\"newUser\" > <loading-indicator v-if=\"updating\" tag=\"span\" small :label=\"t('Processing…')\"> </loading-indicator> <div v-else><i class=\"fas fa-plus\"></i></div> </b-button> </b-input-group-append> </b-input-group> </b-list-group-item> </b-list-group> </b-col> </b-row> </div> <confirm-message v-model=\"confirmUserDelete\" :title=\"confirmUserDeleteTitle\" @ok=\"userDeleteConfirmed\" @cancel=\"userDeleteCancel\" > <p>{{ t(\"Are you sure?\") }}</p> <i18n tag=\"p\" :path=\"t('{0} will be permanently deleted from the game.')\"> <strong>{{ userToDelete ? userToDelete.name : \"\" }}</strong> </i18n> <p v-if=\"userToDelete ? userToDelete.role === 4 : false\"> <strong>{{ t(\"You are about to delete a Game Master user!\") }}</strong> </p> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".forge-user-manager-assignments .users-loading-error { font-size: 1.25em; } .forge-user-manager-assignments .linked-player-row { display: grid; /* icon, icon, label, icon, label, icon, icon */ /* center icon gets 17% to be equivalent to 2 cols of a b-row */ grid-template-columns: 40px 40px 1fr 16.66667% 1fr 40px 40px; grid-template-rows: 1fr; grid-template-areas: \"p-icon-1 p-icon-2 p-label c-icon u-label u-icon-2 u-icon-1\"; } .forge-user-manager-assignments .linked-player-row .forge-player-icon-1 { grid-area: p-icon-1; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .forge-player-icon-2 { grid-area: p-icon-2; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .forge-player { grid-area: p-label; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .center-icon { grid-area: c-icon; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .foundry-user { grid-area: u-label; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .foundry-user-icon-2 { grid-area: u-icon-2; align-self: center; justify-self: center; } .forge-user-manager-assignments .linked-player-row .foundry-user-icon-1 { grid-area: u-icon-1; align-self: center; justify-self: center; } .forge-user-manager-assignments .player-assign-row { display: grid; /* icon, icon, label */ grid-template-columns: 40px 40px 1fr; grid-template-rows: 1fr; grid-template-areas: \"p-icon-1 p-icon-2 p-label\"; } .forge-user-manager-assignments .player-assign-row .forge-player-icon-1 { grid-area: p-icon-1; align-self: center; justify-self: center; } .forge-user-manager-assignments .player-assign-row .forge-player-icon-2 { grid-area: p-icon-2; align-self: center; justify-self: center; } .forge-user-manager-assignments .player-assign-row .forge-player { grid-area: p-label; align-self: center; justify-self: center; } .forge-user-manager-assignments .user-assign-row { display: grid; /* label, icon, icon */ grid-template-columns: 1fr 40px 40px; grid-template-rows: 1fr; grid-template-areas: \"u-label u-icon-1 u-icon-2 \"; } .forge-user-manager-assignments .user-assign-row .foundry-user { grid-area: u-label; align-self: center; justify-self: center; } .forge-user-manager-assignments .user-assign-row .foundry-user-icon-2 { grid-area: u-icon-2; align-self: center; justify-self: center; } .forge-user-manager-assignments .user-assign-row .foundry-user-icon-1 { grid-area: u-icon-1; align-self: center; justify-self: center; } .forge-user-manager-assignments .selectable-player, .forge-user-manager-assignments .selectable-user, .forge-user-manager-assignments .user-assignment-row { cursor: pointer; padding-left: 0; padding-right: 0; } .forge-user-manager-assignments .player-assign-row .selected-icon { right: 1.5em; } .forge-user-manager-assignments .user-assign-row .selected-icon { left: 1.5em; } .forge-user-manager-assignments .role-overridden { opacity: 0; } .user-assign-list-shrink-in-down { animation: user-assign-list-shrink-in-down; overflow-y: hidden; } .user-assign-list-shrink-out-up { animation: user-assign-list-shrink-in-down reverse; overflow-y: hidden; } @keyframes user-assign-list-shrink-in-down { 0% { height: 0; padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; } 100% { height: 3.7em; } } .forge-user-manager-assignments .selectable-player .selected-icon.pulse, .forge-user-manager-assignments .selectable-user .selected-icon.pulse { animation: 2s ease-in-out infinite both user-assign-list-hover-fade; } @keyframes user-assign-list-hover-fade { 0% { opacity: 0; } 50% { opacity: 1; } 100% { opacity: 0; } }"
    });
  },
  props: {
    game: Object
  },
  data() {
    return {
      loading: false,
      // Initial load, hide the whole component
      loadingError: false,
      // Failed to load Foundry users, show placeholder instead of user list
      updating: false,
      // Foundry user create/update in progress
      users: [],
      confirmUserDelete: false,
      userToDelete: null,
      assignments: {},
      assigning: false,
      // Updating assignments on server in progress
      newAssignments: {},
      hoveredAssignment: null,
      hoveredPlayer: null,
      hoveredUser: null,
      selectedPlayer: null,
      selectedUser: null,
      updatingUser: null,
      searchPlayers: "",
      searchUsers: ""
    };
  },
  watch: {
    game(newValue) {
      if (!newValue.manageUsers) {
        selectedUser = null;
        selectedPlayer = null;
      }
    },
    pendingAssignments() {
      this.$emit("pending-assignments", this.pendingAssignments);
    }
  },
  computed: {
    searchThreshold() {
      return 10;
    },
    sortedUsers() {
      return this.users.sort((a, b) => {
        if (a.role === b.role) {
          return a.name.localeCompare(b.name);
        }
        return b.role - a.role;
      });
    },
    showSearch() {
      return this.game.manageUsers ? this.game.players.length >= this.searchThreshold || this.users.length >= this.searchThreshold : this.users.length >= this.searchThreshold;
    },
    filteredPlayers() {
      if (!this.showSearch) {
        return this.game.players;
      }
      const search = this.searchPlayers.trim().toLowerCase();
      return this.game.players.filter(p => p.name.toLowerCase().includes(search));
    },
    filteredUsers() {
      if (!this.showSearch) {
        return this.sortedUsers;
      }
      const search = this.searchUsers.trim().toLowerCase();
      return this.sortedUsers.filter(u => u.name.toLowerCase().includes(search));
    },
    filteredNewAssignments() {
      const filteredAssignments = [];
      for (const [player, user] of Object.entries(this.newAssignments)) {
        if (!this.searchUsers && this.filteredPlayers.find(p => p.id == player)) {
          // No user search, use only the player filter
          filteredAssignments.push([player, user]);
        } else if (!this.searchPlayers && this.filteredUsers.find(u => u.id == user)) {
          // No player search, use only the user filter
          filteredAssignments.push([player, user]);
        } else if (this.filteredPlayers.find(p => p.id == player) && this.filteredUsers.find(u => u.id == user)) {
          // Use both player and user filter
          filteredAssignments.push([player, user]);
        }
      }
      return Object.fromEntries(filteredAssignments);
    },
    unassignedPlayers() {
      return this.findUnassignedPlayers(this.game.players);
    },
    filteredUnassignedPlayers() {
      return this.findUnassignedPlayers(this.filteredPlayers);
    },
    unassignedUsers() {
      return this.findUnassignedUsers(this.sortedUsers);
    },
    filteredUnassignedUsers() {
      return this.findUnassignedUsers(this.filteredUsers);
    },
    filteredPlayersCount() {
      return Object.keys(this.filteredNewAssignments).length + this.filteredUnassignedPlayers.length;
    },
    filteredUsersCount() {
      return Object.keys(this.filteredNewAssignments).length + this.filteredUnassignedUsers.length;
    },
    unassignedUserClass() {
      return this.game.manageUsers ? "selectable-user pl-0" : "";
    },
    pendingAssignments() {
      const changeSet = {
        ...this.newAssignments
      };
      // Check whether any old assignments have been deleted or changed
      for (const player in this.assignments) {
        if (!player in changeSet || changeSet[player] !== this.assignments[player]) {
          return true;
        }
        // If this 'new assignment' already existed, remove it from the change set
        delete changeSet[player];
      }
      // Anything remaining in the change set is an assignment that didn't exist before
      if (Object.keys(changeSet).length) {
        return true;
      }
      // If we make it this far, old assignments and new assignments are the same
      return false;
    },
    unassignedPlayersAndUsersLabel() {
      if (this.filteredUnassignedPlayers.length && this.filteredUnassignedUsers.length) {
        return t("Unassigned Players and Users");
      } else if (this.filteredUnassignedPlayers.length) {
        return t("Unassigned Players");
      } else if (this.filteredUnassignedUsers.length) {
        return t("Unassigned Users");
      }
      return "";
    },
    confirmUserDeleteTitle() {
      return t("Delete User {{userName}}", {
        userName: this.userToDelete ? this.userToDelete.name : ""
      });
    },
    gmCount() {
      return this.users.filter(u => u.role === 4).length;
    }
  },
  methods: {
    async loadAssignments() {
      const response = await Utils.api(`game/players`, {
        game: this.game.slug,
        action: "assignments"
      });
      if (response.error) {
        UI.alert("danger", t(`ERROR.ErrorRetrievingData`, {
          error: response.error
        }));
      } else {
        this.users = response.users;
        this.assignments = response.assignments;
      }
      return response;
    },
    async loadUsers() {
      const response = await Utils.api(`game/players`, {
        game: this.game.slug,
        action: "users"
      });
      if (response.error) {
        UI.alert("danger", t(`ERROR.ErrorRetrievingData`, {
          error: response.error
        }));
      } else {
        this.users = response.users;
      }
      return response;
    },
    roleImg(role) {
      return Games.roleImg(role);
    },
    roleName(role) {
      return Games.roleName(role);
    },
    findPlayer(player) {
      return this.game.players.find(p => p.id === player);
    },
    findUser(user) {
      return this.users.find(u => u.id === user);
    },
    roleImgFromId(id) {
      const player = this.findPlayer(id) || this.findUser(id);
      return Games.roleImg(player && player.role);
    },
    roleNameFromId(id) {
      const player = this.findPlayer(id) || this.findUser(id);
      return Games.roleName(player && player.role);
    },
    playerNameFromId(id) {
      const player = this.findPlayer(id);
      return player && player.name;
    },
    userNameFromId(id) {
      const user = this.findUser(id);
      return user && user.name;
    },
    assignedPlayerLinkClass(playerId) {
      return `fa-${this.hoveredAssignment === playerId ? "unlink text-danger" : "link text-success"}`;
    },
    findUnassignedPlayers(players) {
      return players.filter(p => {
        const assignment = this.newAssignments[p.id];
        return !(assignment && this.users.find(u => u.id === assignment));
      });
    },
    findUnassignedUsers(users) {
      if (!this.game.manageUsers) {
        return users;
      }
      return users.filter(u => !Object.values(this.newAssignments).includes(u.id));
    },
    selectPlayer(player) {
      if (player) {
        this.selectedPlayer = this.selectedPlayer === player.id ? "" : player.id;
      }
      this.checkSelections();
    },
    selectUser(user) {
      if (!this.game.manageUsers) {
        return;
      }
      if (user) {
        this.selectedUser = this.selectedUser === user.id ? "" : user.id;
      }
      this.checkSelections();
    },
    checkSelections() {
      if (this.selectedPlayer && this.selectedUser) {
        this.$nextTick(() => {
          this.$set(this.newAssignments, this.selectedPlayer, this.selectedUser);
          this.selectedPlayer = null;
          this.selectedUser = null;
          this.hoveredAssignment = null;
        });
      }
    },
    cancelAssignment(player) {
      this.$delete(this.newAssignments, player);
    },
    hoverAssignment(playerId, enter) {
      if (enter) {
        this.hoveredAssignment = playerId;
      } else if (this.hoveredAssignment === playerId) {
        this.hoveredAssignment = null;
      }
    },
    hoverPlayer(player, enter) {
      if (enter) {
        this.hoveredPlayer = player.id;
      } else if (this.hoveredPlayer === player.id) {
        this.hoveredPlayer = null;
      }
    },
    hoverUser(user, enter) {
      if (enter) {
        this.hoveredUser = user.id;
      } else if (this.hoveredUser === user.id) {
        this.hoveredUser = null;
      }
    },
    pulsePlayerClass(player) {
      if (this.hoveredPlayer === player.id && !(this.selectedPlayer === player.id)) {
        return "pulse";
      }
      return "";
    },
    pulseUserClass(user) {
      if (this.hoveredUser === user.id && !(this.selectedUser === user.id)) {
        return "pulse";
      }
      return "";
    },
    async assignPlayers() {
      this.assigning = true;
      this.$emit("assigning", true);
      const response = await Utils.api(`game/players`, {
        game: this.game.slug,
        action: "assign",
        assignments: this.newAssignments
      });
      if (response.error) {
        UI.alert("danger", t(`Error setting User Assignments: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.assignments = response.assignments;
      }
      this.assigning = false;
      this.$emit("assigning", false);
    },
    validateAssignments(assignments) {
      const validated = Object.entries(assignments).filter(([player, user]) => {
        return !!this.findPlayer(player) && !!this.findUser(user);
      });
      return Object.fromEntries(validated);
    },
    newUserKeyUp(event) {
      if (event.keyCode === 13) {
        this.newUser();
      }
    },
    async newUser() {
      if (this.updating) {
        return;
      }
      this.updating = true;
      const response = await Utils.api(`game/players`, {
        game: this.game.slug,
        action: "user_create",
        name: this.$refs.newUserName ? this.$refs.newUserName.localValue : undefined
      });
      if (response.error) {
        UI.alert("danger", t(`ERROR.ErrorRetrievingData`, {
          error: response.error
        }));
      } else {
        this.users = response.users;
      }
      if (this.$refs.newUserName) {
        this.$refs.newUserName.localValue = "";
      }
      this.updating = false;
    },
    async editUserName(user, event) {
      if (this.updating) {
        return;
      }
      const newName = event.newValue;
      if (newName === user.name) {
        this.updatingUser = null;
        return;
      }
      this.updating = true;
      this.updatingUser = user.id;
      const response = await Utils.api("game/players", {
        game: this.game.slug,
        action: "user_update",
        worldUser: {
          _id: user.id,
          name: newName
        }
      });
      if (response.error) {
        UI.alert("danger", t(`Error changing name: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.users = response.users;
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
      this.updatingUser = null;
      this.updating = false;
    },
    canEditName(user) {
      return !this.updating && !(this.updatingUser === user.id) && this.game.owner;
    },
    nameUpdating(user) {
      return this.updatingUser === user.id;
    },
    async deleteUser(user) {
      if (this.updating) {
        return;
      }
      // Ensure we don't delete the last GM
      if (this.gmCount <= 1 && user.role === 4) {
        UI.alert("danger", t(`{{userName}} is the only GM user in this world, so cannot be deleted.`, {
          userName: user.name
        }));
        return;
      }
      this.userToDelete = user;
      this.confirmUserDelete = true;
    },
    async userDeleteConfirmed() {
      if (this.updating) {
        return;
      }
      this.updating = true;
      const user = this.userToDelete;
      this.updatingUser = user.id;
      console.log("Deleting", user.id);
      const response = await Utils.api("game/players", {
        game: this.game.slug,
        action: "user_delete",
        worldUser: {
          _id: user.id
        }
      });
      if (response.error) {
        UI.alert("danger", t(`Error deleting user: {{- error}}`, {
          error: response.error
        }));
      } else {
        this.users = response.users;
        this.$emit("update", {
          slug: this.game.slug,
          game: response.game
        });
      }
      this.updatingUser = null;
      this.userToDelete = null;
      this.updating = false;
    },
    userDeleteCancel() {
      this.userToDelete = null;
    }
  },
  async created() {
    this.loading = true;
    this.users = [];
    this.newAssignments = {};
    this.assignments = {};
    this.assigning = false;
    if (this.game.manageUsers) {
      const response = await this.loadAssignments();
      if (!response.error) {
        this.assignments = response.assignments;
        this.newAssignments = this.validateAssignments(response.assignments);
      } else {
        this.loadingError = true;
      }
    } else {
      const response = await this.loadUsers();
      if (response.error) {
        this.loadingError = true;
      }
    }
    this.loading = false;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ImportWizard"] = Vue.component(
                    "ImportWizard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* Preserve nested i18n strings
 * t("IMPORT_TOOL.Assets", { count })
 * t("IMPORT_TOOL.Systems", { count })
 * t("IMPORT_TOOL.Modules", { count }) */

class ProgressBar {
  constructor(typeLabel, initiallyInvisible = false) {
    this.type = typeLabel;
    this.invisible = initiallyInvisible;
    this.reset();
  }
  reset(max = 0) {
    this.label = null;
    this.successes = 0;
    this.failures = 0;
    this.max = max;
    this.alert = null;
    this.alertVariant = null;
  }
  get complete() {
    return !this.max || this.max <= this.successes + this.failures;
  }
  get visible() {
    return !this.invisible || !this.complete;
  }
  get percentage() {
    return this.max === 0 ? "0%" : `${Math.round((this.successes + this.failures) / this.max * 100).toString()}%`;
  }
  setLabel(newText) {
    this.label = newText;
  }
  setMax(maximum) {
    this.max = maximum;
  }

  /**
   * Sets the current progress
   * @param {Number} successes Number of successes
   * @param {Number=} failures Number of failures, if contemplated
   */
  setProgress(successes, failures) {
    this.successes = successes;
    if (failures !== undefined) {
      this.failures = failures;
    }
  }
  setAlert(variant, message) {
    this.alert = message;
    this.alertVariant = variant;
  }
}
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" content-class=\"import-wizard\" :title=\"t('Import Wizard')\" :hide-footer=\"isHashing || isImporting\" :no-close-on-esc=\"isHashing || isImporting\" :no-close-on-backdrop=\"isHashing || isImporting\" :hide-header-close=\"isHashing || isImporting\" @hidden=\"visible = false\" > <!-- Wizard --> <b-tabs v-model=\"step\" class=\"no-nav\"> <!-- Step 0: file/url selection --> <b-tab class=\"picker\"> <b-tabs v-model=\"importType\" justified @input=\"resetFileSelection\"> <b-tab :title=\"t('Local Folder')\"></b-tab> <b-tab :title=\"t('ZIP File')\"></b-tab> <b-tab :title=\"t('Manifest URL')\" title-item-class=\"d-none\"></b-tab> </b-tabs> <b-input-group class=\"mt-4\"> <label :for=\"isManifestImport ? 'iw-manifest' : 'iw-file'\" class=\"input-group-prepend input-group-text\"> <i class=\"fas fa-fw\" :class=\"importTypeIcon\"></i> </label> <b-input v-if=\"isManifestImport\" id=\"iw-manifest\" v-model=\"selectedURL\" placeholder=\"https://example.com/path/manifest.json\" ></b-input> <form v-else ref=\"iwFileSelector\" class=\"form-control\"> <input id=\"iw-file\" ref=\"iwFile\" type=\"file\" class=\"custom-file-input\" v-bind=\"fileInputAttrs[['folder', 'zip'][importType]]\" @change=\"fileSelection\" /> <label class=\"custom-file-label color-input browse-primary mb-0\" :class=\"canAnalyze ? '' : 'placeholder'\" for=\"iw-file\" > {{ importPlaceholder }} </label> </form> </b-input-group> <checkbox-switch v-model=\"useBazaar\" class=\"mt-3\">{{ t(\"Install found packages from the Bazaar\") }}</checkbox-switch> <template v-if=\"!isManifestImport\"> <b-alert show variant=\"warning\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t( \"Remember to shut down your local Foundry first before importing data on the Forge or compressing it in a ZIP file. A running Foundry instance can cause database corruptions, missing files, or otherwise unusable imported content.\" ) }} </b-alert> <p> {{ t( \"You can import your worlds, modules, systems and assets using either a ZIP file, or by specifying the folder directly. Folder or ZIP contents may contain one or more of those in any combination.\" ) }} </p> <p> <strong>{{ t( \"If importing from your local Foundry for the first time, we strongly recommend you specify your entire Foundry Data folder.\" ) }}</strong> <b-link target=\"_blank\" href=\"https://forums.forge-vtt.com/docs?topic=87392\" ><i class=\"fas fa-info-circle\"></i ></b-link> </p> </template> <i18n :path=\"t('IMPORT_WIZARD.AssetsLibraryInfo')\" tag=\"p\"> <a href=\"/assets\">{{ t(\"Assets Library\") }}</a> </i18n> </b-tab> <!-- Step 1: hashing --> <b-tab class=\"hashing\"> <i18n :path=\"getProgressPath(hashing.label)\" tag=\"label\"> <strong>{{ hashing.type }}</strong> <span>{{ hashing.label }}</span> </i18n> <b-progress class=\"position-relative\" :max=\"hashing.max\" :animated=\"!hashing.complete\"> <outlined-text center :text=\"hashing.percentage\" /> <b-progress-bar :value=\"hashing.successes.toString()\" variant=\"success\"></b-progress-bar> </b-progress> </b-tab> <!-- Step 2: files analysis --> <b-tab class=\"import-selection\"> <!-- Worlds --> <b-card v-if=\"worlds.length\" :title=\"t('Worlds')\" img-left img-src=\"/images/import-wizard/worlds-banner.png\"> <b-card-text> <ul class=\"selectors\"> <li v-for=\"world of worlds\" :key=\"world.name\"> <b-checkbox v-model=\"world.selected\" switch>{{ world.json.title || world.json.name }}</b-checkbox> </li> </ul> <p v-if=\"stats.nonMedia.worlds\">{{ t(\"IMPORT_TOOL.NonMedia\", { count: stats.nonMedia.worlds }) }}</p> </b-card-text> </b-card> <!-- Systems --> <b-card v-if=\"systems.length\" :title=\"t('Systems')\" img-left img-src=\"/images/import-wizard/systems-banner.png\"> <b-card-text> <ul class=\"selectors\"> <li v-for=\"system of systems\" :key=\"system.name\"> <b-checkbox v-model=\"system.selected\" switch>{{ system.json.title || system.json.name }}</b-checkbox> </li> </ul> <p v-if=\"stats.nonMedia.systems\">{{ t(\"IMPORT_TOOL.NonMedia\", { count: stats.nonMedia.systems }) }}</p> </b-card-text> </b-card> <!-- Modules --> <b-card v-if=\"modules.length\" :title=\"t('Modules')\" img-left img-src=\"/images/import-wizard/modules-banner.png\"> <b-card-text> <ul v-if=\"modules.length <= MAX_ENTRIES\"> <li v-for=\"mod of modules\" :key=\"mod.name\">{{ mod.json.title || mod.json.name }}</li> </ul> <p v-else>{{ t(\"IMPORT_TOOL.FoundModules\", { modulesCount: modules.length }) }}</p> <p v-if=\"stats.compendiums\">{{ t(\"IMPORT_TOOL.FoundCompendiums\", { count: stats.compendiums }) }}</p> <p v-if=\"stats.nonMedia.modules\">{{ t(\"IMPORT_TOOL.NonMedia\", { count: stats.nonMedia.modules }) }}</p> </b-card-text> </b-card> <!-- Assets --> <b-card v-if=\"assets.length\" :title=\"t('Assets')\" img-left img-src=\"/images/import-wizard/assets-banner.png\"> <b-card-text> <p v-if=\"stats.assetsOrigin.worlds\"> {{ t(\"IMPORT_WIZARD.AssetsInWorlds\", { count: stats.assetsOrigin.worlds }) }} </p> <p v-if=\"looseAssets\">{{ t(\"IMPORT_TOOL.FoundAssets\", { assetsCount: totalAssets }) }}</p> <b-alert :show=\"oversizedAssets.length > 0\" variant=\"warning\" class=\"p-2\"> <details> <summary> {{ t(\"IMPORT_WIZARD.OversizeAssets\", { count: oversizedAssets.length, maxAssetFileSize: Utils.bytesToHuman(maxUploadSize), }) }} </summary> <ul class=\"mb-0\"> <li v-for=\"asset of oversizedAssets\" :key=\"asset\">{{ asset }}</li> </ul> </details> </b-alert> <p v-if=\"stats.nonMedia.assets\">{{ t(\"IMPORT_TOOL.NonMedia\", { count: stats.nonMedia.assets }) }}</p> </b-card-text> </b-card> <!-- Initial Foundry version set up --> <b-alert v-if=\"fvttVersion\" show variant=\"info\"> <i18n :path=\" t( 'As this is your first import of a world, your Foundry VTT server’s version will be set to {0} to match your imported worlds.' ) \" tag=\"p\" > <strong>{{ Utils.escapeHTML(fvttVersion) }}</strong> </i18n> <p>{{ t(\"You can always change your Foundry VTT server version from the Games Configuration page.\") }}</p> </b-alert> </b-tab> <!-- Step 3: import progress --> <b-tab class=\"importing\"> <!-- Progress bar: overall --> <i18n :path=\"getProgressPath(overall.label)\" class=\"pb-label\" tag=\"label\"> <strong>{{ overall.type }}</strong> <span>{{ overall.label }}</span> </i18n> <b-progress :max=\"overall.max\"> <b-progress-bar :value=\"overall.successes\" variant=\"success\"></b-progress-bar> <b-progress-bar :value=\"overall.complete ? 0 : 1\" animated variant=\"primary\"></b-progress-bar> <b-progress-bar :value=\"overall.failures\" variant=\"danger\"></b-progress-bar> </b-progress> <b-alert :show=\"!!overall.alert\" :variant=\"overall.alertVariant\">{{ overall.alert }}</b-alert> <!-- Progress bar: task --> <i18n :path=\"getProgressPath(task.label)\" class=\"pb-label\" tag=\"label\"> <strong>{{ task.type }}</strong> <span>{{ task.label }}</span> </i18n> <b-progress class=\"position-relative\" :max=\"task.max\" :animated=\"!task.complete\"> <outlined-text center :text=\"task.percentage\" /> <b-progress-bar :value=\"task.successes\" variant=\"success\"></b-progress-bar> </b-progress> <b-alert :show=\"!!task.alert\" :variant=\"task.alertVariant\">{{ task.alert }}</b-alert> <!-- Progress bar: upload --> <template v-if=\"upload.visible\"> <i18n :path=\"getProgressPath(upload.label)\" class=\"pb-label\" tag=\"label\"> <strong>{{ upload.type }}</strong> <span>{{ upload.label }}</span> </i18n> <b-progress class=\"position-relative\" :max=\"upload.max\" :animated=\"!upload.complete\"> <outlined-text center :text=\"upload.percentage\" /> <b-progress-bar :value=\"upload.successes\" variant=\"success\"></b-progress-bar> </b-progress> <b-alert :show=\"!!upload.alert\" :variant=\"upload.alertVariant\">{{ upload.alert }}</b-alert> </template> </b-tab> <!-- Done --> <b-tab class=\"done\" lazy> <div class=\"details\"> <div v-for=\"(result, type) in importResults\" :key=\"`sb-${type}`\"> <p v-if=\"result.successes\"> <i class=\"fas fa-fw fa-check text-success\"></i>{{ textImportSuccesses(result.successes, type) }} </p> <p v-if=\"result.installedFromBazaar\" class=\"from-bazaar\"> {{ textImportBazaar(result.installedFromBazaar) }} </p> </div> <div v-for=\"(result, type) in importResults\" :key=\"`f-${type}`\" class=\"mt-3\"> <p v-if=\"result.failures\"> <i class=\"fas fa-fw fa-times text-danger\"></i>{{ textImportFailures(result.failures, type) }} </p> <b-alert v-for=\"(alert, index) in result.alerts\" :key=\"index\" :variant=\"alert.variant\" class=\"p-2\" show> <div v-html=\"alert.message\"></div> </b-alert> </div> <template v-if=\"Object.keys(missingAssets).length\"> <h2>{{ t(\"Missing Assets\") }}</h2> <p>{{ t(\"During import we found out that some of the packages you uploaded had missing asset files.\") }}</p> <details v-for=\"(packages, typology) in missingAssets\" :key=\"`ma-type-${typology}`\" class=\"mt-2\"> <summary>{{ t(Utils.capitalize(typology)) }}</summary> <details v-for=\"(ma, title) in packages\" :key=\"`ma-package-${title}`\"> <summary>{{ title }}</summary> <ul> <li v-for=\"asset of ma\" :key=\"`ma-asset-${asset}`\">{{ asset }}</li> </ul> </details> </details> </template> </div> <h2>{{ t(\"Updated quotas\") }}</h2> <user-quotas /> </b-tab> </b-tabs> <!-- Generic errors --> <b-alert :show=\"!!errorMessage\" variant=\"danger\"><div v-html=\"errorMessage\"></div></b-alert> <!-- Footer buttons --> <template #modal-footer> <a v-if=\"!isDone\" href=\"https://forums.forge-vtt.com/t/importing-worlds-modules-systems-w-video-tutorial/454\" target=\"_blank\" class=\"btn btn-info mr-auto\" > <i class=\"fas fa-question-circle\"></i> </a> <b-button v-if=\"!isSelecting && !isDone\" variant=\"secondary\" @click=\"goBack\">{{ t(\"Previous\") }}</b-button> <b-button v-if=\"isSelecting\" variant=\"primary\" :disabled=\"!canAnalyze\" @click=\"analyze\">{{ t(\"Analyze\") }}</b-button> <b-button v-if=\"isReviewing\" variant=\"primary\" :disabled=\"!canImport\" @click=\"importFiles\">{{ t(\"Import\") }}</b-button> <b-button v-if=\"isDone\" variant=\"success\" @click=\"reset(true)\">{{ t(\"New import\") }}</b-button> <b-button v-if=\"isDone\" variant=\"primary\" @click=\"visible = false\">{{ t(\"Done\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".import-wizard .nav-item { border: none; } .import-wizard .nav-link { border-top-left-radius: 6px; border-top-right-radius: 6px; border-top: solid 4px transparent; font-size: 1.1em; font-weight: bold; user-select: none; } .import-wizard .nav-link.active { border-top-color: #f96854; } .import-wizard .nav-link:not(.active):hover { color: #f96854; background: rgba(255, 255, 255, 0.45); } .import-wizard #iw-file { display: none; } .import-wizard #iw-file + label { border: none; height: 100%; } .import-wizard .no-nav > div > .nav.nav-tabs[role=\"tablist\"] { display: none; } .import-wizard .picker .alert, .import-wizard .picker p { margin: 1.5rem 0 0; } .import-wizard .tabs + .alert, .import-wizard .import-selection .card + .card, .import-wizard .import-selection .card + .alert { margin-top: 1rem; margin-bottom: 0; } .import-wizard .import-selection .card > img { object-fit: contain; width: 6rem; height: 6rem; } .import-wizard .import-selection ul { padding-left: 1.5rem; list-style-type: circle; } .import-wizard .import-selection ul.selectors { list-style-type: none; margin: 0; padding: 0; } .import-wizard .asset-name { cursor: help; } .import-wizard .asset-preview dl:first-child { margin-top: 0; } .import-wizard .asset-preview dl:last-child, .import-wizard .asset-preview dl:last-child dd { margin-bottom: 0.25rem; } .import-wizard .asset-preview dd img { max-width: 100%; max-height: 150px; } .import-wizard .importing label { margin-bottom: 0; } .import-wizard .importing .pb-label { margin-top: 0.5em; } .import-wizard .importing .alert { font-size: 0.8em; margin: 0.5em 0 0; padding: 0.2em 0.5em; } .import-wizard .progress { height: 2em; font-size: 0.9em; } .import-wizard .done h1 { font-size: 1.5em; } .import-wizard .done h2 { font-size: 1.35em; margin-top: 1.5rem; } .import-wizard .done .details p { margin: 0; } .import-wizard .done .details ul { padding-left: 2.2em; list-style-type: circle; } .import-wizard .done .details .fa-fw { width: 1em !important; margin-right: 0.4em; } .import-wizard .done .details .from-bazaar { margin-left: 1.4em; } .import-wizard .done .details details > details { padding-left: 1.1em; } .import-wizard .progress-bar { transition: width 0.2s ease; }"
    });
  },
  props: {
    value: Boolean
  },
  data: () => ({
    MAX_ENTRIES: 5,
    step: 0,
    importType: 0,
    selectedURL: null,
    selectedFiles: null,
    fileInputAttrs: {
      folder: {
        multiple: true,
        directory: true,
        webkitdirectory: true,
        mozdirectory: true
      },
      zip: {
        accept: ".zip"
      }
    },
    useBazaar: true,
    modules: [],
    systems: [],
    assets: [],
    worlds: [],
    stats: {},
    fvttVersion: null,
    importResults: null,
    maxUploadSize: null,
    /** Import Wizard */
    iw: null,
    errorMessage: null,
    // Progress bars { values: [successes, failures], max: total }
    hashing: new ProgressBar(t("Analyzing")),
    overall: new ProgressBar(t("Overall")),
    task: new ProgressBar(t("Task")),
    upload: new ProgressBar(t("Upload"), true)
  }),
  computed: {
    isSelecting() {
      return this.step === 0;
    },
    isHashing() {
      return this.step === 1;
    },
    isReviewing() {
      return this.step === 2;
    },
    isImporting() {
      return this.step === 3;
    },
    isDone() {
      return this.step === 4;
    },
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.reset();
        }
        this.$emit("input", value);
      }
    },
    isManifestImport() {
      return this.importType === 2;
    },
    importTypeIcon() {
      return ["fa-folder", "fa-file-archive", "fa-globe"][this.importType];
    },
    importPlaceholder() {
      if (!this.selectedFiles) {
        return [t("Choose folder"), t("Choose ZIP archive file")][this.importType];
      }
      return this.selectedFiles.length === 1 ? this.selectedFiles[0].name : t("IMPORT_TOOL.files", {
        count: this.selectedFiles.length
      });
    },
    canAnalyze() {
      return this.isManifestImport ? this.selectedURL : this.selectedFiles;
    },
    canImport() {
      return this.assets.length || this.modules.length || this.systems.some(s => s.selected) || this.worlds.some(w => w.selected);
    },
    looseAssets() {
      if (!this.assets) {
        return 0;
      }
      return this.assets.length - this.stats.assetsOrigin.worlds;
    },
    totalAssets() {
      return this.assets ? this.assets.length : 0;
    },
    oversizedAssets() {
      const oversizedAssets = this.assets.reduce((arr, a) => {
        if (a.oversize && !arr.includes(a.path)) {
          arr.push(a.path);
        }
        return arr;
      }, []);
      return oversizedAssets.sort((a, b) => a.localeCompare(b, undefined, {
        sensitivity: "accent"
      }));
    },
    /**
     * Filter missing assets lists
     */
    missingAssets() {
      if (!this.importResults) {
        return {};
      }
      return Object.entries(this.importResults).reduce((p, [type, result]) => {
        if (result && result.missingAssets && Object.keys(result.missingAssets).length) {
          p[type] = result.missingAssets;
        }
        return p;
      }, {});
    }
  },
  methods: {
    reset(preserveChoices = false) {
      // Reset progress bars
      this.hashing.reset();
      this.overall.reset();
      this.task.reset();
      this.upload.reset();
      // Reset wizard
      this.resetFileSelection();
      if (!preserveChoices) {
        this.useBazaar = true;
        this.importType = 0;
      }
      this.step = 0;
    },
    resetFileSelection() {
      this.selectedURL = null;
      this.selectedFiles = null;
      if (this.$refs.iwFileSelector) {
        this.$refs.iwFileSelector.reset();
      }
    },
    fileSelection(ev) {
      const {
        files
      } = ev.target;
      if (!files.length) {
        this.selectedFiles = null;
        return;
      }
      this.selectedFiles = Array.from(files);
    },
    async analyze() {
      if (this.maxUploadSize === null) {
        const response = await Utils.api("quotas");
        if (response.error) {
          this.errorMessage = t("Unable to analyze content: {{- reason}}", {
            reason: response.error
          });
          return;
        }
        this.maxUploadSize = response.upload;
      }
      this.errorMessage = null;
      this.step += 1;
      const content = await this.iw._stepAnalyzeFiles(this.selectedFiles, this.maxUploadSize, this.hashing);
      if (content.error) {
        this.step -= 1;
        this.errorMessage = content.error;
        return;
      }
      content.worlds.forEach(w => {
        w.selected = true;
      });
      content.systems.forEach(s => {
        s.selected = true;
      });
      this.worlds = content.worlds;
      this.systems = content.systems;
      this.modules = content.modules;
      this.assets = content.assets;
      this.stats = content.stats;
      this.fvttVersion = content.FVTTVersion;
      this.step += 1;
    },
    async importFiles() {
      this.task.setMax(100); // Task is always a percentage
      const worlds = this.worlds.filter(w => w.selected);
      const systems = this.systems.filter(s => s.selected);
      this.overall.setMax((this.assets.length > 0 ? 1 : 0) + worlds.length + systems.length + this.modules.length);
      this.step += 1;
      this.importResults = await this.iw._stepImportData({
        worlds,
        systems,
        modules: this.modules,
        assets: this.assets
      }, this.useBazaar, {
        overall: this.overall,
        task: this.task,
        upload: this.upload
      });
      this.step += 1;
      if (this.importResults.worlds && this.importResults.worlds.successes > 0) {
        this.$emit("change");
      }
    },
    textImportSuccesses(successes, type) {
      return t("Imported {{successes}} {{type}}", {
        successes,
        type: Utils.capitalize(type)
      });
    },
    textImportBazaar(count) {
      return t("IMPORT_WIZARD.InstalledFromBazaar", {
        count,
        defaultValue_one: "{{count}} of those was installed from the Bazaar",
        defaultValue_other: "{{count}} of those were installed from the Bazaar"
      });
    },
    textImportFailures(failures, type) {
      return t("Failed to import {{failures}} {{type}}", {
        failures,
        type: Utils.capitalize(type)
      });
    },
    goBack() {
      // If going back from the review pane, go back to step 1
      if (this.isReviewing) {
        this.reset(true);
        return;
      }
      this.step -= 1;
    },
    getProgressPath(description) {
      return description ? t("IMPORT_WIZARD.TypeAndLabel", "{0}: {1}") : "{0}";
    }
  },
  created() {
    this.iw = new ImportTool();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["LogViewer"] = Vue.component(
                    "LogViewer",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal scrollable :hide-footer=\"!$slots.footer\" centered size=\"xl\" :content-class=\"classes\" header-class=\"d-block\" dialog-class=\"log-viewer-modal\" body-class=\"log-viewer forge-custom-scrollbar\" :visible=\"visible\" @hidden=\"visible = false\" > <template #modal-header=\"{ close }\"> <div :class=\"`d-flex${$slots.header ? ' pb-2' : ''}`\"> <h5 class=\"modal-title\">{{ title }}</h5> <button type=\"button\" aria-label=\"Close\" class=\"close\" @click=\"close\">×</button> </div> <slot name=\"header\"></slot> </template> <slot></slot> <template #modal-footer> <slot name=\"footer\"></slot> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".log-viewer .logs { min-height: 10vh; max-height: 80vh; font-family: \"PT Mono\", monospace; } .log-viewer p, .log-viewer .multi-indent { display: block; word-break: break-word; } .log-viewer p, .log-viewer .multi-indent { margin: 0 0 0 14.5pt; text-indent: -14.5pt; } .log-viewer p + p { margin-top: 0.4em; } .log-viewer .multi-indent + .multi-indent { padding: 0 0 0 14.5pt; }"
    });
  },
  props: {
    title: {
      type: String,
      default: t("Foundry Log viewer")
    },
    value: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["LogViewerFoundry"] = Vue.component(
                    "LogViewerFoundry",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<log-viewer v-model=\"visible\" classes=\"foundry-log-viewer\" :title=\"title\"> <!-- Loading spinner --> <p v-if=\"fetching\" class=\"text-center\"><b-spinner small></b-spinner> {{ t(\"Fetching logs…\") }}</p> <!-- Filters --> <template #header> <b-form inline class=\"filters w-100\"> <b-form-input v-model=\"filter.search\" class=\"col-9\" :placeholder=\"t('Search…')\"></b-form-input> <b-dropdown class=\"col-3 pr-0\" :text=\" filter.types.length ? t('Filtering by types ({{ count }})', { count: filter.types.length }) : t('Filter by types') \" > <b-dropdown-form class=\"filter-types\"> <b-form-checkbox-group v-model=\"filter.types\" stacked :options=\"FILTER_TYPES\"></b-form-checkbox-group> </b-dropdown-form> </b-dropdown> </b-form> </template> <b-tabs v-if=\"displayTabs\" v-model=\"activeTab\"> <b-tab v-for=\"(tab, tabIndex) in tabs\" :key=\"tab.id\" :title=\"tab.label\" @click=\"handleTabChange(tabIndex)\"> </b-tab> </b-tabs> <!-- Foundry logs --> <div class=\"logs\"> <p v-for=\"(log, index) of displayedLogs\" :key=\"index\"> <span class=\"date\">{{ log.timestamp }}</span> [<span :class=\"`type-${log.level}`\" >{{ log.level }}<span v-if=\"log.code\"> {{ log.code }}</span></span >] <span class=\"message\" ><span v-for=\"(line, index) of log.message\" :key=\"index\" ><br v-if=\"index > 0\" />{{ line }}<span v-if=\"index === 0 && log.repetitionCount > 0\" class=\"repetition\">{{ repetitionMessage(log.repetitionCount, log.repetitionDuration) }}</span></span ></span > <span v-if=\"log.stack\" class=\"stack\"> <span v-for=\"(line, index) of log.stack\" :key=\"index\" class=\"stack-line multi-indent\">{{ line }}</span> </span> </p> <!-- Lazy loader --> <infinite-loading v-if=\"!fetching\" :identifier=\"`log-viewer-foundry-${activeTab}-${infiniteId}`\" @infinite=\"showMore\" > <template #no-results> <p class=\"text-center mt-4\">{{ t(\"Log file is empty\") }}</p> </template> <template #no-more> <p class=\"text-center mt-4\">{{ t(\"End of log file\") }}</p> </template> <template #spinner> <p class=\"text-center mt-4\"><b-spinner small></b-spinner> {{ t(\"Parsing logs…\") }}</p> </template> </infinite-loading> </div> </log-viewer>",
  beforeCreate() {
    Utils.loadCss({
      content: ".foundry-log-viewer .message { white-space: pre-wrap; } .foundry-log-viewer .date { opacity: 0.75; } .foundry-log-viewer .type-info, .foundry-log-viewer .repetition { color: #338eff; } .foundry-log-viewer .type-warn { color: #ff7e33; } .foundry-log-viewer .type-error { color: #ff3333; } .foundry-log-viewer .filter-types label { justify-content: flex-start; }"
    });
  },
  props: {
    value: Boolean,
    user: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "debug"
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      LOG_PAGING: 1000,
      displayLineCount: 0,
      foundryLogs: null,
      parsedLogs: null,
      fetching: false,
      FILTER_TYPES: [{
        value: "debug",
        text: t("Debug")
      }, {
        value: "info",
        text: t("Information")
      }, {
        value: "warn",
        text: t("Warning")
      }, {
        value: "error",
        text: t("Error")
      }],
      filter: {
        search: "",
        types: []
      },
      infiniteId: 0,
      lazyTimeout: null,
      tabs: [{
        id: "postV12Logs",
        label: t("Post v12 Logs")
      }, {
        id: "preV12Logs",
        label: t("Pre v12 Logs")
      }],
      activeTab: 0
    };
  },
  watch: {
    value(v) {
      if (v) {
        this.fetchLogs();
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    logs() {
      if (!this.foundryLogs) {
        return null;
      }
      if (!this.displayTabs) {
        const logs = this.foundryLogs.preV12Logs ? this.foundryLogs.preV12Logs : this.foundryLogs.postV12Logs;
        return logs.toString().split("\n").reverse();
      }
      if (this.activeTab === 0 && this.foundryLogs.postV12Logs) {
        return this.foundryLogs.postV12Logs.toString().split("\n").reverse();
      }
      if (this.activeTab === 1 && this.foundryLogs.preV12Logs) {
        return this.foundryLogs.preV12Logs.toString().split("\n").reverse();
      }
      return null;
    },
    displayedLogs() {
      if (!this.logs || !this.logs.length || !this.parsedLogs.length) {
        return [];
      }

      // Filtering helpers
      const search = this.filter.search.toLowerCase();
      const cmp = s => s.toLowerCase().indexOf(search);
      const logs = this.parsedLogs.slice(0, this.displayLineCount).filter(l => {
        // Empty lines
        if (!l) {
          return false;
        }

        // Log type matching
        if (this.filter.types.length && !this.filter.types.includes(l.level)) {
          return false;
        }

        // Search input matching
        if (search && cmp(l.level) < 0 &&
        // Log type
        cmp(l.timestamp) < 0 &&
        // Specific timestamp
        !l.message.some(line => cmp(line) >= 0) && (
        // Message
        !l.stack || !l.stack.some(line => cmp(line) >= 0)) // Optional error message
        ) {
          return false;
        }
        return true;
      });

      // Reset infiniload to ensure that enough lines are always visible
      // on the screen while changing filters
      if (logs.length < 100 && this.displayLineCount < this.logs.length && !this.lazyTimeout) {
        this.lazyTimeout = setTimeout(() => {
          this.infiniteId += 1;
          this.lazyTimeout = null;
        }, 0);
      }
      return logs;
    },
    displayTabs() {
      return this.foundryLogs && this.foundryLogs.preV12Logs && this.foundryLogs.postV12Logs;
    }
  },
  methods: {
    handleTabChange(tabIndex) {
      if (this.activeTab === tabIndex) {
        return;
      }
      this.activeTab = tabIndex;
      this.parsedLogs = [];
      this.displayLineCount = 0;
    },
    repetitionMessage(count, duration) {
      return t("(repeated {{count}} times for {{duration}})", {
        count,
        duration
      });
    },
    async fetchLogs() {
      if (!["debug", "error"].includes(this.type)) {
        return UI.alert("danger", t("Invalid Foundry log type"), true, 10000);
      }

      // Init
      this.filter.search = "";
      this.filter.types = [];
      this.parsedLogs = null;
      this.foundryLogs = null;
      const queryUserId = this.user ? `?user=${this.user.id}` : "";
      // We redownload every time, as there's no "smart" refresh at the moment
      this.fetching = true;
      const response = await fetch(`/data/fvtt-${this.type}-log.json${queryUserId}`);
      if (!response.ok) {
        this.visible = false;
        return UI.alert("danger", this.user ? t("Unable to get Foundry {{type}} logs for user “{{user}}”: {{error}}", {
          type: this.type,
          user: this.user.email,
          error: response.statusText
        }) : t("Unable to get Foundry {{type}} logs: {{error}}", {
          type: this.type,
          error: response.statusText
        }), true, 10000);
      }
      this.foundryLogs = await response.json();
      this.displayLineCount = 0;
      this.parsedLogs = [];
      this.fetching = false;
    },
    parseLogs() {
      const missingLogLines = this.logs.slice(this.parsedLogs.length, this.displayLineCount);
      this.parsedLogs.push(...missingLogLines.map(line => Utils.parseFoundryLogLine(line)));
    },
    async showMore($state) {
      if (this.logs && this.parsedLogs.length < this.logs.length) {
        this.displayLineCount += this.LOG_PAGING;
        // Parse in a timeout to let the UI refresh and show the parsing spinner
        setTimeout(() => {
          this.parseLogs();
          $state.loaded();
        }, 0);
      } else {
        $state.complete();
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AboutPage"] = Vue.component(
                    "AboutPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"container about-page\"> <header class=\"text-center mb-3\"> <h1>{{ t(\"About The Forge!\") }}</h1> </header> <div class=\"about-page__content-container mb-4\"> <img src=\"/images/the-forge-logo-512x512.png\" :alt=\"t('Logo for The Forge')\" class=\"about-page__logo\" /> <div class=\"about-page__content\"> <p> {{ t( \"“The Forge” (The Forge VTT inc. / La Forge TJV inc.) is a tabletop game company founded in 2020 by Youness Alaoui, also known as KaKaRoTo.\" ) }} </p> <i18n :path=\" t( 'The Forge is the first and only {0}, turn-key, high-availability hosting solution for Foundry VTT games. Its mission is to make it {1} for game masters to host and manage games, so that they can focus on the story and gameplay, rather than to mess around with servers, network equipment and configuration, security, bandwidth and latency, etc. The Forge provides all the necessary tools for GMs to create immersive tabletop gaming experiences for their players, without going insane and becoming a lich.' ) \" tag=\"p\" > <em>{{ t(\"fully integrated\") }}</em> <strong>{{ t(\"painless\") }}</strong> </i18n> <p> {{ t( \"The company is headquartered in the frozen lands of Montréal, Canada, where KaKaRoTo's office is located. The rest of the team is based in Canada and throughout the world.\" ) }} </p> </div> </div> <h2 class=\"about-page__team-header\">{{ t(\"Our Very Terrific Team\") }}</h2> <section class=\"team\"> <article v-for=\"member of staff\" :key=\"member.nickname\"> <div class=\"character-sheet d-none\"> <character-sheet-forge :member=\"member\" /> </div> <div class=\"text\"> <h1 class=\"h3\"> <a :href=\"`/about/${member.nickname}`\">{{ member.fancyName }}</a> </h1> <p class=\"biography\" v-html=\"renderBio(member.bio)\"></p> <character-sheet-social-links :member=\"member\" /> <hr /> </div> </article> </section> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".about-page{container-name:about-page;container-type:inline-size}.about-page__content-container{max-width:90ch;display:grid;grid-template-columns:1fr;gap:1em;margin:0 auto}.about-page__logo{width:100%;max-width:256px;height:auto;margin:0 auto}.about-page__team-header{position:relative;text-align:center;width:fit-content;margin:0 auto}.about-page__team-header:after{content:\"\";position:absolute;display:block;left:-2em;right:-2em;bottom:0;background:linear-gradient(90deg, transparent, currentcolor, currentcolor, transparent);height:1px}@container about-page (min-width: 60ch){.about-page__content-container{grid-template-columns:max-content 1fr}}.about-page .socials{font-size:1.4em;margin-top:.25em;display:flex;gap:.1em}.about-page .socials a{color:var(--secondary)}.about-page .socials i+i{background-color:var(--primary)}.about-page .socials i+i::before{color:var(--light);opacity:.9}.about-page .team{display:grid;gap:1em;grid-template-columns:1fr}.about-page .team .h5.nickname{text-transform:uppercase;font-weight:bold;font-family:\"El Messiri\",serif}@media screen and (min-width: 992px){.about-page .team{grid-template-columns:1fr 1fr}}@media screen and (min-width: 1904px){.about-page .team{grid-template-columns:1fr 1fr 1fr}}@media screen and (min-width: 460px){.about-page .team article>div.text{display:none}.about-page .team article>div.character-sheet{display:block !important;height:100%}.about-page .team svg.character-sheet-forge{position:relative}.about-page .team article{background:url(\"/images/sheets/forge/vellum.jpg\") no-repeat center center;background-size:cover;border-radius:.5em;position:relative;box-shadow:2px 5px 5px rgba(0,20,0,.33);padding:7px;transition:transform 200ms ease-in-out,box-shadow 200ms ease-in-out}.about-page .team article a:hover{text-decoration:none}}"
    });
  },
  props: {
    staff: Array
  },
  methods: {
    renderBio: bio => DOMPurify.sanitize(marked(bio)).replaceAll(/(?:^\s*<p>|<\/p>\s*$)/g, "")
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdministrationPage"] = Vue.component(
                    "AdministrationPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body class=\"administration\"> <b-tabs v-model=\"tab\" class=\"admin-manager-tabs\" pills card vertical @input=\"onTabChange\"> <b-tab class=\"dashboard\"> <template #title><i class=\"fas fa-tachometer-alt fa-fw\"></i>{{ t(\"Dashboard\") }}</template> <admin-dashboard ref=\"dashboard\"></admin-dashboard> </b-tab> <b-tab class=\"users\"> <template #title><i class=\"fa fa-users fa-fw\"></i>{{ t(\"Users\") }}</template> <admin-users :params=\"params\"></admin-users> </b-tab> <b-tab class=\"giftcards\"> <template #title><i class=\"fa fa-gift fa-fw\"></i>{{ t(\"Gift Cards\") }}</template> <admin-gift-cards :params=\"params\"></admin-gift-cards> </b-tab> <b-tab class=\"packages\"> <template #title> <i class=\"fa fa-box fa-fw\"></i>{{ t(\"Packages\") }} <b-badge v-if=\"packagesAwaitingApproval\" v-b-tooltip=\"t('Packages awaiting approval')\" pill variant=\"warning\" class=\"float-right mt-1\" > {{ packagesAwaitingApproval }} </b-badge> </template> <admin-package-list ref=\"packageList\" @update=\"updateApprovals\"></admin-package-list> </b-tab> <b-tab class=\"promotions\"> <template #title><i class=\"fas fa-bullhorn fa-fw\"></i>{{ t(\"Bazaar Promotions\") }}</template> <admin-bazaar-promotions ref=\"promotions\"></admin-bazaar-promotions> </b-tab> <b-tab class=\"purchases\"> <template #title><i class=\"fa fa-shopping-cart\"></i>{{ t(\"Payouts & Purchases\") }}</template> <admin-payouts-and-purchases ref=\"payoutsAndPurchases\"></admin-payouts-and-purchases> </b-tab> <b-tab class=\"announcements\"> <template #title><i class=\"fas fa-bullhorn fa-fw\"></i>{{ t(\"Service Announcements\") }}</template> <admin-service-announcements ref=\"serviceAnnouncements\"></admin-service-announcements> </b-tab> <b-tab class=\"events\"> <template #title><i class=\"fa fa-calendar-alt fa-fw\"></i>{{ t(\"Event Viewer\") }}</template> <admin-event-viewer ref=\"eventViewer\"></admin-event-viewer> </b-tab> <b-tab class=\"foundry\"> <template #title><i class=\"fas fa-solid fa-code-branch\"></i>{{ t(\"Manage Foundry versions\") }}</template> <admin-foundry-versions ref=\"foundryVersions\"></admin-foundry-versions> </b-tab> <b-tab class=\"channelsManagement\"> <template #title><i class=\"fa fa-tv fa-fw\"></i>{{ t(\"Channels\") }}</template> <admin-channels-management ref=\"channelsManagement\"></admin-channels-management> </b-tab> <b-tab class=\"notificationsManagement\"> <template #title><i class=\"fa fa-paper-plane fa-fw\"></i>{{ t(\"Notifications\") }}</template> <admin-notifications-management ref=\"notificationsManagement\"></admin-notifications-management> </b-tab> <b-tab class=\"settings\"> <template #title><i class=\"fas fa-cog fa-fw\"></i>{{ t(\"Site Settings\") }}</template> <admin-site-settings ref=\"siteSettings\"></admin-site-settings> </b-tab> </b-tabs> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".administration .tabs .nav a i { margin-right: 0.5em; } .administration .tabs > .tab-content > .tab-pane > h2 button { line-height: 0; }"
    });
  },
  data: () => ({
    TABS: ["dashboard", "users", "giftcards", "packages", "promotions", "payoutsAndPurchases", "announcements", "events", "foundry", "channelsManagement", "notificationsManagement", "settings"],
    tab: null,
    params: null,
    packagesAwaitingApproval: 0
  }),
  methods: {
    updateTabFromHash() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        this.tab = this.TABS.findIndex(t => t === hash.tab) || 0;
      }
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    unloadTab() {
      if (!this.tab) {
        return;
      }
      window.location.hash = "";
    },
    /**
     * Call a tab's component's lazyLoad method to fetch data for said component.
     *
     * Note: *Do not* load data that uses an authenticated route on component
     * mount/creation, as that will trigger two 2FA dialogs on page load. Use
     * the component's `lazyLoad()` method to load data that requires auth.
     */
    lazyLoad() {
      switch (this.TABS[this.tab]) {
        case "dashboard":
          return this.$refs.dashboard.lazyLoad();
        case "events":
          return this.$refs.eventViewer.lazyLoad();
        case "announcements":
          return this.$refs.serviceAnnouncements.lazyLoad();
        case "settings":
          return this.$refs.siteSettings.lazyLoad();
        case "packages":
          return this.$refs.packageList.lazyLoad();
        case "payoutsAndPurchases":
          return this.$refs.payoutsAndPurchases.lazyLoad();
        case "promotions":
          return this.$refs.promotions.lazyLoad();
        case "foundry":
          return this.$refs.foundryVersions.lazyLoad();
        case "channelsManagement":
          return this.$refs.channelsManagement.lazyLoad();
        case "notificationsManagement":
          return this.$refs.notificationsManagement.lazyLoad();
      }
    },
    onTabChange(index) {
      this.unloadTab();
      const tab = this.TABS[index];
      this.buildHash({
        tab
      });
      this.lazyLoad();
    },
    async pendingCountUpdate() {
      const count = await Utils.api("administration/packages/pending-count");
      this.packagesAwaitingApproval = !count || isNaN(count) ? 0 : count;
    },
    updateApprovals(count) {
      this.packagesAwaitingApproval = count;
    }
  },
  created() {
    this.updateTabFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
    this.pendingCountUpdate();
  },
  mounted() {
    this.lazyLoad();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CompendiumModuleFixes"] = Vue.component(
                    "CompendiumModuleFixes",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-row> <b-col class=\"text-center\"> <h2>{{ t(\"Invalid Shared Compendiums\") }}</h2> <p> {{ t( \"New Foundry versions may introduce changes to the module manifest, and older versions without the new manifest requirements will now no longer be visible.\" ) }} </p> <p> {{ t( \"Use this tool to have The Forge migrate your incompatible modules so they can be access in Foundry VTT. Migrating the module won't prevent you from using it in earlier versions of Foundry VTT.\" ) }} </p> </b-col> </b-row> <div v-if=\"loading\" class=\"text-center mt-5\"> <div class=\"spinner-border\" role=\"status\"></div> {{ t(\"Loading, please wait…\") }} </div> <div v-else-if=\"!modules.length\"> <b-alert show> {{ t(\"No modules with issues detected\") }} </b-alert> </div> <b-card-group v-else deck> <b-card v-for=\"module in modules\" :key=\"module.id\" class=\"compendium-module\" footer-class=\"text-right\"> <template #header> {{ module.name }} </template> <template v-if=\"module.needsSystemFix\"> <p>{{ t(\"Please select a default system\") }}</p> <vue-multiselect v-model=\"module.system\" :multiple=\"true\" :options=\"installedSystems\" :allow-empty=\"true\" :placeholder=\"t('Please select a default system')\" label=\"label\" track-by=\"id\" /><br /> <b-alert :show=\"module.system.length > 1\" variant=\"warning\"> <p> <i class=\"fa-solid fa-triangle-exclamation\"></i> {{ t(\"Currently we can only convert a module with one default system.\") }} </p> <p> {{ t( \"If you require more than one system, you'll need to edit the module.json file and make sure that compendium packs of type Actors and Items have a system specified.\" ) }} </p> <i18n :path=\"t('Please refer to {0} article for further help.')\" tag=\"p\"> <a href=\"https://forums.forge-vtt.com/t/how-to-fix-v9-shared-compendiums-to-work-on-v10/42655\">{{ t(\"this\") }}</a> </i18n> </b-alert> <p> {{ t( \"This module is compatible with multiple systems or is system-agnostic. However, each Actor or Item compendium is designed to work with a specific system. Please choose the system for which these compendiums are intended.\" ) }} </p> </template> <template v-if=\"module.needsTypeFix\"> <p> {{ t( \"The settings for this module are using outdated fields that are no longer supported. Please click the 'Migrate' button to update it to the latest format.\" ) }} </p> </template> <template #footer> <b-button variant=\"primary\" :disabled=\"module.converting || (module.needsSystemFix && module.system.length != 1)\" @click.prevent=\"convertModule(module)\" > <i class=\"fas fa-sync\" :class=\"module.converting ? 'fa-spin' : ''\"></i> {{ t(\"Migrate\") }} </b-button> </template> </b-card> </b-card-group> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".compendium-module { max-width: 500px; flex: 0 0 500px !important; margin-bottom: 15px !important; }"
    });
  },
  props: {
    invalidCompendiums: Array
  },
  data() {
    return {
      compendiums: [],
      systems: [],
      installedSystems: [],
      systemsLoaded: false,
      loading: true
    };
  },
  computed: {
    modules() {
      return this.compendiums.sort((a, b) => {
        return a.name.localeCompare(b);
      });
    }
  },
  methods: {
    async convertModule(module) {
      module.converting = true;
      if (module.id.includes("/") || [".", ".."].includes(module.id)) {
        UI.alert("danger", t("Error migrating module, {{module}}", {
          module: module.name
        }), true);
        module.converting = false;
        throw new Error(t("Invalid module id"));
      }
      if (!(module.system instanceof Array)) {
        UI.alert("danger", t("Error migrating module, invalid target system, {{module}}", {
          module: module.name
        }), true);
        module.converting = false;
        throw new Error(t("Invalid target system"));
      }

      // get the modules manifest file
      const path = `modules/${module.id}/module.json`;
      const data = await Utils.api(`${window.location.origin}/data/${path}`);

      // make sure this is the module we requested
      if (!data || module.id !== (data.id || data.name)) {
        UI.alert("danger", t("Error retrieving module manifest, {{module}}", {
          module: module.name
        }), true);
        module.converting = false;
        throw new Error(t("Error retrieving module manifest, {{module}}", {
          module: module.name
        }));
      }

      // Save a backup copy in case this method messes something up, and prevent overwrite so additional runs don't destroy the backup.
      const backupUrl = `modules/${module.id}/module-backup-pre-fix.json`;
      await Utils.uploadDataFile(backupUrl, JSON.stringify(data, null, 2), {
        overwrite: false,
        type: "application/json"
      });

      // Fix the id
      data.id = data.name = module.id;

      // Fix the compatibility
      data.compatibility = data.compatibility || {};
      data.compatibility.verified = data.compatibility.verified || "10";
      if (module.needsSystemFix) {
        // Change the system in relationships
        const relationships = data.relationships || {};
        relationships.systems = module.system.map(s => {
          return {
            id: s.id,
            type: "system"
          };
        });
        data.relationships = relationships;
      }
      if (module.needsTypeFix) {
        // Set pack.type to pack.entity if it exists
        const packs = data.packs || [];
        packs.forEach(pack => {
          if (pack.entity && !pack.type) {
            pack.type = pack.entity;
          }
        });
      }

      // save the manifest file changes
      const result = await Utils.uploadDataFile(path, JSON.stringify(data, null, 2), {
        overwrite: true,
        type: "application/json"
      });
      if (!result.success) {
        UI.alert("danger", result.error || t("Error fixing module, {{module}}", {
          module: module.name
        }), true);
      } else {
        UI.alert("success", t("{{module}} module has been fixed", {
          module: module.name
        }), true, 10000);
        const idx = this.compendiums.findIndex(c => c.id === module.id);
        if (idx !== -1) {
          this.compendiums.splice(idx, 1);
        }
      }
      module.converting = false;
    },
    async loadSystems() {
      if (this.systemsLoaded) {
        return;
      }
      const bazaar = await Utils.api(`bazaar/systems`);
      this.systems = bazaar.packages;

      // Find all the user's installed systems
      const installedSystems = await Utils.api("data/systems");
      if (installedSystems.error) {
        UI.alert("danger", t("Error retrieving data: {{- error}}", {
          error: installedSystems.error
        }));
        return;
      }
      // For each installed system get the package information and add it to the installed systems list
      this.installedSystems = installedSystems.map(s => {
        return {
          id: s.id,
          label: s.title
        };
      }).sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
      this.systemsLoaded = true;
    }
  },
  async created() {
    this.loading = true;
    await this.loadSystems();
    const defaultSystem = this.installedSystems.length == 1 ? this.installedSystems[0] : null;
    this.compendiums = this.invalidCompendiums.map(c => {
      // Technically, with the current code from listInvalidCompendiumModules we'll never reference compendiumSystem
      // since the function excludes manifests that have only one system.  So either system is null, or relationships.systems has multiple items to get here.
      // Leaving this here though in case that changes, we have something more accurate to default to.
      let compendiumSystem = [c.data.system];
      if (c.data.relationships && c.data.relationships.systems && c.data.relationships.systems.length > 0) {
        compendiumSystem = c.data.relationships.systems.map(s => s.id);
      }
      // Make sure that the ids exist in the system list
      compendiumSystem = compendiumSystem.map(cs => {
        const system = this.systems.find(s => s.id === cs);
        if (system) {
          return {
            id: system.id,
            label: system.title
          };
        }
      }).filter(cs => !!cs);
      // If there's no system set, and the user only has one system loaded, then we can default to that one.
      if (compendiumSystem.length === 0 && defaultSystem) {
        compendiumSystem = [defaultSystem];
      }

      // v10 requirement: If a module has no system or more than one system
      //  relationship, each Actor or Item pack needs to have its system defined
      const cSystems = c.data.relationships && c.data.relationships.systems || c.data.systems || c.data.system;
      const hasNoSystems = !cSystems || Array.isArray(cSystems) && cSystems.length === 0;
      const hasMultipleSystems = cSystems && Array.isArray(cSystems) && cSystems.length > 1;
      const needsSystemFix = (hasNoSystems || hasMultipleSystems) && (c.data.packs || []).some(pack => !pack.system && ["Actor", "Item"].includes(pack.entity || pack.type));
      // v11 requirement: If a module has packs with no type but with entity, then we need to set the type to the entity
      const needsTypeFix = (c.data.packs || []).some(pack => pack.entity && !pack.type);
      return {
        name: c.title,
        id: c.id,
        system: compendiumSystem,
        // Although technically system is an array, we only allow one system for conversion purposes
        convertWarnings: false,
        packs: (c.data.packs || []).filter(p => ["Actor", "Item"].includes(p.type || p.entity)).map(p => {
          return {
            id: p.name,
            name: p.label,
            type: p.type || p.entity,
            system: p.system || null
          };
        }),
        converting: false,
        needsSystemFix,
        needsTypeFix
      };
    });
    this.loading = false;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ContactPage"] = Vue.component(
                    "ContactPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"contact\"> <div class=\"text-center mb-5\"> <img src=\"/images/contact.png\" width=\"128\" /> <h2>{{ t(\"Let's get in touch!\") }}</h2> </div> <b-card :header=\"t('Live Chat')\"> <p> {{ t( \"To contact us, you can join our Discord, where you’ll get the fastest response times, and join a large and growing community of Forge and Foundry users. Additionally, you’ll be able to chat live with Forge moderators and staff, with extensive experience in using The Forge and Foundry Virtual Tabletop to their fullest!\" ) }} </p> <p> {{ t(\"You can join our Discord\") }} <a href=\"/discord\">{{ t(\"here\") }}</a >! </p> <a href=\"/discord\"><img src=\"/images/social/discord-logo-and-text.png\" class=\"contact__discord-logo\" /></a> </b-card> <b-card :header=\"t('Email')\" class=\"mt-3\"> <p> {{ t(\"Have sensitive Forge account issues, payment problems, or business inquiries?\") }} </p> <p> {{ t(\"You can reach us via email at:\") }} <a href=\"mailto:contact@forge-vtt.com\"><i class=\"far fa-envelope\"></i> contact@forge-vtt.com</a> </p> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".contact__discord-logo{max-width:400px;width:100%}"
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["LoginPage"] = Vue.component(
                    "LoginPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-tabs class=\"login-page\" justified @input=\"toggleSignup\"> <b-tab :title=\"t('Sign In')\" :active=\"!signup\"> <security2fa-code-request v-model=\"showCodeRequest\" :error=\"codeRequestError\" :type=\"codeRequestType\" @submit=\"loginWithOtp\" ></security2fa-code-request> <b-form @submit.prevent=\"login\"> <h1>{{ t(\"Welcome back!\") }}</h1> <b-form-group :label=\"t('Username/Email')\"> <b-form-input v-model=\"form.username\" type=\"text\" :placeholder=\"t('Username or email address')\" required ></b-form-input> </b-form-group> <b-form-group :label=\"t('Password')\"> <b-input-group> <b-form-input v-model=\"form.password\" :type=\"showPassword ? 'text' : 'password'\" name=\"password\" :placeholder=\"t('Enter your password')\" required ></b-form-input> <b-input-group-append> <b-button variant=\"info\" @click=\"showPassword = !showPassword\"> <i class=\"fas fa-eye\" :hidden=\"showPassword\"></i> <i class=\"fas fa-eye-slash\" :hidden=\"!showPassword\"></i> </b-button> </b-input-group-append> </b-input-group> </b-form-group> <b-form-group> <a href=\"/account/forgot-password\">{{ t(\"Forgot password?\") }}</a> </b-form-group> <b-form-group v-if=\"dicetchaEnabled\" :label=\"captcha.label\" style=\"text-align: center\"> <div v-if=\"loadingDicetcha\" class=\"text-center\"> <p>{{ t(\"Rolling the dice…\") }}</p> <div class=\"dice-image-container\"> <img src=\"/images/dice/red-d20-centered.png\" :alt=\"t('Red D20')\" class=\"dice-rotating-image dice-image1\" /> <img src=\"/images/dice/green-d20-centered.png\" :alt=\"t('Green D20')\" class=\"dice-rotating-image dice-image2\" /> <img src=\"/images/dice/orange-d20-centered.png\" :alt=\"t('Orange D20')\" class=\"dice-rotating-image dice-image3\" /> </div> </div> <b-form-radio-group v-else v-model=\"form.captcha\" :options=\"captcha.dice\" class=\"captcha-radio\" button-variant=\"outline-primary\" size=\"lg\" ></b-form-radio-group> </b-form-group> <b-form-group v-else-if=\"cfTurnstileEnabled\" :label=\"t('Are you human?')\"> <div ref=\"loginTurnstile\" class=\"render-cf-turnstile\" data-action=\"login\" :data-sitekey=\"cfTurnstileSiteKey\" ></div> </b-form-group> <div class=\"form-buttons\"> <b-form-group class=\"form-buttons mb-0\"> <b-button type=\"submit\" variant=\"primary\" :disabled=\"processing || incompleteForm\">{{ t(\"Sign In\") }}</b-button> </b-form-group> <separator title=\"Or\" classes=\"my-2\"></separator> <b-form-group class=\"form-buttons\"> <b-button href=\"/account/auth/patreon\" variant=\"patreon\" ><img src=\"/images/social/patreon-white.svg\" />{{ t(\"Sign in with Patreon\") }}</b-button > <b-button href=\"/account/auth/google\" variant=\"google\" ><img src=\"/images/social/g-logo.svg\" />{{ t(\"Sign in with Google\") }}</b-button > <b-button href=\"/account/auth/discord\" variant=\"discord\" ><img src=\"/images/social/discord-logo-white.svg\" />{{ t(\"Sign in with Discord\") }}</b-button > </b-form-group> </div> </b-form> </b-tab> <b-tab :title=\"t('Sign Up')\" :active=\"signup\"> <b-form @submit.prevent=\"register\"> <b-alert v-if=\"disableSignups || disablePasswordSignups\" variant=\"danger\" :show=\"true\"> <i class=\"fas fa-exclamation-triangle\"></i> {{ t(\"New account creation is temporarily disabled.\") }} <span v-if=\"!disableSignups\"> <br /> {{ t(\"You can still create an account by signing up with Patreon, Google, or Discord.\") }} </span> </b-alert> <input type=\"hidden\" name=\"_csrf\" :value=\"csrf\" /> <h1>{{ t(\"Create new account\") }}</h1> <b-form-group :label=\"t('Name')\"> <b-form-input v-model=\"form.name\" type=\"text\" :placeholder=\"t('Display name')\" :disabled=\"disableSignups || disablePasswordSignups\" required :state=\"nameValidationState\" ></b-form-input> <p v-show=\"nameValidationError\" class=\"invalid-feedback\">{{ nameValidationError }}</p> </b-form-group> <b-form-group :label=\"t('Username')\"> <b-form-input v-model=\"form.username\" type=\"text\" :placeholder=\"t('Choose a username')\" :disabled=\"disableSignups || disablePasswordSignups\" required :state=\"usernameValidationState\" @change=\"usernameExists = false\" ></b-form-input> <p v-show=\"!!usernameValidationError\" class=\"invalid-feedback\">{{ usernameValidationError }}</p> </b-form-group> <b-form-group :label=\"t('Email')\"> <b-form-input v-model=\"form.email\" type=\"email\" name=\"email\" :placeholder=\"t('Enter your email address')\" :disabled=\"disableSignups || disablePasswordSignups\" required :state=\"emailValidationState\" @change=\"emailExists = false\" ></b-form-input> <p v-show=\"!!emailValidationError\" class=\"invalid-feedback\">{{ emailValidationError }}</p> </b-form-group> <b-form-group :label=\"t('Password')\"> <b-input-group> <b-form-input v-model=\"form.password\" :type=\"showRegisterPassword ? 'text' : 'password'\" name=\"password\" :placeholder=\"t('Select a secure password')\" :disabled=\"disableSignups || disablePasswordSignups\" required :state=\"passwordValidationState\" ></b-form-input> <b-input-group-append> <b-button v-if=\"showGeneratePassword\" variant=\"outline-primary\" @click=\"generateSecurePassword\"> {{ t(\"Generate\") }} </b-button> <b-button variant=\"primary\" @click=\"showRegisterPassword = !showRegisterPassword\"> <i class=\"fas fa-eye\" :hidden=\"showRegisterPassword\"></i> <i class=\"fas fa-eye-slash\" :hidden=\"!showRegisterPassword\"></i> </b-button> </b-input-group-append> </b-input-group> <p v-show=\"!!passwordValidationError\" class=\"invalid-feedback\">{{ passwordValidationError }}</p> <p v-show=\"passwordGenerated\" class=\"form-sublabel\"> {{ t(\"Save the generated password and store it securely!\") }} </p> </b-form-group> <b-form-group :label=\"t('Confirm Password')\"> <b-input-group> <b-form-input v-model=\"form.confirmPassword\" :type=\"showRegisterPasswordConfirm ? 'text' : 'password'\" name=\"confirmPassword\" :placeholder=\"t('Please confirm your password')\" :disabled=\"disableSignups || disablePasswordSignups\" required :state=\"confirmPasswordValidationState\" ></b-form-input> <b-input-group-append> <b-button variant=\"primary\" @click=\"showRegisterPasswordConfirm = !showRegisterPasswordConfirm\"> <i class=\"fas fa-eye\" :hidden=\"showRegisterPasswordConfirm\"></i> <i class=\"fas fa-eye-slash\" :hidden=\"!showRegisterPasswordConfirm\"></i> </b-button> </b-input-group-append> </b-input-group> <p v-show=\"!!passwordValidationError\" class=\"invalid-feedback\">{{ passwordValidationError }}</p> </b-form-group> <b-form-group> <b-form-checkbox v-model=\"tosAccepted\" :disabled=\"disableSignups || disablePasswordSignups\"> <i18n :path=\"t('LOGIN.ACCEPT_TOS')\"> <a href=\"/tos\" target=\"_blank\">{{ t(\"Terms of Service\") }}</a> </i18n> </b-form-checkbox> </b-form-group> <b-form-group v-if=\"dicetchaEnabled\" :label=\"captcha.label\" style=\"text-align: center\"> <div v-if=\"loadingDicetcha\" class=\"text-center\"> <p>{{ t(\"Rolling the dice…\") }}</p> <div class=\"dice-image-container\"> <img src=\"/images/dice/red-d20-centered.png\" :alt=\"t('Red D20')\" class=\"dice-rotating-image dice-image1\" /> <img src=\"/images/dice/green-d20-centered.png\" :alt=\"t('Green D20')\" class=\"dice-rotating-image dice-image2\" /> <img src=\"/images/dice/orange-d20-centered.png\" :alt=\"t('Orange D20')\" class=\"dice-rotating-image dice-image3\" /> </div> </div> <b-form-radio-group v-else v-model=\"form.captcha\" :options=\"captcha.dice\" class=\"captcha-radio\" button-variant=\"outline-primary\" size=\"lg\" ></b-form-radio-group> </b-form-group> <b-form-group v-else-if=\"cfTurnstileEnabled\" :label=\"t('Are you human?')\"> <div ref=\"signupTurnstile\" class=\"render-cf-turnstile\" data-action=\"signup\" :data-sitekey=\"cfTurnstileSiteKey\" ></div> </b-form-group> <div class=\"form-buttons\"> <b-form-group class=\"form-buttons mb-0\"> <b-button type=\"submit\" variant=\"primary\" :disabled=\"disableSignups || disablePasswordSignups || processing || incompleteForm\" >{{ t(\"Sign Up\") }}</b-button > </b-form-group> <separator :title=\"t('Or')\" classes=\"my-2\"></separator> <b-form-group class=\"form-buttons\"> <b-button href=\"/account/auth/patreon\" variant=\"patreon\" :disabled=\"disableSignups\"> <img src=\"/images/social/patreon-white.svg\" />{{ t(\"Sign Up with Patreon\") }} </b-button> <b-button href=\"/account/auth/google\" variant=\"google\" :disabled=\"disableSignups\"> <img src=\"/images/social/g-logo.svg\" />{{ t(\"Sign Up with Google\") }} </b-button> <b-button href=\"/account/auth/discord\" variant=\"discord\" :disabled=\"disableSignups\"> <img src=\"/images/social/discord-logo-white.svg\" />{{ t(\"Sign Up with Discord\") }} </b-button> </b-form-group> </div> </b-form> </b-tab> </b-tabs>",
  beforeCreate() {
    Utils.loadCss({
      content: ".login-page { padding: 0; margin: 0 auto; width: 100%; max-width: 1000px; } .login-page form { margin: 0; padding: 3em; background: #fff; } .login-page .nav-item { border: none; } .login-page .nav-link { border-top-left-radius: 6px; border-top-right-radius: 6px; border-top: solid 4px transparent; font-size: 1.1em; font-weight: bold; } .login-page .nav-link.active { border-top-color: #f96854; } .login-page .nav-link:not(.active):hover { color: #f96854; background: rgba(255, 255, 255, 0.45); } .login-page h1 { width: 100%; text-align: center; } .login-page .form-group.form-buttons > div { display: flex; flex-direction: column; } .login-page .invalid-feedback { margin-bottom: 0; } .login-page .form-sublabel { margin-bottom: 0; width: 100%; margin-top: 0.25rem; font-size: 80%; color: var(--info) !important; } @media (min-width: 720px) { .login-page .form-group.form-buttons > div { flex-direction: row; } } .login-page .form-group.form-buttons .toggle { font-size: 2em; font-family: \"El Messiri\", serif; } .login-page .form-group.form-buttons .btn { margin: 0.4em 0; } @media (min-width: 420px) { .login-page .form-group.form-buttons .btn { min-width: 15em; } .login-page .form-group.form-buttons .btn { margin: 0.4em auto; } } /* Buttons */ .login-page .form-group > div { flex-wrap: wrap; gap: 12px; } .login-page .form-buttons, .login-page .form-buttons button, .login-page .form-buttons .btn { font-family: \"Roboto\", sans-serif; } .login-page .form-buttons button, .login-page .form-buttons .btn { padding: 8px; } .login-page .form-buttons button img, .login-page .form-buttons .btn img { width: 18px; height: 18px; margin-right: 8px; } .login-page .btn-patreon { color: #fff; background-color: #f96854; border-color: #f96854; } .login-page .btn-patreon:hover { /* #f6270a = darken(#f8523b, 5%) */ background-color: #f8523b; border-color: #f8523b; } .login-page .btn-google { color: rgba(0, 0, 0, 0.54); background-color: #ffffff; border-color: #4285f4; font-weight: 500; /* Medium */ } .login-page .btn-google:hover { filter: brightness(95%); } .login-page .btn-discord { color: #fff; background-color: #5765f2; border-color: #5765f2; } .login-page .btn-discord:hover { background-color: #4752c4; border-color: #4752c4; } .captcha-radio .custom-control-label { padding: 0 20px; } .captcha-radio .custom-control-label::after { display: none; } .captcha-radio .custom-control-label::before { display: none; } .captcha-radio .custom-control-input:checked ~ .custom-control-label { border: 1px solid #007bff; border-radius: 0.25rem; background-color: #007bff; color: #fff; } .dice-image-container { margin: 0 auto; position: relative; width: 100px; /* Adjust to fit your images */ height: 100px; /* Adjust to fit your images */ overflow: hidden; animation: rotate-center 0.6s ease-in-out both infinite; } .dice-rotating-image { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; /* Start hidden */ animation: rotateImage 3s infinite; /* 12s for the full cycle of all images */ } @keyframes rotateImage { /* Define keyframes for each image's appearance */ 0%, 33.333%, 100% { opacity: 0; } 8.333% { opacity: 1; } /* Image 1 */ 41.666% { opacity: 1; } /* Image 2 */ 75% { opacity: 1; } /* Image 3 */ } @keyframes rotate-center { 0% { transform: rotate(0); } 100% { transform: rotate(360deg); } } .dice-image1 { animation-delay: 0s; } .dice-image2 { animation-delay: -1s; /* Adjust based on total animation time / number of images */ } .dice-image3 { animation-delay: -2s; /* Adjust based on total animation time / number of images */ }"
    });
  },
  props: {
    csrf: String,
    emailField: String,
    signup: Boolean,
    otp: Boolean,
    disableSignups: {
      type: Boolean,
      default: false
    },
    disablePasswordSignups: {
      type: Boolean,
      default: false
    },
    cfTurnstileSiteKey: {
      type: String,
      default: ""
    },
    showGeneratePassword: {
      type: Boolean,
      default: false
    },
    dicetchaChallenge: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      authCode: null,
      showSignup: this.signup,
      showCodeRequest: this.otp,
      codeRequestError: null,
      tosAccepted: false,
      codeRequestType: Enums.CodeRequestTypes.LOGIN,
      form: {
        name: "",
        username: "",
        password: "",
        confirmPassword: "",
        email: ""
      },
      _csrf: null,
      processing: false,
      emailExists: false,
      usernameExists: false,
      showRegisterPassword: false,
      showRegisterPasswordConfirm: false,
      passwordGenerated: false,
      showPassword: false,
      loadingDicetcha: true,
      captchaServerError: false,
      captcha: {
        label: null,
        dice: null
      }
    };
  },
  computed: {
    nameValidationError() {
      if (!this.form.name) {
        return null;
      }
      return this.form.name.length >= 3 ? null : t("Please enter a display name of at least 3 characters");
    },
    nameValidationState() {
      if (!this.form.name) {
        return null;
      }
      return !this.nameValidationError;
    },
    usernameValidationError() {
      if (this.usernameExists) {
        return t("An account with this username already exists");
      }
      if (!this.form.username) {
        return null;
      }
      return this.form.username.length > 0 ? null : t("Please enter a username");
    },
    usernameValidationState() {
      if (!this.form.username) {
        return null;
      }
      return !this.usernameValidationError;
    },
    emailValidationError() {
      if (this.emailExists) {
        return t("An account with this email address already exists");
      }
      if (!this.form.email) {
        return null;
      }
      // According to http://emailregex.com/
      const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.form.email.match(emailRegexp) ? null : t("Please enter a valid email address");
    },
    emailValidationState() {
      if (!this.form.email) {
        return null;
      }
      return !this.emailValidationError;
    },
    passwordValidationError() {
      if (!this.form.password || !this.form.confirmPassword) {
        return null;
      }
      if (this.form.password !== this.form.confirmPassword) {
        return t("Passwords do not match");
      } else if (this.form.password.length < 8) {
        return t("Password must be at least 8 characters long");
      }
      return null;
    },
    passwordValidationState() {
      if (!this.form.password) {
        return null;
      }
      return !this.passwordValidationError;
    },
    confirmPasswordValidationState() {
      if (!this.form.confirmPassword) {
        return null;
      }
      return !this.passwordValidationError;
    },
    incompleteForm() {
      if (this.showSignup) {
        // Sign up form
        if (!(this.form.name && this.form.username && this.form.email && this.form.password && this.form.confirmPassword && this.tosAccepted)) {
          // An input is still empty
          return true;
        }
        // Check for errors
        return !!(this.nameValidationError || this.usernameValidationError || this.emailValidationError || this.passwordValidationError);
      }
      // Login form
      return !(this.form.username && this.form.password);
    },
    dicetchaEnabled() {
      return !!this.dicetchaChallenge;
    },
    cfTurnstileEnabled() {
      return !this.dicetchaEnabled && !!this.cfTurnstileSiteKey;
    }
  },
  methods: {
    toggleSignup(tabIndex) {
      window.history.replaceState({}, document.title, ["/account/login", "/account/signup"][tabIndex]);
      this.resetForm();
      this.showSignup = tabIndex === 1;
    },
    async getNewCaptcha() {
      this.loadingDicetcha = true;
      this.captcha.label = null;
      this.form.captcha = null;
      const response = await Utils.api("account/captcha", {
        challengeId: this.dicetchaChallenge
      });
      this.loadingDicetcha = false;
      if (response.error) {
        if (response.code === 500) {
          // Internal server error, disable captcha verification
          this.captchaServerError = true;
        } else {
          // TODO: API failed, retry with exponential backoff or prompt user to refresh the page
          UI.error(response.error, true, 5000);
        }
      } else {
        this.captcha.label = response.label;
        this.captcha.dice = [];
        for (const id of Object.keys(response.dice)) {
          this.captcha.dice.push({
            value: id,
            html: `<img height="120" src="data:image/png;base64,${response.dice[id]}" />`
          });
        }
      }
    },
    isCaptchaDone() {
      if (this.dicetchaEnabled) {
        return !!this.form.captcha || this.captchaServerError;
      }
      if (this.cfTurnstileEnabled) {
        // Verify the turnstile is valid
        if (this.cfTurnstileSiteKey && typeof window.turnstile !== "undefined") {
          const ref = this.showSignup ? this.$refs.signupTurnstile : this.$refs.loginTurnstile;
          const widgetId = ref.dataset.cfTurnstileWidgetId;
          if (!widgetId || !window.turnstile.getResponse(widgetId) || window.turnstile.isExpired(widgetId)) {
            return false;
          }
        }
        return true;
      }
      return true;
    },
    async login() {
      if (this.incompleteForm) {
        return false;
      }
      if (!this.isCaptchaDone()) {
        UI.alert("warning", t("Please confirm that you are human before proceeding…"), true, 5000);
        return false;
      }
      this.processing = true;
      const turnstileResponse = this.cfTurnstileEnabled ? this.$refs.loginTurnstile.dataset.cfTurnstileResponse : undefined;
      const response = await Utils.api("account/login", {
        username: this.form.username,
        password: this.form.password,
        captcha: this.form.captcha,
        challengeId: this.dicetchaChallenge,
        turnstileResponse
      });
      if (response.error) {
        UI.error(response.error, true, 5000);
        if (this.dicetchaEnabled) {
          await this.getNewCaptcha();
        } else if (this.cfTurnstileEnabled) {
          const turnstileWidgetId = this.$refs.loginTurnstile.dataset.cfTurnstileWidgetId;
          if (turnstileWidgetId && typeof window.turnstile !== "undefined") {
            window.turnstile.reset(turnstileWidgetId);
          }
        }
      } else if (response.otp) {
        this.form.password = "";
        this.codeRequestError = null;
        this.showCodeRequest = true;
      } else {
        UI.alert("success", this.t("Welcome back!"));
        window.location = response.returnTo || "/";
      }
      this.processing = false;
    },
    async loginWithOtp(code) {
      const response = await Utils.api("account/otp", {
        authCode: code
      });
      if (response.error) {
        this.codeRequestError = response.error;
      } else {
        UI.alert("success", this.t("Welcome back!"));
        window.location = response.returnTo || "/";
      }
    },
    generateSecurePassword() {
      // Generate 15 character alphanumeric password without easy to confuse characters
      const password = Utils.generatePassword(4);
      this.form.password = password;
      this.showRegisterPassword = true;
      this.passwordGenerated = true;
    },
    async register() {
      if (this.incompleteForm) {
        return false;
      }
      if (!this.isCaptchaDone()) {
        UI.alert("warning", t("Please confirm that you are human before proceeding…"), true, 5000);
        return false;
      }
      this.emailExists = false;
      this.usernameExists = false;
      this.processing = true;
      const turnstileResponse = this.cfTurnstileEnabled ? this.$refs.signupTurnstile.dataset.cfTurnstileResponse : undefined;
      if (this.form.email) {
        this.form[this.emailField] = this.form.email;
      }
      const response = await Utils.api("account/signup", {
        ...this.form,
        challengeId: this.dicetchaChallenge,
        turnstileResponse
      });
      if (response.error) {
        if (response.errorCode === "exists.email") {
          this.emailExists = true;
        } else if (response.errorCode === "exists.username") {
          this.usernameExists = true;
        } else {
          UI.alert("danger", response.error, true, 5000);
        }
        if (this.dicetchaEnabled) {
          await this.getNewCaptcha();
        } else if (this.cfTurnstileEnabled) {
          const turnstileWidgetId = this.$refs.signupTurnstile.dataset.cfTurnstileWidgetId;
          if (turnstileWidgetId && typeof window.turnstile !== "undefined") {
            window.turnstile.reset(turnstileWidgetId);
          }
        }
      } else {
        // Clean up the forms
        this.resetForm();
        UI.alert("success", this.t("Success! Your account has been created."));
        window.location = response.returnTo || "/";
      }
      this.processing = false;
    },
    resetForm() {
      this.form.name = "";
      this.form.username = "";
      this.form.password = "";
      this.form.confirmPassword = "";
      this.form.email = "";
      this.tosAccepted = false;
      if (this.dicetchaEnabled) {
        this.getNewCaptcha();
      }
    }
  },
  mounted() {
    // Replace the generic `#` tab links with a specific, usable URI
    this.$nextTick().then(() => {
      const tabs = document.querySelectorAll(".login-page .nav-item .nav-link");
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].href = ["/account/login", "/account/signup"][i];
      }
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["MainPage"] = Vue.component(
                    "MainPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-container class=\"page-container rounded p-0 overflow-hidden\"> <b-row v-if=\"!!$slots.header\"> <b-col> <header> <slot name=\"header\"></slot> </header> </b-col> </b-row> <b-row class=\"page-container-body m-0 rounded\" :class=\"bodyClass\"> <b-col v-if=\"hasSidePanel('left')\" class=\"page-left p-0\"> <slot name=\"left\"></slot> </b-col> <b-col class=\"page-body p-0 rounded\"> <slot> <loading-indicator small :label=\"loadingText\"></loading-indicator> </slot> </b-col> <b-col v-if=\"hasSidePanel('right')\" class=\"page-right p-0\"> <slot name=\"right\"></slot> </b-col> </b-row> <b-row v-if=\"!!$slots.footer\"> <b-col> <footer> <slot name=\"footer\"></slot> </footer> </b-col> </b-row> </b-container> <div class=\"modal-container\"> <slot name=\"modals\"></slot> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".main-container #main { padding-bottom: 185px; } .page-container { max-width: unset; /* This is here because the container class is altered in the main css file */ min-height: calc(100vh - 318px); } .page-container-body { min-height: calc(100vh - 319px); flex-direction: column; } .page-body { background-color: #fff; } @media (min-width: 1300px) { .page-container-body { flex-direction: row; } .page-container-body.showsides .page-body { width: 1190px; flex: 0 0 1190px; } } .page-container-body:not(.showsides) .page-left, .page-container-body:not(.showsides) .page-right { flex-grow: 0; } .modal-container .package-overlay { width: calc(100vw - 80px); height: calc(100vh - 5rem - 25px); margin-top: calc(5rem + 25px); border-radius: 10px; } .modal-container .package-overlay > div { overflow: auto; border-radius: 0.3rem; height: 100%; background-color: var(--light); } .modal-container .package-overlay .foundry-full-package-view { min-height: 100%; }"
    });
  },
  props: {
    showsides: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: t("Loading content")
    }
  },
  computed: {
    bodyClass() {
      return this.showsides ? "showsides" : "";
    }
  },
  methods: {
    hasSidePanel(side) {
      return !!this.$slots[side] || this.showsides;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPage"] = Vue.component(
                    "PricingPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"container pricing\"> <header class=\"text-center mb-3\"> <img src=\"/images/coin-pouch.png\" width=\"128\" /> <h1>{{ t(\"Subscription Plans and Pricing\") }}</h1> <p>{{ t(\"All plans are ad-free.\") }}</p> </header> <section class=\"pricing__section pricing__section--paid-plans\"> <header> <h2>{{ t(\"Plans for Game Masters\") }}</h2> <p> {{ t( \"The Forge is a hosting platform for the Foundry Virtual Tabletop gaming software, and requires a valid Foundry license to host your own games.\" ) }} </p> </header> <div class=\"pricing__interval-picker\"> <button :class=\"{ 'pricing__interval-picker__button': true, 'pricing__interval-picker__button--active': !shouldShowAnnual, }\" type=\"button\" @click=\"shouldShowAnnual = false\" > {{ t(\"Billed Monthly\") }} </button> <button :class=\"{ 'pricing__interval-picker__button': true, 'pricing__interval-picker__button--active': shouldShowAnnual, }\" type=\"button\" @click=\"shouldShowAnnual = true\" > {{ t(\"Billed Annually\") }} </button> </div> <div class=\"pricing__plans\"> {{ /* This data comes from PRICE_PLANS in /common/constants.js */ }} <pricing-plan v-for=\"plan in plans\" :key=\"plan.title\" :title=\"plan.title\" :should-show-annual=\"shouldShowAnnual\" :features=\"plan.features\" :price-monthly=\"plan.price.monthly\" :price-annual=\"plan.price.annualByMonth\" :is-popular=\"!!plan.isPopular\" :register-route=\"plan.registerRoute\" > <p>{{ plan.subtitle }}</p> <p slot=\"pre-features\">{{ plan.featureCaption }}</p> <i18n v-if=\"shouldShowAnnual\" slot=\"price-caption\" path=\"or ${0}/year\"> <span>{{ plan.price.annual }}</span> </i18n> </pricing-plan> </div> <footer> <b-button variant=\"success\" @click=\"scrollToPlanComparison\">{{ t(\"Compare plans\") }}</b-button> </footer> </section> <section class=\"pricing__section pricing__section--player-plan\"> <header> <h2>{{ t(\"The Player Plan\") }}</h2> <p> {{ t( \"Free, forever! Join games hosted on The Forge, and enjoy a personal asset library shared across all games.\" ) }} </p> </header> <b-button variant=\"success\" href=\"/signup\">{{ t(\"Register for free!\") }}</b-button> </section> <section class=\"pricing__section pricing__section--extras\"> <header> <h2>Extras</h2> <p> {{ t( \"Annual subscribers may choose to purchase add-ons to enhance their subscription benefits. Extras can be purchased multiple times.\" ) }} </p> </header> {{ /* This data comes from SUBSCRIPTION_EXTRA_PLANS in /service/constants.js */ }} <pricing-extra v-for=\"extra in extras\" :key=\"extra.name\" :title=\"extra.name\" :price=\"extra.cost\" :img-src=\"extra.image\" > <span slot=\"caption\"> <i18n path=\"per additional {0}\" tag=\"span\">{{ extra.sizeLabel }}</i18n> </span> <p>{{ t(extra.description) }}</p> </pricing-extra> </section> <section class=\"pricing__section pricing__section--plan-comparison\"> <header> <h2>{{ t(\"Plan Comparison\") }}</h2> </header> <div class=\"pricing__plan-comparison-container\"> <pricing-plan-compare-table></pricing-plan-compare-table> </div> </section> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing{container-type:inline-size;container-name:pricing}.theme--slate .pricing .btn{background:var(--color-forge-green-dark)}.pricing a[href^=http]:after{display:inline-block;font-family:\"Font Awesome 5 Free\";content:\"\";font-weight:900;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:auto;margin-left:.385em;font-size:.75em}.pricing .with-tooltip{position:relative}.pricing .with-tooltip:after{content:\"\";position:absolute;bottom:-4px;left:0;right:0;border-bottom:1px dashed var(--color-forge-blue)}@media(max-width: 767px){.pricing{padding-left:.25em;padding-right:.25em;max-width:100%}}.pricing__section{max-width:80ch;margin:0 auto 5em;--multicolumn-columns: 1fr;--pricing-plans-gaps: 3em}.pricing__section>header{max-width:60ch;text-align:center;margin:0 auto;margin-bottom:1em}.pricing__section>header :is(h2,h3,h4){margin:0 auto .5em;position:relative;width:fit-content}.pricing__section>header :is(h2,h3,h4):after{content:\"\";position:absolute;display:block;left:-2em;right:-2em;bottom:0;background:linear-gradient(90deg, transparent, currentcolor, currentcolor, transparent);height:1px}.pricing__section>header *:last-child{margin-bottom:0}.pricing__section--extras{display:grid;grid-template-columns:var(--multicolumn-columns);gap:1em}.pricing__section--paid-plans{max-width:120ch}.pricing__section--paid-plans>header{margin-bottom:3em}.pricing__section--paid-plans .pricing__interval-picker{display:grid;grid-template-columns:repeat(2, 1fr);max-width:30ch;margin:0 auto 2em}.pricing__section--paid-plans .pricing__interval-picker__button{background:none;border:none;text-align:center;position:relative;color:inherit}.pricing__section--paid-plans .pricing__interval-picker__button:focus{outline:none}.pricing__section--paid-plans .pricing__interval-picker__button--active{font-weight:600}.pricing__section--paid-plans .pricing__interval-picker__button--active:after{content:\"\";display:block;position:absolute;bottom:0;left:0;right:0;height:2px;background-color:var(--color-forge-green)}.pricing__section--paid-plans .pricing__plans{display:grid;grid-template-columns:var(--multicolumn-columns);gap:var(--pricing-plans-gaps);padding-top:2em;margin-bottom:3em}.pricing__section--paid-plans footer{text-align:center}.pricing__section--player-plan{max-width:60ch;display:flex;flex-direction:column;gap:1em;text-align:center}.pricing__section--player-plan ul{display:grid;grid-template-columns:repeat(3, 1fr);margin:0;padding:0;gap:.5em;list-style:none}.pricing__section--player-plan .btn{width:fit-content;margin:0 auto}.pricing__section--plan-comparison{--plan-columns: repeat(4, 11ch);--plan-gap: 1em;--plan-border-color: #b1b2b5;scroll-margin-top:70px}.pricing__section--plan-comparison .pricing__plan-comparison-container{width:100%;height:80vh;max-width:120ch;padding:0 1em;overflow:scroll;container-type:inline-size;container-name:price-comparison-container}.pricing__section--plan-comparison h2{text-align:center;margin-bottom:1em}@container pricing (min-width: 768px){.pricing__section{--multicolumn-columns: repeat(3, 1fr);--pricing-plans-gaps: 0}.pricing__section--extras header{grid-column:1/4}.pricing__section--plan-comparison .pricing__plan-comparison-container{height:unset;overflow:unset}}"
    });
  },
  props: {
    extras: {
      type: [String, Object],
      default: () => ({})
    }
  },
  data: () => ({
    shouldShowAnnual: true,
    extraEntries: []
  }),
  computed: {
    plans: () => PAID_PLANS
  },
  methods: {
    scrollToPlanComparison() {
      document.querySelector(".pricing__section--plan-comparison").scrollIntoView({
        behavior: "smooth"
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingTable"] = Vue.component(
                    "PricingTable",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<!-- <pricing-table :tiers=\"{{ JSONstringify tiers }}\" :signed-in=\"{{ signedIn }}\" :tier=\"{{ tier }}\" :trial-left=\"{{ trialLeft }}\" class=\"vue-render-app\"></pricing-table> --> <b-card-group deck center class=\"pricing-plans\"> <b-card v-for=\"tier in showTiers\" :key=\"tier.code\" border-variant=\"success\" body-class=\"p-0\" center :class=\"tierClass(tier)\" > <template> <div v-if=\"tier.ribbon\" class=\"attract-ribbon\"> <span>{{ tier.ribbon }}</span> </div> <div class=\"d-flex flex-column text-center h-100\"> <img class=\"align-self-center\" :src=\"`/images/${tier.code}-512x512.png`\" width=\"200px\" height=\"200px\" /> <h2>{{ tier.name }}</h2> <h5 v-if=\"tier.tagline\">{{ tier.tagline }}</h5> <div class=\"pricing-details\"> <span class=\"price\">{{ tierPrice(tier) }}</span> <span v-if=\"tierMonthly(tier)\">/{{ t(\"month\") }}</span> <p v-if=\"tierMonthly(tier)\"> {{ t(\"billed annually\") }}<br /> (<strong>${{ tierMonthly(tier) }}</strong> {{ t(\"if billed monthly\") }}) </p> </div> <div class=\"features-block\"> <p v-if=\"tier.featureText\" class=\"text-left\" v-html=\"tier.featureText\"></p> <ul class=\"text-left list-unstyled\"> <li v-for=\"feature in tier.features\" :key=\"feature\"><i class=\"fas fa-hammer\"></i> {{ feature }}</li> </ul> </div> <b-button v-if=\"showButton(tier)\" variant=\"success\" class=\"signup-button\" :href=\"tierLink(tier)\">{{ tierButton(tier) }}</b-button> </div> </template> </b-card> </b-card-group>",
  props: {
    tiers: Object,
    signedIn: {
      type: Boolean,
      default: false
    },
    tier: {
      type: Number,
      default: 0
    },
    trialLeft: {
      type: Number,
      default: 0
    },
    trialMax: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showTiers() {
      const sortedTiers = [];
      for (const [k, v] of Object.entries(this.tiers)) {
        if (v.available) {
          sortedTiers.push(v);
        }
      }
      sortedTiers.sort((a, b) => a.cost - b.cost);
      return sortedTiers;
    }
  },
  methods: {
    tierClass(tier) {
      return `pricing-plan tier${tier.tier}`;
    },
    tierPrice(tier) {
      if (tier.plans["free"]) {
        return `Free`;
      } else if (tier.plans["yearly"]) {
        return tier.plans["yearly"].costText;
      }
      return "";
    },
    tierMonthly(tier) {
      return tier.plans["monthly"] ? tier.plans["monthly"].cost : false;
    },
    tierButton(tier) {
      if (tier.plans["free"]) {
        return t("Sign me up!");
      } else if (this.tier > 1) {
        if (this.tier == tier.tier && this.trialLeft > 0) {
          return t(`TRIAL.DaysRemaining`, {
            count: this.trialLeft
          });
        }
        return t("Change your plan");
      } else if (Math.round(this.trialLeft) === Math.round(this.trialMax)) {
        return t("TRIAL.StartTrialDays", {
          count: this.trialMax
        });
      }
      if (this.trialLeft > 0) {
        return t(`TRIAL.DaysRemaining`, {
          count: this.trialLeft
        });
      }
      return t("Subscribe now!");
    },
    showButton(tier) {
      return !this.signedIn || tier.plans["free"] == undefined;
    },
    tierLink(tier) {
      if (!this.signedIn) {
        if (tier.plans["free"]) {
          return "/signup";
        }
        return `/signup?returnTo=/account%23membership%26subscribe=${tier.code}`;
      }
      return `/account#membership&subscribe=${tier.code}`;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SavePointsPage"] = Vue.component(
                    "SavePointsPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"page-savepoints\"> <header> <div class=\"text-center mb-3\"> <img src=\"/images/workshop/save-points.png\" width=\"128\" /> </div> <h1>{{ t(\"Load Save Point!\") }}</h1> </header> <div class=\"message\"> <p v-html=\" t( 'The Forge’s <em>Save Points</em> feature allow you to recover a game world from our automated backup system and a specific point in time, or from your own per game save points.' ) \" ></p> <p> {{ t( \"Our automatic backups can be useful in case of disaster as we retain recently made backups and make them available to our users.\" ) }} </p> <p> {{ t( \"Game specific save points require the game manager feature and are available to World Builder tier subscribers.\" ) }} </p> <p v-html=\" t( `For more information on how to use the Save Points or restore deleted worlds, please refer to our <a href='https://forums.forge-vtt.com/docs?topic=17790' target='_blank'>Documentation</a>.` ) \" ></p> <b-alert variant=\"warning\" :show=\"!canTimeMachine\"> <i18n :path=\" t( 'The Save Points feature is available to {0} tier subscribers only. Please {1} your subscription to unlock the feature.' ) \" tag=\"p\" > <b>{{ t(\"World Builder\") }}</b> <a href=\"/account#membership&amp;subscribe=world-builder\">{{ t(\"upgrade\") }}</a> </i18n> </b-alert> </div> <save-points-page-tabs :initial-games=\"initialGames\" :initial-save-points-info=\"initialSavePointsInfo\" :can-time-machine=\"canTimeMachine\" :managing-games=\"managingGames\" > </save-points-page-tabs> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".page-savepoints > .message { width: 100%; margin: auto; } @media (min-width: 992px) { /* lg */ .page-savepoints > .message { width: 60%; } }"
    });
  },
  props: {
    initialGames: Array,
    initialSavePointsInfo: Array,
    canTimeMachine: Boolean,
    managingGames: Boolean
  },
  data() {
    return {};
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["WorkshopPage"] = Vue.component(
                    "WorkshopPage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"workshop-page\"> <img src=\"images/wizard.png\" class=\"background-image position-fixed\" /> <div class=\"workshop-container position-relative\"> <div> <div class=\"text-center mb-3\"> <img src=\"/images/gear-and-hammer.png\" width=\"128\" /> </div> <h1>{{ t(\"Welcome to The Forge's Workshop\") }}</h1> <p> {{ t( \"Our Wizards and Goblins have been hard at work with various spells and projects. We're proud to give you a little peek at the things to look forward to at the Forge.\" ) }} </p> <i18n :path=\" t( 'While you can follow our more long-term {0}, you will find here the current projects as well as have the ability to beta-test some of those features before they are readily available.' ) \" tag=\"p\" > <a href=\"https://forums.forge-vtt.com/t/forge-feature-roadmap/3634\" target=\"_blank\">{{ t(\"Roadmap\") }}</a> </i18n> <b-card-group class=\"item-list\"> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/dnd-beyond.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/dnd-beyond.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"D&D Beyond Integration\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Beta\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"Our D&D Beyond integration allows you to download content you've purchased from D&D Beyond, and convert it in a Foundry VTT-ready format.\" ) }} </p> <p> <a href=\"https://www.youtube.com/watch?v=DkS7w7hkg3Y\" target=\"_blank\" ><img src=\"/images/social/youtube.png\" height=\"32\" />{{ t(\"Watch Demo\") }}</a > —— <a href=\"https://forums.forge-vtt.com/docs?topic=13331\" target=\"_blank\">{{ t(\"Read More\") }}</a> </p> </b-card-text> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/internationalization.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/internationalization.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"Internationalization\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Beta\") }}</b-badge> </b-card-title> <b-card-text> <p class=\"m-0\">Soon we'll be able to offer The Forge experience in multiple languages.</p> <p class=\"m-0\">Bientôt, nous pourrons proposer l'expérience La Forge en plusieurs langues.</p> <p class=\"m-0\">Bald können wir The Forge in mehreren Sprachen anbieten.</p> <p class=\"m-0\">Presto saremo in grado di offrire l'esperienza di The Forge in più lingue.</p> <p class=\"m-0\">間もなく、TheForgeのエクスペリエンスを複数の言語で提供できるようになります。</p> </b-card-text> <p> <a href=\"https://weblate.foundryvtt-hub.com/engage/the-forge/\"> <img src=\"https://weblate.foundryvtt-hub.com/widgets/the-forge/-/287x66-grey.png\" :alt=\"t('Translation status')\" /> </a> </p> <p> <a href=\"https://weblate.foundryvtt-hub.com/engage/the-forge/\" target=\"_blank\">{{ t(\"Help us Translate\") }}</a> </p> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/save-points.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/save-points.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"Save Points\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Completed\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"Never worry about lost data with our Save Points feature! Recover your deleted worlds or from other catastrophic events, or simply save your game's state before a big fight.\" ) }} </p> <p> {{ t( \"With our AutoSave option, you can have a Save Point automatically taken whenever your game idles, letting you keep a history of your games through time. Want to see which level your players were a year ago, just clone the world from the specific save point date and see what changed!\" ) }} </p> <p> <em>{{ t(\"This feature is exclusive to World Builder users.\") }}</em> </p> <p> <a href=\"https://www.youtube.com/watch?v=x9hmiFucJ00\" target=\"_blank\" ><img src=\"/images/social/youtube.png\" height=\"32\" />{{ t(\"Watch Demo\") }}</a > —— <a href=\"https://forums.forge-vtt.com/docs?topic=17790\" target=\"_blank\">{{ t(\"Read More\") }}</a> </p> </b-card-text> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/livekit-logo.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/livekit-logo.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"LiveKit servers\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Completed\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"We are now providing LiveKit servers for our World Builder users. Enjoy a more reliable, and flexible audio/video experience in Foundry VTT!\" ) }} </p> <p> <em>{{ t(\"This feature is exclusive to World Builder users.\") }}</em> </p> <p> <a href=\"https://forums.forge-vtt.com/t/livekit-voice-and-video-chat/17792\" target=\"_blank\">{{ t(\"Read More\") }}</a> </p> </b-card-text> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/compendium-browser.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/compendium-browser.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"Forge Compendium Library\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Completed\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"The Forge developed a module for Foundry VTT that displays content from D&D Beyond in a more organized fashion. The module provides features such as chapter navigation, content searching, navigation history, and easy article importing into your game world.\" ) }} </p> <p> <a href=\"https://forge-vtt.com/bazaar/package/forge-compendium-browser\" target=\"_blank\">{{ t(\"Install\") }}</a> —— <a href=\"https://forums.forge-vtt.com/docs?topic=17791\" target=\"_blank\">{{ t(\"Read More\") }}</a> </p> </b-card-text> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/2fa.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/2fa.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"Two Factor Authentication\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Completed\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"The Forge is committed to making your VTT experience as secure as possible. We now offer an optional two-factor authentication security feature for users who want that extra layer of security for their accounts.\" ) }} </p> <p> <a href=\"https://forums.forge-vtt.com/docs?topic=16557\" target=\"_blank\">{{ t(\"Read More\") }}</a> </p> </b-card-text> </b-card-body> </b-card> <b-card no-body class=\"mb-3 flex-row workshop-item\"> <b-card-img left src=\"/images/workshop/patreon.png\" class=\"item-image\"></b-card-img> <b-card-body> <img src=\"/images/workshop/patreon.png\" class=\"item-background position-absolute\" /> <b-card-title> {{ t(\"Patreon Integration\") }} <b-badge class=\"float-right font-weight-normal\" variant=\"success\">{{ t(\"Completed\") }}</b-badge> </b-card-title> <b-card-text> <p> {{ t( \"Get rewarded for supporting your favorite Patreon creators, and access their content straight from The Bazaar! The Forge is developing an option for Patreon creators to offer their content to loyal supporters through our service, making it easier than ever before!\" ) }} </p> </b-card-text> </b-card-body> </b-card> </b-card-group> </div> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".workshop-page .background-image { height: calc(100% - 60px); object-fit: contain; right: -45px; top: 64px; z-index: 0; } .workshop-page .workshop-container { z-index: 50; } .workshop-page .workshop-container > div { width: 60%; margin: auto; } @media (max-width: 1200px) { .workshop-page .background-image { display: none; } .workshop-page .workshop-container > div { width: 100%; } } .workshop-page .workshop-container h1 { text-align: center; } .workshop-page .workshop-container .item-list { display: flex; flex-direction: column; flex-wrap: nowrap; border-radius: 10px; background: rgba(255, 255, 255, 0.7); border: 2px solid #eee; padding: 25px; } .workshop-page .workshop-container .workshop-item { overflow: hidden; } .workshop-page .workshop-container .item-image { width: 180px; min-height: 180px; object-fit: contain; z-index: 50; margin: 10px; } .workshop-page .workshop-container .item-background { top: 0px; left: 0px; filter: blur(10px); width: 200px; height: 100%; object-fit: cover; opacity: 0.7; } .workshop-page .workshop-container .badge { padding-top: 6px; } @media (max-width: 700px) { .workshop-page .workshop-container .workshop-item { flex-direction: column !important; } .workshop-page .workshop-container .item-image { width: calc(100% - 20px); height: 180px; } .workshop-page .workshop-container .item-background { width: 100%; height: 200px; } }"
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BillingInformation"] = Vue.component(
                    "BillingInformation",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <div class=\"billing-error-messages\"></div> <div class=\"subscription-manager-body\"> <form id=\"billing-information\"> <div class=\"form-group\"> <label for=\"customerName\">{{ t(\"Full Legal Name\") }}</label> <b-form-input v-model=\"billing.name\" type=\"text\" name=\"name\" :placeholder=\"t('Your Full Name')\" autocomplete=\"name\" required ></b-form-input> </div> <div v-if=\"requireTaxId\" class=\"form-group\"> <label for=\"taxID\">{{ taxIDLabel }}</label> <b-row v-b-tooltip.topleft.hover class=\"row\" :title=\"taxIDTooltip\"> <b-col md> <b-form-input v-model=\"billing.taxID\" type=\"text\" name=\"taxID\" :disabled=\"noTaxID\" :placeholder=\"t('Your Tax Identifier')\" :formatter=\"taxIDFormatter\" autocomplete=\"taxID\" :state=\"validTaxID\" ></b-form-input> </b-col> <b-col class=\"d-flex align-items-center\" md> <b-form-checkbox v-model=\"noTaxID\" name=\"noTaxID\" class=\"w-100 pt-1\">{{ noTaxIDLabel }}</b-form-checkbox> </b-col> </b-row> </div> <div class=\"form-group\"> <label for=\"address-autocomplete\">{{ t(\"Enter your billing address\") }}</label> <div id=\"address-details\" class=\"card\"> <div class=\"card-body\"> <div class=\"row\"> <div class=\"col-md-6\"> <label class=\"control-label\">{{ t(\"Address Line 1\") }}</label> <b-form-input v-model=\"billing.addressLine1\" name=\"addressLine1\" autocomplete=\"billing address-line1\" :state=\"validAddress\" ></b-form-input> </div> <div class=\"col-md-6\"> <label class=\"control-label\">{{ t(\"Address Line 2\") }}</label> <b-form-input v-model=\"billing.addressLine2\" name=\"addressLine2\" autocomplete=\"billing address-line2\" ></b-form-input> </div> </div> <div class=\"row\"> <div class=\"col-md-6\"> <label class=\"control-label\">City</label> <b-form-input v-model=\"billing.city\" name=\"city\" autocomplete=\"billing address-level2\"></b-form-input> </div> <div class=\"col-md-6\"> <label class=\"control-label\">{{ postalCodeLabel }}</label> <b-form-input v-model=\"billing.postalCode\" name=\"postalCode\" autocomplete=\"billing postal-code\" :state=\"validPostalCode\" ></b-form-input> </div> </div> <div class=\"row\"> <div class=\"col-md-6\"> <label class=\"control-label\">{{ provinceLabel }}</label> <state-province-input v-model=\"billing.province\" :country=\"billing.country\" :country-provinces=\"countryProvinces\" @valid=\"setValidProvince\" ></state-province-input> </div> <div class=\"col-md-6\"> <label class=\"control-label\">{{ t(\"Country\") }}</label> <country-select v-model=\"billing.country\"></country-select> </div> </div> </div> </div> </div> </form> </div> </div>",
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    requireTaxId: Boolean
  },
  data() {
    return {
      validProvince: false,
      noTaxID: false,
      countryProvinces: Object.entries(COUNTRY_PROVINCES).reduce((acc, [countryKey, countryData]) => {
        acc[countryKey] = countryData.map(data => {
          return {
            ...data,
            text: t(data.text)
          };
        });
        return acc;
      }, {})
    };
  },
  watch: {
    complete() {
      this.$emit("complete", this.complete);
    },
    noTaxID() {
      if (this.noTaxID) {
        this.billing.taxID = "";
      }
    }
  },
  computed: {
    billing: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    postalCodeLabel() {
      if (this.billing.country === "CA") {
        return t("Postal Code");
      }
      if (this.billing.country === "US") {
        return t("Zip Code");
      }
      return t("Postal Code/Zip code");
    },
    provinceLabel() {
      if (this.billing.country === "CA") {
        return t("Province");
      }
      if (this.billing.country === "US") {
        return t("State");
      }
      return t("Province/State");
    },
    validPostalCode() {
      if (this.billing && this.billing.country && this.billing.province && (this.billing.country === "CA" || this.billing.country === "US")) {
        return Utils.provinceHasPostalCode(this.billing.country, this.billing.province, this.billing.postalCode);
      }
      return null;
    },
    validAddress() {
      return !!this.billing.addressLine1;
    },
    validTaxID() {
      if (!this.requireTaxId) {
        return null;
      }
      if (this.noTaxID) {
        return true;
      }
      if (this.billing.country === "CA") {
        return /^[0-9]{9}$/.test(this.billing.taxID);
      }
      if (this.billing.country === "US") {
        return /^[0-9]{2}-?[0-9]{7}$/.test(this.billing.taxID);
      }
      return !!this.billing.taxID;
    },
    complete() {
      const hasAddress = !!(this.billing.country && this.billing.addressLine1);
      const hasProvince = !["CA", "US"].includes(this.billing.country) || !!this.billing.province;
      return hasAddress && hasProvince && this.validTaxID !== false && this.validProvince && this.validPostalCode !== false && !!this.billing.name;
    },
    taxIDLabel() {
      if (this.billing.country === "CA") {
        return t("Canada Business Number");
      }
      if (this.billing.country === "US") {
        return t("US FEIN");
      }
      return t("Tax Identifier");
    },
    taxIDTooltip() {
      if (this.billing.country === "CA") {
        return t("If you have an optional CBN, enter it here. If you do not have one, check the box to skip it.");
      }
      if (this.billing.country === "US") {
        return t("If you have an optional FEIN, enter it here. If you do not have one, check the box to skip it.");
      }
      return t("Enter your tax number from your local government here. If you do not have one, check the box to skip it.");
    },
    noTaxIDLabel() {
      if (this.billing.country === "CA") {
        return t("I confirm I do not have a CBN");
      }
      if (this.billing.country === "US") {
        return t("I confirm I do not have an FEIN");
      }
      return t("I do not have a tax ID number with my local government");
    }
  },
  methods: {
    setValidProvince(valid) {
      this.validProvince = valid;
    },
    taxIDFormatter(value) {
      if (this.billing.country === "CA") {
        // Return numbers only
        return value.replace(/[^0-9]/g, "").slice(0, 9);
      }
      if (this.billing.country === "US") {
        value = value.replace(/[^0-9]/g, "");
        if (value.length >= 2) {
          return `${value.slice(0, 2)}-${value.slice(2, 9)}`;
        }
        return value;
      }
      return value;
    }
  },
  mounted() {
    if (this.billing.taxID === "") {
      this.noTaxID = true;
    }
    this.$emit("complete", this.complete);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BillingManager"] = Vue.component(
                    "BillingManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"t('Change your Billing &amp; Payment Details')\" size=\"lg\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <div v-else-if=\"waiting\" class=\"text-center\"> <b-spinner class=\"mx-2\" :label=\"t('Retrieving your account information')\"></b-spinner> {{ t(\"Retrieving your account information, please wait…\") }} </div> <div v-else> <h5> {{ t(\"Update your billing information.\") }} </h5> <billing-information ref=\"billing\" v-model=\"billing\" :require-tax-id=\"requireTaxID\" @complete=\"complete = $event\" ></billing-information> </div> <div v-if=\"processing\" class=\"text-center\"> <b-spinner class=\"mx-2\" size=\"sm\" :label=\"t('Saving your billing information')\"></b-spinner >{{ t(\"Saving your billing information, please wait…\") }} </div> <template #modal-footer=\"{ close }\"> <b-button variant=\"primary\" class=\"float-right\" :disabled=\"processing || !complete || errorSaving || !billingChanged\" @click=\"submit\" >{{ t(\"Save Changes\") }}</b-button > <b-button variant=\"secondary\" class=\"float-right\" @click=\"close\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean
  },
  data() {
    return {
      originalBilling: {},
      billing: {},
      requireTaxID: false,
      error: "",
      waiting: true,
      complete: false,
      processing: false,
      errorSaving: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    billingChanged() {
      return !Utils.objectsAreEqual(this.originalBilling, this.billing);
    }
  },
  methods: {
    async dialogShown() {
      this.waiting = true;
      this.error = "";
      this.errorSaving = false;
      const subscriptionInfo = await Utils.api("subscription");
      if (subscriptionInfo.error) {
        this.error = t(`Error retrieving your billing information: {{- error}}`, {
          error: subscriptionInfo.error
        });
        return;
      }
      this.billing = subscriptionInfo.billing;
      this.originalBilling = Utils.duplicate(this.billing);
      this.requireTaxID = subscriptionInfo.requireTaxID;
      this.waiting = false;
    },
    async submit() {
      try {
        this.processing = true;
        const updated = await Utils.api("profile", {
          billing: this.billing
        });
        if (updated.error) {
          throw new Error(t(`Error updating your billing information: {{- error}}`, {
            error: updated.error
          }));
        }
        UI.alert("success", t("Billing & Payment Details updated successfully."));
        this.processing = false;
        this.visible = false;
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
        this.errorSaving = true;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentDetails"] = Vue.component(
                    "PaymentDetails",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <p>{{ t(\"Please enter your payment details below.\") }}</p> <i18n :path=\" t( 'Credit and Debit card information is handled securely by {0}, a Level 1 {1} payment service provider, and is never stored or transmitted to our servers.' ) \" tag=\"p\" > <a href=\"https://stripe.com/en-ca/about\" target=\"_blank\">{{ t(\"Stripe\") }}</a> <a href=\"https://www.pcisecuritystandards.org/pci_security/\" target=\"_blank\">{{ t(\"PCI Compliant\") }}</a> </i18n> <p v-if=\"trial\"> <strong>{{ t(\"Note:\") }} </strong> <i18n :path=\"t('TRIAL.DaysLeftPaymentInfo', { daysCount: Math.round(trial) })\"></i18n> </p> <i18n :path=\"t('All sales are final. Please refer to our {0} for details.')\" tag=\"p\"> <a href=\"/sales\" target=\"_blank\">{{ t(\"Sales Policy\") }}</a> </i18n> <div id=\"payment-choices\" role=\"tablist\" class=\"accordion\"> <b-card v-if=\"supportsStripe\" no-body class=\"mb-2\"> <b-card-header v-b-toggle.stripe-payment class=\"p-1\" role=\"tab\"> <b-button block variant=\"light\" class=\"text-left\"> &#8226;&nbsp; <i class=\"far fa-credit-card\"></i> <i18n :path=\"t('{{payVerb}} using a Credit or Debit Card', { payVerb })\"></i18n> </b-button> </b-card-header> <b-collapse id=\"stripe-payment\" :visible=\"selected === 'stripe'\" accordion=\"payment-choices\" role=\"tabpanel\" @shown=\"switchTo('stripe')\" > <b-card-body> <payment-stripe ref=\"stripe\" v-model=\"stripeComplete\" :payment-method=\"stripe.paymentMethod\" :public-key=\"stripe.publicKey\" :billing=\"billing\" @error=\"onError\" ></payment-stripe> </b-card-body> </b-collapse> </b-card> <b-card v-else no-body class=\"mb-2\"> <b-card-header tabindex class=\"text-muted\"> &#8226;&nbsp; <i class=\"far fa-credit-card\"></i> <i18n :path=\"t('{{payVerb}} using a Credit or Debit Card (Not available)', { payVerb })\"></i18n> </b-card-header> </b-card> <b-card v-if=\"supportsPaypal\" no-body class=\"mb-2\"> <b-card-header v-b-toggle.paypal-payment class=\"p-1\" role=\"tab\"> <b-button block variant=\"light\" class=\"text-left\"> &#8226;&nbsp; <i class=\"fab fa-paypal\"></i> <i18n :path=\"t('{{payVerb}} using PayPal', { payVerb })\"></i18n> </b-button> </b-card-header> <b-collapse id=\"paypal-payment\" :visible=\"selected === 'paypal'\" accordion=\"payment-choices\" role=\"tabpanel\" @shown=\"switchTo('paypal')\" > <b-card-body no-body> <b-alert v-if=\"trial\" variant=\"info\" show class=\"p-1 m-0\"> <i18n :path=\"t('If subscribing with PayPal, an {0} will appear on your PayPal account throughout the trial.')\" tag=\"p\" > <strong>Authorization</strong> </i18n> <i18n :path=\"t('If you cancel before the trial ends, it will be voided, and {0}.')\" tag=\"p\"> <strong>{{ t(\"you will not be charged\") }}</strong> </i18n> <i18n :path=\" t( 'Note that some banks will charge your account against the authorization. In that case, upon cancellation, you will be refunded the full amount. {0}' ) \" tag=\"p\" > <help-icon :tooltip=\"t('Click here for more information')\" url=\"https://forums.forge-vtt.com/docs?topic=15300\" ></help-icon> </i18n> </b-alert> <payment-paypal ref=\"paypal\" v-model=\"paypalComplete\" :client-id=\"braintree.clientId\" :billing=\"billing\" :manager=\"!subscribed\" @error=\"onError\" ></payment-paypal> </b-card-body> </b-collapse> </b-card> <b-card v-else no-body class=\"mb-2\"> <b-card-header tabindex> &#8226;&nbsp; <i class=\"fab fa-paypal\"></i> <i18n :path=\"t('{{payVerb}} using PayPal (Coming soon)', { payVerb })\"></i18n> </b-card-header> </b-card> </div> <!-- Used to display form errors. --> <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <div v-else-if=\"waiting\" class=\"text-center\"> <b-spinner class=\"mx-2\" size=\"sm\" :label=\"t('Saving your payment details')\"></b-spinner >{{ t(\"Saving your payment details, please wait…\") }} </div> </div>",
  props: {
    providers: {
      type: Object,
      default: {}
    },
    billing: {
      type: Object,
      default: {}
    },
    trial: {
      type: Number,
      default: 0
    },
    subscribed: {
      type: Boolean,
      default: true // By default, don't enable vault manager
    },

    payVerb: {
      type: String,
      default: t("Subscribe")
    },
    current: String,
    value: Boolean
  },
  data() {
    return {
      stripeComplete: false,
      paypalComplete: false,
      selected: "",
      originalSelected: "",
      originalPayment: "",
      error: "",
      waiting: false
    };
  },
  watch: {
    selected(val) {
      this.$emit("input", this.complete);
    },
    stripeComplete(val) {
      this.$emit("input", this.complete);
    },
    paypalComplete(val) {
      this.$emit("input", this.complete);
    },
    value(val) {
      if (val) {
        this.error = "";
      }
    }
  },
  computed: {
    supportsStripe() {
      return this.stripe && !!this.stripe.publicKey;
    },
    supportsPaypal() {
      return this.braintree && !!this.braintree.clientId;
    },
    stripe() {
      return this.providers.stripe;
    },
    braintree() {
      return this.providers.braintree;
    },
    complete() {
      if (this.selected === "stripe" && this.supportsStripe) {
        return this.stripeComplete;
      } else if (this.selected === "paypal" && this.supportsPaypal) {
        return this.paypalComplete;
      }
      return false;
    }
  },
  methods: {
    onError(error) {
      this.$emit("input", false);
      this.waiting = false;
      this.error = error;
    },
    switchTo(target) {
      this.selected = target;
      this.$emit("current", target);
    },
    async submitPayment(force = false) {
      if (!this.complete) {
        throw new Error(t("Incomplete payment details"));
      }
      this.waiting = true;
      try {
        let paymentData = null;
        if (this.selected === "stripe" && this.supportsStripe) {
          paymentData = {
            stripe: {
              payment: await this.$refs.stripe.requestPayment()
            }
          };
        } else if (this.selected === "paypal" && this.supportsPaypal) {
          paymentData = {
            braintree: {
              payment: await this.$refs.paypal.requestPayment()
            }
          };
        } else {
          throw new Error(t("Invalid selection"));
        }
        if (!paymentData) {
          this.waiting = false;
          return;
        }
        // Check if there were no changes to the payment method (only stripe)
        if (force === false && this.originalSelected === this.selected && this.originalPayment && this.selected === "stripe" && this.originalPayment === paymentData.stripe.payment) {
          return true;
        }
        const payment = await Utils.api("subscription/payment", paymentData);
        if (!payment.success) {
          throw new Error(payment.error || t("Error communicating with server"));
        }
        return true;
      } catch (err) {
        this.onError(err.message);
      }
      return false;
    }
  },
  mounted() {
    if (this.supportsStripe && this.current === "stripe") {
      this.selected = "stripe";
    } else if (this.supportsPaypal && this.current === "braintree") {
      this.selected = "paypal";
    } else if (this.supportsStripe) {
      this.selected = "stripe";
    } else if (this.supportsPaypal) {
      this.selected = "paypal";
    }
    this.originalSelected = this.selected;
    this.originalPayment = this.stripe && this.stripe.paymentMethod ? this.stripe.paymentMethod.id : null;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentInvoice"] = Vue.component(
                    "PaymentInvoice",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"m-3\"> <b-table :items=\"items\" :fields=\"fields\" head-variant=\"light\"> <template #cell(description)=\"{ item, value }\"> <em v-if=\"item.period\" class=\"text-muted\">{{ value }}</em> <strong v-else-if=\"item.total_line && item.total_summary\" class=\"float-right\">{{ value }}</strong> <span v-else-if=\"item.total_line\" class=\"float-right text-muted\">{{ value }}</span> <strong v-else>{{ value }}</strong> </template> <template #cell(amount)=\"{ item, value }\"> <b-button v-if=\"alternateCurrency && item.period\" variant=\"outline-secondary\" size=\"sm\" @click.prevent=\"showAlternateCurrency = !showAlternateCurrency\" > <span :class=\"showAlternateCurrency ? '' : 'font-weight-bold'\">{{ currencyDisplay }}</span> <i class=\"fas fa-exchange-alt\"></i> <span :class=\"showAlternateCurrency ? 'font-weight-bold' : ''\">{{ exchangeCurrencyDisplay }}</span> </b-button> <strong v-else>{{ value }}</strong> </template> </b-table> <b-row v-if=\"alternateCurrency\"> <b-alert variant=\"warning\" :show=\"showAlternateCurrency\"> <i18n :path=\" t('All invoices/prices are in {{currencyDisplay}} and are charged in {{currencyDisplay}}.', { currencyDisplay, }) \" ></i18n> <br /> <i18n :path=\" t( 'The {{exchangeCurrencyDisplay}} amounts displayed above are an estimate and for your convenience only.', { exchangeCurrencyDisplay } ) \" ></i18n> </b-alert> </b-row> <b-row v-if=\"showAUSalesTaxWarning\"> <b-alert variant=\"warning\" show> {{ t(\"Note:\") }} <strong>{{ t(\"The Australian GST of 10% will be charged, starting June 1st 2023.\") }}</strong> {{ t( \"The tax amount due does not appear in the invoice preview above, but will be calculated at the time the invoice is created.\" ) }}<br /> <i18n :path=\" t( 'Please be aware that, in that situation, the total amount due will be different from the above preview. {0}' ) \" > <a href=\"https://forums.forge-vtt.com/t/forge-sales-tax-update-for-australia-and-norway/76012\" target=\"_blank\" >{{ t(\"Click here for more information.\") }}</a > </i18n> </b-alert> </b-row> <b-row v-if=\"showNOSalesTaxWarning\"> <b-alert variant=\"warning\" show> {{ t(\"Note:\") }} <strong>{{ t(\"The Norvegian VAT of 25% will be charged, starting June 1st 2023.\") }}</strong> {{ t( \"The tax amount due does not appear in the invoice preview above, but will be calculated at the time the invoice is created.\" ) }}<br /> <i18n :path=\" t( 'Please be aware that, in that situation, the total amount due will be different from the above preview. {0}' ) \" > <a href=\"https://forums.forge-vtt.com/t/forge-sales-tax-update-for-australia-and-norway/76012\" target=\"_blank\" >{{ t(\"Click here for more information.\") }}</a > </i18n> </b-alert> </b-row> </div>",
  props: {
    invoice: {
      type: Object,
      default: null
    },
    country: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: "USD"
    },
    exchangeCurrency: {
      type: String,
      default: "USD"
    },
    exchangeRates: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      fields: [{
        key: "description",
        label: t("Description"),
        formatter: (value, key, item) => {
          return value;
        },
        /* Make the total lines span all 3 columns and hide the quantity and unit_price columns */
        tdAttr: (value, key, item) => {
          if (item.total_line) {
            return {
              colspan: "3"
            };
          }
          return {};
        }
      }, {
        key: "quantity",
        label: t("Quantity"),
        tdClass: (value, key, item) => {
          if (item.total_line) {
            return "d-none";
          }
          return "";
        }
      }, {
        key: "unit_price",
        label: t("Unit Price"),
        formatter: (value, key, item) => {
          if (value == null) {
            return "";
          }
          return `${this.currentCurrencyDisplay} ${this.currentCurrencyAmount(value)}`;
        },
        tdClass: (value, key, item) => {
          if (item.total_line) {
            return "d-none";
          }
          return "";
        }
      }, {
        key: "amount",
        label: t("Amount"),
        formatter: (value, key, item) => {
          if (value == null) {
            return "";
          }
          return `${this.currentCurrencyDisplay} ${this.currentCurrencyAmount(value)}`;
        }
      }],
      currencyToDisplay: {
        USD: "US$",
        CAD: "CA$",
        AUD: "AU$",
        NOK: "kr",
        EUR: "€",
        GBP: "£"
      },
      showAlternateCurrency: false
    };
  },
  computed: {
    items() {
      const items = [];
      // Period
      if (this.invoice.period_start) {
        const start = new Date(this.invoice.period_start * 1000);
        const end = new Date(this.invoice.period_end * 1000);
        items.push({
          period: true,
          description: `${start.toDateString()} - ${end.toDateString()}`
        });
      }
      // Line items
      items.push(...this.invoice.lines);
      // Subtotal
      items.push({
        total_line: true,
        total_summary: true,
        description: t("Subtotal"),
        amount: this.invoice.subtotal
      });
      // Discounts
      for (const discount of this.invoice.discount_amounts) {
        const off = discount.percentage_off ? `${discount.percentage_off}%` : `US$ ${discount.amount_off}`;
        items.push({
          total_line: true,
          description: `${discount.description} (${off} off)`,
          amount: -1 * discount.amount
        });
      }
      // Taxes
      for (const tax of this.invoice.tax_amounts) {
        items.push({
          total_line: true,
          description: `${tax.description} (${tax.percentage}%)`,
          amount: tax.amount
        });
      }
      // Total
      items.push({
        total_line: true,
        total_summary: true,
        description: t("Total"),
        amount: this.invoice.total
      });
      // Balance
      if (this.usedBalance) {
        items.push({
          total_line: true,
          description: t("Applied balance"),
          amount: this.usedBalance
        });
      }
      // Amount due
      items.push({
        total_line: true,
        total_summary: true,
        description: t("Amount due"),
        amount: this.invoice.amount_due
      });
      return items;
    },
    usedBalance() {
      return this.invoice.starting_balance === 0 ? 0 : this.invoice.amount_due - this.invoice.total;
    },
    exchangeRate() {
      const rates = this.exchangeRates || {};
      return rates[this.exchangeCurrency] || 1;
    },
    alternateCurrency() {
      return this.exchangeCurrency !== this.currency && this.exchangeRate !== 1;
    },
    currencyDisplay() {
      return this.currencyToDisplay[this.currency] || this.currency;
    },
    exchangeCurrencyDisplay() {
      return this.currencyToDisplay[this.exchangeCurrency] || this.exchangeCurrency;
    },
    currentCurrencyDisplay() {
      if (this.showAlternateCurrency) {
        return this.exchangeCurrencyDisplay;
      }
      return this.currencyDisplay;
    },
    showAUSalesTaxWarning() {
      if (this.country !== "AU") {
        return false;
      }
      const zeroTax = this.invoice.tax_amounts.every(t => t.amount === 0);
      const june1st = 1685595600000;
      return zeroTax && Date.now() < june1st && this.invoice.created * 1000 >= june1st;
    },
    showNOSalesTaxWarning() {
      if (this.country !== "NO") {
        return false;
      }
      const zeroTax = this.invoice.tax_amounts.every(t => t.amount === 0);
      const june1st = 1685595600000;
      return zeroTax && Date.now() < june1st && this.invoice.created * 1000 >= june1st;
    }
  },
  methods: {
    currentCurrencyAmount(amount) {
      if (this.showAlternateCurrency) {
        amount *= this.exchangeRate;
      }
      return amount.toFixed(2);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentInvoicePreview"] = Vue.component(
                    "PaymentInvoicePreview",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-list-group> <b-list-group-item v-for=\"(item, index) of items\" :key=\"`item-${index}`\"> <b-row> <b-col cols=\"8\" class=\"border-right\"> {{ item.description }} </b-col> <b-col cols=\"4\" class=\"text-right\"> $ {{ Number(item.price).toFixed(2) }} </b-col> </b-row> </b-list-group-item> <b-list-group-item disabled> <b-row> <b-col cols=\"8\" class=\"border-right text-right\"> {{ t(\"Sub-Total\") }} </b-col> <b-col cols=\"4\" class=\"text-right\"> $ {{ subtotal.toFixed(2) }} </b-col> </b-row> </b-list-group-item> <b-list-group-item v-for=\"(item, index) of taxItems\" :key=\"`tax-${index}`\" disabled> <b-row> <b-col cols=\"8\" class=\"border-right text-right\"> <i18n :path=\"t('Taxes ({{item.rate}}% {{item.type}})', { item })\"></i18n> </b-col> <b-col cols=\"4\" class=\"text-right\"> $ {{ item.value.toFixed(2) }} </b-col> </b-row> </b-list-group-item> <b-list-group-item> <b-row> <b-col cols=\"8\" class=\"border-right text-right\"> <strong>Total</strong> </b-col> <b-col cols=\"4\" class=\"text-right\"> <strong>$ {{ total.toFixed(2) }}</strong> </b-col> </b-row> </b-list-group-item> <b-list-group-item v-if=\"balance !== 0\" disabled> <b-row> <b-col cols=\"8\" class=\"border-right text-right\"> {{ t(\"Applied Balance\") }} </b-col> <b-col cols=\"4\" class=\"text-right\"> $ {{ usedBalance.toFixed(2) }} </b-col> </b-row> </b-list-group-item> <b-list-group-item> <b-row> <b-col cols=\"8\" class=\"border-right text-right\"> <strong>{{ t(\"Amount Due\") }}</strong> </b-col> <b-col cols=\"4\" class=\"text-right\"> <strong>$ {{ amountDue.toFixed(2) }}</strong> </b-col> </b-row> </b-list-group-item> </b-list-group>",
  props: {
    items: {
      type: Array,
      default: []
    },
    balance: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: "USD"
    },
    exchangeRates: {
      type: Object,
      default: {}
    },
    taxes: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  },
  computed: {
    subtotal() {
      return this.items.reduce((total, i) => total + i.price, 0);
    },
    taxableTotal() {
      return this.items.reduce((total, i) => total + (i.untaxed ? 0 : i.price), 0);
    },
    taxItems() {
      return Object.entries(this.taxes).map(([type, rate]) => ({
        type,
        rate,
        value: rate / 100 * this.taxableTotal
      }));
    },
    total() {
      const taxes = this.taxItems.reduce((total, tax) => total + tax.value, 0);
      return this.subtotal + taxes;
    },
    usedBalance() {
      if (this.balance + this.total < 0) {
        return -1 * this.total;
      }
      return this.balance;
    },
    amountDue() {
      return this.total + this.usedBalance;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentManager"] = Vue.component(
                    "PaymentManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"t('Change your Payment Details')\" size=\"lg\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <div v-else-if=\"waiting\" class=\"text-center\"> <b-spinner class=\"mx-2\" :label=\"t('Retrieving your payment details')\"></b-spinner >{{ t(\"Retrieving your payment details, please wait…\") }} </div> <payment-details v-else ref=\"payment\" v-model=\"complete\" :billing=\"billing\" :providers=\"providers\" :current=\"currentProvider\" :trial=\"trial\" :subscribed=\"subscribed\" @current=\"current = $event\" ></payment-details> <template #modal-footer=\"{ close }\"> <payment-stripe-portal class=\"mr-auto\"></payment-stripe-portal> <b-button variant=\"primary\" class=\"float-right\" :disabled=\"processing || !complete\" @click=\"submit\" >{{ t(\"Confirm\") }} {{ currentString }}</b-button > <b-button variant=\"secondary\" class=\"float-right\" @click=\"close\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean
  },
  data() {
    return {
      providers: {},
      billing: {},
      trial: 0,
      error: "",
      waiting: true,
      currentProvider: "",
      current: "",
      subscribed: false,
      complete: false,
      processing: false
    };
  },
  watch: {
    complete(val) {}
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    currentString() {
      if (this.current === "stripe") {
        return t("(Card)");
      } else if (this.current === "paypal") {
        return t("(Paypal)");
      }
      return "";
    }
  },
  methods: {
    async dialogShown() {
      const paymentInfoPromise = Utils.api("subscription/payment");
      const subscriptionInfoPromise = Utils.api("subscription");
      const [paymentInfo, subscriptionInfo] = await Promise.all([paymentInfoPromise, subscriptionInfoPromise]);
      if (paymentInfo.error) {
        this.error = t(`Error retrieving payment information: {{- error}}`, {
          error: paymentInfo.error
        });
        return;
      }
      if (subscriptionInfo.error) {
        this.error = t(`Error retrieving payment information: {{- error}}`, {
          error: subscriptionInfo.error
        });
        return;
      }
      this.providers = paymentInfo.providers;
      this.trial = paymentInfo.trialDays || 0;
      this.subscribed = paymentInfo.subscribed || false;
      this.currentProvider = paymentInfo.current;
      this.billing = subscriptionInfo.billing;
      this.waiting = false;
    },
    async submit() {
      try {
        this.processing = true;
        const success = await this.$refs.payment.submitPayment(true);
        this.processing = false;
        if (success) {
          this.visible = false;
        }
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentPaypal"] = Vue.component(
                    "PaymentPaypal",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <div ref=\"paypalDropin\"></div> <div class=\"float-right\"> {{ t(\"Secured by Braintree\") }} <img src=\"https://s3.amazonaws.com/braintree-badges/braintree-badge-dark.png\" width=\"82px\" height=\"22px\" border=\"0\" /> </div> </div>",
  props: {
    billing: {
      type: Object,
      default: () => {
        return {};
      }
    },
    clientId: String,
    manager: Boolean,
    value: Boolean
  },
  methods: {
    async requestPayment() {
      try {
        const payload = await this._instance.requestPaymentMethod();
        console.log("Got payload ", payload);
        return payload;
      } catch (err) {
        console.error("Paypal error", err);
        throw err;
      }
    },
    async requestDeviceData() {
      try {
        const dataCollectorInstance = await braintree.dataCollector.create({
          client: this._instance,
          paypal: true
        });
        console.log("Got data collector instance ", dataCollectorInstance);
        console.log("Got device data  ", dataCollectorInstance.deviceData);
        return dataCollectorInstance.deviceData;
      } catch (err) {
        console.error("Braintree data collector error", err);
        throw err;
      }
    }
  },
  async mounted() {
    try {
      this._instance = await braintree.dropin.create({
        authorization: this.clientId,
        container: this.$refs.paypalDropin,
        paypal: {
          flow: "vault"
        },
        dataCollector: {
          paypal: true
        },
        card: false,
        vaultManager: this.manager
      });
      this.$emit("input", this._instance.isPaymentMethodRequestable());
      this._instance.on("paymentMethodRequestable", event => {
        this.$emit("input", this._instance.isPaymentMethodRequestable());
      });
      this._instance.on("noPaymentMethodRequestable", event => {
        this.$emit("input", this._instance.isPaymentMethodRequestable());
      });
    } catch (err) {
      console.error("Paypal error", err);
      this.$emit("error", err);
    }
  },
  async beforeDestroy() {
    await this._instance.teardown();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentStripe"] = Vue.component(
                    "PaymentStripe",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-form-group :label=\"t('Credit or debit card')\"> <div v-if=\"hasAttached\" class=\"mb-2\"> <b-form-radio v-model=\"selected\" name=\"payment-method\" value=\"attached\">{{ t(\"Use existing default payment method\") }}</b-form-radio> <b-form-radio v-model=\"selected\" name=\"payment-method\" value=\"new\">{{ t(\"Add new payment method\") }}</b-form-radio> </div> <input v-if=\"hasAttached && selected === 'attached'\" type=\"text\" class=\"form-control\" :value=\"paymentMethod.name\" readonly /> <div v-show=\"!hasAttached || selected === 'new'\" ref=\"stripeCardElement\" class=\"form-control\"></div> <b-form-group> <!-- Used to display form errors. --> <div v-show=\"cardErrors\" ref=\"stripeCardErrors\" role=\"alert\" class=\"border border-danger rounded p-1\"> {{ cardErrors }} </div> </b-form-group> <!-- Display mandate acceptance text. --> <div class=\"card form-group\"> <div class=\"card-body\"> <p class=\"card-text\"> <i class=\"fas fa-info-circle\"></i> <i18n :path=\" t( 'I authorise The Forge to send instructions to the financial institution that issued my card to take payments from my card account in accordance with the terms of my {0} with The Forge.' ) \" > <a href=\"/sales\" target=\"_blank\">{{ t(\"agreement\") }}</a> </i18n> </p> </div> </div> </b-form-group>",
  props: {
    billing: {
      type: Object,
      default: () => {
        return {};
      }
    },
    publicKey: String,
    paymentMethod: {
      type: Object,
      default: () => {
        return {};
      }
    },
    value: Boolean
  },
  data() {
    return {
      selected: "",
      cardErrors: "",
      newComplete: false
    };
  },
  watch: {
    selected(value) {
      if (value === "attached" && this.hasAttached) {
        this.$emit("input", true);
      } else {
        this.$emit("input", this.newComplete);
      }
    },
    newComplete(value) {
      if (this.selected === "new") {
        this.$emit("input", this.newComplete);
      }
    }
  },
  computed: {
    hasAttached() {
      return !!this.paymentMethod.id;
    }
  },
  methods: {
    async requestPayment() {
      if (this.selected === "attached") {
        return this.paymentMethod.id;
      }
      const complete = this.$refs.stripeCardElement.classList.contains("StripeElement--complete");
      if (!complete) {
        throw new Error(t("Card information is incomplete"));
      }
      const intent = await Utils.api("subscription/payment", {
        stripe: {
          intent: "card"
        }
      });
      if (!intent.secret) {
        throw new Error(t("Error communicating with server"));
      }
      const result = await this._stripe.confirmCardSetup(intent.secret, {
        payment_method: {
          type: "card",
          card: this._cardElement,
          billing_details: {
            name: this.billing.name,
            email: this.billing.email,
            address: {
              city: this.billing.city,
              country: this.billing.country,
              line1: this.billing.addressLine1,
              line2: this.billing.addressLine2,
              postal_code: this.billing.postalCode,
              state: this.billing.province
            }
          }
        }
      });
      if (result.error) {
        throw new Error(result.error.message);
      }
      return result.setupIntent.payment_method;
    }
  },
  mounted() {
    this._stripe = Stripe(this.publicKey);
    this._stripe_elements = this._stripe.elements();
    this._cardElement = this._stripe_elements.create("card", {
      hidePostalCode: true,
      postalCode: this.billing.postalCode
    });
    this._cardElement.mount(this.$refs.stripeCardElement);
    // Handle real-time validation errors from the card Element.
    this._cardElement.on("change", event => {
      if (event.error) {
        this.cardErrors = event.error.message;
      } else {
        this.cardErrors = "";
      }
      this.newComplete = event.complete;
    });
    this.selected = this.hasAttached ? "attached" : "new";
  },
  beforeDestroy() {
    this._cardElement.unmount().destroy();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PaymentStripePortal"] = Vue.component(
                    "PaymentStripePortal",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-button v-b-tooltip.top variant=\"info\" :title=\"t('Change payment methods and view billing history')\" @click.prevent=\"openPortal\" > {{ label }} <i class=\"fas fa-external-link-alt\"></i> </b-button>",
  props: {
    label: {
      type: String,
      default: t("View Billing History")
    }
  },
  methods: {
    async openPortal() {
      const portal = await Utils.api("subscription/payment", {
        stripe: {
          portal: true
        }
      });
      if (!portal.url) {
        return this.$emit("error", portal.error || t("Error communicating with server"));
      }
      window.open(portal.url, "_blank");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingExtra"] = Vue.component(
                    "PricingExtra",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article class=\"pricing-page__extra\"> <header> <img v-if=\"!!imgSrc\" :src=\"imgSrc\" alt=\"\" /> <h3>{{ title }}</h3> </header> <pricing-price :price=\"price\" interval=\"year\"> <slot name=\"caption\"></slot> </pricing-price> <slot></slot> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing-page__extra{text-align:center}.pricing-page__extra,.pricing-page__extra>header{display:flex;flex-direction:column;gap:1em}.pricing-page__extra>header h3{line-height:1em;margin-bottom:0;font-size:1.5em}.pricing-page__extra>header img{margin:0 auto;display:block;width:100%;max-width:400px;height:auto}.pricing-page__extra .pricing-price{background:unset;padding:0}"
    });
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    price: {
      type: [String, Number],
      default: 1
    },
    imgSrc: {
      type: String,
      default: ""
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPlan"] = Vue.component(
                    "PricingPlan",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article :class=\"getHostClasses()\"> <span v-if=\"isPopular\" class=\"price-plan__popular-banner\">{{ t(\"Most popular\") }}</span> <header class=\"price-plan__header\"> <h3>{{ title }}</h3> <slot></slot> </header> <pricing-price v-if=\"shouldShowAnnual\" :price=\"priceAnnual\" interval=\"month\"> <slot name=\"price-caption\"></slot> </pricing-price> <pricing-price v-else :price=\"priceMonthly\" interval=\"month\"> <slot name=\"price-caption\"></slot> </pricing-price> <div class=\"price-plan__call-to-action\"> <b-button v-if=\"!!registerRoute\" variant=\"success\" :href=\"registerRoute\" :size=\"isPopular ? 'lg' : ''\" >{{ t(\"Register now\") }}!</b-button > </div> <div class=\"price-plan__feature-descriptor\"> <slot name=\"pre-features\"></slot> </div> <ul class=\"price-plan__features\"> <li v-for=\"({ text, isNew }, index) in features\" :key=\"index\" class=\"price-plan__feature\"> <i v-if=\"!isNew\" class=\"price-plan__feature__marker fas fa-hammer\"></i> <i v-else v-b-tooltip:hover=\"t('New!')\" class=\"price-plan__feature__marker price-plan__feature__marker--new fas fa-plus-square with-tooltip\" :aria-label=\"t('New!')\" ></i> <span class=\"price-plan__feature__label\">{{ text }}</span> </li> </ul> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".price-plan{--plan-padding: 2rem;--plan-popular-border-width: 2px;--plan-accent-color: var(--color-forge-green-dark);--plan-popular-color: var(--color-forge-green-dark);--plan-background: #d4d4d4;container-type:inline-size;container-name:price-plan;padding:1em 0;background-color:var(--plan-background);position:relative;z-index:0;display:flex;flex-direction:column;gap:1em}.theme--slate .price-plan{--plan-background: #555a;--plan-accent-color: var(--color-forge-green)}.theme--slate .price-plan .pricing-price{background-color:rgba(51,51,51,.8)}.price-plan .btn{margin:0 var(--plan-padding);line-height:1em;width:calc(100% - var(--plan-padding)*2)}.price-plan .btn-lg{padding:.75rem 1rem}.price-plan__header,.price-plan__feature-descriptor,.price-plan__features{padding-left:2em;padding-right:2em}.price-plan__header{--plan-heading-size: 1.25em;--plan-caption-size: 1em;padding:0 2em;text-align:center}.price-plan__header h3{font-size:var(--plan-heading-size);color:var(--plan-accent-color);margin-bottom:0}.price-plan__header p{font-size:var(--plan-caption-size);margin-bottom:0}.price-plan__feature-descriptor p:last-of-type{margin-bottom:0}.price-plan__details{justify-self:end}.price-plan__details p{text-align:center}.price-plan:has(.price-plan__popular-banner){outline:var(--plan-popular-border-width) solid var(--plan-popular-color);z-index:1}.price-plan:has(.price-plan__popular-banner) .price-plan__popular-banner{position:absolute;top:calc(var(--plan-padding)*-1);left:calc(var(--plan-popular-border-width)*-1);right:calc(var(--plan-popular-border-width)*-1);display:inline-block;padding:.25em 1em;text-align:center;font-weight:600;color:#fff;background-color:var(--plan-popular-color)}.price-plan__features{margin:0;display:flex;flex-direction:column;gap:.5em}.price-plan__feature{list-style:none;display:grid;grid-template-columns:24px 1fr;gap:.5em;align-items:baseline}.price-plan__feature__marker{color:var(--plan-accent-color);display:flex;justify-content:space-around}.price-plan__feature__marker--new{font-size:1.25em}@container price-plan (min-width: 30ch){.price-plan__header{--plan-heading-size: 2em;--plan-caption-size: 1.25em}}"
    });
  },
  props: {
    title: {
      type: String,
      default: "Untitled Plan"
    },
    priceMonthly: {
      type: String,
      default: "0.00"
    },
    priceAnnual: {
      type: String,
      default: "0.00"
    },
    shouldShowAnnual: Boolean,
    features: {
      type: Array,
      default: () => []
    },
    isPopular: Boolean,
    registerRoute: {
      type: String,
      default: ""
    }
  },
  methods: {
    getHostClasses: () => ({
      "price-plan": true,
      "price-plan--is-popular": void 0 && !!(void 0).isPopular
    })
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPlanCompareRow"] = Vue.component(
                    "PricingPlanCompareRow",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article class=\"pricing-page__comparison__feature\"> <header> <h4 :class=\"getHeadingClasses($slots)\">{{ title }}</h4> <slot name=\"caption\"></slot> </header> <div class=\"pricing-page__comparison__feature__plan\"><slot name=\"player\"></slot></div> <div class=\"pricing-page__comparison__feature__plan\"><slot name=\"game-master\"></slot></div> <div class=\"pricing-page__comparison__feature__plan\"><slot name=\"story-teller\"></slot></div> <div class=\"pricing-page__comparison__feature__plan\"><slot name=\"world-builder\"></slot></div> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing-page__comparison__feature{display:grid;grid-template-columns:minmax(22ch, 1fr) var(--plan-columns, repeat(4, 10ch));gap:var(--plan-gap, 1em);align-items:baseline;border-top:1px solid var(--plan-border-color);padding:.25em 0 .5em}.pricing-page__comparison__feature .pricing-page__comparison__feature__plan{text-align:center}.pricing-page__comparison__feature header{line-height:1.2}.pricing-page__comparison__feature header *:last-child{margin-bottom:0}.pricing-page__comparison__feature header h4{margin:0;font-family:\"Montserrat\",sans-serif;font-size:1rem;font-weight:600}.pricing-page__comparison__feature header h4:not(.pricing-page__comparison__feature__title--with-caption){margin-bottom:1.25em}"
    });
  },
  props: {
    title: String,
    cost: String,
    interval: String
  },
  methods: {
    getHeadingClasses: slots => {
      return {
        "pricing-page__comparison__feature__title": true,
        "pricing-page__comparison__feature__title--with-caption": slots.caption
      };
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPlanCompareSection"] = Vue.component(
                    "PricingPlanCompareSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<article class=\"pricing-page__comparison\"> <header> <h3 :class=\"getHeadingClasses($slots)\"> {{ title }} </h3> <slot name=\"caption\"></slot> </header> <slot></slot> </article>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing-page__comparison{border-top:2px solid var(--plan-border-color);padding:1em 0}.pricing-page__comparison:last-of-type{border-bottom:2px solid var(--plan-border-color)}.pricing-page__comparison header{position:sticky;top:0px}.pricing-page__comparison header h3{margin:0 0 .5em}@container price-compare-container (min-width: 660px){.pricing-page__comparison header{top:70px}}"
    });
  },
  props: {
    title: String,
    cost: String,
    interval: String
  },
  methods: {
    getHeadingClasses: $slots => {
      return {
        "pricing-page__comparison__title": true,
        "pricing-page__comparison__title--with-caption": $slots.caption
      };
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPlanCompareTable"] = Vue.component(
                    "PricingPlanCompareTable",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"pricing__plan-comparison-table\"> <header class=\"pricing__plan-comparison-table__plan-names\"> <span>{{ t(\"Player\") }}</span> <span>{{ t(\"Game Master\") }}</span> <span>{{ t(\"Story Teller\") }}</span> <span>{{ t(\"World Builder\") }}</span> </header> <pricing-plan-compare-section :title=\"t('Price (USD)')\"> <pricing-plan-compare-row :title=\"t('Monthly')\"> <span slot=\"player\">Free</span> <span slot=\"game-master\"> <i18n tag=\"span\" path=\"{0} per month\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;4.49<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> <span slot=\"story-teller\"> <i18n tag=\"span\" path=\"{0} per month\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;8.99<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> <span slot=\"world-builder\"> <i18n tag=\"span\" path=\"{0} per month\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;12.99<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Yearly')\"> <p slot=\"caption\">{{ t(\"Save 10%!\") }}</p> <span slot=\"player\">{{ t(\"Free\") }}</span> <span slot=\"game-master\"> <i18n tag=\"span\" path=\"{0} per year\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;47.99<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> <span slot=\"story-teller\"> <i18n tag=\"span\" path=\"{0} per year\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;96.99<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> <span slot=\"world-builder\"> <i18n tag=\"span\" path=\"{0} per year\"> <span class=\"pricing__plan-comparison-table__price-amount\"> &dollar;139.99<pricing-tax-tooltip></pricing-tax-tooltip ></span> </i18n> </span> </pricing-plan-compare-row> </pricing-plan-compare-section> <pricing-plan-compare-section :title=\"t('The Forge features')\"> <pricing-plan-compare-row :title=\"t('Game Management')\"> <p slot=\"caption\">{{ t(\"A unique URL per game, with automatic world switching\") }}</p> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('User management')\"> <p slot=\"caption\"> {{ t(\"Your players can skip the Foundry login screen if they have an account with The Forge\") }} </p> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('D&D Beyond™ Integration')\"> <p slot=\"caption\">{{ t(\"Import adventures, statblocks, and rulebooks into your Foundry games\") }}</p> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('LiveKit servers')\"> <p slot=\"caption\">{{ t(\"Improved voice and video chat from within Foundry\") }}</p> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Automatic game data backups')\"> <p slot=\"caption\"> <i18n path=\"Including access to {0}\" tag=\"span\"> <span>{{ t(\"Save Points\") }}</span> </i18n> </p> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> </pricing-plan-compare-section> <pricing-plan-compare-section :title=\"t('Quotas')\"> <pricing-plan-compare-row :title=\"t('Game data storage')\"> <p slot=\"caption\">{{ t(\"Storage for game databases, systems, and addon modules\") }}</p> <i18n slot=\"player\" tag=\"span\" :path=\"t('{0} MB')\"> <span>0</span> </i18n> <i18n slot=\"game-master\" tag=\"span\" :path=\"t('{0} MB')\"> <span>500</span> </i18n> <i18n slot=\"story-teller\" tag=\"span\" :path=\"t('{0} GB')\"> <span>1</span> </i18n> <i18n slot=\"world-builder\" tag=\"span\" :path=\"t('{0} GB')\"> <span>2</span> </i18n> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Asset storage')\"> <p slot=\"caption\"> <i18n path=\"Your {0} contains images, audio, and videos used in your games\"> <a href=\"https://forums.forge-vtt.com/t/the-assets-library/574\" target=\"_blank\">{{ t(\"assets library\") }}</a> </i18n> </p> <i18n slot=\"player\" tag=\"span\" :path=\"t('{0} MB')\"> <span>100</span> </i18n> <i18n slot=\"game-master\" tag=\"span\" :path=\"t('{0} GB')\"> <span>5</span> </i18n> <i18n slot=\"story-teller\" tag=\"span\" :path=\"t('{0} GB')\"> <span>10</span> </i18n> <i18n slot=\"world-builder\" tag=\"span\" :path=\"t('{0} GB')\"> <span>20</span> </i18n> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Max file size')\"> <p slot=\"caption\">{{ t(\"The largest file your plan can upload\") }}</p> <i18n slot=\"player\" tag=\"span\" :path=\"t('{0} MB')\"> <span>10</span> </i18n> <i18n slot=\"game-master\" tag=\"span\" :path=\"t('{0} MB')\"> <span>50</span> </i18n> <i18n slot=\"story-teller\" tag=\"span\" :path=\"t('{0} MB')\"> <span>100</span> </i18n> <i18n slot=\"world-builder\" tag=\"span\" :path=\"t('{0} MB')\"> <span>250</span> </i18n> </pricing-plan-compare-row> </pricing-plan-compare-section> <pricing-plan-compare-section :title=\"t('Foundry features')\"> <pricing-plan-compare-row :title=\"t('Requires FVTT License')\"> <p slot=\"caption\"> <i18n path=\"A valid {0} license is required for creating your own games.\"> <a href=\"https://foundryvtt.com\" target=\"_blank\">{{ t(\"Foundry Virtual Table Top\") }}</a> </i18n> </p> <span slot=\"player\">{{ t(\"No\") }}</span> <span slot=\"game-master\">{{ t(\"Yes\") }}</span> <span slot=\"story-teller\">{{ t(\"Yes\") }}</span> <span slot=\"world-builder\">{{ t(\"Yes\") }}</span> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Export games')\"> <i slot=\"player\" v-b-tooltip:hover:top class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator with-tooltip\" :title=\"t('For games you own and would have created while on a higher tier.')\" :aria-label=\"t('Yes')\" /> <i slot=\"game-master\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" /> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Import games')\"> <p slot=\"caption\">{{ t(\"Create games locally and upload them to The Forge\") }}</p> <i slot=\"game-master\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" /> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" /> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" /> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Create and launch your own games')\"> <p slot=\"caption\">{{ t(\"Any paid plan can create an unlimited number of games.\") }}</p> <i slot=\"game-master\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" /> </pricing-plan-compare-row> <pricing-plan-compare-row :title=\"t('Install custom game systems and add-on modules')\"> <i slot=\"game-master\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"story-teller\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> <i slot=\"world-builder\" class=\"fas fa-hammer pricing__plan-comparison-table__boolean-feature-indicator\" :aria-label=\"t('Yes')\" ></i> </pricing-plan-compare-row> </pricing-plan-compare-section> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing__plan-comparison-table{min-width:785px;container-type:inline-size;container-name:price-compare-table}.pricing__plan-comparison-table__plan-names{position:sticky;top:-1em;transform:translateY(0.25em);float:right;z-index:10;display:grid;grid-template-columns:var(--plan-columns);gap:var(--plan-gap);justify-content:end;width:min-content;margin-bottom:-2em;padding:1em 0;text-align:center;font-weight:600}.pricing__plan-comparison-table__boolean-feature-indicator{display:inline-block;color:var(--color-forge-green-dark)}.pricing__plan-comparison-table__price-amount{display:block;font-weight:600}@container price-comparison-container (min-width: 660px){.pricing__plan-comparison-table__plan-names{top:calc(70px - 1em);right:0}}"
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingPrice"] = Vue.component(
                    "PricingPrice",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"pricing-price\"> <span class=\"pricing-price__price-per-interval\"> <span class=\"pricing-price__price\">${{ price }}</span ><span class=\"pricing-price__interval\">/{{ t(interval) }}</span> <pricing-tax-tooltip></pricing-tax-tooltip> </span> <slot></slot> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing-price{container-type:inline-size;container-name:price-price;width:100%;background-color:#fff;padding:1em;text-align:center}.pricing-price__price-per-interval{display:block}.pricing-price__price{--pricing-price-size: 2em;font-size:var(--pricing-price-size);line-height:1em}@container price-price (min-width: 30ch){.pricing-price__price{--pricing-price-size: 3em}}"
    });
  },
  props: {
    price: {
      type: [String, Number],
      default: ""
    },
    interval: {
      type: String,
      default: ""
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PricingTaxTooltip"] = Vue.component(
                    "PricingTaxTooltip",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<sup class=\"pricing__tax-tooltip\"> <a v-b-tooltip.hover=\"{ html: true }\" class=\"text-body\" target=\"_blank\" href=\"https://forums.forge-vtt.com/docs?topic=16837\" :title=\"tooltipContent\" > <i class=\"fas fa-info-circle\"></i> </a> </sup>",
  beforeCreate() {
    Utils.loadCss({
      content: ".pricing__tax-tooltip a[href]:after{display:none}"
    });
  },
  props: {
    footnoteNumber: {
      type: Number,
      default: 1
    }
  },
  computed: {
    tooltipContent() {
      const tooltipContent = t("PLANS.TaxTooltip");
      const callToAction = t("Click for more information");
      return `${tooltipContent}<br /><em>${callToAction}</em>`;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["DeletedWorldsList"] = Vue.component(
                    "DeletedWorldsList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"automatic-backups\"> <b-input-group class=\"pb-3\"> <b-form-input v-model=\"searchWorlds\" type=\"search\" :placeholder=\"t('Find worlds')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> <b-list-group class=\"mt-3\"> <b-list-group-item v-if=\"loadingBackupDate\" class=\"busy\"> <span> <b-spinner small class=\"align-middle\"></b-spinner ><i18n :path=\"t('Searching deleted worlds in the {{loadingBackupDate}} automatic backup…', { loadingBackupDate })\" ></i18n> </span> </b-list-group-item> <b-list-group-item v-for=\"world in filteredWorlds\" :key=\"world.key\"> <div class=\"details\"> <p class=\"title\"> <span class=\"title\">{{ world.world }}</span> <span v-if=\"world.type === 'backup'\" class=\"type\"> <i v-b-tooltip.hover :title=\"t('Automatic daily backup')\" class=\"fas fa-hourglass-half\"></i> {{ t(\"Automatic backup\") }} </span> <span v-else class=\"type\"> <i v-b-tooltip.hover :title=\"t('Save Point')\" class=\"fas fa-save\"></i> {{ t(\"Save Point\") }} </span> </p> <p class=\"date\"> <span v-if=\"world.type === 'backup'\" v-b-tooltip :title=\"Utils.localizeDate(world.date)\">{{ Utils.timeSince(world.date) }}</span> <span v-else v-b-tooltip :title=\"Utils.localizeDate(world.latest.date)\">{{ Utils.timeSince(world.latest.date) }}</span> </p> </div> <b-button v-b-tooltip.hover.ds400 :disabled=\"!!loadingBackupDate || busy !== null\" variant=\"primary\" :title=\"t('Restore from backup')\" @click=\"confirmRestore(world)\" > <i class=\"fa fa-fw\" :class=\"busy === world.key ? 'fa-spinner fa-spin' : 'fa-trash-restore'\"></i> </b-button> </b-list-group-item> </b-list-group> <!-- Confirm reverting a world to a save point state --> <confirm-message v-model=\"showRestoreConfirmation\" variant=\"warning\" :title=\"t('Restore backup {{date}}', { date: `“${selection.date}”` })\" @ok=\"restoreWorld()\" > <!-- Add for string extraction which can skip values in ternaries --> <!-- t('Unknown World') --> <!-- t('Automatic Backup') --> <i18n :path=\" t('You are about to recover the deleted world {{world}} using the {{label}} from {{date}}.', { world: `“${selection.world ? selection.world : t('Unknown World')}”`, label: selection.type === 'savepoint' ? t('Save Point') : t('Automatic Backup'), date: selection.date ? selection.date : Date.now(), }) \" tag=\"p\" ></i18n> <p>{{ t(\"Are you sure you wish to continue?\") }}</p> </confirm-message> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".automatic-backups .busy span { display: flex; align-items: center; gap: 0.5rem; }"
    });
  },
  props: {
    deletedWorlds: Array,
    // Worlds which have been deleted, found in save points/backups
    existingWorlds: Array
  },
  data() {
    return {
      busy: null,
      // List key of the world we're restoring
      loadingBackupDate: null,
      selection: {
        // World backup restore/clone
        index: null,
        world: null,
        type: "backup",
        backupId: null,
        date: Utils.localizeDate(Date.now())
      },
      showRestoreConfirmation: false,
      searchWorlds: "",
      // Worlds search string
      backupWorlds: [] // List of worlds found in automatic backups
    };
  },

  computed: {
    filteredWorlds() {
      // Filtered list of all deleted worlds found
      const search = this.searchWorlds.trim().toLowerCase();
      let worlds = !this.deletedWorlds ? [] : this.deletedWorlds.map(dw => ({
        ...dw,
        type: "savepoint",
        key: this.keygen(dw, "savepoint")
      }));
      worlds = worlds.concat(this.backupWorlds).sort((a, b) => {
        // Sort by date, then by world name, then by savepoint/backup
        if (a.date !== b.date) {
          return b.date - a.date; // Recent first
        } else if (a.world !== b.world) {
          return a.world.localeCompare(b.world);
        }
        return a.type.localeCompare(b.type);
      });
      if (!search) {
        return worlds;
      }
      return worlds.filter(w => {
        // Filter by search string against world name and backup type
        const backupType = w.type === "savepoint" ? [t("Save Point").toLowerCase(), "save point", "savepoint"] : [t("Automatic Backup").toLowerCase(), "automatic backup", "autobackup"];
        const typeMatch = backupType.map(t => t.includes(search));
        return w.world.toLowerCase().includes(search) || typeMatch.includes(true);
      });
    }
  },
  methods: {
    keygen(world, type) {
      if (type === "savepoint") {
        return `${world.world}-${world.latest.savepoint}`;
      }
      return `${world.world}-${world.backupId}`;
    },
    async fetchWorlds(backup) {
      const date = Utils.localizeDate(backup.date, true);
      this.loadingBackupDate = date;
      const response = await Utils.apiTask("saves/worlds", {
        backup: backup.id
      });
      if (response.success) {
        this.$emit("found-worlds", backup.id, response.worlds);
        const worlds = response.worlds;
        const deletedWorlds = worlds.filter(w => !this.existingWorlds.includes(w)).map(w => ({
          world: w,
          type: "backup",
          date: backup.date,
          backupId: backup.id,
          key: `${w}-${backup.id}`
        }));
        if (deletedWorlds.length) {
          this.$emit("alert", "success", t("Found {{count}} deleted worlds in the {{date}} backup", {
            count: deletedWorlds.length,
            date
          }));
          this.backupWorlds = this.backupWorlds.concat(deletedWorlds);
        } else {
          this.$emit("alert", "warning", t("Found no deleted worlds in the {{date}} backup", {
            date
          }));
        }
      }
      this.loadingBackupDate = null;
      return !!response.success;
    },
    async confirmRestore(world) {
      if (this.showRestoreConfirmation) {
        return;
      }
      if (world.type === "savepoint") {
        this.selection = {
          ...world,
          backupId: world.latest.savepoint,
          date: Utils.localizeDate(world.latest.date)
        };
      } else {
        this.selection = {
          ...world,
          date: Utils.localizeDate(world.date)
        };
      }
      this.showRestoreConfirmation = true;
    },
    async restoreWorld() {
      const save = this.selection;
      this.busy = save.key;
      const response = await Utils.apiTask("saves/restore", {
        world: save.world,
        [save.type]: save.backupId,
        revert: true
      });
      if (response.error) {
        this.$emit("alert", "danger", t("Error restoring backup: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("change");
        this.$emit("alert", "success", t("The world was restored to the automatic backup from {{date}}", {
          date: save.date
        }));
      }
      this.busy = null;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SavePoints"] = Vue.component(
                    "SavePoints",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"game-savepoints\"> <b-alert variant=\"warning\" :show=\"!canTimeMachine\"> <p class=\"mb-0\"> <i18n :path=\" t( 'The Save Points feature is available to {0} tier subscribers only. Please {1} your subscription to unlock the feature.' ) \" > <b>{{ t(\"World Builder\") }}</b> <a href=\"/account#membership&amp;subscribe=world-builder\">{{ t(\"upgrade\") }}</a> </i18n> </p> </b-alert> <div v-if=\"!managingGames && game.table\"> <!-- Opened on a game table, instead of a world --> <i18n :path=\"t('In order to use the Game specific Save Points, you need to enable the {0}.')\" tag=\"p\"> <a href=\"#manager=1\">{{ t(\"Game Manager\") }}</a> </i18n> <i18n :path=\"t('However, you can still browse your available Save Points and world backups from the {0} page.')\" tag=\"p\" > <a href=\"/saves\">{{ t(\"Save Points\") }}</a> </i18n> </div> <div v-else> <!-- Autosave and manual save controls --> <b-form-group label-for=\"autosave\" class=\"options mb-0\" label-cols=\"12\" label-cols-sm=\"3\" label-cols-lg=\"2\" label-class=\"pl-0\" > <template #label> <legend class=\"col-form-label\" :class=\"managingGames ? '' : 'text-muted'\"> {{ t(\"Autosave\") }} <help-icon :tooltip=\"t('Click here for more information')\" url=\"https://forums.forge-vtt.com/docs?topic=37844\" ></help-icon> </legend> </template> <b-form-checkbox id=\"autosave\" v-model=\"autoSaving\" :disabled=\"!managingGames || blockingAction\" switch size=\"lg\" ></b-form-checkbox> </b-form-group> <b-form-group :label=\"t('Manual Save')\" class=\"options mb-2\" label-cols=\"12\" label-cols-sm=\"3\" label-cols-lg=\"2\"> <b-input-group> <b-form-input v-model=\"saveTitle\" :disabled=\"blockingAction\" :maxlength=\"maxSaveName\" :placeholder=\"t('Save Point name')\" ></b-form-input> <template #append> <b-button v-b-tooltip.hover.top :disabled=\"blockingAction\" variant=\"success\" :title=\"t('Create a Save Point now!')\" @click=\"createSave\" > <loading-indicator v-if=\"action === 'save'\" tag=\"span\" small :label=\"t('Saving…')\"></loading-indicator> <span v-else><i class=\"fas faw fa-save\"></i> {{ t(\"Save\") }}</span> </b-button> </template> </b-input-group> </b-form-group> <!-- Search filtering --> <b-form-group v-if=\"showFilters\" :label=\"t('Filter by Date')\" class=\"options filters mb-2\" label-cols=\"12\" label-cols-sm=\"3\" label-cols-lg=\"2\" > <date-picker v-model=\"dateRangeSavePoints\" range class=\"w-100\" input-class=\"form-control\" :popup-style=\"{ top: '100%', left: 0 }\" :append-to-body=\"false\" ></date-picker> </b-form-group> <b-form-group v-if=\"showFilters\" :label=\"t('Search Text')\" class=\"options filters mb-2\" label-cols=\"12\" label-cols-sm=\"3\" label-cols-lg=\"2\" > <b-input-group> <b-form-input v-model=\"searchString\" type=\"search\" :placeholder=\"t('Find Save Points')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> </b-form-group> <!-- Display automatic backups --> <b-form-group v-if=\"hasBackupsAndSavePoints\" :label=\"t('Show Backups')\" class=\"options filters align-items-center\" label-cols=\"12\" label-cols-sm=\"3\" label-cols-lg=\"2\" > <b-form-checkbox id=\"displayBackups\" v-model=\"displayBackups\" switch size=\"lg\"></b-form-checkbox> </b-form-group> <!-- Save points list --> <i18n v-if=\"showFilters && filteredSavePoints.length !== savePoints.length\" :path=\" t('{{filtered}} out of {{total}} match the current filters', { filtered: filteredSavePoints.length, total: savePoints.length + (displayBackups ? backups.length : 0), }) \" ></i18n> <b-table :striped=\"striped\" hover bordered sticky-header stacked=\"md\" small class=\"save-list mt-3\" head-variant=\"light\" :busy=\"loading\" :items=\"filteredSavePoints\" :fields=\"fields\" :per-page=\"perPage\" :current-page=\"currentPage\" > <template #table-busy> <div class=\"text-center my-2\"> <b-spinner class=\"align-middle\"></b-spinner> <strong>{{ t(\"Loading…\") }}</strong> </div> </template> <template #cell(date)=\"{ value }\"> {{ Utils.localizeDate(value, true) }} </template> <template #head(manual)> <i v-b-tooltip.hover=\"t('Savepoint type')\" class=\"fas fa-flag\"></i> </template> <template #cell(manual)=\"{ item, value }\"> <!-- Icons - always shown --> <i v-if=\"item.type === 'backup'\" v-b-tooltip.hover :title=\"t('Automatic daily backup')\" class=\"fas fa-hourglass-half text-secondary d-inline-block d-md-block\" ></i> <i v-else-if=\"value\" v-b-tooltip.hover :title=\"t('Manual save')\" class=\"fas fa-save text-success d-inline-block d-md-block\" ></i> <i v-else v-b-tooltip.hover :title=\"t('Automatic save')\" class=\"fas fa-magic text-info d-inline-block d-md-block\" ></i> <!-- Text - for narrow viewports, table rendered in stacked mode --> <p v-if=\"item.type === 'backup'\" class=\"d-inline-block d-md-none text-left pl-2 mb-0\"> {{ t(\"Automatic daily backup\") }} </p> <p v-else-if=\"value\" class=\"d-inline-block d-md-none text-left pl-2 mb-0\">{{ t(\"Manual save\") }}</p> <p v-else class=\"d-inline-block d-md-none text-left pl-2 mb-0\">{{ t(\"Automatic save\") }}</p> </template> <template #cell(title)=\"{ item }\"> <div class=\"row\"> <editable-input :disabled=\"item.type === 'backup' || blockingAction || item.editingTitle\" :editable=\"item.type !== 'backup'\" :processing=\"item.editingTitle\" :state=\"item.editTitleState\" :value=\"getSaveTitle(item)\" :maxlength=\"maxSaveName\" @change=\"changeTitle($event, item.id)\" ></editable-input> </div> </template> <template #cell(actions)=\"{ item }\"> <span v-for=\"action in item.actions || actions\" :key=\"action.name\" v-b-tooltip.hover :title=\"action.tooltip\" class=\"ml-1\" > <b-button :disabled=\"blockingAction || action.disabled\" :variant=\"`outline-${action.variant}`\" @click=\"confirmAction(action.name, item)\" > <i v-if=\"action.name === 'restore'\" class=\"fa fa-fw\" :class=\"performingAction(item.id, action.name) ? 'fa-spinner fa-spin' : 'fa-history'\" ></i> <i v-if=\"action.name === 'clone' && performingAction(item.id, action.name)\" class=\"fa fa-fw fa-spinner fa-spin\" ></i> <span v-else-if=\"action.name === 'clone'\" class=\"fa-stack clone-stack\"> <i class=\"fas fa-fw fa-globe-americas fa-stack-2x\"></i> <i class=\"fa fa-fw fa-plus fa-stack-1x\"></i> </span> <i v-if=\"action.name === 'delete'\" class=\"fa fa-fw\" :class=\"performingAction(item.id, action.name) ? 'fa-spinner fa-spin' : 'fa-trash'\" ></i> <i v-if=\"action.name === 'unavailable'\" class=\"fa fa-fw fa-ban\"></i> </b-button> </span> </template> <template #custom-foot> <tr v-if=\"noSaves\" class=\"no-saves\"> <td colspan=\"4\"> <p>{{ t(\"No Save Points found\") }}</p> </td> </tr> </template> </b-table> <p v-if=\"hiddenSaves\" class=\"text-center mt-2 mb-0\"> <b-button variant=\"primary\" size=\"sm\" @click=\"showAllSavePoints\" ><i18n :path=\"t('View all the Save Points ({{ hiddenSaves }} currently hidden)', { hiddenSaves })\"></i18n ></b-button> </p> <div v-else-if=\"filteredSavePoints.length > perPage\" class=\"mt-2\"> <b-pagination v-model=\"currentPage\" :total-rows=\"filteredSavePoints.length\" :per-page=\"perPage\" align=\"center\" first-number last-number > </b-pagination> </div> <!-- Confirm reverting a world to a Save Point state --> <confirm-message v-model=\"show.restore\" variant=\"warning\" :title=\"t('Restore Save Point {{- title }}', { title: `“${selection.descriptiveTitle}”` })\" @ok=\"restoreSave()\" > <i18n :path=\" t(`You are about to revert {0} to the {1} Save Point {{title}}.`, { title: `“${selection.descriptiveTitle}”`, interpolation: { escapeValue: false }, }) \" tag=\"p\" > <b>{{ game.title }}</b> {{ selection.manualHR }} </i18n> <p>{{ t(\"Are you sure you wish to continue?\") }}</p> </confirm-message> <!-- Confirm cloning world from a Save Point --> <table-tool-clone-world v-model=\"show.clone\" :game=\"game\" :modal-title=\"t('Clone from savepoint')\" :default-name=\"t('{{world}}-restore', { world: game.world })\" :title-placeholder=\"cloneTitle(game)\" :clone=\"false\" @clone-world=\"cloneWorld\" ></table-tool-clone-world> <!-- Confirm deleting Save Point --> <confirm-message v-model=\"show.delete\" variant=\"danger\" :title=\"t('Delete Save Point {{- title }}', { title: `“${selection.descriptiveTitle}”` })\" @ok=\"deleteSave\" > <i18n :path=\" t('You are about to permanently delete the {{type}} Save Point {{-title}}.', { type: selection.manualHR ? selection.manualHR : '', title: `“${selection.descriptiveTitle ? selection.descriptiveTitle : ''}”`, }) \" tag=\"p\" ></i18n> <p>{{ t(\"Are you sure you wish to continue?\") }}</p> </confirm-message> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".game-savepoints .form-group { margin-left: 0.25em; } .game-savepoints #autosave + label { margin-left: 0.25em; /* Override vue rendering differences with custom labels */ } .game-savepoints .save-list { border-radius: 0.25em; margin-bottom: 0; } .game-savepoints .save-list + .pagination { margin: 1rem 0 0; } .game-savepoints .save-list td { vertical-align: middle; } .game-savepoints .manual-save { text-align: center; } .game-savepoints .custom-switch.b-custom-control-lg .custom-control-label::before, .game-savepoints .custom-switch.b-custom-control-lg .custom-control-label::after { cursor: pointer; } .game-savepoints button:disabled, .game-savepoints .custom-switch.b-custom-control-lg .custom-control-input:disabled ~ .custom-control-label::before, .game-savepoints .custom-switch.b-custom-control-lg .custom-control-input:disabled ~ .custom-control-label::after { cursor: not-allowed; } /* Table column styling */ .game-savepoints .save-list td.date { line-height: 1.2; } @media (min-width: 992px) { .game-savepoints .save-list td.date { /* Force least width possible without wrapping too much */ width: 8em; } } .game-savepoints .save-list td.manual-save, .game-savepoints .save-list td.actions { /* Force minimal width possible */ width: 0; white-space: nowrap; } @media (max-width: 767px) { .game-savepoints .save-list td.manual-save, .game-savepoints .save-list td.actions { width: inherit; } } .game-savepoints .save-list td.actions button + button { margin-left: 0.3rem; } .game-savepoints .save-list td.title .row { display: flex; flex-direction: row; align-items: center; flex-wrap: nowrap; max-width: 100%; margin-left: inherit; } /* Getting rid of the bottom borders */ .game-savepoints .save-list, .game-savepoints .save-list tfoot, .game-savepoints .save-list tfoot td { padding: 0; border: none !important; } .game-savepoints .save-list tfoot { display: table-footer-group !important; } .game-savepoints .save-list tfoot button { width: 100%; height: 100%; border-top-left-radius: 0; border-top-right-radius: 0; } .game-savepoints .save-list .no-saves p { font-size: 1.1em; padding: 0.6em 0; text-align: center; } /* Switch alignment */ .game-savepoints label[for=\"autosave\"] + div, .game-savepoints .form-group legend + div { display: flex; align-items: center; } .game-savepoints label.custom-control-label[for=\"autosave\"] { margin-top: -2px; /* Vue bootstrap large checkbox misalignment */ } .game-savepoints table.table-striped td.title, .game-savepoints table.table-striped td.actions { display: flex !important; align-items: center; } /* Icon stack */ .game-savepoints .clone-stack { font-size: 0.5em; margin-top: -0.5em; } .game-savepoints .clone-stack .fa-circle { margin-top: -0.525em; padding-left: 0.775em; font-size: 1.25em; } .game-savepoints .clone-stack .fa-plus { margin-top: -1.1em; margin-left: 1.1em; }"
    });
  },
  props: {
    game: Object,
    backups: Array,
    canTimeMachine: Boolean,
    managingGames: Boolean,
    limit: Number,
    autoload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      action: null,
      actions: [{
        variant: "primary",
        name: "restore",
        tooltip: t("Revert to this point")
      }, {
        variant: "primary",
        name: "clone",
        tooltip: t("Create new world from this point")
      }, {
        variant: "danger",
        name: "delete",
        tooltip: t("Delete this Save Point")
      }],
      backupActions: [{
        variant: "primary",
        name: "restore",
        tooltip: t("Revert from this backup")
      }, {
        variant: "primary",
        name: "clone",
        tooltip: t("Create new world from this backup")
      }],
      loading: true,
      // Currently loading
      currentPage: 1,
      perPageLimit: 10,
      useLimit: true,
      // Respect the limit property or show all savepoints
      savePoints: null,
      // List of Save Points
      show: {
        // Show confirmation dialogs
        restore: false,
        clone: false,
        delete: false
      },
      autoSaving: false,
      // Auto save enabled
      displayBackups: false,
      // Display the automatic backups in the list
      saveTitle: null,
      // Manual save title
      fields: [
      // Save Points table
      {
        key: "date",
        label: t("Date"),
        tdClass: "date"
      }, {
        key: "manual",
        label: t("Save type"),
        tdClass: "manual-save"
      }, {
        key: "title",
        label: t("Save name"),
        thClass: "title",
        tdClass: "title"
      }, {
        key: "actions",
        label: t("Actions"),
        thClass: "text-center",
        tdClass: "actions"
      }],
      selection: {},
      // Save object to restore/clone/delete
      striped: false,
      // Striped table
      searchString: "",
      // Save Points search string
      dateRangeSavePoints: [null, null] // Selected Save Points date range
    };
  },

  watch: {
    autoSaving(value) {
      if (value !== this.game.autoSave) {
        this.toggleAutoSave(value);
      }
    },
    game() {
      this.autoSaving = this.game.autoSave;
    },
    filteredSavePoints() {
      this.currentPage = 1;
    },
    action(val) {
      this.$emit("action", val);
    }
  },
  computed: {
    maxSaveName() {
      return 100;
    },
    noSaves() {
      return !this.loading && (!this.savePoints || this.savePoints.length === 0) && (!this.backups || this.backups.length === 0);
    },
    hiddenSaves() {
      if (!this.useLimit || !this.savePoints || !this.limit) {
        return 0;
      }
      return Math.max(0, this.filteredSavePoints.length - this.limit);
    },
    hasBackupsAndSavePoints() {
      return this.savePoints && this.savePoints.length > 0 && this.backups && this.backups.length > 0;
    },
    perPage() {
      return this.useLimit && this.limit ? this.limit : this.perPageLimit;
    },
    blockingAction() {
      // Performing an action that should be blocking
      return this.action !== null;
    },
    showFilters() {
      // Hide within the game configuration page
      return this.savePoints && this.hiddenSaves === 0;
    },
    filteredSavePoints() {
      // Save Points matching the filters, wrapped in b-table items format
      const from = this.dateRangeSavePoints[0] ? this.dateRangeSavePoints[0].getTime() : null;
      const to = this.dateRangeSavePoints[1] ? this.dateRangeSavePoints[1].getTime() + 86399999 : null; // 23:59:59.999
      const totalSavePoints = (this.savePoints ? this.savePoints : []).concat(!this.backups || !this.displayBackups ? [] : this.backups.map(backup => {
        const hasWorlds = !!backup.worlds;
        const hasThisWorld = hasWorlds && backup.worlds.includes(this.game.world);
        return {
          ...backup,
          manual: false,
          type: "backup",
          title: t("Automatic backup on {{date}}", {
            date: new Date(backup.date).toLocaleDateString(),
            interpolation: {
              escapeValue: false
            }
          }),
          actions: hasWorlds && !hasThisWorld ? [{
            variant: "danger",
            name: "unavailable",
            tooltip: this.t("World not found in backup"),
            disabled: true
          }] : this.backupActions
        };
      }));
      return !totalSavePoints.length ? [] : totalSavePoints.filter(sp => {
        // Filter by date
        if (from !== null && to !== null) {
          return from <= sp.date && sp.date <= to;
        }
        return true;
      }).filter(sp => {
        // Filter by search string against save point type and title
        const spType = sp.manual ? [t("Manual save").toLowerCase(), "manual save"] : [t("Autosave").toLowerCase(), "autosave", "auto save", "automatic save"];
        const typeMatch = spType.map(t => t.includes(this.searchString));
        return this.getSaveTitle(sp).toLowerCase().includes(this.searchString) || typeMatch.includes(true);
      }).sort((a, b) => {
        return b.date - a.date;
      });
    }
  },
  methods: {
    performingAction(id, action) {
      return this.action === action && id === this.selection.id;
    },
    async reloadSavepoints(bootstrap = false) {
      if (bootstrap && this.savePoints) {
        return;
      }
      const response = await Utils.apiTask("saves", {
        world: this.game.world
      });
      if (response.success) {
        // Inject props to track whether the title is being edited and indicate edit result
        this.savePoints = response.savepoints.map(sp => ({
          ...sp,
          editingTitle: false,
          editTitleState: undefined
        }));
        this.$emit("tally", {
          world: this.game.world,
          count: this.savePoints.length,
          auto: this.savePoints.filter(sp => !sp.manual && (!sp.type || sp.type !== "backup")).length,
          manual: this.savePoints.filter(sp => sp.manual).length
        });
      }
      if (bootstrap && this.backups) {
        // Display backups by default if we have no Save Points
        this.displayBackups = !(this.savePoints && this.savePoints.length > 0);
      }
      this.loading = false;
    },
    getSaveTitle(sp) {
      if (sp.title) {
        return sp.title;
      }
      return sp.manual ? t("Manual save") : t("Autosave");
    },
    async toggleAutoSave(enable) {
      const response = await Utils.api("saves/autosave", {
        game: this.game.slug,
        enabled: enable
      });
      if (response.error) {
        this.$emit("alert", "danger", t(`Error {{verb}} Auto Save: {{- error}}`, {
          verb: enable ? t("enabling") : t("disabling"),
          error: response.error
        }));
      } else {
        this.$emit("update", {
          slug: this.game.slug,
          game: {
            ...this.game,
            autoSave: enable
          }
        });
      }
    },
    async createSave() {
      this.action = "save";
      const title = (this.saveTitle || "").trim().replace(/\s{2,}/g, " ");
      const response = await Utils.apiTask("saves/create", {
        world: this.game.world,
        title
      });
      this.action = null;
      if (response.error) {
        this.$emit("alert", "danger", t("Error creating Save Point: {{- error}}", {
          error: response.error
        }));
      } else {
        this.saveTitle = null;
        if (this.savePoints && this.savePoints.find(sp => sp.id === response.savepoint.id)) {
          this.$emit("alert", "success", t("No changes detected since your last Save Point"));
        } else {
          this.$emit("alert", "success", t("A new Save Point has been created"));
          this.reloadSavepoints();
        }
      }
    },
    async restoreSave(target = null, title = null) {
      const save = this.selection;
      const reverting = save.action === "restore";
      if (!reverting && !target) {
        return;
      }
      this.action = save.action;
      const response = await Utils.apiTask("saves/restore", {
        [save.type]: save.id,
        world: this.game.world,
        target,
        title,
        revert: reverting
      });
      this.action = null;
      if (response.error) {
        this.$emit("alert", "danger", t("Error restoring Save Point: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("change");
        this.$emit("alert", "success", reverting ? t("The world was restored to Save Point {{- title}}", {
          title: `“${save.descriptiveTitle}”`
        }) : t("A new world was created from Save Point {{- title}}", {
          title: `“${save.descriptiveTitle}”`
        }));
        if (reverting) {
          this.reloadSavepoints();
        }
      }
    },
    async deleteSave() {
      const save = this.selection;
      if (this.selection.type === "backup") {
        this.$emit("alert", "danger", this.t("Can't delete an automatic backup"));
        return;
      }
      this.action = "delete";
      const response = await Utils.apiTask("saves/delete", {
        world: this.game.world,
        savepoint: save.id
      });
      this.action = null;
      if (response.error) {
        this.$emit("alert", "danger", t("Error deleting Save Point: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("alert", "success", t("Save Point {{- title}} deleted", {
          title: `“${save.descriptiveTitle}”`
        }));
        this.reloadSavepoints();
      }
    },
    async confirmAction(action, item) {
      if (this.blockingAction || !["restore", "clone", "delete"].includes(action)) {
        return;
      }
      this.selection = {
        action,
        id: item.id,
        type: item.type === "backup" ? "backup" : "savepoint",
        date: Utils.localizeDate(item.date, true),
        manual: !!item.manual,
        manualHR: item.manual ? "manual" : "automatic",
        title: this.getSaveTitle(item),
        descriptiveTitle: item.title ? item.title : Utils.localizeDate(item.date, true) // A date is better than a generic 'Autosave' title
      };

      if (item.type === "backup") {
        if (!["restore", "clone"].includes(action)) {
          return;
        }
        if (!item.worlds) {
          this.$emit("alert", "info", t("Searching Automatic Backup files for a backup of this world"));
          await this.fetchBackupWorlds(item, action);
        }
        if (item.worlds && item.worlds.includes(this.game.world)) {
          this.$emit("alert", "info", t(`The Automatic Backup from {{date}} contains a backup of this world`, {
            date: new Date(item.date).toLocaleDateString(),
            interpolation: {
              escapeValue: false
            }
          }));
        } else {
          if (item.worlds) {
            this.$emit("alert", "danger", t(`Automatic Backup from {{date}} does not contain a backup of this world`, {
              date: new Date(item.date).toLocaleDateString(),
              interpolation: {
                escapeValue: false
              }
            }));
          }
          return;
        }
      }
      this.show[action] = true;
      if (action === "clone") {
        this.$nextTick(() => {
          // This is not a great way to do this, but something kept taking the focus away and it was the best solution I could come up with.
          const focusInterval = window.setInterval(() => {
            if (!$(".foldername").is(":focus")) {
              $(".foldername").focus();
            } else {
              window.clearInterval(focusInterval);
            }
          }, 500);
        });
      }
    },
    async fetchBackupWorlds(backup, action = "search") {
      this.action = action;
      const response = await Utils.apiTask("saves/worlds", {
        backup: backup.id
      });
      this.action = null;
      if (response.success) {
        this.$emit("found-worlds", backup.id, response.worlds);
        backup.worlds = response.worlds;
      } else if (response.error) {
        this.$emit("alert", "danger", response.error);
      }
    },
    async cloneWorld(name, title, ev) {
      if (name.length > 0) {
        this.show.clone = false;
        this.restoreSave(name, title);
      }
    },
    cloneTitle() {
      return t("{{title}} (Restored from {{date}})", {
        title: this.game.title,
        date: new Date(this.selection.date).toLocaleDateString(),
        interpolation: {
          escapeValue: false
        }
      });
    },
    async changeTitle(newTitle, saveId) {
      const savePoint = this.savePoints.find(sp => sp.id === saveId);
      if (!savePoint) {
        return;
      }
      savePoint.editingTitle = true;
      const response = await Utils.api("saves/rename", {
        world: this.game.world,
        savepoint: saveId,
        title: newTitle
      });
      if (response.error) {
        this.$emit("alert", "danger", t("Error renaming Save Point: {{- error}}", {
          error: response.error
        }));
        savePoint.editTitleState = false;
      } else if (response.success) {
        savePoint.title = newTitle;
        savePoint.editTitleState = true;
      }
      savePoint.editingTitle = false;
      setTimeout(() => savePoint.editTitleState = undefined, 1200); // Show validation state for 1.2s, then clear it
    },

    showAllSavePoints() {
      this.useLimit = false;
    }
  },
  async mounted() {
    // Small helper to detect viewport changes, since screen is not reliable
    const viewportWidth = () => Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.striped = viewportWidth() < 768;
    window.addEventListener("resize", () => this.striped = viewportWidth() < 768);
    this.autoSaving = this.game.autoSave;
    this.savePoints = null;
    await Utils.loadDependencies(["date-picker"]);
    if (this.autoload) {
      this.reloadSavepoints(true);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SavePointsDialog"] = Vue.component(
                    "SavePointsDialog",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal v-model=\"visible\" :title=\"title\" shadow backdrop lazy :no-close-on-backdrop=\"isBusy\" centered size=\"lg\"> <b-alert v-model=\"showAlert\" :variant=\"alertData.variant\" dismissible>{{ alertData.message }}</b-alert> <save-points :can-time-machine=\"canTimeMachine\" :managing-games=\"managingGames\" :autoload=\"true\" :game=\"game\" :backups=\"backups\" :limit=\"5\" @alert=\"onAlert\" @change=\"$emit('change', $event)\" @update=\"$emit('update', $event)\" @tally=\"updateCounts\" @action=\"action = $event\" @found-worlds=\"onFoundWorlds\" ></save-points> <template #modal-footer=\"{ cancel }\"> <b-row class=\"w-100\" align-v=\"center\"> <b-col class=\"text-left pl-0\"> <b-button variant=\"info\" class=\"float-left\" href=\"https://forums.forge-vtt.com/t/save-points/17790\" target=\"_blank\" > {{ t(\"Help\") }} <i class=\"fas fa-question-circle\"></i> </b-button> </b-col> <b-col class=\"text-center\"> <span v-b-tooltip.hover.top :title=\" t( 'You have {{autosaveCount}} autosaves on this world. The Forge will keep {{autosaveQuota}} autosaves per world.', { autosaveCount, autosaveQuota } ) \" > {{ autosaveCount }} / {{ autosaveQuota }} <i class=\"fas fa-magic text-info\"></i> </span> <help-icon v-if=\"autosaveCount > autosaveQuota\" v-b-tooltip.hover.top :title=\" t( 'Our retention rules ensure at least {{autosaveQuota}} saves are kept. However, more savepoints can be kept to ensure you have at least one for each month of the past 2 years.', { autosaveQuota } ) \" ></help-icon> </b-col> <b-col v-b-tooltip.hover.top class=\"text-center\" :title=\" t( 'You have {{manualCount}} manual saves on this world. The Forge will keep all manual saves indefinitely.', { manualCount } ) \" > {{ manualCount }} / <i class=\"fas fa-infinity\"></i> <i class=\"fas fa-save text-success\"></i> </b-col> <b-col class=\"text-right pr-0\"> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> </b-col> </b-row> </template> </b-modal>",
  props: {
    value: Boolean,
    game: Object,
    backups: Array,
    canTimeMachine: Boolean,
    managingGames: Boolean
  },
  data() {
    return {
      showAlert: false,
      alertData: {
        variant: null,
        message: null
      },
      action: null,
      autosaveCount: null,
      manualCount: null
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    title() {
      return Utils.t_vue(`Save Points: {{title}}`, {
        title: this.game.title
      });
    },
    isBusy() {
      return !!this.action;
    },
    autosaveQuota() {
      return 200;
    }
  },
  methods: {
    onAlert(variant, message) {
      this.alertData.variant = variant;
      this.alertData.message = message; // Already translated
      this.showAlert = true;
    },
    onFoundWorlds(backupId, worlds) {
      this.$emit("found-worlds", backupId, worlds);
    },
    updateCounts(data) {
      this.$emit("tally", data);
      this.autosaveCount = data.auto;
      this.manualCount = data.manual;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SavePointsPageTabs"] = Vue.component(
                    "SavePointsPageTabs",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-tabs v-model=\"tab\" class=\"mt-5\" content-class=\"card\" fill @input=\"changeTab\"> <!-- Recover worlds --> <b-tab class=\"floppy-bg\"> <template #title> <span class=\"d-inline-block d-md-none\">{{ t(\"Recover\") }}</span> <span class=\"d-none d-md-inline-block\">{{ t(\"Recover deleted world\") }}</span> </template> <div class=\"backups\"> <!-- Automatic backups world finder --> <div class=\"backups-finder\"> <b-dropdown block menu-class=\"w-100\" :disabled=\"disableBackupList\"> <template #button-content> <span v-if=\"backupsNeedLoading\" ><b-spinner small class=\"align-middle mr-1\"></b-spinner> {{ t(\"Loading backups\") }}</span > <span v-else-if=\"backupsExhausted\">{{ t(\"No backups left to search\") }}</span> <span v-else-if=\"!selectedBackup\">{{ t(\"Select an available backup date\") }}</span> <div v-else class=\"d-inline-block\"> <span class=\"d-none d-sm-block\">{{ Utils.localizeDate(selectedBackup.date) }}</span> <span class=\"d-block d-sm-none\">{{ Utils.localizeDate(selectedBackup.date, true) }}</span> </div> </template> <b-dropdown-group v-for=\"(monthBackups, month) in backupsGroupedByDate\" :key=\"month\" :header=\"month\"> <b-dropdown-item-button v-for=\"backup in monthBackups\" :key=\"backup.id\" class=\"ml-1\" :disabled=\"fetchedBackupsIDs.includes(backup.id)\" @click=\"dateSelected(backup)\" > <span class=\"d-none d-sm-inline-block\">{{ Utils.localizeDate(backup.date) }}</span> <span class=\"d-inline-block d-sm-none\">{{ Utils.localizeDate(backup.date, true) }}</span> <i v-if=\"fetchedBackupsIDs.includes(backup.id)\" class=\"fa fa-check text-success ml-1\"></i> </b-dropdown-item-button> </b-dropdown-group> </b-dropdown> </div> <!-- Alerts for searching/restoring deleted worlds --> <b-alert fade dismissible :show=\"!!backupAlert.message\" :variant=\"backupAlert.variant\" @dismissed=\"backupAlert.message = null\" >{{ backupAlert.message }}</b-alert > <!-- Aggregated deleted worlds list --> <deleted-worlds-list ref=\"deletedWorldsList\" :deleted-worlds=\"deletedGames\" :existing-worlds=\"existingWorlds\" @change=\"reloadGames\" @alert=\"onAlert\" @found-worlds=\"onFoundWorlds\" ></deleted-worlds-list> </div> </b-tab> <!-- Browse Save Points --> <b-tab class=\"savepoints\"> <template #title> <span class=\"d-inline-block d-md-none\">{{ t(\"Browse\") }}</span> <span class=\"d-none d-md-inline-block\">{{ t(\"Browse Save Points\") }}</span> </template> <save-points-dialog v-model=\"savePointsDialogVisible\" :game=\"games.find((g) => g.world === selectedGame) || {}\" :backups=\"backups\" :managing-games=\"managingGames\" :can-time-machine=\"canTimeMachine\" @change=\"reloadGames\" @update=\"updateGame\" @tally=\"updateSavePointsCount\" @found-worlds=\"onFoundWorlds\" ></save-points-dialog> <div class=\"d-flex\"> <b-input-group class=\"pb-3\"> <b-form-input v-model=\"searchGame\" type=\"search\" :placeholder=\"t('Find games')\"></b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> <!-- Cycle sorting method - for narrow screens --> <b-button v-b-tooltip.hover class=\"ml-3 mb-3 d-md-none\" :title=\"sortTooltip[gameSort]\" @click.prevent=\"onCycleGameSort\" ><i class=\"fas\" :class=\"sortCycleIcon(gameSort)\" style=\"min-width: 1em\"></i> </b-button> <!-- Separate sorting buttons - for wider screens --> <b-button-group class=\"ml-3 mb-3 d-none d-md-inline-flex\"> <b-button v-b-tooltip.hover :title=\"sortTooltip['alpha']\" :variant=\"gameSort === 'alpha' ? 'primary' : 'secondary'\" @click=\"gameSort = 'alpha'\" ><i class=\"fas\" :class=\"sortIcon['alpha']\"></i> </b-button> <b-button v-if=\"managingGames\" v-b-tooltip.hover :title=\"sortTooltip['time']\" :variant=\"gameSort === 'time' ? 'primary' : 'secondary'\" @click=\"gameSort = 'time'\" ><i class=\"fas\" :class=\"sortIcon['time']\"></i> </b-button> <b-button v-b-tooltip.hover :title=\"sortTooltip['saves']\" :variant=\"gameSort === 'saves' ? 'primary' : 'secondary'\" @click=\"gameSort = 'saves'\" ><i class=\"fas\" :class=\"sortIcon['saves']\"></i> </b-button> </b-button-group> </div> <b-list-group class=\"games-list\"> <b-list-group-item v-for=\"game in filteredSortedGames\" :key=\"game.world\" :active=\"selectedGame === game.world\" @click=\"showSavePoints(game)\" > <div class=\"banner d-none d-md-block w-25 text-center\"> <img v-if=\"game.banner\" alt=\"\" :src=\"game.banner\" class=\"mw-100 align-middle\" /> </div> <div class=\"details\"> <p class=\"title\"> <span class=\"title\"> {{ game.title }} <span v-if=\"game.favorite\" v-b-tooltip class=\"favorite gold ml-1\" :title=\"t('Favorite')\" ><i class=\"fa fa-star\"></i ></span> </span> </p> <p class=\"name\"> <span>{{ game.slug }}</span> <span v-if=\"game.autoSave\"> <i v-b-tooltip class=\"fas fa-save\" :title=\"t('Autosave enabled')\"></i> </span> </p> <!-- Last access and player count --> <p v-if=\"game.lastAccess\" class=\"played\"> <i18n :path=\"t('Last played {0}')\"> <span v-b-tooltip :title=\"Utils.localizeDate(game.lastAccess)\">{{ Utils.timeSince(game.lastAccess, \"h\") }}</span> </i18n> <span v-if=\"game.players.length > 1\" >, <span :id=\"`players-list-${game.slug}`\" class=\"players\" @mouseover=\"game.popover = true\" @mouseleave=\"game.popover = false\" ><i18n :path=\"t('{{count}} players', { count: game.players.length })\"></i18n ></span> </span> </p> <!-- Players list --> <b-popover v-if=\"game.players.length > 1\" :target=\"`players-list-${game.slug}`\" triggers=\"hover\" placement=\"top\" custom-class=\"savepoints-players-popover\" > <ul> <li v-for=\"player in game.players.slice(0, 10)\" :key=\"player.id\"> <b-img v-b-tooltip.hover.top=\"Games.roleName(player.role)\" :src=\"Games.roleImg(player.role)\" :alt=\"Games.roleName(player.role)\" ></b-img >{{ player.name }} </li> <li v-if=\"game.players.length > 10\"> <em ><i18n :path=\"t('{{count}} more players hidden…', { count: game.players.length - 10 })\"></i18n ></em> </li> </ul> </b-popover> <!-- Savepoints count --> <p class=\"count\"> <span :id=\"`count-${game.world}`\" v-b-tooltip class=\"type\">{{ game.saveCount > 0 ? t(\"SAVEPOINTS.SavePointsCount\", { count: game.saveCount }) : t(\"SAVEPOINTS.BackupsCount\", { count: backupsCount }) }}</span> <b-tooltip :target=\"`count-${game.world}`\"> {{ t(\"SAVEPOINTS.BackupsCount\", { count: backupsCount }) }}<br /> {{ t(\"SAVEPOINTS.SavePointsCount\", { count: game.saveCount }) }} </b-tooltip> </p> </div> </b-list-group-item> </b-list-group> </b-tab> </b-tabs>",
  beforeCreate() {
    Utils.loadCss({
      content: ".page-savepoints > header, .page-savepoints > .tabs, .page-savepoints > .card { width: 100%; margin: auto; } .page-savepoints h1 { text-align: center; } @media (min-width: 992px) { /* lg */ .page-savepoints > header, .page-savepoints > .tabs, .page-savepoints > .card { width: 60%; } } .page-savepoints > .tabs > .tab-content.card { padding: 1.5rem 1.25rem 0.75rem; border-top: none; border-top-left-radius: 0; border-top-right-radius: 0; } .page-savepoints > .tabs .nav-link { border-top-left-radius: 6px; border-top-right-radius: 6px; border-top: solid 4px transparent; font-size: 1.1em; font-weight: bold; } .page-savepoints > .tabs .nav-link.active { border-top-color: #f96854; } .page-savepoints > .tabs .nav-link:not(.active):hover { color: #f96854; background: rgba(255, 255, 255, 0.45); } .page-savepoints .backups-finder { display: flex; gap: 1rem; } .page-savepoints .backups-finder .dropdown { flex: auto; } /* Save points games list */ .page-savepoints .list-group-item { display: flex; flex-direction: row; gap: 1rem; max-width: 100%; align-items: flex-start; justify-content: space-between; } .page-savepoints .games-list .list-group-item { cursor: pointer; min-height: 106px; } .page-savepoints .details { flex: 1 1 auto; } .page-savepoints .details p { margin: 0; } .page-savepoints .details p.title { line-height: 1; display: flex; gap: 0.25em; justify-content: space-between; align-items: flex-start; flex-direction: column; } @media (min-width: 768px) { /* md */ .page-savepoints .details p.title { flex-direction: row; align-items: center; gap: 0; } } .page-savepoints .details span.title { font-weight: bold; display: inline-block; } .page-savepoints .details span.title:hover { white-space: normal; } .page-savepoints .details .name { font-variant: small-caps; } .page-savepoints .details .name .fa-save { font-size: 0.8em; margin-left: 0.5rem; opacity: 0.8; } .page-savepoints .details .title .type, .page-savepoints .details .date, .page-savepoints .details .count, .page-savepoints .details .played { font-size: 0.8em; } .page-savepoints .details .players { cursor: help; text-decoration: underline; text-decoration-style: dotted; } .page-savepoints .banner img { max-height: 5em; border-radius: 6px; } .page-savepoints .tab-pane.active { height: 100%; min-height: 60vh; } .page-savepoints .floppy-bg { background: no-repeat url('data:image/svg+xml,<svg viewBox=\"0 0 425 443\" xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" style=\"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2\"><path fill=\"rgba(0,0,0,.05)\" d=\"m433.941 129.941-83.882-83.882A48.018 48.018 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48.018 48.018 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A12.002 12.002 0 0 1 320 111.48z\" style=\"fill-rule:nonzero\" transform=\"rotate(14.958 180.73 344.288) scale(.83955)\"/></svg>') center center; background-size: 35vh; } /* Tab links */ .page-savepoints [role=\"tablist\"] .nav-link.active { font-weight: bold; } /* Date picker */ .page-savepoints header.dropdown-header { font-variant: small-caps; } /* Clip game titles */ .page-savepoints .nav-item, .page-savepoints .nav-link { max-width: 100%; } .page-savepoints .nav-link { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; } /* Favorite */ .page-savepoints .gold { color: gold; } /* No tabs open */ .page-savepoints .no-tabs h2 { margin-bottom: 0.6em; } .page-savepoints .no-tabs p { line-height: 1.75; font-size: 1.25em; margin: 0.875em 0 0; } /* Clip date selection to 50% screen height */ .page-savepoints .dropdown > ul { max-height: 47vh; overflow-y: scroll; } /* Searches */ .page-savepoints .search-games-dropdown { padding: 0.5rem calc(1rem - 1px); } /* Players list */ .savepoints-players-popover img { height: 1.5em; margin-right: 0.25rem; } .savepoints-players-popover ul { list-style: none; margin: 0; padding: 0; }"
    });
  },
  props: {
    initialGames: Array,
    initialSavePointsInfo: Array,
    canTimeMachine: Boolean,
    managingGames: Boolean
  },
  data() {
    return {
      extraSmallScreen: false,
      // Responsive behavioural changes
      games: [],
      savePointsInfo: [],
      backupsNeedLoading: true,
      backups: null,
      backupAlert: {},
      fetchedBackupsIDs: [],
      // List of backups IDs we already searched
      selectedBackup: null,
      selectedGame: null,
      tab: 0,
      searchGame: "",
      // Games search string
      gameSort: "alpha",
      sortTooltip: {
        alpha: t("Sort alphabetically"),
        time: t("Sort by last played time"),
        saves: t("Sort by number of save points")
      },
      sortIcon: {
        alpha: "fa-sort-alpha-down",
        time: "fa-sort-numeric-down",
        saves: "fa-sort-amount-down"
      },
      savePointsDialogVisible: false,
      searchingBackupWorlds: false
    };
  },
  computed: {
    deletedGames() {
      return this.savePointsInfo.filter(stat => !this.games.some(game => game.world === stat.world));
    },
    existingWorlds() {
      return this.games.map(g => g.world);
    },
    backupsCount() {
      return this.backups ? this.backups.length : 0;
    },
    backupsExhausted() {
      return this.backupsCount === this.fetchedBackupsIDs.length;
    },
    disableBackupSearch() {
      return !this.selectedBackup || this.searchingBackupWorlds || this.fetchedBackupsIDs.includes(this.selectedBackup.id);
    },
    disableBackupList() {
      return this.backupsNeedLoading || this.searchingBackupWorlds || this.backupsExhausted;
    },
    backupsGroupedByDate() {
      if (!this.backups) {
        return {};
      }
      return this.backups.reduce((bbd, b) => {
        const date = new Date(b.date);
        const year = date.getFullYear(); // YYYY
        const month = t(date.toLocaleString(undefined, {
          month: "long"
        })); // January-December
        const formattedDate = t("{{month}} {{year}}", {
          // Allow proper date localization
          year,
          month
        });
        if (!bbd[formattedDate]) {
          bbd[formattedDate] = [];
        }
        bbd[formattedDate].push(b);
        return bbd;
      }, {});
    },
    filteredSortedGames() {
      const search = this.searchGame.trim().toLowerCase();
      const sorted = this.games.map(g => ({
        ...g,
        saveCount: this.numWorldSavePoints(g.world)
      })).sort((a, b) => {
        switch (this.gameSort) {
          case "alpha":
            return a.title.localeCompare(b.title);
          case "time":
            return b.lastAccess - a.lastAccess;
          case "saves":
            return b.saveCount - a.saveCount;
        }
      });
      if (!search) {
        return sorted;
      }
      return sorted.filter(g => g.title.toLowerCase().includes(search));
    }
  },
  methods: {
    setHash(hash = "") {
      window.history.replaceState({}, document.title, window.location.pathname + (hash ? `#${hash}` : ""));
    },
    async reloadGames() {
      const list = await Utils.api("game/list?owner=1");
      if (!list) {
        return;
      }
      this.games = list.games;
    },
    updateGame({
      slug,
      game
    }) {
      // Must find index and splice to maintain reactivity
      const idx = this.games.findIndex(g => g.slug === slug);
      if (idx !== -1) {
        this.games.splice(idx, 1, game);
      }
    },
    async loadBackups() {
      // Prevent multiple triggers
      if (this.backups) {
        return;
      }
      const response = await Utils.api("saves/backups");
      if (response.success) {
        // Sort and organize
        this.backups = response.backups.sort((a, b) => b.date - a.date);
        this.backupsNeedLoading = false;
        return;
      }
    },
    onAlert(variant, message) {
      this.backupAlert = {
        variant,
        message
      }; // Already translated
    },

    changeTab(tab) {
      // Update hashes
      let hash = "backups";
      if (tab === 0) {
        this.loadBackups();
      } else if (tab === 1) {
        hash = "games";
        const sel = this.games.find(g => g.world === this.selectedGame);
        if (this.selectedGame && sel) {
          hash += `/${sel.world}`;
        }
      }
      this.setHash(hash);
    },
    showSavePoints(game) {
      if (this.selectedGame !== game.world) {
        this.selectedGame = game.world;
        this.setHash(`games/${game.world}`);
      }
      this.savePointsDialogVisible = true;
    },
    showDeletedGameSavePoints(world) {
      //@TODO have a way do display a save points dialog when API allows non existing game
    },
    updateSavePointsCount({
      world,
      count
    }) {
      const savePointWorld = this.savePointsInfo.find(stat => stat.world === world);
      if (savePointWorld) {
        savePointWorld.count = count;
      } else {
        this.savePointsInfo.push({
          world,
          count,
          latest: Date.now()
        });
      }
    },
    numWorldSavePoints(world) {
      const stat = this.savePointsInfo.find(stat => stat.world === world);
      return stat ? stat.count : 0;
    },
    async dateSelected(backup) {
      this.selectedBackup = backup;
      await this.findDeletedWorlds();
    },
    async findDeletedWorlds() {
      if (this.disableBackupSearch) {
        return;
      }
      this.searchingBackupWorlds = true;
      const worldsLoaded = await this.$refs.deletedWorldsList.fetchWorlds(this.selectedBackup);
      if (worldsLoaded) {
        this.fetchedBackupsIDs.push(this.selectedBackup.id);
      }
      this.searchingBackupWorlds = false;
    },
    onFoundWorlds(backupId, worlds) {
      const backup = this.backups.find(backup => backup.id === backupId);
      if (backup) {
        // Save the found worlds for this backup, and make it reactive
        this.$set(backup, "worlds", worlds);
      }
    },
    sortCycleIcon(sort) {
      const afterAlpha = this.managingGames ? "time" : "saves";
      switch (sort) {
        case "alpha":
          return this.sortIcon[afterAlpha];
        case "time":
          return this.sortIcon["saves"];
        case "saves":
          return this.sortIcon["alpha"];
      }
    },
    onCycleGameSort() {
      const afterAlpha = this.managingGames ? "time" : "saves";
      switch (this.gameSort) {
        case "alpha":
          this.gameSort = afterAlpha;
          break;
        case "time":
          this.gameSort = "saves";
          break;
        case "saves":
          this.gameSort = "alpha";
          break;
      }
    }
  },
  async created() {
    // List of game titles, sorted alphabetically
    this.games = this.initialGames.sort((a, b) => a.title.localeCompare(b.title));
    this.savePointsInfo = this.initialSavePointsInfo;
    await this.loadBackups();
    // Auto open save points tab
    if (/^#games(?:\/|$)/.test(window.location.hash)) {
      this.tab = 1;
      const prefix = "#games/";
      if (window.location.hash.length >= prefix.length) {
        const world = window.location.hash.slice(prefix.length).trim();
        if (!world) {
          this.setHash(prefix);
        } else {
          const sel = this.games.find(g => g.world === world);
          this.selectedGame = sel ? sel.world : "";
          if (!this.selectedGame) {
            this.setHash("games");
          }
        }
      }
    } else {
      this.setHash();
    }
    this.extraSmallScreen = window.screen.width < 576;
    window.addEventListener("resize", () => this.extraSmallScreen = window.screen.width < 576);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ButtonWithTooltip"] = Vue.component(
                    "ButtonWithTooltip",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span v-b-tooltip.hover=\"tooltip\"> <b-button :size=\"size\" :disabled=\"disabled\" :variant=\"variant\" :aria-label=\"tooltip\" tabindex=\"0\" @click.stop=\"onActivate\" @keydown=\"onActivate\" > <i v-if=\"icon\" :class=\"icon\" aria-role=\"presentation\"></i> <slot v-if=\"showLabel\" /> </b-button> </span>",
  props: {
    /**
     * Text displayed when a non-disabled button is hovered upon.
     */
    tooltip: {
      default: "",
      type: String
    },
    /**
     * The button's size, passed through to b-button.
     */
    size: {
      default: "",
      type: String,
      validator: value => ["", "sm", "md", "lg"].includes(value)
    },
    /**
     * The button's variant, passed through to b-button.
     */
    variant: {
      default: "",
      type: String,
      validator: value => ["", "primary", "secondary", "success", "danger", "warning", "info", "light", "dark"].includes(value)
    },
    /**
     * An optional FontAwesome icon for this button.
     *
     * If the icon is present, it *must* provide the family of icon
     * (`fa`, `fas`, etc) and the specific icon to be used.
     */
    icon: {
      default: "",
      type: String,
      validator: value => {
        if (value === "") {
          return true;
        }
        if (!value.startsWith("fa")) {
          return false;
        }
        const iconParts = value.split(" ");
        if (iconParts.length !== 2) {
          return false;
        }
        return true;
      }
    },
    /**
     * Is the underlying b-button disabled? Passed along to b-button.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Determines whether the button label should be displayed alongside the button icon.
     * @type {boolean}
     * @default true
     */
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    /**
     * Bubble a click event to this component's parent.
     * @param {Event} e - The original event to bubble. This can be either a
     * keydown or a click, but for the sake of compatibility with most buttons
     * on the site, we're dispatching a `click` event from here.
     * @emits ButtonWithTooltip#click
     */
    onActivate(e) {
      if (e instanceof KeyboardEvent) {
        if (e.key !== " " && e.key !== "Enter") {
          return false;
        }
      }
      this.$emit("click", e);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CheckboxSwitch"] = Vue.component(
                    "CheckboxSwitch",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"d-flex forge-custom-switch custom-switch pl-0\" :class=\"classes\"> <b-form-checkbox :id=\"uid\" v-model=\"checked\" switch :size=\"size\" :name=\"name\" :disabled=\"disabled\" ></b-form-checkbox> <label :id=\"`forge-switch-label-${_uid}`\" :for=\"uid\" class=\"custom-control-label flex-grow-1\"><slot></slot></label> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: "label[id^=\"forge-switch-label-\"]::before, label[id^=\"forge-switch-label-\"]::after { display: none; } .forge-custom-switch.forge-custom-switch-right > .custom-switch { order: 1; }"
    });
  },
  props: {
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    alignRight: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    classes() {
      const c = [];
      if (this.size !== "md") {
        c.push(`b-custom-control-${this.size}`);
      }
      if (this.alignRight) {
        c.push("forge-custom-switch-right");
      }
      return c.join(" ");
    },
    uid() {
      return this.id || `forge-switch-${this._uid}`;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CollapsibleSidePanel"] = Vue.component(
                    "CollapsibleSidePanel",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-row class=\"collapse-container p-0 m-0 w-100\" :class=\"containerClass\"> <b-col class=\"collapse-sidebar flex-grow-0 p-0\" :style=\"sidebarStyle\"> <!-- Sidebar panel --> <div class=\"w-100 h-100\"> <!-- Sidebar expanded content --> <div class=\"sidebar-panel h-100\" :style=\"panelStyle\" @collapse=\"handleCollapse\"> <div class=\"sidebar-panel-inner\" :style=\"panelInnerStyle\"> <slot name=\"panel\"></slot> </div> </div> <!-- Sidebar collapsed content --> <div class=\"sidebar-panel-collapsed position-absolute h-100\" style=\"display: none\" @collapse=\"handleCollapse\"> <b-card body-class=\"p-2\"> <slot name=\"collapsed\"></slot> </b-card> </div> </div> </b-col> <!-- Main content --> <b-col class=\"collapse-body-container p-0\"> <div class=\"collapse-body p-0 h-100\"> <slot></slot> </div> </b-col> </b-row>",
  beforeCreate() {
    Utils.loadCss({
      content: ".collapse-container { flex-wrap: nowrap; } .collapse-container .collapse-sidebar, .collapse-container .collapse-sidebar .sidebar-panel, .collapse-container .collapse-sidebar .sidebar-panel-collapsed { -webkit-transition: all 0.5s ease-in; transition: all 0.5s ease-in; display: flex; } .collapse-container .collapse-sidebar { z-index: 9; height: 100%; } .collapse-container .collapse-sidebar .sidebar-panel-collapsed { width: 0px; min-width: 0px; max-width: 0px; flex: 0 0 0px; overflow: hidden; display: flex !important; top: 0px; } .collapse-container.collapsed .collapse-sidebar .sidebar-panel-collapsed { width: 60px; min-width: 60px; max-width: 60px; flex: 0 0 60px; } .collapse-container .collapse-sidebar .sidebar-panel-collapsed button { padding: 6px; width: 42px !important; } .collapse-container .collapse-sidebar .sidebar-panel-collapsed #warning-details .btn { width: 42px !important; height: 42px !important; padding: 8px; } .collapse-container .collapse-body-container { flex: 1 1 auto; overflow: hidden; } .collapse-container .collapse-body { min-width: 400px; }"
    });
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    overlap: {
      type: Boolean,
      default: false
    },
    panelWidth: {
      type: String,
      default: "300px"
    }
  },
  data() {
    return {
      expanding: false
    };
  },
  watch: {
    value() {
      this.expanding = true;
    }
  },
  computed: {
    collapsed: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    containerClass() {
      return this.collapsed ? "collapsed" : "expanded";
    },
    sidebarStyle() {
      let width = this.overlap ? "60px" : this.panelWidth;
      if (this.collapsed) {
        width = this.$slots.collapsed ? "60px" : "0px";
      }
      return {
        width: width,
        minWidth: width,
        flex: "0 0 " + width
      };
    },
    panelStyle() {
      return {
        width: this.collapsed ? "0px" : this.panelWidth,
        minWidth: this.collapsed ? "0px" : `${this.panelWidth} !important`,
        flex: "0 0 " + this.collapsed ? "0px" : this.panelWidth,
        overflow: this.collapsed || this.expanding ? "hidden" : "visible"
      };
    },
    panelInnerStyle() {
      return {
        width: this.panelWidth,
        minWidth: this.panelWidth,
        flex: "0 0 " + this.panelWidth
      };
    }
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    handleCollapse(value) {
      if (typeof value === "boolean") {
        this.collapsed = !value;
      } else {
        this.toggleCollapsed();
      }
    }
  },
  mounted() {
    $(".sidebar-panel").off("transitionend").on("transitionend", () => {
      this.expanding = false;
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ConfirmDeleteWithCode"] = Vue.component(
                    "ConfirmDeleteWithCode",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"md\" :title=\"getTitle\" @ok=\"queryOk\" @hidden=\"visible = false\" @shown=\"userCode = null\" > <slot> <div> <i18n :path=\"t('Please confirm the deletion of {{what}} by entering the following code below.', { what })\" ></i18n> </div> <b-alert show variant=\"primary\" class=\"mt-2 mb-2\"> <b>{{ name }}:</b> {{ code }} </b-alert> <div v-if=\"followUp\" class=\"mb-2 font-italic\"> {{ followUp }} </div> </slot> <b-form-input v-model=\"userCode\" autofocus trim class=\"w-100\" :placeholder=\"getPlaceholder\" @keyup=\"queryKeyUp\" ></b-form-input> <template #modal-footer=\"{ ok, cancel }\"> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <b-button variant=\"danger\" :disabled=\"userCode !== code\" @click=\"ok\"> {{ verb }} {{ name }} </b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    name: String,
    what: String,
    code: String,
    placeholder: String,
    followUp: String,
    title: String,
    verb: {
      type: String,
      default: t("Delete")
    }
  },
  data() {
    return {
      userCode: null
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    getTitle() {
      return this.title || `${this.verb} ${this.name}`;
    },
    getPlaceholder() {
      return this.placeholder || t(`Enter deletion code: {{code}}`, {
        code: this.code
      });
    }
  },
  methods: {
    queryKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.queryOk();
        this.visible = false;
      }
    },
    queryOk() {
      if (this.userCode === this.code) {
        this.$emit("delete", this.code);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ConfirmMessage"] = Vue.component(
                    "ConfirmMessage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" :title=\"title\" size=\"lg\" :no-close-on-backdrop=\"noCloseOnBackdrop\" :no-close-on-esc=\"noCloseOnEsc\" @ok=\"emitOk\" @cancel=\"emitCancel\" @hidden=\"hide\" > <b-row align-v=\"start\"> <b-col md=\"auto\"> <i class=\"confirm-message-icon fas\" :class=\"iconClass\"></i> </b-col> <b-col> <slot></slot> </b-col> </b-row> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".confirm-message-icon { font-size: 70px; }"
    });
  },
  props: {
    value: Boolean,
    title: String,
    variant: {
      type: String,
      default: "warning"
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    },
    cancelOnEsc: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    iconClass() {
      switch (this.variant) {
        case "error":
          return "fa-times-circle text-danger";
        case "danger":
          return "fa-exclamation-triangle text-danger";
        case "warning":
          return "fa-exclamation-triangle text-warning";
        case "info":
          return "fa-info-circle text-info";
        case "question":
          return "fa-question-circle text-primary";
      }
    }
  },
  methods: {
    emitOk(ev) {
      this.$emit("ok", ev);
    },
    emitCancel(ev) {
      this.$emit("cancel", ev);
    },
    hide() {
      if (this.cancelOnEsc) {
        this.emitCancel();
      }
      this.visible = false;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ConfirmMessageWithInputs"] = Vue.component(
                    "ConfirmMessageWithInputs",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal body-class=\"confirm-inputs\" :visible=\"visible\" :title=\"title\" size=\"lg\" @cancel=\"$emit('cancel', $event)\" @hidden=\"visible = false\" > <b-row align-v=\"start\"> <b-col md=\"auto\"> <i class=\"confirm-message-icon fas\" :class=\"iconClass\"></i> </b-col> <b-col> <b-form :id=\"uid\" @submit.prevent=\"$emit('validate-submission', $event)\"> <slot></slot> </b-form> </b-col> </b-row> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"secondary\" @click=\"cancel()\">{{ t(\"Cancel\") }}</b-button> <b-button variant=\"primary\" type=\"submit\" :form=\"uid\" :disabled=\"!valid\">{{ t(\"OK\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".confirm-inputs input { margin-bottom: 1rem; } .confirm-inputs .confirm-message-icon { font-size: 70px; }"
    });
  },
  props: {
    value: Boolean,
    title: String,
    variant: {
      type: String,
      default: "warning"
    },
    valid: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // Strong per page/input unique ids to avoid input id conflicts
      uid: `confirmation-uid-${Math.random().toString(36).slice(2)}-${Date.now()}`
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    iconClass() {
      switch (this.variant) {
        case "error":
          return "fa-times-circle text-danger";
        case "danger":
          return "fa-exclamation-triangle text-danger";
        case "warning":
          return "fa-exclamation-triangle text-warning";
        case "info":
          return "fa-info-circle text-info";
        case "question":
          return "fa-question-circle text-primary";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CountrySelect"] = Vue.component(
                    "CountrySelect",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<select v-model=\"country\" class=\"form-control\" :name=\"name\" data-live-search=\"true\" :data-live-search-placeholder=\"t('Search…')\" data-live-search-normalize=\"true\" :title=\"title\" autocomplete=\"billing country\" > <option v-for=\"country in countries\" :key=\"country.code\" :value=\"country.code\" :data-tokens=\"country.code\" :data-content=\"toHtml(country)\" v-html=\"toHtml(country)\" ></option> </select>",
  props: {
    name: {
      type: String,
      default: "country"
    },
    title: {
      type: String,
      default: t("Select Country")
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      countries: [{
        code: "AF",
        name: t(`Afghanistan`)
      }, {
        code: "AX",
        name: t(`Åland Islands`)
      }, {
        code: "AL",
        name: t(`Albania`)
      }, {
        code: "DZ",
        name: t(`Algeria`)
      }, {
        code: "AS",
        name: t(`American Samoa`)
      }, {
        code: "AD",
        name: t(`Andorra`)
      }, {
        code: "AO",
        name: t(`Angola`)
      }, {
        code: "AI",
        name: t(`Anguilla`)
      }, {
        code: "AQ",
        name: t(`Antarctica`)
      }, {
        code: "AG",
        name: t(`Antigua and Barbuda`)
      }, {
        code: "AR",
        name: t(`Argentina`)
      }, {
        code: "AM",
        name: t(`Armenia`)
      }, {
        code: "AW",
        name: t(`Aruba`)
      }, {
        code: "AU",
        name: t(`Australia`)
      }, {
        code: "AT",
        name: t(`Austria`)
      }, {
        code: "AZ",
        name: t(`Azerbaijan`)
      }, {
        code: "BS",
        name: t(`Bahamas`)
      }, {
        code: "BH",
        name: t(`Bahrain`)
      }, {
        code: "BD",
        name: t(`Bangladesh`)
      }, {
        code: "BB",
        name: t(`Barbados`)
      }, {
        code: "BY",
        name: t(`Belarus`)
      }, {
        code: "BE",
        name: t(`Belgium`)
      }, {
        code: "BZ",
        name: t(`Belize`)
      }, {
        code: "BJ",
        name: t(`Benin`)
      }, {
        code: "BM",
        name: t(`Bermuda`)
      }, {
        code: "BT",
        name: t(`Bhutan`)
      }, {
        code: "BO",
        name: t(`Bolivia, Plurinational State of`)
      }, {
        code: "BQ",
        name: t(`Bonaire, Sint Eustatius and Saba`)
      }, {
        code: "BA",
        name: t(`Bosnia and Herzegovina`)
      }, {
        code: "BW",
        name: t(`Botswana`)
      }, {
        code: "BV",
        name: t(`Bouvet Island`)
      }, {
        code: "BR",
        name: t(`Brazil`)
      }, {
        code: "IO",
        name: t(`British Indian Ocean Territory`)
      }, {
        code: "BN",
        name: t(`Brunei Darussalam`)
      }, {
        code: "BG",
        name: t(`Bulgaria`)
      }, {
        code: "BF",
        name: t(`Burkina Faso`)
      }, {
        code: "BI",
        name: t(`Burundi`)
      }, {
        code: "KH",
        name: t(`Cambodia`)
      }, {
        code: "CM",
        name: t(`Cameroon`)
      }, {
        code: "CA",
        name: t(`Canada`)
      }, {
        code: "CV",
        name: t(`Cape Verde`)
      }, {
        code: "KY",
        name: t(`Cayman Islands`)
      }, {
        code: "CF",
        name: t(`Central African Republic`)
      }, {
        code: "TD",
        name: t(`Chad`)
      }, {
        code: "CL",
        name: t(`Chile`)
      }, {
        code: "CN",
        name: t(`China`)
      }, {
        code: "CX",
        name: t(`Christmas Island`)
      }, {
        code: "CC",
        name: t(`Cocos (Keeling) Islands`)
      }, {
        code: "CO",
        name: t(`Colombia`)
      }, {
        code: "KM",
        name: t(`Comoros`)
      }, {
        code: "CG",
        name: t(`Congo`)
      }, {
        code: "CD",
        name: t(`Congo, the Democratic Republic of the`)
      }, {
        code: "CK",
        name: t(`Cook Islands`)
      }, {
        code: "CR",
        name: t(`Costa Rica`)
      }, {
        code: "CI",
        name: t(`Côte d'Ivoire`)
      }, {
        code: "HR",
        name: t(`Croatia`)
      }, {
        code: "CU",
        name: t(`Cuba`)
      }, {
        code: "CW",
        name: t(`Curaçao`)
      }, {
        code: "CY",
        name: t(`Cyprus`)
      }, {
        code: "CZ",
        name: t(`Czech Republic`)
      }, {
        code: "DK",
        name: t(`Denmark`)
      }, {
        code: "DJ",
        name: t(`Djibouti`)
      }, {
        code: "DM",
        name: t(`Dominica`)
      }, {
        code: "DO",
        name: t(`Dominican Republic`)
      }, {
        code: "EC",
        name: t(`Ecuador`)
      }, {
        code: "EG",
        name: t(`Egypt`)
      }, {
        code: "SV",
        name: t(`El Salvador`)
      }, {
        code: "GQ",
        name: t(`Equatorial Guinea`)
      }, {
        code: "ER",
        name: t(`Eritrea`)
      }, {
        code: "EE",
        name: t(`Estonia`)
      }, {
        code: "ET",
        name: t(`Ethiopia`)
      }, {
        code: "FK",
        name: t(`Falkland Islands (Malvinas)`)
      }, {
        code: "FO",
        name: t(`Faroe Islands`)
      }, {
        code: "FJ",
        name: t(`Fiji`)
      }, {
        code: "FI",
        name: t(`Finland`)
      }, {
        code: "FR",
        name: t(`France`)
      }, {
        code: "GF",
        name: t(`French Guiana`)
      }, {
        code: "PF",
        name: t(`French Polynesia`)
      }, {
        code: "TF",
        name: t(`French Southern Territories`)
      }, {
        code: "GA",
        name: t(`Gabon`)
      }, {
        code: "GM",
        name: t(`Gambia`)
      }, {
        code: "GE",
        name: t(`Georgia`)
      }, {
        code: "DE",
        name: t(`Germany`)
      }, {
        code: "GH",
        name: t(`Ghana`)
      }, {
        code: "GI",
        name: t(`Gibraltar`)
      }, {
        code: "GR",
        name: t(`Greece`)
      }, {
        code: "GL",
        name: t(`Greenland`)
      }, {
        code: "GD",
        name: t(`Grenada`)
      }, {
        code: "GP",
        name: t(`Guadeloupe`)
      }, {
        code: "GU",
        name: t(`Guam`)
      }, {
        code: "GT",
        name: t(`Guatemala`)
      }, {
        code: "GG",
        name: t(`Guernsey`)
      }, {
        code: "GN",
        name: t(`Guinea`)
      }, {
        code: "GW",
        name: t(`Guinea-Bissau`)
      }, {
        code: "GY",
        name: t(`Guyana`)
      }, {
        code: "HT",
        name: t(`Haiti`)
      }, {
        code: "HM",
        name: t(`Heard Island and McDonald Islands`)
      }, {
        code: "VA",
        name: t(`Holy See (Vatican City State)`)
      }, {
        code: "HN",
        name: t(`Honduras`)
      }, {
        code: "HK",
        name: t(`Hong Kong`)
      }, {
        code: "HU",
        name: t(`Hungary`)
      }, {
        code: "IS",
        name: t(`Iceland`)
      }, {
        code: "IN",
        name: t(`India`)
      }, {
        code: "ID",
        name: t(`Indonesia`)
      }, {
        code: "IR",
        name: t(`Iran, Islamic Republic of`)
      }, {
        code: "IQ",
        name: t(`Iraq`)
      }, {
        code: "IE",
        name: t(`Ireland`)
      }, {
        code: "IM",
        name: t(`Isle of Man`)
      }, {
        code: "IL",
        name: t(`Israel`)
      }, {
        code: "IT",
        name: t(`Italy`)
      }, {
        code: "JM",
        name: t(`Jamaica`)
      }, {
        code: "JP",
        name: t(`Japan`)
      }, {
        code: "JE",
        name: t(`Jersey`)
      }, {
        code: "JO",
        name: t(`Jordan`)
      }, {
        code: "KZ",
        name: t(`Kazakhstan`)
      }, {
        code: "KE",
        name: t(`Kenya`)
      }, {
        code: "KI",
        name: t(`Kiribati`)
      }, {
        code: "KP",
        name: t(`Korea, Democratic People's Republic of`)
      }, {
        code: "KR",
        name: t(`Korea, Republic of`)
      }, {
        code: "KW",
        name: t(`Kuwait`)
      }, {
        code: "KG",
        name: t(`Kyrgyzstan`)
      }, {
        code: "LA",
        name: t(`Lao People's Democratic Republic`)
      }, {
        code: "LV",
        name: t(`Latvia`)
      }, {
        code: "LB",
        name: t(`Lebanon`)
      }, {
        code: "LS",
        name: t(`Lesotho`)
      }, {
        code: "LR",
        name: t(`Liberia`)
      }, {
        code: "LY",
        name: t(`Libya`)
      }, {
        code: "LI",
        name: t(`Liechtenstein`)
      }, {
        code: "LT",
        name: t(`Lithuania`)
      }, {
        code: "LU",
        name: t(`Luxembourg`)
      }, {
        code: "MO",
        name: t(`Macao`)
      }, {
        code: "MK",
        name: t(`Macedonia, the former Yugoslav Republic of`)
      }, {
        code: "MG",
        name: t(`Madagascar`)
      }, {
        code: "MW",
        name: t(`Malawi`)
      }, {
        code: "MY",
        name: t(`Malaysia`)
      }, {
        code: "MV",
        name: t(`Maldives`)
      }, {
        code: "ML",
        name: t(`Mali`)
      }, {
        code: "MT",
        name: t(`Malta`)
      }, {
        code: "MH",
        name: t(`Marshall Islands`)
      }, {
        code: "MQ",
        name: t(`Martinique`)
      }, {
        code: "MR",
        name: t(`Mauritania`)
      }, {
        code: "MU",
        name: t(`Mauritius`)
      }, {
        code: "YT",
        name: t(`Mayotte`)
      }, {
        code: "MX",
        name: t(`Mexico`)
      }, {
        code: "FM",
        name: t(`Micronesia, Federated States of`)
      }, {
        code: "MD",
        name: t(`Moldova, Republic of`)
      }, {
        code: "MC",
        name: t(`Monaco`)
      }, {
        code: "MN",
        name: t(`Mongolia`)
      }, {
        code: "ME",
        name: t(`Montenegro`)
      }, {
        code: "MS",
        name: t(`Montserrat`)
      }, {
        code: "MA",
        name: t(`Morocco`)
      }, {
        code: "MZ",
        name: t(`Mozambique`)
      }, {
        code: "MM",
        name: t(`Myanmar`)
      }, {
        code: "NA",
        name: t(`Namibia`)
      }, {
        code: "NR",
        name: t(`Nauru`)
      }, {
        code: "NP",
        name: t(`Nepal`)
      }, {
        code: "NL",
        name: t(`Netherlands`)
      }, {
        code: "NC",
        name: t(`New Caledonia`)
      }, {
        code: "NZ",
        name: t(`New Zealand`)
      }, {
        code: "NI",
        name: t(`Nicaragua`)
      }, {
        code: "NE",
        name: t(`Niger`)
      }, {
        code: "NG",
        name: t(`Nigeria`)
      }, {
        code: "NU",
        name: t(`Niue`)
      }, {
        code: "NF",
        name: t(`Norfolk Island`)
      }, {
        code: "MP",
        name: t(`Northern Mariana Islands`)
      }, {
        code: "NO",
        name: t(`Norway`)
      }, {
        code: "OM",
        name: t(`Oman`)
      }, {
        code: "PK",
        name: t(`Pakistan`)
      }, {
        code: "PW",
        name: t(`Palau`)
      }, {
        code: "PS",
        name: t(`Palestinian Territory, Occupied`)
      }, {
        code: "PA",
        name: t(`Panama`)
      }, {
        code: "PG",
        name: t(`Papua New Guinea`)
      }, {
        code: "PY",
        name: t(`Paraguay`)
      }, {
        code: "PE",
        name: t(`Peru`)
      }, {
        code: "PH",
        name: t(`Philippines`)
      }, {
        code: "PN",
        name: t(`Pitcairn`)
      }, {
        code: "PL",
        name: t(`Poland`)
      }, {
        code: "PT",
        name: t(`Portugal`)
      }, {
        code: "PR",
        name: t(`Puerto Rico`)
      }, {
        code: "QA",
        name: t(`Qatar`)
      }, {
        code: "RE",
        name: t(`Réunion`)
      }, {
        code: "RO",
        name: t(`Romania`)
      }, {
        code: "RU",
        name: t(`Russian Federation`)
      }, {
        code: "RW",
        name: t(`Rwanda`)
      }, {
        code: "BL",
        name: t(`Saint Barthélemy`)
      }, {
        code: "SH",
        name: t(`Saint Helena, Ascension and Tristan da Cunha`)
      }, {
        code: "KN",
        name: t(`Saint Kitts and Nevis`)
      }, {
        code: "LC",
        name: t(`Saint Lucia`)
      }, {
        code: "MF",
        name: t(`Saint Martin (French part)`)
      }, {
        code: "PM",
        name: t(`Saint Pierre and Miquelon`)
      }, {
        code: "VC",
        name: t(`Saint Vincent and the Grenadines`)
      }, {
        code: "WS",
        name: t(`Samoa`)
      }, {
        code: "SM",
        name: t(`San Marino`)
      }, {
        code: "ST",
        name: t(`Sao Tome and Principe`)
      }, {
        code: "SA",
        name: t(`Saudi Arabia`)
      }, {
        code: "SN",
        name: t(`Senegal`)
      }, {
        code: "RS",
        name: t(`Serbia`)
      }, {
        code: "SC",
        name: t(`Seychelles`)
      }, {
        code: "SL",
        name: t(`Sierra Leone`)
      }, {
        code: "SG",
        name: t(`Singapore`)
      }, {
        code: "SX",
        name: t(`Sint Maarten (Dutch part)`)
      }, {
        code: "SK",
        name: t(`Slovakia`)
      }, {
        code: "SI",
        name: t(`Slovenia`)
      }, {
        code: "SB",
        name: t(`Solomon Islands`)
      }, {
        code: "SO",
        name: t(`Somalia`)
      }, {
        code: "ZA",
        name: t(`South Africa`)
      }, {
        code: "GS",
        name: t(`South Georgia and the South Sandwich Islands`)
      }, {
        code: "SS",
        name: t(`South Sudan`)
      }, {
        code: "ES",
        name: t(`Spain`)
      }, {
        code: "LK",
        name: t(`Sri Lanka`)
      }, {
        code: "SD",
        name: t(`Sudan`)
      }, {
        code: "SR",
        name: t(`Suriname`)
      }, {
        code: "SJ",
        name: t(`Svalbard and Jan Mayen`)
      }, {
        code: "SZ",
        name: t(`Swaziland`)
      }, {
        code: "SE",
        name: t(`Sweden`)
      }, {
        code: "CH",
        name: t(`Switzerland`)
      }, {
        code: "SY",
        name: t(`Syrian Arab Republic`)
      }, {
        code: "TW",
        name: t(`Taiwan, Province of China`)
      }, {
        code: "TJ",
        name: t(`Tajikistan`)
      }, {
        code: "TZ",
        name: t(`Tanzania, United Republic of`)
      }, {
        code: "TH",
        name: t(`Thailand`)
      }, {
        code: "TL",
        name: t(`Timor-Leste`)
      }, {
        code: "TG",
        name: t(`Togo`)
      }, {
        code: "TK",
        name: t(`Tokelau`)
      }, {
        code: "TO",
        name: t(`Tonga`)
      }, {
        code: "TT",
        name: t(`Trinidad and Tobago`)
      }, {
        code: "TN",
        name: t(`Tunisia`)
      }, {
        code: "TR",
        name: t(`Turkey`)
      }, {
        code: "TM",
        name: t(`Turkmenistan`)
      }, {
        code: "TC",
        name: t(`Turks and Caicos Islands`)
      }, {
        code: "TV",
        name: t(`Tuvalu`)
      }, {
        code: "UG",
        name: t(`Uganda`)
      }, {
        code: "UA",
        name: t(`Ukraine`)
      }, {
        code: "AE",
        name: t(`United Arab Emirates`)
      }, {
        code: "GB",
        name: t(`United Kingdom`)
      }, {
        code: "US",
        name: t(`United States`)
      }, {
        code: "UM",
        name: t(`United States Minor Outlying Islands`)
      }, {
        code: "UY",
        name: t(`Uruguay`)
      }, {
        code: "UZ",
        name: t(`Uzbekistan`)
      }, {
        code: "VU",
        name: t(`Vanuatu`)
      }, {
        code: "VE",
        name: t(`Venezuela, Bolivarian Republic of`)
      }, {
        code: "VN",
        name: t(`Viet Nam`)
      }, {
        code: "VG",
        name: t(`Virgin Islands, British`)
      }, {
        code: "VI",
        name: t(`Virgin Islands, U.S.`)
      }, {
        code: "WF",
        name: t(`Wallis and Futuna`)
      }, {
        code: "EH",
        name: t(`Western Sahara`)
      }, {
        code: "YE",
        name: t(`Yemen`)
      }, {
        code: "ZM",
        name: t(`Zambia`)
      }, {
        code: "ZW",
        name: t(`Zimbabwe`)
      }]
    };
  },
  computed: {
    country: {
      get() {
        return this.value;
      },
      set(value) {
        $(this.$el).selectpicker("val", value);
        this.$emit("input", value);
      }
    }
  },
  methods: {
    toHtml(country) {
      return `<i class="${country.code.toLowerCase()} flag"></i>${country.name}`;
    }
  },
  mounted() {
    $(this.$el).selectpicker("val", this.country);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Drag"] = Vue.component(
                    "Drag",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// From https://github.com/cameronhimself/vue-drag-drop/
var _default = exports.default = {
  template: "<component :is=\"tag\" :draggable=\"draggable\" @click=\"$emit('click', $event)\" @mousedown=\"$emit('mousedown', $event)\" @mouseup=\"$emit('mouseup', $event)\" @mouseover=\"$emit('mouseover', $event)\" @mouseleave=\"$emit('mouseleave', $event)\" @drag=\"emitEvent('drag', $event)\" @dragstart=\"emitEvent('dragstart', $event)\" @dragenter=\"emitEvent('dragenter', $event)\" @dragleave=\"emitEvent('dragleave', $event)\" @dragend=\"emitEvent('dragend', $event)\" > <slot :transfer-data=\"scopedData\"></slot> <div ref=\"image\" :style=\"hideImageStyle\"> <slot name=\"image\" :transfer-data=\"scopedData\"></slot> </div> </component>",
  props: {
    draggable: {
      type: Boolean,
      default: true
    },
    transferData: {},
    dropEffect: {
      validator: value => ["copy", "move", "link", "none"].includes(value)
    },
    effectAllowed: {
      validator: value => ["none", "copy", "copyLink", "copyMove", "link", "linkMove", "move", "all", "uninitialized"].includes(value)
    },
    image: String,
    imageXOffset: {
      type: Number,
      default: 0
    },
    imageYOffset: {
      type: Number,
      default: 0
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      dragging: false
    };
  },
  computed: {
    scopedData() {
      return this.dragging && this.transferData;
    },
    hideImageStyle: () => ({
      position: "fixed",
      top: "-1000px"
    })
  },
  methods: {
    emitEvent(name, nativeEvent) {
      const transfer = nativeEvent.dataTransfer;
      // A number of things need to happen on drag start
      if (name === "dragstart") {
        // Set the drop effect and allowed effects
        if (this.effectAllowed) {
          transfer.effectAllowed = this.effectAllowed;
        }
        if (this.dropEffect) {
          transfer.dropEffect = this.dropEffect;
        }
        // Set the drag image
        if (this.image || this.$slots.image) {
          let image;
          if (this.image) {
            image = new Image();
            image.src = this.image;
          } else if (this.$slots.image) {
            image = this.$refs.image;
          }
          if (transfer.setDragImage) {
            transfer.setDragImage(image, this.imageXOffset, this.imageYOffset);
          }
        }
        // Indicate that we're dragging.
        this.dragging = true;
      }
      // At last, emit the event.
      this.$emit("drag", {
        name,
        nativeEvent
      });
      // Clean up stored data on drag end after emitting.
      if (name === "dragend") {
        this.dragging = false;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Drop"] = Vue.component(
                    "Drop",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<component :is=\"tag\" @dragenter=\"emitEvent('dragenter', $event)\" @dragleave=\"emitEvent('dragleave', $event)\" @dragover.prevent.stop=\"emitEvent('dragover', $event)\" @drop.prevent.stop=\"emitEvent('drop', $event)\" > <slot></slot> <slot name=\"overlay\" :is-dragging=\"dragging\" :is-over=\"isDraggingOver\"> <b-overlay :show=\"dragging\" rounded=\"sm\" :opacity=\"overlayOpacity\" no-wrap> <template #overlay> <div class=\"text-center text-secondary\"> <span :class=\"isDraggingOver ? 'text-success' : ''\" :style=\"`font-size: ${iconSize}; opacity: ${iconOpacity}`\" > <i class=\"fas fa-angle-double-down\"></i> </span> </div> </template> </b-overlay> </slot> </component>",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    dragging: false,
    iconSize: {
      type: String,
      default: "2.4rem"
    },
    overlayOpacity: {
      type: Number,
      default: 0.8
    },
    iconOpacity: {
      type: Number,
      default: 1.0
    }
  },
  data() {
    return {
      isDraggingOver: false,
      insideElements: new Set()
    };
  },
  methods: {
    emitEvent(name, nativeEvent) {
      this.$emit("drop", {
        name,
        nativeEvent
      });
      /**
       * After emitting the event, we need to determine if we're still
       * dragging inside this Drop. We keep a Set of all elements that we've
       * dragged into, then clear the data if that set is empty.
       */
      if (name === "dragenter") {
        this.insideElements.add(nativeEvent.target);
      }
      if (name === "dragleave") {
        this.insideElements.delete(nativeEvent.target);
      }

      // A drop resets everything.
      if (name === "drop") {
        this.insideElements.clear();
      }
      // Finally, since Vue can't react to Set changes, set a flag indicating drag status.
      this.isDraggingOver = Boolean(this.insideElements.size);
      this.$emit("over", this.isDraggingOver);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["EditableInput"] = Vue.component(
                    "EditableInput",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-form class=\"editable-input\" :class=\"`${formClass} w-100`\" inline @submit.stop.prevent=\"onSubmit\"> <b-input-group class=\"w-100\"> <b-form-input ref=\"editor\" :value=\"value\" :disabled=\"disabled || !editable\" :state=\"state\" :formatter=\"applyMaxLength\" @focus.native=\"onFocus\" @keydown.escape.stop.prevent=\"onCancel\" @input=\"onInput\" ></b-form-input> <template v-if=\"processing || (editable && editMode)\" #append> <b-button v-if=\"editable && editMode\" v-b-tooltip.hover.top variant=\"success\" :disabled=\"disabled\" :title=\"t('Save Changes')\" @click=\"onSubmit\" > <i class=\"fas fa-check-circle\"></i> </b-button> <b-button v-if=\"editable && editMode\" v-b-tooltip.hover.top variant=\"danger\" :disabled=\"disabled\" :title=\"t('Discard changes')\" @click=\"onCancel\" > <i class=\"fas fa-times-circle\"></i> </b-button> <b-button v-if=\"processing\" :disabled=\"true\"> <loading-indicator tag=\"span\" small :label=\"t('Saving…')\"></loading-indicator> </b-button> </template> </b-input-group> </b-form>",
  beforeCreate() {
    Utils.loadCss({
      content: "form.editable-input { position: relative; } form.editable-input.validated input { /* The additional padding while validating looks nice, but breaks layouts like it's nobody's business */ padding-right: inherit !important; } form.editable-input:not(.validated, .disabled):hover::after { position: absolute; right: 0.75rem; font-weight: 900; font-family: \"Font Awesome 5 Free\"; content: \"\\f303\"; /* Double backslash because our compiler is stupid */ opacity: 75%; pointer-events: none; }"
    });
  },
  props: {
    id: String,
    value: String,
    disabled: Boolean,
    editable: Boolean,
    processing: Boolean,
    maxlength: {
      type: Number,
      default: 0
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      editMode: false,
      previous: null,
      localValue: ""
    };
  },
  watch: {
    value(newValue) {
      this.previous = newValue;
    }
  },
  computed: {
    formClass() {
      // Note: this only hides the pencil icon to avoid clashing with Bootstrap validation styling.
      //   Bootstrap applies its styling regardless.
      return `${this.state || this.state === false ? "validated" : ""} ${this.disabled ? " disabled" : ""}`;
    }
  },
  methods: {
    onInput(text) {
      this.localValue = text;
    },
    onFocus(event) {
      this.previous = event.target.value;
      this.editMode = this.editable; // Only switch to edit mode if this is editable
    },

    onCancel(event) {
      this.editMode = false;
      this.$refs.editor.localValue = this.previous;
    },
    onSubmit(event) {
      this.editMode = false;
      const newTitle = this.localValue.trim();
      if (this.previous !== newTitle) {
        this.$emit("change", newTitle);
      }
    },
    applyMaxLength(str) {
      if (!this.maxlength) {
        return str;
      }
      return str.slice(0, this.maxlength);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["FilterField"] = Vue.component(
                    "FilterField",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body class=\"border-0 p-0 filter-card w-100\"> <b-card-header v-if=\"header\" :header-bg-variant=\"bgVariant\" class=\"border-bottom rounded-0 px-2 text-center\"> <span v-html=\"header\"></span> <b-link v-if=\"displayClear\" v-b-tooltip.hover class=\"float-right text-secondary mr-2\" :title=\"t('Clear all filters')\" @click=\"clearFilters\" > <i class=\"fas fa-broom\"></i> </b-link> </b-card-header> <b-card-body class=\"border-right border-left p-0 m-0\"> <filter-field-item v-for=\"filter in filterHierarchy\" :key=\"filter.key\" v-model=\"tags\" :field-data=\"filter\" :display-icons=\"displayIcons\" :search-tags=\"searchTags\" v-on=\"$listeners\" ></filter-field-item> </b-card-body> <template #description> <div id=\"tags-description-text\" class=\"mx-2\"> <slot name=\"description\" :v-html=\"description\"></slot> </div> </template> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".filter-card { width: 350px; } .filter-select option:disabled { background: rgba(0, 0, 0, 0.05); } .filter-field-list { background: rgba(0, 0, 0, 0.02); } .filter-field-link i { font-size: 12px; } .filter-field-link.collapsed i.fa-minus, .filter-field-link.not-collapsed i.fa-plus { display: none; } .filter-list-checkbox label { width: 100%; } .filter-tags-list { background: transparent; } .filter-tags-list .filter-tags-item button:focus { outline: none; }"
    });
  },
  props: {
    // The current search tags
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    // The root menu to display
    menu: {
      type: Array,
      default() {
        return [];
      }
    },
    packageList: Array,
    visibilityKey: String,
    // Visibility key used by the search tags to know if a search tag can be shown on this component
    description: String,
    header: {
      type: String,
      default: t("Filters")
    },
    bgVariant: {
      type: String,
      default: ""
    },
    displayClear: {
      type: Boolean,
      default: false
    },
    displayIcons: {
      type: Boolean,
      default: false
    },
    searchTags: Object
  },
  data() {
    return {
      refreshValue: 1
    };
  },
  computed: {
    filterMenu() {
      return {
        options: this.menu
      }; // Need to wrap it in an object with "options" to match how other menu items will look
    },

    tags: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    filterHierarchy() {
      this.refreshValue;
      return this.getFilterHierarchy(this.filterMenu).options;
    }
  },
  methods: {
    refresh() {
      this.refreshValue++;
    },
    isTagVisible(searchTag) {
      if (!searchTag) {
        return false;
      } else if (searchTag.visible === undefined) {
        return true;
      } else if (typeof searchTag.visible === "boolean") {
        return searchTag.visible;
      }
      return searchTag.visible["default"] === true || searchTag.visible["default"] === undefined ? searchTag.visible[this.visibilityKey] !== false : searchTag.visible[this.visibilityKey] === true;
    },
    getLinkedSearchTags(tagKey) {
      return Object.entries(this.searchTags).filter(([key, tag]) => (tag.parent && tag.parent.key) === tagKey && this.isTagVisible(tag)).map(([key, tag]) => Object.assign({
        key
      }, tag));
    },
    getFilterHierarchy(tag, parent) {
      let {
        filter,
        ...data
      } = tag; // Remove the filter function from the tag as we don't need it.

      // Check to see if this search tag is being limited, based on a required tag
      if (data.limit && !data.disabled) {
        data.disabled = !this.tags[data.limit.key] || data.limit.value && !(this.tags[data.limit.key] || []).includes(data.limit.value);
      }
      // If the options are a function, then call the function to get the values
      if (data.options instanceof Function) {
        data.options = data.options();
      }

      // If the type of this search tag is a menu, then find any additional options.
      if (data.type && data.type.includes("menu") && data.parse === true) {
        if (data.options) {
          // Find items from the current options
          data.options = this.convertOptionsToHierarchy(data.options, null, tag, tag);
        } else {
          // If no options have been provided then look through the bazaar tags
          data.options = this.convertOptionsToHierarchy(this.searchTags["tag"].options(), tag.key, {
            key: "tag"
          });
        }
        data.parse = false; // Stop looking for additional options
      }

      // Find any search tags that are linked to this search tag
      if (data.key) {
        const linkedTags = this.getLinkedSearchTags(data.key);
        if (linkedTags && linkedTags.length) {
          data.options = (data.options || []).concat(linkedTags);
        }
      }

      /*
      // This is eventual code for collecting the potential packages data
      if (this.packageList && data.selectable !== false && parent) {
        /// Add this to the tags, and run it through the search again
        const tags = this.addTag(parent.key, data.key);
        const packagesWithFilter = this.searchUtil.search(this.packageList, tags);
        data.remainingPackages = packagesWithFilter.length;
      }
      */

      // Parse the options
      data.options = (data.options || []).map(o => {
        let searchTag = this.searchTags[o.tag];
        if (!searchTag && !parent) {
          return null;
        }
        let option = o;
        if (o.tag) {
          // If this option is a placeholder for a tag, then copy the actual tag information in.
          option = Object.assign({
            key: o.tag
          }, searchTag, o);
          option.visible = this.isTagVisible(searchTag) && o.visible;
        }
        return option;
      })
      // Remove any options that won't show on the list
      .filter(o => !!o && !o.disabled && this.isTagVisible(o))
      // If parsing is allowed, then try and get any hierarchy under this tag
      .map(o => data.parse !== false ? this.getFilterHierarchy(o, tag) : o)
      // Remove any blank entries returned from getting additional hierarchy
      .filter(o => !!o)
      // Sort the options based on sort value, if it has a list, and then by name
      .sort((a, b) => {
        if (a.sort !== b.sort) {
          return a.sort - b.sort;
        }
        if (a.options && b.options) {
          let hasListA = !!a.options.length;
          let hasListB = !!b.options.length;
          if (hasListA !== hasListB) {
            return hasListA ? -1 : 1;
          }
        }
        return (a.name || "").localeCompare(b.name || "");
      });
      if (data.options.length === 0) {
        // Remove this tag entirely if it's a menu checklist with no options (This is used for tags)
        if (data.type && data.type.includes("menu") && data.type.includes("checklist")) {
          return null;
        }
        // Otherwise just remove the options
        delete data.options;
      }
      return data;
    },
    convertOptionsToHierarchy(allOptions, key, root, parent) {
      if (!(allOptions instanceof Array)) {
        return;
      }
      let result = allOptions.filter(o => o.parent === key).map(o => {
        const option = {
          key: o.key || o.name,
          name: o.name,
          useKey: o.useKey || root.key,
          parent: o.parent,
          header: o.selectable === false,
          sort: o.sort,
          options: !parent || parent.parse !== false ? this.convertOptionsToHierarchy(allOptions, o.key, root, o) : null,
          selectable: o.selectable,
          visible: o.visible,
          type: ["menu", "checklist"]
        };

        // Passing an empty option array will cause drop down filters to be changed to optgroups
        // Remove empty option groups
        if (option.options && option.options.length === 0) {
          delete option.options;
        }

        /*
        // This is eventual code for collecting the potential packages data
        if (this.packageList && o.selectable !== false && parent && parent.filter) {
          const packagesWithFilter = this.packageList.filter((p) => parent.filter(p, o.key));
          option.remainingPackages = packagesWithFilter.length;
        }
        */

        return option;
      }).sort((a, b) => {
        if (a.sort !== b.sort) {
          return a.sort - b.sort;
        }
        return (a.name || "").localeCompare(b.name || "");
      });
      return result;
    },
    clearFilters() {
      this.tags = {};
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["FilterFieldItem"] = Vue.component(
                    "FilterFieldItem",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-nav vertical class=\"border-bottom filter-field-nav bg-light\"> <b-nav-text class=\"p-0 w-100\"> <template v-if=\"fieldData.header\"> <b-link v-if=\"!fieldData.open\" v-b-toggle=\"`collapse-${filterKey}`\" class=\"w-100 bg-white d-block text-decoration-none text-primary filter-field-link\" :class=\"filterNameClass()\" > <div class=\"p-2 border-bottom no-select\"> <img v-if=\"fieldData.icon && displayIcons\" class=\"filter-item-image\" :src=\"fieldData.icon\" width=\"20px\" height=\"20px\" /> {{ fieldData.name }} <small v-if=\"fieldData.remainingPackages\" class=\"text-muted remaining-packages\"> ({{ fieldData.remainingPackages }}) </small> <div class=\"float-right mr-1\"> <i class=\"fas fa-plus\"></i> <i class=\"fas fa-minus\"></i> </div> </div> </b-link> <div v-else-if=\"fieldData.name\" class=\"p-2 border-bottom bg-white no-select\" :class=\"filterNameClass()\"> <img v-if=\"fieldData.icon && displayIcons\" class=\"filter-item-image\" :src=\"fieldData.icon\" width=\"20px\" height=\"20px\" /> {{ fieldData.name }} <small v-if=\"fieldData.remainingPackages\" class=\"text-muted remaining-packages\"> ({{ fieldData.remainingPackages }}) </small> </div> </template> <component :is=\"fieldData.open || !fieldData.header ? 'div' : 'b-collapse'\" :id=\"`collapse-${filterKey}`\" v-model=\"expanded[filterKey]\" class=\"filter-field-list\" :class=\"fieldData.name ? 'pt-1' : ''\" :is-nav=\"true\" > <b-form-group class=\"mb-0\"> <b-form-text v-if=\"fieldData.disabled && fieldData.limit\" class=\"mb-2 ml-2\"> {{ t(\"This filter only applies to {limit}\", { limit: filterLimit(fieldData) }) }} </b-form-text> <template v-if=\"filterShowType('menu')\"> <div v-if=\"menuList.length\" class=\"ml-1 mb-1 ml-2 border-left border-top\"> <filter-field-item v-for=\"option in menuList\" :key=\"option.key\" v-model=\"allTags\" :field-data=\"option\" :display-icons=\"displayIcons\" :search-tags=\"searchTags\" v-on=\"$listeners\" ></filter-field-item> </div> </template> <div v-if=\"filterShowType('checklist')\" class=\"filter-field-checklist\"> <div v-for=\"option in checkboxList\" :key=\"option.key\" :class=\"checklistClass(option)\"> <b-row class=\"m-0\"> <b-col md=\"auto\" class=\"p-0 filter-list-checkbox-container\"> <tri-state-checkbox v-if=\"option.tristate\" :id=\"`checkbox-${filterKey}-${option.key}`\" :checked=\"getCheckedValue(option.useKey || filterKey, option.key)\" :value=\"option.key\" class=\"filter-list-tristate\" :disabled=\"fieldData.disabled && !(tags[filterKey] || []).includes(option.key)\" @change=\"changeCheckbox(option.useKey || filterKey, option.key, $event, true)\" ></tri-state-checkbox> <b-form-checkbox v-else :id=\"`checkbox-${filterKey}-${option.key}`\" :checked=\"getCheckedValue(option.useKey || filterKey, option.key)\" class=\"filter-list-checkbox\" :class=\"hasTags(option) ? 'child-selected' : ''\" :disabled=\"fieldData.disabled && !(tags[filterKey] || []).includes(option.key)\" switch @change=\"changeCheckbox(option.useKey || filterKey, option.key, $event)\" > </b-form-checkbox> </b-col> <b-col class=\"pl-0 pr-1 overflow-hidden filter-option-name\"> <b-link v-if=\"hasList(option)\" v-b-toggle=\"`collapse-${filterKey}-${option.key}`\" class=\"w-100 d-block text-decoration-none text-primary filter-field-link\" > <div class=\"px-2 no-select\"> <span :class=\"filterNameClass(option)\"> <img v-if=\"option.icon && displayIcons\" class=\"filter-item-image\" :src=\"option.icon\" width=\"20px\" height=\"20px\" /> {{ option.name }} <small v-if=\"option.remainingPackages\" class=\"text-muted remaining-packages\"> ({{ option.remainingPackages }}) </small> </span> <div class=\"float-right mr-1\"> <i class=\"fas fa-plus\"></i> <i class=\"fas fa-minus\"></i> </div> </div> </b-link> <b-link v-else class=\"w-100 d-block text-decoration-none text-primary filter-field-link\" :disabled=\"fieldData.disabled && !(tags[filterKey] || []).includes(option.key)\" @click.stop=\"clickLink(option.key)\" > <div class=\"px-2 no-select\"> <img v-if=\"option.icon && displayIcons\" class=\"filter-item-image\" :src=\"option.icon\" width=\"20px\" height=\"20px\" /> {{ option.name }} <small v-if=\"option.remainingPackages\" class=\"text-muted remaining-packages\"> ({{ option.remainingPackages }}) </small> </div> </b-link> </b-col> </b-row> <b-collapse v-if=\"hasList(option)\" :id=\"`collapse-${filterKey}-${option.key}`\" v-model=\"expanded[`${option.useKey || filterKey}-${option.key}`]\" class=\"border-right-0 border-top border-left mb-2\" :is-nav=\"true\" > <filter-field-item v-model=\"allTags\" :field-data=\"option\" :display-icons=\"displayIcons\" :search-tags=\"searchTags\" v-on=\"$listeners\" ></filter-field-item> </b-collapse> </div> </div> <template v-if=\"filterShowType('dropdown')\"> <b-form-tags v-model=\"tagList\" class=\"border-0 pt-1 px-2 pb-2 filter-tags-list\" add-on-change no-outer-focus > <template #default=\"{ tags, inputAttrs, inputHandlers, disabled }\"> <ul v-if=\"tags.length\" class=\"list-inline d-inline-block mb-2\"> <li v-for=\"tag in tags\" :key=\"tag\" class=\"list-inline-item mr-1 filter-tags-item\"> <b-form-tag :title=\"tag\" :disabled=\"disabled\" class=\"mr-0\" :variant=\"fieldData.disabled ? 'warning' : 'info'\" @remove=\"removeTag(tag)\" > {{ tag }} </b-form-tag> </li> </ul> <select-picker v-if=\"!fieldData.disabled\" v-model=\"tagList\" v-bind=\"inputAttrs\" class=\"filter-select\" :options=\"dropdownOptions\" value-field=\"key\" text-field=\"name\" label-field=\"name\" :placeholder=\"dropdownPlaceholder\" multiple v-on=\"inputHandlers\" > </select-picker> </template> </b-form-tags> </template> <template v-if=\"filterShowType('minmax')\"> <b-row class=\"m-0 ml-2 mb-2\"> <b-col class=\"pr-1 pl-0\"> <b-form-input placeholder=\"Min\" type=\"number\" class=\"text-right\" :value=\"getMinMaxValue('min')\" @blur=\"changeMinMax('min', $event)\" ></b-form-input> </b-col> <b-col class=\"pl-1 pr-2\"> <b-form-input placeholder=\"Max\" type=\"number\" class=\"text-right\" :value=\"getMinMaxValue('max')\" @blur=\"changeMinMax('max', $event)\" ></b-form-input> </b-col> </b-row> </template> </b-form-group> </component> </b-nav-text> </b-nav>",
  beforeCreate() {
    Utils.loadCss({
      content: "a.disabled { color: #808080; cursor: default; } .dropdown-item.selected { background: rgba(0, 0, 0, 0.05); color: var(--success) !important; } .filter-field-nav .filter-field-checklist > div:last-child { margin-bottom: 5px; } .filter-field-nav .filter-field-checklist + .filter-field-nav { border-bottom: 0px !important; } .filter-field-list { background: rgba(0, 0, 0, 0.03); } .filter-field-link i { font-size: 12px; } .filter-field-link.collapsed i.fa-minus, .filter-field-link.not-collapsed i.fa-plus { display: none; } .filter-list-checkbox-container { width: 30px; } .filter-list-checkbox label { width: 100%; } .filter-list-checkbox.child-selected label::after { background-color: var(--primary); } .filter-tags-list { background: transparent; } .filter-tags-list .filter-tags-item button:focus { outline: none; } .filter-item-image { width: 20px; height: 20px; display: inline-block; margin-top: -3px; } .filter-option-name { white-space: nowrap; text-overflow: ellipsis; }"
    });
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    fieldData: Object,
    displayIcons: Boolean,
    searchTags: Object
  },
  data() {
    return {
      expanded: {}
    };
  },
  computed: {
    allTags: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    fieldTags: {
      get() {
        return this.value[this.filterKey] || [];
      },
      set(value) {
        const tags = {
          ...this.value
        };
        tags[this.filterKey] = value.length === 0 ? null : value;
        this.$emit("input", tags);
      }
    },
    tagList: {
      get() {
        return this.fieldTags; //.map((t) => Object.assign({}, t, { disabled: false }));
      },

      set(value) {
        const suggestion = this.searchTags[this.filterKey];
        if (!suggestion) {
          return;
        }
        let data = Utils.duplicate(this.fieldTags);
        const intersection = value.filter(x => !data.includes(x));
        if (intersection.length === 0) {
          data = value;
        } else {
          if (suggestion.restrict) {
            for (let intersect of intersection) {
              data = suggestion.restrict(data, intersect);
            }
          } else {
            data = data.concat(intersection);
          }
        }
        this.fieldTags = data;
      }
    },
    filterKey() {
      return this.fieldData.key;
    },
    options() {
      return this.fieldData.options || [];
    },
    checkboxList() {
      return this.options.filter(o => o.selectable !== false);
    },
    menuList() {
      return this.options.filter(o => o.selectable === false);
    },
    dropdownOptions() {
      return this.options;
    },
    dropdownPlaceholder() {
      return this.fieldData.placeholder || t("Choose a tag...");
    }
  },
  methods: {
    hasTags(filter = this.fieldData) {
      if (Object.keys(this.value).length === 0) {
        return false;
      }
      // Does this filter have any tags, or do any of its children
      const hasMyKey = (this.value[filter.key] || []).some(t => (filter.type || []).includes("minmax") && (t.startsWith("<") || t.startsWith(">")) || (filter.options || []).some(o => o.key === t || o.tristate && `-${o.key}` === t));
      const hasParentKey = (this.value[filter.useKey] || []).some(t => t === filter.key || filter.tristate && `-${filter.key}` === t);
      const childrenHaveKey = filter.options && filter.options.some(o => this.hasTags(o));
      return hasMyKey || hasParentKey || childrenHaveKey;
    },
    hasList(option) {
      return option.options && option.options.length;
    },
    clickLink(optionKey) {
      $(`#checkbox-${this.filterKey}-${optionKey}`).click();
    },
    filterNameClass(data = this.fieldData) {
      const hasTags = this.hasTags(data);
      if (data.disabled) {
        return hasTags ? "text-warning" : "text-secondary";
      } else if (hasTags) {
        return "text-success font-weight-bold";
      }
      return "text-primary";
    },
    filterLimit(filter) {
      if (filter.limit) {
        const suggestion = this.searchTags[filter.limit.key];
        if (!suggestion || !suggestion.options) {
          return false;
        }
        if (filter.limit.value) {
          let options = suggestion.options();
          const option = options[filter.limit.value];
          if (option) {
            return option.name;
          }
          return "";
        }
        return suggestion.name;
      }
    },
    filterShowType(type) {
      if (this.fieldData.type === undefined) {
        return type === "checklist";
      }
      return this.fieldData.type.includes(type);
    },
    checklistClass(option) {
      if (!this.hasList(option)) {
        return "ml-2 mt-1";
      }
      return "py-2 pl-1 bg-white border-top border-bottom" + (this.fieldData.name ? " ml-1 border-left" : " ml-0 mb-0");
    },
    getCheckedValue(key, value) {
      let tags = this.value[key] || [];
      if (!tags) {
        return undefined;
      }
      if (tags.includes(value)) {
        return true;
      }
      if (tags.includes(`-${value}`)) {
        return false;
      }
      return undefined;
    },
    getMinMaxValue(type) {
      const tag = this.fieldTags.find(t => t.trim().startsWith(type === "min" ? ">" : "<"));
      return tag ? tag.replace(/[^0-9\.]/g, "") : "";
    },
    changeCheckbox(key, value, checked, tristate) {
      const suggestion = this.searchTags[key];
      if (!suggestion) {
        return;
      }
      let tags = Utils.duplicate(this.value);
      let data = Utils.duplicate(tags[key] || []);
      if (checked === false && !tristate || checked === undefined) {
        // Remove the tag, only needs to happen if there are any tags for this key
        tags[key] = data.filter(t => t !== value && t !== `-${value}`);
        if (tags[key].length === 0) {
          delete tags[key];
        }
      } else {
        // Add the tag
        if (!data.length || checked && !data.includes(value) || checked === false && !data.includes(`-${value}`)) {
          if (checked && data.includes(`-${value}`)) {
            // Swap to the positive tag
            data.splice(data.findIndex(t => t === `-${value}`), 1, value);
          } else if (checked === false && tristate && data.includes(value)) {
            // Swap to the negative tag
            data.splice(data.findIndex(t => t === value), 1, `-${value}`);
          } else {
            const tagValue = checked === false && tristate ? `-${value}` : value;
            // If this suggestion has a restriction then run the tags through it
            if (suggestion.restrict) {
              data = suggestion.restrict(data, tagValue);
            } else {
              data.push(tagValue);
            }
          }
          tags[key] = data;
        }
      }
      this.$emit("input", tags);
    },
    changeMinMax(type, ev) {
      const value = ev.target.value;
      if (value === "") {
        const newFieldTags = this.fieldTags.filter(t => t.trim().startsWith(type === "min" ? "<" : ">"));
        if (JSON.stringify(newFieldTags) !== JSON.stringify(this.fieldTags)) {
          this.fieldTags = newFieldTags;
        }
      } else {
        const tag = `${type === "min" ? ">=" : "<="}${value}`;
        let data = Utils.duplicate(this.fieldTags);
        const suggestion = this.searchTags[this.filterKey];
        if (!suggestion) {
          return;
        }
        if (suggestion.restrict) {
          data = suggestion.restrict(data, tag);
        } else {
          data.push(tag);
        }
        this.fieldTags = data;
      }
    },
    removeTag(tag) {
      this.tagList = this.tagList.filter(t => t !== tag);
    }
  },
  created() {
    this.expanded = {};
    if (this.hasTags(this.fieldData)) {
      this.expanded[this.filterKey] = true;
    }
    (this.fieldData.options || []).forEach(option => {
      if (this.hasTags(option)) {
        this.expanded[`${option.useKey || this.filterKey}-${option.key}`] = true;
      }
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["HelpIcon"] = Vue.component(
                    "HelpIcon",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<a v-b-tooltip.hover=\"{ title: tooltip, html: html, customClass: customClass }\" :href=\"url\" target=\"_blank\" ><small><i class=\"fas fa-question-circle\"></i></small ></a>",
  props: {
    url: String,
    tooltip: String,
    customClass: String,
    html: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["InformationToggle"] = Vue.component(
                    "InformationToggle",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-button v-b-tooltip.hover class=\"information-toggle-button\" variant=\"outline-info\" :title=\"tooltip\" :pressed=\"showField\" @click=\"changeInputType\" > <i v-if=\"!showField\" class=\"fas fa-eye\"></i> <i v-else class=\"fas fa-eye-slash\"></i> </b-button>",
  beforeCreate() {
    Utils.loadCss({
      content: ".information-toggle-button { /* There's a difference in size between eye and eye-slash so setting the width maintains consistency */ width: 46px; }"
    });
  },
  props: {
    noun: String,
    value: String
  },
  computed: {
    inputType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    showField() {
      return this.inputType == "text";
    },
    tooltip() {
      const verb = this.showField ? t("hide") : t("show");
      return this.noun ? t("INFORMATION_TOGGLE.ClickTo", {
        verb: verb,
        noun: this.noun
      }) : "";
    }
  },
  methods: {
    changeInputType() {
      this.inputType = this.showField ? "password" : "text";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Intersection"] = Vue.component(
                    "Intersection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copied from https://github.com/heavyy/vue-intersect/blob/master/src/index.js
// Made to not use an import and moved warn const into a method
var _default = exports.default = {
  abstract: true,
  props: {
    threshold: {
      type: Array,
      required: false,
      default: () => [0, 0.2]
    },
    root: {
      type: typeof HTMLElement !== "undefined" ? HTMLElement : Object,
      required: false,
      default: () => null
    },
    rootMargin: {
      type: String,
      required: false,
      default: () => "0px 0px 0px 0px"
    }
  },
  methods: {
    warn(msg) {
      if (!Vue.config.silent) {
        console.warn(msg);
      }
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) {
        this.$emit("leave", [entries[0]]);
      } else {
        this.$emit("enter", [entries[0]]);
      }
      this.$emit("change", [entries[0]]);
    }, {
      threshold: this.threshold,
      root: this.root,
      rootMargin: this.rootMargin
    });
    this.$nextTick(() => {
      if (this.$slots.default && this.$slots.default.length > 1) {
        return this.warn("[VueIntersect] You may only wrap one element in a <intersect> component.");
      } else if (!this.$slots.default || this.$slots.default.length < 1) {
        return this.warn("[VueIntersect] You must have one child inside a <intersect> component.");
      }
      this.observer.observe(this.$slots.default[0].elm);
    });
  },
  destroyed() {
    this.$emit("destroyed");
    this.observer.disconnect();
  },
  render() {
    return this.$slots.default ? this.$slots.default[0] : null;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["LazyLoadingList"] = Vue.component(
                    "LazyLoadingList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @typedef {import("../../common/types.d").PaginatedResponse} PaginatedResponse
 */
var _default = exports.default = {
  template: "<div ref=\"lazyLoadingList\" class=\"lazy-loading-list\" :class=\"{ fixed: fixedHeight }\" :style=\"{ height: fixedHeight }\"> <div ref=\"lazyLoadingListContent\" class=\"lazy-loading-list-content\"> <template v-for=\"item in items\"> <slot name=\"entry\" :item=\"item\" /> </template> </div> <div v-if=\"loadedEverything\" class=\"text-center\"> <slot name=\"end-of-list\"> </slot> </div> <div v-if=\"isLoading\" class=\"text-center lazy-loading-list-loading-indicator\"> <slot name=\"spinner\"> <b-spinner label=\"Loading...\" class=\"my-3\"></b-spinner> </slot> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".lazy-loading-list { overflow-y: auto; position: relative; } .lazy-loading-list.fixed { height: 100%; } .lazy-loading-list:not(.fixed) { overflow-y: hidden; }"
    });
  },
  /**
   * Slots for the LazyLoadingList component
   * @slot default - Slot for rendering each item in the list
   * @slot spinner - Slot for rendering a spinner while loading
   * @slot end-of-list - Slot for rendering when the end of the list is reached
   */
  slots: ["default", "spinner", "end-of-list"],
  props: {
    /**
     * Function to load more items, it should return a promise that resolves to either an array of items or a PaginatedResponse object.
     * The function should accept an object with a `page` property, which is the page number to load.
     * @type {Function}
     * @required
     */
    loadFunction: {
      type: Function,
      required: true
    },
    /**
     * The threshold in pixels from the bottom of the list to trigger the load of more items.
     * @type {number}
     * @default 300
     */
    scrollThreshold: {
      type: Number,
      default: 300
    },
    /**
     * Height of the container, container will grow indefinitely if not set.
     * Must be a valid CSS height value (e.g., '100px', '50%', 'auto').
     * @type {string}
     * @default null
     */
    fixedHeight: {
      type: String,
      default: null,
      validator: value => {
        if (value === null) {
          return true;
        } // Allow null as a valid value
        const cssHeightRegex = /^(\d+(px|em|rem|%)|auto|inherit|initial|unset)$/;
        return cssHeightRegex.test(value);
      }
    },
    /**
     * Number of items to load per page.
     * @type {number}
     * @default 10
     */
    perPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      items: [],
      currentPage: 0,
      loadedPage: 0,
      totalPages: 0,
      totalItems: 0,
      isLoading: false,
      loadedEverything: false,
      loadQueue: [],
      scrollDebounce: null
    };
  },
  methods: {
    async refresh() {
      this.items = [];
      this.loadedPage = 0;
      this.totalPages = 0;
      this.totalItems = 0;
      this.loadedEverything = false;
      this.isLoading = false;
      this.loadQueue = [];
      await this.loadMoreItems({
        page: 1
      });
    },
    async onScroll(event) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = event.target;
      const inLoadMoreZone = scrollHeight - scrollTop <= clientHeight + this.scrollThreshold;
      if (inLoadMoreZone) {
        this.requestLoadMore();
      }
    },
    async requestLoadMore() {
      if (this.loadedEverything) {
        return;
      }
      if (this.isLoading) {
        this.loadQueue.push(Symbol());
        return;
      }
      this.loadMoreItems();
    },
    async loadMoreItems({
      page = this.loadedPage + 1
    } = {}) {
      if (this.loadedEverything) {
        this.loading = false;
        return;
      }
      this.isLoading = true;
      let newItems = await this.loadFunction({
        page,
        limit: this.perPage
      });
      if (Array.isArray(newItems)) {
        const lastPage = newItems.length === 0;
        /**
         * @type {PaginatedResponse<*>}
         */
        newItems = {
          entries: newItems,
          total: this.totalItems + newItems.length,
          page: {
            isLast: lastPage,
            current: lastPage ? this.loadedPage : page,
            total: this.loadedPage,
            limit: this.perPage
          }
        };
      }
      if (newItems.page.isLast || newItems.entries.length === 0) {
        this.loadedEverything = true;
      }
      this.items = [...this.items, ...newItems.entries];
      this.loadedPage = newItems.page.current;
      this.totalPages = newItems.page.total;
      this.totalItems = newItems.total;
      this.$emit("items-changed", this.items);
      this.$emit("page-loaded", this.loadedPage);
      this.isLoading = false;
      if (this.loadQueue.length > 0) {
        const next = this.loadQueue.shift();
        if (next && !this.loadedEverything) {
          this.loadMoreItems();
        }
        return;
      }
      const containerHeight = this.fixedHeight ? this.$refs.lazyLoadingList.clientHeight : this.$refs.lazyLoadingList?.parentElement?.clientHeight || this.$refs.lazyLoadingList.clientHeight;
      if (!this.loadedEverything && this.$refs.lazyLoadingListContent.scrollHeight < containerHeight) {
        this.requestLoadMore();
      }
    }
  },
  mounted() {
    this.loadMoreItems();
    if (!this.fixedHeight) {
      if (this.$refs.lazyLoadingList.parentElement) {
        this.$refs.lazyLoadingList.parentElement.addEventListener("scroll", this.onScroll);
      } else {
        console.warn("LazyLoadingList: parentElement not found");
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["LoadingIndicator"] = Vue.component(
                    "LoadingIndicator",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<component :is=\"tag\" :class=\"classes\"> <b-spinner :class=\"innerClasses\" :type=\"type\" :small=\"small\" :variant=\"variant\" :label=\"label\"></b-spinner> {{ label }} </component>",
  props: {
    label: {
      type: String,
      default: t("Loading…")
    },
    tag: {
      type: String,
      default: "h4"
    },
    type: {
      type: String
    },
    variant: {
      type: String
    },
    small: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes() {
      return {
        "d-inline-block": true,
        "text-center": this.centered
      };
    },
    innerClasses() {
      return {
        "align-middle": true,
        "mr-2": this.label !== ""
      };
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NavTree"] = Vue.component(
                    "NavTree",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-nav vertical class=\"w-100\"> <template v-for=\"item in value\"> <b-nav-item v-if=\"item.clickable || (item.children && item.children.length)\" :key=\"item.id\" link-classes=\"py-1 pr-0\" @click.stop=\"clickLink(item)\" @focus=\"$emit('focus')\" @blur=\"$emit('blur')\" > <slot name=\"itemrow\" :item=\"item\" :expanded=\"expanded\" :toggle=\"clickToggle\"> <b-row> <b-col class=\"p-1 no-select\" :class=\"itemClass(item)\"> {{ item.label }} </b-col> <b-col v-if=\"item.children\" class=\"flex-grow-0 py-1 mr-1\" @click.stop.prevent=\"clickToggle(item)\"> <i v-if=\"!expanded[item.id]\" class=\"fas fa-plus\"></i> <i v-else class=\"fas fa-minus\"></i> </b-col> </b-row> </slot> <component :is=\"collapsible ? 'b-collapse' : 'div'\" v-if=\"item.children\" :id=\"`collapse-${item.id}`\" v-model=\"expanded[item.id]\" class=\"ml-1 pl-3 border-left\" :is-nav=\"true\" > <nav-tree v-model=\"item.children\" :collapsible=\"collapsible\" v-on=\"$listeners\"> <template v-for=\"(index, name) in $scopedSlots\" #[name]=\"data\"> <slot :name=\"name\" v-bind=\"data\" /> </template> </nav-tree> </component> </b-nav-item> </template> </b-nav>",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: {}
    };
  },
  methods: {
    itemClass(item) {
      return item.disabled ? "text-secondary" : "text-primary";
    },
    clickToggle(item) {
      this.$root.$emit("bv::toggle::collapse", `collapse-${item.id}`);
    },
    clickLink(item) {
      if (item.disabled) {
        return;
      }
      if (item.clickable) {
        this.$emit("click", item);
      } else if (item.children) {
        this.$root.$emit("bv::toggle::collapse", `collapse-${item.id}`);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NotificationCard"] = Vue.component(
                    "NotificationCard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"notification-container\" :class=\"{ compact: isCompactHeader }\"> <div class=\"notification-header-row\" :class=\"{ 'notification-header-row--unread': isUnread, 'notification-header-row--clickable': isLinkOnlyMessage }\" @click=\"expandOrNaviagate\" > <img v-if=\"!!img\" :src=\"img\" alt=\"Notification Image\" class=\"notification-header-image\" /> <div class=\"notification-header-text\"> <p class=\"notification-header-title mb-0\"> <b-badge v-if=\"isUnread\" pill variant=\"primary\">{{ t(\"New\") }}</b-badge> {{ title }} <i v-if=\"isLinkOnlyMessage\" class=\"fas\" :class=\"[isLinkExternal ? 'fa-external-link-alt' : 'fa-link']\"></i> </p> <p class=\"notification-header-from-date mb-0\"> {{ from }} <i v-if=\"isSenderVerified\" class=\"fas fa-check-circle text-success\" :title=\"t('Verified')\"></i> <span class=\"notification-header-date\">{{ date.toLocaleString() }}</span> </p> </div> <!-- Expand borderless button - chevron that changes appearance --> <div v-if=\"!isLinkOnlyMessage\" class=\"ml-auto\" :aria-label=\"t('Expand notification')\"> <i :class=\"['fas', expanded ? 'fa-chevron-up' : 'fa-chevron-down']\"></i> </div> </div> <div v-if=\"!isLinkOnlyMessage\" class=\"notification-content\" :class=\"{ 'notification-content--expanded': expanded }\"> <div v-if=\"!!snippet\" class=\"notification-content-header\"> <p>{{ snippet }}</p> </div> <div v-if=\"!!content\" class=\"notification-content-body\"> <p>{{ content }}</p> </div> <div v-if=\"!!url\" class=\"notification-content-footer\"> <a :href=\"url\" target=\"_blank\" >{{ t(\"Find out more\") }} <i class=\"fas\" :class=\"[isLinkExternal ? 'fa-external-link-alt' : 'fa-link']\"></i> </a> </div> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".notification-container { padding: 0; width: 100%; &:not(:last-of-type) { border-bottom: 0.1rem solid rgba(0, 0, 0, 0.25); } .notification-header-row { display: flex; align-items: center; padding: 1rem; &.notification-header-row--clickable { cursor: pointer; } } .notification-header-image { width: 3rem; height: 3rem; border-radius: 50%; margin-right: 0.5rem; } .notification-header-title { font-weight: bold; } .notification-header-from-date { font-size: 0.8rem; } .notification-header-date { opacity: 0.7; } .notification-content { height: 0; padding: 0 1rem; background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)); border-color: rgba(0, 0, 0, 0.25); overflow: hidden; transition: all 0.3s; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; &.notification-content--expanded { height: auto; padding: 1rem; border-top: 0.1rem solid rgba(0, 0, 0, 0.125); } } &.compact { .notification-header-row { padding: 0.25rem; } .notification-header-from, .notification-header-date { line-height: 1.5rem; font-size: 1rem; display: inline; } .notification-content { background-image: initial; } .notification-header-image { width: 1.5rem; height: 1.5rem; } } } .lazy-loading-list { overflow-y: auto; }"
    });
  },
  props: {
    /**
     * URL of the notification image.
     * @type {string}
     */
    img: {
      type: String,
      default: ""
    },
    /**
     * Title of the notification.
     * @type {string}
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Snippet of the notification.
     * @type {string}
     */
    snippet: {
      type: String,
      default: ""
    },
    /**
     * Content of the notification.
     * @type {string}
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * URL associated with the notification.
     * @type {string}
     */
    url: {
      type: String,
      default: ""
    },
    /**
     * Sender of the notification.
     * @type {string}
     */
    from: {
      type: String,
      default: ""
    },
    /**
     * Date of the notification.
     * @type {Date}
     */
    date: {
      type: Date,
      default: () => new Date()
    },
    /**
     * Whether the notification is unread.
     * @type {boolean}
     */
    isUnread: {
      type: Boolean,
      default: true
    },
    /**
     * Whether the sender of the notification is verified.
     * @type {boolean}
     */
    isSenderVerified: {
      type: Boolean,
      default: false
    },
    /**
     * Initial expanded state of the notification.
     * @type {boolean}
     */
    isExpanded: {
      type: Boolean,
      default: false
    },
    /**
     * Notification header display type, one of 'default', 'compact'
     * @type {string}
     */
    headerType: {
      type: String,
      default: "default",
      validator: value => ["default", "compact"].includes(value)
    }
  },
  data() {
    return {
      /**
       * Expanded state of the notification.
       * @type {boolean}
       */
      expanded: this.isExpanded
    };
  },
  computed: {
    isLinkOnlyMessage() {
      return !this.snippet && !this.content && this.url;
    },
    isCompactHeader() {
      return this.headerType === "compact";
    },
    isLinkExternal() {
      return this.url.startsWith("http") && !this.url.includes(window.location.hostname);
    }
  },
  methods: {
    /**
     * Toggles the expanded state of the notification.
     */
    expandOrNaviagate() {
      if (this.isLinkOnlyMessage) {
        window.open(this.url, this.isLinkExternal ? "_blank" : "_self");
      } else {
        this.expanded = !this.expanded;
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["OutlinedText"] = Vue.component(
                    "OutlinedText",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<svg ref=\"container\" class=\"outlined-text\" :class=\"classes\"> <defs> <filter :id=\"`outlineEffect${_uid}`\" color-interpolation-filters=\"sRGB\"> <feConvolveMatrix in=\"SourceGraphic\" result=\"SHARPENED\" order=\"5\" kernelMatrix=\"1 4 6 4 1 4 16 24 16 4 6 24 -476 24 6 4 16 24 16 4 1 4 6 4 1\" ></feConvolveMatrix> <feMorphology in=\"SourceAlpha\" result=\"MORPH\" operator=\"dilate\" :radius=\"radius\" /> <feColorMatrix in=\"MORPH\" result=\"TINT\" type=\"matrix\" :values=\"matrix\" /> <feMerge> <feMergeNode in=\"TINT\" /> <feMergeNode in=\"SHARPENED\" /> </feMerge> </filter> </defs> <g> <text ref=\"text\" :x=\"center ? '50%' : radius\" y=\"50%\" :text-anchor=\"center ? 'middle' : false\" dominant-baseline=\"central\" :fill=\"color\" :filter=\"`url(#outlineEffect${_uid})`\" > {{ text }} </text> </g> </svg>",
  beforeCreate() {
    Utils.loadCss({
      content: "svg.outlined-text { max-width: 100%; /* Don't clip through parent containers */ height: 100%; } svg.outlined-text:not(.position-absolute) { /* * y: Offset outline to align text in paragraphs * x: Allow auto horizontal centering when place in flexes */ margin: -0.25em auto; } svg.outlined-text.outlined-inline-text { margin-bottom: 0; } svg.outlined-text.outlined-inline-text:not(.position-absolute) { height: 1.5em; }"
    });
  },
  props: {
    text: {
      type: String,
      required: true
    },
    radius: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: "white"
    },
    outline: {
      type: String,
      default: "black"
    },
    inline: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    alpha: {
      type: Number,
      default: 1
    }
  },
  watch: {
    text() {
      this.resizeContainer();
    }
  },
  computed: {
    classes() {
      const c = [];
      if (this.inline) {
        c.push("outlined-inline-text");
      }
      if (this.center) {
        c.push("position-absolute", "w-100");
      }
      return c;
    },
    matrix() {
      switch (this.outline) {
        case "white":
          return `1 0 0 0 1, 0 1 0 0 1, 0 0 1 0 1, 0 0 0 ${this.alpha} 0`;
        default:
          /* black */
          return `0 0 0 0 0, 0 0 0 0 0, 0 0 0 0 0, 0 0 0 ${this.alpha} 0`;
      }
    }
  },
  methods: {
    resizeContainer() {
      if (!this.center) {
        setTimeout(() => {
          // Adjust container width
          this.$refs.container.style.width = `${this.$refs.text.getComputedTextLength() + this.radius * 2}px`;
        }, 0);
      }
    }
  },
  mounted() {
    this.resizeContainer();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["QuotaList"] = Vue.component(
                    "QuotaList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-table-simple bordered round class=\"quota-list\"> <b-tbody> <b-tr class=\"quota\"> <b-th class=\"quota-header\" variant=\"secondary\">{{ t(\"Game Data:\") }}</b-th> <b-td class=\"quota-stats br-0\"> {{ bytesToHuman(quotas.data.used) }} / {{ bytesToHuman(quotas.data.total) }} </b-td> <b-td> <b-progress v-if=\"quotas.data.total > 0\" max=\"100\" :variant=\"badgeColourPercentage(quotas.data.percent)\" show-progress > <b-progress-bar class=\"text-right\" :value=\"quotas.data.percent\" :label=\"`${quotas.data.percent}%`\" ></b-progress-bar> </b-progress> <span v-else class=\"text-secondary small\">{{ t(\"Subscribe for data\") }}</span> </b-td> </b-tr> <b-tr class=\"quota\"> <b-th class=\"quota-header\" variant=\"secondary\">{{ t(\"Assets Library:\") }}</b-th> <b-td class=\"quota-stats br-0\"> {{ bytesToHuman(quotas.assets.used) }} / {{ bytesToHuman(quotas.assets.total) }} </b-td> <b-td> <b-progress v-if=\"quotas.assets.total > 0\" max=\"100\" :variant=\"badgeColourPercentage(quotas.assets.percent)\" show-progress > <b-progress-bar class=\"text-right\" :value=\"quotas.assets.percent\" :label=\"`${quotas.assets.percent}%`\" ></b-progress-bar> </b-progress> <span v-else class=\"text-secondary small\">{{ t(\"Subscribe for data\") }}</span> </b-td> </b-tr> <b-tr class=\"quota\"> <b-th class=\"quota-header\" variant=\"secondary\"> {{ t(\"Max. Asset Upload Size:\") }} </b-th> <b-td colspan=\"2\"><i18n :path=\"t('{{size}} per file', { size: bytesToHuman(quotas.upload) })\"></i18n></b-td> </b-tr> </b-tbody> </b-table-simple>",
  beforeCreate() {
    Utils.loadCss({
      content: ".quota-list .quota .quota-header { width: 220px; } .quota-list .quota .quota-stats { width: 200px; } .quota-list .quota .progress .progress-bar { min-width: 25px; border-top-right-radius: 4px; border-bottom-right-radius: 4px; padding-right: 4px; }"
    });
  },
  props: {
    quotas: Object
  },
  methods: {
    bytesToHuman(bytes) {
      return Utils.bytesToHuman(bytes);
    },
    badgeColourPercentage(percent) {
      if (percent < 60) {
        return "success";
      }
      if (percent < 85) {
        return "warning";
      }
      return "danger";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SearchButton"] = Vue.component(
                    "SearchButton",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"search-button-container d-flex\" :class=\"flexJustification\"> <b-button v-b-tooltip.hover.top.viewport squared variant=\"outline-info\" :pressed=\"filtered\" class=\"order-1\" :title=\"title\" @click=\"toggleInput()\" > <i class=\"fas fa-fw fa-search\"></i> </b-button> <div class=\"search-input-container\" :class=\"inputContainerClass\"> <b-form-input ref=\"input\" v-model=\"search\" :placeholder=\"title\" class=\"mx-2\" @blur=\"filterBlurred\"></b-form-input> <i class=\"fas fa-fw fa-times clear-input\" @click=\"clearInput\"></i> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".search-button-container input { width: 100%; /* Leave space for the X clear button */ padding-right: 2rem; } .search-button-container { flex-grow: 1; } .search-button-container .search-input-container { max-width: 0px; width: 0px; transition: width 0.5s, max-width 0.5s; overflow: hidden; position: relative; } .search-button-container .search-input-container.open { max-width: 200px; width: 200px; padding-left: 1rem; } .search-button-container i.clear-input { position: absolute; top: calc(50% - 0.5rem); right: 0px; opacity: 50%; } .search-button-container .search-input-container.closed i.clear-input { display: none; }"
    });
  },
  props: {
    title: {
      type: String,
      default: t("Search")
    },
    position: {
      type: String,
      default: "right"
    },
    /* Automatically hide the search input if blurred, even with content */
    autohide: {
      type: Boolean,
      default: true
    },
    value: String
  },
  data() {
    return {
      showInput: false,
      blurTimeout: 0
    };
  },
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    filtered() {
      return this.showInput || this.search != "";
    },
    inputContainerClass() {
      const order = this.position === "left" ? "order-0" : "order-2";
      const open = this.showInput ? "open" : "closed";
      return `${order} ${open}`;
    },
    flexJustification() {
      return this.position === "left" ? "justify-content-end" : "justify-content-start";
    }
  },
  methods: {
    toggleInput(force) {
      this.showInput = force === undefined ? !this.showInput : force;
      if (this.showInput) {
        this.$nextTick(() => {
          $(this.$refs.input.$el).focus().select();
        });
      } else {
        // In case we switch tabs, we need to unfocus the input
        $(this.$refs.input.$el).blur();
      }
    },
    filterBlurred() {
      // Delay closing the input on blur, in case the blur is caused
      // by clicking on the search button itself
      clearTimeout(this.blurTimeout);
      if (this.autohide || this.search === "") {
        this.blurTimeout = setTimeout(() => this.toggleInput(false), 500);
      }
    },
    clearInput() {
      this.search = "";
      // Refocus and clear the
      this.$nextTick(() => {
        $(this.$refs.input.$el).focus().select();
        clearTimeout(this.blurTimeout);
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SearchField"] = Vue.component(
                    "SearchField",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"search-field-container\"> <b-form-group class=\"mb-0\"> <b-input-group> <b-form-tags class=\"px-2\" no-add-on-enter> <template #default=\"{ inputAttrs, inputHandlers }\"> <ul class=\"b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center\"> <b-form-tag v-for=\"tag in tagList\" :key=\"tag.id\" class=\"search-field-tag\" tag=\"li\" :variant=\"tagClass(tag)\" :title=\"filterTitle(tag)\" @remove=\"removeTag(tag)\" >{{ tag.key }}:{{ tag.label }}</b-form-tag > <li class=\"b-form-tags-field flex-grow-1\"> <b-input-group class=\"d-flex\"> <input id=\"filter-input\" v-model=\"filterText\" v-bind=\"inputAttrs\" aria-describedby=\"tags-description-text\" :placeholder=\"t('Add Filter')\" autocomplete=\"off\" class=\"b-form-tags-input w-100 flex-grow-1 p-0 pt-1 m-0 bg-transparent border-0\" style=\"outline-color: transparent\" v-on=\"inputHandlers\" @focus=\"expand\" @blur=\"blurInput\" @keyup=\"checkForKeyPress($event)\" @click=\"clickSearchInput\" /> </b-input-group> </li> </ul> <div class=\"position-absolute w-100 suggestions\"> <b-collapse v-model=\"expanded\"> <b-card class=\"w-100\" body-class=\"pt-0\"> <b-nav vertical class=\"w-100\"> <div v-if=\"noSuggestions\" class=\"mt-3\">{{ t(\"No recommended suggestions\") }}</div> <loading-indicator v-else-if=\"generatingSuggestions\" class=\"mt-3 mb-0 text-body\" :label=\"t('Finding suggestions…')\" ></loading-indicator> <div v-for=\"section in suggestionList\" v-else :key=\"section.id\"> <b-nav-text :key=\"section.id\" class=\"text-muted\"> {{ section.name }} </b-nav-text> <b-nav-item v-if=\"section.suggestion\" :key=\"section.suggestion.key\" class=\"suggestion-item\" link-classes=\"p-1\" @click.stop=\"selectSuggestion()\" > <span v-html=\"section.suggestion.label\"></span> <span class=\"float-right\">{{ t(\"Click to go back\") }}</span> </b-nav-item> <div v-for=\"group in section.groups\" :key=\"group.id\"> <div v-if=\"group.name\" :key=\"group.id\" class=\"group-container rounded border text-white bg-info px-2\" @click.stop=\"selectOptionGroup\" > {{ group.name }} </div> <b-nav vertical class=\"w-100\"> <b-nav-item v-for=\"option in group.options\" :key=\"option.id\" class=\"rounded w-100 d-flex suggestion-list-item\" link-classes=\"p-1 w-100\" @click=\"selectSuggestion(option)\" > <b-row class=\"flex-nowrap\"> <b-col v-if=\"option.display\" class=\"key-container\"> <b-badge pill :variant=\"optionClass(option)\">{{ option.display }}</b-badge> </b-col> <b-col class=\"item-description\"> <b-row> <b-col><span v-html=\"option.description\"></span></b-col> <b-col v-if=\"option.example && showExample\" class=\"item-example text-right\"> {{ option.example }} </b-col> </b-row> </b-col> </b-row> </b-nav-item> </b-nav> </div> </div> </b-nav> </b-card> </b-collapse> </div> </template> </b-form-tags> <template v-if=\"hasPresets\" #prepend> <b-dropdown v-b-tooltip.hover.top.noninteractive.d0 :title=\"t('Search Presets')\" variant=\"info\" class=\"test\"> <template v-for=\"{ key, name, items, tags, sort } in presets\"> <b-dropdown-group v-if=\"items\" :key=\"'group-' + key\" :header=\"name\"> <b-dropdown-item v-for=\"{ key, name, tags, sort } in items\" :key=\"key\" class=\"pl-2\" @click=\"selectPreset(tags, sort)\" >{{ name }}</b-dropdown-item > </b-dropdown-group> <b-dropdown-item v-else :key=\"'element-' + key\" @click=\"selectPreset(tags, sort)\"> {{ name }} </b-dropdown-item> </template> </b-dropdown> </template> <template #append> <b-button v-if=\"hasTags\" variant=\"outline-secondary\" :title=\"t('Clear all filters')\" @click=\"clearSearch\"> <i class=\"fas fa-times\"></i> </b-button> <b-button :title=\"t('Search')\" @click=\"doSearch\"> <i class=\"fas fa-search\"></i> </b-button> <b-button id=\"search-help-button\" :title=\"t('Learn how to perform advanced searches')\" variant=\"outline-secondary\" target=\"_blank\" href=\"https://forums.forge-vtt.com/docs?topic=84005\" > <i class=\"fas fa-info-circle\"></i> </b-button> <b-tooltip target=\"search-help-button\" triggers=\"hover\" placement=\"left\" :delay=\"{ show: 500, hide: 50 }\" custom-class=\"search-tooltip\" noninteractive > <b>{{ t(\"Tips for Searching\") }}</b> <ul> <li>{{ t(\"Wrap your search terms in quotes to search for the entire phrase\") }}</li> <li>{{ t(\"Put a + in front of a search term to require the search to include that term\") }}</li> <li>{{ t(\"Put a - in front of a search term to exclude it from any searches\") }}</li> <!-- Temporarily hidden until #1884 fixes it --> <!-- <li>{{ t(\"Put an = in front of a search term to match the term exactly\") }}</li> --> <li> {{ t( \"Put a * in behind or in front a search term to include entries that start with or end with the term\" ) }} </li> </ul> <b>{{ t(\"Click for more information\") }}</b> </b-tooltip> </template> </b-input-group> <template #description> <div id=\"tags-description-text\" class=\"mx-2\"> <slot name=\"description\" :v-html=\"description\"></slot> </div> </template> </b-form-group> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".suggestions { left: 0px; top: 100%; z-index: 100; min-width: 400px; } .suggestions .card { border-top-left-radius: 0px; border-top-right-radius: 0px; } .suggestion-item { height: 32px; overflow-y: hidden; } .suggestion-item:hover { background: rgb(128, 128, 128, 0.2); } .suggestion-list-item { max-height: 32px; overflow: hidden; } .suggestion-list-item:hover { background: rgb(128, 128, 128, 0.2); } .suggestion-list-item > a.nav-link { background-image: none !important; border: 0px !important; text-shadow: none !important; } .search-field-tag button:focus { outline: none; } .group-container { cursor: default; } .key-container { overflow: hidden; flex: 0 0 20%; max-width: 20%; min-width: 140px; } .key-container .badge { max-width: 100%; text-overflow: ellipsis; overflow: hidden; } .item-description:not(:first-child) { flex: 0 0 80%; max-width: 80%; } .item-example { flex-grow: 0; white-space: nowrap; } @media (max-width: 1500px) { .item-example { display: none; } } @media (max-width: 1300px) { .suggestion-list-item { max-height: unset; } .key-container { flex: 1; } .item-description { flex: 1; } .item-example { overflow: hidden; } .suggestions .nav-link .row { flex-direction: column; } } @media (max-width: 530px) { .suggestions { left: -30px; } } @media (min-width: 724px) and (max-width: 1025px) { .suggestions { left: -30px; } } .search-tooltip .tooltip-inner { max-width: 600px; } .search-tooltip .tooltip-inner ul { text-align: left; }"
    });
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    presets: {
      type: Array,
      default() {
        return [];
      }
    },
    visibilityKey: String,
    // Visibility key used by the search tags to know if a search tag can be shown on this component
    placeholder: {
      type: String,
      default: t("Add Filter")
    },
    showExample: {
      type: Boolean,
      default: true
    },
    description: String,
    packages: {
      type: Array,
      default() {
        return [];
      }
    },
    searchTags: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      focussed: false,
      expanded: false,
      filterText: "",
      lastFilterText: "",
      refreshSearch: 0,
      filterCaret: 0,
      maxSuggestions: 10,
      maxPackages: 5,
      lastKeyPress: "",
      suggestionList: {},
      suggestionsDebounce: null
    };
  },
  watch: {
    value(_newValue) {
      this.filterText = this.terms.join(" ");
      this.filterCaret = this.filterText.length;
    },
    expanded(value) {
      if (value) {
        this.findOption();
      }
    },
    packages() {
      this.setSuggestions();
    },
    filterText(value, oldValue) {
      // The tag at the end determines the sub tag
      this.lastFilterText = oldValue;
      this.findOption();
      this.suggestionList = {};
      // Clear the debounce timer if it's already running
      if (this.generatingSuggestions) {
        clearTimeout(this.suggestionsDebounce);
        this.suggestionsDebounce = null;
      }
      // Start a 200ms debounce timer
      this.suggestionsDebounce = setTimeout(async () => {
        this.suggestionsDebounce = null;
        this.suggestionList = await this.generateSuggestions();
      }, 200);
    }
  },
  computed: {
    tags: {
      get() {
        const {
          terms,
          ...tags
        } = this.value;
        return tags || [];
      },
      set(value) {
        let {
          parts
        } = this.getFilterTextParts();
        parts = parts.filter(p => p);
        if (!parts.length) {
          this.$emit("input", value);
        } else {
          this.$emit("input", Object.assign({
            terms: parts.join(" ")
          }, value));
        }
      }
    },
    terms: {
      get() {
        return this.value.terms || [];
      },
      set(value) {
        if (!value.length) {
          this.$emit("input", this.tags);
        } else {
          this.$emit("input", Object.assign({
            terms: value
          }, this.tags));
        }
      }
    },
    hasTags() {
      return Object.keys(this.tags).length || this.filterText.trim().length;
    },
    hasPresets() {
      return this.presets.length;
    },
    tagList() {
      let tags = Object.entries(this.tags).filter(([k, v]) => v && v.length && this.searchTags[k]);
      if (!tags.length) {
        return [];
      }
      return tags.reduce((a, [k, v]) => {
        return a.concat(v.map(t => {
          let searchTerm = t;
          if (searchTerm.startsWith("-") || searchTerm.startsWith("+")) {
            searchTerm = searchTerm.substring(1);
          }
          // Check for this term afterwards since it can exist with the include or exclude
          if (searchTerm.startsWith("=")) {
            searchTerm = searchTerm.substring(1);
          }
          const searchTag = this.searchTags[k];
          const options = searchTag.options && searchTag.options() || [];
          let option = options.find(o => o.key === searchTerm || o.tag === searchTerm);
          const error = searchTag.strict && !option;
          option = option || {};
          if (!option.key && option.tag) {
            option = this.searchTags[option.tag];
          }
          const limit = searchTag && searchTag.limit && (!this.tags[searchTag.limit.key] || searchTag.limit.value && !(this.tags[searchTag.limit.key] || []).includes(searchTag.limit.value));
          return {
            id: `${k}:${t}`,
            key: k,
            value: t,
            limit,
            error,
            label: option && option.name || searchTerm
          };
        }));
      }, []).sort((a, b) => {
        const filterA = this.searchTags[a.key];
        const filterB = this.searchTags[b.key];
        if (filterA.sort !== filterB.sort) {
          return filterA.sort - filterB.sort;
        }
        return a.id.localeCompare(b.id);
      });
    },
    noSuggestions() {
      const {
        parts,
        idx
      } = this.getFilterTextParts();
      return parts[idx].length > 3 && !this.generatingSuggestions && Object.keys(this.suggestionList).length === 0 && this.filterText[this.filterCaret - 1] !== " ";
    },
    generatingSuggestions() {
      return this.suggestionsDebounce !== null;
    }
  },
  methods: {
    setSuggestions() {
      this.generateSuggestions().then(suggestionList => {
        this.suggestionList = suggestionList;
      });
    },
    async generateSuggestions() {
      this.refreshSearch++;
      const sections = {
        filters: {
          id: "_filters",
          name: t("Suggested filters")
        }
      };
      const {
        parts,
        idx,
        offset
      } = this.getFilterTextParts();
      if (parts[idx].length !== 0 && offset >= 0 && offset <= parts[idx].length) {
        // Something's been typed into the filter text, does it match a suggestion?
        let tag = parts[idx] || "";
        let [key, value] = tag.split(":");
        const suggestion = this.searchTags[key];
        if (suggestion && tag.indexOf(":") > 0) {
          value = (value || "").trim();
          let options = (suggestion.options && suggestion.options() || []).filter(o => o.visible !== false);
          const total = options.length;
          const groups = this.optionsList(options, key, value);
          const remainingOptions = groups.flatMap(g => g.options).length;
          let optionStats = total ? t("{{total}} options", {
            total
          }) : "Type text into the search field";
          if (total) {
            if (remainingOptions >= this.maxSuggestions) {
              optionStats += t(", showing top {{max}}", {
                max: this.maxSuggestions
              });
            } else {
              optionStats += t(", showing {{max}}", {
                max: remainingOptions
              });
            }
          }
          sections.filters = {
            id: key,
            suggestion: Object.assign({
              key,
              label: '<i class="fas fa-arrow-left"></i> ' + (suggestion.name ? `<b>${suggestion.name}</b> - ` : "") + optionStats
            }, suggestion),
            groups,
            total: total
          };
        }
      }
      if (sections.filters.groups === undefined) {
        // Nothing was found, so display the root menu
        let tag = parts[idx] || "";
        let [key, value] = tag.split(":");
        const groups = Object.entries(this.searchTags).filter(([k, v]) => (!key || (k || "").toLowerCase().includes(key.toLowerCase()) || (v.name || "").toLowerCase().includes(key.toLowerCase())) && this.isTagVisible(v)).map(([k, v]) => {
          let {
            options,
            filter,
            ...data
          } = v;
          if (options instanceof Function) {
            options = options();
          }

          // Don't include this tag if it's supposed to have options, but doesn't have any
          if (options && options.length === 0) {
            return null;
          }
          if (data.limit && !data.disabled) {
            data.disabled = !this.tags[data.limit.key] || data.limit.value && !(this.tags[data.limit.key] || []).includes(data.limit.value);
          }
          return Object.assign({
            display: `${k} :`,
            key: k
          }, data);
        }).filter(i => !!i && !i.disabled);
        if (groups.length === 0) {
          delete sections.filters;
        } else {
          sections.filters.groups = [{
            options: groups
          }];
        }

        // Sub option search
        let subgroups = [];
        for (const [k, v] of Object.entries(this.searchTags)) {
          const options = (v.options && v.options() || []).filter(o => o.visible !== false);
          const list = this.optionsList(options, k, key);
          const filteredOptions = list.flatMap(g => g.options).filter(g => !!g && key && g.name && g.value && (g.name.toLowerCase().startsWith(key.toLowerCase()) || g.value.toLowerCase().startsWith(key.toLowerCase())));
          if (filteredOptions.length) {
            subgroups = subgroups.concat(filteredOptions);
          }
        }
        subgroups = subgroups.filter(s => !!s);
        // Disable subgroups for now, until #1891 is fixed.
        if (false && subgroups.length) {
          // trim to the top 10
          subgroups.splice(this.maxSuggestions);
          sections.subfilters = {
            id: "_subfilters",
            name: t("Suggested Sub filters"),
            groups: [{
              options: subgroups
            }]
          };
        }
      }

      // Autocomplete on package name
      if (this.filterText && this.filterText.length > 2) {
        const {
          parts,
          idx
        } = this.getFilterTextParts();
        // If the current part doesn't start with a tag or allows autocomplete, then show the package suggestions
        const searchTag = Object.keys(this.searchTags).find(k => parts[idx].startsWith(`${k}:`));
        if (!searchTag || this.searchTags[searchTag].allowAutocomplete) {
          let testText = this.filterText.toLowerCase();
          // If this searchTag allows autocomplete, then remove the tag from the search text
          if (searchTag) {
            testText = testText.substring(searchTag.length + 1);
          }
          const normalizedText = this.normalizeTerm(testText);
          // check that testText is still greater than 2 characters
          if (testText.length > 2) {
            const pkgs = this.packages.filter(p => this.normalizeTerm(p.title).includes(normalizedText) || this.normalizeTerm(p.name).includes(normalizedText) || (p.id || "").toLowerCase() === testText).sort((a, b) => {
              // Exact match first
              if ((a.id || "").toLowerCase() === testText) {
                return -1;
              }
              if ((b.id || "").toLowerCase() === testText) {
                return 1;
              }
              // Starts with match next
              if (a.title.startsWith(testText) !== b.title.startsWith(testText)) {
                return a.title.startsWith(testText) ? -1 : 1;
              }
              // Then sort by installs
              if (a.installs !== b.installs) {
                return b.installs - a.installs;
              }
              // Then sort by title
              return (a.title || "").localeCompare(b.title || "");
            }).map(p => {
              return {
                description: `<b>${p.title}</b>`,
                // Here `id` is used as a unique "key" for the suggestion component
                id: Bazaar.getDisplayedPackageKey(p),
                name: p.name,
                key: "name",
                value: `"${p.title}"`,
                clearSearch: true
              };
            }).splice(0, this.maxPackages);
            if (pkgs.length) {
              sections.suggested = {
                id: "_packages",
                name: t("Matching Packages"),
                groups: [{
                  options: pkgs
                }]
              };
            }
          }
        }
      }
      return sections;
    },
    getFilterTextParts() {
      const splits = this.filterText.split(" ");
      const parts = [];
      let idx = 0;
      let offset = 0;
      let term = "";
      let collecting = false;
      let addTerm = true;
      let lengthSoFar = 0;
      for (let i = 0; i < splits.length; i++) {
        let s = splits[i];
        const key = Object.keys(this.searchTags).find(st => s.startsWith(st + ":"));
        if (key) {
          if (collecting) {
            i--;
            addTerm = false;
            collecting = false;
          } else {
            collecting = this.searchTags[key].strict !== true;
          }
        } else if (s.indexOf('"') >= 0 && s.indexOf('"') < s.length - 2) {
          collecting = true;
        }
        if (s.endsWith('"') || i === splits.length - 1) {
          collecting = false;
        }
        if (addTerm) {
          term += (term !== "" ? " " : "") + s;
        }
        if (!collecting) {
          if (this.filterCaret > lengthSoFar && this.filterCaret < lengthSoFar + term.length + 1) {
            idx = parts.length;
            offset = this.filterCaret - lengthSoFar;
          }
          parts.push(term);
          lengthSoFar += term.length + 1;
          term = "";
          addTerm = true;
        }
      }
      if (idx === -1) {
        idx = parts.length - 1;
      }
      if (parts.length === 0) {
        parts.push("");
      }
      return {
        parts,
        idx,
        offset
      };
    },
    updateFilterText(parts) {
      // Add the trailing space to make sure that the next thing they add won't try and use the current filter
      this.filterText = parts.join(" ") + (parts.length ? " " : "");
      this.filterCaret = this.filterText.length;
    },
    isTagVisible(tag) {
      if (!tag) {
        return false;
      } else if (tag.visible === undefined) {
        return true;
      } else if (typeof tag.visible === "boolean") {
        return tag.visible;
      }
      return tag.visible["default"] === true || tag.visible["default"] === undefined ? tag.visible[this.visibilityKey] !== false : tag.visible[this.visibilityKey] === true;
    },
    filterTitle(tag) {
      const suggestion = this.searchTags[tag.key];
      if (tag.limit) {
        const limitFilter = this.searchTags[suggestion.limit.key];
        return t("This filter only applies to {limit}", {
          limit: suggestion.limit.value ? limitFilter.options[suggestion.limit.value].name : limitFilter.name
        });
      }
      const options = suggestion.options && suggestion.options() || [];
      const option = options.find(o => o.key === tag.value || o.tag === tag.value);
      if (option !== undefined) {
        return option.description || suggestion.description || "";
      }
      if (tag.value.startsWith("-")) {
        return t("Exclude this filter from search results");
      }
      if (tag.value.startsWith("+")) {
        return t("Require this filter in search results");
      }
      if (tag.value.startsWith("=")) {
        return t("Match this filter exactly in search results");
      }
      return "";
    },
    findOption() {
      const parts = this.getFilterTextParts();
      if (parts.length) {
        let key = parts[parts.length - 1];
        if (key.endsWith(":")) {
          key = key.substring(0, key.length - 1);
        }
      }
    },
    createTagsFromFilter() {
      let text = [];
      let {
        parts
      } = this.getFilterTextParts();
      let tags = Object.assign({}, this.tags);
      for (let term of parts) {
        // Try to add the tag, if it's a valid tag then it will clear the filter, otherwise the tag will be returned to the filter
        term = this.addTag(tags, term);

        // If the term hasn't been added as a tag, then add it as a text search
        if (term) {
          text.push(term);
        }
      }

      // Set both this.terms and this.tags at once to avoid doing a double search
      const input = tags;
      if (text.length) {
        input.terms = text;
      }
      this.$emit("input", input);
      this.updateFilterText(text);
    },
    blurInput() {
      this.collapse();
      if (this.filterText === "" && this.value.terms && this.value.terms.length) {
        this.doSearch();
      }
    },
    expand() {
      this.focussed = true;
      this.expanded = true;
    },
    collapse() {
      this.focussed = false;
      this.filterCaret = $("#filter-input")[0].selectionStart;
      window.setTimeout(() => {
        if (!this.focussed) {
          this.expanded = false;
          const {
            parts
          } = this.getFilterTextParts();
          this.$emit("change", Object.assign({
            terms: parts.join(" ")
          }, this.tags));
        }
      }, 200);
    },
    tagClass(tag) {
      if (tag.error) {
        return "danger";
      }
      if (tag.value.startsWith("=")) {
        return "info";
      }
      return tag.limit || tag.value.startsWith("-") ? "warning" : "success";
    },
    optionClass(option) {
      if (option.disabled) {
        return "secondary";
      }
      if (option.error) {
        return "danger";
      }
      return option.reverse ? "warning" : "primary";
    },
    optionsList(options, key, value) {
      const items = options
      // Load any options that are a link to other tags, and add additional information to the options
      .flatMap(o => {
        let option = o;
        if (o.tag) {
          let searchTag = this.searchTags[o.tag];
          option = Object.assign({
            key: o.tag
          }, searchTag, o);
          option.visible = searchTag && searchTag.visible && o.visible;
        }

        // Don't show the ones that aren't selectable
        if (o.selectable === false) {
          return;
        }
        const optionKey = option.key || option.name || "";
        const parent = options.find(p => p.key === o.parent) || {};
        const result = {
          display: `${key} : ${optionKey}`,
          id: optionKey,
          key: key,
          useKey: option.useKey || key,
          value: optionKey,
          name: option.name || option.key || "",
          sort: option.sort,
          description: option.description || option.name,
          disabled: option.disabled || this.tags[key] !== undefined && this.tags[key].includes(optionKey),
          group: {
            key: parent.key,
            name: parent.name,
            sort: parent.sort
          }
        };

        // Only show ones that actually contain the search value
        if (value !== "" && !result.value.toLowerCase().includes(value.toLowerCase()) && !result.name.toLowerCase().includes(value.toLowerCase())) {
          return;
        }
        let reverse;
        if (!!option.tristate && !!option.reverseName) {
          reverse = {
            reverse: true,
            display: `${key} : -${optionKey}`,
            id: "-" + optionKey,
            key: key,
            useKey: option.useKey || key,
            value: "-" + optionKey,
            name: option.reverseName || "",
            sort: option.sort + 0.5,
            description: option.reverseName || "",
            disabled: option.disabled || this.tags[key] !== undefined && this.tags[key].includes("-" + optionKey),
            group: {
              key: parent.key,
              name: parent.name,
              sort: parent.sort
            }
          };
        }
        return [result, reverse];
      })
      // Filter out the blank ones
      .filter(o => !!o)
      // Sort by relevance
      .sort((a, b) => {
        const startsWithA = a.key.toLowerCase().startsWith(value.toLowerCase()) || a.name.toLowerCase().startsWith(value.toLowerCase());
        const startsWithB = b.key.toLowerCase().startsWith(value.toLowerCase()) || b.name.toLowerCase().startsWith(value.toLowerCase());
        if (startsWithA !== startsWithB) {
          // Favor results that start with the search term
          return startsWithA ? -1 : 1;
        }
        if (a.sort !== b.sort) {
          return a.sort - b.sort;
        }
        return a.name.localeCompare(b.name);
      })
      // Preserve sorting after the splice and grouping
      .map((o, idx) => Object.assign(o, {
        sort: idx
      }))
      // Only take the top 10 most relevant
      .splice(0, this.maxSuggestions);

      // Add them to their groups
      const groups = [];
      for (let item of items) {
        let group = groups.find(g => g.key === item.group.key);
        if (!group) {
          group = Object.assign({
            type: "collection",
            options: []
          }, item.group);
          groups.push(group);
        }
        group.options.push(item);
      }
      return groups;
    },
    selectSuggestion(suggestion) {
      $("#filter-input").focus();
      let {
        idx,
        parts,
        offset
      } = this.getFilterTextParts();
      if (!suggestion) {
        parts[idx] = "";
        this.filterText = parts.filter(p => !!p).join(" ");
        const newCaretPosition = idx === 0 ? 0 : parts.slice(0, idx - 1).reduce((sum, p) => sum + p.length, 0) + idx * 1;
        this.$nextTick(() => this.setCaretPosition(newCaretPosition < 0 ? this.filterText.length + newCaretPosition : newCaretPosition));
      } else {
        if (suggestion.disabled) {
          return;
        }
        const data = Object.assign({}, this.tags);
        if (suggestion.value) {
          // get the correct key
          let key = suggestion.useKey || suggestion.key;
          //This is a full suggestion being selected
          if (suggestion.exclusive && data[key] !== undefined) {
            // If this is a true or false option then clear the other tag
            data[key] = [suggestion.value];
            parts[idx] = "";
          } else if (data[suggestion.key] !== undefined && data[key].includes(suggestion.value)) {
            // If this option is already in the list of tags, then don't bother adding it, and just remove it
            parts = parts.splice(idx, 1);
          } else {
            let value = suggestion.value;
            if (parts[idx].startsWith("id:") && suggestion.name) {
              key = "id";
              value = suggestion.name;
            }
            data[key] = data[key] || [];
            data[key].push(value);
            if (suggestion.clearSearch) {
              parts = [];
            } else {
              parts[idx] = "";
            }
          }
          if (suggestion.include) {
            const includeTags = suggestion.include.filter(i => {
              return !(this.tags[i.key] !== undefined && this.tags[i.key].includes(i.value));
            }).map(i => `${i.key}:${i.value}`);
            parts = parts.concat(includeTags);
          }
          if (suggestion.clearSearch) {
            this.collapse();
          }
          this.filterText = parts.join(" ");
          this.tags = data;
        } else {
          let newCaretPosition = 0;
          const newSuggestion = suggestion.key + ":";
          // If we're at the very end of the parts the add to the end
          if (parts[idx].length === offset && idx === parts.length - 1) {
            // If the part is the start of a key then fill in the rest of the key
            if (parts[idx] !== "" && suggestion.key.startsWith(parts[idx])) {
              parts[idx] = newSuggestion;
            }
            // Add the suggestion as a new tag
            else {
              if (parts[idx] === "") {
                parts[idx] = newSuggestion;
              } else {
                parts.push(newSuggestion);
                idx++;
              }
            }
          }
          // If the current part is blank, then replace it
          else if (parts[idx].length === 0) {
            parts[idx] = newSuggestion;
          }
          // If the offset is at the end of the string then add a space and the suggestion key
          else if (parts[idx].length === offset) {
            // If the part is the start of a key then fill in the rest of the key
            if (suggestion.key.startsWith(parts[idx])) {
              parts[idx] = suggestion.key + ":";
            }
            // Add the suggestion as a new tag
            else {
              parts.splice(idx + 1, 0, newSuggestion);
            }
          }
          // If the offest is at the beginning or somewhere in the middle then
          else {
            // If the part starts with the entire suggestion key, then clear the remaining text
            if (parts[idx].startsWith(suggestion.key + ":")) {
              parts[idx] = suggestion.key + ":";
            }
            // If the part is the start of a key then fill in the rest of the key
            else if (suggestion.key.startsWith(parts[idx])) {
              parts[idx] = newSuggestion;
            }
            // If the part starts with suggestion key that isn't this suggestion key, then replace the keys
            else {
              const tag = Object.keys(this.searchTags).find(s => parts[idx].startsWith(s + ":"));
              if (tag) {
                parts[idx] = suggestion.key + parts[idx].substring(tag.length);
              }
              // Otherwise append the key
              else {
                parts[idx] = `${suggestion.key}:${parts[idx]}`;
              }
            }
          }
          if (newCaretPosition === 0) {
            newCaretPosition = parts.slice(0, idx + 1).reduce((sum, p) => sum + p.length, 0) + idx * 1;
          }
          this.filterText = parts.join(" ");
          this.$nextTick(() => this.setCaretPosition(newCaretPosition < 0 ? this.filterText.length + newCaretPosition : newCaretPosition));
        }
      }
    },
    selectOptionGroup(event) {
      // Left blank to prevent the event from bubbling
      $("#filter-input").focus();
    },
    selectPreset(preset, sort) {
      // Replace the tags with this filter
      this.filterText = "";
      this.tags = Object.assign({}, preset);
      if (sort) {
        this.$emit("sort", sort);
      } else {
        this.$emit("sort", {
          key: Sort.defaultSort,
          dir: "asc"
        });
      }
    },
    addTag(tags, tag) {
      // If the tag isn't a valid string, then exit
      if (!tag || typeof tag !== "string") {
        return tag;
      }

      // If either key or value is invalid, then exit
      let [key, value] = tag.split(":");
      if (!key || !value) {
        return tag;
      }

      // If the key isn't in the list of valid suggestions, then exit
      const suggestion = this.searchTags[key];
      if (!suggestion) {
        return tag;
      }
      value = value.trim();

      // If the value isn't a valid option in this suggestion, then exit
      if (suggestion.strict) {
        if (!suggestion.options) {
          return tag;
        }
        const options = suggestion.options();
        const option = options.find(sg => (sg.key || sg.tag) === (value.startsWith("-") ? value.substring(1) : value));
        if (!option) {
          return tag;
        }
      }
      let data = Utils.duplicate(tags[key] || []);

      // If this suggestion has a restriction then run the tags through it
      if (suggestion.restrict) {
        data = suggestion.restrict(data, value);
      } else {
        data.push(value);
      }
      // Remove the reverse tag of this tag
      const reverseTag = value.startsWith("-") ? value.substring(1) : "-" + value;
      if (data[key] && data[key].includes(reverseTag)) {
        data[key] = data[key].filter(t => t !== reverseTag);
      }
      tags[key] = data;
      return "";
    },
    removeTag(tag) {
      const tags = Object.assign({}, this.tags);
      let category = tags[tag.key];
      if (category !== undefined) {
        if (category.includes(tag.value)) {
          category = category.filter(t => t !== tag.value);
          if (category.length) {
            tags[tag.key] = category;
          } else {
            delete tags[tag.key];
          }
          this.tags = tags;
        }
      }
    },
    clickSearchInput() {
      this.filterCaret = document.getElementById("filter-input").selectionStart;
      this.refreshSearch++;
    },
    checkForKeyPress(event) {
      this.expanded = true;
      this.filterCaret = document.getElementById("filter-input").selectionStart;
      // on an enter key press, do the search
      if (event.keyCode === 13) {
        this.doSearch();
      }
      // else on backspace and nothing in the text field, remove the last tag
      else if (event.keyCode === 8 && this.filterText === "") {
        if (this.lastFilterText === "") {
          const tags = Object.assign({}, this.tags);
          const keys = Object.keys(tags);
          if (keys.length) {
            const lastKey = keys[keys.length - 1];
            const lastTag = tags[lastKey];
            if (lastTag.length) {
              const lastValue = lastTag[lastTag.length - 1];
              this.removeTag({
                key: lastKey,
                value: lastValue
              });
            } else {
              delete tags[lastKey];
              this.tags = tags;
            }
          }
        } else {
          // Using the last filter text to differentiate between the last deletion of a character and the deletion of a tag
          this.lastFilterText = "";
        }
      }
      this.lastKeyPress = event.keyCode;
    },
    doSearch() {
      this.createTagsFromFilter();
      this.expanded = false;
    },
    clearSearch() {
      this.filterText = "";
      this.tags = {};
    },
    setCaretPosition(caretPos) {
      var elem = document.getElementById("filter-input");
      if (elem !== null) {
        if (elem.createTextRange) {
          var range = elem.createTextRange();
          range.collapse(true);
          range.moveEnd("character", caretPos);
          range.moveStart("character", caretPos);
          range.select();
        } else {
          elem.focus();
          if (elem.selectionStart) {
            elem.setSelectionRange(caretPos, caretPos);
          }
        }
      }
    },
    normalizeTerm(term = "") {
      const a = /[àáâäæãåāăąдвçćčсđďèéêëēėęěеğǵḧîïíīįìłḿñńǹňийпôöòóœøōõőоṕрŕřßśšşșťțûüùúūǘůűųẃẍÿýуžźż]+/g;
      const b = "aaaaaaaaaaabccccddeeeeeeeeegghiiiiiilmnnnnnnnoooooooooopprrsssssttuuuuuuuuuwxyyyzzz";
      return term.toLowerCase().trim().replace(a, s => s.split("").reduce((sp, c) => sp + b.charAt(a.source.indexOf(c) - 1), "")).replace(/[^\w \-_]+/g, "");
    }
  },
  created() {
    this.filterText = this.terms.join(" ");
    $(window).on("blur", () => {
      $("#filter-input").blur();
    });
    // Generate the initial suggestions list
    this.setSuggestions();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SelectPicker"] = Vue.component(
                    "SelectPicker",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<select v-model=\"selected\" class=\"form-control\" :multiple=\"multiple\" :name=\"name\" data-live-search=\"true\" :data-live-search-placeholder=\"placeholder\" data-live-search-normalize=\"true\" :title=\"placeholder\" :value-field=\"valueField\" :text-field=\"textField\" :label-field=\"labelField\" v-on=\"$listeners\" > <!-- v-on=\"$listeners\" any of the events that the select dropdown passes, is passed directly to parent --> <option v-for=\"option in filteredOptions\" :key=\"option[valueField]\" :disabled=\"option.disabled\" :value=\"option[valueField]\" :data-tokens=\"option[valueField]\" :data-content=\"option[textField]\" v-html=\"option[textField]\" ></option> </select>",
  beforeCreate() {
    Utils.loadCss({
      content: ".dropdown-menu { z-index: 9999; }"
    });
  },
  props: {
    name: {
      type: String,
      default: "select-picker"
    },
    value: {
      type: [Array, String]
    },
    // JQuery will use the <select> element's title attribute as placeholder
    placeholder: {
      type: String,
      default: t("Search Value")
    },
    valueField: {
      type: String,
      default: "value"
    },
    textField: {
      type: String,
      default: "text"
    },
    labelField: {
      type: String,
      default: "label"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // pass in options as array of { value: String; text: String; }
    options: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    value() {
      $(this.$el).selectpicker("val", this.selected);
    },
    options() {
      $(this.$el).selectpicker("refresh");
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option, index, array) => {
        return array.findIndex(i => i[this.valueField] === option[this.valueField]) === index;
      });
    },
    selected: {
      // props.value can be a string or an array, depending on the multiple prop
      get() {
        if (!this.value) {
          return this.multiple ? [] : "";
        }
        return this.value;
      },
      set(value) {
        if (this.multiple && !Array.isArray(value) || !this.multiple && typeof value === "string") {
          return;
        }
        $(this.$el).selectpicker("val", value);
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    $(this.$el).selectpicker("val", this.selected);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["Separator"] = Vue.component(
                    "Separator",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div :class=\"separatorClasses\"> <hr class=\"separator-left\" /> <span>{{ title }}</span> <hr class=\"separator-right\" /> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".separator { display: flex; align-items: center; justify-content: center; } .separator span { padding: 0 0.6rem; text-transform: uppercase; font-weight: bold; font-size: 0.875em; user-select: none; } .separator hr { width: 100%; border: none; height: 2px; }"
    });
  },
  props: {
    title: String,
    classes: String
  },
  computed: {
    separatorClasses() {
      return `separator ${this.classes}`.split(/\s+/g).join(" ");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["SortField"] = Vue.component(
                    "SortField",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"sort-container\"> <span>{{ sortLabel }} </span> <b-dropdown variant=\"primary\" :html=\"sortText\" class=\"m-0 ml-2 sort-field-list\"> <b-dropdown-item v-for=\"option in sortOptions\" :key=\"option.key\" @click=\"changeSort(option)\"> <i v-if=\"option.icon\" class=\"fas\" :class=\"option.icon\"></i> {{ option.text }} </b-dropdown-item> </b-dropdown> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".sort-field-list { width: 200px; }"
    });
  },
  props: {
    // Value is the sort object from the parent in the form of {key:, dir:asc|desc}
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    sortLabel: {
      type: String,
      default: t("Sort By:")
    }
  },
  data() {
    return {
      sortSelection: Object // This is selected from the sortOptions
    };
  },

  watch: {
    value(newValue) {
      // If the sort is changed externally, then update the selection
      this.sortSelection = this.findSortOption(newValue.key, newValue.dir);
    }
  },
  computed: {
    sortOptions() {
      return Object.entries(Sort.sortTags).flatMap(([k, v]) => {
        if (v.visible === false) {
          return [];
        }
        const results = [{
          key: `${k}-asc`,
          value: k,
          dir: "asc",
          text: v.name,
          icon: v.icon
        }];
        if (v.reverse) {
          // If the sort also contains a reverse option, then add that as well.
          results.push({
            key: `${k}-desc`,
            value: k,
            dir: "desc",
            text: v.reverse.name,
            icon: v.reverse.icon
          });
        }
        return results;
      });
    },
    sort: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    sortText() {
      let text = this.sortSelection.text;
      if (this.sortSelection.icon) {
        text = `<i class="fas ${this.sortSelection.icon}"></i> ` + text;
      }
      return text;
    }
  },
  methods: {
    changeSort(option) {
      this.sort = {
        key: option.value,
        dir: option.dir
      };
    },
    findSortOption(value, dir) {
      let option = this.sortOptions.find(x => x.value === value && x.dir === dir);
      if (!option) {
        option = this.sortOptions.find(x => x.value === value);
      }
      return option;
    }
  },
  created() {
    this.sortSelection = this.findSortOption(this.sort.key, this.sort.dir);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["StateProvinceInput"] = Vue.component(
                    "StateProvinceInput",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<select v-if=\"options\" ref=\"select\" v-model=\"province\" class=\"form-control selectpicker\" :class=\"invalidClass\" name=\"province\" :title=\"title\" autocomplete=\"billing address-level1\" > <option v-for=\"option in options\" :key=\"option.value\" :value=\"option.value\">{{ option.text }}</option> </select> <b-form-input v-else v-model=\"province\" name=\"province\" autocomplete=\"billing address-level1\"></b-form-input>",
  props: {
    value: {
      type: String,
      default: ""
    },
    country: {
      type: String,
      default: ""
    },
    countryProvinces: {
      type: Object,
      required: true
    }
  },
  watch: {
    validProvince() {
      // Because the HTML select is being wrapper by the selectpicker class
      // The parent needs to have the is-invalid class updated whenever Vue updates the child.
      $(this.$refs.select).parent().toggleClass("is-invalid", !this.validProvince);
      this.$emit("valid", this.validProvince);
    },
    country() {
      $(this.$el).selectpicker("destroy");
      if (this.options) {
        const lower = this.value.toLowerCase();
        const matchingOption = this.options.find(o => [o.value.toLowerCase(), o.text.toLowerCase()].includes(lower));
        this.province = matchingOption ? matchingOption.value : "";
        this.$nextTick(() => {
          $(this.$el).selectpicker("val", this.province);
        });
      }
    }
  },
  computed: {
    title() {
      if (this.country.toUpperCase() === "CA") {
        return t("Select Province");
      }
      if (this.country.toUpperCase() === "US") {
        return t("Select State");
      }
      return "";
    },
    province: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    options() {
      if (!this.country) {
        return null;
      }
      return this.countryProvinces[this.country.toUpperCase()];
    },
    validProvince() {
      if (!this.options) {
        return true;
      }
      if (!this.value) {
        return false;
      }
      return !!this.options.find(opt => opt.value === this.value);
    },
    invalidClass() {
      return this.validProvince ? "" : "is-invalid";
    }
  },
  mounted() {
    if (this.options) {
      $(this.$el).selectpicker("val", this.province);
    }
    this.$emit("valid", this.validProvince);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TierBadgeIcon"] = Vue.component(
                    "TierBadgeIcon",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<img :src=\"url\" height=\"32\" />",
  props: {
    tier: Number
  },
  computed: {
    url() {
      switch (this.tier) {
        case 0:
        default:
          return "/images/badges/player-badge.png";
        case 1:
          return "/images/badges/explorer-badge.png";
        case 2:
          return "/images/badges/game-master-badge.png";
        case 3:
          return "/images/badges/story-teller-badge.png";
        case 4:
          return "/images/badges/world-builder-badge.png";
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["TriStateCheckbox"] = Vue.component(
                    "TriStateCheckbox",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"custom-control custom-switch tristate\" @click=\"clickCheckbox\" @contextmenu.stop.prevent=\"rightClickCheckbox\" > <label class=\"custom-control-label\" :class=\"switchClass\"></label> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".custom-switch.tristate .custom-control-label.disabled::before { background-color: #e9ecef; } .custom-switch.tristate .custom-control-label.checked::before { color: #fff; background-color: var(--success); border-color: var(--success); } .custom-switch.tristate .custom-control-label.unchecked::before { color: #fff; background-color: var(--warning); border-color: var(--warning); } .custom-switch.tristate .custom-control-label::after { left: calc(-1.875rem + 2px); } .custom-switch.tristate .custom-control-label.checked::after { transform: translateX(0.35rem); background-color: #fff; } .custom-switch.tristate .custom-control-label.unchecked::after { transform: translateX(-0.35rem); background-color: #fff; }"
    });
  },
  props: {
    checked: {
      type: Boolean,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    switchClass() {
      if (this.disabled) {
        return "disabled";
      }
      if (this.checked === true) {
        return "checked";
      }
      if (this.checked === false) {
        return "unchecked";
      }
      return "";
    }
  },
  methods: {
    clickCheckbox() {
      if (this.disabled) {
        return;
      }
      if (this.checked === false) {
        this.$emit("change", undefined);
      } else if (this.checked === true) {
        this.$emit("change", false);
      } else {
        this.$emit("change", true);
      }
    },
    rightClickCheckbox() {
      if (this.disabled) {
        return;
      }
      if (this.checked === false) {
        this.$emit("change", true);
      } else if (this.checked === true) {
        this.$emit("change", undefined);
      } else {
        this.$emit("change", false);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["WizardProvider"] = Vue.component(
                    "WizardProvider",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** @typedef {import('./WizardStep.vue').WizardStepItem} WizardStepItem */
/**
 * Manage state for a WizardStepIndicators component and a set of WizardSteps.
 *
 * @see ./WizardStep.vue
 * @see ./WizardStepIndicators.vue
 * @todo Get the wizard steps to slide and fade in/out.
 */
var _default = exports.default = {
  template: "<div class=\"wizard\"> <nav v-if=\"!hideIndicators\" class=\"wizard__progress\"> <wizard-step-indicators :steps=\"enhancedSteps\" @click=\"goToStep\"></wizard-step-indicators> </nav> <section class=\"wizard__content\"> <!-- @slot The step of the workflow to display. @binding active-step-id The ID of the currently active step. @binding steps  The list of \"enhanced\" steps (see this.getEnhancedSteps()) @binding go-to-step  A function to skip to a specific step. @binding go-to-next-step  A function to move to the next step. @binding go-to-previous-step  A function to move to the previous step. @binding mark-step-complete  A function to mark a step as completed by ID @binding mark-step-incomplete  A function to mark a step as incomplete by ID @binding can-go-to-previous-step  Validate if the user can get to the next step @binding can-go-to-next-step  Validate if the user can get to a previous step --> <slot :active-step-id=\"activeStepId\" :steps=\"enhancedSteps\" :go-to-step=\"goToStep\" :go-to-next-step=\"goToNextStep\" :go-to-previous-step=\"goToPreviousStep\" :mark-step-complete=\"markStepComplete\" :mark-step-incomplete=\"markStepIncomplete\" :can-go-to-previous-step=\"canGoToPreviousStep\" :can-go-to-next-step=\"canGoToNextStep\" ></slot> </section> <footer v-if=\"enhancedSteps?.length && !hideNavigation\" class=\"wizard__navigation\"> <b-button v-if=\"canDisplayPreviousStepButton\" :disabled=\"!canGoToPreviousStep\" @click=\"goToPreviousStep\"> {{ t(\"Previous\") }} </b-button> <b-button v-if=\"canDisplayNextStepButton\" :disabled=\"!canGoToNextStep\" variant=\"primary\" @click=\"goToNextStep\"> {{ t(\"Next\") }} </b-button> <b-button v-if=\"canDisplayFinalStepButton\" :disabled=\"!canComplete\" variant=\"success\" @click=\"reportWizardComplete\" > {{ t(\"Complete\") }} </b-button> </footer> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".wizard{width:100%;height:100%;display:flex;gap:1em;flex-direction:column}.wizard__progress{width:100%;max-width:80ch;margin:0 auto 2rem}.wizard__content{overflow:clip auto}.wizard__navigation{width:100%;display:flex;justify-content:space-between;margin:auto auto 0}.wizard__navigation .btn:first-of-type:not(:last-of-type){margin-left:0;margin-right:auto}.wizard__navigation .btn:last-of-type{margin-left:auto;margin-right:0}"
    });
  },
  provide() {
    return {
      wizardStepProvider: {
        registerStep: this.registerStep,
        unregisterStep: this.unregisterStep,
        getActiveStepId: () => this.activeStepId,
        markStepComplete: this.markStepComplete,
        markStepIncomplete: this.markStepIncomplete,
        getNavigationDirection: () => this.navigationDirection
      }
    };
  },
  props: {
    /**
     * The ID of the step to start on in the wizard.
     */
    initialStep: {
      type: String,
      default: null
    },
    /**
     * Should the provider hide the provided previous/next buttons? Note that
     * the default slot's bindings include methods for moving forward and back.
     */
    hideNavigation: {
      type: Boolean,
      default: false
    },
    /**
     * Should the provider hide the provided step indicators? Note that the
     * default slot's bindings include the currently selected step ID, should
     * the parent component wish to display the currently active step in another
     * way.
     */
    hideIndicators: {
      type: Boolean,
      default: false
    },
    /**
     * An (optional) validator function, used to block completion of the wizard.
     */
    validate: {
      type: Function,
      default: () => true
    }
  },
  data() {
    return {
      /**
       * The active step in the wizard.
       * @type {string|null}
       */
      activeStepId: null,
      /**
       * The *not-enriched* set of steps for this wizard.
       * @type {WizardStepItem[]}
       */
      steps: [],
      /**
       * The list of steps in the wizard that were successfully completed.
       * @type {Set<string>}
       */
      completedSteps: new Set(),
      /**
       * The direction that the wizard will animate. Accepts "forward" and "backward"
       */
      navigationDirection: "forward"
    };
  },
  computed: {
    /**
     * @returns {WizardStepItem[]} The set of enriched steps for this wizard.
     */
    enhancedSteps() {
      return this.getEnhancedSteps();
    },
    /**
     * @returns {WizardStepItem} The active step.
     */
    activeStep() {
      return this.steps.find(step => step.id === this.activeStepId);
    },
    /**
     * @todo Is it worth it to have a "validate that we can go back" function on
     * the step component?
     * @returns {boolean} Can we move back a step?
     */
    canGoToPreviousStep() {
      return this.activeStepId !== this.steps?.[0]?.id;
    },
    /**
     * @returns {boolean} Can we display the "previous step" button?
     */
    canDisplayPreviousStepButton() {
      return this.activeStepId !== this.steps?.[0]?.id;
    },
    /**
     * @returns {boolean} Can we move ahead a step?
     */
    canGoToNextStep() {
      return !this.activeStep ? false : this.canDisplayNextStepButton && this.activeStep.validate();
    },
    /**
     * @returns {boolean} Can the "next" button be displayed?
     */
    canDisplayNextStepButton() {
      return this.activeStepId !== this.steps?.[this.steps.length - 1]?.id;
    },
    /**
     * @returns {boolean} Can the "complete" button be active?
     */
    canComplete() {
      return this.canDisplayFinalStepButton && this.validate();
    },
    /**
     * @returns {boolean} Can the "complete" button be displayed?
     */
    canDisplayFinalStepButton() {
      return this.activeStepId === this.steps?.[this.steps.length - 1]?.id;
    }
  },
  methods: {
    /**
     * Given a set of data that makes up a step in the wizard workflow, add it
     * to the list of steps.
     * @param {WizardStepItem} step  A step to add to the workflow.
     */
    registerStep(step) {
      const index = this.steps.findIndex(s => s.id === step.id);
      if (index === -1) {
        this.steps.push(step);
      } else {
        this.$set(this.steps, index, step);
      }
    },
    /**
     * Remove a step from the registry of steps, if it exists.
     * @param {string} stepId  The step to remove.
     */
    unregisterStep(stepId) {
      const index = this.steps.findIndex(step => step.id === stepId);
      if (index !== -1) {
        this.steps.splice(index, 1);
      }
    },
    /**
     * Mark a specific step as the active step, if it exists.
     * @param {string} stepId  The step to move to.
     * @emits step-change
     */
    goToStep(stepId) {
      const currentIndex = this.steps.findIndex(step => step.id === this.activeStepId);
      const targetIndex = this.steps.findIndex(step => step.id === stepId);
      this.navigationDirection = targetIndex > currentIndex ? "forward" : "backward";
      const targetStep = this.steps.find(step => step.id === stepId);
      if (targetStep) {
        this.activeStepId = stepId;
        /**
         * Dispatched when changing the wizard's active step. When listened to, it includes the newly-activated step's ID.
         *
         * @event step-change
         * @property {string} stepId The ID of the newly active step.
         */
        this.$emit("step-change", this.activeStepId);
      }
    },
    /**
     * If there's a step ahead of the current step, mark that step as active.
     * @emits step-change
     */
    goToNextStep() {
      this.navigationDirection = "forward";
      const currentIndex = this.steps.findIndex(step => step.id === this.activeStepId);
      if (currentIndex < this.steps.length - 1) {
        this.activeStepId = this.steps[currentIndex + 1].id;
        this.$emit("step-change", this.activeStepId);
      }
    },
    /**
     * If there's a step behind the current step, mark that step as active.
     * @emits step-change
     */
    goToPreviousStep() {
      this.navigationDirection = "backward";
      const currentIndex = this.steps.findIndex(step => step.id === this.activeStepId);
      if (currentIndex > 0) {
        this.activeStepId = this.steps[currentIndex - 1].id;
        this.$emit("step-change", this.activeStepId);
      }
    },
    /**
     * Given a step ID, add it to the list of completed steps.
     * @param {string} stepId  The step to mark as completed.
     */
    markStepComplete(stepId) {
      const newSet = new Set(this.completedSteps);
      newSet.add(stepId);
      this.completedSteps = newSet;
    },
    /**
     * Given a step ID, remove it from the list of completed steps.
     * @param {string} stepId  The step to remove.
     */
    markStepIncomplete(stepId) {
      const newSet = new Set(this.completedSteps);
      newSet.delete(stepId);
      this.completedSteps = newSet;
    },
    /**
     * Let the parent component know that the wizard would like to complete itself.
     * @emits complete
     */
    reportWizardComplete() {
      /**
       * Dispatched when the wizard attempts to complete itself.
       * @event complete
       */
      this.$emit("complete");
    },
    /**
     * Enrich the wizard's steps with some computed values:
     * - `success`: Did we mark the step as completed?
     * - `active`: Is this the current step?
     * - `inactive`: Did we skip this step?
     * - `class`: The step's CSS class, but forced to an empty string if it's falsy
     *
     * @returns {WizardStepItem[]} The enriched set of steps for this wizard.
     */
    getEnhancedSteps() {
      return this.steps.map((step, index) => {
        const currentStepIndex = this.steps.findIndex(s => s.id === this.activeStepId);
        return {
          ...step,
          success: this.completedSteps.has(step.id),
          active: step.id === this.activeStepId,
          skipped: index > currentStepIndex && !this.completedSteps.has(step.id),
          // Preserve existing class for backwards compatibility
          class: step.class || ""
        };
      });
    }
  },
  created() {
    if (this.initialStep) {
      this.activeStepId = this.initialStep;
    } else if (this.steps.length) {
      this.activeStepId = this.steps[0].id;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["WizardStep"] = Vue.component(
                    "WizardStep",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * A set of metadata for a step in a wizard.
 * @typedef {Object} WizardStepItem
 * @property {string} id The unique identifier for this step.
 * @property {string} name The name of the step, to be displayed in the
 * step indicator
 * @property {string} icon The FontAwesome classes to add to the indicator
 * circle for this step
 * @property {string} class Arbitrary CSS classes to add to the step indicator
 * @property {Function} validate A function that blocks advancement to the step after this one.
 */
/**
 * Given a parent WizardStepProvider, manage the display and completion status
 * of a step in a wizard workflow.
 * @see ./WizardStepProvider.vue
 */
var _default = exports.default = {
  template: "<article v-show=\"isActive\" class=\"wizard-step\" :aria-hidden=\"!isActive\"> <!-- @slot The step of the workflow to display. @binding is-active Is this the active step? @binding is-complete Has this step been completed? --> <slot :is-active=\"isActive\" :is-complete=\"isComplete\"></slot> </article>",
  inject: ["wizardStepProvider"],
  props: {
    /**
     * The unique identifier for the step.
     */
    id: {
      type: String,
      required: true
    },
    /**
     * The name of the step, to be used in the parent wizardStepProvider
     */
    name: {
      type: String,
      required: true
    },
    /**
     * The FontAwesome icon class names to use in the step indicator.
     */
    icon: {
      type: String,
      default: "fas fa-dot-circle"
    },
    /**
     * Should this step be marked as complete already?
     */
    initiallyComplete: {
      type: Boolean,
      default: false
    },
    /**
     * An (optional) validator function, used to block advancement to the next
     * step of the wizard.
     * @todo This could use some more fleshing out.
     */
    validate: {
      type: Function,
      default: () => true
    }
  },
  data() {
    return {
      isComplete: this.initiallyComplete,
      isValid: false
    };
  },
  watch: {
    /**
     * Report complete state to the parent component.
     * @param {boolean} newValue  Is this step completed?
     */
    isComplete(newValue) {
      if (newValue) {
        this.wizardStepProvider.markStepComplete(this.id);
      } else {
        this.wizardStepProvider.markStepIncomplete(this.id);
      }
      this.validateStep();
    }
  },
  computed: {
    /**
     * Given a parent WizardStepProvider component, check if this is
     * the active step.
     * @returns {boolean} Whether or not this step is active, per the
     * parent component.
     */
    isActive() {
      return this.wizardStepProvider.getActiveStepId() === this.id;
    }
  },
  methods: {
    /**
     * Mark this step as complete.
     */
    complete() {
      this.isComplete = true;
    },
    /**
     * Mark this step as incomplete.
     */
    incomplete() {
      this.isComplete = false;
    },
    /**
     * Given a validation method, mark this step as complete or report an error.
     */
    async validateStep() {
      try {
        this.isValid = await this.validate();
        return this.isValid;
      } catch {
        this.isValid = false;
        return false;
      }
    }
  },
  /**
   * Given a step provider, do the following:
   * - Register this step with the step provider
   * - If it's meant to already be complete, mark it as complete.
   */
  created() {
    this.wizardStepProvider.registerStep({
      id: this.id,
      name: this.name,
      icon: this.icon,
      class: "",
      validate: () => this.isValid // Return the cached validation state
    });

    if (this.initiallyComplete) {
      this.wizardStepProvider.markStepComplete(this.id);
    }

    // Initial validation
    this.validateStep();
  },
  /**
   * When the step is removed, remove it from the step provider as well.
   */
  beforeDestroy() {
    try {
      this.wizardStepProvider.unregisterStep(this.id);
      this.wizardStepProvider.markStepIncomplete(this.id);
    } catch {
      /* noop */
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["WizardStepIndicators"] = Vue.component(
                    "WizardStepIndicators",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div :class=\"['wizard-step-indicator', { 'wizard-step-indicator--can-interact': hasClickListener }]\" role=\"tablist\" :aria-label=\"t('Progress Steps')\" > <ol role=\"presentation\"> <li v-for=\"step of steps\" :key=\"step.id\" :data-step-name=\"step.name\" role=\"presentation\" :class=\"[ 'indicator', { success: step.success, inactive: step.skipped, active: step.active, }, step.class, ]\" > <button :id=\"`step-${step.id}`\" class=\"step\" role=\"tab\" :aria-controls=\"`step-panel-${step.id}`\" :aria-selected=\"step.active\" :aria-label=\"step.name\" :tabindex=\"step.active ? 0 : -1\" :disabled=\"!step.success && !step.active\" @click=\"stepClick(step.id)\" > <i v-if=\"step.success\" class=\"fas fa-check text-success\" aria-hidden=\"true\"></i> <i v-else-if=\"step.icon\" :class=\"step.icon\" aria-hidden=\"true\"></i> <i v-else class=\"fas fa-dot-circle\" aria-hidden=\"true\"></i> </button> </li> </ol> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".wizard-step-indicator{padding:20px 0;width:100%;--step-button-size: 20px}.wizard-step-indicator ol{display:flex;justify-content:stretch;align-items:center;list-style:none;margin:0;padding:0;position:relative;width:100%}.wizard-step-indicator ol .indicator{display:flex;position:relative;justify-content:center;flex:1;color:var(--secondary)}.wizard-step-indicator ol .indicator.success{color:var(--success)}.wizard-step-indicator ol .indicator.inactive{color:var(--secondary)}.wizard-step-indicator ol .indicator.active{color:var(--primary)}.wizard-step-indicator ol .indicator.active .step{font-size:calc(var(--step-button-size)*1.5)}.wizard-step-indicator ol .indicator,.wizard-step-indicator ol .indicator::before,.wizard-step-indicator ol .indicator::after,.wizard-step-indicator ol .indicator i{transition:all 333ms ease-in-out,font-size 333ms ease-in-out 125ms;transform-origin:center}.wizard-step-indicator ol .indicator:not(:first-child)::before{content:\"\";position:absolute;top:50%;right:calc(50% + var(--step-button-size));width:calc(100% - var(--step-button-size)*2);height:4px;background-color:var(--secondary);translate:0 -50%;border-radius:2px;transform-origin:center}.wizard-step-indicator ol .indicator:is(.active+.indicator,.indicator+.active)::before{scale:.97 1}.wizard-step-indicator ol .indicator.active+.indicator::before{transform-origin:right}.wizard-step-indicator ol .indicator.indicator+.active::before{transform-origin:left}.wizard-step-indicator ol .indicator::after{position:absolute;bottom:calc(var(--step-button-size)*-1.25);content:attr(data-step-name);color:var(--step-label-color, var(--color-body-text));font-size:.8em;font-weight:600}.wizard-step-indicator ol .indicator .step{display:flex;align-items:center;justify-content:center;width:var(--step-button-size);height:var(--step-button-size);font-size:var(--step-button-size);background:rgba(0,0,0,0);border:none;position:relative;color:inherit}"
    });
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasClickListener() {
      return this.$listeners?.click;
    }
  },
  methods: {
    stepClick(id) {
      this.$emit("click", id);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["WelcomeWizardRegionSelector"] = Vue.component(
                    "WelcomeWizardRegionSelector",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"welcome-wizard__region-selector\"> <div class=\"welcome-wizard__region-selector-content\"> <span class=\"welcome-wizard__region-selector__description\">{{ t(\"To get you the fastest connection to your area, we’re testing the connection to our servers.\") }}</span> <menu class=\"welcome-wizard__region-selector__regions\"> <li v-for=\"region in regions\" :key=\"region.name\" :class=\"{ 'welcome-wizard__region-selector__region': true, 'welcome-wizard__region-selector__region--selected': region.id === selectedRegion?.id, }\" > <button :aria-label=\"region.name\" @click=\"setRegion(region)\"> <span class=\"welcome-wizard__region-selector__region__name\">{{ region.name }}</span> <span class=\"welcome-wizard__region-selector__region__latency\"> <loading-indicator v-if=\"region.pinging\" tag=\"span\" small label=\"\"> </loading-indicator> <template v-else>{{ region.latency !== null ? region.latency : \"&ndash;\" }} </template> </span> </button> </li> </menu> </div> <div class=\"welcome-wizard__region-selector__globe-container\"> <img src=\"https://placehold.co/200x200\" /> </div> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".welcome-wizard__region-selector{color:var(--color-body-text);width:100%;display:flex;gap:1em;align-items:end}.welcome-wizard__region-selector-content{display:flex;flex-direction:column;gap:1em;flex:1}.welcome-wizard__region-selector__description{margin-bottom:auto;margin-top:auto;transform:translateY(-50%)}.welcome-wizard__region-selector__regions{list-style:none;margin:0;padding:0;display:grid;justify-content:space-around;grid-template-columns:repeat(auto-fit, minmax(10ch, 1fr));gap:.5em;flex:1}.welcome-wizard__region-selector__region button{color:var(--color-body-text);background:rgba(0,0,0,0);border-radius:4px;border:none;display:flex;flex-direction:column;text-align:center;width:100%;max-width:15ch;margin:0 auto;padding:.25em .625em;border:1px solid var(--secondary)}.welcome-wizard__region-selector__region button:hover,.welcome-wizard__region-selector__region button:focus{border-color:var(--info)}.welcome-wizard__region-selector__region--selected button{border-color:var(--primary)}.welcome-wizard__region-selector__region--selected .welcome-wizard__region-selector__region__latency{background-color:var(--primary);color:var(--color-light)}:is(.welcome-wizard__region-selector__region__name,.welcome-wizard__region-selector__region__ping){display:block;width:100%;padding:.25em .625em}.welcome-wizard__region-selector__region__latency{background-color:var(--color-table-accent-bg);border-radius:2px;font-size:1rem;line-height:1.6;text-shadow:1px 1px var(--dark)}.welcome-wizard__region-selector__globe-container{max-width:60ch;margin:0 auto}"
    });
  },
  data() {
    return {
      regions: [],
      loading: false,
      selectedRegion: null
    };
  },
  methods: {
    async getRegions() {
      this.loading = true;
      try {
        const regions = await Utils.api("regions");
        if (regions.error) {
          throw new Error(regions.error);
        }
        if (!Array.isArray(regions)) {
          throw new Error("Malformed region data received");
        }
        return regions.map(r => ({
          ...r,
          pinging: true,
          pings: [],
          latency: null
        }));
      } catch (error) {
        UI.alert("danger", t("Error retrieving list of available regions: {{- error}}", {
          error
        }), false, 10000);
      } finally {
        this.loading = false;
      }
    },
    setRegion(region) {
      this.selectedRegion = region;
      this.$emit("change", this.selectedRegion);
    },
    async pingRegionServer(region) {
      const pings = [];
      const url = `https://ping.${region.domain}/api/ping`;
      for (let i = 0; i < 10; i++) {
        pings.push(await this.ping(url));
      }
      const latency = Math.round(Math.min(...pings));
      console.debug(`Ping results to ${url}: (${latency} ms)`, pings);
      return {
        id: region.id,
        pings,
        latency
      };
    },
    async ping(url) {
      const start = performance.now();
      await Utils.fetch(url, {
        cache: "no-cache",
        method: "HEAD"
      }).catch(console.error);
      const end = performance.now();
      return end - start;
    }
  },
  async mounted() {
    this.regions = await this.getRegions();
    const pingSets = await Promise.all(this.regions.map(region => this.pingRegionServer(region)));
    this.regions = this.regions.map(region => ({
      ...region,
      ...pingSets.find(({
        id
      }) => id === region.id),
      pinging: false
    }));
    this.selectedRegion = this.regions.reduce((fastest, region) => {
      if (Number.isNaN(region.latency)) {
        return fastest;
      }
      if (region.latency < fastest.latency) {
        return region;
      }
      return fastest;
    }, this.regions[0]);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CreatorPackageList"] = Vue.component(
                    "CreatorPackageList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div class=\"package-list\"> <b-card no-body> <b-card-header class=\"section-header px-2\"> <slot></slot> <span>{{ listTitle }}</span> <b-button v-b-tooltip.hover variant=\"primary\" class=\"ml-auto\" :title=\"t('Create a new package')\" @click.prevent=\"$emit('create')\" > <i class=\"fas fa-plus\"></i> {{ t(\"Create Package\") }} </b-button> <b-button v-b-tooltip.hover variant=\"primary\" :pressed=\"showSearch\" :title=\"t('Search packages')\" @click.prevent=\"showSearchField\" > <i class=\"fas fa-search\"></i> </b-button> </b-card-header> <b-card-body class=\"p-0\"> <div class=\"d-flex flex-column\"> <b-input-group v-if=\"showSearch\"> <b-input-group-prepend> <!-- Any changes to the text here should also be reflected in searchTypeText --> <b-dropdown :text=\"searchTypeText\"> <b-dropdown-item href=\"#\" @click=\"changeSearchType('any')\"> {{ t(\"Any Terms\") }} </b-dropdown-item> <b-dropdown-item href=\"#\" @click=\"changeSearchType('all')\"> {{ t(\"All Terms\") }} </b-dropdown-item> </b-dropdown> </b-input-group-prepend> <b-form-input v-model=\"searchFilter\" autofocus> </b-form-input> <b-input-group-append is-text> <i class=\"fa fas fa-search\"></i> </b-input-group-append> </b-input-group> <b-table id=\"creator-package-table\" hover stacked=\"md\" show-empty small sticky-header sort-icon-left head-variant=\"light\" class=\"mb-0\" :sort-by.sync=\"sortBy\" :sort-desc.sync=\"sortDesc\" :items=\"filteredList\" :fields=\"packageFields\" :per-page=\"perPage\" :current-page=\"currentPage\" primary-key=\"id\" :tbody-transition-props=\"transitionProps\" > <template #cell(title)=\"{ value, item }\"> <a v-b-tooltip.hover href=\"#\" :title=\"item.name\" @click.prevent=\"$emit('select', item.id)\">{{ value }}</a> </template> <template #cell(price)=\"{ item }\"> <b-form-input v-model=\"item.price\" class=\"text-right\" lazy-formatter :formatter=\"priceFormatter\" @blur.native=\"$emit('change', 'price', item.id, $event.target.value)\" ></b-form-input> </template> <template #cell(sale)=\"{ item }\"> <b-form-input v-model=\"item.sale\" class=\"text-right\" lazy-formatter :formatter=\"priceFormatter\" @blur.native=\"$emit('change', 'sale', item.id, $event.target.value)\" ></b-form-input> </template> <template #cell(approve)=\"{ item }\"> <b-button v-if=\"needsApproval(item)\" v-b-tooltip.hover variant=\"success\" class=\"mt-1\" @click=\"$emit('approve', item)\" >{{ t(\"Approve\") }}</b-button > </template> </b-table> <div v-show=\"filteredList.length > perPage\" class=\"mt-2\"> <b-pagination v-model=\"currentPage\" :total-rows=\"filteredList.length\" :per-page=\"perPage\" align=\"center\" first-number last-number > </b-pagination> </div> </div> </b-card-body> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".sale-column { width: 100px; } .view-link { font-size: 10px; } table#creator-package-table .flip-list-move { transition: transform 1s; } .package-list .section-header { gap: 0.5rem; }"
    });
  },
  props: {
    initialData: Array,
    admin: {
      type: Boolean,
      default: false
    },
    userId: String,
    perPage: {
      type: Number,
      default: 50
    },
    approvals: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortBy: this.admin ? "status" : "title",
      sortDesc: false,
      showSearch: false,
      searchFilter: "",
      searchType: "any",
      hash: null,
      transitionProps: {
        name: "flip-list"
      },
      packages: [],
      currentPage: 1,
      packageFields: [{
        key: "title",
        label: t("Title"),
        sortable: true,
        stickyColumn: true,
        tdClass: "py-3 pl-3 align-middle",
        thClass: "pl-3 border-right"
      }, {
        key: "user",
        label: t("Author"),
        sortable: true,
        tdClass: "py-3 pr-3 align-middle",
        thClass: "border-right"
      }, {
        key: "type",
        label: t("Type"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "created",
        label: t("Created"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right",
        formatter: (value, _, __) => {
          return new Date(value).toLocaleDateString();
        }
      }, {
        key: "status",
        label: t("Status"),
        sortable: true,
        sortByFormatted: value => value.sort,
        tdClass: "py-3 align-middle",
        thClass: "border-right",
        formatter: (value, _, __) => {
          return value.label;
        }
      }, {
        key: "price",
        label: t("Price"),
        sortable: true,
        tdClass: "text-right py-2 sale-column align-middle",
        thClass: "sale-column border-right"
      }, {
        key: "sale",
        label: t("Sale"),
        sortable: true,
        tdClass: "text-right py-2 sale-column align-middle",
        thClass: "sale-column border-right"
      }, {
        key: "installs",
        label: t("Installs"),
        sortable: true,
        tdClass: "text-right py-3 pr-3 align-middle",
        thClass: "border-right",
        formatter: (value, key, item) => {
          return item.stats[key];
        }
      }, {
        key: "sales",
        label: t("Sales"),
        sortable: true,
        sortByFormatted: true,
        tdClass: "text-right py-3 pr-3 align-middle",
        thClass: "border-right",
        formatter: (value, key, item) => {
          return `$ ${item.stats[key].toFixed(2)}`;
        }
      }, {
        key: "revenue",
        label: t("Revenue"),
        sortable: true,
        sortByFormatted: true,
        tdClass: "text-right py-3 pr-3 align-middle",
        thClass: "border-right",
        formatter: (value, key, item) => {
          return `$ ${item.stats[key].toFixed(2)}`;
        }
      }]
    };
  },
  watch: {
    initialData: {
      handler(newValue, oldValue) {
        this.addAdditionalDataToPackages(newValue);
      },
      deep: true
    },
    hash() {
      this.updatePropsFromHash();
    },
    sortBy(newValue, oldValue) {
      this.buildHash({
        sort: newValue
      });
    },
    sortDesc(value) {
      this.buildHash({
        sortdesc: value
      });
    },
    searchFilter(value) {
      this.buildHash({
        search: value
      });
      this.currentPage = 1;
    }
  },
  computed: {
    filteredList() {
      const packageList = this.approvals ? this.packages.filter(p => p.status.name === "approval") : this.packages;
      if (this.searchFilter) {
        const searchTerms = this.searchFilter.toLowerCase().split(" ");
        return packageList.filter(p => {
          const searchFn = this.searchType === "any" ? searchTerms.some : searchTerms.every;
          return searchFn.call(searchTerms, t => (p.title || "").toLowerCase().includes(t)) || searchFn.call(searchTerms, t => (p.user || "").toLowerCase().includes(t)) || searchFn.call(searchTerms, t => (p.type || "").toLowerCase().includes(t)) || searchFn.call(searchTerms, t => (p.status.label || "").toLowerCase().includes(t));
        });
      }
      return packageList;
    },
    searchTypeText() {
      // Any changes to the text here should also be reflected in the related select element
      return this.searchType === "any" ? t("Any Terms") : t("All Terms");
    },
    listTitle() {
      if (!this.admin) {
        return t("Creator Package List");
      }
      if (this.approvals) {
        return t("Packages awaiting approval");
      }
      return t("All packages");
    }
  },
  methods: {
    updatePropsFromHash() {
      if (window.location.hash) {
        const hash = Utils.hashProps(window.location.hash);
        this.viewAll = hash.view === undefined ? this.viewAll : hash.view === "true";
        this.sortBy = hash.sort || this.sortBy;
        this.sortDesc = hash.sortdesc === undefined ? this.sortDesc : hash.sortdesc === "true";
        this.showSearch = hash.showSearch === undefined ? this.showSearch : hash.showSearch === "true";
        this.searchFilter = hash.search || this.searchFilter;
        this.searchType = ["any", "all"].includes(hash.searchType) ? hash.searchType : this.searchType;
      }
    },
    status(pkg) {
      if (pkg.manifest === null) {
        return {
          name: "unavailable",
          sort: 3,
          label: t("Unavailable"),
          variant: "secondary"
        };
      } else if (!pkg.marketplace.ready) {
        return {
          name: "unpublished",
          sort: 1,
          label: t("Waiting to be published"),
          variant: "warning"
        };
      } else if (!pkg.available) {
        return {
          name: "approval",
          sort: 0,
          label: t("Waiting to be approved"),
          variant: "info"
        };
      } else if (pkg.available) {
        return {
          name: "published",
          sort: 2,
          label: t("Published"),
          variant: null
        };
      }
      return {
        name: "unavailable",
        sort: 3,
        label: t("Unavailable"),
        variant: "secondary"
      };
    },
    needsApproval(item) {
      return item.status.name === "approval";
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    addAdditionalDataToPackages(data) {
      this.packages = data.map(p => {
        const status = this.status(p);
        return Object.assign(p.data, p.marketplace, {
          stats: p.stats,
          status: status,
          _rowVariant: status.variant,
          user: p.user.name,
          creatorId: p.user.id
        });
      });
    },
    showSearchField() {
      this.showSearch = !this.showSearch;
      this.buildHash({
        showSearch: this.showSearch
      });
    },
    changeSearchType(type) {
      if (!["any", "all"].includes(type)) {
        return;
      }
      this.searchType = type;
      this.buildHash({
        searchType: this.searchType
      });
    },
    priceFormatter(value) {
      // Format the price to exclude any non-numeric characters
      return value.replace(/[^-.0-9]/g, "");
    }
  },
  created() {
    this.addAdditionalDataToPackages(this.initialData);
    if (this.admin) {
      // Add a column with an approval button for admins
      this.packageFields.push({
        key: "approve",
        label: t("Approve"),
        thClass: "text-center",
        tdClass: "text-center"
      });
    }
    this.updatePropsFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => {
      this.hash = window.location.hash;
    });
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["CreatorProfile"] = Vue.component(
                    "CreatorProfile",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"Creator Profile\") }} <div v-b-tooltip.hover class=\"header-buttons\" :class=\"!canViewProfile ? 'disabled' : ''\" :title=\"profileLinkTooltip\" > <b-button variant=\"primary\" :disabled=\"!canViewProfile\" class=\"float-right\" @click=\"viewProfile\"> <i class=\"fas fa-eye\"></i> {{ t(\"View Profile\") }} </b-button> </div> </b-card-header> <b-card-body> <b-row cols=\"1\" cols-xl=\"2\"> <b-col> <!-- Display Name --> <b-form-group label-cols=\"3\" label-for=\"name\"> <template #label> <span v-show=\"isNameModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> {{ t(\"Display name\") }} </template> <b-form-input v-model=\"creatorData.name\" type=\"text\" name=\"name\" :placeholder=\"t('Creator Name')\" ></b-form-input> </b-form-group> <!-- Vanity URL --> <b-form-group label-cols=\"3\" label-for=\"vanity\"> <template #label> <span v-show=\"isVanityModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> {{ t(\"URL\") }} </template> <div v-if=\"!!creator.vanity\" v-b-tooltip.hover class=\"input-group-text vanity-url-link\" :title=\"t('Click to copy link to clipboard')\" @click=\"copyProfileLinkToClipboard\" > {{ forgeLink }}{{ creator.vanity }} </div> <b-input-group v-else> <template #prepend> <b-input-group-text> {{ forgeLink }} </b-input-group-text> </template> <b-form-input id=\"input-vanity\" v-model=\"creatorData.vanity\" type=\"text\" name=\"vanity\" autocomplete=\"off\" aria-describedby=\"input-vanity-help input-vanity-feedback\" :state=\"isVanityTaken ? false : null\" :formatter=\"vanityFormatter\" ></b-form-input> <template v-if=\"checkingVanity\" #append> <b-input-group-text> <i class=\"fas fa-sync fa-spin\"></i> </b-input-group-text> </template> </b-input-group> <b-form-invalid-feedback id=\"input-vanity-feedback\"> {{ t(\"This URL has already been taken!\") }} </b-form-invalid-feedback> <b-form-text v-if=\"!creator.vanity\" id=\"input-vanity-help\"> {{ t(\"Please be aware that once set, your URL cannot be changed.\") }} </b-form-text> </b-form-group> <b-row> <b-col md=\"auto\"> <!-- Avatar --> <div class=\"image-container avatar-image text-center p-0\"> <span v-show=\"isAvatarModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\" class=\"position-absolute unsaved-image mt-1\" > <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> <b-button v-if=\"hasAvatarImage\" v-b-tooltip.hover.top=\"t('Clear Avatar')\" class=\"position-absolute delete-image\" size=\"sm\" @click=\"clearAvatar\" > <i class=\"fas fa-trash\"></i> </b-button> <div v-if=\"showAvatarIcon\" class=\"position-absolute upload-icon\"> <i v-if=\"dragging\" class=\"fas fa-download\"></i> <i v-else-if=\"avatarLoading\" class=\"fas fa-sync fa-spin\"></i> <i v-else-if=\"avatarError\" class=\"fas fa-exclamation-triangle\"></i> <i v-else class=\"fas fa-upload\"></i> </div> <b-img id=\"creator-avatar-image\" rounded class=\"creator-upload-image\" :title=\"t('Click to change')\" :src=\"avatarImage\" @load=\"loadedAvatar\" @error=\"errorLoadingImage\" ></b-img> <div class=\"rounded avatar-click-indicator upload-click-indicator position-absolute\" :class=\"dragging ? 'dragging' : ''\" :title=\"avatarError ? t('Error loading Avatar image') : ''\" @dragover.prevent=\"dragging = true\" @dragenter=\"dragging = true\" @dragend=\"dragging = false\" @dragleave=\"dragging = false\" @drop.prevent=\"dropAvatarFile\" @click=\"selectAvatar\" > <span v-if=\"dragging\"> {{ t(\"Drop Image Here\") }} </span> <span v-else> {{ t(\"Click to change Avatar\") }} </span> </div> <b-form-file ref=\"fileAvatarInput\" v-model=\"fileAvatar\" class=\"d-none\" accept=\"image/*\"> </b-form-file> </div> <b-form-text class=\"text-center\"> {{ t(\"Dimensions:\") }} 100x100 </b-form-text> </b-col> <b-col> <!-- Banner --> <div class=\"image-container banner-image text-center p-0\"> <span v-show=\"isBannerModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\" class=\"position-absolute unsaved-image mt-1\" > <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> <b-button v-if=\"hasBannerImage\" v-b-tooltip.hover.top=\"t('Clear Banner')\" class=\"position-absolute delete-image\" size=\"sm\" @click=\"clearBanner\" > <i class=\"fas fa-trash\"></i> </b-button> <div v-if=\"showBannerIcon\" class=\"position-absolute upload-icon\"> <i v-if=\"dragging\" class=\"fas fa-download\"></i> <i v-else-if=\"bannerLoading\" class=\"fas fa-sync fa-spin\"></i> <i v-else-if=\"bannerError\" class=\"fas fa-exclamation-triangle\"></i> <i v-else class=\"fas fa-upload\"></i> </div> <b-img id=\"creator-banner-image\" rounded class=\"creator-upload-image\" :title=\"t('Click to change')\" :src=\"bannerImage\" @load=\"loadedBanner\" @error=\"errorLoadingBanner\" ></b-img> <div class=\"rounded banner-click-indicator upload-click-indicator position-absolute\" :class=\"dragging ? 'dragging' : ''\" :title=\"bannerError ? t('Error loading Banner image') : ''\" @dragover.prevent=\"dragging = true\" @dragenter=\"dragging = true\" @dragend=\"dragging = false\" @dragleave=\"dragging = false\" @drop.prevent=\"dropBannerFile\" @click=\"selectBanner\" > <span v-if=\"dragging\"> {{ t(\"Drop Image Here\") }} </span> <span v-else> {{ t(\"Click to change Banner\") }} </span> </div> <b-form-file ref=\"fileBannerInput\" v-model=\"fileBanner\" class=\"d-none\" accept=\"image/*\"> </b-form-file> </div> <b-form-text class=\"text-center\"> {{ t(\"Dimensions:\") }} 1600x400 </b-form-text> </b-col> </b-row> </b-col> <b-col> <!-- Social Links --> <b-card class=\"border border-info social-link-container\"> <template #header> <h6 class=\"mb-0\"><i class=\"fas fa-handshake\"></i> {{ t(\"Social Links\") }}</h6> </template> <b-form-group v-for=\"(value, key) in socialLinks\" :key=\"key\" label-cols=\"4\" class=\"mb-2\"> <template #label> <img :src=\"`/images/social/${value.icon}`\" width=\"30\" height=\"30\" />&nbsp; <span v-show=\"isSocialLinkModified(key)\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> {{ value.name }} </template> <b-input-group> <template v-if=\"socialDisplayLink(key)\" #prepend> <b-input-group-text> {{ socialDisplayLink(key) }} </b-input-group-text> </template> <b-form-input v-model=\"creatorData.social[key]\" v-b-tooltip.hover.top.viewport type=\"text\" :name=\"key\" :state=\"socialLinkValid(key)\" :title=\"socialValidTooltip(key)\" @input=\"cleanSocialLink(key)\" ></b-form-input> <template #append> <b-button v-b-tooltip.hover.top.viewport :disabled=\"!creatorData.social[key]\" :title=\"t('Open {{- link}} in a new tab', { link: socialLink(key) })\" @click=\"openSocialLink(key)\" > <i class=\"fas fa-external-link-alt\"></i> </b-button> </template> </b-input-group> </b-form-group> </b-card> </b-col> </b-row> <b-row class=\"mt-4\"> <b-col> <!-- Bio --> <b-card no-body class=\"border border-warning\"> <b-card-header class=\"section-header\"> <span v-show=\"isBioModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a> &nbsp; </span> {{ t(\"Bio\") }} </b-card-header> <b-card-body class=\"p-0\"> <tiny-mce v-model=\"creatorData.description\" name=\"description\" class=\"w-100\" :settings=\"tinymceSettings\" > </tiny-mce> </b-card-body> </b-card> </b-col> </b-row> </b-card-body> </b-card> <b-toaster name=\"creator-profile-toaster\" :class=\"toastIntersected ? '' : 'fixed'\"></b-toaster> <!-- Add padding to avoid toaster jumping from fixed to non fixed then add intersection observer beneath the padding --> <div :style=\"!toastIntersected && isProfileChanged ? 'height: 70px' : ''\"></div> <intersection @enter=\"toastIntersected = true\" @leave=\"toastIntersected = false\"> <div></div> </intersection> <!-- Pending modifications toaster --> <b-toast key=\"toast\" :visible=\"isProfileChanged\" toaster=\"creator-profile-toaster\" variant=\"primary\" no-auto-hide no-close-button > <div class=\"text-center\" :class=\"toastAnimationClass\"> {{ t(\"You have unsaved changes to your creator profile.\") }} <b-button size=\"sm\" class=\"m-1\" variant=\"secondary\" @click.prevent=\"resetChanges\" ><i class=\"fas fa-undo\"></i> {{ t(\"Reset changes\") }}</b-button > <b-button size=\"sm\" class=\"m-1\" variant=\"success\" :disabled=\"savingProfile\" @click.prevent=\"saveCreatorProfile\"> <loading-indicator v-if=\"savingProfile\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else> <i class=\"fas fa-save\"></i> {{ t(\"Save Changes\") }} </span> </b-button> </div> </b-toast> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".unsaved-image { z-index: 1; text-shadow: black 0 0 5px; } .delete-image { z-index: 1; right: 5px; top: 5px; font-size: 20px; opacity: 0; cursor: pointer; } .image-container { position: relative; display: flex; justify-content: center; } .image-container:hover .delete-image { opacity: 0.5; } .image-container .delete-image:hover { opacity: 0.9; } .creator-upload-image { width: 190px; height: 190px; object-fit: contain; cursor: pointer; background-color: rgba(248, 248, 248, 0.9); } #creator-banner-image { width: 100%; } .upload-click-indicator { position: absolute; width: 190px; height: 190px; background: rgba(255, 255, 255, 0.5); border: 2px dashed #c0c0c0; text-shadow: 1px 0 0 #fff, 0 -1px 0 #fff, 0 1px 0 #fff, -1px 0 0 #fff; color: #808080; top: 0px; text-align: center; line-height: 190px; font-weight: bold; cursor: pointer; } .upload-click-indicator.banner-click-indicator { width: 100%; left: 0px; right: 0px; } .upload-click-indicator:not(.dragging):hover { opacity: 0; } .upload-click-indicator.dragging { border-width: 4px; } .upload-icon { width: 190px; height: 190px; line-height: 190px; font-size: 120px; color: rgba(0, 0, 0, 0.3); pointer-events: none; left: 50%; margin-left: -95px; } .b-toaster.creator-profile-toaster.fixed { position: fixed; bottom: 0.5rem; left: 0.5rem; right: 0.5rem; margin: 0px; padding: 0px; } .b-toaster.creator-profile-toaster .b-toaster-slot, .b-toaster.creator-profile-toaster .b-toaster-slot .b-toast, .b-toaster.creator-profile-toaster .b-toaster-slot .toast { width: 100%; max-width: 100%; } .mde-editor .mde-halfscreen.editor-preview-active-side { width: calc(50% - 100px); bottom: 100px; top: 150px; right: 100px; z-index: 1050; } .mde-editor .editor-toolbar.fullscreen { width: calc(100% - 200px); top: 100px; left: 100px; z-index: 1050; } .mde-editor .CodeMirror-sided { width: calc(50% - 100px) !important; } .mde-editor .CodeMirror-fullscreen { top: 150px; left: 100px; right: 100px; bottom: 100px; height: auto; z-index: 1050; } .no-select { -webkit-user-select: none; /* Safari */ -ms-user-select: none; /* IE 10 and IE 11 */ user-select: none; /* Standard syntax */ } .vanity-url-link { cursor: pointer; } .creator-manager-tabs button.disabled, .creator-manager-tabs .header-buttons.disabled { cursor: not-allowed !important; } .social-link-container fieldset:last-child { margin-bottom: 0px; }"
    });
  },
  props: {
    creator: Object
  },
  data() {
    return {
      saving: false,
      creatorData: {
        social: {}
      },
      isVanityTaken: false,
      dragging: false,
      checkingVanity: null,
      fileAvatar: null,
      avatarPreview: null,
      avatarShowing: null,
      avatarLoading: true,
      avatarError: false,
      fileBanner: null,
      bannerPreview: null,
      bannerShowing: null,
      bannerLoading: true,
      bannerError: false,
      socialLinks: {
        website: {
          name: t("Website"),
          icon: "website-icon.png",
          link: ["{0}"]
        },
        twitter: {
          name: t("Twitter"),
          icon: "twitter.png",
          link: ["https://twitter.com/{0}"]
        },
        facebook: {
          name: t("Facebook"),
          icon: "facebook.png",
          link: ["https://facebook.com/{0}", "https://www.facebook.com/{0}"]
        },
        patreon: {
          name: t("Patreon"),
          icon: "patreon.png",
          link: ["https://patreon.com/{0}", "https://www.patreon.com/{0}"]
        },
        discord: {
          name: t("Discord"),
          icon: "discord.png",
          link: ["https://discord.gg/{0}"]
        }
      },
      unsavedTooltipTitle: t("Modified value is not saved"),
      takenTooltipTitle: t("Vanity URL has already been taken"),
      tinymceSettings: {
        language: "en",
        height: 500,
        menubar: true,
        plugins: ["advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor", "searchreplace", "visualblocks", "code", "fullscreen", "insertdatetime", "media", "table", "code", "help", "wordcount"],
        toolbar: "undo redo | formatselect | bold italic forecolor backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help",
        promotion: false // Disable TinyMCE advertisement
      },

      toastAnimationClass: "animate__animated animate__fast animate__tada",
      toastIntersected: false,
      savingProfile: false,
      blankImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    };
  },
  watch: {
    async fileAvatar(newValue, oldValue) {
      this.avatarLoading = true;
      this.avatarError = false;
      this.avatarPreview = await this.encodePreview(newValue);
      this.avatarLoading = false;
    },
    async fileBanner(newValue, oldValue) {
      this.bannerLoading = true;
      this.bannerError = false;
      this.bannerPreview = await this.encodePreview(newValue);
      this.bannerLoading = false;
    }
  },
  computed: {
    avatarImage() {
      if (this.dragging) {
        return "";
      }
      return this.avatarPreview || this.avatarShowing || this.blankImage;
    },
    bannerImage() {
      if (this.dragging) {
        return "";
      }
      return this.bannerPreview || this.bannerShowing || this.blankImage;
    },
    hasAvatarImage() {
      return !!(this.avatarPreview || this.avatarShowing);
    },
    hasBannerImage() {
      return !!(this.bannerPreview || this.bannerShowing);
    },
    showAvatarIcon() {
      return !this.hasAvatarImage || this.dragging || this.avatarLoading || this.avatarError;
    },
    showBannerIcon() {
      return !this.hasBannerImage || this.dragging || this.bannerLoading || this.bannerError;
    },
    isNameModified() {
      return this.creator.name !== this.creatorData.name;
    },
    isVanityModified() {
      return this.creator.vanity !== this.creatorData.vanity && !this.isVanityTaken;
    },
    areSocialLinksModified() {
      return Object.keys(this.socialLinks).some(link => this.isSocialLinkModified(link));
    },
    isBioModified() {
      return this.creator.description !== this.creatorData.description;
    },
    isAvatarModified() {
      return this.fileAvatar !== null || (this.creator.picture || "") !== (this.avatarShowing || "");
    },
    isBannerModified() {
      return this.fileBanner !== null || (this.creator.banner || "") !== (this.bannerShowing || "");
    },
    isProfileChanged() {
      return (this.isNameModified || this.isVanityModified || this.areSocialLinksModified || this.isBioModified || this.isAvatarModified || this.isBannerModified) && !this.isVanityTaken;
    },
    canViewProfile() {
      return !this.saving && this.creatorData.vanity && !this.isVanityTaken && !this.isProfileChanged;
    },
    profileLinkTooltip() {
      if (this.canViewProfile) {
        return t("View Profile");
      }
      if (!this.creatorData.vanity) {
        return t("You must set your URL before you can view your profile");
      }
      if (this.isProfileChanged) {
        return t("Save or reset your changes before viewing your profile");
      }
      if (this.saving) {
        return t("Please wait while your changes are saved");
      }
    },
    forgeLink() {
      return "forge-vtt.com/creator/";
    }
  },
  methods: {
    async encodePreview(value) {
      if (value) {
        // as soon as the user uploads an image to fileAvatar or fileBanner, we generate a base64 version of the image
        // so that the user can preview the changes before uploading the file.
        return await Utils.getDataURL(value);
      }
    },
    toastNeedsAttention() {
      this.toastAnimationClass = "";
      this.$nextTick(() => {
        this.toastAnimationClass = "animate__animated animate__fast animate__tada";
      });
    },
    vanityFormatter(value) {
      const slugVanity = Utils.slugify(value);
      if (slugVanity && slugVanity.length >= 3) {
        // Check to see that the vanity isn't already taken
        // Do it async so we return immediately the formatted vanity
        const checkId = this.checkingVanity + 1;
        this.checkingVanity = checkId;
        Utils.api(`profile/creator/check-vanity?vanity=${slugVanity}`).then(vanityExists => {
          if (this.checkingVanity === checkId) {
            this.isVanityTaken = !!vanityExists.exists;
            this.checkingVanity = null;
          }
        });
      } else {
        this.isVanityTaken = false;
      }
      return slugVanity;
    },
    cleanSocialLink(key) {
      // Make sure the creator's social links don't include the site's base URL, since we add it automatically
      for (link of this.socialLinks[key].link) {
        const linkPrefix = link.replace("{0}", "");
        if (linkPrefix && this.creatorData.social[key].startsWith(linkPrefix)) {
          this.creatorData.social[key] = this.creatorData.social[key].replace(linkPrefix, "");
          return;
        }
      }
    },
    isSocialLinkModified(link) {
      return (this.creator.social[link] || "") !== (this.creatorData.social[link] || "");
    },
    updateSocialValue(key, value) {
      this.$emit("input", {
        ...this.creatorData.social,
        [key]: value
      });
    },
    socialLinkValid(key) {
      const link = this.creatorData.social[key];
      if (link && this.socialLinks[key].link[0] !== "{0}" && (link.startsWith("http://") || link.startsWith("https://"))) {
        return false;
      }
      return null;
    },
    socialValidTooltip(key) {
      if (this.socialLinkValid(key) === false) {
        return t("Only enter your user ID, not the whole URL");
      }
    },
    resetChanges() {
      this.fileAvatar = null;
      this.fileBanner = null;
      this.avatarPreview = null;
      this.bannerPreview = null;
      this.avatarShowing = this.creator.picture;
      this.bannerShowing = this.creator.banner;
      this.avatarError = false;
      this.bannerError = false;
      const defaultLinks = {};
      for (const key of Object.keys(this.socialLinks)) {
        defaultLinks[key] = "";
      }
      this.creatorData = {
        name: this.creator.name,
        vanity: this.creator.vanity,
        description: this.creator.description,
        social: Object.assign(defaultLinks, this.creator.social)
      };
    },
    async saveCreatorProfile() {
      this.savingProfile = true;
      if (this.fileAvatar) {
        const avatar = await Assets.uploadFiles("avatars", [this.fileAvatar]);
        if (!avatar.success) {
          UI.alert("danger", t(`Error uploading avatar picture`), true);
        }
        this.fileAvatar = null;
        const urls = avatar.results.map(r => r.url).filter(u => !!u);
        this.creatorData.picture = this.avatarShowing = urls[0];
      }
      if (this.fileBanner) {
        const banner = await Assets.uploadFiles("banners", [this.fileBanner]);
        if (!banner.success) {
          UI.alert("danger", t(`Error uploading banner picture`), true);
        }
        this.fileBanner = null;
        const urls = banner.results.map(r => r.url).filter(u => !!u);
        this.creatorData.banner = this.bannerShowing = urls[0];
      }
      const result = await Utils.api("profile/creator", this.creatorData);
      if (!result.success) {
        UI.error(result.msg || result.error || t(`Error communicating with server`));
        this.savingProfile = false;
      } else {
        this.$emit("update", result.data);
        UI.success(t(`Your creator profile information has been updated.`));
        this.savingProfile = false;
      }
    },
    selectAvatar() {
      this.$refs.fileAvatarInput.$el.childNodes[0].click();
    },
    dropAvatarFile(e) {
      this.dragging = false;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) {
        return;
      }
      this.fileAvatar = droppedFiles[0];
    },
    selectBanner() {
      this.$refs.fileBannerInput.$el.childNodes[0].click();
    },
    dropBannerFile(e) {
      this.dragging = false;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) {
        return;
      }
      this.fileBanner = droppedFiles[0];
    },
    loadedAvatar(ev) {
      this.avatarLoading = false;
    },
    loadedBanner(ev) {
      this.bannerLoading = false;
    },
    errorLoadingImage(ev) {
      this.avatarError = true;
      this.avatarLoading = false;
      Utils.errorLoadingImage(ev, this.blankImage);
    },
    errorLoadingBanner(ev) {
      this.bannerError = true;
      this.bannerLoading = false;
      Utils.errorLoadingImage(ev, this.blankImage);
    },
    clearAvatar() {
      this.fileAvatar = null;
      this.avatarShowing = "";
      this.creatorData.picture = "";
      // Set the preview to a blank image
      this.avatarPreview = null;
    },
    clearBanner() {
      this.fileBanner = null;
      this.bannerShowing = "";
      this.creatorData.banner = "";
      // Set the preview to a blank image
      this.bannerPreview = null;
    },
    viewProfile() {
      if (!this.creator.vanity) {
        return;
      }
      const link = `/creator/${this.creator.vanity}`;
      window.open(link, "_blank");
    },
    copyProfileLinkToClipboard() {
      navigator.clipboard.writeText(`forge-vtt.com/creator/${this.creator.vanity}`);
      UI.info(t("Copied Creator profile link to clipboard"));
    },
    socialDisplayLink(key) {
      return (this.socialLinks[key].link[0] || "").replace("{0}", "");
    },
    socialLink(key) {
      return (this.socialLinks[key].link[0] || "{0}").replace("{0}", this.creatorData.social[key]);
    },
    openSocialLink(key) {
      window.open(this.socialLink(key), "_blank");
    }
  },
  mounted() {
    this.resetChanges();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PackageStatusIndicator"] = Vue.component(
                    "PackageStatusIndicator",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<i v-b-tooltip.hover.viewport.top=\"t('This package {{status.tooltip}}', { status })\" class=\"no-select fas\" :class=\"status.icon\" :style=\"`color: ${status.colour};`\" ></i>",
  props: {
    package: Object
  },
  data() {
    return {
      statuses: {
        unavailable: {
          colour: "dimgray",
          icon: "fa-file-download",
          tooltip: t("is waiting to be uploaded")
        },
        unpublished: {
          colour: "gold",
          icon: "fa-edit",
          tooltip: t("is ready to be published")
        },
        approval: {
          colour: "orange",
          icon: "fa-hourglass-half",
          tooltip: t("is waiting to be approved")
        },
        published: {
          colour: "green",
          icon: "fa-check-square",
          tooltip: t("has been published")
        }
      }
    };
  },
  computed: {
    status() {
      if (this.package.manifest === null) {
        return this.statuses.unavailable;
      } else if (!this.package.marketplace.ready) {
        return this.statuses.unpublished;
      } else if (!this.package.available) {
        return this.statuses.approval;
      } else if (this.package.available) {
        return this.statuses.published;
      }
      return this.statuses.unavailable;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["PatreonIntegrationManager"] = Vue.component(
                    "PatreonIntegrationManager",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"xl\" :title=\"t('Manage your Patreon integrations')\" content-class=\"forge-patreon-integration-manager\" no-close-on-backdrop @hidden=\"visible = false\" @show=\"reset\" > <template> <div v-if=\"dataLoading\"> <div class=\"text-center\"> {{ t(\"Retreiving your account information, please wait.\") }} <div class=\"spinner-border\" role=\"status\"></div> </div> </div> <b-alert v-else-if=\"error\" variant=\"danger\" show> {{ errorMsg }} </b-alert> <div v-else> <wizard-step-indicators :steps=\"currentSteps\" @click=\"clickStep\"> </wizard-step-indicators> <hr /> <div v-if=\"success\"> <div class=\"alert alert-success\" role=\"alert\"> {{ t(\"Your integrations have been updated successfully!\") }} </div> </div> <div v-else-if=\"activeStep('integrations')\"> <p> {{ t( \"Patreon integrations allows The Forge to support modules or assets that are only available to your Patreon supporters.\" ) }} </p> <p>{{ t(\"The Forge charges $ 5 per 5 slots, rounded up to the nearest 5, to cover hosting costs.\") }}</p> <p> {{ t( \"Changes to the number of slots available will be reflected in this months invoice, and you will be charged for the maximum number requested during the month.\" ) }} </p> <p> {{ t( \"Any decreases to slots will be effective at the start of the next month, any increases will be effective immediately.\" ) }} </p> <b-alert v-if=\"available === 0\" show> <b-row> <b-col> {{ t(\"You currently have no slots available for Patreon integrations.\") }} </b-col> </b-row> </b-alert> <b-alert v-else show> <i18n :path=\"t('You are using {0} of {1} integration slots')\"> <strong>{{ used }}</strong> <strong>{{ available }}</strong> </i18n> <b-progress :max=\"available\"> <b-progress-bar :value=\"used\"></b-progress-bar> </b-progress> </b-alert> <b-form-group label-cols-lg=\"6\" label-class=\"text-right\"> <template #label>{{ t(\"Integration Slots:\") }}</template> <b-input-group> <b-input-group-prepend> <b-button variant=\"info\" @click=\"changeSlots(-1)\"> <i class=\"fas fa-chevron-left\"></i> </b-button> </b-input-group-prepend> <b-form-input v-model=\"slots\" class=\"slot-input text-center\" type=\"number\" @change=\"checkSlots\" ></b-form-input> <b-input-group-append> <b-button variant=\"info\" @click=\"changeSlots(1)\"> <i class=\"fas fa-chevron-right\"></i> </b-button> </b-input-group-append> </b-input-group> </b-form-group> </div> <div v-else-if=\"activeStep('billing')\"> <b-alert variant=\"warning\" :show=\"!email_verified\"> {{ t( \"Your email address is not verified. Make sure you have entered the correct email address so you can receive your invoice, payment receipts and other related communications.\" ) }} </b-alert> <i18n :path=\"t('Please enter your billing information. {0}')\" tag=\"p\"> <b>{{ t(\"This must match the information on your payment method.\") }}</b> </i18n> <div class=\"billing-error-messages\"></div> <billing-information v-model=\"billing\" @complete=\"completeStep('billing', $event)\"></billing-information> <div v-if=\"processing\" class=\"text-center\"> <b-spinner label=\"Processing\"></b-spinner> {{ t(\"Saving billing information, please wait…\") }} </div> </div> <div v-else-if=\"activeStep('payment')\"> <div v-if=\"stepLoading\" class=\"text-center\"> <b-spinner label=\"Processing\"></b-spinner> {{ t(\"Loading payment information, please wait…\") }} </div> <payment-details v-else ref=\"payment\" v-model=\"complete\" :billing=\"billing\" :providers=\"providers\" :trial=\"trial\" :current=\"currentPaymentDetails\" @input=\"completeStep('payment', $event)\" ></payment-details> </div> <div v-else-if=\"activeStep('preview')\"> {{ t(\"At the end of the month you will be charged {totalCharge}\", { totalCharge }) }} <span v-if=\"slots < available\"> {{ t(\"Next month your slots will be reduced to {slots}\", { slots }) }} </span> <span v-else> {{ t(\"Your slots will be increased to {slots}\", { slots }) }} </span> </div> </div> </template> <template #modal-footer=\"{ ok, cancel }\"> <b-row class=\"w-100\"> <b-col class=\"text-right\"> <b-button v-if=\"showMovePrev\" variant=\"secondary\" :disabled=\"stepLoading || processing\" @click=\"prev\"> <i class=\"fas fa-chevron-left\"></i> {{ prevLabel }} </b-button> <b-button v-if=\"showMoveNext\" variant=\"primary\" :disabled=\"!canMoveNext || stepLoading || processing\" @click=\"next\" >{{ nextLabel }} <i class=\"fas fa-chevron-right\"></i> </b-button> <b-button v-if=\"showFinish\" variant=\"primary\" :disabled=\"stepLoading || processing\" @click=\"finish\">{{ t(\"Confirm Integrations\") }}</b-button> <b-button v-if=\"success\" variant=\"success\" @click=\"ok\">{{ t(\"OK\") }}</b-button> <b-button v-if=\"error\" variant=\"danger\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </b-col> </b-row> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: "/* Chrome, Safari, Edge, Opera */ input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; } /* Firefox */ .slot-input { -moz-appearance: textfield; flex: 0 0 100px !important; }"
    });
  },
  props: {
    value: Boolean,
    available: Number,
    used: Number
  },
  data() {
    return {
      dataLoading: true,
      error: "",
      warning: "",
      success: false,
      stepLoading: false,
      processing: false,
      email_verified: true,
      slots: 0,
      step: 0,
      steps: [{
        code: "integrations",
        name: t("Integrations"),
        done: false
      }, {
        code: "billing",
        name: t("Billing"),
        done: false
      }, {
        code: "payment",
        name: t("Payment Details"),
        done: false
      }, {
        code: "preview",
        name: t("Confirm"),
        done: false
      }],
      // need these for payment
      originalBilling: {},
      billing: {},
      providers: {},
      trial: 0,
      complete: true,
      currentPaymentDetails: "",
      paymentInfo: {},
      // need these for preview
      preview_invoice: null,
      country: null,
      currency: "",
      exchangeRates: null,
      futureInvoiceDate: ""
    };
  },
  watch: {
    step(value) {
      this.loadStep(this.steps[value].code);
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    prevLabel() {
      return t("Previous");
    },
    nextLabel() {
      return t("Next");
    },
    showMovePrev() {
      return this.step !== 0 && !this.error && !this.success;
    },
    showMoveNext() {
      return this.step < this.steps.length - 1 && !this.error && !this.success;
    },
    showFinish() {
      return this.step === this.steps.length - 1 && !this.error && !this.success;
    },
    canMoveNext() {
      return this.currentStep.done !== false;
    },
    currentStep() {
      return this.steps[this.step];
    },
    errorMsg() {
      return this.error;
    },
    currentSteps() {
      return this.steps.map(step => {
        return {
          id: step.code,
          name: step.name,
          class: this.indicatorClass(step),
          icon: this.indicatorIcon(step)
        };
      });
    },
    totalCharge() {
      return `US$ ${Math.max(this.available, this.slots).toFixed(2)}`;
    }
  },
  methods: {
    async reset() {
      this.step = 0;
      this.success = false;
      this.error = false;
      this.processing = false;
      this.stepLoading = false;
      this.dataLoading = true;
      for (let step of this.steps) {
        step.done = false;
      }
      const info = await Utils.api("subscription");
      if (!info || info.error) {
        this.error = t("Error retrieving your subscription's information: {{- error}}", {
          error: info ? info.error : "Unknown error"
        });
      } else {
        try {
          this.licenses = info.licenses;
          this.billing = info.billing;
          this.originalBilling = Utils.duplicate(this.billing || {});
          this.email_verified = info.email_verified;
        } catch (err) {
          this.error = err.message;
        }
      }
      this.slots = this.available;
      this.dataLoading = false;
    },
    async next() {
      try {
        const newStep = this.step + (await this.processStep());
        this.step = newStep;
      } catch (err) {
        this.error = err.message;
      }
    },
    prev() {
      while (this.step > 0) {
        if (this.steps[this.step].done !== "bypass") {
          this.steps[this.step].done = false;
        }
        this.step--;
        if (this.steps[this.step].done !== "bypass") {
          break;
        }
      }
    },
    async finish() {
      this.processing = true;
      const response = await Utils.api("integrations", {
        slots: this.slots
      });
      this.processing = false;
      if (!response || response.error) {
        this.error = t("Error updating your subscriptions: {{- error}}", {
          error: update ? update.error : "Unknown error"
        });
      } else {
        this.success = true;
        this.slots = response.available;
        this.steps[this.steps.length - 1].done = true;
        this.$emit("refresh", {
          available: response.available,
          used: response.used,
          nextAvailable: response.nextAvailable
        });
      }
    },
    async loadStep(step) {
      this.stepLoading = true;
      this.warning = "";
      switch (step || this.currentStep.code) {
        case "payment":
          {
            this.paymentInfo = await Utils.api("subscription/payment");
            if (!this.paymentInfo || this.paymentInfo.error) {
              this.error = t("Error retrieving payment information: {{- error}}", {
                error: this.paymentInfo ? this.paymentInfo.error : "Unknown error"
              });
            } else {
              this.providers = this.paymentInfo.providers;
              this.trial = this.paymentInfo.trialDays;
              this.complete = false;
              this.currentPaymentDetails = this.paymentInfo.current;
              this.currency = this.paymentInfo.currency || null;
              this.exchangeRates = this.paymentInfo.exchangeRates || null;
            }
          }
          break;
        case "preview":
          {}
          break;
      }
      this.stepLoading = false;
    },
    async processStep(step) {
      let result = 1;
      this.processing = true;
      this.warning = "";
      switch (step || this.currentStep.code) {
        case "integrations":
          {
            if (this.slots < this.available) {
              this.steps[1].done = this.steps[2].done = "bypass";
              result = 3; // move ahead 3 steps
            }
          }

          break;
        case "billing":
          {
            if (!Utils.objectsAreEqual(this.originalBilling, this.billing)) {
              const updated = await Utils.api("profile", {
                billing: this.billing
              });
              if (!updated || updated.error) {
                throw new Error(t("Error updating your billing information: {{- error}}", {
                  error: updated ? updated.error : "Unknown error"
                }));
              }
            }
          }
          break;
        case "payment":
          {
            result = await this.$refs.payment.submitPayment();
            if (!result) {
              this.error = t("Error Processing Payment");
            }
          }
          break;
      }
      this.processing = false;
      return result;
    },
    activeStep(step) {
      return this.currentStep.code === step;
    },
    completeStep(code, done = false) {
      const step = this.steps.find(s => s.code === code);
      if (step) {
        step.done = done;
      }
    },
    clickStep(code) {
      // Can't switch steps after completion
      if (this.error || this.success) {
        return;
      }
      const idx = this.steps.findIndex(s => s.code === code);
      // Can only move to a step if the step can be found and it's a previous one
      if (idx === -1 || idx >= this.step) {
        return;
      }
      // can't move to a bypassed step isn't being bypassed
      if (this.steps[idx].done === "bypass") {
        return;
      }
      this.step = idx;
      // Clear out 'done' flag on steps that come after the one we're changing to
      for (let i = idx; i < this.steps.length; i++) {
        this.steps[i].done = false;
      }
    },
    indicatorClass(step) {
      if (this.activeStep(step.code) && !this.success && !this.error) {
        return "indicator active";
      }
      if (step.done === "bypass") {
        return "indicator inactive";
      } else if (step.done !== false) {
        return "indicator success";
      }
      return "indicator";
    },
    indicatorIcon(step) {
      if (step.done === "bypass") {
        return "fas fa-minus";
      }
      if (step.done !== false) {
        return "fas fa-check";
      }
      if (this.activeStep(step.code)) {
        return "fas fa-pen";
      }
      return "fas fa-dot-circle";
    },
    changeSlots(direction) {
      if (this.slots === 5 && direction === -1) {
        this.slots = 0;
      } else if (this.slots === 0 && direction === 1) {
        this.slots = 5;
      } else {
        this.slots += direction;
      }
      this.checkSlots();
    },
    checkSlots() {
      if (this.slots < 0) {
        this.slots = 0;
      } else if (this.slots > 0 && this.slots < 5) {
        this.slots = 5;
      }
      this.currentStep.done = this.slots != this.available;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorConfigurePayout"] = Vue.component(
                    "ProfileCreatorConfigurePayout",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered :title=\"t('Link your Paypal account')\" size=\"lg\" @hidden=\"visible = false\"> <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <div v-else-if=\"waiting\" class=\"text-center\"> <b-spinner class=\"mx-2\" :label=\"t('Retrieving your payment details')\"></b-spinner >{{ t(\"Retrieving your payment details, please wait…\") }} </div> <payment-details v-else ref=\"payment\" v-model=\"complete\" :billing=\"billing\" :providers=\"providers\" :current=\"currentProvider\" pay-verb=\"Configure\" @current=\"current = $event\" ></payment-details> <b-alert show info>{{ t( 'While this interface sets up your Paypal account for \"paying\", it will actually be used for payouts to your Paypal account (unless you have a negative balance for some reason)' ) }}</b-alert> <template #modal-footer=\"{ close }\"> <b-button variant=\"primary\" class=\"float-right\" :disabled=\"processing || !complete\" @click=\"submit\">{{ t(\"Confirm Payout account\") }}</b-button> <b-button variant=\"secondary\" class=\"float-right\" @click=\"close\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean
  },
  data() {
    return {
      providers: {},
      billing: {},
      trial: 0,
      error: "",
      waiting: true,
      currentProvider: "",
      current: "",
      subscribed: false,
      complete: false,
      processing: false
    };
  },
  watch: {
    complete(val) {}
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    async submit() {
      try {
        this.processing = true;
        this.processing = await this.$refs.payment.submitPayment();
        if (this.processing) {
          this.visible = false;
        }
        this.processing = false;
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
      }
    }
  },
  async mounted() {
    const paymentInfoPromise = Utils.api("subscription/payment");
    const subscriptionInfoPromise = Utils.api("subscription");
    const [paymentInfo, subscriptionInfo] = await Promise.all([paymentInfoPromise, subscriptionInfoPromise]);
    if (paymentInfo.error) {
      this.error = t(`Error retrieving payment information: {{- error}}`, {
        error: paymentInfo.error
      });
      return;
    }
    if (subscriptionInfo.error) {
      this.error = t(`Error retrieving payment information: {{- error}}`, {
        error: subscriptionInfo.error
      });
      return;
    }
    delete paymentInfo.providers.stripe;
    this.providers = paymentInfo.providers;
    this.trial = paymentInfo.trialDays || 0;
    this.subscribed = paymentInfo.subscribed || false;
    this.currentProvider = paymentInfo.current;
    this.billing = subscriptionInfo.billing;
    this.waiting = false;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorDashboard"] = Vue.component(
                    "ProfileCreatorDashboard",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-tabs v-model=\"tabIndex\" class=\"creator-manager-tabs\" pills card vertical @input=\"changeTab\"> <b-tab v-if=\"showTabs.includes('profile')\" :title=\"t('Profile')\"> <b-card-text> <creator-profile ref=\"creator-profile\" :creator=\"creatorData\" @update=\"updateCreator\"></creator-profile> </b-card-text> </b-tab> <b-tab v-if=\"showTabs.includes('payouts')\" :title=\"t('Payouts & Purchases')\"> <b-card-text> <b-card v-if=\"isCreator\" no-body> <b-card-header class=\"section-header\"> {{ t(\"Paypal Configuration\") }} <div class=\"header-buttons\"> <b-button class=\"ml-2\" @click.prevent=\"configurePaypal = true\">{{ t(\"Link Paypal account\") }}</b-button> </div> </b-card-header> <b-card-body> <div v-if=\"paypalEmail\"> <i18n :path=\"t('Your payouts will be sent to {0}')\" tag=\"span\"> <strong ><code>{{ paypalEmail }}</code></strong > </i18n> <b-link v-b-tooltip.hover=\"t('Copy to clipboard')\" size=\"sm\" @click=\"copyEmail\" ><i class=\"fas fa-clipboard\"></i ></b-link> </div> <div v-else> {{ t(\"You did not set your payout address yet\") }} </div> <b-alert variant=\"info\" :show=\"creatorData.id\" class=\"m-3\"> <p> <i18n :path=\"t('Your unique Creator ID is: {0}')\" tag=\"span\"> <code>{{ creatorData.id }}</code> </i18n> <b-link v-b-tooltip.hover=\"t('Copy to clipboard')\" size=\"sm\" @click=\"copyCreatorId\" ><i class=\"fas fa-clipboard\"></i ></b-link> </p> <p class=\"mb-0\"> {{ t( \"You can share this ID with another creator to allow them to enable revenue sharing for one of their packages.\" ) }} </p> </b-alert> <profile-creator-configure-payout v-model=\"configurePaypal\"></profile-creator-configure-payout> <profile-creator-section ref=\"creatorPayoutSection\" :dashboard=\"true\" :creator-integration=\"creatorIntegration\" :loading-integrations=\"loadingIntegrations\" @remove=\"removeIntegration\" @reload=\"loadIntegrations\" ></profile-creator-section> </b-card-body> </b-card> </b-card-text> </b-tab> <b-tab v-if=\"showTabs.includes('packages')\" :title=\"t('Packages')\" lazy> <template #title> {{ t(\"Packages\") }} </template> <b-card-text> <transition tag=\"div\" enter-active-class=\"animate__animated animate__fast animate__fadeIn\" leave-active-class=\"d-none\" > <profile-creator-package v-if=\"currentPackage\" :back-button=\"true\" :package=\"currentPackage\" :admin=\"false\" :creator-data=\"creatorData\" :paypal=\"paypal\" :user-integrations=\"userIntegrations\" :creator-integration=\"creatorIntegration\" :used-slots=\"usedSlots\" :bazaar-tags-list=\"bazaarTagsList\" @update=\"updatePackage\" @remove=\"removeIntegration\" @back=\"showPackages\" ></profile-creator-package> <creator-package-list v-else :initial-data=\"packages\" :admin=\"false\" :user-id=\"creatorData.id\" @create=\"createPackage\" @change=\"changeSale\" @select=\"selectPackage\" ></creator-package-list> </transition> </b-card-text> </b-tab> <b-tab v-if=\"showTabs.includes('newpackage')\"> <template #title> <i class=\"fas fa-plus\"></i> {{ t(\"Create Package\") }} </template> <b-card-text> <profile-creator-new-package @created=\"newPackageCreated\"></profile-creator-new-package> </b-card-text> </b-tab> </b-tabs> </b-card>",
  props: {
    initialData: Array,
    bazaarTags: Array,
    paypal: String,
    patreon: Object,
    initialCreatorData: Object,
    // Only used on creation. Afterwards, use creatorData.
    admin: Boolean
  },
  data() {
    return {
      savingConfig: false,
      packages: null,
      creatorData: {},
      hash: null,
      tabIndex: 0,
      tabs: ["profile", "payouts", "packages", "newpackage"],
      currentPackage: null,
      paypalEmail: null,
      configurePaypal: false,
      userIntegrations: null,
      creatorIntegration: null,
      loadingIntegrations: false
    };
  },
  watch: {
    hash() {
      this.updateTabFromHash();
    },
    async configurePaypal(value) {
      // When the paypal dialog closes, reload paypal address
      if (!value) {
        const response = await Utils.api("bazaar/creator?packages=false");
        if (response && !response.success) {
          UI.error(t("Error retreiving updated creator data: {{- error}}", {
            field: field,
            error: response.error || t("Unknown error")
          }));
        } else {
          this.paypalEmail = response ? response.paypal : this.paypalEmail;
        }
      }
    }
  },
  computed: {
    showTabs() {
      return this.isCreator ? this.tabs : this.tabs.filter(t => t !== "profile" && t !== "payouts");
    },
    isCreator() {
      // Confirm that this is a creator and not just an admin
      return this.creatorData.isCreator !== false;
    },
    usedSlots() {
      return this.packages.filter(pkg => {
        if (pkg.user.id !== this.creatorData.id || !(pkg && pkg.patreon && pkg.patreon.tiers)) {
          return false;
        }
        return pkg.patreon.tiers.length;
      }).length;
    },
    availableSlots() {
      if (!this.creatorIntegration) {
        return 0;
      }
      const patreon = this.creatorIntegration.patreon;
      return patreon && patreon.slots ? Math.ceil(patreon.slots / patreon.slot_incr) * patreon.unit_cost : 0;
    },
    bazaarTagsList() {
      // Client side translation of BazaarTags, to set label and untranslated _label
      return this.bazaarTags.map(tag => {
        tag._label = tag.label;
        tag.label = t(`BAZAAR_TAG.${tag.tag}`, tag.label || tag.tag);
        return tag;
      });
    }
  },
  methods: {
    updateTabFromHash() {
      if (window.location.hash) {
        let hash = Utils.hashProps(window.location.hash);
        // Compatibility for old links - if hash is "view={pkgId}", redirect to "tab=packages&package={pkgId}"
        if (hash.view && (hash.view !== "true" || hash.view !== "false")) {
          hash.tab = "packages";
          hash.package = hash.view;
          this.buildHash({
            tab: hash.tab,
            package: hash.package,
            view: undefined
          });
          // Update the hash object
          hash = Utils.hashProps(window.location.hash);
        }
        // Find navigate to the correct tab and package
        this.tabIndex = this.showTabs.findIndex(t => t === hash.tab) || 0;
        if (hash.package) {
          const pkg = this.packages && this.packages.find(p => p.data.id === hash.package);
          if (pkg) {
            this.currentPackage = pkg;
          } else {
            this.currentPackage = null;
          }
        } else {
          this.currentPackage = null;
        }
      } else {
        this.tabIndex = 0;
        this.currentPackage = null;
      }
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    changeTab(tab) {
      const name = this.showTabs[tab];
      this.buildHash({
        tab: name
      });
      this.tabLoad();
    },
    tabLoad() {
      const currentTab = this.showTabs[this.tabIndex];
      switch (currentTab) {
        case "payouts":
          if (this.isCreator) {
            console.log("Preload payouts");
            const payouts = this.$refs.creatorPayoutSection;
            payouts.tabLoad();
          }
          break;
        case "newpackage":
          this.createPackage();
          break;
      }
    },
    async loadIntegrations() {
      this.loadingIntegrations = true;
      const response = await Utils.api("profile/integrations");
      if (response.success) {
        this.userIntegrations = response;
      } else {
        UI.error(t("Error retrieving integration information: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      }
      const response2 = await Utils.api("profile/creator/integrations");
      if (response2.success) {
        this.creatorIntegration = response2;
      } else {
        UI.error(t("Error retrieving integration information: {{- error}}", {
          error: response2.error || t("Unknown Error")
        }));
      }
      this.loadingIntegrations = false;
    },
    async removeIntegration(item) {
      const response = await Utils.api(`bazaar/creator`, {
        action: "remove-integration",
        type: item.type,
        name: item.name
      });
      this.savingConfig = false;
      if (response.error) {
        UI.error(t("Error removing integration: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
      } else {
        const pkg = this.packages.find(p => p.data.type === item.type && p.data.id === item.name);
        if (pkg) {
          pkg.patreon = pkg.data.patreon = {
            creator: null,
            tiers: [],
            multi: []
          };
        }
        this.creatorIntegration.integrations = this.creatorIntegration.integrations.filter(i => i.data.id !== item.name);
        UI.success(t("Integration successfully removed"));
      }
    },
    createPackage() {
      this.currentPackage = null;
      this.tabIndex = this.showTabs.findIndex(t => t === "newpackage");
    },
    selectPackage(id) {
      this.buildHash({
        package: id
      });
    },
    async changeSale(field, item) {
      const pkg = this.packages.find(p => p.data.id === item.id);
      if (!pkg) {
        return;
      }
      const data = {
        action: "configure-package",
        type: pkg.data.type,
        name: pkg.data.name,
        marketplace: {}
      };
      data.marketplace[field] = Number(item[field]);

      // Don't change the sale price if the price hasn't changed
      if (data.marketplace[field] === pkg.marketplace[field]) {
        return;
      }
      this.savingConfig = true;
      const response = await Utils.api("bazaar/creator", data);
      if (response.error) {
        UI.error(t("Error setting package {{- field}}: {{- error}}", {
          field: field,
          error: response.error || t("Unknown error")
        }));
      } else {
        UI.success(t("The package {{- field}} changed.", {
          field: field
        }));
        pkg.marketplace = Object.assign(pkg.marketplace, data.marketplace);
      }
      this.savingConfig = false;
    },
    newPackageCreated(pkg) {
      this.packages.push(pkg);
      this.selectPackage(pkg.data.id);
      this.changeTab("packages");
    },
    updatePackage(pkg) {
      const idx = this.packages.findIndex(p => p.data.id === pkg.data.id);
      this.packages.splice(idx, 1, pkg);
      this.currentPackage = pkg;
      // Merge update into integrations
      if (this.creatorIntegration && this.creatorIntegration.integrations) {
        const integrationIdx = this.creatorIntegration.integrations.findIndex(integ => integ.data.id === pkg.data.id);
        if (pkg.patreon && pkg.patreon.tiers) {
          // The updated package has Patreon integration, so ensure it is in the integrations list.
          if (integrationIdx >= 0) {
            this.creatorIntegration.integrations.splice(integrationIdx, 1, pkg);
          } else {
            this.creatorIntegration.integrations.push(pkg);
          }
        } else {
          // The updated package has no Patreon integration, so ensure it is removed from the integrations list.
          if (integrationIdx >= 0) {
            this.creatorIntegration.integrations.splice(integrationIdx, 1);
          }
        }
      }
    },
    showPackages() {
      this.buildHash({
        package: null
      });
      this.changeTab(this.showTabs.findIndex(t => t === "packages"));
    },
    updateCreator(data) {
      this.creatorData = data;
    },
    copyEmail() {
      if (this.paypalEmail) {
        navigator.clipboard.writeText(this.paypalEmail);
      }
    },
    copyCreatorId() {
      navigator.clipboard.writeText(this.creatorData.id);
    }
  },
  created() {
    this.packages = this.initialData;
    this.creatorData = this.initialCreatorData;
    this.paypalEmail = this.paypal;
    this.loadIntegrations();
    this.updateTabFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
  },
  mounted() {
    this.tabLoad();
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorEula"] = Vue.component(
                    "ProfileCreatorEula",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" centered size=\"lg\" :title=\"t('Publish package to the Bazaar')\" @hidden=\"visible = false\" @shown=\"dialogShown\" > <!-- Error --> <b-alert v-if=\"error\" variant=\"danger\" show>{{ error }}</b-alert> <!-- Busy --> <div v-else-if=\"busy\" class=\"text-center\"> <b-spinner class=\"mx-2\" :label=\"busy\"></b-spinner>{{ busy }}{{ t(\", please wait…\") }} </div> <!-- Billing page --> <div v-else-if=\"step === 'billing'\"> <h5>{{ t(\"Please confirm your personal details and billing information.\") }}</h5> <billing-information ref=\"billing\" v-model=\"billing\" :require-tax-id=\"true\" @complete=\"billingComplete = $event\" ></billing-information> </div> <div v-else-if=\"step === 'paypal'\"> <i18n v-if=\"paypal\" tag=\"div\" :path=\"t('Your payouts will be sent to {0}')\"> <strong ><code>{{ paypal }} </code></strong >> </i18n> <div v-else>{{ t(\"You did not set your payout address yet\") }}</div> <div class=\"text-center my-3\"> <b-button @click.prevent=\"configurePaypal = true\">{{ t(\"Link Paypal account\") }}</b-button> <profile-creator-configure-payout v-model=\"configurePaypal\"></profile-creator-configure-payout> </div> </div> <!-- Licensing information --> <div v-else-if=\"step === 'licensing'\"> <h5>{{ t(\"Please enter and confirm the licensing information for the content of this package.\") }}</h5> <p> {{ t( \"List/confirm which content (text, code, assets, concepts, etc…) is of your own making, and if any content wasn't your own creation, please list who the original creator is and what is the licensing terms with regards to that content.\" ) }} </p> <i18n :path=\" t( `As an example, if you use the 5e OGL in a world, then you should mention it here and add the appropriate license to your world as well. Here's a {0} that you can import as a template for the OGL license.` ) \" tag=\"p\" > <a href=\"https://drive.google.com/uc?id=10sTHJemiw6P-rUkX4Usb9Gi5XLgviFjL&amp;export=download\">{{ t(\"journal entry\") }}</a> </i18n> <p>{{ t(\"This will serve to make sure that this package is not infringing on anyone's copyright.\") }}</p> <tiny-mce v-model=\"pkg.marketplace.licensingInformation\" name=\"licensingInformation\" class=\"w-100\" :settings=\"tinymceSettings\" > </tiny-mce> <small>{{ pkg.marketplace.licensingInformation.length }} / 50 ({{ t(\"minimum\") }})</small> </div> <!-- Billing page --> <div v-else-if=\"step === 'eula'\"> <h5>{{ t(\"Please read and confirm your acceptance of the Bazaar Creator Agreement.\") }}</h5> <b-card> <span v-html=\"eulaHtml\"></span> </b-card> <strong>{{ t( 'By clicking \"I accept these terms\", you acknowledge reading and understanding these terms and you are electronically signing this agreement.' ) }}</strong> </div> <!-- Final page --> <div v-else-if=\"step === 'final'\"> <b-alert variant=\"success\" show> {{ t(\"Your request has been sent and will be reviewed shortly. Thank you.\") }}<br /> <i18n :path=\" t( 'Make sure you have entered your Paypal information from the {0} page in order to receive your payouts in a timely manner.' ) \" > <a href=\"/account\" target=\"_blank\">{{ t(\"My Account\") }}</a> </i18n> </b-alert> </div> <!-- Footer Buttons --> <template #modal-footer=\"{ cancel }\"> <b-button v-if=\"step !== 'final'\" variant=\"secondary\" class=\"float-left\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> <!-- Billing -> Paypal --> <b-button v-if=\"step === 'billing'\" variant=\"success\" class=\"float-right\" :disabled=\"!billingComplete || processing || error !== ''\" @click=\"confirmBilling\" >{{ t(\"Next\") }}</b-button > <!-- Paypal -> License --> <b-button v-else-if=\"step === 'paypal'\" variant=\"success\" class=\"float-right\" :disabled=\"processing\" @click=\"confirmPaypal\" >{{ t(\"Next\") }}</b-button > <!-- Payment -> Preview --> <b-button v-else-if=\"step === 'licensing'\" variant=\"success\" class=\"float-right\" :disabled=\"!licenseFilled || processing\" @click=\"confirmLicensing\" >{{ t(\"Next\") }}</b-button > <!-- Preview -> Confirm --> <b-button v-else-if=\"step === 'eula'\" variant=\"success\" class=\"float-right\" :disabled=\"processing\" @click=\"acceptEULA\" >{{ t(\"I accept these terms\") }}</b-button > <!-- Final page (Close) --> <b-button v-else-if=\"step === 'final'\" variant=\"success\" class=\"float-right\" @click=\"cancel\">{{ t(\"Close\") }}</b-button> </template> </b-modal>",
  props: {
    value: Boolean,
    pkg: Object,
    paypal: String
  },
  data() {
    return {
      step: "",
      processing: false,
      providers: {},
      billing: {},
      originalBilling: {},
      error: "",
      eula: "",
      busy: null,
      currentProvider: "",
      current: "",
      billingComplete: false,
      configurePaypal: false,
      tinymceSettings: {
        language: "en",
        height: 500,
        menubar: false,
        plugins: ["advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor", "searchreplace", "visualblocks", "code", "fullscreen", "insertdatetime", "media", "table", "code", "help", "wordcount"],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | removeformat | help",
        promotion: false // Disable TinyMCE advertisement
      },

      toastAnimationClass: "animate__animated animate__fast animate__tada",
      toastIntersected: false,
      savingConfig: false
    };
  },
  watch: {
    configurePaypal() {
      // Reload paypal address
      this.$emit("update", null);
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    eulaHtml() {
      return DOMPurify.sanitize(marked(this.eula, {
        breaks: true,
        headerIds: false
      }));
    },
    licenseFilled() {
      return this.pkg.marketplace.licensingInformation.length >= 50;
    }
  },
  methods: {
    async dialogShown() {
      this.step = "";
      this.error = "";
      this.billingComplete = false;
      this.configurePaypal = false;
      this.busy = t("Retrieving your billing information");
      const subscriptionInfo = await Utils.api("subscription");
      if (subscriptionInfo.error) {
        this.error = t(`Error retrieving payment information: {{- error}}`, {
          error: subscriptionInfo.error
        });
        this.busy = null;
        return;
      }
      this.billing = subscriptionInfo.billing;
      this.originalBilling = Utils.duplicate(this.billing);
      this.step = "billing";
      this.busy = null;
    },
    close() {
      this.visible = false;
    },
    async confirmBilling() {
      try {
        if (!Utils.objectsAreEqual(this.originalBilling, this.billing)) {
          this.processing = true;
          const updated = await Utils.api("profile", {
            billing: this.billing
          });
          if (updated.error) {
            throw new Error(t(`Error updating your billing information: {{- error}}`, {
              error: updated.error
            }));
          }
          this.processing = false;
        }
        this.step = "paypal";
      } catch (err) {
        this.processing = false;
        this.error = err.message || err;
      }
    },
    async confirmPaypal() {
      // Make sure the field is set and is reactive
      this.$set(this.pkg.marketplace, "licensingInformation", this.pkg.marketplace.licensingInformation || "");
      this.step = "licensing";
    },
    async confirmLicensing() {
      this.processing = true;
      const response = await Utils.api("bazaar/creator", {
        action: "get-eula",
        type: this.pkg.data.type,
        name: this.pkg.data.name,
        licensingInformation: this.pkg.marketplace.licensingInformation
      });
      this.processing = false;
      if (response.error) {
        UI.alert("danger", t("Error retrieving EULA terms: {{- error}}", {
          error: response.error
        }));
      } else {
        this.eula = response.eula;
        this.step = "eula";
      }
      this.processing = false;
    },
    async acceptEULA() {
      this.processing = true;
      const response = await Utils.api(`bazaar/creator`, {
        action: "publish-package",
        type: this.pkg.data.type,
        name: this.pkg.data.name,
        eula: this.eula,
        eulaSigned: true
      });
      if (response.error) {
        UI.alert("danger", t("Error setting package as ready: {{- error}}", {
          error: response.error
        }));
      } else {
        UI.alert("success", t("The request to publish your package has been sent."));
        this.$emit("update", response.package);
        this.step = "final";
      }
      this.processing = false;
    }
  },
  async created() {
    await Utils.loadDependencies(["simple-markdown"]);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorIntegrationList"] = Vue.component(
                    "ProfileCreatorIntegrationList",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"integrationList\" :fields=\"integrationFields\" class=\"integrations-list\" > <template #cell(content)=\"{ item }\"> <a v-b-tooltip.hover :href=\"`/account/creator#tab=packages&package=${item.name}`\" :title=\"item.name\"> {{ item.title }} </a> </template> <template #cell(remove)=\"{ item }\"> <b-button v-b-tooltip.hover size=\"sm\" variant=\"outline-secondary\" :title=\"t('Remove this integration')\" @click=\"$emit('remove', item)\" > <i class=\"fas fa-trash\"></i> </b-button> </template> <template #cell(downloads)=\"{ item }\"> <span v-b-tooltip.hover :title=\" t( `This purchase was downloaded via Manifest {{downloads}} times, from {{downloadIPs}} distinct IP locations`, { downloads: item.downloads, downloadIPs: item.downloadIPs } ) \" > {{ item.downloads }} / {{ item.downloadIPs }} </span> </template> </b-table>",
  props: {
    integrationList: Array
  },
  data() {
    return {
      integrationFields: [{
        key: "date",
        label: t("Added date"),
        formatter: (value, key, item) => {
          return new Date(value).toUTCString();
        }
      }, {
        key: "content",
        label: t("Content")
      }, {
        key: "tiers",
        label: t("Tiers")
      }, {
        key: "remove",
        label: "",
        thClass: "remove-col",
        labelAlign: "right"
      }]
    };
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorNewPackage"] = Vue.component(
                    "ProfileCreatorNewPackage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-card no-body> <b-card-header class=\"section-header pr-1\"> <div> <span> {{ t(\"Create Package\") }} </span> </div> <div v-if=\"backButton\" class=\"header-buttons\"> <b-button v-b-tooltip.hover variant=\"primary\" class=\"float-right mx-2\" @click.prevent=\"$emit('back')\"> <i class=\"fas fa-chevron-left\"></i> {{ t(\"Package List\") }} </b-button> </div> </b-card-header> <b-card-body> <b-row> <b-col> <b-alert show variant=\"warning\"> <p> <b>{{ t(\"Note:\") }}</b> {{ t( \"The package will be added to a queue for processing and will become available for editing within approximately 15 to 30 minutes.\" ) }} </p> <p class=\"mb-0\"> {{ t(\"It will then need to be approved by an administrator before it becomes publicly available.\") }} </p> </b-alert> <b-alert show variant=\"info\"> <p> {{ t( \"Package names are unique across all types, make sure the name of your asset pack won't conflict with other packages.\" ) }} </p> <p class=\"mb-0\"> <b>{{ t(\"Note:\") }}</b> {{ t( \"Asset files are never deleted even if renamed or deleted in a future update, as a user might have selected it for one of their maps/tokens/etc… and renaming or removing the asset could break their game.\" ) }} </p> </b-alert> <b-alert :show=\"realType === 'asset'\" variant=\"info\"> <h5>{{ t(\"Assets\") }}</h5> <p> {{ t( \"You would need to use an asset.json manifest similar to a module.json that links to the zip download.\" ) }} </p> <i18n :path=\"t('Avoid any filename with the {0} character in it. Preferably keep all filenames url-friendly.')\" tag=\"p\" class=\"mb-0\" > <code>#</code> </i18n> </b-alert> <b-form-group :label=\"t('Enter the Manifest URL of the package to create')\"> <b-form-input v-model=\"manifestURL\" autofocus trim :placeholder=\"urlPlaceholder\" @keyup=\"queryKeyUp\"> </b-form-input> </b-form-group> <b-form-group :label=\"t('What type of package is it?')\" label-cols=\"4\"> <b-form-select v-model=\"type\" :options=\"typeOptions\"></b-form-select> </b-form-group> <b-row> <b-col class=\"text-right\"> <b-button v-if=\"processing\" variant=\"secondary\" :disabled=\"true\"> <loading-indicator tag=\"span\" small :label=\"t('Adding package to queue…')\"> </loading-indicator> </b-button> <b-button v-else variant=\"success\" :disabled=\"!validURL\" @click=\"create\"> <i18n :path=\"t('Create {0}')\" tag=\"span\"> {{ packageType }} </i18n> </b-button> </b-col> </b-row> </b-col> </b-row> </b-card-body> </b-card>",
  props: {
    backButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      manifestURL: "",
      type: "module",
      typeOptions: [{
        value: "module",
        text: t("Module")
      }, {
        value: "system",
        text: t("System")
      }, {
        value: "world",
        text: t("World")
      }, {
        value: "asset",
        text: t("Assets")
      }],
      processing: false
    };
  },
  watch: {
    realType(newValue, oldValue) {
      if (newValue !== oldValue || newValue !== this.type) {
        this.type = newValue;
      }
    }
  },
  computed: {
    realType() {
      const [path] = this.manifestURL.split("?");
      if (path.endsWith("world.json")) {
        return "world";
      }
      if (path.endsWith("system.json")) {
        return "system";
      }
      if (path.endsWith("module.json")) {
        return "module";
      }
      if (path.endsWith("asset.json")) {
        return "asset";
      }
      return this.type;
    },
    packageType() {
      // t("Asset")
      return Utils.capitalize(this.realType);
    },
    validURL() {
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(this.manifestURL);
    },
    urlPlaceholder() {
      if (this.realType === "world") {
        return "https://example.com/world.json";
      }
      if (this.realType === "system") {
        return "https://example.com/system.json";
      }
      if (this.realType === "asset") {
        return "https://example.com/asset.json";
      }
      return "https://example.com/module.json";
    }
  },
  methods: {
    async create() {
      if (!this.validURL) {
        return;
      }
      this.processing = true;
      const response = await Utils.api(`bazaar/creator`, {
        action: "add-package",
        type: this.realType,
        url: this.manifestURL
      });
      console.log(response);
      if (response.error) {
        this.processing = false;
        UI.alert("danger", response.error);
        return;
      }
      this.$emit("created", response.package);
      this.manifestURL = "";
      this.processing = false;
    },
    queryKeyUp(ev) {
      if (ev.keyCode === 13) {
        this.addPackage();
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorPackage"] = Vue.component(
                    "ProfileCreatorPackage",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* global PACKAGE_MEDIA_TYPES */
var _default = exports.default = {
  template: "<b-card no-body> <template #header> <b-row> <b-col> <b-button v-if=\"backButton\" variant=\"primary\" @click.prevent=\"$emit('back')\"> <i class=\"fas fa-chevron-left\"></i> {{ t(\"Package List\") }} </b-button> </b-col> <b-col class=\"text-center\"> <h3 class=\"mb-0 mt-1\">{{ pkg.title }}</h3> </b-col> <b-col class=\"text-right package-status\"> <package-status-indicator :package=\"originalPackage\"></package-status-indicator> </b-col> </b-row> </template> <b-card-body> <div v-if=\"isBrandNew\"> <b-alert variant=\"secondary\" show> <b-row> <b-col> {{ t(\"This package has been recently added to the queue to be processed.\") }} <i18n :path=\"t('It can take {0} to {1} minutes before the package is available to be configured.')\"> <strong>15</strong> <strong>30</strong> </i18n> </b-col> <b-col md=\"auto pr-1\"> <b-button @click=\"reloadPage\"> {{ t(\"Refresh\") }} <i class=\"fas fa-sync-alt\"></i> </b-button> </b-col> </b-row> </b-alert> <p> <strong>{{ t(\"Note:\") }} </strong> <i18n :path=\" t( `If after 30 minutes, it still doesn't appear, make sure the {0} field in the {1} is a valid zip file that is downloadable and contains the same {2} as the one pointed to by your manifest URL.` ) \" > <code>{{ t(\"download\") }}</code> <a :href=\"pkg.manifest\" target=\"_blank\">{{ pkg.type }}.json</a> <code>{{ pkg.type }}.json</code> </i18n> </p> <b-form-group label-cols-lg=\"3\"> <template #label> {{ t(\"Manifest URL:\") }} </template> <b-input-group> <b-form-input v-model=\"pkg.manifest\" :type=\"manifestInputType\"></b-form-input> <b-input-group-append> <information-toggle v-model=\"manifestInputType\" :noun=\"t('Manifest URL')\"></information-toggle> <b-button variant=\"primary\" @click=\"updateManifestURL\"> {{ t(\"Update\") }} </b-button> </b-input-group-append> </b-input-group> <small class=\"form-text text-muted\"> {{ t(\"You'd only need to change it if the previous URL has become invalid.\") }} </small> </b-form-group> </div> <div v-else class=\"creator-dashboard-package\"> <b-row> <div> <!-- Do not inject entitled/purchased/installed data into editedPkg, so that this preview appears as it would to a user who is not entitled --> <bazaar-package :package=\"editedPkg\" :user-integrations=\"userIntegrations\" :can-install=\"true\" :can-select=\"true\" :allow-status-indicator=\"false\" @selected=\"displayPackage(true)\" > </bazaar-package> <div class=\"m-1 text-center font-italic\"> <b-link @click=\"displayPackage(true)\"> {{ t(\"Click for full page view\") }} </b-link> </div> <div v-if=\"originalPackage.available\" class=\"my-3 text-center\"> <b-button variant=\"success\" :href=\"`/bazaar#package=${pkg.name}`\" target=\"_blank\"> {{ t(\"View in the Bazaar\") }} <i class=\"fas fa-external-link-alt\"></i> </b-button> </div> <b-card :title=\"t('Package Fees')\"> <div v-if=\"pwyw\"> {{ t(\"Platform fees\") }} (&gt; $ {{ editedPackage.marketplace.platformFeeRateThreshold.toFixed(2) }}): {{ editedPackage.marketplace.platformFeeRate * 100 }}% <br /> {{ t(\"Platform fees\") }} (&lt; $ {{ editedPackage.marketplace.platformFeeRateThreshold.toFixed(2) }}): {{ editedPackage.marketplace.platformFeeRateMicro * 100 }}% </div> <div v-else>{{ t(\"Platform fees:\") }} {{ platformFeeRate * 100 }}%</div> <div>{{ t(\"Creator's share:\") }} {{ creatorRate * 100 }}%</div> <div> {{ t(\"Revenue Sharing:\") }} <b-table v-if=\"revenueSharing\" small :items=\"revenueSharingItems\" :fields=\"revenueSharingFields\"> <template #cell(name)=\"{ item }\"> <strong v-if=\"item.self\">{{ t(\"You\") }}</strong> <span v-else> {{ item.name }} </span> </template> </b-table> <span v-else>{{ t(\"Disabled\") }}</span> <div class=\"my-3 text-center\"> <b-button variant=\"warning\" @click=\"editRevenueSharing\"> {{ revenueSharingButtonLabel }} </b-button> <profile-creator-revenue-sharing v-model=\"revenueSharingDialogVisible\" :pkg=\"originalPackage\" @update=\"$emit('update', $event)\" ></profile-creator-revenue-sharing> </div> </div> </b-card> <b-card :title=\"t('Statistics')\" class=\"mt-2\"> <div> {{ t(\"Current installs:\") }} <strong>{{ stats.installs }}</strong> </div> <div> {{ t(\"Total Sales:\") }} <strong>{{ stats.purchases }}</strong> </div> <div> {{ t(\"Generated Revenue:\") }} <strong>{{ salesValue }}</strong> </div> <div> {{ t(\"Your Revenue Share:\") }} <strong>{{ revenueValue }}</strong> </div> </b-card> <div v-if=\"originalPackage.available\" class=\"my-3 text-center\"> <b-button variant=\"primary\" @click.prevent=\"generateGift\"> <i class=\"fas fa-gift\"></i> {{ t(\"Generate gift\") }} </b-button> </div> <div v-if=\"!originalPackage.marketplace.ready\" class=\"my-3 text-center\"> <b-button v-if=\"!admin\" variant=\"success\" :disabled=\"savingConfig || isConfigurationChanged\" @click=\"readyToPublish\" > <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else> {{ t(\"Send for Approval\") }} <i class=\"fas fa-play\"></i> </span> </b-button> <profile-creator-eula v-model=\"eulaDialogVisible\" :paypal=\"paypal\" :pkg=\"originalPackage\" @update=\"$emit('update', $event)\" ></profile-creator-eula> </div> <div v-else class=\"my-3 text-center\"> <b-button variant=\"danger\" :disabled=\"savingConfig\" @click=\"unpublish\"> <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else-if=\"isWaitingApproval\"> {{ t(\"Cancel Approval\") }} </span> <span v-else>{{ t(\"Unpublish package\") }}</span> </b-button> </div> </div> <b-col> <b-form class=\"package-configuration\"> <b-alert v-if=\"!originalPackage.marketplace.ready\" variant=\"warning\" show> <b-row class=\"align-items-center\"> <b-col> {{ t(\"This package is waiting to be published.\") }}<br /> <span v-if=\"!admin\"> {{ t( \"When the package is ready, send it to The Forge for approval. Once approved it will then be published to the Bazaar.\" ) }} </span> </b-col> <b-col md=\"auto pr-1\"> <b-button v-if=\"!admin\" variant=\"warning\" :disabled=\"savingConfig || isConfigurationChanged\" @click=\"readyToPublish\" > <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else> {{ t(\"Send for Approval\") }} <i class=\"fas fa-play\"></i> </span> </b-button> </b-col> </b-row> </b-alert> <b-alert v-else-if=\"isWaitingApproval\" variant=\"info\" show> <b-row class=\"align-items-center\"> <b-col> {{ t(\"This package is currently awaiting approval.\") }} <br /> <div v-if=\"!admin\"> {{ t(\"Please be patient as this can sometimes take up to a day or two.\") }}<br /> {{ t(\"Packages are approved during regular business days (max. 2 packages per creator per day).\") }} </div> </b-col> <b-col md=\"auto pr-1\"> <b-button v-if=\"admin\" variant=\"success\" :disabled=\"savingConfig\" @click=\"approve\"> <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else> {{ t(\"Approve\") }} <i class=\"fas fa-check\"></i> </span> </b-button> <b-button v-else variant=\"info\" :disabled=\"savingConfig\" @click=\"unpublish\"> <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else>{{ t(\"Cancel approval\") }}</span> </b-button> </b-col> </b-row> </b-alert> <b-alert v-else-if=\"originalPackage.available\" variant=\"success\" show> {{ t(\"This package has been published to the bazaar.\") }} </b-alert> <!-- Manifest --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isManifestModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Manifest URL:\") }} </template> <b-input-group> <b-form-input v-model=\"editedPackage.manifest.manifest\" name=\"manifest\" :type=\"manifestInputType\" ></b-form-input> <b-input-group-append> <information-toggle v-model=\"manifestInputType\" :noun=\"t('Manifest URL')\"></information-toggle> </b-input-group-append> </b-input-group> <small class=\"form-text text-muted\">{{ t(\"You'd only need to change it if the previous URL has become invalid.\") }}</small> </b-form-group> <!-- Download link --> <b-form-group v-if=\"editedPackage.marketplace.download\" label-cols-lg=\"3\"> <template #label> <span v-show=\"isDownloadModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Protected Download URL:\") }} </template> <b-form-input v-model=\"editedPackage.marketplace.download\" name=\"download\"> </b-form-input> </b-form-group> <!-- Allow Manifest Install  --> <b-form-group v-if=\"pkg.type !== 'asset'\" label-cols-lg=\"3\"> <template #label> <span v-show=\"isAllowManifestInstallModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Allow users to install from the Manifest URL:\") }} </template> <b-form-checkbox v-model=\"editedPackage.marketplace.allowManifestInstall\" name=\"available\"> </b-form-checkbox> <small class=\"form-text text-muted\"> {{ t( \"If you are distributing this package for users to install via its manifest URL, outside of the Forge Bazaar, then enable the option. Otherwise, the Forge will prevent installation by users that did not purchase the content from the Bazaar directly.\" ) }} </small> </b-form-group> <!-- Bazaar Tags  --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isBazaarTagsModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Bazaar Tags:\") }} <help-icon :tooltip=\"bazaarTagTipData\" :html=\"true\"></help-icon> </template> <b-input-group> <b-form-tags remove-on-delete no-add-on-enter no-outer-focus class=\"px-2\"> <template #default=\"{ disabled, inputAttrs, inputHandlers }\"> <ul class=\"b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center bazaar-tag-list\" > <b-form-tag v-for=\"{ tag, label } in tagList\" :key=\"tag\" class=\"bazaar-tag-item\" tag=\"li\" :disabled=\"disabled\" variant=\"info\" @remove=\"removeBazaarTag(tag)\" >{{ label }}</b-form-tag > <li class=\"b-from-tags-field flex-grow-1\"> <b-input-group class=\"d-flex\"> <input v-model=\"bazaarTagText\" v-bind=\"inputAttrs\" :placeholder=\"BazaarTagAddTooltip\" :disabled=\"disabled\" class=\"b-form-tags-input w-100 flex-grow-1 p-0 m-0 mt-1 bg-transparent border-0\" v-on=\"inputHandlers\" @focus=\"expandBazaarTagDropdown\" @blur=\"collapseBazaarTagDropdown\" @keyup=\"checkForEnterKey($event)\" /> </b-input-group> </li> </ul> <bazaar-tags-dropdown v-model=\"bazaarTagDropdownExpanded\" :tags=\"bazaarTagsList\" :can-select=\"canAddTags\" :filter=\"bazaarTagText\" :selection=\"editedPkg.bazaarTags\" :no-tag-message=\"t('No tag found, add this as a custom tag')\" @selected=\"selectFromDropDown\" @focus=\"expandBazaarTagDropdown\" @blur=\"collapseBazaarTagDropdown\" > <small class=\"form-text text-muted mt-0 mb-1 border-bottom\"> {{ t( \"Please choose a tag from the recommended list. If your desired tag doesn't exist, you can also add a custom tag.\" ) }} </small> </bazaar-tags-dropdown> </template> </b-form-tags> <template #append> <b-button v-if=\"hasTags\" variant=\"outline-secondary\" :title=\"t('Clear all tags')\" @click=\"clearBazaarTags\" > <i class=\"fas fa-times\"></i> </b-button> <b-button :disabled=\"!canAddTags\" :title=\"BazaarTagAddTooltip\" @click=\"selectTagText\"> {{ t(\"Add\") }} </b-button> </template> </b-input-group> <template #description> <i18n :path=\"t('You can add a maximum number of {0} bazaar tags.')\" tag=\"p\" class=\"mb-1\"> <strong>{{ maxBazaarTags }}</strong> </i18n> {{ t( \"You can also add your own custom tags that are not in the list.  These will be searchable, but won't show up as options in the search filter.\" ) }} </template> </b-form-group> <!-- Marketplace --> <b-card class=\"my-2 border border-success\"> <template #header> <h6 class=\"mb-0\"><i class=\"fas fa-shopping-cart\"></i> {{ t(\"Marketplace pricing\") }}</h6> </template> <!-- Price --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isPriceModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Price\") }}: </template> <b-input-group prepend=\"$\" class=\"w-25\"> <b-form-input v-model=\"editedPackage.marketplace.price\" name=\"available\" type=\"number\" class=\"text-right\" no-wheel > </b-form-input> </b-input-group> <small class=\"form-text text-muted\"> {{ t(\"Must always be greater than zero.\") }} </small> </b-form-group> <!-- Sale --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isSaleModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Sale Price\") }}: </template> <b-input-group prepend=\"$\" class=\"w-25\"> <b-form-input v-model=\"editedPackage.marketplace.sale\" name=\"available\" type=\"number\" class=\"text-right\" no-wheel :disabled=\"pwyw\" > </b-form-input> </b-input-group> <template v-if=\"!pwyw\"> <small class=\"form-text text-muted\"> {{ t( \"Set to zero if product is not on sale. Will display a sale banner and the percentage off, if sale price is lower than regular price.\" ) }} </small> <small> <strong> {{ t( \"Due to consumer protection laws, you need to make sure your package is being sold at the regular price at least as much as being on sale.\" ) }} </strong> </small> </template> <div v-show=\"pwyw\"> {{ t('Having a sale is incompatible with using the \"Pay what you can\" or \"Pay More\" models.') }} </div> </b-form-group> <!-- PWYW --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isPWYWModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Enable Pay What You Can Pricing:\") }} </template> <b-form-checkbox v-model=\"editedPackage.marketplace.pwyw\" name=\"available\"> </b-form-checkbox> </b-form-group> <!-- Minimum PWYW --> <b-form-group v-if=\"pwyw\" label-cols-lg=\"3\"> <template #label> <span v-show=\"isMinimumModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Minimum allowed price:\") }} </template> <b-form-input v-model=\"editedPackage.marketplace.minimum\" name=\"available\" type=\"number\" no-wheel> </b-form-input> <small class=\"form-text text-muted\"> {{ t( 'Set to zero for \"Pay what you can\". If price is not zero, then it will become a \"Pay $X or more\" and the minimum amount will be the default displayed price.' ) }} </small> </b-form-group> <!-- Download --> <!-- <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isDownloadableModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"><i class=\"fas fa-exclamation-triangle text-warning\"></i></a>&nbsp; </span> Allow buyers to download the zip file for self hosting: </template> <b-form-checkbox name=\"available\" v-model=\"editedPackage.marketplace.downloadable\" :disabled=\"editedPackage.available\"> </b-form-checkbox> <small class=\"form-text text-muted\">Cannot be changed after the package is made available (manifest file in the zip will contain the download url as well).</small> </b-form-group> --> </b-card> <b-card class=\"my-2 border border-primary\"> <template #header> <h6 class=\"mb-0\"><i class=\"fas fa-image\"></i> {{ t(\"Multimedia\") }}</h6> </template> <!-- Icon --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isIconModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Icon image URL(max 48 pixels in height):\") }} </template> <b-form-input v-model=\"editedPackage.icon\" name=\"manifest\"> </b-form-input> <small> {{ t( \"The icon image will be displayed in full if there is no cover image, otherwise, it will only be shown as an icon in the full page view\" ) }} </small> </b-form-group> <!-- Cover --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isCoverModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> <i18n :path=\"t('Cover image URL {0}:')\"> <strong> ({{ t(\"ratio\") }} <span v-if=\"pkg.type === 'asset'\">1</span><span v-else>2</span>:1) </strong> </i18n> </template> <b-form-input v-model=\"editedPackage.cover\" name=\"manifest\"> </b-form-input> </b-form-group> <!-- Screenshots --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isScreenshotsModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Screenshots / Video:\") }} </template> <b-input-group :prepend=\"t('Add URL:')\"> <b-form-input v-model=\"screenshot\" name=\"screenshot\"> </b-form-input> <b-input-group-append> <b-button v-show=\"screenshot\" size=\"sm\" @click=\"addScreenshot\"> {{ t(\"Add link\") }} </b-button> </b-input-group-append> </b-input-group> <b-list-group> <b-list-group-item v-for=\"(url, index) of screenshots\" :key=\"index\" class=\"d-flex justify-content-between align-items-center\" > {{ url }} <span class=\"text-center text-danger\" @click=\"removeScreenshot(index)\"> <i class=\"fas fa-times\"></i> </span> </b-list-group-item> </b-list-group> </b-form-group> </b-card> <!-- Integrations --> <b-card class=\"my-2 border border-info\"> <template #header> <h6 class=\"mb-0\"> <img src=\"/images/social/patreon.png\" class=\"patreon-icon\" width=\"18px\" height=\"18px\" /> {{ t(\"Patreon Integration\") }} </h6> </template> <template v-if=\"isPatreonLinked && creatorTiers.length\"> <b-alert show> <i18n :path=\" t( `If you wish to share access to this package with another Patreon's subscribers, please contact {0}` ) \" > <a href=\"mailto:bazaar@forge-vtt.com\">us</a> </i18n> </b-alert> <!-- Usage --> <i18n v-if=\"totalSlots !== 0\" :path=\"t('You are using {0} of {1} integration slots')\" tag=\"div\"> <strong>{{ usedSlots }}</strong> <strong>{{ availableSlots }}</strong> </i18n> <div> <i>{{ t(\"Choose the Patreon tiers who can access this package below\") }}:</i> </div> <!-- Tiers --> <b-form-group label-cols-lg=\"3\" class=\"mt-2\" :description=\"minimumContributionDescription\"> <template #label> <span v-show=\"isContributionModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Minimum Lifetime Contribution\") }}: </template> <b-input-group prepend=\"$\" class=\"w-25\"> <b-form-input v-model=\"editedPackage.patreon.minimumContribution\" name=\"minimumContribution\" type=\"number\" class=\"text-right\" no-wheel > </b-form-input> </b-input-group> </b-form-group> <b-form-group label-cols-lg=\"3\" class=\"mt-2\"> <template #label> <span v-show=\"isTiersModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Selected tiers\") }}: </template> <b-list-group horizontal> <b-form-checkbox-group v-model=\"editedPackage.patreon.tiers\" class=\"pt-2\" stacked :options=\"creatorTiers\" value-field=\"title\" text-field=\"title\" ></b-form-checkbox-group> </b-list-group> </b-form-group> </template> <template v-else> <p> {{ t( \"The Forge offers you the option to link your Patreon account and provide this package to subscribers of specific tiers.\" ) }} </p> <p v-if=\"!isPatreonLinked\"> <i18n :path=\"t(`Click {0} to link your Patreon account`)\"> <a href=\"/account#patreon\">{{ t(\"here\") }}</a> </i18n> </p> <p v-else-if=\"!creatorTiers.length\"> <template v-if=\"admin\"> {{ t(\"The creator has not configured Patreon tiers for this package yet.\") }} </template> <template v-else> {{ t(\"Your Patreon account has no tiers, please visit your Patreon account to add tiers.\") }} </template> </p> </template> </b-card> <!-- Version informations --> <b-card class=\"my-2 border border-primary\"> <template #header> <h6 class=\"mb-0\"><i class=\"fa fa-box fa-fw\"></i> {{ t(\"Package versions\") }}</h6> </template> <b-table bordered stacked=\"md\" show-empty medium sticky-header head-variant=\"light\" sort-by=\"version\" :fields=\"packageVersionFields\" :items=\"editedPackage.data.versionsData\" > <template #cell(available)=\"rowData\"> <b-form-group v-if=\"admin\" :id=\"`version-switch-${rowData.item._id}`\"> <b-form-checkbox v-model=\"rowData.item.available\" switch :disabled=\" !originalPackage.available || !originalPackage.marketplace.ready || disableVersionSwitch(rowData.item._id) \" > {{ t(\"Available\") }} </b-form-checkbox> <b-tooltip v-if=\"!originalPackage.available || !originalPackage.marketplace.ready\" :target=\"`version-switch-${rowData.item._id}`\" triggers=\"hover\" > <span>{{ t(\"The package is unavailable or not ready, versions availability cannot be updated.\") }}</span> </b-tooltip> <b-tooltip v-else-if=\"disableVersionSwitch(rowData.item._id)\" :target=\"`version-switch-${rowData.item._id}`\" triggers=\"hover\" > <span>{{ t(\"At least one version should be available\") }}</span> </b-tooltip> </b-form-group> <i v-else-if=\"rowData.item.available\" class=\"fas fa-check text-success\"></i> <i v-else class=\"fas fa-times text-danger\"></i> </template> <template #cell(manifest)=\"rowData\"> <a :href=\"rowData.item.manifest\" target=\"_blank\"><i class=\"fas fa-external-link-alt\"></i></a> </template> </b-table> </b-card> <!-- Description --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isShortDescriptionModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Preview Description:\") }} </template> <tiny-mce v-model=\"editedPkg.short_description\" name=\"description\" class=\"w-100\" :settings=\"tinymceSettings\" > </tiny-mce> </b-form-group> <!-- Full Description --> <b-form-group label-cols-lg=\"3\"> <template #label> <span v-show=\"isFullDescriptionModified\" v-b-tooltip.hover.top=\"unsavedTooltipTitle\"> <a href=\"#\" @click.prevent=\"toastNeedsAttention\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </a >&nbsp; </span> {{ t(\"Full Description:\") }} </template> <tiny-mce v-model=\"editedPkg.description_full\" name=\"description_full\" class=\"w-100\" :settings=\"tinymceSettings\" > </tiny-mce> </b-form-group> </b-form> <div v-if=\"originalPackage.marketplace.eulaSigned\"> <!-- Licensing Information --> <b-form-group label-cols-lg=\"3\"> <template #label> {{ t(\"Licensing information:\") }} </template> <b-card class=\"licensing-information\"> <span v-html=\"editedPackage.marketplace.licensingInformation\"></span> </b-card> <small> <i18n :path=\" t( 'The licensing information can only be changed during publishing. If you need to modify this information after the package is made public, but without unlisting your package, contact us at {0}' ) \" > <a href=\"mailto:contact@forge-vtt.com\"> contact@forge-vtt.com </a> </i18n> </small> </b-form-group> <!-- EULA --> <b-form-group label-cols-lg=\"3\"> <template #label> {{ t(\"Bazaar Marketplace agreement:\") }} </template> <b-card class=\"marketplace-creator-eula\"> <b-row> <b-col> {{ t(\"You have signed the Bazaar Marketplace agreement on:\") }} <b>{{ eulaDate }}</b> </b-col> <b-col md=\"auto\"> <b-button variant=\"primary\" @click=\"showEula = true\"> <i class=\"fas fa-external-link-alt\"></i> </b-button> </b-col> </b-row> <b-modal v-model=\"showEula\" size=\"xl\" :ok-only=\"true\" :title=\"t('Bazaar Marketplace agreement')\"> <span v-html=\"eulaHtml\"></span> </b-modal> </b-card> </b-form-group> </div> <b-toaster name=\"package-configuration-toaster\" :class=\"toastIntersected ? '' : 'fixed'\"></b-toaster> <!-- Add padding to avoid toaster jumping from fixed to non fixed then add intersection observer beneath the padding --> <div :style=\"!toastIntersected && isConfigurationChanged ? 'height: 70px' : ''\"></div> <intersection @enter=\"toastIntersected = true\" @leave=\"toastIntersected = false\"> <div></div> </intersection> <!-- Pending modifications toaster --> <b-toast key=\"toast\" :visible=\"isConfigurationChanged\" toaster=\"package-configuration-toaster\" variant=\"primary\" no-auto-hide no-close-button > <div class=\"text-center\" :class=\"toastAnimationClass\"> <div v-if=\"(allUsed || totalSlots === 0) && isTiersModified\" class=\"font-weight-bold\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> {{ t( \"Making these changes could result in additional fees being added to your account at the end of the month.\" ) }} </div> {{ t(\"You have unsaved changes to your package configuration.\") }} <b-button size=\"sm\" class=\"m-1\" variant=\"secondary\" @click.prevent=\"resetChanges\"> <i class=\"fas fa-undo\"></i> {{ t(\"Reset changes\") }} </b-button> <b-button size=\"sm\" class=\"m-1\" variant=\"success\" :disabled=\"savingConfig\" @click.prevent=\"saveConfig\"> <loading-indicator v-if=\"savingConfig\" tag=\"span\" small :label=\"t('Saving configuration…')\" ></loading-indicator> <span v-else> <i class=\"fas fa-save\"></i> {{ t(\"Save Changes\") }} </span> </b-button> </div> </b-toast> </b-col> </b-row> <!-- Confirm adding another slot --> <confirm-message v-model=\"showConfirmAnotherSlot\" variant=\"question\" title=\"Confirm additional fees\" no-close-on-backdrop no-close-on-esc @cancel=\"cancelAnotherSlot\" @ok=\"saveConfig\" > <div v-if=\"totalSlots === 0\"> <p> <i18n :path=\"t('Making these changes will result in additional fees on {0}.')\" tag=\"span\"> <strong>{{ nextBillingDate }}</strong> </i18n> <a href=\"https://forums.forge-vtt.com/t/patreon-integration/68542\" target=\"_blank\">{{ t(\"Click here for more information.\") }}</a> </p> <i18n :path=\"t('Total integration costs: {0}')\" tag=\"p\"> <strong>{{ futureCost }}</strong> </i18n> </div> <div v-else> <p> <i18n :path=\" t( 'Making these changes will result in additional slots being added to your account, which will result in additional fees on {0}.' ) \" tag=\"span\" > <strong>{{ nextBillingDate }}</strong> </i18n> <a href=\"https://forums.forge-vtt.com/t/patreon-integration/68542\" target=\"_blank\">{{ t(\"Click here to read more.\") }}</a> </p> <i18n :path=\"t('Total integration costs with the additional slot: {0}')\" tag=\"p\"> <strong>{{ futureCost }}</strong> </i18n> <div v-if=\"usedSlots > 0\"> {{ t( \"Alternatively, you can remove one of your current packages from being integrated with Patreon and use that slot instead.\" ) }} <ul class=\"integration-list forge-custom-scrollbar\"> <li v-for=\"integration in integrationList\" :key=\"integration.name\"> {{ integration.title }} </li> </ul> </div> </div> </confirm-message> <bazaar-full-package-modal v-model=\"fullPage\" :package=\"editedPkg\" :user-integrations=\"userIntegrations\" :can-install=\"true\" :show-creator-alerts=\"false\" @close=\"displayPackage\" @add-tag=\"redirectToBazaar\" > </bazaar-full-package-modal> </div> </b-card-body> </b-card>",
  beforeCreate() {
    Utils.loadCss({
      content: ".creator-dashboard-package .package-overlay { width: 100vw; height: calc(100vh - 60px); } .creator-dashboard-package .package-overlay .jumbotron { overflow: auto; } .creator-dashboard-package .marketplace-creator-eula pre { border: solid black 1px; padding: 5px; /* This is to prevent long pre/code from screwing up the layout * no idea why it does it or how to fix it. */ display: none; } .package-configuration .clickable { cursor: pointer; } .package-configuration-banner-thumbnail { height: 75px; width: auto; } .package-configuration-banner-upload-zone { border: 3px dotted; border-radius: 10px; height: 75px; width: 100%; cursor: pointer; } .b-toaster.package-configuration-toaster.fixed { position: fixed; bottom: 0.5rem; left: 0.5rem; right: 0.5rem; margin: 0px; padding: 0px; } .b-toaster.package-configuration-toaster .b-toaster-slot, .b-toaster.package-configuration-toaster .b-toaster-slot .b-toast, .b-toaster.package-configuration-toaster .b-toaster-slot .toast { width: 100%; max-width: 100%; } .package-status { font-size: 35px; line-height: 12px; } ul.integration-list { overflow-y: scroll; max-height: 20em; } .b-form-tags-input { outline-color: transparent; } .bazaar-tag-list .bazaar-tag-item button { outline: none !important; }"
    });
  },
  props: {
    package: Object,
    admin: {
      type: Boolean,
      default: false
    },
    creatorData: Object,
    paypal: String,
    userIntegrations: Object,
    creatorIntegration: Object,
    usedSlots: {
      type: Number,
      default: 0
    },
    backButton: {
      type: Boolean,
      default: false
    },
    bazaarTagsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hash: "",
      fullPage: false,
      eulaDialogVisible: false,
      revenueSharingDialogVisible: false,
      editedPackage: {},
      screenshot: "",
      unsavedTooltipTitle: t("Modified value is not saved"),
      tinymceSettings: {
        language: "en",
        height: 500,
        menubar: true,
        plugins: ["advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor", "searchreplace", "visualblocks", "code", "fullscreen", "insertdatetime", "media", "table", "code", "help", "wordcount"],
        toolbar: "undo redo | formatselect | bold italic forecolor backcolor | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | help",
        promotion: false // Disable TinyMCE advertisement
      },

      toastAnimationClass: "animate__animated animate__fast animate__tada",
      toastIntersected: false,
      savingConfig: false,
      showEula: false,
      showManifest: false,
      showManifestURL: false,
      manifestInputType: "password",
      showConfirmAnotherSlot: false,
      bazaarTagText: "",
      maxBazaarTags: 5,
      bazaarTagFocussed: false,
      bazaarTagDropdownExpanded: false,
      packageVersionFields: [{
        key: "version",
        label: t("Version"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "created",
        label: t("Created"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right",
        formatter: (value, _, __) => {
          return new Date(value).toLocaleDateString();
        }
      }, {
        key: "manifest",
        label: t("Manifest URL"),
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "minCoreVersion",
        label: t("Minimum Core Version"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "maxCoreVersion",
        label: t("Maximum Core Version"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "compatibleCoreVersion",
        label: t("Compatible Core Version"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }, {
        key: "available",
        label: t("Availability"),
        sortable: true,
        tdClass: "py-3 align-middle",
        thClass: "border-right"
      }]
    };
  },
  watch: {
    hashProps() {
      if (Boolean(this.hashProps.full) !== this.fullPage) {
        this.fullPage = Boolean(this.hashProps.full);
      }
    },
    package() {
      this.resetChanges();
    },
    pwywMinimum() {
      this.editedPkg.pwywMinimum = this.pwywMinimum;
    },
    price() {
      this.editedPkg.price = this.price;
    },
    icon() {
      this.editedPkg.media = this.genMedia();
    },
    cover() {
      this.editedPkg.media = this.genMedia();
    },
    screenshots() {
      this.editedPkg.media = this.genMedia();
    },
    tiers() {
      if (this.editedPackage.patreon && this.isPatreonLinked) {
        this.editedPackage.patreon.creator = this.userIntegrations.patreon.username;
        if ((this.allUsed || this.totalSlots === 0) && this.isTiersModified && this.editedPackage.patreon.tiers.length && (this.package.patreon.tiers === undefined || this.package.patreon.tiers.length === 0)) {
          this.showConfirmAnotherSlot = true;
        }
      }
    }
  },
  computed: {
    pkg() {
      return this.package.data;
    },
    editedPkg() {
      return Object.assign(this.editedPackage.data, {
        isCreator: true,
        marketplace: {
          ready: this.editedPackage.marketplace.ready
        }
      });
    },
    isPkgVersionsModified() {
      for (const editedPkgVersion of this.editedPackage.data.versionsData) {
        if (Array.from(this.package.data.versionsData).find(version => version._id === editedPkgVersion._id && version.available !== editedPkgVersion.available)) {
          return true;
        }
      }
      return false;
    },
    originalPackage() {
      // why did I use 'package' which is a JS keyword??
      return this.package;
    },
    hashProps() {
      return Bazaar.hashProps(this.hash);
    },
    isBrandNew() {
      return !this.package.manifest;
    },
    isWaitingApproval() {
      return this.package.marketplace.ready && !this.package.available;
    },
    isShortDescriptionModified() {
      return this.pkg.short_description !== this.editedPkg.short_description;
    },
    isFullDescriptionModified() {
      return this.pkg.description_full !== this.editedPkg.description_full;
    },
    isManifestModified() {
      return this.package.manifest.manifest !== this.editedPackage.manifest.manifest;
    },
    isDownloadModified() {
      return this.package.marketplace && this.package.marketplace.download !== this.editedPackage.marketplace.download;
    },
    isAvailableModified() {
      return this.package.available !== this.editedPackage.available;
    },
    isAllowManifestInstallModified() {
      return this.package.marketplace.allowManifestInstall !== this.editedPackage.marketplace.allowManifestInstall;
    },
    isBazaarTagsModified() {
      return JSON.stringify(this.pkg.bazaarTags) !== JSON.stringify(this.editedPkg.bazaarTags);
    },
    isPriceModified() {
      return this.package.marketplace.price !== this.editedPackage.marketplace.price;
    },
    isSaleModified() {
      return this.package.marketplace.sale !== this.editedPackage.marketplace.sale;
    },
    isPWYWModified() {
      return this.package.marketplace.pwyw !== this.editedPackage.marketplace.pwyw;
    },
    isMinimumModified() {
      return this.package.marketplace.minimum !== this.editedPackage.marketplace.minimum;
    },
    isDownloadableModified() {
      return this.package.marketplace.downloadable !== this.editedPackage.marketplace.downloadable;
    },
    isIconModified() {
      return this.package.icon !== this.editedPackage.icon;
    },
    isCoverModified() {
      return this.package.cover !== this.editedPackage.cover;
    },
    isScreenshotsModified() {
      return JSON.stringify(this.package.screenshots) !== JSON.stringify(this.editedPackage.screenshots);
    },
    isTiersModified() {
      return JSON.stringify(this.package.patreon.tiers) !== JSON.stringify(this.editedPackage.patreon.tiers);
    },
    isContributionModified() {
      return JSON.stringify(this.package.patreon.minimumContribution) !== JSON.stringify(this.editedPackage.patreon.minimumContribution);
    },
    isConfigurationChanged() {
      return this.isShortDescriptionModified || this.isFullDescriptionModified || this.isManifestModified || this.isDownloadModified || this.isAvailableModified || this.isAllowManifestInstallModified || this.isBazaarTagsModified || this.isPriceModified || this.isSaleModified || this.isPWYWModified || this.isMinimumModified || this.isDownloadableModified || this.isIconModified || this.isCoverModified || this.isScreenshotsModified || this.isTiersModified || this.isContributionModified || this.isPkgVersionsModified;
    },
    pwyw() {
      return this.editedPackage.marketplace && this.editedPackage.marketplace.pwyw;
    },
    pwywMinimum() {
      return this.pwyw ? Number(this.editedPackage.marketplace.minimum) : undefined;
    },
    price() {
      return this.editedPackage.marketplace && (Number(this.editedPackage.marketplace.sale) || Number(this.editedPackage.marketplace.price));
    },
    platformFeeRate() {
      return this.price < this.editedPackage.marketplace.platformFeeRateThreshold ? this.editedPackage.marketplace.platformFeeRateMicro : this.editedPackage.marketplace.platformFeeRate;
    },
    creatorRate() {
      return 1 - this.platformFeeRate;
    },
    newPriceValid() {
      if (!this.isPriceModified) {
        return null;
      }
      if (this.editedPackage.marketplace.price <= 0) {
        return false;
      }
      return true;
    },
    newSaleValid() {
      if (!this.isSaleModified && !this.isPriceModified) {
        return null;
      }
      if (this.editedPackage.marketplace.price < this.editedPackage.marketplace.sale || this.editedPackage.marketplace.sale < 0) {
        return false;
      }
      return true;
    },
    icon() {
      return this.editedPackage.icon;
    },
    cover() {
      return this.editedPackage.cover;
    },
    screenshots() {
      return this.editedPackage.screenshots;
    },
    tiers() {
      if (!this.editedPackage.patreon) {
        return [];
      }
      return this.editedPackage.patreon.tiers;
    },
    eulaDate() {
      const date = new Date(this.package.marketplace.eulaDate);
      return `${date.toDateString()} ${date.toTimeString()}`;
    },
    eulaHtml() {
      return DOMPurify.sanitize(marked(this.package.marketplace.eulaSigned, {
        breaks: true,
        headerIds: false
      }));
    },
    salesValue() {
      return Utils.isNumeric(this.stats.sales) ? `US$ ${Math.abs(this.stats.sales.toFixed(2))}` : "";
    },
    revenueValue() {
      return Utils.isNumeric(this.stats.revenue) ? `US$ ${Math.abs(this.stats.revenue.toFixed(2))}` : "";
    },
    revenueShare() {
      return this.package.marketplace.revenueShare || [];
    },
    revenueSharing() {
      return this.revenueShare.length > 0;
    },
    revenueSharingButtonLabel() {
      if (this.revenueSharing) {
        return t("Edit Revenue Sharing");
      }
      return t("Set Up Revenue Sharing");
    },
    revenueSharingItems() {
      const share = this.revenueShare;
      const totalShare = share.reduce((t, s) => t + s.rate, 0);
      return [{
        self: true,
        // makes it bold
        name: t("You"),
        rate: 1 - totalShare
      }, ...share];
    },
    revenueSharingFields() {
      return [{
        key: "name",
        label: t("Creator")
      }, {
        key: "rate",
        label: t("Share"),
        formatter: (value, key, item) => {
          return `${(value * 100).toFixed(2)}%`;
        }
      }];
    },
    stats() {
      return this.package.stats || {
        installs: 0,
        revenue: 0,
        purchases: 0,
        sales: 0
      };
    },
    dashboardLink() {
      return "/account/creator#packages";
    },
    isPatreonLinked() {
      return this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon.linked;
    },
    minimumContributionDescription() {
      if (!this.isPatreonLinked) {
        return "";
      }
      return `
        ${t('This is a way to reward long-time subscribers, or limit "hit and run" subscribers from paying for one month and gaining access to all content for their tier.')}
        ${t("A subscriber must have paid at least this much (in your Patreon's currency) before being allowed to install the package.")}
      `;
    },
    allUsed() {
      return this.usedSlots >= this.availableSlots;
    },
    creatorTiers() {
      if (this.creatorData.id === this.package.user.id) {
        // The current user is the creator of this package, use their Patreon data to populate the tiers list.
        const patreon = this.userIntegrations && this.userIntegrations.patreon && this.userIntegrations.patreon;
        const pledge = patreon && patreon.pledges && patreon.pledges.find(p => p.creator && p.vanity === patreon.username);
        const tiers = pledge && pledge.tiers || [];
        const orphans = (this.editedPackage.patreon.tiers || []).filter(t => !tiers.find(ct => ct.title === t)).map(t => {
          return {
            title: t
          };
        });
        return tiers.concat(orphans);
      }
      // The current user is an admin who is not the creator of this package, just display the existing tiers.
      return this.package.patreon && this.package.patreon.tiers ? this.package.patreon.tiers : [];
    },
    availableSlots() {
      if (!this.creatorIntegration) {
        return 0;
      }
      const patreon = this.creatorIntegration.patreon;
      return patreon && patreon.slots ? Math.ceil(patreon.slots / patreon.slot_incr) * patreon.slot_incr : patreon.slot_incr;
    },
    totalSlots() {
      if (!this.creatorIntegration) {
        return 0;
      }
      return this.creatorIntegration.patreon.slots || 0;
    },
    slotIncrCost() {
      if (!this.creatorIntegration) {
        return 0;
      }
      return this.creatorIntegration.patreon.unit_cost || 0;
    },
    futureCost() {
      if (!this.creatorIntegration) {
        return 0;
      }
      const slotIncrements = Math.ceil((this.creatorIntegration.patreon.slots + 1) / this.creatorIntegration.patreon.slot_incr);
      const value = this.slotIncrCost * slotIncrements;
      return `$ ${value.toFixed(2)}`;
    },
    nextBillingDate() {
      // Default to today's date so that billing date preview is accurate when enabling integrations for the first time.
      const billDate = this.creatorIntegration && this.creatorIntegration.slots ? new Date(this.creatorIntegration.patreon.startDate) : new Date();
      billDate.setUTCMonth(billDate.getUTCMonth() + 1);
      // Sanitize the date to match what is used for billing
      billDate.setUTCHours(0);
      billDate.setUTCMinutes(0);
      billDate.setUTCSeconds(0);
      billDate.setUTCMilliseconds(0);
      if (billDate.getUTCDate() > 28) {
        billDate.setUTCDate(28);
      }
      return billDate.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    },
    integrationList() {
      if (!this.creatorIntegration) {
        return [];
      }
      const integrations = this.creatorIntegration.integrations;
      return integrations.map(i => {
        return {
          name: i.data.name,
          title: i.data.title,
          type: i.data.type,
          tiers: i.patreon.tiers.join(", "),
          date: i.data.created,
          patreon: i.patreon
        };
      });
    },
    tagList() {
      return this.editedPkg.bazaarTags.map(tag => {
        // Check to see that the tag key appears in the list of selectable tags from the database
        // Otherwise it's custom
        // It's possible, if multiple selectable bazaarTags with the same bt.tag exists, label will be incorrect
        const matchedBazaarTag = this.bazaarTagsList.find(bt => bt.selectable && bt.tag === tag);
        return {
          tag,
          label: matchedBazaarTag && matchedBazaarTag.label || tag // Translated label or the custom tag itself
        };
      }).filter((value, index, array) => array.findIndex(t => t.label === value.label) === index).sort((a, b) => a.label.localeCompare(b.label));
    },
    hasTags() {
      return !!this.editedPkg.bazaarTags.length;
    },
    canAddTags() {
      return this.editedPkg.bazaarTags.length < this.maxBazaarTags;
    },
    BazaarTagAddTooltip() {
      return this.canAddTags ? t("Add tag") : t("Maximum tags have been reached");
    },
    bazaarTagTipData() {
      return t("Bazaar Tags are terms that can be used while searching for this module in the Bazaar.  You can either select tags from our list, or add your own if you can't find them on the list.");
    }
  },
  methods: {
    onHashChange() {
      this.hash = window.location.hash;
    },
    buildHash(overrides = {}) {
      this.hash = window.location.hash = `#${Bazaar.buildHash(this.hashProps, overrides)}`;
    },
    displayPackage(display) {
      this.buildHash({
        full: display ? "1" : ""
      });
    },
    overlayClicked(ev) {
      if (this.$refs.packageOverlay === ev.target) {
        this.displayPackage(false);
      }
    },
    disableVersionSwitch(versionId) {
      const availableVersions = this.editedPackage.data.versionsData.filter(version => version.available);
      if (availableVersions.length !== 1) {
        // If there is no available versions in the db, it should not be disabled
        return false;
      }
      return availableVersions[0]._id === versionId;
    },
    genMedia() {
      const media = [];
      const originalMedia = (this.package.data.media || []).filter(m => {
        if (m.type === PACKAGE_MEDIA_TYPES.ICON && m.url === this.package.icon) {
          return false;
        }
        if (m.type === PACKAGE_MEDIA_TYPES.COVER && m.url === this.package.cover) {
          return false;
        }
        return true;
      });
      if (this.icon) {
        media.push({
          type: PACKAGE_MEDIA_TYPES.ICON,
          url: this.icon
        });
      }
      if (this.cover) {
        media.push({
          type: PACKAGE_MEDIA_TYPES.COVER,
          url: this.cover
        });
      }
      media.push(...this.screenshots.map(url => ({
        type: this.isUrlVideo(url) ? PACKAGE_MEDIA_TYPES.VIDEO : PACKAGE_MEDIA_TYPES.SCREENSHOT,
        url: url
      })));
      media.push(...originalMedia);
      return media;
    },
    addScreenshot() {
      this.screenshots.push(this.screenshot);
      this.screenshot = "";
    },
    removeScreenshot(idx) {
      this.screenshots.splice(idx, 1);
    },
    isUrlVideo(url) {
      return Assets.VIDEO_EXTENSIONS.some(ext => url.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) || /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i.test(url) || /^.*vimeo.com\/(\d+)($|\/|\b)/i.test(url) || /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#\&\?]*).*/i.test(url);
    },
    toastNeedsAttention() {
      this.toastAnimationClass = "";
      this.$nextTick(() => this.toastAnimationClass = "animate__animated animate__fast animate__tada");
    },
    resetChanges() {
      this.editedPackage = JSON.parse(JSON.stringify(this.package));
      this.editedPackage.data.fullyLoaded = true;

      // make sure that the patreon tiers object exists
      this.editedPackage = Object.assign({
        patreon: {
          tiers: []
        }
      }, this.editedPackage);
    },
    async saveConfig() {
      if (this.bazaarTagText) {
        this.selectTagText();
      }
      if (!this.editedPackage.patreon || !this.editedPackage.patreon.tiers || this.editedPackage.patreon.tiers.length === 0) {
        this.editedPackage.patreon.creator = null;
      }
      this.savingConfig = true;
      this.editedPackage.marketplace.price = Number(this.editedPackage.marketplace.price);
      this.editedPackage.marketplace.sale = Number(this.editedPackage.marketplace.sale);
      this.editedPackage.marketplace.minimum = Number(this.editedPackage.marketplace.minimum);
      this.editedPackage.patreon.minimumContribution = Number(this.editedPackage.patreon.minimumContribution);
      const response = await Utils.api("bazaar/creator", {
        action: "configure-package",
        type: this.pkg.type,
        name: this.pkg.name,
        manifest: this.editedPackage.manifest.manifest,
        short_description: this.editedPkg.short_description,
        description_full: this.editedPkg.description_full,
        available: this.admin ? this.editedPackage.available : undefined,
        allowManifestInstall: this.editedPackage.marketplace.allowManifestInstall,
        marketplace: this.editedPackage.marketplace,
        icon: this.editedPackage.icon,
        cover: this.editedPackage.cover,
        screenshots: this.editedPackage.screenshots,
        patreon: this.editedPackage.patreon,
        bazaarTags: this.editedPkg.bazaarTags,
        versionsData: this.admin && this.isPkgVersionsModified ? this.editedPackage.data.versionsData : null
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t("Error setting package configuration: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", response.package);
      }
    },
    readyToPublish() {
      this.eulaDialogVisible = true;
    },
    editRevenueSharing() {
      this.revenueSharingDialogVisible = true;
    },
    async approve() {
      if (this.admin) {
        this.savingConfig = true;
        const response = await Utils.api("bazaar/creator", {
          action: "configure-package",
          type: this.pkg.type,
          name: this.pkg.name,
          available: true
        });
        this.savingConfig = false;
        if (response.error) {
          UI.alert("danger", t("Error setting package configuration: {{- error}}", {
            error: response.error
          }));
        } else {
          this.$emit("update", response.package);
          UI.alert("success", t("The package, {{- name}}, has been approved.", {
            name: this.pkg.title
          }));
        }
      }
    },
    async unpublish() {
      const result = this.isWaitingApproval ? "yes" : await UI.query(t("Unpublish this package"), t(`Are you sure you want to unpublish {{- title}}?`, {
        title: `“<strong>${Utils.escapeHTML(this.pkg.name)}</strong>”`
      }), {
        buttons: [{
          id: "unpublish-no",
          type: "success",
          label: t("No"),
          response: "no"
        }, {
          id: "unpublish-yes",
          type: "danger",
          label: t("Yes, Unpublish from the Bazaar"),
          response: "yes"
        }]
      });
      if (result !== "yes") {
        return;
      }
      this.eulaDialogVisible = false; // Adding this here to avoid the eula re-opening after cancelling approval
      this.savingConfig = true;
      const response = await Utils.api("bazaar/creator", {
        action: "configure-package",
        type: this.pkg.type,
        name: this.pkg.name,
        available: false,
        ready: false
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t("Error setting package configuration: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", response.package);
        UI.alert("success", t("Your package has been unpublished."));
      }
    },
    async generateGift() {
      const result = await UI.query(t("Generate new gift"), `${t(`Do you want to generate a gift for the package {{- title}}?`, {
        title: `“<strong>${Utils.escapeHTML(this.pkg.name)}</strong>”`
      })}<br/>
        ${t(`You can generate <strong>5</strong> gifts per month for free (across all your packages),<br/>then a <strong>15%</strong> platform fee will be charged per gift that you create.`)}`, {
        buttons: [{
          id: "gift-no",
          type: "danger",
          label: t("Never mind"),
          response: "no"
        }, {
          id: "gift-yes",
          type: "success",
          label: t("I'm feeling generous"),
          response: "yes"
        }],
        dialog_classes: "modal-lg modal-dialog-centered"
      });
      if (result !== "yes") {
        return;
      }
      this.savingConfig = true;
      const response = await Utils.api("bazaar/creator", {
        action: "generate-gift",
        type: this.pkg.type,
        name: this.pkg.name
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t("Error generating gift: {{- error}}", {
          error: response.error
        }));
      } else {
        UI.alert("success", t("Gift created successfully. Look for it in your account's purchases."));
      }
    },
    reloadPage() {
      window.location.reload();
    },
    cancelAnotherSlot() {
      if (this.editedPackage.patreon.tiers.length === 0) {
        this.editedPackage.patreon.creator = null;
      }
    },
    expandBazaarTagDropdown() {
      this.bazaarTagFocussed = true;
      this.bazaarTagDropdownExpanded = true;
    },
    collapseBazaarTagDropdown() {
      this.bazaarTagFocussed = false;
      // Use a timeout to make sure that the dropdown stays open so users can select multiple tags
      window.setTimeout(() => {
        if (!this.bazaarTagFocussed) {
          this.bazaarTagDropdownExpanded = false;
        }
      }, 200);
    },
    findSelectableBazaarTag(input) {
      /*
        When a user adds a tag, we try to match the input against our system tags by checking if:
        -- the lowercase input strictly matches a system tag's default language lowercase label or,
        -- the lowercase input strictly matches a system tag's translated lowercase label or,
        -- the slugified input strictly matches a system tag's tag slug
        If there is a match to a system tag, then we add the system tag's tag slug to packages.bazaarTags.
         */
      return this.bazaarTagsList.find(bt => {
        // Check if lowercased input matches lowercased original label or translated label strictly
        const toMatch = input.toLowerCase();
        return bt.selectable && (bt.tag.toLowerCase() === toMatch || bt.label.toLowerCase() === toMatch || bt._label.toLowerCase() === toMatch);
      });
    },
    addBazaarTag(bazaarTag) {
      if (!bazaarTag) {
        return;
      }
      const selectableTag = this.findSelectableBazaarTag(bazaarTag);
      if (selectableTag) {
        bazaarTag = selectableTag.tag;
      }

      // Remove the tag if adding the tag again
      if (this.editedPkg.bazaarTags.includes(bazaarTag)) {
        this.removeBazaarTag(bazaarTag);
      } else {
        if (this.editedPkg.bazaarTags.length >= this.maxBazaarTags) {
          return UI.warn(t("Maximum number of tags has been reached"));
        }
        if (bazaarTag.length < 3) {
          return UI.warn(t("Bazaar tag must be at least 3 characters"));
        }
        this.editedPkg.bazaarTags.push(bazaarTag);
      }
      this.bazaarTagText = "";
    },
    removeBazaarTag(bazaarTag) {
      this.editedPkg.bazaarTags = this.editedPkg.bazaarTags.filter(t => t !== bazaarTag);
    },
    clearBazaarTags() {
      this.editedPkg.bazaarTags = [];
      this.bazaarTagText = "";
      this.collapseBazaarTagDropdown();
    },
    selectFromDropDown(tag) {
      // Use the untranslated text to save to the database
      this.addBazaarTag(tag._label);
    },
    selectTagText() {
      this.addBazaarTag(this.bazaarTagText);
      this.bazaarTagText = "";
      this.bazaarTagDropdownExpanded = false;
    },
    checkForEnterKey(event) {
      this.bazaarTagDropdownExpanded = true;
      if (event.keyCode === 13) {
        this.selectTagText();
      }
    },
    redirectToBazaar(tag) {
      const [key, value] = tag.split(":");
      if (key && value) {
        window.open(`/bazaar#${key}=${value}`, "_blank");
      }
    },
    async updateManifestURL() {
      this.savingConfig = true;
      const response = await Utils.api("bazaar/creator", {
        action: "configure-package",
        type: this.pkg.type,
        name: this.pkg.name,
        manifest: this.pkg.manifest
      });
      this.savingConfig = false;
      if (response.error) {
        UI.alert("danger", t("Error setting package manifest URL: {{- error}}", {
          error: response.error
        }));
      } else {
        this.$emit("update", response.package);
        UI.alert("success", t("The manifest for, {{- name}}, has been updated.", {
          name: this.pkg.title
        }));
      }
    }
  },
  created() {
    this.resetChanges();
    this.hash = window.location.hash;
    $(window).on("hashchange", this.onHashChange);
    $(window).on("blur", this.collapseBazaarTagDropdown);
  },
  beforeDestroy() {
    $(window).off("hashchange", this.onHashChange);
    $(window).off("blur", this.collapseBazaarTagDropdown);
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorRevenueSharing"] = Vue.component(
                    "ProfileCreatorRevenueSharing",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<b-modal size=\"lg\" :visible=\"visible\" title=\"Configure Revenue Sharing\" centered @hidden=\"visible = false\" @shown=\"dialogShown\" > <div> <div class=\"revenue-sharing-config\"> <div class=\"m-2\"> {{ t( \"The Forge can automatically share revenues from a package sale on the Bazaar Marketplace with other creators or publishers.\" ) }}<br /> <i18n :path=\" t('Simply enter the Creator ID of the creator (available from their {0} and the share of their revenue).') \" > <a href=\"https://forge-vtt.com/account/creator\" target=\"_blank\">{{ t(\"Dashboard\") }}</a> </i18n> </div> <strong class=\"m-2 mb-5\"> {{ t( \"Note that changes take effect immediately once submitted. However, they are not retroactive and the distribution of the revenue will only affect future purchases.\" ) }} </strong> <b-table ref=\"creatorsList\" class=\"revenue-sharing-creators-list\" striped small sticky-header foot-clone :fields=\"fields\" :items=\"items\" > <template #cell(error)=\"{ item }\"> <span v-if=\"!validEntry(item)\" v-b-tooltip.hover.top=\"issueTooltip(item)\"> <i class=\"fas fa-exclamation-triangle text-warning\"></i> </span> </template> <template #cell(name)=\"{ item }\"> <strong v-if=\"item.self\">{{ item.name }}</strong> <span v-else> {{ item.name }} </span> </template> <template #cell(rate)=\"{ item }\"> <b-input-group append=\"%\"> <b-form-input v-model=\"item.rate\" class=\"revenu-share-percentage\" :placeholder=\"t('Share Percentage')\" :disabled=\"item.self\" number min=\"0\" max=\"100\" ></b-form-input> </b-input-group> </template> <template #cell(delete)=\"data\"> <b-link v-if=\"!data.item.self\" href=\"#\" @click=\"deleteRow(data.index)\"><i class=\"fas fa-trash\"></i></b-link> </template> <template #foot(name)> <b-form-input v-model=\"dummyID\" :placeholder=\"t('Enter Creator ID')\" :state=\"dummyID ? isValidNewCreatorID : null\" @keyup=\"addRow\" ></b-form-input> </template> <template #foot(rate)> <b-input-group append=\"%\"> <b-form-input v-model=\"dummyRate\" :placeholder=\"t('Share Percentage')\" number min=\"0\" max=\"100\" ></b-form-input> </b-input-group> </template> </b-table> </div> </div> <b-alert variant=\"danger\" :show=\"!!errorMessage\"> {{ errorMessage }} </b-alert> <template #modal-footer=\"{ cancel }\"> <b-button variant=\"primary\" class=\"mr-auto\" @click=\"openInformation\" ><i class=\"fas fa-question-circle\"></i> {{ t(\"More Information\") }}</b-button > <b-button variant=\"success\" :disabled=\"!!errorMessage\" @click=\"submit\">{{ t(\"Submit\") }}</b-button> <b-button variant=\"secondary\" @click=\"cancel\">{{ t(\"Cancel\") }}</b-button> </template> </b-modal>",
  beforeCreate() {
    Utils.loadCss({
      content: ".revenue-sharing-config .error-column { width: 40px; } .revenue-sharing-config .revenue-sharing-creators-list { max-height: calc(100vh - 500px); } .revenue-sharing-config .revenue-sharing-creators-list thead tr th { border-top: 0px; } .revenue-sharing-config .revenue-sharing-creators-list tfoot tr th { position: -webkit-sticky; position: sticky; bottom: -1px; z-index: 2; color: #212529; background-color: #fff; border-bottom: 0px; }"
    });
  },
  props: {
    value: Boolean,
    pkg: {
      type: Object
    }
  },
  data() {
    return {
      dummyID: "",
      dummyRate: "10",
      fields: [{
        key: "error",
        label: "",
        class: "align-middle text-center",
        tdClass: "error-column"
      }, {
        key: "name",
        label: t("Creator")
      }, {
        key: "rate",
        label: t("Share")
      }, {
        key: "delete",
        label: "",
        class: "align-middle text-center"
      }],
      items: []
    };
  },
  watch: {
    items: {
      handler() {
        const self = this.items.find(i => i.self);
        if (this.totalRate > 100 || isNaN(this.totalRate)) {
          self.rate = "---";
        } else {
          self.rate = (100 - this.totalRate).toFixed(2);
        }
      },
      deep: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    totalRate() {
      return this.items.reduce((total, share) => {
        if (share.self) {
          return total;
        }
        return total + Number(share.rate);
      }, 0);
    },
    isValidNewCreatorID() {
      return /^[0-9a-f]{24}$/.test((this.dummyID || "").trim());
    },
    errorMessage() {
      if (this.totalRate > 100) {
        return t("Total revenue share cannot exceed 100%");
      }
      for (const share of this.items) {
        if (!this.validEntry(share)) {
          return t("Some entries have errors");
        }
      }
      return "";
    }
  },
  methods: {
    dialogShown() {
      this.items = [{
        self: true,
        name: t("Your share"),
        rate: "100"
      }];
      for (const share of this.pkg.marketplace.revenueShare) {
        this.items.push({
          id: share.id,
          name: share.name,
          rate: (share.rate * 100).toFixed(2)
        });
      }
      // self rate gets calculated on next tick through the watch handler
      this.$nextTick(() => {
        // Set default rate to 50% of the remaining share of the creator
        this.dummyRate = (Number(this.items[0].rate) / 2).toString();
        this.dummyID = "";
      });
    },
    async submit() {
      if (this.errorMessage) {
        return;
      }
      const revenueShare = this.items
      // Filter out the self portion
      .filter(share => !share.self)
      // Create the slug/pathname, incrementing each entity type to ensure uniqueness
      .map(share => {
        return {
          creator: share.id,
          rate: Number(share.rate) / 100
        };
      });
      const response = await Utils.api(`bazaar/creator`, {
        action: "configure-revenue-sharing",
        type: this.pkg.data.type,
        name: this.pkg.data.name,
        revenueShare: revenueShare
      });
      if (response.error) {
        UI.alert("danger", t("Error setting Revenue Sharing: {{- error}}", {
          error: response.error
        }), true, 10000);
      } else {
        UI.alert("success", t("New Revenue Sharing configured set successfully"), true, 10000);
        this.$emit("update", response.package);
        this.visible = false;
      }
    },
    openInformation() {
      window.open("https://forums.forge-vtt.com/t/bazaar-creator-how-to-share-revenue-with-other-creators/15809", "_blank").focus();
    },
    validEntry(item) {
      if (item.self) {
        return true;
      }
      if (this.items.filter(i => i.id === item.id).length > 1) {
        return false;
      }
      const rate = Number(item.rate);
      return !isNaN(rate) && rate >= 0 && rate <= 100;
    },
    issueTooltip(item) {
      if (this.items.filter(i => i.id === item.id).length > 1) {
        return t("Creator already exists. Remove duplicate");
      }
      const rate = Number(item.rate);
      if (isNaN(rate)) {
        return t("Invalid share rate");
      }
      if (rate < 0) {
        return t("Share Percentage must be a positive number");
      }
      if (rate > 100) {
        return t("Share Percentage cannot exceed 100%");
      }
      return "";
    },
    addRow(ev) {
      if (!this.isValidNewCreatorID && !this.dummyType) {
        return;
      }
      this.items.push({
        id: this.dummyID,
        name: this.dummyID,
        rate: this.dummyRate || "0"
      });
      this.$nextTick(() => {
        this.dummyID = "";
        this.dummyRate = (Number(this.items[0].rate) / 2).toString();
      });
      this.focusLastInput();
    },
    deleteRow(idx) {
      // Never delete the 'self' line
      if (idx === 0) {
        return;
      }
      this.items.splice(idx, 1);
    },
    focusLastInput() {
      this.$nextTick(() => {
        const table = $(this.$refs.creatorsList.$el).closest(".b-table-sticky-header");
        // scroll to the bottom so the newly created line is in view.  Technically, focus will do this too,
        // except that the sticky footer will cover the last entry if it's already scrolled to the bottom.
        table.scrollTop(table.prop("scrollHeight"));
        $(".revenu-share-percentage", this.$refs.creatorsList.$el).last().focus();
      });
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ProfileCreatorSection"] = Vue.component(
                    "ProfileCreatorSection",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div> <b-card no-body> <b-card-header class=\"section-header\"> {{ t(\"Content Creator Profile\") }} <div class=\"header-buttons\"> <b-button v-b-tooltip.hover variant=\"primary\" :disabled=\"loading\" class=\"float-right ml-2\" :title=\"t('Refresh')\" @click.prevent=\"loadContent(true)\" > <i v-if=\"loaded\" class=\"fas fa-sync-alt\"></i> <i v-else class=\"fas fa-eye\"></i> </b-button> <b-button v-if=\"!dashboard\" v-b-tooltip.hover variant=\"success\" class=\"float-right ml-2\" :title=\"t('Open Creator Dashboard')\" href=\"/account/creator#dashboard=1\" > {{ t(\"Dashboard\") }} </b-button> </div> </b-card-header> <b-card-body> <div v-if=\"!loaded\" v-b-tooltip.hover :title=\"loading ? t('Loading…') : t('Click to view')\" @click.prevent=\"loadContent\" > <b-skeleton-table :animation=\"(loading && 'wave') || null\" :rows=\"5\" :columns=\"1\"></b-skeleton-table> </div> <div v-else> <b-alert show> <i18n :path=\"t('Your current account balance is: {0}')\"> <strong>US$ {{ balance.toFixed(2) }} </strong> </i18n> </b-alert> <div v-if=\"nextPayoutAmount\" class=\"m-2\"> <i18n :path=\"t('Next Payout (for purchases made before {0}) will be paid out by {1}: {2}')\"> {{ nextPayoutCutoffDate.toLocaleDateString(undefined, dateOptions) }} <em>{{ nextPayout.toLocaleDateString(undefined, dateOptions) }}</em> <strong>$ {{ nextPayoutAmount.toFixed(2) }}</strong> </i18n> </div> <div> <b-col> <b-row> <h5 class=\"mt-2\">{{ t(\"Payouts\") }}</h5> <b-button v-if=\"payouts.length\" v-b-tooltip.hover variant=\"success\" class=\"ml-auto mr-2\" :title=\"t('Export as CSV')\" @click.prevent=\"exportPayouts\" > <i class=\"fas fa-download\"></i> </b-button> </b-row> </b-col> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"payouts\" :fields=\"payoutsFields\" > </b-table> </div> <b-col class=\"pr-2\"> <b-row class=\"mb-1\"> <h5 class=\"mt-2\">{{ t(\"Purchases\") }}</h5> <b-button v-if=\"purchases.length\" v-b-tooltip.hover variant=\"success\" small class=\"ml-auto mr-2\" :title=\"t('Export as CSV')\" @click.prevent=\"exportPurchases\" > <i class=\"fas fa-download\"></i> </b-button> </b-row> </b-col> <b-table bordered hover stacked=\"md\" show-empty small sticky-header head-variant=\"light\" :items=\"purchases\" :fields=\"purchasesFields\" > <template #cell(content)=\"{ item }\"> <a v-b-tooltip.hover :href=\"`/bazaar#package=${item.name}`\" target=\"_blank\" :title=\"item.name\">{{ item.title }}</a> </template> <template #cell(downloads)=\"{ item }\"> <span v-b-tooltip.hover :title=\" t( `This purchase was downloaded via Manifest {{downloads}} times, from {{downloadIPs}} distinct IP locations`, { downloads: item.downloads, downloadIPs: item.downloadIPs } ) \" > {{ item.downloads }} / {{ item.downloadIPs }} </span> </template> </b-table> <b-col> <b-row> <h5 class=\"mt-2\">{{ t(\"Integrations\") }}</h5> </b-row> </b-col> <b-alert v-if=\"totalSlots === 0\" show> <b-row> <b-col> {{ t(\"You currently have no modules registered for Patreon integration.\") }} </b-col> </b-row> </b-alert> <b-alert v-else show class=\"mb-1\"> <i18n :path=\" t( 'Your current charge for Patreon integrations this month is {0} from using up to {1} slots throughout the month. You will be charged next on {2}.' ) \" tag=\"p\" > <strong>{{ integrationCost }}</strong> <strong>{{ totalSlots }}</strong> <strong>{{ nextBillingDate }}</strong> </i18n> <i18n :path=\"t('You are using {0} of {1} of your current integration slots.')\"> <strong>{{ usedSlots }}</strong> <strong>{{ availableSlots }}</strong> </i18n> </b-alert> <profile-creator-integration-list v-if=\"usedSlots > 0\" :integration-list=\"integrationList\" class=\"mt-3 mb-1\" @remove=\"removeIntegration\" ></profile-creator-integration-list> </div> </b-card-body> </b-card> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ".integrations-list .remove-col { width: 40px; }"
    });
  },
  props: {
    dashboard: {
      type: Boolean,
      default: false
    },
    creatorIntegration: Object,
    loadingIntegrations: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      loadError: false,
      dataLoaded: false,
      purchases: [],
      payouts: [],
      balance: 0,
      nextPayoutAmount: 0,
      dateOptions: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      },
      payoutsFields: [{
        key: "date",
        label: t("Payout date"),
        formatter: (value, key, item) => {
          return new Date(value).toUTCString();
        }
      }, {
        key: "amount",
        label: t("Amount"),
        tdClass: "text-right",
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "status",
        label: t("Status")
      }]
    };
  },
  computed: {
    loaded() {
      return !this.loadError && !this.loading && !this.loadingIntegrations && this.dataLoaded;
    },
    purchasesFields() {
      return [{
        key: "date",
        label: t("Purchase date"),
        formatter: (value, key, item) => {
          return new Date(value).toUTCString();
        }
      }, {
        key: "content",
        label: t("Content")
      }, {
        key: "price",
        label: t("Price"),
        tdClass: "text-right",
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "fee",
        label: t("Platform Fee"),
        tdClass: "text-right",
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "share",
        label: t("Creator's share"),
        tdClass: "text-right",
        formatter: (value, key, item) => {
          return `$ ${value.toFixed(2)}`;
        }
      }, {
        key: "downloads",
        label: t("Downloads"),
        tdClass: "text-center"
      }, {
        key: "gift",
        label: t("Gifted?"),
        tdClass: "text-center",
        formatter: (value, key, item) => {
          return value ? `🎁` : "";
        }
      }];
    },
    nextPayoutCutoffDate() {
      const today = new Date();
      const isStartOfMonthEDT = today.getMonth() >= 3 && today.getMonth() <= 10;
      const tzDiff = isStartOfMonthEDT ? 4 : 5;
      return new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1, tzDiff));
    },
    nextPayout() {
      const today = new Date();
      const isStartOfMonthEDT = today.getMonth() >= 3 && today.getMonth() <= 10;
      const tzDiff = isStartOfMonthEDT ? 4 : 5;
      return new Date(Date.UTC(today.getFullYear(), today.getMonth() + 1, 1, tzDiff));
    },
    integrationCost() {
      const value = this.slotIncrCost * (this.availableSlots / this.slotIncr);
      return `$ ${value.toFixed(2)}`;
    },
    integrationList() {
      return this.integrations.map(i => {
        return {
          name: i.data.name,
          title: i.data.title,
          type: i.data.type,
          tiers: i.patreon.tiers.join(", "),
          date: i.data.created,
          patreon: i.patreon
        };
      });
    },
    integrations() {
      if (!this.creatorIntegration) {
        return [];
      }
      return this.creatorIntegration.integrations || [];
    },
    availableSlots() {
      if (!this.creatorIntegration) {
        return 0;
      }
      const patreon = this.creatorIntegration.patreon;
      return patreon && patreon.slots ? Math.ceil(patreon.slots / patreon.slot_incr) * patreon.slot_incr : 0;
    },
    totalSlots() {
      if (!this.creatorIntegration) {
        return 0;
      }
      return this.creatorIntegration.patreon.slots || 0;
    },
    usedSlots() {
      return this.integrations.filter(pkg => {
        return pkg.patreon.tiers.length;
      }).length;
    },
    slotIncr() {
      if (!this.creatorIntegration) {
        return 0;
      }
      return this.creatorIntegration.patreon.slot_incr || 0;
    },
    slotIncrCost() {
      if (!this.creatorIntegration) {
        return 0;
      }
      return this.creatorIntegration.patreon.unit_cost || 0;
    },
    minimumSlots() {
      return this.creatorIntegration.patreon.slot_incr;
    },
    nextBillingDate() {
      if (!this.creatorIntegration) {
        return "";
      }
      const billDate = new Date(this.creatorIntegration.patreon.startDate);
      billDate.setUTCMonth(billDate.getUTCMonth() + 1);
      // Sanitize the date to match what is used for billing
      billDate.setUTCHours(0);
      billDate.setUTCMinutes(0);
      billDate.setUTCSeconds(0);
      billDate.setUTCMilliseconds(0);
      if (billDate.getUTCDate() > 28) {
        billDate.setUTCDate(28);
      }
      return billDate.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    }
  },
  methods: {
    async loadContent(integrations = false) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const response = await Utils.api(`profile/creator/purchases`);
      if (response.success) {
        this.purchases = response.purchases || [];
        this.payouts = response.payouts || [];
        this.balance = response.balance;
        this.nextPayoutAmount = response.nextPayout;
        this.loadError = false;
        this.dataLoaded = true;
      } else {
        UI.error(t("Error retrieving profile information: {{- error}}", {
          error: response.error || t("Unknown Error")
        }));
        this.loadError = true;
      }
      // Load creator integrations data as well
      if (integrations) {
        this.$emit("reload");
      }
      this.loading = false;
    },
    async exportPurchases() {
      const allPurchases = await Utils.api("profile/creator/purchases?limit=-1");
      Utils.downloadAsCSV(allPurchases.purchases, {
        filename: "purchases.csv",
        transform: {
          date: d => new Date(d).toLocaleString()
        }
      });
    },
    exportPayouts() {
      Utils.downloadAsCSV(this.payouts, {
        filename: "payouts.csv",
        transform: {
          date: d => new Date(d).toLocaleString()
        }
      });
    },
    async removeIntegration(item) {
      this.$emit("remove", item);
    },
    tabLoad() {
      if (this.dataLoaded) {
        return;
      }
      this.loadContent();
    }
  },
  mounted() {
    if (this.dashboard) {
      this.loadContent(true);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminNotificationsManagement"] = Vue.component(
                    "AdminNotificationsManagement",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div id=\"notifications-management\"> <b-card no-body> <b-card-header class=\"d-flex align-items-center\"> <div> {{ t(\"Notifications Management\") }} </div> <b-button id=\"notifications-management__add-notification-button\" v-b-tooltip.hover=\"t('Add new notification')\" class=\"ml-auto\" size=\"sm\" variant=\"outline-primary\" @click=\"showAddNotificationModal\" ><i class=\"fa-fw fas fa-plus\"></i> </b-button> </b-card-header> <b-card-body> <b-input-group> <b-input-group-prepend> <b-dropdown :text=\"searchField?.label || t('Select field')\"> <b-dropdown-item @click=\"searchField = null\">{{ t(\"Select field\") }}</b-dropdown-item> <b-dropdown-item v-for=\"field in fields.filter((f) => f.searchable)\" :key=\"field.key\" @click=\"searchField = field\" > {{ field.label }} </b-dropdown-item> </b-dropdown> </b-input-group-prepend> <b-form-checkbox v-if=\"searchField?.searchInputType === 'checkbox'\" v-model=\"searchFilter\" button :button-variant=\"searchFilter ? 'primary' : 'outline-primary'\" true-value=\"true\" false-value=\"false\" debounce=\"500\" :readonly=\"!searchField\" > {{ searchFilter ? t(\"Yes\") : t(\"No\") }} </b-form-checkbox> <b-form-select v-else-if=\"searchField?.searchInputType === 'dropdown'\" v-model=\"searchFilter\" :options=\"searchField.options\" debounce=\"500\" :readonly=\"!searchField\" ></b-form-select> <b-input v-else v-model=\"searchFilter\" :type=\"searchField?.searchInputType || 'text'\" placeholder=\"Search...\" debounce=\"500\" :readonly=\"!searchField\" ></b-input> <b-input-group-append is-text> <i v-if=\"!searching\" class=\"fa fas fa-search\"></i> <b-spinner v-else small></b-spinner> </b-input-group-append> </b-input-group> <b-table ref=\"notificationsTable\" :items=\"notifications\" :fields=\"fields.filter((f) => f.visible)\" :current-page=\"currentPage\" :per-page=\"perPage\" :busy=\"refreshing\" :sort-by.sync=\"sortBy\" :sort-desc.sync=\"sortDesc\" > <template #cell(title)=\"row\"> <span style=\"cursor: pointer\" @click=\"row.toggleDetails\"> {{ row.item.title }} <span v-if=\"row.item.type !== 'USER'\" class=\"text-muted\" ><i class=\"fa fa-tv mr-1\"></i>{{ row.item.channel.name }}</span > <span v-else class=\"text-muted\"><i class=\"fa fa-user mr-1\"></i>{{ row.item.userId }}</span> <span class=\"fa fa-fw\" :class=\"row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down'\"></span ></span> </template> <template #cell(source)=\"{ item }\"> <b-badge>{{ item.source || \"SYSTEM\" }}</b-badge> </template> <template #cell(actions)=\"{ item }\"> <b-button-group> <b-button v-b-tooltip.hover=\"t('Edit')\" :title=\"t('Edit notification')\" variant=\"primary\" size=\"sm\" @click=\"showNotificationEdit(item)\" > <i class=\"fa-fw fas fa-edit\"></i> </b-button> <b-button v-b-tooltip.hover=\"t('Delete')\" :title=\"t('Delete notification')\" variant=\"danger\" size=\"sm\" @click=\"confirmNotificationDelete(item)\" > <i class=\"fa-fw fas fa-trash\"></i> </b-button> </b-button-group> </template> <template #row-details=\"{ item }\"> <b-row v-for=\"field in fields.filter((f) => !f.visible)\" :key=\"field.key\"> <b-col cols=\"3\">{{ field.label }}</b-col> <b-col cols=\"9\">{{ formatFieldValue(item[field.key], field) }}</b-col> </b-row> </template> </b-table> <b-pagination v-model=\"currentPage\" :total-rows=\"totalNotifications\" :per-page=\"perPage\"></b-pagination> </b-card-body> </b-card> <notification-modal v-if=\"addNewNotificationModalVisible\" :visible=\"addNewNotificationModalVisible\" :notification=\"newNotification\" @close=\"hideAddNotificationModal\" @save=\"addNotification\" ></notification-modal> <notification-modal v-if=\"editNotificationModalVisible\" :visible=\"editNotificationModalVisible\" :notification=\"editedNotification\" :is-edit=\"true\" @close=\"cancelNotificationEdit\" @save=\"editNotification\" ></notification-modal> <b-modal id=\"confirmNotificationDelete\" :visible=\"deleteConfirmationModalVisible\" title=\"Delete notification\" @hidden=\"deleteConfirmationModalVisible = false\" @ok=\"deleteNotification\" @cancel=\"cancelNotificationDelete\" > <p>{{ t(\"Are you sure you want to delete this notification?\") }}</p> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: "#notifications-management table thead th:not([aria-sort]) { pointer-events: none; }"
    });
  },
  data() {
    return {
      totalNotifications: 0,
      fields: [{
        key: "_id",
        label: this.t("ID"),
        searchable: true,
        searchInputType: "text"
      }, {
        key: "title",
        label: this.t("Title"),
        sortable: true,
        searchable: true,
        searchInputType: "text",
        visible: true
      }, {
        key: "source",
        label: this.t("Source"),
        sortable: true,
        searchable: true,
        searchInputType: "dropdown",
        visible: true,
        options: [Enums.NotificationSource.SYSTEM, Enums.NotificationSource.MANUAL]
      }, {
        key: "snippet",
        label: this.t("Snippet"),
        searchable: true,
        searchInputType: "text"
      }, {
        key: "content",
        label: this.t("Content"),
        searchable: true,
        searchInputType: "text"
      }, {
        key: "url",
        label: this.t("URL"),
        searchable: true,
        searchInputType: "text"
      }, {
        key: "timestamp",
        label: this.t("Timestamp"),
        sortable: true,
        visible: true,
        formatter: value => new Date(value).toLocaleString()
      }, {
        key: "availableFrom",
        label: this.t("Available From"),
        sortable: true,
        visible: true,
        formatter: value => new Date(value).toLocaleString()
      }, {
        key: "actions",
        label: this.t("Actions"),
        visible: true
      }],
      sortBy: "timestamp",
      sortDesc: true,
      searchFilter: "",
      searchField: null,
      currentPage: 1,
      perPage: 10,
      refreshing: false,
      searching: false,
      newNotification: {
        title: "",
        content: "",
        url: "",
        snippet: "",
        userId: null,
        channelId: null
      },
      editedNotification: {
        title: "",
        content: "",
        url: "",
        snippet: "",
        userId: null,
        channelId: null
      },
      notificationToDelete: null,
      addNewNotificationModalVisible: false,
      editNotificationModalVisible: false,
      deleteConfirmationModalVisible: false,
      hash: null,
      tabLoaded: false,
      loadedNotifications: []
    };
  },
  watch: {
    searchFilter() {
      this.buildHash({
        searchFilter: this.searchFilter,
        searchField: this.searchField.key
      });
    },
    searchField() {
      this.buildHash({
        searchFilter: "",
        searchField: this.searchField.key
      });
    },
    currentPage() {
      this.buildHash({
        page: this.currentPage
      });
    },
    sortDesc() {
      this.buildHash({
        sortDesc: this.sortDesc,
        sortBy: this.sortBy
      });
    },
    sortBy() {
      this.buildHash({
        sortBy: this.sortBy
      });
    },
    hash() {
      this.updateFromHash();
    }
  },
  computed: {
    emptyNotification() {
      return {
        title: "",
        content: "",
        url: "",
        snippet: "",
        userId: null,
        channelId: null
      };
    }
  },
  methods: {
    async showAddNotificationModal() {
      this.buildHash({
        action: "new-notification"
      });
    },
    async hideAddNotificationModal() {
      this.buildHash({
        action: null,
        userId: null,
        channelId: null
      });
    },
    async addNotification(notificationData) {
      const response = await Utils.apiAdmin(`administration/notifications`, notificationData);
      if (response.error) {
        console.error("Unable to add notification: ", response.error);
        UI.alert("danger", `Unable to add notification: ${response.error}`, true, 10000);
      } else {
        this.newNotification = this.emptyNotification;
        this.$refs.notificationsTable.refresh();
        UI.success(t("Notification sent successfully."));
      }
    },
    async confirmNotificationDelete(item) {
      this.deleteConfirmationModalVisible = true;
      this.notificationToDelete = item;
    },
    async deleteNotification() {
      const response = await Utils.apiAdmin(`administration/notifications/${this.notificationToDelete._id}`, {}, {
        method: "DELETE"
      });
      if (response.error) {
        console.error("Unable to delete notification: ", response.error);
        UI.alert("danger", `Unable to delete notification: ${response.error}`, true, 10000);
      } else {
        this.$refs.notificationsTable.refresh();
      }
    },
    async cancelNotificationDelete() {
      this.deleteConfirmationModalVisible = false;
      this.notificationToDelete = null;
    },
    async showNotificationEdit(item) {
      this.buildHash({
        action: "edit-notification",
        id: item._id
      });
    },
    async editNotification(notificationData) {
      const response = await Utils.apiAdmin(`administration/notifications/${notificationData._id}`, notificationData, {
        method: "PATCH"
      });
      if (response.error) {
        console.error("Unable to edit notification: ", response.error);
        UI.alert("danger", `Unable to edit notification: ${response.error}`, true, 10000);
      } else {
        this.editedNotification = this.emptyNotification;
        this.$refs.notificationsTable.refresh();
      }
    },
    async cancelNotificationEdit() {
      this.buildHash({
        action: null,
        id: null
      });
    },
    async notifications(ctx) {
      if (!this.tabLoaded) {
        return [];
      }
      this.refreshing = true;
      this.sortBy = ctx.sortBy || this.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (!this.sortBy) {
        this.refreshing = false;
        return this.loadedNotifications;
      }
      const params = {
        page: ctx.currentPage || this.currentPage,
        limit: ctx.perPage || this.perPage,
        query: this.searchFilter ? {
          [this.searchField.key]: this.searchFilter
        } : {},
        sort: {
          field: this.sortBy,
          direction: this.sortDesc ? -1 : 1
        }
      };
      const response = await Utils.apiAdmin(`administration/notifications/query`, params);
      if (response.error) {
        console.error("Unable to load notifications: ", response.error);
        UI.alert("danger", `Unable to load notifications: ${response.error}`, true, 10000);
      } else {
        this.totalNotifications = response.total;
        this.totalPages = response.page.total;
      }
      this.searching = false;
      this.refreshing = false;
      return this.loadedNotifications = response.entries;
    },
    async updateFromHash() {
      if (window.location.hash && this.created) {
        const hashProps = Utils.hashProps(window.location.hash);
        let requireRefresh = false;
        if (hashProps.action === "new-notification" && this.addNewNotificationModalVisible === false) {
          this.newNotification = this.emptyNotification;
          this.newNotification.userId = hashProps.userId;
          this.newNotification.channelId = hashProps.channelId;
          this.addNewNotificationModalVisible = true;
        } else if (hashProps.action === "edit-notification") {
          this.editedNotification = (await Utils.apiAdmin(`administration/notifications/${hashProps.id}`)).notification;
          this.editNotificationModalVisible = true;
        } else {
          this.addNewNotificationModalVisible = false;
          this.editNotificationModalVisible = false;
        }
        if (hashProps.searchFilter && hashProps.searchField) {
          this.searchFilter = hashProps.searchFilter;
          this.searchField = this.fields.find(f => f.key === hashProps.searchField);
          requireRefresh = true;
        } else if (hashProps.searchField) {
          this.searchField = this.fields.find(f => f.key === hashProps.searchField);
          this.searchFilter = "";
          requireRefresh = true;
        }
        if (hashProps.page) {
          this.currentPage = parseInt(hashProps.page);
          requireRefresh = true;
        }
        if (hashProps.sortBy) {
          this.sortBy = hashProps.sortBy;
          requireRefresh = true;
        }
        if (hashProps.sortDesc) {
          this.sortDesc = hashProps.sortDesc === "true";
          requireRefresh = true;
        }
        if (requireRefresh) {
          this.$refs.notificationsTable.refresh();
        }
      }
    },
    buildHash(overrides = {}) {
      const hash = Utils.hashProps(window.location.hash);
      this.hash = window.location.hash = `#${Utils.buildHash(hash, overrides)}`;
    },
    lazyLoad() {
      this.tabLoaded = true;
      this.buildHash({
        searchFilter: "MANUAL",
        searchField: "source",
        page: 1,
        sortBy: "timestamp",
        sortDesc: true
      });
    },
    formatFieldValue(value, field) {
      if (field.formatter) {
        return field.formatter(value);
      }
      if (typeof value === "string" && value.includes("\n")) {
        return value.replace(/\n/g, "<br>");
      }
      return value;
    }
  },
  async created() {
    await Utils.loadDependencies(["dompurify", "tinymce-vue"]);
    this.updateFromHash();
    this.hash = window.location.hash;
    $(window).on("hashchange", () => this.hash = window.location.hash);
    this.created = true;
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["NotificationModal"] = Vue.component(
                    "NotificationModal",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @typedef {import("../../../../common/types.d").Notification} Notification
 */
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" :title=\"notificationData._id ? t('Edit notification') : t('Send notification')\" :ok-disabled=\"!!validateTarget || !!validate(notificationData, { field: '!from' })\" @hidden=\"closeModal\" @ok=\"saveNotification\" @cancel=\"closeModal\" > <b-form @submit.stop.prevent> <b-form-group label=\"Target\" label-for=\"target\"> <b-form-radio-group id=\"target\" v-model=\"target\" :options=\"targetOptions\" buttons :readonly=\"isEdit\" :button-variant=\"!!target ? 'success' : 'danger'\" :state=\"!!target\" class=\"col-12 p-0\" @change=\"delete notificationData[target === 'channel' ? 'userId' : 'channelId']\" ></b-form-radio-group> </b-form-group> <b-form-group v-if=\"target === 'channel'\" :label=\"t('Channel ID')\" label-for=\"channelId\"> <b-form-input id=\"channelId\" v-model=\"notificationData.channelId\" :state=\"target === 'channel' && !validate(notificationData, { field: 'channelId' })\" :readonly=\"isEdit\" required ></b-form-input> <b-form-invalid-feedback :state=\"target === 'channel' && !validate(notificationData, { field: 'channelId' })\">{{ validate(notificationData, { field: \"channelId\" }) }}</b-form-invalid-feedback> </b-form-group> <b-form-group v-if=\"target === 'user'\" :label=\"t('User ID')\" label-for=\"userId\"> <b-form-input id=\"userId\" v-model=\"notificationData.userId\" :state=\"target === 'user' && !validate(notificationData, { field: 'userId' })\" :readonly=\"isEdit\" required ></b-form-input> <b-form-invalid-feedback :state=\"target === 'user' && !validate(notificationData, { field: 'userId' })\">{{ validate(notificationData, { field: \"userId\" }) }}</b-form-invalid-feedback> </b-form-group> <b-form-group :label=\"t('Set the sender as The Forge?')\" label-for=\"anonymize\"> <b-form-checkbox id=\"anonymize\" v-model=\"anonymizeSender\" switch>{{ sendFromForgeLabel }}</b-form-checkbox> </b-form-group> <b-form-group :label=\"t('Title')\" label-for=\"title\"> <b-form-input id=\"title\" v-model=\"notificationData.title\" :state=\"!validate(notificationData, { field: 'title' })\" required ></b-form-input> <b-form-invalid-feedback :state=\"!validate(notificationData, { field: 'title' })\">{{ validate(notificationData, { field: \"title\" }) }}</b-form-invalid-feedback> </b-form-group> <b-form-group :label=\"t('Snippet')\" label-for=\"snippet\"> <b-form-input id=\"snippet\" v-model=\"notificationData.snippet\" :state=\"!validate(notificationData, { field: 'snippet', exactFields: false, required: false })\" ></b-form-input> <b-form-invalid-feedback :state=\"!validate(notificationData, { field: 'snippet', exactFields: false, required: false })\" >{{ validate(notificationData, { field: \"snippet\" }) }}</b-form-invalid-feedback > </b-form-group> <b-form-group :label=\"t('Content')\" label-for=\"content\"> <b-form-textarea id=\"content\" v-model=\"notificationData.content\" :state=\"!validate(notificationData, { field: 'content', exactFields: false, required: false })\" ></b-form-textarea> <b-form-invalid-feedback :state=\"!validate(notification, { field: 'content', exactFields: false, required: false })\" >{{ validate(notificationData, { field: \"content\" }) }}</b-form-invalid-feedback > </b-form-group> <b-form-group :label=\"t('URL')\" label-for=\"url\"> <b-form-input id=\"url\" v-model=\"notificationData.url\" :state=\"!validate(notificationData, { field: 'url', exactFields: false, required: false })\" ></b-form-input> <b-form-invalid-feedback :state=\"!validate(notification, { field: 'url', exactFields: false, required: false })\" >{{ validate(notificationData, { field: \"url\" }) }}</b-form-invalid-feedback > </b-form-group> <b-form-invalid-feedback :state=\"!validate(notificationData, { field: ['snippet', 'content', 'url'], required: false })\" >{{ validate(notificationData, { field: [\"snippet\", \"content\", \"url\"], required: false }) }}</b-form-invalid-feedback > </b-form> </b-modal>",
  props: {
    visible: Boolean,
    /** @type {Notification} */
    notification: {
      type: Object,
      default: () => ({
        title: "",
        snippet: "",
        content: "",
        url: "",
        type: "",
        target: "",
        channelId: "",
        userId: ""
      })
    }
  },
  data() {
    return {
      target: this.notification.userId ? "user" : "channel",
      notificationData: {
        ...this.notification
      },
      anonymizeSender: true,
      notificationTypes: [{
        value: "SYSTEM",
        text: this.t("System")
      }, {
        value: "USER",
        text: this.t("User")
      }, {
        value: "CHANNEL",
        text: this.t("Channel")
      }],
      targetOptions: [{
        value: "channel",
        text: this.t("Channel")
      }, {
        value: "user",
        text: this.t("User")
      }]
    };
  },
  computed: {
    validateTarget() {
      return this.target === "channel" ? this.validate(this.notificationData, {
        field: "channelId"
      }) : this.validate(this.notificationData, {
        field: "userId"
      });
    },
    isEdit() {
      return !!this.notificationData._id;
    },
    sendFromForgeLabel() {
      return this.anonymizeSender ? t('The notification will be sent by "The Forge".') : t("The notification will be sent by your user.");
    }
  },
  methods: {
    saveNotification() {
      if (this.anonymizeSender) {
        this.notificationData.from = {
          name: "The Forge"
        };
      } else {
        delete this.notificationData.from;
      }
      this.$emit("save", this.notificationData);
    },
    closeModal() {
      this.$emit("close");
    },
    validate(notification, {
      field,
      exactFields = true,
      required = true
    }) {
      return ValidateUtils.validateNotification(notification, field, exactFields, required);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButton"] = Vue.component(
                    "BazaarPackageButton",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span class=\"bazaar-package-button\"> <!-- User is not logged in. Show a sign-in button. --> <bazaar-package-button-login v-if=\"!canInstall\" :show-label=\"fullView\" :size=\"size\" /> <!-- The package this component represents is processing. It's not interactive, and should display a loading spinner. --> <bazaar-package-button-processing v-else-if=\"pkg.processing\" :show-label=\"fullView\" :size=\"size\" /> <!-- The package this component represents is not processing; we know if it's installed or not, and should display a UI matching one of a number of cases, as seen below. Note: you can jump to a specific case with your editor's Find tool. ## UNINSTALLED: * U01: Uninstalled, incompatible * U02: Uninstalled, installable, not purchasable, multiple versions, full view * U03: Uninstalled, installable, not purchasable * U04: Uninstalled, premium, from the Bazaar Marketplace * U05: Uninstalled, premium, from D&D Beyond * U06: Uninstalled, premium, from Patreon * U07: Uninstalled, premium, from the Bazaar (default case) ## INSTALLED: * I01: Installed, but the package's latest version is incompatible * I02: Installed, and the package has an update * I03: Installed, but it's a custom package that doesn't have a manifest * I04: Installed, but it's a custom package and isn't the latest version * I05: Installed and up to date (default case) --> <template v-else> <!-- If the package is not installed, try one of the following cases --> <template v-if=\"!isInstalled\"> <!-- # U01 If the following are true: * The package does not have any releases that are compatible with the Foundry versions the user uses. Display a warning to the user that this package cannot be installed due to a version mismatch. --> <template v-if=\"!hasCompatibleVersions\"> <!-- If the following are true: * This component is not used in the full package view. The install button is hidden, the compatibility badge shall be shown to notify user that the package is not compatible. --> <bazaar-package-button-incompatible v-if=\"fullView\" :show-label=\"fullView\" :size=\"size\" /> </template> <!-- # U02 If the following are true: * This component is used in the full package view * There are multiple installable versions of this package * The package is installable * The package is not for sale This package has multiple valid versions that can be installed. Offer a dropdown to the user with options for which version of this package to install. --> <bazaar-package-button-versions v-else-if=\"isFullViewWithMultipleInstallableVersions\" v-bind=\"commonProps\" :show-label=\"fullView\" @install=\"$emit('install', $event)\" /> <!-- # U03 If the following are true: * This package is installable * This package is not for sale Either there is a single valid version for this package, or this component is used on the search view. Display a button to allow the user to install the package. --> <bazaar-package-button-install v-else-if=\"installable && !isPurchasable\" v-bind=\"commonProps\" :show-label=\"fullView\" @install=\"$emit('install', $event)\" /> <template v-else> <!-- # U06 If the following are true: * This package is from Patreon This package can only be acquired through Patreon. Inform the user with a disabled button. \"if a package was patreon only and not entitled, we should only show the Patreon button. We could have both for a package that has Patreon but is also purchasable.\" --> <bazaar-package-button-patreon v-if=\"isPatreon\" v-bind=\"commonProps\" :show-label=\"fullView\" :user-integrations=\"userIntegrations\" /> <template v-if=\"!isPremiumPatreon\"> <!-- # U04 If the following are true: * This package is available to purchase through the Bazaar We sell this package; therefore, display the price of the package, with iconography for PWYW/paying more for the package. --> <bazaar-package-button-marketplace v-if=\"isMarketplace\" v-bind=\"commonProps\" :show-label=\"fullView\" @purchase=\"$emit('purchase', $event)\" /> <!-- # U05 If the following are true: * This package is from D&D Beyond In addition to a button, we include a modal that'll help the user import their D&D Beyond content. --> <bazaar-package-button-dndbeyond v-else-if=\"isDndbeyond\" v-bind=\"commonProps\" :show-label=\"fullView\" @ddb-installed=\"$emit('ddb-installed', $event)\" /> <!-- # U07 This package must be for sale. Show the purchase button. --> <bazaar-package-button-purchase v-else v-bind=\"commonProps\" :show-label=\"fullView\" /> </template> </template> <!-- End of uninstalled cases --> </template> <!-- If the component is installed, try one of the following cases --> <template v-else> <!-- # I01 If the following are true: * This package has no version that are compatible with the user's Foundry version. The user should be notified about the incompatibility, and given the option to uninstall the package. --> <template v-if=\"!hasCompatibleVersions\"> <bazaar-package-button-uninstall v-bind=\"commonProps\" :show-label=\"false\" @uninstall=\"$emit('uninstall', $event)\" /> <bazaar-package-button-incompatible v-if=\"fullView\" :show-label=\"fullView\" :size=\"size\" /> </template> <!-- # I02 If the following are true: * This package has updates Offer the user a button to update this component, as well as a means to uninstall the package. --> <template v-else-if=\"hasUpdate\"> <bazaar-package-button-uninstall v-bind=\"commonProps\" :show-label=\"false\" @uninstall=\"$emit('uninstall', $event)\" /> <bazaar-package-button-update v-bind=\"commonProps\" :show-label=\"fullView\" @install=\"$emit('install', $event)\" /> </template> <!-- # I03 If the following are true: * This package is a custom package; the user installed it from outside of the Bazaar * This package does not have a manifest We don't know if this package is up to date, because we don't have a manifest to check against. Offer the uninstall button. --> <bazaar-package-button-uninstall v-else-if=\"isCustom && !hasManifest\" v-bind=\"commonProps\" :show-label=\"fullView\" @uninstall=\"$emit('uninstall', $event)\" /> <!-- # I05 If the following are true: * This package is a custom package; the user installed it from outside of the Bazaar * This package needs to check for if it's updated. We need to check if this package is up-to-date; offer a button to perform the check, as well as the uninstall button. --> <template v-else-if=\"isCustom && customNeedsCheck\"> <bazaar-package-button-uninstall v-bind=\"commonProps\" :show-label=\"false\" @uninstall=\"$emit('uninstall', $event)\" /> <bazaar-package-button-check v-bind=\"commonProps\" :show-label=\"fullView\" @check-update=\"$emit('check-update', $event)\" /> </template> <!-- # I06 The package is installed and up to date. Display iconography to mark it as up to date, as well as the uninstall button. --> <template v-else> <i v-b-tooltip.hover=\"upToDateLabel\" class=\"fas fa-check text-success mr-2\" :aria-label=\"upToDateLabel\" /> <bazaar-package-button-uninstall v-bind=\"commonProps\" :show-label=\"fullView\" @uninstall=\"$emit('uninstall', $event)\" /> </template> <!-- End of installed cases --> </template> </template> </span>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-button{display:flex;align-items:center;gap:.25em}.bazaar-package-button .btn{white-space:nowrap}"
    });
  },
  props: {
    pkg: {
      type: Object,
      required: true
    },
    canInstall: Boolean,
    fullView: {
      type: Boolean,
      default: true
    },
    userIntegrations: {
      type: Object,
      default: null
    }
  },
  computed: {
    /**
     * Common props for buttons created by this component.
     * @returns {unknown}  a `v-bind`-able object with props shared by all components.
     */
    commonProps() {
      return {
        pkg: this.pkg,
        size: this.size
      };
    },
    isPremium() {
      return !!this.pkg.premium;
    },
    isMarketplace() {
      return this.pkg.premium === "marketplace";
    },
    isDndbeyond() {
      return this.pkg.premium === "dndbeyond";
    },
    isPatreon() {
      return !!this.pkg.patreon;
    },
    isPremiumPatreon() {
      return this.pkg.premium === "patreon";
    },
    installable() {
      return !this.isPremium || this.isEntitled;
    },
    isInstalled() {
      return this.pkg.installed;
    },
    isCustom() {
      return this.pkg.custom;
    },
    hasManifest() {
      return !!this.pkg.manifest;
    },
    hasUpdate() {
      const target = this.pkg.versionToInstall || this.pkg.latest;
      return this.hasCompatibleVersions && target && this.pkg.installed !== target;
    },
    hasCompatibleVersions() {
      return this.pkg.versions && Array.isArray(this.pkg.versions) && this.pkg.versions.length > 0;
    },
    /**
     * Whether or not the package is associated with a Patreon
     * @returns {boolean} Is the package associated with a Patreon?
     */
    hasPatreon() {
      if (!this.pkg.patreon) {
        return false;
      }
      return this.pkg.patreon.creator && this.pkg.patreon.tiers && this.pkg.patreon.tiers.length;
    },
    /**
     * Check for the following state:
     * - we're using this button on the full Package view
     * - there are multiple versions available for install
     * - the package is installable
     * - the package does not need to be purchased
     * @returns {boolean} Does this package fit this specific state?
     */
    isFullViewWithMultipleInstallableVersions() {
      return this.installable && !this.isPurchasable && this.hasVersions && this.fullView;
    },
    customNeedsCheck() {
      return this.isCustom && !this.pkg.latest;
    },
    isEntitled() {
      return this.pkg.entitled;
    },
    isOwner() {
      return ["admin", "creator"].includes(this.pkg.entitlement);
    },
    isPurchased() {
      return this.pkg.purchased;
    },
    isPurchasable() {
      return this.isMarketplace && (!this.isEntitled || this.pkg.entitlement === "patreon") && !this.isOwner && !this.isPurchased;
    },
    size() {
      return this.fullView ? "md" : "sm";
    },
    hasVersions() {
      return this.pkg.versions && Array.isArray(this.pkg.versions) && this.pkg.versions.length > 1;
    },
    upToDateLabel() {
      return t("Up to Date!");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonCheck"] = Vue.component(
                    "BazaarPackageButtonCheck",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__check\" :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"warning\" icon=\"fas fa-sync-alt\" @click.prevent=\"emitCheckUpdate\" > {{ label }} </button-with-tooltip>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    label() {
      return t("Check");
    },
    tooltip() {
      return t("Check for Updates");
    }
  },
  methods: {
    emitCheckUpdate() {
      this.$emit("check-update", this.pkg);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonDndbeyond"] = Vue.component(
                    "BazaarPackageButtonDndbeyond",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span class=\"bazaar-package-button__dndbeyond\"> <button-with-tooltip :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"primary\" icon=\"fas fa-arrow-circle-down\" @click.prevent=\"openDndbeyondFrame\" > {{ label }} </button-with-tooltip> <bazaar-dnd-beyond v-if=\"dndbeyondFrame\" :key=\"pkg.id\" v-model=\"dndbeyondFrame\" :package=\"pkg\" @installed=\"emitDdbInstalled\" /> </span>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  data() {
    return {
      dndbeyondFrame: false
    };
  },
  computed: {
    label() {
      return t("Import");
    },
    tooltip() {
      return t("Import from D&D Beyond");
    }
  },
  methods: {
    emitDdbInstalled(event) {
      this.$emit("ddb-installed", event);
    },
    openDndbeyondFrame() {
      this.dndbeyondFrame = true;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonIncompatible"] = Vue.component(
                    "BazaarPackageButtonIncompatible",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__incompatible\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" disabled variant=\"warning\" icon=\"fas fa-exclamation-circle\" > {{ label }} </button-with-tooltip>",
  props: {
    size: {
      type: String,
      default: "md"
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    label() {
      return t("Incompatible");
    },
    tooltip() {
      return t("Not Compatible with your Foundry Version");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonInstall"] = Vue.component(
                    "BazaarPackageButtonInstall",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__install\" :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"success\" icon=\"fas fa-download\" @click.prevent=\"emitInstall\" > {{ label }} </button-with-tooltip>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    label() {
      if (this.pkg.type === "asset") {
        return t("Enable");
      }
      const versionToInstall = this.pkg.versionToInstall || this.pkg.latest;
      return versionToInstall !== this.pkg.latest ? t("Install {{version}}", {
        version: versionToInstall
      }) : t("Install");
    },
    tooltip() {
      switch (this.pkg.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return this.showLabel ? "" : this.label;
      }
    }
  },
  methods: {
    emitInstall() {
      this.$emit("install", this.pkg);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonLogin"] = Vue.component(
                    "BazaarPackageButtonLogin",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__signin\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"success\" icon=\"fas fa-user-circle\" @click.prevent=\"redirectToLogin\" > {{ label }} </button-with-tooltip>",
  props: {
    size: {
      type: String,
      default: "md"
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    label() {
      return t("Sign In");
    },
    tooltip() {
      return t("Sign in to Install");
    }
  },
  methods: {
    redirectToLogin() {
      window.location = "/account/login";
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonMarketplace"] = Vue.component(
                    "BazaarPackageButtonMarketplace",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__marketplace\" :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"primary\" icon=\"fas fa-shopping-cart\" @click.prevent=\"emitPurchase\" > {{ priceDisplay }} <i v-if=\"payWhatYouWant || payMore\" class=\"fas fa-plus\" aria-role=\"presentation\"></i> </button-with-tooltip>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    price() {
      if (!this.pkg) {
        return 0;
      }
      return Number(this.pkg.pwywMinimum === undefined || this.pkg.pwywMinimum === null ? this.pkg.price : this.pkg.pwywMinimum) || 0;
    },
    payWhatYouWant() {
      return this.pkg.pwywMinimum === 0;
    },
    payMore() {
      return this.pkg.pwywMinimum > 0;
    },
    tooltip() {
      if (this.payWhatYouWant) {
        return t("Pay what you can!");
      }
      if (this.payMore) {
        return t("Pay {{price}} or more!", {
          price: this.priceDisplay
        });
      }
      if (this.pkg.type === "forge-gift-card") {
        return t("This is a great gift!");
      }
      return t("Purchase");
    },
    priceDisplay() {
      return `$ ${this.price.toFixed(2)}`;
    }
  },
  methods: {
    emitPurchase() {
      this.$emit("purchase", this.pkg);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonPatreon"] = Vue.component(
                    "BazaarPackageButtonPatreon",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span> <b-button :id=\"buttonId\" :size=\"size\" :variant=\"buttonVariant\" :disabled=\"disabled\" tabindex=\"0\" @click.prevent=\"handleClick\" > <img src=\"/images/social/patreon-white.png\" class=\"bazaar-package-button-patreon__icon\" width=\"20\" height=\"20\" /> <span v-if=\"showLabel\" class=\"bazaar-package-button-patreon__label\"> {{ buttonLabel }} </span> </b-button> <b-tooltip ref=\"tooltip\" :target=\"buttonId\" trigger=\"hover\" custom-class=\"bazaar-package-button-patreon\"> <template v-if=\"showPatreonInfo\"> <bazaar-package-patreon-info class=\"bazaar-package-button-patreon__tooltip-inner\" :package=\"pkg\" :user-integrations=\"userIntegrations\" /> </template> <template v-else>{{ tooltipText }}</template> </b-tooltip> </span>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-button-patreon button:disabled{cursor:not-allowed;pointer-events:all}.bazaar-package-button-patreon__icon{width:20px;height:20px}.bazaar-package-button-patreon .tooltip-inner{max-width:500px;text-align:left}.bazaar-package-button-patreon .tooltip-inner a{text-decoration:underline dotted}"
    });
  },
  props: {
    disabled: Boolean,
    fullView: {
      type: Boolean,
      default: true
    },
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    },
    userIntegrations: {
      type: Object,
      default: null
    }
  },
  computed: {
    buttonId() {
      return `bazaar-package-button-patreon--${this.pkg.id}`;
    },
    patreonData() {
      return this.pkg?.patreon || {};
    },
    installable() {
      return this.hasPatreon && this.hasForgeTier && this.hasSubscribed && this.hasTier && this.hasMinimumContribution;
    },
    isInstalled() {
      return !!this.pkg.installed;
    },
    patreonCreator() {
      return this.patreonData.creator;
    },
    hasPatreon() {
      return !!this.userIntegrations?.patreon?.linked;
    },
    minForgeTier() {
      return this.patreonData.minimumForgeTier ?? 3;
    },
    minForgeTierName() {
      const tiers = {
        0: t("Player"),
        1: t("Explorer"),
        2: t("Game Master"),
        3: t("Story Teller"),
        4: t("World Builder")
      };
      return tiers[this.minForgeTier] || tiers[3];
    },
    hasForgeTier() {
      return this.userIntegrations?.tier >= this.minForgeTier;
    },
    patreonPledge() {
      return this.userIntegrations?.patreon?.pledges?.find(p => p.vanity === this.patreonCreator);
    },
    hasSubscribed() {
      return !!this.patreonPledge;
    },
    hasTier() {
      return this.patreonPledge?.tiers?.some(t => this.patreonData.tiers.includes(t.title));
    },
    hasMinimumContribution() {
      return this.userContribution === "creator" || this.userContribution >= (this.patreonData.minimumContribution || 0);
    },
    userContribution() {
      if (!this.patreonPledge) {
        return 0;
      }
      if (this.patreonPledge.creator) {
        return "creator";
      }
      return this.patreonPledge.lifetime_contribution || 0;
    },
    isSetupButton() {
      return !this.hasPatreon || !this.hasForgeTier;
    },
    isSubscribeButton() {
      return !this.isSetupButton && (!this.hasSubscribed || !this.hasTier);
    },
    isInstallButton() {
      return !this.isSetupButton && !this.isSubscribeButton && !this.isInstalled && this.installable;
    },
    buttonVariant() {
      if (this.isInstallButton) {
        return "success";
      }
      if (this.isSubscribeButton) {
        return "warning";
      }
      return "secondary";
    },
    buttonLabel() {
      if (this.isSetupButton) {
        return t("Setup");
      }
      if (this.isSubscribeButton) {
        return t("Subscribe");
      }
      if (this.pkg.type === "asset") {
        return t("Enable");
      }
      return t("Install from Patreon");
    },
    tooltipText() {
      if (this.isSetupButton) {
        return this.hasPatreon ? t("Subscribe to {{tier}} tier or higher", {
          tier: this.minForgeTierName
        }) : t("Link your Patreon account");
      }
      if (this.isSubscribeButton) {
        return this.hasSubscribed ? t("Subscribe to this creators Patreon tier") : t("Subscribe to {{creator}}'s Patreon", {
          creator: this.patreonCreator
        });
      }
      switch (this.pkg.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return t("Your Patreon subscription allows you to install this package");
      }
    },
    showPatreonInfo() {
      return this.hasPatreon && !this.installable;
    }
  },
  methods: {
    handleClick() {
      if (this.$refs.tooltip && this.$refs.tooltip.$emit) {
        this.$refs.tooltip.$emit("close");
      }
      if (this.isSetupButton) {
        return this.$emit("setup");
      }
      if (this.isSubscribeButton) {
        return this.$emit("subscribe");
      }
      if (this.isInstallButton) {
        return this.$emit("install", this.pkg);
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonProcessing"] = Vue.component(
                    "BazaarPackageButtonProcessing",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__processing\" :size=\"size\" :tooltip=\"showLabel ? '' : label\" disabled variant=\"secondary\" > <b-spinner :class=\"{ 'align-middle': true, 'mr-2': showLabel, }\" small /> {{ showLabel ? label : null }} </button-with-tooltip>",
  beforeCreate() {
    Utils.loadCss({
      content: ".bazaar-package-button__processing .spinner-border{margin-top:-1px}"
    });
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    label() {
      return t("Processing");
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonPurchase"] = Vue.component(
                    "BazaarPackageButtonPurchase",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__purchase\" :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" variant=\"primary\" icon=\"fas fa-shopping-cart\" @click.prevent=\"openPremiumLink\" > {{ label }} </button-with-tooltip>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    label() {
      return t("Purchase");
    },
    tooltip() {
      switch (this.pkg.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return this.showLabel ? "" : this.label;
      }
    }
  },
  methods: {
    openPremiumLink() {
      if (this.pkg.url) {
        window.open(this.pkg.url, "_blank");
      }
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonUninstall"] = Vue.component(
                    "BazaarPackageButtonUninstall",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__uninstall\" :disabled=\"disabled\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"showLabel ? null : label\" variant=\"danger\" icon=\"fas fa-trash-alt\" @click.prevent=\"emitUninstall\" > {{ label }} </button-with-tooltip>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    label() {
      return this.pkg.type === "asset" ? t("Disable") : t("Uninstall");
    }
  },
  methods: {
    emitUninstall() {
      this.$emit("uninstall", this.pkg);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonUpdate"] = Vue.component(
                    "BazaarPackageButtonUpdate",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<button-with-tooltip class=\"bazaar-package-button__update\" :disabled=\"disabled || isLocked\" :show-label=\"showLabel\" :size=\"size\" :tooltip=\"tooltip\" :variant=\"isLocked ? 'secondary' : 'success'\" :icon=\"isLocked ? 'fas fa-lock' : 'fas fa-arrow-alt-circle-up'\" @click.prevent=\"emitUpdate\" > {{ label }} </button-with-tooltip>",
  props: {
    pkg: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    size: {
      type: String,
      default: "md"
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    version() {
      return this.pkg.installed || this.pkg.latest;
    },
    isLocked() {
      return this.pkg.locked;
    },
    tooltip() {
      if (this.isLocked) {
        return t("You have locked this package to version {{version}}", {
          version: this.version
        });
      }
      const versionToInstall = this.pkg.versionToInstall || this.pkg.latest;
      return t("Update to {{version}}", {
        version: versionToInstall
      });
    },
    label() {
      const hasCustomTarget = this.pkg.versionToInstall && this.pkg.versionToInstall !== this.pkg.latest;
      return hasCustomTarget ? t("Update to {{version}}", {
        version: this.pkg.versionToInstall
      }) : t("Update");
    }
  },
  methods: {
    emitUpdate() {
      this.$emit("install", this.pkg);
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["BazaarPackageButtonVersions"] = Vue.component(
                    "BazaarPackageButtonVersions",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<span v-b-tooltip.hover=\"tooltip\" class=\"bazaar-package-button__versions\"> <b-dropdown :disabled=\"disabled\" :size=\"size\" right split variant=\"success\" @click.prevent=\"emitInstall\"> <template #button-content> <i class=\"fas fa-download\" aria-role=\"presentation\"></i> {{ showLabel ? installLabel : null }} </template> <b-dropdown-header>{{ t(\"Versions\") }}</b-dropdown-header> <b-dropdown-item v-for=\"(version, index) in availableVersions\" :key=\"index\" @click=\"setVersionToInstall(version)\"> {{ version.text }} </b-dropdown-item> </b-dropdown> </span>",
  props: {
    disabled: Boolean,
    pkg: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    tooltip() {
      switch (this.pkg.type) {
        case "world":
          return t("Install as a new World");
        case "asset":
          return t("Enable access");
        default:
          return this.showLabel ? "" : this.installLabel;
      }
    },
    installLabel() {
      if (this.pkg.type === "asset") {
        return t("Enable");
      }
      const versionToInstall = this.pkg.versionToInstall || this.pkg.latest;
      return versionToInstall !== this.pkg.latest ? t("Install {{version}}", {
        version: versionToInstall
      }) : t("Install");
    },
    availableVersions() {
      return this.pkg.versions.map(v => ({
        value: v,
        text: this.getVersionText(v)
      }));
    }
  },
  methods: {
    emitInstall() {
      this.$emit("install", this.pkg);
    },
    setVersionToInstall(option) {
      if (option.value) {
        // Because we pass the package prop to processing functions, it appears necessary to reassign the versionToInstall here
        // eslint-disable-next-line vue/no-mutating-props
        this.pkg.versionToInstall = option.value;
      }
    },
    getVersionText(v) {
      if (v === this.pkg.latest) {
        return `${v} ${t("(Latest)")}`;
      } else if (v === this.pkg.installed) {
        return `${v} ${t("(Installed)")}`;
      }
      return v;
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["AdminChannelsManagement"] = Vue.component(
                    "AdminChannelsManagement",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  template: "<div id=\"channels-management\"> <b-card no-body> <b-card-header class=\"d-flex align-items-center\"> <div> {{ t(\"Channels Management\") }} </div> <b-button id=\"channels-management__add-channel-button\" v-b-tooltip.hover=\"t('Add new channel')\" class=\"ml-auto\" size=\"sm\" variant=\"outline-primary\" @click=\"addNewChannelModalVisible = true\" ><i class=\"fa-fw fas fa-plus\"></i> </b-button> </b-card-header> <b-card-body> <b-input-group> <b-input-group-prepend> <!-- Any changes to the text here should also be reflected in searchTypeText --> <b-dropdown :text=\"searchField?.label || t('Select field')\"> <b-dropdown-item @click=\"searchField = null\">{{ t(\"Select field\") }}</b-dropdown-item> <b-dropdown-item v-for=\"field in fields.filter((f) => f.searchable)\" :key=\"field.key\" @click=\"searchField = field\" > {{ field.label }} </b-dropdown-item> </b-dropdown> </b-input-group-prepend> <b-form-checkbox v-if=\"searchField?.searchInputType === 'checkbox'\" v-model=\"searchFilter\" button :button-variant=\"searchFilter ? 'primary' : 'outline-primary'\" true-value=\"true\" false-value=\"false\" debounce=\"500\" :readonly=\"!searchField\" > {{ searchFilter ? t(\"Yes\") : t(\"No\") }} </b-form-checkbox> <b-form-select v-else-if=\"searchField?.searchInputType === 'dropdown'\" v-model=\"searchFilter\" :options=\"searchField.options\" debounce=\"500\" :readonly=\"!searchField\" ></b-form-select> <b-form-input v-else v-model=\"searchFilter\" :type=\"searchField?.searchInputType || 'text'\" :placeholder=\"t('Type to search…')\" debounce=\"500\" :readonly=\"!searchField\" ></b-form-input> <b-input-group-append is-text> <i v-if=\"!searching\" class=\"fa fas fa-search\"></i> <b-spinner v-else small></b-spinner> </b-input-group-append> </b-input-group> <b-table ref=\"channelsTable\" :items=\"channels\" :fields=\"fields.filter((f) => f.visible)\" :current-page=\"currentPage\" :per-page=\"perPage\" :busy=\"refreshing\" > <template #cell(name)=\"{ item }\"> {{ item.name }} </template> <template #cell(slug)=\"{ item }\"> <b-badge>{{ item.slug }}</b-badge> </template> <template #cell(mandatory)=\"{ item }\"> <b-badge :variant=\"item.mandatory ? 'danger' : 'success'\">{{ item.mandatory ? t(\"Mandatory\") : t(\"Optional\") }}</b-badge> </template> <template #cell(actions)=\"{ item }\"> <b-button-group> <b-button size=\"sm\" variant=\"primary\" :title=\"t('Send notification')\" @click=\"sendNotificationToChannel(item)\" ><i class=\"fa-fw fas fa-paper-plane\"></i ></b-button> <b-button data-action=\"edit\" size=\"sm\" variant=\"primary\" :title=\"t('Edit channel')\" @click=\"showChannelEdit(item)\" ><i class=\"fa-fw fas fa-edit\"></i ></b-button> <b-button data-action=\"delete\" size=\"sm\" variant=\"danger\" :title=\"t('Delete channel')\" @click=\"confirmChannelDelete(item)\" ><i class=\"fa-fw fas fa-trash\"></i> </b-button ></b-button-group> </template> </b-table> <b-pagination v-model=\"currentPage\" :total-rows=\"totalChannels\" :per-page=\"perPage\"></b-pagination> </b-card-body> </b-card> <channel-modal v-if=\"addNewChannelModalVisible\" :visible=\"addNewChannelModalVisible\" :channel=\"newChannel\" @close=\"addNewChannelModalVisible = false\" @save=\"addChannel\" ></channel-modal> <channel-modal v-if=\"editChannelModalVisible\" :visible=\"editChannelModalVisible\" :channel=\"editedChannel\" @close=\"editChannelModalVisible = false\" @save=\"editChannel\" ></channel-modal> <b-modal id=\"confirmChannelDelete\" :visible=\"confirmChannelDeleteModalVisible\" title=\"Delete channel\" @hidden=\"confirmChannelDeleteModalVisible = false\" @ok=\"deleteChannel\" @cancel=\"cancelChannelDelete\" > <p>{{ t(\"Are you sure you want to delete this channel?\") }}</p> </b-modal> </div>",
  beforeCreate() {
    Utils.loadCss({
      content: ""
    });
  },
  data() {
    return {
      totalChannels: 0,
      /**
       * @typedef {object} Field
       * @property {string} key - The unique identifier for the field.
       * @property {string} label - The display name of the field.
       * @property {boolean} [sortable] - Whether the field is sortable.
       * @property {boolean} [searchable] - Whether the field is searchable.
       * @property {string} [searchInputType] - The type of input for searching (e.g., 'text', 'dropdown', 'checkbox').
       * @property {boolean} [visible] - Whether the field is visible in the table.
       * @property {Array<string>} [options] - Array of options for dropdown-type fields.
       */

      /**
       * @type {Field[]}
       */
      fields: [{
        key: "Id",
        label: this.t("ID"),
        searchable: true,
        searchInputType: "text"
      }, {
        key: "name",
        label: this.t("Name"),
        sortable: true,
        searchable: true,
        searchInputType: "text",
        visible: true
      }, {
        key: "slug",
        label: this.t("Slug"),
        sortable: true,
        searchable: true,
        searchInputType: "text",
        visible: true
      }, {
        key: "type",
        label: this.t("Type"),
        sortable: true,
        searchable: true,
        searchInputType: "dropdown",
        visible: true,
        options: ["CREATOR", "SYSTEM", "STAFF"]
      }, {
        key: "mandatory",
        label: this.t("Mandatory"),
        sortable: true,
        searchable: true,
        searchInputType: "checkbox",
        visible: true
      }, {
        key: "actions",
        label: this.t("Actions"),
        visible: true
      }],
      sortBy: "name",
      sortDesc: false,
      searchFilter: "",
      searchField: null,
      currentPage: 1,
      perPage: 10,
      refreshing: false,
      searching: false,
      channelTypes: [{
        value: "CREATOR",
        text: this.t("Creator")
      }, {
        value: "SYSTEM",
        text: this.t("System")
      }, {
        value: "STAFF",
        text: this.t("Staff")
      }],
      newChannel: {
        name: "",
        slug: "",
        mandatory: false
      },
      editedChannel: {
        name: "",
        slug: "",
        mandatory: false
      },
      addNewChannelModalVisible: false,
      confirmChannelDeleteModalVisible: false,
      editChannelModalVisible: false,
      tabLoaded: false
    };
  },
  watch: {
    searchFilter() {
      this.searching = true;
      this.$refs.channelsTable.refresh();
    },
    searchField() {
      this.searchFilter = "";
      this.searching = true;
      this.$refs.channelsTable.refresh();
    }
  },
  methods: {
    async addChannel(channelData) {
      const response = await Utils.apiAdmin(`administration/channels`, channelData);
      if (response.error) {
        console.error("Unable to add channel: ", response.error);
        UI.alert("danger", `Unable to add channel: ${response.error}`, true, 10000);
      } else {
        this.newChannel = {
          name: "",
          slug: "",
          mandatory: false
        };
        this.$refs.channelsTable.refresh();
      }
    },
    async confirmChannelDelete(item) {
      this.confirmChannelDeleteModalVisible = true;
      this.channelToDelete = item;
    },
    async deleteChannel() {
      const response = await Utils.apiAdmin(`administration/channels/${this.channelToDelete.slug}`, {}, {
        method: "DELETE"
      });
      if (response.error) {
        console.error("Unable to delete channel: ", response.error);
        UI.alert("danger", `Unable to delete channel: ${response.error}`, true, 10000);
      } else {
        this.$refs.channelsTable.refresh();
      }
    },
    async cancelChannelDelete() {
      this.confirmChannelDeleteModalVisible = false;
      this.channelToDelete = null;
    },
    async showChannelEdit(item) {
      this.editedChannel = {
        ...item
      };
      this.editChannelModalVisible = true;
    },
    async editChannel(channelData) {
      const response = await Utils.apiAdmin(`administration/channels/${channelData.slug}`, channelData, {
        method: "PATCH"
      });
      if (response.error) {
        console.error("Unable to edit channel: ", response.error);
        UI.alert("danger", `Unable to edit channel: ${response.error}`, true, 10000);
      } else {
        this.editedChannel = {
          name: "",
          slug: "",
          mandatory: false
        };
        this.$refs.channelsTable.refresh();
      }
    },
    async cancelChannelEdit() {
      this.editChannelModalVisible = false;
      this.editedChannel = {
        name: "",
        slug: "",
        mandatory: false
      };
    },
    resetNewChannel() {
      this.newChannel = {
        name: "",
        slug: "",
        mandatory: false
      };
    },
    async updateChannelSlug() {
      if (this.newChannel.name && !this.newChannel.slug) {
        this.newChannel.slug = this.newChannel.name.toLowerCase().replace(/[^a-z0-9]/g, "-");
      }
    },
    async sendNotificationToChannel(channel) {
      window.location.hash = `#${Utils.buildHash({
        tab: "channelsManagement",
        action: "new-notification",
        channelId: channel._id
      })}`;
    },
    async channels(ctx) {
      if (!this.tabLoaded) {
        return [];
      }
      this.refreshing = true;
      this.refreshing = true;
      this.sortBy = ctx.sortBy || this.sortBy;
      this.sortDesc = ctx.sortBy ? ctx.sortDesc : this.sortDesc;
      const params = {
        page: ctx.currentPage || this.currentPage,
        limit: ctx.perPage || this.perPage,
        query: this.searchFilter ? {
          [this.searchField.key]: this.searchFilter
        } : {},
        sort: {
          field: this.sortBy,
          direction: this.sortDesc ? -1 : 1
        }
      };
      const response = await Utils.apiAdmin(`administration/channels/query`, params);
      if (response.error) {
        console.error("Unable to load channels: ", response.error);
        UI.alert("danger", `Unable to load channels: ${response.error}`, true, 10000);
      } else {
        this.totalChannels = response.total;
        this.totalPages = response.page.total;
      }
      this.searching = false;
      this.refreshing = false;
      return response.entries;
    },
    lazyLoad() {
      this.tabLoaded = true;
      this.$refs.channelsTable.refresh();
    }
  }
};;
                        return _default;
                    })()
                );
window["VueComponents"]["ChannelModal"] = Vue.component(
                    "ChannelModal",
                    (function() {
                        const exports = {};
                        "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @typedef {import("../../../../common/types.d").Channel} Channel
 */
var _default = exports.default = {
  template: "<b-modal :visible=\"visible\" :title=\"channelData._id ? t('Edit channel') : t('Add new channel')\" :ok-disabled=\"!!validate(channelData)\" @hidden=\"closeModal\" @ok=\"saveChannel\" @cancel=\"closeModal\" > <b-form @submit.stop.prevent> <b-form-group :label=\"t('Name')\" label-for=\"name\"> <b-form-input id=\"name\" v-model=\"channelData.name\" :state=\"!validate(channelData, { field: 'name' })\" required @blur=\"updateChannelSlug\" ></b-form-input> <b-form-invalid-feedback :state=\"!validate(channelData, { field: 'name' })\">{{ validate(channelData, { field: \"name\" }) }}</b-form-invalid-feedback> </b-form-group> <b-form-group :label=\"t('Slug')\" label-for=\"slug\"> <b-form-input id=\"slug\" v-model=\"channelData.slug\" :state=\"!validate(channelData, { field: 'slug' })\" :readonly=\"isEdit\" required ></b-form-input> <b-form-invalid-feedback :state=\"!validate(channelData, { field: 'slug' })\">{{ validate(channelData, { field: \"slug\" }) }}</b-form-invalid-feedback> </b-form-group> <b-form-group :label=\"t('Mandatory')\" label-for=\"mandatory\"> <b-form-checkbox id=\"mandatory\" v-model=\"channelData.mandatory\"></b-form-checkbox> </b-form-group> <b-form-group :label=\"t('Content')\" label-for=\"type\"> <b-form-select id=\"type\" v-model=\"channelData.type\" :options=\"channelTypes\" :state=\"!validate(channelData, { field: 'type' })\" ></b-form-select> <b-form-invalid-feedback :state=\"!validate(channelData, { field: 'type' })\">{{ validate(channelData, { field: \"type\" }) }}</b-form-invalid-feedback> </b-form-group> </b-form> </b-modal>",
  props: {
    visible: Boolean,
    /** @type {Channel} */
    channel: {
      type: Object,
      default: () => ({
        name: "",
        slug: "",
        mandatory: false,
        type: "CREATOR"
      })
    }
  },
  data() {
    return {
      channelData: {
        ...this.channel
      },
      channelTypes: [{
        value: "CREATOR",
        text: this.t("Creator")
      }, {
        value: "SYSTEM",
        text: this.t("System")
      }, {
        value: "STAFF",
        text: this.t("Staff")
      }]
    };
  },
  computed: {
    isEdit() {
      return !!this.channelData._id;
    }
  },
  methods: {
    saveChannel() {
      this.$emit("save", this.channelData);
    },
    closeModal() {
      this.$emit("close");
    },
    updateChannelSlug() {
      if (this.channelData.name && !this.channelData.slug) {
        this.channelData.slug = this.channelData.name.toLowerCase().replace(/[^a-z0-9]/g, "-");
      }
    },
    validate(channel, {
      field = null,
      exactFields = true,
      required = true
    } = {}) {
      return ValidateUtils.validateChannel(channel, field, exactFields, required);
    }
  }
};;
                        return _default;
                    })()
                );
            return window.VueComponents;
        }